/**
 * Thomson Reuters Authenticator Web Component v4.0.4
 * @license Copyright 2017 Thomson Reuters. All rights reserved.
 * Must support IE9+, Chrome, Firefox, Safari
 * Minimal dependencies
 */
/**
 * Console-polyfill.
 * @license MIT license.
 * https://github.com/paulmillr/console-polyfill
 * Make it safe to do console.log() always.
 * 0.2.3
 */
(function(global) {
  'use strict';
  if (!global.console) {
    global.console = {};
  }
  var con = global.console;
  var prop, method;
  var dummy = function() {};
  var properties = ['memory'];
  var methods = ('assert,clear,count,debug,dir,dirxml,error,exception,group,' +
     'groupCollapsed,groupEnd,info,log,markTimeline,profile,profiles,profileEnd,' +
     'show,table,time,timeEnd,timeline,timelineEnd,timeStamp,trace,warn').split(',');
  while (prop = properties.pop()) if (!con[prop]) con[prop] = {};
  while (method = methods.pop()) if (typeof con[method] !== 'function') con[method] = dummy;
  // Using `this` for web workers & supports Browserify / Webpack.
})(typeof window === 'undefined' ? this : window);

/**
 * MDN CustomEvent polyfill IE9+
 * https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent/CustomEvent
 * Any copyright is dedicated to the Public Domain. http://creativecommons.org/publicdomain/zero/1.0/
 */
(function () {

  if ( typeof window.CustomEvent === "function" ) return false;

  function CustomEvent ( event, params ) {
    params = params || { bubbles: false, cancelable: false, detail: undefined };
    var evt = document.createEvent( 'CustomEvent' );
    evt.initCustomEvent( event, params.bubbles, params.cancelable, params.detail );
    return evt;
   }

  CustomEvent.prototype = window.Event.prototype;

  window.CustomEvent = CustomEvent;

})();

/**
 * MDN Array.from polyfill
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/from
 * Any copyright is dedicated to the Public Domain. http://creativecommons.org/publicdomain/zero/1.0/
 */
// Production steps of ECMA-262, Edition 6, 22.1.2.1
// Reference: https://people.mozilla.org/~jorendorff/es6-draft.html#sec-array.from
if (!Array.from) {
  Array.from = (function () {
    var toStr = Object.prototype.toString;
    var isCallable = function (fn) {
      return typeof fn === 'function' || toStr.call(fn) === '[object Function]';
    };
    var toInteger = function (value) {
      var number = Number(value);
      if (isNaN(number)) { return 0; }
      if (number === 0 || !isFinite(number)) { return number; }
      return (number > 0 ? 1 : -1) * Math.floor(Math.abs(number));
    };
    var maxSafeInteger = Math.pow(2, 53) - 1;
    var toLength = function (value) {
      var len = toInteger(value);
      return Math.min(Math.max(len, 0), maxSafeInteger);
    };

    // The length property of the from method is 1.
    return function from(arrayLike/*, mapFn, thisArg */) {
      // 1. Let C be the this value.
      var C = this;

      // 2. Let items be ToObject(arrayLike).
      var items = Object(arrayLike);

      // 3. ReturnIfAbrupt(items).
      if (arrayLike == null) {
        throw new TypeError("Array.from requires an array-like object - not null or undefined");
      }

      // 4. If mapfn is undefined, then let mapping be false.
      var mapFn = arguments.length > 1 ? arguments[1] : void undefined;
      var T;
      if (typeof mapFn !== 'undefined') {
        // 5. else
        // 5. a If IsCallable(mapfn) is false, throw a TypeError exception.
        if (!isCallable(mapFn)) {
          throw new TypeError('Array.from: when provided, the second argument must be a function');
        }

        // 5. b. If thisArg was supplied, let T be thisArg; else let T be undefined.
        if (arguments.length > 2) {
          T = arguments[2];
        }
      }

      // 10. Let lenValue be Get(items, "length").
      // 11. Let len be ToLength(lenValue).
      var len = toLength(items.length);

      // 13. If IsConstructor(C) is true, then
      // 13. a. Let A be the result of calling the [[Construct]] internal method of C with an argument list containing the single item len.
      // 14. a. Else, Let A be ArrayCreate(len).
      var A = isCallable(C) ? Object(new C(len)) : new Array(len);

      // 16. Let k be 0.
      var k = 0;
      // 17. Repeat, while k < len… (also steps a - h)
      var kValue;
      while (k < len) {
        kValue = items[k];
        if (mapFn) {
          A[k] = typeof T === 'undefined' ? mapFn(kValue, k) : mapFn.call(T, kValue, k);
        } else {
          A[k] = kValue;
        }
        k += 1;
      }
      // 18. Let putStatus be Put(A, "length", len, true).
      A.length = len;
      // 20. Return A.
      return A;
    };
  }());
}

/**
 * classList.js: Cross-browser full element.classList implementation.
 * 2014-07-23
 *
 * By Eli Grey, http://eligrey.com
 * Public Domain.
 * NO WARRANTY EXPRESSED OR IMPLIED. USE AT YOUR OWN RISK.
 */

/*global self, document, DOMException */

/*! @source http://purl.eligrey.com/github/classList.js/blob/master/classList.js*/

if ("document" in self) {

// Full polyfill for browsers with no classList support
if (!("classList" in document.createElement("_"))) {

(function (view) {

"use strict";

if (!('Element' in view)) return;

var
    classListProp = "classList"
  , protoProp = "prototype"
  , elemCtrProto = view.Element[protoProp]
  , objCtr = Object
  , strTrim = String[protoProp].trim || function () {
    return this.replace(/^\s+|\s+$/g, "");
  }
  , arrIndexOf = Array[protoProp].indexOf || function (item) {
    var
        i = 0
      , len = this.length
    ;
    for (; i < len; i++) {
      if (i in this && this[i] === item) {
        return i;
      }
    }
    return -1;
  }
  // Vendors: please allow content code to instantiate DOMExceptions
  , DOMEx = function (type, message) {
    this.name = type;
    this.code = DOMException[type];
    this.message = message;
  }
  , checkTokenAndGetIndex = function (classList, token) {
    if (token === "") {
      throw new DOMEx(
          "SYNTAX_ERR"
        , "An invalid or illegal string was specified"
      );
    }
    if (/\s/.test(token)) {
      throw new DOMEx(
          "INVALID_CHARACTER_ERR"
        , "String contains an invalid character"
      );
    }
    return arrIndexOf.call(classList, token);
  }
  , ClassList = function (elem) {
    var
        trimmedClasses = strTrim.call(elem.getAttribute("class") || "")
      , classes = trimmedClasses ? trimmedClasses.split(/\s+/) : []
      , i = 0
      , len = classes.length
    ;
    for (; i < len; i++) {
      this.push(classes[i]);
    }
    this._updateClassName = function () {
      elem.setAttribute("class", this.toString());
    };
  }
  , classListProto = ClassList[protoProp] = []
  , classListGetter = function () {
    return new ClassList(this);
  }
;
// Most DOMException implementations don't allow calling DOMException's toString()
// on non-DOMExceptions. Error's toString() is sufficient here.
DOMEx[protoProp] = Error[protoProp];
classListProto.item = function (i) {
  return this[i] || null;
};
classListProto.contains = function (token) {
  token += "";
  return checkTokenAndGetIndex(this, token) !== -1;
};
classListProto.add = function () {
  var
      tokens = arguments
    , i = 0
    , l = tokens.length
    , token
    , updated = false
  ;
  do {
    token = tokens[i] + "";
    if (checkTokenAndGetIndex(this, token) === -1) {
      this.push(token);
      updated = true;
    }
  }
  while (++i < l);

  if (updated) {
    this._updateClassName();
  }
};
classListProto.remove = function () {
  var
      tokens = arguments
    , i = 0
    , l = tokens.length
    , token
    , updated = false
    , index
  ;
  do {
    token = tokens[i] + "";
    index = checkTokenAndGetIndex(this, token);
    while (index !== -1) {
      this.splice(index, 1);
      updated = true;
      index = checkTokenAndGetIndex(this, token);
    }
  }
  while (++i < l);

  if (updated) {
    this._updateClassName();
  }
};
classListProto.toggle = function (token, force) {
  token += "";

  var
      result = this.contains(token)
    , method = result ?
      force !== true && "remove"
    :
      force !== false && "add"
  ;

  if (method) {
    this[method](token);
  }

  if (force === true || force === false) {
    return force;
  } else {
    return !result;
  }
};
classListProto.toString = function () {
  return this.join(" ");
};

if (objCtr.defineProperty) {
  var classListPropDesc = {
      get: classListGetter
    , enumerable: true
    , configurable: true
  };
  try {
    objCtr.defineProperty(elemCtrProto, classListProp, classListPropDesc);
  } catch (ex) { // IE 8 doesn't support enumerable:true
    if (ex.number === -0x7FF5EC54) {
      classListPropDesc.enumerable = false;
      objCtr.defineProperty(elemCtrProto, classListProp, classListPropDesc);
    }
  }
} else if (objCtr[protoProp].__defineGetter__) {
  elemCtrProto.__defineGetter__(classListProp, classListGetter);
}

}(self));

} else {
// There is full or partial native classList support, so just check if we need
// to normalize the add/remove and toggle APIs.

(function () {
  "use strict";

  var testElement = document.createElement("_");

  testElement.classList.add("c1", "c2");

  // Polyfill for IE 10/11 and Firefox <26, where classList.add and
  // classList.remove exist but support only one argument at a time.
  if (!testElement.classList.contains("c2")) {
    var createMethod = function(method) {
      var original = DOMTokenList.prototype[method];

      DOMTokenList.prototype[method] = function(token) {
        var i, len = arguments.length;

        for (i = 0; i < len; i++) {
          token = arguments[i];
          original.call(this, token);
        }
      };
    };
    createMethod('add');
    createMethod('remove');
  }

  testElement.classList.toggle("c3", false);

  // Polyfill for IE 10 and Firefox <24, where classList.toggle does not
  // support the second argument.
  if (testElement.classList.contains("c3")) {
    var _toggle = DOMTokenList.prototype.toggle;

    DOMTokenList.prototype.toggle = function(token, force) {
      if (1 in arguments && !this.contains(token) === !force) {
        return force;
      } else {
        return _toggle.call(this, token);
      }
    };

  }

  testElement = null;
}());

}

}

// http://paulirish.com/2011/requestanimationframe-for-smart-animating/
// http://my.opera.com/emoller/blog/2011/12/20/requestanimationframe-for-smart-er-animating

// requestAnimationFrame polyfill by Erik Möller. fixes from Paul Irish and Tino Zijdel

// MIT license

(function() {
    var lastTime = 0;
    var vendors = ['ms', 'moz', 'webkit', 'o'];
    for(var x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
        window.requestAnimationFrame = window[vendors[x]+'RequestAnimationFrame'];
        window.cancelAnimationFrame = window[vendors[x]+'CancelAnimationFrame']
                                   || window[vendors[x]+'CancelRequestAnimationFrame'];
    }

    if (!window.requestAnimationFrame)
        window.requestAnimationFrame = function(callback, element) {
            var currTime = new Date().getTime();
            var timeToCall = Math.max(0, 16 - (currTime - lastTime));
            var id = window.setTimeout(function() { callback(currTime + timeToCall); },
              timeToCall);
            lastTime = currTime + timeToCall;
            return id;
        };

    if (!window.cancelAnimationFrame)
        window.cancelAnimationFrame = function(id) {
            clearTimeout(id);
        };
}());

/**
 * MDN Element.matches() polyfill
 * https://developer.mozilla.org/en-US/docs/Web/API/Element/matches
 * Any copyright is dedicated to the Public Domain. http://creativecommons.org/publicdomain/zero/1.0/
 */
if (!Element.prototype.matches) {
  Element.prototype.matches = Element.prototype.msMatchesSelector;
}
/**
 * MDN String trim polyfill
 * https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Global_Objects/String/trim
 * Any copyright is dedicated to the Public Domain. http://creativecommons.org/publicdomain/zero/1.0/
 */
if (!String.prototype.trim) {
  String.prototype.trim = function () {
    return this.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
  };
}

/**
 * MDN Array.isArray polyfill
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/isArray
 * Any copyright is dedicated to the Public Domain. http://creativecommons.org/publicdomain/zero/1.0/
 */
if (!Array.isArray) {
  Array.isArray = function(arg) {
    return Object.prototype.toString.call(arg) === '[object Array]';
  };
}

/**
 * MDN lastElementChild polyfill
 * https://developer.mozilla.org/en-US/docs/Web/API/ParentNode/lastElementChild
 */
// Source: https://github.com/Alhadis/Snippets/blob/master/js/polyfills/IE8-child-elements.js
if(!("lastElementChild" in document.documentElement)){
    Object.defineProperty(Element.prototype, "lastElementChild", {
        get: function(){
            for(var nodes = this.children, n, i = nodes.length - 1; i >= 0; --i)
                if(n = nodes[i], 1 === n.nodeType) return n;
            return null;
        }
    });
}

/**
 * MDN firstElementChild polyfill
 * https://developer.mozilla.org/en-US/docs/Web/API/ParentNode/firstElementChild
 */
// Source: https://github.com/Alhadis/Snippets/blob/master/js/polyfills/IE8-child-elements.js
if(!("firstElementChild" in document.documentElement)){
    Object.defineProperty(Element.prototype, "firstElementChild", {
        get: function(){
            for(var nodes = this.children, n, i = 0, l = nodes.length; i < l; ++i)
                if(n = nodes[i], 1 === n.nodeType) return n;
            return null;
        }
    });
}

/**
 * MDN previousElementSibling polyfill
 * https://developer.mozilla.org/en-US/docs/Web/API/NonDocumentTypeChildNode/previousElementSibling
 */
// Source: https://github.com/Alhadis/Snippets/blob/master/js/polyfills/IE8-child-elements.js
if(!("previousElementSibling" in document.documentElement)){
    Object.defineProperty(Element.prototype, "previousElementSibling", {
        get: function(){
            var e = this.previousSibling;
            while(e && 1 !== e.nodeType)
                e = e.previousSibling;
            return e;
        }
    });
}

/**
 * MDN nextElementSibling polyfill
 * https://developer.mozilla.org/en-US/docs/Web/API/NonDocumentTypeChildNode/nextElementSibling
 */
// Source: https://github.com/Alhadis/Snippets/blob/master/js/polyfills/IE8-child-elements.js
if(!("nextElementSibling" in document.documentElement)){
    Object.defineProperty(Element.prototype, "nextElementSibling", {
        get: function(){
            var e = this.nextSibling;
            while(e && 1 !== e.nodeType)
                e = e.nextSibling;
            return e;
        }
    });
}

/**
 * MDN Object.keys polyfill
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/keys
 * Any copyright is dedicated to the Public Domain. http://creativecommons.org/publicdomain/zero/1.0/
 */

if (!Object.keys) {
  Object.keys = (function() {
    'use strict';
    var hasOwnProperty = Object.prototype.hasOwnProperty,
        hasDontEnumBug = !({ toString: null }).propertyIsEnumerable('toString'),
        dontEnums = [
          'toString',
          'toLocaleString',
          'valueOf',
          'hasOwnProperty',
          'isPrototypeOf',
          'propertyIsEnumerable',
          'constructor'
        ],
        dontEnumsLength = dontEnums.length;

    return function(obj) {
      if (typeof obj !== 'object' && (typeof obj !== 'function' || obj === null)) {
        throw new TypeError('Object.keys called on non-object');
      }

      var result = [], prop, i;

      for (prop in obj) {
        if (hasOwnProperty.call(obj, prop)) {
          result.push(prop);
        }
      }

      if (hasDontEnumBug) {
        for (i = 0; i < dontEnumsLength; i++) {
          if (hasOwnProperty.call(obj, dontEnums[i])) {
            result.push(dontEnums[i]);
          }
        }
      }
      return result;
    };
  }());
}

/**
 * MDN Array forEach polyfill
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/forEach
 * Any copyright is dedicated to the Public Domain. http://creativecommons.org/publicdomain/zero/1.0/
 */
// Production steps of ECMA-262, Edition 5, 15.4.4.18
// Reference: http://es5.github.io/#x15.4.4.18
if (!Array.prototype.forEach) {

  Array.prototype.forEach = function(callback, thisArg) {

    var T, k;

    if (this === null) {
      throw new TypeError(' this is null or not defined');
    }

    // 1. Let O be the result of calling toObject() passing the
    // |this| value as the argument.
    var O = Object(this);

    // 2. Let lenValue be the result of calling the Get() internal
    // method of O with the argument "length".
    // 3. Let len be toUint32(lenValue).
    var len = O.length >>> 0;

    // 4. If isCallable(callback) is false, throw a TypeError exception.
    // See: http://es5.github.com/#x9.11
    if (typeof callback !== "function") {
      throw new TypeError(callback + ' is not a function');
    }

    // 5. If thisArg was supplied, let T be thisArg; else let
    // T be undefined.
    if (arguments.length > 1) {
      T = thisArg;
    }

    // 6. Let k be 0
    k = 0;

    // 7. Repeat, while k < len
    while (k < len) {

      var kValue;

      // a. Let Pk be ToString(k).
      //    This is implicit for LHS operands of the in operator
      // b. Let kPresent be the result of calling the HasProperty
      //    internal method of O with argument Pk.
      //    This step can be combined with c
      // c. If kPresent is true, then
      if (k in O) {

        // i. Let kValue be the result of calling the Get internal
        // method of O with argument Pk.
        kValue = O[k];

        // ii. Call the Call internal method of callback with T as
        // the this value and argument list containing kValue, k, and O.
        callback.call(T, kValue, k, O);
      }
      // d. Increase k by 1.
      k++;
    }
    // 8. return undefined
  };
}

/**
 * MDN addEventListener polyfill
 * https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener
 * Any copyright is dedicated to the Public Domain. http://creativecommons.org/publicdomain/zero/1.0/
 */
(function() {
  if (!Event.prototype.preventDefault) {
    Event.prototype.preventDefault=function() {
      this.returnValue=false;
    };
  }
  if (!Event.prototype.stopPropagation) {
    Event.prototype.stopPropagation=function() {
      this.cancelBubble=true;
    };
  }
  if (!Element.prototype.addEventListener) {
    var eventListeners=[];

    var addEventListener=function(type,listener /*, useCapture (will be ignored) */) {
      var self=this;
      var wrapper=function(e) {
        e.target=e.srcElement;
        e.currentTarget=self;
        if (typeof listener.handleEvent != 'undefined') {
          listener.handleEvent(e);
        } else {
          listener.call(self,e);
        }
      };
      if (type=="DOMContentLoaded") {
        var wrapper2=function(e) {
          if (document.readyState=="complete") {
            wrapper(e);
          }
        };
        document.attachEvent("onreadystatechange",wrapper2);
        eventListeners.push({object:this,type:type,listener:listener,wrapper:wrapper2});

        if (document.readyState=="complete") {
          var e=new Event();
          e.srcElement=window;
          wrapper2(e);
        }
      } else {
        this.attachEvent("on"+type,wrapper);
        eventListeners.push({object:this,type:type,listener:listener,wrapper:wrapper});
      }
    };
    var removeEventListener=function(type,listener /*, useCapture (will be ignored) */) {
      var counter=0;
      while (counter<eventListeners.length) {
        var eventListener=eventListeners[counter];
        if (eventListener.object==this && eventListener.type==type && eventListener.listener==listener) {
          if (type=="DOMContentLoaded") {
            this.detachEvent("onreadystatechange",eventListener.wrapper);
          } else {
            this.detachEvent("on"+type,eventListener.wrapper);
          }
          eventListeners.splice(counter, 1);
          break;
        }
        ++counter;
      }
    };
    Element.prototype.addEventListener=addEventListener;
    Element.prototype.removeEventListener=removeEventListener;
    if (HTMLDocument) {
      HTMLDocument.prototype.addEventListener=addEventListener;
      HTMLDocument.prototype.removeEventListener=removeEventListener;
    }
    if (Window) {
      Window.prototype.addEventListener=addEventListener;
      Window.prototype.removeEventListener=removeEventListener;
    }
  }
})();
/*
 * underscore.template 0.1.7
 * Extracted template from Underscore, use '_.template' without full underscore source.
 * https://github.com/superRaytin/underscore.template
 *
 * Copyright 2015-present, Leon Shi
 * Released under the MIT license.
*/

!function e(r,n,t){function o(u,i){if(!n[u]){if(!r[u]){var c="function"==typeof require&&require;if(!i&&c)return c(u,!0);if(a)return a(u,!0);throw new Error("Cannot find module '"+u+"'")}var f=n[u]={exports:{}};r[u][0].call(f.exports,function(e){var n=r[u][1][e];return o(n?n:e)},f,f.exports,e,r,n,t)}return n[u].exports}for(var a="function"==typeof require&&require,u=0;u<t.length;u++)o(t[u]);return o}({1:[function(e,r,n){"use strict";function t(e,r,n){return a(e,r,n)}var o=e("./underscore.template"),a=o.template;t._=o,r.exports=t,"function"==typeof define&&define.amd?define(function(){return t}):("undefined"!=typeof window||"undefined"!=typeof navigator)&&(window.UnderscoreTemplate=t)},{"./underscore.template":2}],2:[function(e,r,n){"use strict";var t={},o=Array.prototype,a=Object.prototype,u=o.slice,i=a.toString,c=a.hasOwnProperty,f=o.forEach,l=Object.keys,s=Array.isArray,p=function(){},v=p.each=p.forEach=function(e,r,n){if(null!=e)if(f&&e.forEach===f)e.forEach(r,n);else if(e.length===+e.length){for(var o=0,a=e.length;a>o;o++)if(r.call(n,e[o],o,e)===t)return}else for(var u=p.keys(e),o=0,a=u.length;a>o;o++)if(r.call(n,e[u[o]],u[o],e)===t)return};p.keys=l||function(e){if(e!==Object(e))throw new TypeError("Invalid object");var r=[];for(var n in e)p.has(e,n)&&r.push(n);return r},p.defaults=function(e){return v(u.call(arguments,1),function(r){if(r)for(var n in r)void 0===e[n]&&(e[n]=r[n])}),e},p.isArray=s||function(e){return"[object Array]"===i.call(e)},p.has=function(e,r){if(!p.isArray(r))return null!=e&&c.call(e,r);for(var n=r.length,t=0;n>t;t++){var o=r[t];if(null==e||!c.call(e,o))return!1;e=e[o]}return!!n};var _={escape:{"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#x27;"}},h={escape:new RegExp("["+p.keys(_.escape).join("")+"]","g")};p.each(["escape"],function(e){p[e]=function(r){return null==r?"":(""+r).replace(h[e],function(r){return _[e][r]})}}),p.templateSettings={evaluate:/<%([\s\S]+?)%>/g,interpolate:/<%=([\s\S]+?)%>/g,escape:/<%-([\s\S]+?)%>/g};var g=/(.)^/,y={"'":"'","\\":"\\","\r":"r","\n":"n","	":"t","\u2028":"u2028","\u2029":"u2029"},d=/\\|'|\r|\n|\t|\u2028|\u2029/g;p.template=function(e,r,n){var t;n=p.defaults({},n,p.templateSettings);var o=new RegExp([(n.escape||g).source,(n.interpolate||g).source,(n.evaluate||g).source].join("|")+"|$","g"),a=0,u="__p+='";e.replace(o,function(r,n,t,o,i){return u+=e.slice(a,i).replace(d,function(e){return"\\"+y[e]}),n&&(u+="'+\n((__t=("+n+"))==null?'':_.escape(__t))+\n'"),t&&(u+="'+\n((__t=("+t+"))==null?'':__t)+\n'"),o&&(u+="';\n"+o+"\n__p+='"),a=i+r.length,r}),u+="';\n",n.variable||(u="with(obj||{}){\n"+u+"}\n"),u="var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};\n"+u+"return __p;\n";try{t=new Function(n.variable||"obj","_",u)}catch(i){throw i.source=u,i}if(r)return t(r,p);var c=function(e){return t.call(this,e,p)};return c.source="function("+(n.variable||"obj")+"){\n"+u+"}",c},r.exports=p},{}]},{},[1]);!function a(b,c,d){function e(g,h){if(!c[g]){if(!b[g]){var i="function"==typeof require&&require;if(!h&&i)return i(g,!0);if(f)return f(g,!0);var j=new Error("Cannot find module '"+g+"'");throw j.code="MODULE_NOT_FOUND",j}var k=c[g]={exports:{}};b[g][0].call(k.exports,function(a){var c=b[g][1][a];return e(c?c:a)},k,k.exports,a,b,c,d)}return c[g].exports}for(var f="function"==typeof require&&require,g=0;g<d.length;g++)e(d[g]);return e}({1:[function(a,b,c){function d(a){this.message=a}function e(a){var b=String(a).replace(/=+$/,"");if(b.length%4==1)throw new d("'atob' failed: The string to be decoded is not correctly encoded.");for(var c,e,g=0,h=0,i="";e=b.charAt(h++);~e&&(c=g%4?64*c+e:e,g++%4)?i+=String.fromCharCode(255&c>>(-2*g&6)):0)e=f.indexOf(e);return i}var f="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";d.prototype=new Error,d.prototype.name="InvalidCharacterError",b.exports="undefined"!=typeof window&&window.atob&&window.atob.bind(window)||e},{}],2:[function(a,b,c){function d(a){return decodeURIComponent(e(a).replace(/(.)/g,function(a,b){var c=b.charCodeAt(0).toString(16).toUpperCase();return c.length<2&&(c="0"+c),"%"+c}))}var e=a("./atob");b.exports=function(a){var b=a.replace(/-/g,"+").replace(/_/g,"/");switch(b.length%4){case 0:break;case 2:b+="==";break;case 3:b+="=";break;default:throw"Illegal base64url string!"}try{return d(b)}catch(c){return e(b)}}},{"./atob":1}],3:[function(a,b,c){"use strict";var d=a("./base64_url_decode");b.exports=function(a,b){if("string"!=typeof a)throw new Error("Invalid token specified");b=b||{};var c=b.header===!0?0:1;return JSON.parse(d(a.split(".")[c]))}},{"./base64_url_decode":2}],4:[function(a,b,c){(function(b){var c=a("./lib/index");"function"==typeof b.window.define&&b.window.define.amd?b.window.define("jwt_decode",function(){return c}):b.window&&(b.window.jwt_decode=c)}).call(this,"undefined"!=typeof global?global:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{"./lib/index":3}]},{},[4]);/**
 * @fileoverview
 * - Using the 'QRCode for Javascript library'
 * - Fixed dataset of 'QRCode for Javascript library' for support full-spec.
 * - this library has no dependencies.
 * 
 * @author davidshimjs
 * @see <a href="http://www.d-project.com/" target="_blank">http://www.d-project.com/</a>
 * @see <a href="http://jeromeetienne.github.com/jquery-qrcode/" target="_blank">http://jeromeetienne.github.com/jquery-qrcode/</a>
 */
var QRCode;

(function () {
	//---------------------------------------------------------------------
	// QRCode for JavaScript
	//
	// Copyright (c) 2009 Kazuhiko Arase
	//
	// URL: http://www.d-project.com/
	//
	// Licensed under the MIT license:
	//   http://www.opensource.org/licenses/mit-license.php
	//
	// The word "QR Code" is registered trademark of 
	// DENSO WAVE INCORPORATED
	//   http://www.denso-wave.com/qrcode/faqpatent-e.html
	//
	//---------------------------------------------------------------------
	function QR8bitByte(data) {
		this.mode = QRMode.MODE_8BIT_BYTE;
		this.data = data;
		this.parsedData = [];

		// Added to support UTF-8 Characters
		for (var i = 0, l = this.data.length; i < l; i++) {
			var byteArray = [];
			var code = this.data.charCodeAt(i);

			if (code > 0x10000) {
				byteArray[0] = 0xF0 | ((code & 0x1C0000) >>> 18);
				byteArray[1] = 0x80 | ((code & 0x3F000) >>> 12);
				byteArray[2] = 0x80 | ((code & 0xFC0) >>> 6);
				byteArray[3] = 0x80 | (code & 0x3F);
			} else if (code > 0x800) {
				byteArray[0] = 0xE0 | ((code & 0xF000) >>> 12);
				byteArray[1] = 0x80 | ((code & 0xFC0) >>> 6);
				byteArray[2] = 0x80 | (code & 0x3F);
			} else if (code > 0x80) {
				byteArray[0] = 0xC0 | ((code & 0x7C0) >>> 6);
				byteArray[1] = 0x80 | (code & 0x3F);
			} else {
				byteArray[0] = code;
			}

			this.parsedData.push(byteArray);
		}

		this.parsedData = Array.prototype.concat.apply([], this.parsedData);

		if (this.parsedData.length != this.data.length) {
			this.parsedData.unshift(191);
			this.parsedData.unshift(187);
			this.parsedData.unshift(239);
		}
	}

	QR8bitByte.prototype = {
		getLength: function (buffer) {
			return this.parsedData.length;
		},
		write: function (buffer) {
			for (var i = 0, l = this.parsedData.length; i < l; i++) {
				buffer.put(this.parsedData[i], 8);
			}
		}
	};

	function QRCodeModel(typeNumber, errorCorrectLevel) {
		this.typeNumber = typeNumber;
		this.errorCorrectLevel = errorCorrectLevel;
		this.modules = null;
		this.moduleCount = 0;
		this.dataCache = null;
		this.dataList = [];
	}

	QRCodeModel.prototype={addData:function(data){var newData=new QR8bitByte(data);this.dataList.push(newData);this.dataCache=null;},isDark:function(row,col){if(row<0||this.moduleCount<=row||col<0||this.moduleCount<=col){throw new Error(row+","+col);}
	return this.modules[row][col];},getModuleCount:function(){return this.moduleCount;},make:function(){this.makeImpl(false,this.getBestMaskPattern());},makeImpl:function(test,maskPattern){this.moduleCount=this.typeNumber*4+17;this.modules=new Array(this.moduleCount);for(var row=0;row<this.moduleCount;row++){this.modules[row]=new Array(this.moduleCount);for(var col=0;col<this.moduleCount;col++){this.modules[row][col]=null;}}
	this.setupPositionProbePattern(0,0);this.setupPositionProbePattern(this.moduleCount-7,0);this.setupPositionProbePattern(0,this.moduleCount-7);this.setupPositionAdjustPattern();this.setupTimingPattern();this.setupTypeInfo(test,maskPattern);if(this.typeNumber>=7){this.setupTypeNumber(test);}
	if(this.dataCache==null){this.dataCache=QRCodeModel.createData(this.typeNumber,this.errorCorrectLevel,this.dataList);}
	this.mapData(this.dataCache,maskPattern);},setupPositionProbePattern:function(row,col){for(var r=-1;r<=7;r++){if(row+r<=-1||this.moduleCount<=row+r)continue;for(var c=-1;c<=7;c++){if(col+c<=-1||this.moduleCount<=col+c)continue;if((0<=r&&r<=6&&(c==0||c==6))||(0<=c&&c<=6&&(r==0||r==6))||(2<=r&&r<=4&&2<=c&&c<=4)){this.modules[row+r][col+c]=true;}else{this.modules[row+r][col+c]=false;}}}},getBestMaskPattern:function(){var minLostPoint=0;var pattern=0;for(var i=0;i<8;i++){this.makeImpl(true,i);var lostPoint=QRUtil.getLostPoint(this);if(i==0||minLostPoint>lostPoint){minLostPoint=lostPoint;pattern=i;}}
	return pattern;},createMovieClip:function(target_mc,instance_name,depth){var qr_mc=target_mc.createEmptyMovieClip(instance_name,depth);var cs=1;this.make();for(var row=0;row<this.modules.length;row++){var y=row*cs;for(var col=0;col<this.modules[row].length;col++){var x=col*cs;var dark=this.modules[row][col];if(dark){qr_mc.beginFill(0,100);qr_mc.moveTo(x,y);qr_mc.lineTo(x+cs,y);qr_mc.lineTo(x+cs,y+cs);qr_mc.lineTo(x,y+cs);qr_mc.endFill();}}}
	return qr_mc;},setupTimingPattern:function(){for(var r=8;r<this.moduleCount-8;r++){if(this.modules[r][6]!=null){continue;}
	this.modules[r][6]=(r%2==0);}
	for(var c=8;c<this.moduleCount-8;c++){if(this.modules[6][c]!=null){continue;}
	this.modules[6][c]=(c%2==0);}},setupPositionAdjustPattern:function(){var pos=QRUtil.getPatternPosition(this.typeNumber);for(var i=0;i<pos.length;i++){for(var j=0;j<pos.length;j++){var row=pos[i];var col=pos[j];if(this.modules[row][col]!=null){continue;}
	for(var r=-2;r<=2;r++){for(var c=-2;c<=2;c++){if(r==-2||r==2||c==-2||c==2||(r==0&&c==0)){this.modules[row+r][col+c]=true;}else{this.modules[row+r][col+c]=false;}}}}}},setupTypeNumber:function(test){var bits=QRUtil.getBCHTypeNumber(this.typeNumber);for(var i=0;i<18;i++){var mod=(!test&&((bits>>i)&1)==1);this.modules[Math.floor(i/3)][i%3+this.moduleCount-8-3]=mod;}
	for(var i=0;i<18;i++){var mod=(!test&&((bits>>i)&1)==1);this.modules[i%3+this.moduleCount-8-3][Math.floor(i/3)]=mod;}},setupTypeInfo:function(test,maskPattern){var data=(this.errorCorrectLevel<<3)|maskPattern;var bits=QRUtil.getBCHTypeInfo(data);for(var i=0;i<15;i++){var mod=(!test&&((bits>>i)&1)==1);if(i<6){this.modules[i][8]=mod;}else if(i<8){this.modules[i+1][8]=mod;}else{this.modules[this.moduleCount-15+i][8]=mod;}}
	for(var i=0;i<15;i++){var mod=(!test&&((bits>>i)&1)==1);if(i<8){this.modules[8][this.moduleCount-i-1]=mod;}else if(i<9){this.modules[8][15-i-1+1]=mod;}else{this.modules[8][15-i-1]=mod;}}
	this.modules[this.moduleCount-8][8]=(!test);},mapData:function(data,maskPattern){var inc=-1;var row=this.moduleCount-1;var bitIndex=7;var byteIndex=0;for(var col=this.moduleCount-1;col>0;col-=2){if(col==6)col--;while(true){for(var c=0;c<2;c++){if(this.modules[row][col-c]==null){var dark=false;if(byteIndex<data.length){dark=(((data[byteIndex]>>>bitIndex)&1)==1);}
	var mask=QRUtil.getMask(maskPattern,row,col-c);if(mask){dark=!dark;}
	this.modules[row][col-c]=dark;bitIndex--;if(bitIndex==-1){byteIndex++;bitIndex=7;}}}
	row+=inc;if(row<0||this.moduleCount<=row){row-=inc;inc=-inc;break;}}}}};QRCodeModel.PAD0=0xEC;QRCodeModel.PAD1=0x11;QRCodeModel.createData=function(typeNumber,errorCorrectLevel,dataList){var rsBlocks=QRRSBlock.getRSBlocks(typeNumber,errorCorrectLevel);var buffer=new QRBitBuffer();for(var i=0;i<dataList.length;i++){var data=dataList[i];buffer.put(data.mode,4);buffer.put(data.getLength(),QRUtil.getLengthInBits(data.mode,typeNumber));data.write(buffer);}
	var totalDataCount=0;for(var i=0;i<rsBlocks.length;i++){totalDataCount+=rsBlocks[i].dataCount;}
	if(buffer.getLengthInBits()>totalDataCount*8){throw new Error("code length overflow. ("
	+buffer.getLengthInBits()
	+">"
	+totalDataCount*8
	+")");}
	if(buffer.getLengthInBits()+4<=totalDataCount*8){buffer.put(0,4);}
	while(buffer.getLengthInBits()%8!=0){buffer.putBit(false);}
	while(true){if(buffer.getLengthInBits()>=totalDataCount*8){break;}
	buffer.put(QRCodeModel.PAD0,8);if(buffer.getLengthInBits()>=totalDataCount*8){break;}
	buffer.put(QRCodeModel.PAD1,8);}
	return QRCodeModel.createBytes(buffer,rsBlocks);};QRCodeModel.createBytes=function(buffer,rsBlocks){var offset=0;var maxDcCount=0;var maxEcCount=0;var dcdata=new Array(rsBlocks.length);var ecdata=new Array(rsBlocks.length);for(var r=0;r<rsBlocks.length;r++){var dcCount=rsBlocks[r].dataCount;var ecCount=rsBlocks[r].totalCount-dcCount;maxDcCount=Math.max(maxDcCount,dcCount);maxEcCount=Math.max(maxEcCount,ecCount);dcdata[r]=new Array(dcCount);for(var i=0;i<dcdata[r].length;i++){dcdata[r][i]=0xff&buffer.buffer[i+offset];}
	offset+=dcCount;var rsPoly=QRUtil.getErrorCorrectPolynomial(ecCount);var rawPoly=new QRPolynomial(dcdata[r],rsPoly.getLength()-1);var modPoly=rawPoly.mod(rsPoly);ecdata[r]=new Array(rsPoly.getLength()-1);for(var i=0;i<ecdata[r].length;i++){var modIndex=i+modPoly.getLength()-ecdata[r].length;ecdata[r][i]=(modIndex>=0)?modPoly.get(modIndex):0;}}
	var totalCodeCount=0;for(var i=0;i<rsBlocks.length;i++){totalCodeCount+=rsBlocks[i].totalCount;}
	var data=new Array(totalCodeCount);var index=0;for(var i=0;i<maxDcCount;i++){for(var r=0;r<rsBlocks.length;r++){if(i<dcdata[r].length){data[index++]=dcdata[r][i];}}}
	for(var i=0;i<maxEcCount;i++){for(var r=0;r<rsBlocks.length;r++){if(i<ecdata[r].length){data[index++]=ecdata[r][i];}}}
	return data;};var QRMode={MODE_NUMBER:1<<0,MODE_ALPHA_NUM:1<<1,MODE_8BIT_BYTE:1<<2,MODE_KANJI:1<<3};var QRErrorCorrectLevel={L:1,M:0,Q:3,H:2};var QRMaskPattern={PATTERN000:0,PATTERN001:1,PATTERN010:2,PATTERN011:3,PATTERN100:4,PATTERN101:5,PATTERN110:6,PATTERN111:7};var QRUtil={PATTERN_POSITION_TABLE:[[],[6,18],[6,22],[6,26],[6,30],[6,34],[6,22,38],[6,24,42],[6,26,46],[6,28,50],[6,30,54],[6,32,58],[6,34,62],[6,26,46,66],[6,26,48,70],[6,26,50,74],[6,30,54,78],[6,30,56,82],[6,30,58,86],[6,34,62,90],[6,28,50,72,94],[6,26,50,74,98],[6,30,54,78,102],[6,28,54,80,106],[6,32,58,84,110],[6,30,58,86,114],[6,34,62,90,118],[6,26,50,74,98,122],[6,30,54,78,102,126],[6,26,52,78,104,130],[6,30,56,82,108,134],[6,34,60,86,112,138],[6,30,58,86,114,142],[6,34,62,90,118,146],[6,30,54,78,102,126,150],[6,24,50,76,102,128,154],[6,28,54,80,106,132,158],[6,32,58,84,110,136,162],[6,26,54,82,110,138,166],[6,30,58,86,114,142,170]],G15:(1<<10)|(1<<8)|(1<<5)|(1<<4)|(1<<2)|(1<<1)|(1<<0),G18:(1<<12)|(1<<11)|(1<<10)|(1<<9)|(1<<8)|(1<<5)|(1<<2)|(1<<0),G15_MASK:(1<<14)|(1<<12)|(1<<10)|(1<<4)|(1<<1),getBCHTypeInfo:function(data){var d=data<<10;while(QRUtil.getBCHDigit(d)-QRUtil.getBCHDigit(QRUtil.G15)>=0){d^=(QRUtil.G15<<(QRUtil.getBCHDigit(d)-QRUtil.getBCHDigit(QRUtil.G15)));}
	return((data<<10)|d)^QRUtil.G15_MASK;},getBCHTypeNumber:function(data){var d=data<<12;while(QRUtil.getBCHDigit(d)-QRUtil.getBCHDigit(QRUtil.G18)>=0){d^=(QRUtil.G18<<(QRUtil.getBCHDigit(d)-QRUtil.getBCHDigit(QRUtil.G18)));}
	return(data<<12)|d;},getBCHDigit:function(data){var digit=0;while(data!=0){digit++;data>>>=1;}
	return digit;},getPatternPosition:function(typeNumber){return QRUtil.PATTERN_POSITION_TABLE[typeNumber-1];},getMask:function(maskPattern,i,j){switch(maskPattern){case QRMaskPattern.PATTERN000:return(i+j)%2==0;case QRMaskPattern.PATTERN001:return i%2==0;case QRMaskPattern.PATTERN010:return j%3==0;case QRMaskPattern.PATTERN011:return(i+j)%3==0;case QRMaskPattern.PATTERN100:return(Math.floor(i/2)+Math.floor(j/3))%2==0;case QRMaskPattern.PATTERN101:return(i*j)%2+(i*j)%3==0;case QRMaskPattern.PATTERN110:return((i*j)%2+(i*j)%3)%2==0;case QRMaskPattern.PATTERN111:return((i*j)%3+(i+j)%2)%2==0;default:throw new Error("bad maskPattern:"+maskPattern);}},getErrorCorrectPolynomial:function(errorCorrectLength){var a=new QRPolynomial([1],0);for(var i=0;i<errorCorrectLength;i++){a=a.multiply(new QRPolynomial([1,QRMath.gexp(i)],0));}
	return a;},getLengthInBits:function(mode,type){if(1<=type&&type<10){switch(mode){case QRMode.MODE_NUMBER:return 10;case QRMode.MODE_ALPHA_NUM:return 9;case QRMode.MODE_8BIT_BYTE:return 8;case QRMode.MODE_KANJI:return 8;default:throw new Error("mode:"+mode);}}else if(type<27){switch(mode){case QRMode.MODE_NUMBER:return 12;case QRMode.MODE_ALPHA_NUM:return 11;case QRMode.MODE_8BIT_BYTE:return 16;case QRMode.MODE_KANJI:return 10;default:throw new Error("mode:"+mode);}}else if(type<41){switch(mode){case QRMode.MODE_NUMBER:return 14;case QRMode.MODE_ALPHA_NUM:return 13;case QRMode.MODE_8BIT_BYTE:return 16;case QRMode.MODE_KANJI:return 12;default:throw new Error("mode:"+mode);}}else{throw new Error("type:"+type);}},getLostPoint:function(qrCode){var moduleCount=qrCode.getModuleCount();var lostPoint=0;for(var row=0;row<moduleCount;row++){for(var col=0;col<moduleCount;col++){var sameCount=0;var dark=qrCode.isDark(row,col);for(var r=-1;r<=1;r++){if(row+r<0||moduleCount<=row+r){continue;}
	for(var c=-1;c<=1;c++){if(col+c<0||moduleCount<=col+c){continue;}
	if(r==0&&c==0){continue;}
	if(dark==qrCode.isDark(row+r,col+c)){sameCount++;}}}
	if(sameCount>5){lostPoint+=(3+sameCount-5);}}}
	for(var row=0;row<moduleCount-1;row++){for(var col=0;col<moduleCount-1;col++){var count=0;if(qrCode.isDark(row,col))count++;if(qrCode.isDark(row+1,col))count++;if(qrCode.isDark(row,col+1))count++;if(qrCode.isDark(row+1,col+1))count++;if(count==0||count==4){lostPoint+=3;}}}
	for(var row=0;row<moduleCount;row++){for(var col=0;col<moduleCount-6;col++){if(qrCode.isDark(row,col)&&!qrCode.isDark(row,col+1)&&qrCode.isDark(row,col+2)&&qrCode.isDark(row,col+3)&&qrCode.isDark(row,col+4)&&!qrCode.isDark(row,col+5)&&qrCode.isDark(row,col+6)){lostPoint+=40;}}}
	for(var col=0;col<moduleCount;col++){for(var row=0;row<moduleCount-6;row++){if(qrCode.isDark(row,col)&&!qrCode.isDark(row+1,col)&&qrCode.isDark(row+2,col)&&qrCode.isDark(row+3,col)&&qrCode.isDark(row+4,col)&&!qrCode.isDark(row+5,col)&&qrCode.isDark(row+6,col)){lostPoint+=40;}}}
	var darkCount=0;for(var col=0;col<moduleCount;col++){for(var row=0;row<moduleCount;row++){if(qrCode.isDark(row,col)){darkCount++;}}}
	var ratio=Math.abs(100*darkCount/moduleCount/moduleCount-50)/5;lostPoint+=ratio*10;return lostPoint;}};var QRMath={glog:function(n){if(n<1){throw new Error("glog("+n+")");}
	return QRMath.LOG_TABLE[n];},gexp:function(n){while(n<0){n+=255;}
	while(n>=256){n-=255;}
	return QRMath.EXP_TABLE[n];},EXP_TABLE:new Array(256),LOG_TABLE:new Array(256)};for(var i=0;i<8;i++){QRMath.EXP_TABLE[i]=1<<i;}
	for(var i=8;i<256;i++){QRMath.EXP_TABLE[i]=QRMath.EXP_TABLE[i-4]^QRMath.EXP_TABLE[i-5]^QRMath.EXP_TABLE[i-6]^QRMath.EXP_TABLE[i-8];}
	for(var i=0;i<255;i++){QRMath.LOG_TABLE[QRMath.EXP_TABLE[i]]=i;}
	function QRPolynomial(num,shift){if(num.length==undefined){throw new Error(num.length+"/"+shift);}
	var offset=0;while(offset<num.length&&num[offset]==0){offset++;}
	this.num=new Array(num.length-offset+shift);for(var i=0;i<num.length-offset;i++){this.num[i]=num[i+offset];}}
	QRPolynomial.prototype={get:function(index){return this.num[index];},getLength:function(){return this.num.length;},multiply:function(e){var num=new Array(this.getLength()+e.getLength()-1);for(var i=0;i<this.getLength();i++){for(var j=0;j<e.getLength();j++){num[i+j]^=QRMath.gexp(QRMath.glog(this.get(i))+QRMath.glog(e.get(j)));}}
	return new QRPolynomial(num,0);},mod:function(e){if(this.getLength()-e.getLength()<0){return this;}
	var ratio=QRMath.glog(this.get(0))-QRMath.glog(e.get(0));var num=new Array(this.getLength());for(var i=0;i<this.getLength();i++){num[i]=this.get(i);}
	for(var i=0;i<e.getLength();i++){num[i]^=QRMath.gexp(QRMath.glog(e.get(i))+ratio);}
	return new QRPolynomial(num,0).mod(e);}};function QRRSBlock(totalCount,dataCount){this.totalCount=totalCount;this.dataCount=dataCount;}
	QRRSBlock.RS_BLOCK_TABLE=[[1,26,19],[1,26,16],[1,26,13],[1,26,9],[1,44,34],[1,44,28],[1,44,22],[1,44,16],[1,70,55],[1,70,44],[2,35,17],[2,35,13],[1,100,80],[2,50,32],[2,50,24],[4,25,9],[1,134,108],[2,67,43],[2,33,15,2,34,16],[2,33,11,2,34,12],[2,86,68],[4,43,27],[4,43,19],[4,43,15],[2,98,78],[4,49,31],[2,32,14,4,33,15],[4,39,13,1,40,14],[2,121,97],[2,60,38,2,61,39],[4,40,18,2,41,19],[4,40,14,2,41,15],[2,146,116],[3,58,36,2,59,37],[4,36,16,4,37,17],[4,36,12,4,37,13],[2,86,68,2,87,69],[4,69,43,1,70,44],[6,43,19,2,44,20],[6,43,15,2,44,16],[4,101,81],[1,80,50,4,81,51],[4,50,22,4,51,23],[3,36,12,8,37,13],[2,116,92,2,117,93],[6,58,36,2,59,37],[4,46,20,6,47,21],[7,42,14,4,43,15],[4,133,107],[8,59,37,1,60,38],[8,44,20,4,45,21],[12,33,11,4,34,12],[3,145,115,1,146,116],[4,64,40,5,65,41],[11,36,16,5,37,17],[11,36,12,5,37,13],[5,109,87,1,110,88],[5,65,41,5,66,42],[5,54,24,7,55,25],[11,36,12],[5,122,98,1,123,99],[7,73,45,3,74,46],[15,43,19,2,44,20],[3,45,15,13,46,16],[1,135,107,5,136,108],[10,74,46,1,75,47],[1,50,22,15,51,23],[2,42,14,17,43,15],[5,150,120,1,151,121],[9,69,43,4,70,44],[17,50,22,1,51,23],[2,42,14,19,43,15],[3,141,113,4,142,114],[3,70,44,11,71,45],[17,47,21,4,48,22],[9,39,13,16,40,14],[3,135,107,5,136,108],[3,67,41,13,68,42],[15,54,24,5,55,25],[15,43,15,10,44,16],[4,144,116,4,145,117],[17,68,42],[17,50,22,6,51,23],[19,46,16,6,47,17],[2,139,111,7,140,112],[17,74,46],[7,54,24,16,55,25],[34,37,13],[4,151,121,5,152,122],[4,75,47,14,76,48],[11,54,24,14,55,25],[16,45,15,14,46,16],[6,147,117,4,148,118],[6,73,45,14,74,46],[11,54,24,16,55,25],[30,46,16,2,47,17],[8,132,106,4,133,107],[8,75,47,13,76,48],[7,54,24,22,55,25],[22,45,15,13,46,16],[10,142,114,2,143,115],[19,74,46,4,75,47],[28,50,22,6,51,23],[33,46,16,4,47,17],[8,152,122,4,153,123],[22,73,45,3,74,46],[8,53,23,26,54,24],[12,45,15,28,46,16],[3,147,117,10,148,118],[3,73,45,23,74,46],[4,54,24,31,55,25],[11,45,15,31,46,16],[7,146,116,7,147,117],[21,73,45,7,74,46],[1,53,23,37,54,24],[19,45,15,26,46,16],[5,145,115,10,146,116],[19,75,47,10,76,48],[15,54,24,25,55,25],[23,45,15,25,46,16],[13,145,115,3,146,116],[2,74,46,29,75,47],[42,54,24,1,55,25],[23,45,15,28,46,16],[17,145,115],[10,74,46,23,75,47],[10,54,24,35,55,25],[19,45,15,35,46,16],[17,145,115,1,146,116],[14,74,46,21,75,47],[29,54,24,19,55,25],[11,45,15,46,46,16],[13,145,115,6,146,116],[14,74,46,23,75,47],[44,54,24,7,55,25],[59,46,16,1,47,17],[12,151,121,7,152,122],[12,75,47,26,76,48],[39,54,24,14,55,25],[22,45,15,41,46,16],[6,151,121,14,152,122],[6,75,47,34,76,48],[46,54,24,10,55,25],[2,45,15,64,46,16],[17,152,122,4,153,123],[29,74,46,14,75,47],[49,54,24,10,55,25],[24,45,15,46,46,16],[4,152,122,18,153,123],[13,74,46,32,75,47],[48,54,24,14,55,25],[42,45,15,32,46,16],[20,147,117,4,148,118],[40,75,47,7,76,48],[43,54,24,22,55,25],[10,45,15,67,46,16],[19,148,118,6,149,119],[18,75,47,31,76,48],[34,54,24,34,55,25],[20,45,15,61,46,16]];QRRSBlock.getRSBlocks=function(typeNumber,errorCorrectLevel){var rsBlock=QRRSBlock.getRsBlockTable(typeNumber,errorCorrectLevel);if(rsBlock==undefined){throw new Error("bad rs block @ typeNumber:"+typeNumber+"/errorCorrectLevel:"+errorCorrectLevel);}
	var length=rsBlock.length/3;var list=[];for(var i=0;i<length;i++){var count=rsBlock[i*3+0];var totalCount=rsBlock[i*3+1];var dataCount=rsBlock[i*3+2];for(var j=0;j<count;j++){list.push(new QRRSBlock(totalCount,dataCount));}}
	return list;};QRRSBlock.getRsBlockTable=function(typeNumber,errorCorrectLevel){switch(errorCorrectLevel){case QRErrorCorrectLevel.L:return QRRSBlock.RS_BLOCK_TABLE[(typeNumber-1)*4+0];case QRErrorCorrectLevel.M:return QRRSBlock.RS_BLOCK_TABLE[(typeNumber-1)*4+1];case QRErrorCorrectLevel.Q:return QRRSBlock.RS_BLOCK_TABLE[(typeNumber-1)*4+2];case QRErrorCorrectLevel.H:return QRRSBlock.RS_BLOCK_TABLE[(typeNumber-1)*4+3];default:return undefined;}};function QRBitBuffer(){this.buffer=[];this.length=0;}
	QRBitBuffer.prototype={get:function(index){var bufIndex=Math.floor(index/8);return((this.buffer[bufIndex]>>>(7-index%8))&1)==1;},put:function(num,length){for(var i=0;i<length;i++){this.putBit(((num>>>(length-i-1))&1)==1);}},getLengthInBits:function(){return this.length;},putBit:function(bit){var bufIndex=Math.floor(this.length/8);if(this.buffer.length<=bufIndex){this.buffer.push(0);}
	if(bit){this.buffer[bufIndex]|=(0x80>>>(this.length%8));}
	this.length++;}};var QRCodeLimitLength=[[17,14,11,7],[32,26,20,14],[53,42,32,24],[78,62,46,34],[106,84,60,44],[134,106,74,58],[154,122,86,64],[192,152,108,84],[230,180,130,98],[271,213,151,119],[321,251,177,137],[367,287,203,155],[425,331,241,177],[458,362,258,194],[520,412,292,220],[586,450,322,250],[644,504,364,280],[718,560,394,310],[792,624,442,338],[858,666,482,382],[929,711,509,403],[1003,779,565,439],[1091,857,611,461],[1171,911,661,511],[1273,997,715,535],[1367,1059,751,593],[1465,1125,805,625],[1528,1190,868,658],[1628,1264,908,698],[1732,1370,982,742],[1840,1452,1030,790],[1952,1538,1112,842],[2068,1628,1168,898],[2188,1722,1228,958],[2303,1809,1283,983],[2431,1911,1351,1051],[2563,1989,1423,1093],[2699,2099,1499,1139],[2809,2213,1579,1219],[2953,2331,1663,1273]];
	
	function _isSupportCanvas() {
		return typeof CanvasRenderingContext2D != "undefined";
	}
	
	// android 2.x doesn't support Data-URI spec
	function _getAndroid() {
		var android = false;
		var sAgent = navigator.userAgent;
		
		if (/android/i.test(sAgent)) { // android
			android = true;
			var aMat = sAgent.toString().match(/android ([0-9]\.[0-9])/i);
			
			if (aMat && aMat[1]) {
				android = parseFloat(aMat[1]);
			}
		}
		
		return android;
	}
	
	var svgDrawer = (function() {

		var Drawing = function (el, htOption) {
			this._el = el;
			this._htOption = htOption;
		};

		Drawing.prototype.draw = function (oQRCode) {
			var _htOption = this._htOption;
			var _el = this._el;
			var nCount = oQRCode.getModuleCount();
			var nWidth = Math.floor(_htOption.width / nCount);
			var nHeight = Math.floor(_htOption.height / nCount);

			this.clear();

			function makeSVG(tag, attrs) {
				var el = document.createElementNS('http://www.w3.org/2000/svg', tag);
				for (var k in attrs)
					if (attrs.hasOwnProperty(k)) el.setAttribute(k, attrs[k]);
				return el;
			}

			var svg = makeSVG("svg" , {'viewBox': '0 0 ' + String(nCount) + " " + String(nCount), 'width': '100%', 'height': '100%', 'fill': _htOption.colorLight});
			svg.setAttributeNS("http://www.w3.org/2000/xmlns/", "xmlns:xlink", "http://www.w3.org/1999/xlink");
			_el.appendChild(svg);

			svg.appendChild(makeSVG("rect", {"fill": _htOption.colorLight, "width": "100%", "height": "100%"}));
			svg.appendChild(makeSVG("rect", {"fill": _htOption.colorDark, "width": "1", "height": "1", "id": "template"}));

			for (var row = 0; row < nCount; row++) {
				for (var col = 0; col < nCount; col++) {
					if (oQRCode.isDark(row, col)) {
						var child = makeSVG("use", {"x": String(row), "y": String(col)});
						child.setAttributeNS("http://www.w3.org/1999/xlink", "href", "#template")
						svg.appendChild(child);
					}
				}
			}
		};
		Drawing.prototype.clear = function () {
			while (this._el.hasChildNodes())
				this._el.removeChild(this._el.lastChild);
		};
		return Drawing;
	})();

	var useSVG = document.documentElement.tagName.toLowerCase() === "svg";

	// Drawing in DOM by using Table tag
	var Drawing = useSVG ? svgDrawer : !_isSupportCanvas() ? (function () {
		var Drawing = function (el, htOption) {
			this._el = el;
			this._htOption = htOption;
		};
			
		/**
		 * Draw the QRCode
		 * 
		 * @param {QRCode} oQRCode
		 */
		Drawing.prototype.draw = function (oQRCode) {
            var _htOption = this._htOption;
            var _el = this._el;
			var nCount = oQRCode.getModuleCount();
			var nWidth = Math.floor(_htOption.width / nCount);
			var nHeight = Math.floor(_htOption.height / nCount);
			var aHTML = ['<table style="border:0;border-collapse:collapse;">'];
			
			for (var row = 0; row < nCount; row++) {
				aHTML.push('<tr>');
				
				for (var col = 0; col < nCount; col++) {
					aHTML.push('<td style="border:0;border-collapse:collapse;padding:0;margin:0;width:' + nWidth + 'px;height:' + nHeight + 'px;background-color:' + (oQRCode.isDark(row, col) ? _htOption.colorDark : _htOption.colorLight) + ';"></td>');
				}
				
				aHTML.push('</tr>');
			}
			
			aHTML.push('</table>');
			_el.innerHTML = aHTML.join('');
			
			// Fix the margin values as real size.
			var elTable = _el.childNodes[0];
			var nLeftMarginTable = (_htOption.width - elTable.offsetWidth) / 2;
			var nTopMarginTable = (_htOption.height - elTable.offsetHeight) / 2;
			
			if (nLeftMarginTable > 0 && nTopMarginTable > 0) {
				elTable.style.margin = nTopMarginTable + "px " + nLeftMarginTable + "px";	
			}
		};
		
		/**
		 * Clear the QRCode
		 */
		Drawing.prototype.clear = function () {
			this._el.innerHTML = '';
		};
		
		return Drawing;
	})() : (function () { // Drawing in Canvas
		function _onMakeImage() {
			this._elImage.src = this._elCanvas.toDataURL("image/png");
			this._elImage.style.display = "block";
			this._elCanvas.style.display = "none";			
		}
		
		// Android 2.1 bug workaround
		// http://code.google.com/p/android/issues/detail?id=5141
		if (this._android && this._android <= 2.1) {
	    	var factor = 1 / window.devicePixelRatio;
	        var drawImage = CanvasRenderingContext2D.prototype.drawImage; 
	    	CanvasRenderingContext2D.prototype.drawImage = function (image, sx, sy, sw, sh, dx, dy, dw, dh) {
	    		if (("nodeName" in image) && /img/i.test(image.nodeName)) {
		        	for (var i = arguments.length - 1; i >= 1; i--) {
		            	arguments[i] = arguments[i] * factor;
		        	}
	    		} else if (typeof dw == "undefined") {
	    			arguments[1] *= factor;
	    			arguments[2] *= factor;
	    			arguments[3] *= factor;
	    			arguments[4] *= factor;
	    		}
	    		
	        	drawImage.apply(this, arguments); 
	    	};
		}
		
		/**
		 * Check whether the user's browser supports Data URI or not
		 * 
		 * @private
		 * @param {Function} fSuccess Occurs if it supports Data URI
		 * @param {Function} fFail Occurs if it doesn't support Data URI
		 */
		function _safeSetDataURI(fSuccess, fFail) {
            var self = this;
            self._fFail = fFail;
            self._fSuccess = fSuccess;

            // Check it just once
            if (self._bSupportDataURI === null) {
                var el = document.createElement("img");
                var fOnError = function() {
                    self._bSupportDataURI = false;

                    if (self._fFail) {
                        self._fFail.call(self);
                    }
                };
                var fOnSuccess = function() {
                    self._bSupportDataURI = true;

                    if (self._fSuccess) {
                        self._fSuccess.call(self);
                    }
                };

                el.onabort = fOnError;
                el.onerror = fOnError;
                el.onload = fOnSuccess;
                el.src = "data:image/gif;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAAHElEQVQI12P4//8/w38GIAXDIBKE0DHxgljNBAAO9TXL0Y4OHwAAAABJRU5ErkJggg=="; // the Image contains 1px data.
                return;
            } else if (self._bSupportDataURI === true && self._fSuccess) {
                self._fSuccess.call(self);
            } else if (self._bSupportDataURI === false && self._fFail) {
                self._fFail.call(self);
            }
		};
		
		/**
		 * Drawing QRCode by using canvas
		 * 
		 * @constructor
		 * @param {HTMLElement} el
		 * @param {Object} htOption QRCode Options 
		 */
		var Drawing = function (el, htOption) {
    		this._bIsPainted = false;
    		this._android = _getAndroid();
		
			this._htOption = htOption;
			this._elCanvas = document.createElement("canvas");
			this._elCanvas.width = htOption.width;
			this._elCanvas.height = htOption.height;
			el.appendChild(this._elCanvas);
			this._el = el;
			this._oContext = this._elCanvas.getContext("2d");
			this._bIsPainted = false;
			this._elImage = document.createElement("img");
			this._elImage.alt = "Scan me!";
			this._elImage.style.display = "none";
			this._el.appendChild(this._elImage);
			this._bSupportDataURI = null;
		};
			
		/**
		 * Draw the QRCode
		 * 
		 * @param {QRCode} oQRCode 
		 */
		Drawing.prototype.draw = function (oQRCode) {
            var _elImage = this._elImage;
            var _oContext = this._oContext;
            var _htOption = this._htOption;
            
			var nCount = oQRCode.getModuleCount();
			var nWidth = _htOption.width / nCount;
			var nHeight = _htOption.height / nCount;
			var nRoundedWidth = Math.round(nWidth);
			var nRoundedHeight = Math.round(nHeight);

			_elImage.style.display = "none";
			this.clear();
			
			for (var row = 0; row < nCount; row++) {
				for (var col = 0; col < nCount; col++) {
					var bIsDark = oQRCode.isDark(row, col);
					var nLeft = col * nWidth;
					var nTop = row * nHeight;
					_oContext.strokeStyle = bIsDark ? _htOption.colorDark : _htOption.colorLight;
					_oContext.lineWidth = 1;
					_oContext.fillStyle = bIsDark ? _htOption.colorDark : _htOption.colorLight;					
					_oContext.fillRect(nLeft, nTop, nWidth, nHeight);
					
					// 안티 앨리어싱 방지 처리
					_oContext.strokeRect(
						Math.floor(nLeft) + 0.5,
						Math.floor(nTop) + 0.5,
						nRoundedWidth,
						nRoundedHeight
					);
					
					_oContext.strokeRect(
						Math.ceil(nLeft) - 0.5,
						Math.ceil(nTop) - 0.5,
						nRoundedWidth,
						nRoundedHeight
					);
				}
			}
			
			this._bIsPainted = true;
		};
			
		/**
		 * Make the image from Canvas if the browser supports Data URI.
		 */
		Drawing.prototype.makeImage = function () {
			if (this._bIsPainted) {
				_safeSetDataURI.call(this, _onMakeImage);
			}
		};
			
		/**
		 * Return whether the QRCode is painted or not
		 * 
		 * @return {Boolean}
		 */
		Drawing.prototype.isPainted = function () {
			return this._bIsPainted;
		};
		
		/**
		 * Clear the QRCode
		 */
		Drawing.prototype.clear = function () {
			this._oContext.clearRect(0, 0, this._elCanvas.width, this._elCanvas.height);
			this._bIsPainted = false;
		};
		
		/**
		 * @private
		 * @param {Number} nNumber
		 */
		Drawing.prototype.round = function (nNumber) {
			if (!nNumber) {
				return nNumber;
			}
			
			return Math.floor(nNumber * 1000) / 1000;
		};
		
		return Drawing;
	})();
	
	/**
	 * Get the type by string length
	 * 
	 * @private
	 * @param {String} sText
	 * @param {Number} nCorrectLevel
	 * @return {Number} type
	 */
	function _getTypeNumber(sText, nCorrectLevel) {			
		var nType = 1;
		var length = _getUTF8Length(sText);
		
		for (var i = 0, len = QRCodeLimitLength.length; i <= len; i++) {
			var nLimit = 0;
			
			switch (nCorrectLevel) {
				case QRErrorCorrectLevel.L :
					nLimit = QRCodeLimitLength[i][0];
					break;
				case QRErrorCorrectLevel.M :
					nLimit = QRCodeLimitLength[i][1];
					break;
				case QRErrorCorrectLevel.Q :
					nLimit = QRCodeLimitLength[i][2];
					break;
				case QRErrorCorrectLevel.H :
					nLimit = QRCodeLimitLength[i][3];
					break;
			}
			
			if (length <= nLimit) {
				break;
			} else {
				nType++;
			}
		}
		
		if (nType > QRCodeLimitLength.length) {
			throw new Error("Too long data");
		}
		
		return nType;
	}

	function _getUTF8Length(sText) {
		var replacedText = encodeURI(sText).toString().replace(/\%[0-9a-fA-F]{2}/g, 'a');
		return replacedText.length + (replacedText.length != sText ? 3 : 0);
	}
	
	/**
	 * @class QRCode
	 * @constructor
	 * @example 
	 * new QRCode(document.getElementById("test"), "http://jindo.dev.naver.com/collie");
	 *
	 * @example
	 * var oQRCode = new QRCode("test", {
	 *    text : "http://naver.com",
	 *    width : 128,
	 *    height : 128
	 * });
	 * 
	 * oQRCode.clear(); // Clear the QRCode.
	 * oQRCode.makeCode("http://map.naver.com"); // Re-create the QRCode.
	 *
	 * @param {HTMLElement|String} el target element or 'id' attribute of element.
	 * @param {Object|String} vOption
	 * @param {String} vOption.text QRCode link data
	 * @param {Number} [vOption.width=256]
	 * @param {Number} [vOption.height=256]
	 * @param {String} [vOption.colorDark="#000000"]
	 * @param {String} [vOption.colorLight="#ffffff"]
	 * @param {QRCode.CorrectLevel} [vOption.correctLevel=QRCode.CorrectLevel.H] [L|M|Q|H] 
	 */
	QRCode = function (el, vOption) {
		this._htOption = {
			width : 256, 
			height : 256,
			typeNumber : 4,
			colorDark : "#000000",
			colorLight : "#ffffff",
			correctLevel : QRErrorCorrectLevel.H
		};
		
		if (typeof vOption === 'string') {
			vOption	= {
				text : vOption
			};
		}
		
		// Overwrites options
		if (vOption) {
			for (var i in vOption) {
				this._htOption[i] = vOption[i];
			}
		}
		
		if (typeof el == "string") {
			el = document.getElementById(el);
		}

		if (this._htOption.useSVG) {
			Drawing = svgDrawer;
		}
		
		this._android = _getAndroid();
		this._el = el;
		this._oQRCode = null;
		this._oDrawing = new Drawing(this._el, this._htOption);
		
		if (this._htOption.text) {
			this.makeCode(this._htOption.text);	
		}
	};
	
	/**
	 * Make the QRCode
	 * 
	 * @param {String} sText link data
	 */
	QRCode.prototype.makeCode = function (sText) {
		this._oQRCode = new QRCodeModel(_getTypeNumber(sText, this._htOption.correctLevel), this._htOption.correctLevel);
		this._oQRCode.addData(sText);
		this._oQRCode.make();
		this._el.title = sText;
		this._oDrawing.draw(this._oQRCode);			
		this.makeImage();
	};
	
	/**
	 * Make the Image from Canvas element
	 * - It occurs automatically
	 * - Android below 3 doesn't support Data-URI spec.
	 * 
	 * @private
	 */
	QRCode.prototype.makeImage = function () {
		if (typeof this._oDrawing.makeImage == "function" && (!this._android || this._android >= 3)) {
			this._oDrawing.makeImage();
		}
	};
	
	/**
	 * Clear the QRCode
	 */
	QRCode.prototype.clear = function () {
		this._oDrawing.clear();
	};
	
	/**
	 * @name QRCode.CorrectLevel
	 */
	QRCode.CorrectLevel = QRErrorCorrectLevel;
})();
(function(window) {
  'use strict';

  var respHeaderParsePtn = /([^\r\n:]+):\s*([^\r\n]+)/g;
  var queryStrParsePtn = /([^=&]+)(?:=([^&]*))?/g;
  var intPtn = /^[1-9]\d*$/; // digits-only, not starting with 0
  var spacePtn = /^\s+$/;
  var insPosToTraversalMap = {
    beforebegin: 'previousElementSibling',
    afterbegin: 'firstElementChild',
    beforeend: 'lastElementChild',
    afterend: 'nextElementSibling',
  };

  var stateHistory;

  // variable height elem centering
  // use fieldset for component-wide disable support
  /* jshint multistr: true */
  var html = '\
    <fieldset id="trta1" class="tr-auth-dialog">\
      <div class="trta1-outer">\
        <!--img src="tr-logo.svg" class="trta1-logo trta1-print-only"-->\
        <div class="trta1-middle">\
          <div id="trta1-browsehappy">\
            <h1 t8>Thomson Reuters</h1>\
            <h2 t8>Your Browser is not supported</h2>\
            <p t8>To log in to Onvio, please use one of the supported internet browsers below.</p>\
            <ul>\
              <li id="trta1-chrome-upgrade-item"><a target="_blank" rel="noopener" href="<%= browserLinks.chrome %>">Google Chrome</a></li>\
              <li id="trta1-firefox-upgrade-item"><a target="_blank" rel="noopener" href="<%= browserLinks.firefox %>">Mozilla Firefox</a></li>\
              <li id="trta1-edge-upgrade-item"><a target="_blank" rel="noopener" href="<%= browserLinks.edge %>">Microsoft Edge</a></li>\
              <li id="trta1-safari-upgrade-item"><a target="_blank" rel="noopener" href="<%= browserLinks.safari %>">Apple Safari</a></li>\
            </ul>\
            <div class="trta1-btn-group">\
              <button t8 class="trta1-btn-primary trta1-outdated-browser-btn">Ignore warning</button>\
            </div>\
            <div class="trta1-icon-warning"></div>\
          </div>\
        </div>\
      </div>\
    </fieldset>\
  ';
  /* jshint multistr: false */

  /* translation fn */
  function getTranslateFn(locale) {
    locale = locale || 'en-US';
    return function(key) {
      var strings = window.trAuth.submodules.locales[locale];
      return (strings && strings[key.trim()]) || key.trim();
    };
  }

  function getRootElem() {
    // Document.getElementById will not select element in shadow dom
    if (window.trAuth.shadowDomElem) {
      return window.trAuth.shadowDomElem.querySelector('#trta1');
    }
    return document.getElementById('trta1');
  }

  /* Utils */

  function isObject(value) {
    return value !== null && typeof value === 'object' && !Array.isArray(value);
  }

  function isTagType(elem, tagType) {
    return elem.tagName.toLowerCase() === tagType.toLowerCase();
  }

  // based on angular.js baseExtend
  function objAssignDeep(dst) {
    for (var i = 1, ii = arguments.length; i < ii; ++i) {
      var obj = arguments[i];
      if (!isObject(obj) && !Array.isArray(obj)) continue;
      var keys = Object.keys(obj);
      for (var j = 0, jj = keys.length; j < jj; j++) {
        var key = keys[j];
        var src = obj[key];

        if (isObject(src)) {
          if (src.nodeName) {
            // don't deep clone dom nodes!
            dst[key] = src;
          } else {
            if (!isObject(dst[key])) dst[key] = Array.isArray(src) ? [] : {};
            objAssignDeep(dst[key], src);
          }
        } else {
          dst[key] = src;
        }
      }
    }
    return dst;
  }

  function seekObjPath(name, context, create) {
    var i, segs = name.split('.'), len = segs.length, seg, last = context || window;
    for (i = 0; i < len; i++) {
      seg = segs[i];
      if(!isObject(last[seg]) && !(create && typeof last[seg] === 'undefined')) return null;
      last = last[seg] = last[seg] || {};
    }
    return last;
  }

  // careful since this uses innerHTML to render
  function openPrintWindow(content, title) {
    var w = window.open('', 'trta1-print-window');
    w.document.body.innerHTML = content;
    if (title) w.document.title = title;
    // IWebBrowser2 control might fail
    try {
      if (w.focus) w.focus();
      if (w.print) w.print();
    } catch(e) {}
  }

  var errorEventTypePattern = /^trta1-[^*]+-error$/;
  function trigger(type, detail, target) {
    var event = new CustomEvent(type, { bubbles: true, cancelable: true, detail: detail });
    target = target || getRootElem() || window;

    // dispatch to browser
    target.dispatchEvent(event);

    // trigger wildcard error
    if (errorEventTypePattern.test(type)) {
      trigger('trta1-*-error', detail, target);
    }

    // log special events
    if (type.indexOf('tr') === 0) {
      if (window.trAuth.debug) {
        window.console.log(type, event);
      }
    }
  }

  function extractFormData(form, overrides) {
    var name, nameMap = overrides.namedFieldMap,
      namedFields = form.querySelectorAll('input[name], button[name], select[name], textarea[name]');

    return Array.from(namedFields).reduce(function(obj, namedField) {
      if (namedField.hasAttribute('tr-nosend')) { return obj; } // skip sending these fields
      name = nameMap && nameMap[namedField.name] || namedField.name;
      if (namedField.hasAttribute('tr-noconvert')) { // don't run fromString
        obj[name] = namedField.value;
      } else {
        obj[name] = fromString(namedField.value);
      }
      return obj;
    }, {});
  }

  function toFormUrlEncoded(obj) {
    return Object.keys(obj).reduce(function(prev, key) {
      if (obj[key] != null) { // coerce undefined
        prev.push(encodeURIComponent(key) + '=' + encodeURIComponent(obj[key]));
      }
      return prev;
    }, []).join('&').replace(/%20/g, '+');
  }

  function normalizeXhrResponse(xhr) {
    var headers = {}, contentType, data;

    if (xhr.getAllResponseHeaders)
      xhr.getAllResponseHeaders().replace(respHeaderParsePtn, function(pair, key, value) {
        headers[key.toLowerCase()] = value;
      });

    // if json, parse
    contentType = headers['content-type'];
    if (contentType && contentType.indexOf('application/json') === 0) {
      data = JSON.parse(xhr.responseText);
    } else {
      data = xhr.responseText;
    }

    return {
      // IE9 will sometimes return 1223 instead of 204, slege hammer it
      status: xhr.status === 1223 ? 204 : xhr.status,
      statusText: xhr.statusText,
      headers: headers,
      data: data
    };
  }

  // defensive get/set sugar for localStorage, mostly bc of this
  // https://kadoppe.com/archives/2013/04/ccleaner-ie-cookie-localstorage.html
  function store(key, value) {
    if (typeof value !== 'undefined') { // set
      try {
        return window.localStorage.setItem(key, value);
      } catch(e) {
        return undefined;
      }
    } else { // get
      try {
        return window.localStorage.getItem(key);
      } catch(e) {
        return null;
      }
    }
  }

  // does simple bool and int conversions e.g. 'true' -> true, '12' -> 12
  // assumes all field values should be trimmed of leading/trailing spaces
  function fromString(value) {
    if (typeof value !== 'string') return value;

    value = value.trim();
    if (value === 'true') value = true;
    else if (value === 'false') value = false;
    else if (intPtn.test(value)) {
      var num = parseInt(value, 10);
      if (!isNaN(num)) value = num;
    }
    return value;
  }

  function removeNodes(els) {
    if (!els || els.length === 0) return;
    if (typeof els.length === 'undefined') els.parentNode.removeChild(els);
    else Array.from(els).forEach(function(el) {
      el.parentNode.removeChild(el);
    });
  }

  function getFieldLabelTextNode(field) {
    // note: assumes label element contains field
    var label = closestTagName(field, 'label');
    if (!label) return null;
    var child = label.firstChild;
    while (child) {
      if (child.nodeType === 1) child = child.firstChild;
      if (child.nodeType === 3 && !spacePtn.test(child.nodeValue)) return child;
      child = child.nextSibling;
    }
  }

  function template(htmlTemplate, options) {
    return function(data) {
      return window.UnderscoreTemplate(htmlTemplate)(objAssignDeep({}, (options && options.templateData ? options.templateData : undefined), data));
    };
  }

  function walk(el, fn) {
    fn(el);
    el = el.firstElementChild;
    while(el) {
      walk(el, fn);
      el = el.nextElementSibling;
    }
  }

  function localizeElem(elem, $t) {
    walk(elem, function(el) {
      if (el.hasAttribute('t8')) {
        var title = el.getAttribute('title');
        var placeholder = el.getAttribute('placeholder');
        var ariaLabel = el.getAttribute('aria-label');

        if (title) {
          el.setAttribute('title', $t(title));
        }
        if (placeholder) {
          el.setAttribute('placeholder', $t(placeholder));
        }
        if (ariaLabel) {
          el.setAttribute('aria-label', $t(ariaLabel));
        }
        // note: since we are not using user supplied data we do not need to sanitize
        el.innerHTML = $t(el.innerHTML);
      }
    });
    return elem;
  }

  function toElem(htmlToEl) {
    var container = document.createElement('div');
    // note: since we are not using user supplied data we do not need to sanitize
    container.innerHTML = htmlToEl;
    return container.firstElementChild;
  }

  function renderTemplate(tmpl, data, target, position, locale) {
    var $t = getTranslateFn(locale);
    var htmlTemplate = (typeof tmpl === 'function') ? tmpl(objAssignDeep({}, data, { $t: $t, locale: locale })) : tmpl;
    var elem = toElem(htmlTemplate);
    var localizedElem = localizeElem(elem, $t);

    target = target || getRootElem().querySelector('.trta1-middle');
    position = position || 'beforeend';

    target.insertAdjacentElement(position, localizedElem);
    return target[insPosToTraversalMap[position]];
  }

  function loadScript(src) {
    var head = document.getElementsByTagName('head')[0],
      script = head.querySelector('script[src="' + src + '"]');

    // remove if found so we can get it to re-execute as some scripts need
    if (script) removeNodes(script);

    script = document.createElement('script');
    script.src = src;
    head.appendChild(script);
  }

  // exponential backoff in seconds
  function calcBackoff(attempts, min, max) {
    var delay = Math.round((1 / 2) * (Math.pow(2, attempts) - 1));
    min = min || 1; // 1s default min
    max = max || 300; // 5m default max
    return Math.min(max, Math.max(min, delay));
  }

  function requestTimeout(fn, delay) {
    var start = new Date().getTime(),
      handle = {};

    function loop(){
      var current = new Date().getTime(),
        delta = current - start;

      if (delta >= delay) {
        fn.call();
      } else {
        handle.value = window.requestAnimationFrame(loop);
      }
    }

    handle.value = window.requestAnimationFrame(loop);
    return handle;
  }

  function cancelRequestTimeout(handle) {
    window.cancelAnimationFrame(handle.value);
  }

  // delay and timeout in seconds
  function pollFormRequest(form, testFn, successFn, timeoutFn, errorFn, delay, timeout, leadingEdge, continueOnError) {
    var endTime = Number(new Date()) + (timeout || 40) * 1e3, // 40s default timeout
      typePrefix = (form.id || form.name) + '-',
      evtTypes = typePrefix + 'success ' + typePrefix + 'error',
      attempts = 0,
      adjustedDelay,
      timer,
      unlisten = listen(evtTypes, testResponse, form),
      cancelFn = function() {
        if (timer) {
          cancelRequestTimeout(timer);
          timer = null;
        }
        if (unlisten) {
          unlisten();
          unlisten = null;
        }
      };

    delay = delay || 2; // 2s default delay

    // prepare for possible trailing edge
    timer = requestTimeout(function() {
      // first attempt
      attempts++;
      trigger('submit', null, form);
    }, leadingEdge ? 0 : delay * 1e3);

    function testResponse(resp) {
      if (/-success$/.test(resp.type)) {
        if (testFn(resp)) { // if condition met, exit
          cancelFn();
          if (successFn) successFn(resp);
          return;
        }
        // success = no adjustment
        adjustedDelay = delay;
      } else { // error = exponentially backoff delay
        if (continueOnError !== true) {
          cancelFn();
          if (errorFn) errorFn(resp);
          return;
        }
        adjustedDelay = delay + calcBackoff(attempts);
      }
      if (Number(new Date()) < endTime) { // not timed out
        timer = requestTimeout(function() {
          attempts++;
          trigger('submit', null, form);
        }, adjustedDelay * 1e3);
      } else { // timed out
        cancelFn();
        if (timeoutFn) {
          // wait till next loop to get around async form request result firing after
          setTimeout(timeoutFn, 0, resp);
        }
        return;
      }
    }

    return cancelFn;
  }

  function makeFormRequest(form, options, successFn, errorFn, doneFn) {
    var overrides = options.formOverrides && options.formOverrides[form.name] || {};

    var method = overrides.method || form.getAttribute('method'),
      action = overrides.action || form.getAttribute('action');

    if (!method || !action) return;

    method = method.toUpperCase();

    var xhr = new XMLHttpRequest(),
      headers = objAssignDeep(
        {},
        options.headers,
        overrides.headers
      ),
      formData = objAssignDeep(
        { type: options.type, sp: options.sp },
        options.payload,
        overrides.payload,
        extractFormData(form, overrides)
      ),
      sendData, contentType;

    if (method === 'GET') {
      action += (action.indexOf('?') > -1 ? '&' : '?') + toFormUrlEncoded(formData);
    } else {
      contentType = headers['content-type'];

      if (contentType && contentType.indexOf('application/x-www-form-urlencoded') === 0) {
        sendData = toFormUrlEncoded(formData);
      } else { // detault to json
        sendData = JSON.stringify(formData);
      }
    }

    xhr.onreadystatechange = function() {
      if (xhr.readyState === 4) {
        var resp = normalizeXhrResponse(xhr);
        if (overrides.statusMap && overrides.statusMap[resp.status]) {
          resp.status = overrides.statusMap[resp.status];
        }

        var isSuccess = resp.status >= 200 && resp.status <= 299;

        if (!isSuccess) {
          // note: we redirect on status 4xx rather than 3xx so we can drive it
          // from the client-side component avoiding CORS
          var isRedirect = getPrimaryErrorReason(resp) === 'REDIRECT';
          var locationHdr = resp.headers.location;

          if (isRedirect && locationHdr) {
            // redirect and exit
            location.href = locationHdr;
            return;
          }

          // put this here so we can modify normalized response obj
          // note: this works and the handler fires on next cycle, go figure
          xhr.ontimeout = function() {
            resp.status = 500; // normally 0, making 500 to trigger offline mode in desktop
            resp.statusText = 'timeout';
          };
        }

        // allow ontimeout a chance to refine resp by deferring events till next cycle
        setTimeout(function() {
          form.trAuthLastResponse = resp;
          if (isSuccess) {
            if (successFn) successFn(resp);
          } else {
            if (errorFn) errorFn(resp);
          }
          if (doneFn) doneFn(resp);
        }, 0);
      }
    };

    updateFormState(form, 'processing', options);
    xhr.open(method, action);
    xhr.timeout = overrides.timeout || 60000; // 60s
    // set headers
    Object.keys(headers).forEach(function(key) {
      xhr.setRequestHeader(key, headers[key]);
    });
    try {
      xhr.send(sendData);
    } catch(e) {
      errorFn();
    }
  }

  function getSecondaryError(resp) {
    var secondary, secondaries;
    if (resp.data && resp.data.errors && resp.data.errors.length) {
      secondaries = resp.data.errors.filter(function(err) {
        return !err.primary;
      });
      // if not marked, assume the first error is the primary
      secondary = (secondaries && secondaries[0]) || resp.data.errors[0];
    }
    return secondary;
  }

  function getPrimaryError(resp) {
    var primary, primaries;
    if (resp.data && resp.data.errors && resp.data.errors.length) {
      primaries = resp.data.errors.filter(function(err) {
        return err.primary;
      });
      // if not marked, assume the first error is the primary
      primary = (primaries && primaries[0]) || resp.data.errors[0];
    }
    return primary;
  }

  function getPrimaryErrorReason(resp) {
    var reason, primary = getPrimaryError(resp);
    if (primary) {
      reason = primary.reason;
    } else if (resp.data && resp.data.error && typeof resp.data.error === 'string' && resp.data.error.split('_').length) {
      reason = resp.data.error;
    }
    return reason;
  }

  function getLastFormResp(form) {
    if (typeof form === 'string') {
      return document.forms[form].trAuthLastResponse;
    } else {
      return form.trAuthLastResponse;
    }
  }

  function getFormStateMsgs(form, options) {
    var formOverrideMsgs;
    // if there are overrides look them up
    if (options && options.formOverrides && options.formOverrides[form.name]) {
      formOverrideMsgs = options.formOverrides[form.name].formStateMessages;
    }
    // get reason to message map
    return objAssignDeep({}, options.formStateMessages, formOverrideMsgs || {});
  }

  function getFormStateMessage(form, state, options, detail) {
    var msg, reason, msgs,
      dfault = 'default'; // get around ie8 keyword prob after min

    if (isObject(detail)) {
      // if we have more error detail, use it
      // otherwise, use statusText
      // otherwise, use status (HTTP/2)
      reason = getPrimaryErrorReason(detail) || detail.statusText.toLowerCase() || detail.status.toString();
    } else if (typeof detail === 'string') {
      reason = detail;
    } else {
      reason = dfault;
    }

    if (options) {
      msgs = getFormStateMsgs(form, options);

      /*eslint dot-notation: ["error", { "allowKeywords": false }]*/
      msg = msgs[state] && (msgs[state][reason] || msgs[state][dfault]);
    }
    return msg;
  }

  // html disable attrib at a form level doesn't work but it will at the root fieldset
  function toggleFormDisable(form, state) {
    var root = getRootElem();
    if (typeof state !== 'boolean') state = !root.disabled;
    root[state ? 'setAttribute' : 'removeAttribute']('disabled', 'disabled');
  }

  function updateFormMsg(form, msg) {
      // safe way to avoid possible xss
      form.querySelector('.trta1-form-msg').textContent = msg;
  }

  // states: processing, success, error
  function updateFormState(form, state, options, detail) {
    var msg;

    // clear state classes
    form.classList.remove('trta1-processing', 'trta1-success', 'trta1-error');
    // remove error and validation msgs
    removeNodes(form.querySelectorAll('.trta1-form-msg, .trta1-validation-msg'));
    // clear disable or set for processing
    if (!form.classList.contains('trta1-nodisable')) {
      toggleFormDisable(form, state === 'processing');
    }

    // if default, return
    if (state === 'default') {
      form.classList.remove('trta1-submitted');
      return;
    }

    form.classList.add('trta1-' + state);
    msg = getFormStateMessage(form, state, options, detail);
    if (!form.classList.contains('trta1-not-display-success') || state !== "success") {
      if (msg) {
        if(!form.classList.contains('trta1-not-display-wait') || state !== 'processing' ){
          var msgContainer = document.createElement('div');
          msgContainer.classList.add('trta1-form-msg');
          form.insertAdjacentElement('afterbegin', msgContainer);
          updateFormMsg(form, msg);
        }
      }
    }

    // todo: remove form.id, need to fix login
    trigger((form.id || form.name) + '-' + state, detail, form);

    // change form on state
    var gotoForm = form.getAttribute('tr-goto-on' + state);
    if (gotoForm) {
      changeForm(gotoForm, form.parentElement, detail);
    }
  }

  function exitForm(form, detail) {
    if (!form) return;

    updateFormState(form, 'default'); // reset form state
    // form.reset(); // clear fields
    form.classList.remove('trta1-active-form');
    // todo: remove form.id, need to fix login
    trigger((form.id || form.name) + '-exit', detail, form);
  }

  function changeForm(formName, context, detail) {
    var form, prevForm;

    if (!formName) return false;

    context = context || getRootElem();
    prevForm = context.querySelector('.trta1-active-form');

    // handle $pecial targets
    switch (formName) {
      case 'trta1-$back':
        formName = stateHistory[stateHistory.length - 2];
        break;
      case 'trta1-$start':
        formName = stateHistory[0];
        break;
      case 'trta1-$close':
        trigger('tr-dialog-user-closed', {form: prevForm.name});
        exitForm(prevForm, detail);
        destroy();
        return;
      case 'trta1-$retry':
        trigger('submit', null, prevForm);
        return;
    }

    // resolve form
    if (typeof formName === 'string') {
      form = context.querySelector('form[name=' + formName + ']');
    } else {
      form = formName;
    }
    if (!form) return false;

    // exit prev
    exitForm(prevForm, detail);

    form.classList.add('trta1-active-form');
    stateHistory.push(formName);

    focusFirstEnabledField(form, function(field) {
      // primary buttons only
      if (isTagType(field, 'button')) return field.classList.contains('trta1-btn-primary');
      // empty fields only
      return field.value.length === 0;
    });

    // todo: remove form.id, need to fix login
    trigger((form.id || form.name) + '-enter', detail, form);

    // autosubmit
    if (form.getAttribute('tr-autosubmit') !== null) {
      trigger('submit', null, form);
    }

    return true;
  }

  function focusFirstEnabledField(context, filter) {
    var fields = context.querySelectorAll('input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled])');
    var filtered, field;

    if (!fields.length) return;

    field = fields[0];

    // give time for autofill to complete
    setTimeout(function() {
      // filter inside timeout in case you are filtering on value
      if (filter) {
        filtered = Array.from(fields).filter(filter);
        field = filtered[0];
      }
      if (!field) return;

      // if focus and/or select is available use it
      // sometimes it's available but IWebBrowser2 control fails
      try {
        if (field.focus) field.focus();
        if (field.select) field.select();
      } catch(e) {}
    }, 250);
  }

  function processOverrides(options, rootElem) {
    if (options.formOverrides) {
      Object.keys(options.formOverrides).forEach(function(formName) {
        var form = rootElem.querySelector('form[name=' + formName + ']'), overrides;
        if (!form) return;

        overrides = options.formOverrides[formName];
        overrides.payload = overrides.payload || {};

        // process values
        if (overrides.values) {
          Object.keys(overrides.values).forEach(function(fieldName) {
            var value = overrides.values[fieldName];
            // jshint eqnull:true
            if (value == null) return;

            form.elements[fieldName].value = value;
          });
        }

        // process types
        if (overrides.types) {
          Object.keys(overrides.types).forEach(function(fieldName) {
            var value = overrides.types[fieldName];
            // jshint eqnull:true
            if (value == null) return;

            form.elements[fieldName].type = value;
          });
        }

        // process labels
        if (overrides.labels) {
          Object.keys(overrides.labels).forEach(function(fieldName) {
            var field = form.elements[fieldName];
            var value = overrides.labels[fieldName];
            // jshint eqnull:true
            if (!field || value == null) return;

            if (field.placeholder) field.placeholder = value;
            getFieldLabelTextNode(field).nodeValue = value;
          });
        }

        // process hide
        if (overrides.hide) {
          Object.keys(overrides.hide).forEach(function(fieldName) {
            var field = form.elements[fieldName];
            if (!field) return;

            field[overrides.hide[fieldName] ? 'setAttribute' : 'removeAttribute']('disabled', 'disabled');

            if (isTagType(field.parentElement, 'label')) {
              field = field.parentElement;
            }
            field.classList[overrides.hide[fieldName] ? 'add' : 'remove']('trta1-hide');
          });
        }

        // process disable
        if (overrides.disable) {
          Object.keys(overrides.disable).forEach(function(fieldName) {
            var field = form.elements[fieldName];
            if (!field) return;

            field[overrides.disable[fieldName] ? 'setAttribute' : 'removeAttribute']('disabled', 'disabled');
          });
        }
      });
    }
  }

  // expects typical format from location.search, i.e. expects leading '?'
  // no complex types supported e.g. Object, Array
  function parseQueryStr(qStr) {
    var qObj = {};
    qStr.substring(1).replace(/\+/g, ' ').replace(queryStrParsePtn, function(pair, key, value) {
      qObj[decodeURIComponent(key)] = fromString(decodeURIComponent(value));
    });
    return qObj;
  }

  function getValidationState(field) {
    for (var state in field.validity) {
      if (field.validity[state] === true) return state;
    }
  }

  function getValidationMessage(form, field, options) {
    var formOverrideMsgs;
    if (options.formOverrides && options.formOverrides[form.name]) {
      formOverrideMsgs = options.formOverrides[form.name].validationMessages;
    }
    var msgs = objAssignDeep({}, options.validationMessages, formOverrideMsgs);
    return msgs[getValidationState(field)] || field.validationMessage;
  }

  function clearFieldValidation(field, form) {
    removeNodes(form.querySelector('[name=' + field.name + '] + .trta1-validation-msg'));
  }

  function renderFieldValidation(field, form, options) {
    var msg, labelTextNode, labelText;
    var msgContainer = form.querySelector('[name=' + field.name + '] + .trta1-validation-msg');

    labelTextNode = getFieldLabelTextNode(field);
    labelText = labelTextNode && labelTextNode.nodeValue.trim() || 'This field';
    msg = getValidationMessage(form, field, options)
      .replace('{{label}}', labelText)
      .replace('{{title}}', field.title || options.state.$t('Invalid value entered.'));

    if (!msgContainer) {
      msgContainer = document.createElement('div');
      msgContainer.classList.add('trta1-validation-msg');
      field.insertAdjacentElement('afterend', msgContainer);
    }
    msgContainer.textContent = msg;
  }

  function validateForm(form, options) {
    if (!form.checkValidity) return true; // not supported, let server validate
    if (!form.classList.contains('trta1-submitted')) return;

    var isValid = form.checkValidity();

    // clear old msgs
    removeNodes(form.querySelectorAll('.trta1-validation-msg'));

    // if invalid, setup msgs
    if (!isValid) {
      Array.from(form.querySelectorAll('input:invalid, button:invalid, select:invalid, textarea:invalid')).forEach(function(field) {
        renderFieldValidation(field, form, options);
      });
    }

    return isValid;
  }

  function validateField(field, options) {
    if (!field.checkValidity) return true; // not supported, let server validate

    var form = closestTagName(field, 'form');
    if (!form.classList.contains('trta1-submitted')) return;

    var isValid = field.checkValidity();

    // if invalid, setup msgs
    if (!isValid) {
      renderFieldValidation(field, form, options);
    } else {
      clearFieldValidation(field, form);
    }

    return isValid;
  }

  function closestTagName(elem, tagName) {
    var parent = elem.parentElement;
    if (!parent) return null;
    if (isTagType(parent, tagName)) return parent;
    return closestTagName(parent, tagName);
  }

  function listen(types, fn, el, once) {
    el = el || getRootElem() || window;
    types.split(' ').forEach(function(type) {
      el.addEventListener(type, once ? function onceFn(evt) {
        unlisten(types, onceFn, el);
        fn.call(this, evt);
      } : fn, false);
    });
    return function() { unlisten(types, fn, el); };
  }

  function unlisten(types, fn, el) {
    el = el || getRootElem() || window;
    types.split(' ').forEach(function(type) {
      el.removeEventListener(type, fn, false);
    });
  }

  // here so IE8 parts are happy, since classList polyfill doesn't work
  function classListAdd(el, classes) {
    el.className += ' ' + classes;
  }

  var ieAgent = (function() {
    var msie = navigator.userAgent.match(/MSIE (\d+)/);
    var trident = navigator.userAgent.match(/Trident\/(\d+)/);
    var result = {
      ie: false,
      ver: 0,
      emul: 0,
      compat: false
    };

    if (msie) {
      result.ie = true;
      result.ver = result.emul = parseInt(msie[1], 10);
    }

    // IE8+ has the more accurate trident
    if (trident) {
      result.ie = true;
      result.ver = parseInt(trident[1], 10) + 4;
      result.emul = result.emul || result.ver;
    }

    result.compat = result.ver !== result.emul;

    return result;
  })();

  // note: only based on msie version for now
  function isBrowserSupported(options) {
    return !isUnsupportedBrowser(options);
  }
  function isOutdatedBrowser(options) {
    if (options.outdatedBrowser) return true;
    return ieAgent.ie && ieAgent.ver < options.minimumMsieWarn;
  }
  function isUnsupportedBrowser(options) {
    if (options.unsupportedBrowser) return true;
    return ieAgent.ie && ieAgent.ver < options.minimumMsie;
  }

  function inputPlaceholderIsSupported() {
    return 'placeholder' in document.createElement('input');
  }

  /* Setup */
  function moduleReady(context, options) {
    var h1 = context.querySelector('h1');
    if (options.title && h1) {
      h1.textContent = options.title;
    }

    processOverrides(options, context);

    // display start form from param or first named form
    // todo: remove deprecated startSection
    changeForm(options.startingForm || options.startSection || context.querySelector('form[name]'), context);
  }

  function getDefaultOptions(locale) {
    var browserDownloads = {
      'en-US': {
        edge: 'https://www.microsoft.com/en-us/windows/microsoft-edge',
        chrome: 'https://www.google.com/chrome',
        firefox: 'https://www.mozilla.com/en-US/firefox/',
        safari: 'https://support.apple.com/downloads/#safari'
      },
      'es-AR': {
        edge: 'https://www.microsoft.com/es-ar/windows/microsoft-edge',
        chrome: 'https://www.google.com.mx/intl/es-419/chrome/browser/desktop/',
        firefox: 'https://www.mozilla.org/es-AR/firefox/',
        safari: 'https://www.apple.com/la/safari/'
      },
      'pt-BR': {
        edge: 'https://www.microsoft.com/pt-br/windows/microsoft-edge',
        chrome: 'https://www.google.com/intl/pt-BR/chrome/',
        firefox: 'https://www.mozilla.org/pt-BR/firefox/',
        safari: 'http://www.apple.com/br/safari/'
      },
      'fr-CA': {
        edge: 'https://www.microsoft.com/fr-ca/windows/microsoft-edge',
        chrome: 'https://www.google.com/intl/fr_ca/chrome/browser/',
        firefox: 'https://www.mozilla.org/fr/firefox/',
        safari: 'https://www.apple.com/ca/fr/safari/'
      },
      'en-GB': {
        edge: ' https://www.microsoft.com/en-gb/windows/microsoft-edge',
        chrome: 'https://www.google.com/intl/en_uk/chrome/browser/',
        firefox: 'https://www.mozilla.org/en-GB/firefox/',
        safari: 'https://www.apple.com/uk/safari/'
      },
      'en-AU': {
        edge: 'http://www.microsoft.com/en-au/windows/microsoft-edge',
        chrome: 'https://www.google.com/intl/en_au/chrome/browser/',
        firefox: 'https://www.mozilla.org/en-US/firefox/',
        safari: 'http://www.apple.com/au/safari/'
      },
      'en-BR': {
        edge: 'https://www.microsoft.com/en-us/windows/microsoft-edge',
        chrome: 'https://www.google.com/intl/en-BR/chrome/',
        firefox: 'https://www.mozilla.org/en-US/firefox/',
        safari: 'https://support.apple.com/downloads/#safari  '
      },
      'en-CA': {
        edge: 'https://www.microsoft.com/en-ca/windows/microsoft-edge',
        chrome: 'https://www.google.com/intl/en_ca/chrome/browser/',
        firefox: 'https://www.mozilla.com/en-CA/firefox/',
        safari: 'https://www.apple.com/ca/safari/'
      }
    }
    var browserLinks = browserDownloads[locale] || browserDownloads['en-US'];
    var $t = getTranslateFn(locale);
    return {
      minimumMsie: 11,
      minimumMsieWarn: 11,
      locale: 'en-US',
      headers: {
        'content-type': 'application/json;charset=utf-8',
        'accept': 'application/json'
      },
      formStateMessages: {
        'processing': {
          'default': $t('Please wait.')
        },
        'success': {
          'default': $t('Success!')
        },
        'error': {
          'default': $t('An unexpected error occurred. Please try again.'),
          /* Custom service error reasons */
          // this redirect error should not show up unless something went wrong
          'REDIRECT': $t('An unexpected error occurred while redirecting your request.'),
          /* Custom client-side keys */
          'timeout': $t('The server did not respond in time. Please try again.'),
          /* Http statusText.toLowerCase() for AWS since it lowercases response
             as well as status codes for HTTP/2 since it is missing statusText */
          'bad request': $t('An error occurred with your request. Please try again.'),
          '400': $t('An error occurred with your request. Please try again.'),
        }
      },
      // ValidityState keys
      validationMessages: {
        // 'badInput': '',
        // 'customError': '',
        'patternMismatch': '{{title}}',
        // 'rangeOverflow': '',
        // 'rangeUnderflow': '',
        // 'stepMismatch': '',
        // 'tooLong': '',
        'typeMismatch': $t('Please provide a valid {{label}}.'),
        'valueMissing': $t('{{label}} is required.')
      },
      templateData: { browserLinks: browserLinks },
      state: {
        $t: $t,
        exitCode: 1 // unixy exit code: 0 success, !0 fail; default to fail
      }
    };
  }

  function init(options) {
    destroy();

    var rootElem = renderTemplate(template(html, options), options.templateData, options.targetElem || document.body, options.insertPosition, options.locale),
      browserSupported = isBrowserSupported(options);

    stateHistory = [];
    // component states
    if (isUnsupportedBrowser(options)) classListAdd(rootElem, 'trta1-unsupported-browser');
    else if (isOutdatedBrowser(options)) classListAdd(rootElem, 'trta1-outdated-browser');
    if (options.msieOnly) classListAdd(rootElem, 'trta1-msie-only');
    if (options.disallowIE) classListAdd(rootElem, 'trta1-no-ie');
    if (options.offline) classListAdd(rootElem, 'trta1-offline');
    if (!options.targetElem) classListAdd(rootElem, 'trta1-modal');

    if (options.title) {
      // note: use innerText instead of textContent because this is in the IE8 execution path
      rootElem.querySelector('h1').innerText = options.title;
    }

    if (browserSupported) {
      if (options.type || options.sp) {
        // yucky but necesary for backwards compatibility
        var type = /netfirm|csweb/.test(options.sp) ? options.sp : options.type;
        if (type === 'netfirm') {
          if (options.locale === 'en-CA' || options.locale === 'fr-CA') {
            type += 'dt';
          } else if (options.locale === 'en-UK') {
            type += 'digita';
          }
        }
        rootElem.classList.add('trta1-type-' + type.toLowerCase());
      }

      if (!inputPlaceholderIsSupported()) rootElem.classList.add('trta1-placeholder-unsupported');

      listen('submit', function(evt) {
        var form = evt.target;
        evt.preventDefault();

        form.classList.add('trta1-submitted');

        if (!validateForm(form, options)) {
          focusFirstEnabledField(form, function(field) {
            return !field.validity.valid;
          });
          return;
        }

        // valid, make request
        makeFormRequest(
          form,
          options,
          function(resp) { updateFormState(form, 'success', options, resp); },
          function(resp) { updateFormState(form, 'error', options, resp); },
          function(resp) { trigger((form.id || form.name) + '-' + 'done', resp, form); }
        );
      });

      listen('input propertychange', function(evt) {
        var field = evt.target;
        validateField(field, options);
      });

      listen('click', function(evt) {
        var dest;

        if (rootElem.disabled) {
          evt.preventDefault();
          return;
        }

        dest = evt.target.getAttribute('data-trta1-dest');
        if (!dest) return;
        if (changeForm(dest)) {
          evt.preventDefault();
        }
      });

      // handle outdated browser ignore button click
      listen('click', function() {
        rootElem.classList.remove('trta1-outdated-browser');
      }, rootElem.querySelector('.trta1-outdated-browser-btn'));

    }

    classListAdd(document.documentElement, 'trta1-active');
    if (!options.targetElem) classListAdd(document.documentElement, 'trta1-modal-active');

    return browserSupported;
  }

  function destroy() {
    var rootElem = getRootElem();
    if (!rootElem) return;
    trigger('tr-dialog-before-destroy');
    removeNodes(rootElem);
    document.documentElement.classList.remove('trta1-active');
    document.documentElement.classList.remove('trta1-modal-active');
    stateHistory = [];
  }

  /* Export */
  // NOTE: trid is deprecated
  window.trAuth = window.trid = {
    version: '4.0.4',
    debug: false,
    locales: [],
    getRootElem: getRootElem,
    isBrowserSupported: isBrowserSupported,
    getDefaultOptions: getDefaultOptions,
    getTranslateFn: getTranslateFn,
    trigger: trigger,
    seekObjPath: seekObjPath,
    openPrintWindow: openPrintWindow,
    validateForm: validateForm,
    toggleFormDisable: toggleFormDisable,
    loadScript: loadScript,
    focusFirstEnabledField: focusFirstEnabledField,
    changeForm: changeForm,
    pollFormRequest: pollFormRequest,
    updateFormMsg: updateFormMsg,
    updateFormState: updateFormState,
    getLastFormResp: getLastFormResp,
    getFormStateMsgs: getFormStateMsgs,
    fromString: fromString,
    store: store,
    removeNodes: removeNodes,
    objAssignDeep: objAssignDeep,
    listen: listen,
    unlisten: unlisten,
    template: template,
    classListAdd: classListAdd,
    renderTemplate: renderTemplate,
    parseQueryStr: parseQueryStr,
    getPrimaryError: getPrimaryError,
    getSecondaryError: getSecondaryError,
    moduleReady: moduleReady,
    init: init,
    destroy: destroy,
    modules: {}
  };
})(window);
this.trAuth = this.trAuth || {};
this.trAuth.submodules = (function () {
  'use strict';

  var template = "<form name=\"trta1-mfa-approvecode\" method=\"post\" action=\"<%= authSvcHost %>/api/mfa/v1/requests/_id_/validate\" class=\"trta1-nodisable\" novalidate>\n  <div class=\"trta1-approve-push-only\">\n    <h3 t8>Check your device!</h3>\n    <div class=\"trta1-form-instructions\">\n      <p t8>Approve your request<br> in the Thomson Reuters Authenticator app</p>\n    </div>\n    <fieldset>\n      <p><span t8>Didn&apos;t get a notification? <a href=\"javascript:void(0)\" data-trta1-dest=\"trta1-mfa-choosedevice\">Resend it</a> or </span>\n        <input t8 required pattern=\"\\d{3,4}\\s?\\d{3,4}\" name=\"mfa-manual-code\" tr-nosend placeholder=\"Enter code\" autocomplete=\"off\" maxlength=\"9\"><button t8>Go</button>\n      </p>\n      <p t8>No phone? Contact your firm&apos;s administrator</p>\n    </fieldset>\n  </div>\n  <div class=\"trta1-approve-code-only\">\n    <h3 t8>Enter your authentication code</h3>\n    <div class=\"trta1-form-instructions\">\n      <p t8>Enter the authentication code displayed by your multi-factor device or provided to you.</p>\n      <p t8>You have set up the following multi-factor methods:</p>\n      <ul></ul>\n    </div>\n    <label><span t8>Code</span><br>\n      <input required pattern=\"\\d{3,4}\\s?\\d{3,4}\" name=\"mfa-manual-nonpush-code\" tr-nosend autocomplete=\"off\" maxlength=\"9\">\n    </label>\n    <button t8 class=\"trta1-btn-primary\">Go</button>\n  </div>\n  <div class=\"trta1-btn-group\">\n    <a t8 data-trta1-dest=\"<%= cancelDestForm %>\" href=\"javascript:void(0)\">Cancel Request</a>\n  </div>\n</form>\n";

  function init(rootElem, options, trAuth) {
    var form = rootElem.querySelector('form[name=trta1-mfa-approvecode]');

    trAuth.listen('trta1-mfa-approvecode-enter', function(evt) {
      var factors = trAuth.seekObjPath('formOverrides.trta1-mfa-notifydevice.payload', options).factors;
      var pushCodeInput = form.elements['mfa-manual-code'];
      var nonPushCodeInput = form.elements['mfa-manual-nonpush-code'];
      var factorNamesList = form.querySelector('.trta1-approve-code-only ul');
      var pushFactors = factors.filter(function(factor) {
        return factor.type === 'P'; // P = Push
      });
      var nonPushDeviceFactors = factors.filter(function(factor) {
        // H = Hardware device, A = Auth card, T = Third party TOTP app
        return /^(H|A|T)$/.test(factor.type);
      });
      // if no factors, error. Should only occur if MFA killswitch is on
      if(!pushFactors.length && !nonPushDeviceFactors.length) {
        trAuth.updateFormState(evt.target, 'error', options);
      }

      form.classList.add('trta1-approve-' + (pushFactors.length ? 'push' : 'code'));
      if (pushFactors.length) {
        pushCodeInput.required = true;
        nonPushCodeInput.required = false;
      } else {
        trAuth.removeNodes(factorNamesList.children);
        nonPushDeviceFactors.forEach(function(factor) {
          var li = document.createElement('li');
          li.textContent = factor.name;
          factorNamesList.appendChild(li);
        });

        pushCodeInput.required = false;
        nonPushCodeInput.required = true;
      }
      trAuth.focusFirstEnabledField(form, function(field) {
        return field.required === true;
      });
    }, rootElem);

    trAuth.listen('submit', function(evt) {
      var code = form.elements['mfa-manual-code'].value.replace(/\s/g, '') ||
        form.elements['mfa-manual-nonpush-code'].value.replace(/\s/g, '');
      var approveHdrs = trAuth.seekObjPath('formOverrides.trta1-mfa-approvecode.headers', options, true);
      var mfarId = trAuth.getLastFormResp('trta1-mfa-notifydevice').data.id;

      form.action = form.action.replace(/[^/]+(?=\/validate$)/, mfarId);

      approveHdrs.authorization = 'OTP ' + code;
    }, rootElem.querySelector('form[name=trta1-mfa-approvecode]'));

    trAuth.listen('trta1-mfa-approvecode-error', function(evt) {
      form.reset();
      trAuth.focusFirstEnabledField(form);
    }, rootElem);

    trAuth.listen('trta1-mfa-approvecode-exit', function(evt) {
      form.reset();
    }, rootElem);
  }

  var approveCode = {
    template: template,
    init: init
  };

  var Back = "Back";
  var Cancel = "Cancel";
  var Choose = "Choose";
  var Code = "Code";
  var Copy = "Copy";
  var Done = "Done";
  var Finish = "Finish";
  var Go = "Go";
  var Next = "Next";
  var OK = "OK";
  var Password = "Password";
  var Print = "Print";
  var Reset = "Reset";
  var Retry = "Retry";
  var or = "or";
  var enCA = {
    "A few minutes.": "A few minutes.",
    "Acknowledge and Ignore Warning": "Acknowledge and Ignore Warning",
    "Add an additional level of security in case your password is ever compromised. Confirm your identity using your mobile device.": "Add an additional level of security in case your password is ever compromised. Confirm your identity using your mobile device.",
    "After installing and opening the app, click Next.": "After installing and opening the app, click Next.",
    "An error occurred with your request. Please try again.": "An error occurred with your request. Please try again.",
    "An unexpected error occurred while redirecting your request.": "An unexpected error occurred while redirecting your request.",
    "An unexpected error occurred. Please try again.": "An unexpected error occurred. Please try again.",
    "Approve your request<br> in the Thomson Reuters Authenticator app": "Approve your request<br> in the Thomson Reuters Authenticator app",
    "At least 1 digit (0-9)": "At least 1 digit (0-9)",
    "At least 1 lowercase letter (a-z)": "At least 1 lowercase letter (a-z)",
    "At least 1 symbol (e.g. ! @ # $ % ^ &amp; *)": "At least 1 symbol (e.g. ! @ # $ % ^ &amp; *)",
    "At least 1 uppercase letter (A-Z)": "At least 1 uppercase letter (A-Z)",
    Back: Back,
    "Back To Sign In": "Back To Sign In",
    "CS Professional Suite Security Help": "CS Professional Suite Security Help",
    Cancel: Cancel,
    "Cancel Request": "Cancel Request",
    "Change My Password": "Change My Password",
    "Change my password": "Change my password",
    "Check your device!": "Check your device!",
    Choose: Choose,
    "Choose multi-factor option": "Choose multi-factor option",
    Code: Code,
    "Confirm New Password": "Confirm New Password",
    Copy: Copy,
    "Contact your Onvio administrator": "Contact your Onvio administrator",
    "Deactivated account. Contact your administrator or accountant.": "Deactivated account. Contact your administrator or accountant.",
    "Device ID": "Device ID",
    "Didn't get a notification? <a href=\"javascript:void(0)\" data-trta1-dest=\"trta1-mfa-choosedevice\">Resend it</a> or": "Didn't get a notification? <a href=\"javascript:void(0)\" data-trta1-dest=\"trta1-mfa-choosedevice\">Resend it</a> or",
    "Didn't get a notification? <a href=\"javascript:void(0)\" data-trta1-dest=\"trta1-mfa-choosedevice\">Resend it</a> or <a href=\"javascript:void(0)\" data-trta1-dest=\"trta1-mfa-approvecode\">enter a code</a>": "Didn't get a notification? <a href=\"javascript:void(0)\" data-trta1-dest=\"trta1-mfa-choosedevice\">Resend it</a> or <a href=\"javascript:void(0)\" data-trta1-dest=\"trta1-mfa-approvecode\">enter a code</a>",
    "Do it later": "Do it later",
    "Do you want to change it now?": "Do you want to change it now?",
    Done: Done,
    "Download and install Thomson Reuters Authenticator app": "Download and install Thomson Reuters Authenticator app",
    "Download and install an alternate multi-factor app": "Download and install an alternate multi-factor app",
    "Email Address": "Email Address",
    "Email Address (Thomson Reuters ID)": "Email Address (Thomson Reuters ID)",
    "Emergency Access Codes": "Emergency Access Codes",
    "Emergency codes copied to the clipboard for pasting to a safe place.": "Emergency codes copied to the clipboard for pasting to a safe place.",
    "End of support for Windows 7, Server 2008 / 2008 R2": "End of support for Windows 7, Server 2008 / 2008 R2",
    "Enter code": "Enter code",
    "Enter the 9-character device ID starting with the letters TR from the back of your Thomson Reuters Authenticator card.": "Enter the 9-character device ID starting with the letters TR from the back of your Thomson Reuters Authenticator card.",
    "Enter the authentication code displayed by the Authenticator app.": "Enter the authentication code displayed by the Authenticator app.",
    "Enter the authentication code displayed by your multi-factor device or provided to you.": "Enter the authentication code displayed by your multi-factor device or provided to you.",
    "Enter the code displayed by your alternate multi-factor app.": "Enter the code displayed by your alternate multi-factor app.",
    "Enter the one-time code displayed on your multi-factor device.": "Enter the one-time code displayed on your multi-factor device.",
    "Enter your authentication code": "Enter your authentication code",
    "Error copying emergency codes to the clipboard.": "Error copying emergency codes to the clipboard.",
    "Finding your paired device.": "Finding your paired device.",
    Finish: Finish,
    "For your firm to access this software, one of your firm's administrators needs to upgrade your accounts at <a target=\"_blank\" rel=\"noopener\" href=\"<%= cswebHost %>/myaccount\">cs.thomsonreuters.com/myaccount</a>.": "For your firm to access this software, one of your firm's administrators needs to upgrade your accounts at <a target=\"_blank\" rel=\"noopener\" href=\"<%= cswebHost %>/myaccount\">cs.thomsonreuters.com/myaccount</a>.",
    "Generating QR code.": "Generating QR code.",
    "Generating emergency codes.": "Generating emergency codes.",
    "Get Started": "Get Started",
    "Let's get started": "Let's get started",
    Go: Go,
    "Go To Sign In": "Go To Sign In",
    "Hide typing": "Hide typing",
    "How long will it take to set up?": "How long will it take to set up?",
    "How will this affect me?": "How will this affect me?",
    "If you lose access to your mobile device, you can use one of these emergency codes to sign in to your account. Each code may be used only once.": "If you lose access to your mobile device, you can use one of these emergency codes to sign in to your account. Each code may be used only once.",
    "Ignore warning": "Ignore warning",
    "Incorrect Device ID or Code. Please try again.": "Incorrect Device ID or Code. Please try again.",
    "Incorrect Email Address or Password. Please try again.": "Incorrect Email Address or Password. Please try again.",
    "Incorrect Login or Password. Please try again.": "Incorrect Login or Password. Please try again.",
    "Increase security for your account": "Increase security for your account",
    "Instructions for resetting your password have been sent to your registered email address.": "Instructions for resetting your password have been sent to your registered email address.",
    "Internet Access Required": "Internet Access Required",
    "Invalid code. Please try again.": "Invalid code. Please try again.",
    "Invalid value entered.": "Invalid value entered.",
    "Leading or trailing spaces": "Leading or trailing spaces",
    "Learn More About New Security Measures": "Learn More About New Security Measures",
    "Learn more about Emergency Access Codes": "Learn more about Emergency Access Codes",
    "Learn more about multi-factor authentication.": "Learn more about multi-factor authentication.",
    "Learn more about multi-factor devices": "Learn more about multi-factor devices",
    "Learn more about these new security measures.": "Learn more about these new security measures.",
    "Learn more about third-party MFA apps": "Learn more about third-party MFA apps",
    "Learn which MFA option is right for you": "Learn which MFA option is right for you",
    "Make your account even more secure!": "Make your account even more secure!",
    "Manage Account": "Manage Account",
    "Microsoft Window Server 2008 / 2008 R2 Announcement": "Microsoft Window Server 2008 / 2008 R2 Announcement",
    "Microsoft Windows 7 Announcement": "Microsoft Windows 7 Announcement",
    "Missing data required to reset password. Please try again.": "Missing data required to reset password. Please try again.",
    "Missing data required to unlock account. Please try again.": "Missing data required to unlock account. Please try again.",
    "Missing firmId parameter.": "Missing firmId parameter.",
    "Multi-Factor Authentication Setup": "Multi-Factor Authentication Setup",
    "Multi-factor authentication required": "Multi-factor authentication required",
    "Multifactor authentication is currently unavailable.": "Multifactor authentication is currently unavailable.",
    "My Multi-Factor App": "My Multi-Factor App",
    "Name this multi-factor option": "Name this multi-factor option",
    "Need an account? Contact your administrator.": "Need an account? Contact your administrator.",
    "Need an account? Create one now.": "Need an account? Create one now.",
    "New Password": "New Password",
    Next: Next,
    "Next steps after setting up MFA": "Next steps after setting up MFA",
    "No phone? Contact your firm's administrator": "No phone? Contact your firm's administrator",
    "Notifying your paired device.": "Notifying your paired device.",
    OK: OK,
    "ONVIO Sign In Security Help": "ONVIO Sign In Security Help",
    "On your mobile device, open the app store and download and install the <b>Thomson Reuters Authenticator</b> app.": "On your mobile device, open the app store and download and install the <b>Thomson Reuters Authenticator</b> app.",
    "Open the <b>Thomson Reuters Authenticator</b> app on your mobile device and point your device's camera at your monitor to scan the code below.": "Open the <b>Thomson Reuters Authenticator</b> app on your mobile device and point your device's camera at your monitor to scan the code below.",
    "Outdated Operating System Detected": "Outdated Operating System Detected",
    "Pairing Successful!": "Pairing Successful!",
    Password: Password,
    "Password contains prohibited characters": "Password contains prohibited characters",
    "Password is too similar to a common or blacklisted password.": "Password is too similar to a common or blacklisted password.",
    "Password must be a minimum of 8 characters and contain at least one uppercase letter, one lowercase letter, one digit, and one symbol, with no leading or trailing spaces.": "Password must be a minimum of 8 characters and contain at least one uppercase letter, one lowercase letter, one digit, and one symbol, with no leading or trailing spaces.",
    "Passwords Don't Match": "Passwords Don't Match",
    "Passwords can be hacked, but using multi-factor authentication adds another layer of security to your account.": "Passwords can be hacked, but using multi-factor authentication adds another layer of security to your account.",
    "Please change your password.": "Please change your password.",
    "Please choose a password you have not already used.": "Please choose a password you have not already used.",
    "Please complete the required fields.": "Please complete the required fields.",
    "Please create a new password that meets <a id=\"trta1-toggle-pwd-requirements\" href=\"javascript:void(0)\">requirements</a>.": "Please create a new password that meets <a id=\"trta1-toggle-pwd-requirements\" href=\"javascript:void(0)\">requirements</a>.",
    "Please enter your email address.": "Please enter your email address.",
    "Please enter your login and email address.": "Please enter your login and email address.",
    "Please provide a valid password.": "Please provide a valid password.",
    "Please provide a valid {{label}}.": "Please provide a valid {{label}}.",
    "Please wait while we sign you into your account…": "Please wait while we sign you into your account…",
    "Please wait.": "Please wait.",
    "Please wait…": "Please wait…",
    Print: Print,
    "Receive notifications on your mobile device and sign in with a single touch.": "Receive notifications on your mobile device and sign in with a single touch.",
    "Registering your device.": "Registering your device.",
    "Remind Me Later": "Remind Me Later",
    Reset: Reset,
    "Reset My Password": "Reset My Password",
    "Reset Password": "Reset Password",
    "Retrieving authentication token.": "Retrieving authentication token.",
    "Retrieving device info.": "Retrieving device info.",
    Retry: Retry,
    "Save Emergency Access Codes": "Save Emergency Access Codes",
    "Save or print these codes to a secure location for use when your primary MFA device is unavailable (e.g., if you get a new phone). You can use each code only once, but you can generate more codes in your account profile": "Save or print these codes to a secure location for use when your primary MFA device is unavailable (e.g., if you get a new phone). You can use each code only once, but you can generate more codes in your account profile",
    "Scan Code": "Scan Code",
    "Sequential letters or numbers such as \"abc\" or \"123\"": "Sequential letters or numbers such as \"abc\" or \"123\"",
    "Set Up Now": "Set Up Now",
    "Show typing": "Show typing",
    "Sign back in": "Sign back in",
    "Sign In": "Sign In",
    "Sign in with your NetStaff CS account": "Sign in with your NetStaff CS account",
    "Sign in with your Thomson Reuters ID": "Sign in with your Thomson Reuters ID",
    "Sorry, there was an issue on our end. Please try again.": "Sorry, there was an issue on our end. Please try again.",
    "Your registration link has expired. Please contact the firm for a new one.": "Your registration link has expired. Please contact the firm for a new one.",
    "Step 1": "Step 1",
    "Step 2": "Step 2",
    "Success!": "Success!",
    "System Status": "System Status",
    "Tell me how": "Tell me how",
    "Continue to sign in page": "Continue to sign in page",
    "Sign in": "Sign in",
    "The alternate method must be time-based one time password (TOTP) compliant. Download now at the <a target=\"_blank\" rel=\"noopener\" href=\"https://itunes.apple.com/<%= appleStoreCountryCode %>/app/thomson-reuters-authenticator/id1155604687?mt=8&amp;l=<%= appleStoreLangCode %>\">Apple App Store</a> or the <a target=\"_blank\" rel=\"noopener\" href=\"https://play.google.com/store/apps/details?id=com.thomsonreuters.trta.authenticator&amp;pcampaignid=MKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1&amp;hl=<%= googleStoreLangCode %>\">Google Play Store</a>.": "The alternate method must be time-based one time password (TOTP) compliant. Download now at the <a target=\"_blank\" rel=\"noopener\" href=\"https://itunes.apple.com/<%= appleStoreCountryCode %>/app/thomson-reuters-authenticator/id1155604687?mt=8&amp;l=<%= appleStoreLangCode %>\">Apple App Store</a> or the <a target=\"_blank\" rel=\"noopener\" href=\"https://play.google.com/store/apps/details?id=com.thomsonreuters.trta.authenticator&amp;pcampaignid=MKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1&amp;hl=<%= googleStoreLangCode %>\">Google Play Store</a>.",
    "The firm requires you to enable multi-factor authentication before signing in. Please complete the multi-factor authentication setup wizard to continue.": "The firm requires you to enable multi-factor authentication before signing in. Please complete the multi-factor authentication setup wizard to continue.",
    "The server did not respond in time. Please try again.": "The server did not respond in time. Please try again.",
    "There was an error sending the email. Please try again.": "There was an error sending the email. Please try again.",
    "These codes are like the key to your office - keep them in a safe place only you can access!": "These codes are like the key to your office - keep them in a safe place only you can access!",
    "This option requires you to enter a code each time you sign in.": "This option requires you to enter a code each time you sign in.",
    "Thomson Reuters": "Thomson Reuters",
    "Thomson Reuters Authenticator": "Thomson Reuters Authenticator",
    "Thomson Reuters Authenticator Card": "Thomson Reuters Authenticator Card",
    "Thomson Reuters will no longer support its products on Windows 7 operating systems or Windows Server 2008 or 2008 R2 beginning January 14, 2020. We strongly urge you to upgrade any workstations or servers that require access to Thomson Reuters products to a supported operating system prior to January 14, 2020. Please find more information at the links below:": "Thomson Reuters will no longer support its products on Windows 7 operating systems or Windows Server 2008 or 2008 R2 beginning January 14, 2020. We strongly urge you to upgrade any workstations or servers that require access to Thomson Reuters products to a supported operating system prior to January 14, 2020. Please find more information at the links below:",
    "Timed out waiting for device approval. Resend notification or enter code.": "Timed out waiting for device approval. Resend notification or enter code.",
    "Timed out waiting for scan. Please go back and try again.": "Timed out waiting for scan. Please go back and try again.",
    "To help protect the confidential data belonging to your firm and your clients and to comply with new IRS requirements, Thomson Reuters is adding usernames and passwords to access our Tax &amp; Accounting products.": "To help protect the confidential data belonging to your firm and your clients and to comply with new IRS requirements, Thomson Reuters is adding usernames and passwords to access our Tax &amp; Accounting products.",
    "To log in to Onvio, please use one of the supported internet browsers below.": "To log in to Onvio, please use one of the supported internet browsers below.",
    "To sign in, please connect this computer to the internet then restart the application.": "To sign in, please connect this computer to the internet then restart the application.",
    "Too many sign in attempts. Please check for unlock email or try later.": "Too many sign in attempts. Please check for unlock email or try later.",
    "Unlocking your account.": "Unlocking your account.",
    "Use Thomson Reuters Authenticator (recommended)": "Use Thomson Reuters Authenticator (recommended)",
    "Use a multi-factor device": "Use a multi-factor device",
    "Use a multi-factor device like a card that displays a code to enter.": "Use a multi-factor device like a card that displays a code to enter.",
    "Use a third-party multi-factor app": "Use a third-party multi-factor app",
    "Use your alternate multi-factor app to scan the code below.": "Use your alternate multi-factor app to scan the code below.",
    "Validate your alternate multi-factor app": "Validate your alternate multi-factor app",
    "Validate your multi-factor device": "Validate your multi-factor device",
    "Words from the dictionary": "Words from the dictionary",
    "You can generate more codes by signing in and accessing your profile.": "You can generate more codes by signing in and accessing your profile.",
    "You can use Thomson Reuters Authenticator (recommended), or a different multi-factor app.": "You can use Thomson Reuters Authenticator (recommended), or a different multi-factor app.",
    "You have set up multi-factor authentication for your account. You will need to approve each sign-in request on your device each time you sign in with this account.": "You have set up multi-factor authentication for your account. You will need to approve each sign-in request on your device each time you sign in with this account.",
    "You have set up the following multi-factor methods:": "You have set up the following multi-factor methods:",
    "You will need to approve each sign-in request on your device each time you sign in with this account.": "You will need to approve each sign-in request on your device each time you sign in with this account.",
    "You're signed out": "You're signed out",
    "You've been authenticated.": "You've been authenticated.",
    "You've been signed out due to inactivity. Sign in to resume.": "You've been signed out due to inactivity. Sign in to resume.",
    "You've exceeded maximum usage time. Please sign in again.": "You've exceeded maximum usage time. Please sign in again.",
    "You've successfully changed your password.": "You've successfully changed your password.",
    "Your Browser is not supported": "Your Browser is not supported",
    "Your Thomson Reuters ID is the email address you use to sign in to your Onvio and/or CS Web (cs.thomsonreuters.com) accounts.": "Your Thomson Reuters ID is the email address you use to sign in to your Onvio and/or CS Web (cs.thomsonreuters.com) accounts.",
    "Your account has been unlocked.": "Your account has been unlocked.",
    "Your account is locked. Please contact your administrator.": "Your account is locked. Please contact your administrator.",
    "Your firm's license is inactive": "Your firm's license is inactive",
    "Your password <strong>must</strong> have <span>at least 8 characters</span> including all of the following:": "Your password <strong>must</strong> have <span>at least 8 characters</span> including all of the following:",
    "Your password has expired. Please create a new one that meets <a id=\"trta1-toggle-expired-pwd-requirements\" href=\"javascript:void(0)\">requirements</a>.": "Your password has expired. Please create a new one that meets <a id=\"trta1-toggle-expired-pwd-requirements\" href=\"javascript:void(0)\">requirements</a>.",
    "Your password needs to be updated. Please <a target=\"_blank\" rel=\"noopener\" href=\"<%= netfirmWebHost %>\">log in</a> and change your password.": "Your password needs to be updated. Please <a target=\"_blank\" rel=\"noopener\" href=\"<%= netfirmWebHost %>\">log in</a> and change your password.",
    "Your password should <strong>not</strong> use:": "Your password should <strong>not</strong> use:",
    "Your password will expire <em>today</em>.": "Your password will expire <em>today</em>.",
    "Your password will expire in <em id=\"trta1-pwdexpdays\">2</em> days.": "Your password will expire in <em id=\"trta1-pwdexpdays\">2</em> days.",
    "Your password will expire in <em>1</em> day.": "Your password will expire in <em>1</em> day.",
    "Your password will expire soon": "Your password will expire soon",
    "Your session is ending soon": "Your session is ending soon",
    "Your session will end in:": "Your session will end in:",
    "Your user ID": "Your user ID",
    "You don't have access": "You don't have access",
    or: or,
    "{{label}} is required.": "{{label}} is required.",
    "Sign-in Help": "Sign-in Help",
    "View system status": "View system status",
    "Your firm's license is no longer active. Please contact your administrator.": "Your firm's license is no longer active. Please contact your administrator.",
    "Please enter a valid password. Your password cannot contain personal information associated with your account.": "Please enter a valid password. Your password cannot contain personal information associated with your account.",
    "Refer to <a class=\"trta1-howAndHelp-link\" target=\"_blank\" rel=\"noopener\" href=\"https://cs.thomsonreuters.com/ua/login_security/cs_us_en/mfa-troubleshooting.htm\"> Help & How To Center </a> for possible solutions": "Refer to <a class=\"trta1-howAndHelp-link\" target=\"_blank\" rel=\"noopener\" href=\"https://cs.thomsonreuters.com/ua/login_security/cs_us_en/mfa-troubleshooting.htm\"> Help & How To Centre </a> for possible solutions",
    "Contact your Onvio administrator.": "Contact your Onvio administrator.",
    "Contact your administrator.": "Contact your administrator.",
    "Onvio requires two-step verification. You only have to configure this once, and it won't take long.": "Onvio requires two-step verification. You only have to configure this once, and it won't take long.",
    "Please close this window and try again.": "Please close this window and try again.",
    "Read about account security": "Read about account security",
    "Secure your account": "Secure your account",
    "Set up two-step verification": "Set up two-step verification",
    "https://onvio.us/ua/help/us-en/staff/core/setup/thomson-reuters-account.htm": "https://onvio.us/ua/help/us-en/staff/core/setup/thomson-reuters-account.htm",
    "You don't have access to this product": "You do not have access to this product",
    "Select the module you wish to access and try again": "Select the product you wish to access and try again:",
    "Client Center": "Client Centre",
    "Employee Portal": "Employee Portal"
  };

  var Password$1 = "Contraseña";
  var Back$1 = "Atrás";
  var OK$1 = "Aceptar";
  var Reset$1 = "Restablecer";
  var Retry$1 = "Volver a intentarlo";
  var Cancel$1 = "Cancelar";
  var Next$1 = "Siguiente";
  var Go$1 = "Continuar";
  var Close = "Cerrar";
  var Done$1 = "Listo";
  var Choose$1 = "Elegir";
  var Code$1 = "Código";
  var Finish$1 = "Finalizar";
  var Copy$1 = "Copia";
  var Print$1 = "Imprimir";
  var or$1 = "o";
  var Download = "Descargar";
  var esAR = {
    "Email Address (Thomson Reuters ID)": "Correo Electrónico (Thomson Reuters ID)",
    "Sign in with your Thomson Reuters ID": "Inicie sesion con su Thomson Reuters ID",
    "Your Thomson Reuters ID is the email address you use to sign in to your Onvio and/or CS Web (cs.thomsonreuters.com) accounts.": "Su Thomson Reuters ID es el correo electrónico para ingresar a Onvio y/o a su cuenta de CS Web (cs.thomsonreuters.com).",
    "Sign in with your NetStaff CS account": "Inicie sesion con su NetStaff CS cuenta",
    Password: Password$1,
    "Reset Password": "Restablecer Contraseña",
    "Manage Account": "Administrar Cuenta",
    "CS Professional Suite Security Help": "Ayuda con la seguridad de CS Professional Suite",
    "Need an account? Contact your administrator": "¿Necesita una cuenta? Comuníquese con el administrador",
    "ONVIO Sign In Security Help": "Ayuda con la seguridad del inicio de sesión en ONVIO",
    "Need an account? Please create a new account": "¿Necesita una cuenta? Cree una cuenta nueva",
    "Internet Access Required": "Se requiere acceso a Internet",
    "To help protect the confidential data belonging to your firm and your clients and to comply with new IRS requirements, Thomson Reuters is adding usernames and passwords to access our Tax &amp; Accounting products.": "A fin de ayudar a proteger la información confidencial de su estudio contable y sus clientes, y de cumplir con los nuevos requisitos del IRS, Thomson Reuters agrega nombres de usuario y contraseñas al acceso a nuestros productos contables y tributarios.",
    "To sign in, please connect this computer to the internet then restart the application.": "Para iniciar sesión, conecte esta computadora a Internet y después vuelva a iniciar la aplicación.",
    "Learn more about these new security measures.": "Obtener más información sobre estas nuevas medidas de seguridad.",
    "For your firm to access this software, one of your firm's administrators needs to upgrade your accounts at <a href=\"<%= cswebHost %>/myaccount\" target=\"_blank\">cs.thomsonreuters.com/myaccount</a>.": "Para que su estudio contable pueda obtener acceso a este software, uno de los administradores del estudio contable debe actualizar sus cuentas en <a href=\"<%= cswebHost %>/myaccount\" target=\"_blank\">cs.thomsonreuters.com/myaccount</a>.",
    "Learn More About New Security Measures": "Obtener más información sobre las nuevas medidas de seguridad",
    "Please enter your email address.": "Ingrese su dirección de correo electrónico.",
    "Please enter your login and email address.": "Ingrese su información de inicio de sesión y su dirección de correo electrónico.",
    Back: Back$1,
    "Reset My Password": "Restablecer mi contraseña",
    "Continue to sign in page": "Continuar a la página de inicio de sesión",
    "https://onvio.us/ua/help/us-en/staff/core/setup/thomson-reuters-account.htm": "https://onvio.us/ua/help/us-en/staff/core/setup/thomson-reuters-account.htm",
    "Instructions for resetting your password have been sent to your registered email address.": "Se le han enviado instrucciones para restablecer su contraseña a la dirección de correo electrónico registrada.",
    "Go To Sign In": "Ir al inicio de sesión",
    "Please create a new password that meets <a id=\"trta1-toggle-pwd-requirements\" href=\"javascript:void(0)\">requirements</a>.": "Por favor, cree una nueva contraseña que cumpla <a id=\"trta1-toggle-pwd-requirements\" href=\"javascript:void(0)\">los requisitos</a>.",
    "Your password has expired. Please create a new one that meets <a id=\"trta1-toggle-expired-pwd-requirements\" href=\"javascript:void(0)\">requirements</a>.": "Su contraseña ha expirado. Por favor, cree una nueva que cumpla <a id=\"trta1-toggle-expired-pwd-requirements\" href=\"javascript:void(0)\">los requisitos</a>.",
    "Your password <strong>must</strong> have <span>at least 8 characters</span> including all of the following:": "Su contraseña <strong>debe</strong> tener <span>al menos 8 caracteres</span>, incluyendo todo lo siguiente:",
    "At least 1 uppercase letter (A-Z)": "Al menos 1 letra mayúscula (A-Z)",
    "At least 1 lowercase letter (a-z)": "Al menos 1 letra minúscula (a-z)",
    "At least 1 digit (0-9)": "Al menos 1 dígito (0-9)",
    "At least 1 symbol (e.g. ! @ # $ % ^ &amp; *)": "Al menos 1 símbolo (e.g. ! @ # $ % ^ &amp; *)",
    "Your password should <strong>not</strong> use:": "Su contraseña <strong>no debe </strong> contener:",
    "Leading or trailing spaces": "Espacios al inicio o al final",
    "Words from the dictionary": "Palabras incluidas en el diccionario",
    "Your user ID": "Su código de usuario",
    "Sequential letters or numbers such as \"abc\" or \"123\"": "Letras o números consecutivos, tales como \"abc\" or \"123\"",
    "Show typing": "Mostrar Caracteres",
    "Hide typing": "Ocultar Caracteres",
    "New Password": "Contraseña Nueva",
    "Confirm New Password": "Confirmar Contraseña Nueva",
    "Change My Password": "Cambiar mi Contraseña",
    "You've successfully changed your password.": "Cambió correctamente su contraseña.",
    OK: OK$1,
    "Your password needs to be updated. Please <a href=\"<%= netfirmWebHost %>\" target=\"_blank\"> log in</a> and change your password.": "Su contraseña necesita ser actualizada. Por favor, <a href=\"<%= netfirmWebHost %>\" target=\"_blank\">inicie sesión</a> y cambie su contraseña.",
    "Back To Sign In": "Volver a Inicio de sesión",
    "Unlocking your account.": "Desbloqueo de la cuenta.",
    "Your password will expire soon": "Su contraseña caduca pronto",
    "Your password will expire in <em id=\"trta1-pwdexpdays\">2</em> days.": "Su contraseña caducará en <em id=\"trta1-pwdexpdays\">2</em> días.",
    "Your password will expire in <em>1</em> day.": "Su contraseña caduca dentro de <em>1</em> día.",
    "Your password will expire <em>today</em>.": "Su contraseña caduca <em>hoy</em>.",
    "Do you want to change it now?": "¿Desea cambiarla ahora?",
    "Change my password": "Cambiar mi contraseña",
    "Do it later": "Más tarde",
    "Your session is ending soon": "Su sesión finaliza pronto",
    "Your session will end in:": "Your session will end in:",
    Reset: Reset$1,
    "Multi-factor authentication required": "La autenticación de múltiples factores es obligatoria",
    "The firm requires you to enable multi-factor authentication before signing in. Please complete the multi-factor authentication setup wizard to continue.": "El estudio requiere que se habilite la autenticación de múltiples factores antes de iniciar sesión. Por favor complete el asistente de configuración de autenticación de múltiples factores para continuar.",
    "Set Up Now": "Configurar Ahora",
    "Finding your paired device.": "Buscando el dispositivo sincronizado.",
    Retry: Retry$1,
    "Notifying your paired device.": "Notificando al dispositivo sincronizado.",
    "Check your device!": "Revise su dispositivo.",
    "Approve your request<br> in the Thomson Reuters Authenticator app": "Aprobar su solicitud<br> en la aplicación Thomson Reuters Authenticator",
    "Didn't get a notification? <a href=\"javascript:void(0)\" data-trta1-dest=\"trta1-mfa-choosedevice\">Resend it</a> or <a href=\"javascript:void(0)\" data-trta1-dest=\"trta1-mfa-approvecode\">enter a code</a>": "¿No recibió una notificación? <a href=\"javascript:void(0)\" data-trta1-dest=\"trta1-mfa-choosedevice\">Reenvíe la notificación</a> o <a href=\"javascript:void(0)\" data-trta1-dest=\"trta1-mfa-approvecode\">introduzca un código</a>",
    "No phone? Contact your firm's administrator": "¿No tiene teléfono? Comuníquese con el administrador de su estudio contable",
    "Cancel Request": "Cancelar solicitud",
    "Didn't get a notification? <a href=\"javascript:void(0)\" data-trta1-dest=\"trta1-mfa-choosedevice\">Resend it</a> or": "¿No recibió una notificación? <a href=\"javascript:void(0)\" data-trta1-dest=\"trta1-mfa-choosedevice\">Reenvíe la notificación</a> o",
    "Enter code": "Ingresar código",
    "Retrieving authentication token.": "Recuperando token de autenticación.",
    "You've been authenticated.": "Ya está autenticado.",
    "Please wait while we sign you into your account…": "Espere mientras se inicia la sesión en su cuenta...",
    "Multifactor authentication is currently unavailable.": "La autenticación de múltiples factores no está disponible en este momento.",
    "Thomson Reuters": "Thomson Reuters",
    "You are using an <strong>outdated</strong> browser. Please upgrade your browser to improve security.": "Está utilizando un navegador <strong>obsoleto</strong>. Actualice su navegador para mejorar la seguridad.",
    "Multi-factor Authentication Setup": "Configuración de autenticación de múltiples factores",
    "<strong>Increase security for your account</strong> Passwords can be hacked, but using multi-factor authentication adds another layer of security to your account.": "<strong>Mejore la seguridad de su cuenta</strong> Las contraseñas pueden ser descifradas por hackers, pero la autenticación de múltiples factores le suma otra capa de seguridad a su cuenta.",
    "<strong>How long will it take to set up?</strong> Minutes.": "<strong>¿Cuánto tiempo demora la configuración?</strong> Unos minutos.",
    "<strong>How will this affect me?</strong> You will need to approve each sign in request on your smartphone once a day and after each time you log out.": "<strong>¿En qué me afectará esto?</strong> Tendrá que aprobar cada solicitud de inicio de sesión con su teléfono inteligente una vez al día y cada vez que cierre sesión.",
    Cancel: Cancel$1,
    "Get Started": "Empezar",
    "Install the Thomson Reuters Authenticator app on your smartphone or tablet.": "Instale la aplicación Thomson Reuters Authenticator en su teléfono inteligente o tablet.",
    "Download on the Apple App Store": "Descarguela de la App Store de Apple",
    "Get it on Google Play": "Consígala en Google Play",
    Next: Next$1,
    "Generating QR code.": "Generando código QR.",
    "Open the Thomson Reuters Authenticator app and scan the QR code below.": "Abra la aplicación Thomson Reuters Authenticator y escanee el código QR de abajo.",
    "Retrieving device info.": "Recuperando información del dispositivo.",
    "You have paired your account with <strong id=\"trta1-mfs-devicename\">this device</strong>. You will need to approve each sign in request on this device once a day and after each time you log out.": "Sincronizó su cuenta con <strong id=\"trta1-mfs-devicename\">este dispositivo</strong>. Deberá aprobar cada solicitud de registro en este dispositivo una vez al día y después de cada vez que cierre la sesión.",
    "Got It": "Entendido",
    "Please wait…": "Espere...",
    "Enter your authentication code": "Ingrese el código de autenticación",
    "Invalid code. Please enter a valid authentication code.": "Código no válido  Ingrese un código de autenticación válido.",
    "Enter the code provided by your adminstrator": "Ingrese el código que le dio su administrador",
    "Set up your mobile device": "Configure su dispositivo móvil",
    "Password must be a minimum of 8 characters and contain at least one uppercase letter, one lowercase letter, one digit, and one symbol, with no leading or trailing spaces.": "La contraseña debe tener un mínimo de 8 caracteres y contener al menos una letra mayúscula, una letra minúscula, un número y un símbolo, sin espacios iniciales o finales.",
    "Incorrect Email Address or Password. Please try again.": "Dirección de correo electrónico o contraseña incorrectos. Vuelva a intentarlo.",
    "Too many sign in attempts. Please check for unlock email or try later.": "Demasiados intentos de inicio de sesión. Verifique si su correo electrónico se encuentra bloqueado o intente nuevamente más tarde.",
    "Please change your password.": "Por favor, cambie su contraseña.",
    "Please complete the required fields.": "Por favor complete los campos requeridos.",
    "Deactivated account. Contact your administrator or accountant.": "Cuenta desactivada. Póngase en contacto con su administrador o contador.",
    "There was an error sending the email. Please try again.": "Se ha producido un error al enviar el correo electrónico. Vuelva a intentarlo. ",
    "Please choose a password you have not already used.": "Elija una contraseña que no haya utilizado con anterioridad.",
    "Your account has been unlocked.": "Su cuenta se ha desbloqueado.",
    "You've been signed out due to inactivity. Sign in to resume.": "Ha sido desconectado debido a su inactividad. Inicie sesión para reanudar.",
    "You've exceeded maximum usage time. Please sign in again.": "Ha excedido el tiempo máximo de uso. Inicie sesión nuevamente.",
    "Incorrect Login or Password. Please try again.": "Usuario o contraseña incorrectos. Vuelva a intentarlo.",
    "Missing data required to reset password. Please try again.": "Faltan los datos necesarios para restablecer la contraseña. Vuelva a intentarlo.",
    "Missing data required to unlock account. Please try again.": "Faltan los datos necesarios para desbloquear su cuenta. Vuelva a intentarlo.",
    "Timed out waiting for device approval. Resend notification or enter code.": "Tiempo de espera agotado para la aprobación del dispositivo. Reenvíe la notificación o introduzca un código.",
    "Invalid code. Please try again.": " Código inválido. Vuelva a intentarlo.",
    "Passwords Don't Match": "Las contraseñas no coinciden",
    "Please wait.": "Por favor espere.",
    "Success!": "¡Correcto!",
    "An unexpected error occurred. Please try again.": "Se ha producido un error inesperado. Vuelva a intentarlo.",
    "An unexpected error occurred while redirecting your request.": "Se ha producido un error inesperado al redireccionar la solicitud.",
    "The server did not respond in time. Please try again.": "El servidor no respondió a tiempo. Vuelva a intentarlo.",
    "An error occurred with your request. Please try again.": "Se ha producido un error en su solicitud. Vuelva a intentarlo.",
    "Please provide a valid {{label}}.": "Proporcione un {{label}} válido.",
    "{{label}} is required.": "{{label}} es requerido.",
    "Timed out waiting for scan. Please go back and try again.": "Tiempo de espera agotado. Por favor, regrese y vuelva a intentarlo.",
    "Your account is locked. Please contact your administrator.": "Su cuenta se encuentra bloqueada. Póngase en contacto con el administrador.",
    Go: Go$1,
    "Sorry, there was an issue on our end. Please try again.": "Hemos tenido un problema. Por favor, inténtelo de nuevo.",
    "Your registration link has expired. Please contact the firm for a new one.": "Su enlace de registro ha caducado. Contáctese con el Estudio Contable para obtener uno nuevo.",
    "Make your account even more secure!": "¡Haga que su cuenta sea aún más segura!",
    "Add an additional level of security in case your password is ever compromised. Confirm your identity using your mobile device.": "Agregue un nivel adicional de seguridad en caso de que su contraseña se encuentre en peligro. Confirme su identidad mediante su dispositivo móvil.",
    "Learn more about multi-factor authentication.": "Más información acerca de la autenticación de múltiples factores.",
    "Remind Me Later": "Recordarme Más Tarde",
    Close: Close,
    Done: Done$1,
    "Update Password": "Actualizar Contraseña",
    "Please enter your email address to update your password.": "Por favor, ingrese su dirección de correo electrónico para actualizar su contraseña.",
    "Sign In": "Iniciar sesión",
    "Please provide a valid password.": "Proporcione una contraseña válida.",
    "Password contains prohibited characters.": "La constraseña posee caracteres no válidos.",
    "Password is too similar to a common or blacklisted password.": "Esta contraseña es similar a una contraseña muy común o en la lista de no permitidas.",
    "Ignore warning": "Ignorar esta advertencia",
    "Your browser is not supported for use with this application. Please try again using the latest version of one of the following browsers.": "Su navegador no es compatible para su uso con esta aplicación. Por favor intente de nuevo usando la última versión de uno de los siguientes navegadores.",
    "Using a browser that’s no longer supported by the vendor is a security risk. Click one of the links below to upgrade to a current browser.": "Usar un navegador que ya no es compatible con el proveedor es un riesgo de seguridad. Haga clic en uno de los enlaces a continuación para actualizar a un navegador actual.",
    "Your Browser is Outdated": "Su navegador no está actualizado",
    "A few minutes.": "Unos pocos minutos.",
    "After installing and opening the app, click Next.": "Después de instalar y abrir la aplicación, haga clic en Siguiente.",
    Choose: Choose$1,
    "Choose multi-factor option": "Elija la opción multifactor",
    Code: Code$1,
    "Download and install Thomson Reuters Authenticator app": "Descargue e instale la aplicación Thomson Reuters Authenticator",
    "Download and install an alternate multi-factor app": "Descargue e instale una aplicación alternativa de múltiples factores",
    "Enter the authentication code displayed by the Authenticator app.": "Ingrese el código de autenticación que muestra la aplicación Authenticator.",
    "Enter the code displayed by your alternate multi-factor app.": "Ingrese el código que muestra su aplicación de múltiples factores.",
    Finish: Finish$1,
    "For your firm to access this software, one of your firm's administrators needs to upgrade your accounts at <a target=\"_blank\" rel=\"noopener\" href=\"<%= cswebHost %>/myaccount\">cs.thomsonreuters.com/myaccount</a>.": "Para que su estudio contable acceda a este software, uno de los administradores de su estudio debe actualizar sus cuentas en <a target=\"_blank\" rel=\"noopener\" href=\"<%= cswebHost %>/myaccount\">cs.thomsonreuters.com/myaccount</a>.",
    "How long will it take to set up?": "¿Cuánto tiempo demora la configuración?",
    "How will this affect me?": "¿En qué me afectará esto?",
    "Increase security for your account": "Aumente la seguridad de su cuenta",
    "Invalid value entered.": "Valor inválido ingresado.",
    "Learn more about third-party MFA apps": "Obtenga más información acerca de las aplicaciones de autenticación de múltiples factores de terceros",
    "Learn which MFA option is right for you": "Conozca la opción de autenticación de múltiples factores adecuada para usted",
    "My Multi-Factor App": "Mi aplicación de múltiples factores",
    "Name this multi-factor option": "Nombre esta opción de múltiples factores",
    "Need an account? Contact your administrator.": "¿Necesita una cuenta? Comuníquese con el administrador",
    "Need an account? Create one now.": "¿Necesita una cuenta? Cree una ahora",
    "Next steps after setting up MFA": "Próximos pasos después de configurar la autenticación de múltiples factores",
    "On your mobile device, open the app store and download and install the <b>Thomson Reuters Authenticator</b> app.": "En su dispositivo móvil, abra la tienda de aplicaciones y descargue e instale la aplicación <b>Thomson Reuters Authenticator</b>.",
    "Open the <b>Thomson Reuters Authenticator app</b> on your mobile device and point your device's camera at your monitor to scan the code below.": "Abra la <b>aplicación Thomson Reuters Authenticator</b> en su dispositivo móvil y apunte la cámara de su dispositivo hacia su monitor para escanear el código siguiente.",
    "Pairing Successful!": "¡Sincronización exitosa!",
    "Passwords can be hacked, but using multi-factor authentication adds another layer of security to your account.": "Mejore la seguridad de su cuenta. Las contraseñas pueden ser descifradas por hackers, pero la autenticación de múltiples factores le suma otra capa de seguridad a su cuenta.",
    "Receive notifications on your mobile device and sign in with a single touch.": "Reciba notificaciones en su dispositivo móvil e inicie sesión con un solo toque.",
    "Registering your device.": "Registrando su dispositivo",
    "Scan Code": "Escanear código",
    "Step 1": "Paso 1",
    "Step 2": "Paso 2",
    "Tell me how": "Dime cómo",
    "The alternate method must be time-based one time password (TOTP) compliant. Download now at the <a target=\"_blank\" rel=\"noopener\" href=\"https://itunes.apple.com/<%= appleStoreCountryCode %>/app/thomson-reuters-authenticator/id1155604687?mt=8&amp;l=<%= appleStoreLangCode %>\">Apple App Store</a> or the <a target=\"_blank\" rel=\"noopener\" href=\"https://play.google.com/store/apps/details?id=com.thomsonreuters.trta.authenticator&amp;pcampaignid=MKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1&amp;hl=<%= googleStoreLangCode %>\">Google Play Store</a>.": "El método alternativo debe ser compatible con una sola contraseña basada en el tiempo (TOTP). Descargue ahora en <a target=\"_blank\" rel=\"noopener\" href=\"https://itunes.apple.com/<%= appleStoreCountryCode %>/app/thomson-reuters-authenticator/id1155604687?mt=8&amp;l=<%= appleStoreLangCode %>\">Apple App Store</a> o <a target=\"_blank\" rel=\"noopener\" href=\"https://play.google.com/store/apps/details?id=com.thomsonreuters.trta.authenticator&amp;pcampaignid=MKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1&amp;hl=<%= googleStoreLangCode %>\">Google Play Store</a>.",
    "This option requires you to enter a code each time you sign in.": "Esta opción requiere que ingrese un código cada vez que inicie sesión.",
    "Thomson Reuters Authenticator": "Authenticator de Thomson Reuters",
    "Use Thomson Reuters Authenticator (recommended)": "Utilice Thomson Reuters Authenticator (recomendado)",
    "Use a third-party multi-factor app": "Utilice una aplicación de múltiples factores de terceros",
    "Use your alternate multi-factor app to scan the code below.": "Use su aplicación alternativa de múltiples factores para escanear el código a continuación.",
    "Validate your alternate multi-factor app": "Valide su aplicación alternativa de múltiples factores",
    "You can use Thomson Reuters Authenticator (recommended), or a different multi-factor app.": "Puede utilizar Thomson Reuters Authenticator (recomendado) o una aplicación de múltiples factores diferente.",
    "You have set up multi-factor authentication for your account. You will need to approve each sign-in request on your device each time you sign in with this account.": "Ha configurado una autenticación de múltiples factores para su cuenta. Deberá aprobar cada solicitud de inicio de sesión en su dispositivo cada vez que inicie sesión con esta cuenta.",
    "You will need to approve each sign-in request on your device each time you sign in with this account.": "Deberá aprobar cada solicitud de inicio de sesión en su dispositivo cada vez que inicie sesión con esta cuenta.",
    "Your password needs to be updated. Please <a target=\"_blank\" rel=\"noopener\" href=\"<%= netfirmWebHost %>\">log in</a> and change your password.": "Su contraseña necesita ser actualizada. Por favor, <a target=\"_blank\" rel=\"noopener\" href=\"<%= netfirmWebHost %>\">inicie sesión</a> y cambie su contraseña.",
    Copy: Copy$1,
    "Emergency Access Codes": "Códigos de acceso de emergencia",
    "Emergency codes copied to the clipboard for pasting to a safe place.": "Los códigos de emergencia fueron copiados en el portapapeles para pegarlos en un lugar seguro.",
    "Generating emergency codes.": "Generando códigos de emergencia.",
    "If you lose access to your mobile device, you can use one of these emergency codes to sign in to your account. Each code may be used only once.": "Si pierde el acceso a su dispositivo móvil, puede usar uno de estos códigos de emergencia para iniciar sesión en su cuenta. Cada código puede usarse solo una vez.",
    "Missing firmId parameter.": "Falta el parámetro firmId.",
    "Multi-Factor Authentication Setup": "Configuración de la autenticación de múltiples factores",
    Print: Print$1,
    "These codes are like the key to your office - keep them in a safe place only you can access!": "Estos códigos son como la llave de su oficina: ¡guárdelos en un lugar seguro al que solo usted pueda acceder!",
    "Use one of these codes when this device is inaccessible. Print or save the codes to a secure location. Each code can only be used once, but more codes can be generated in your account profile.": "Use uno de estos códigos cuando este dispositivo sea inaccesible. Imprima o guarde los códigos en una ubicación segura. Cada código solo se puede usar una vez, pero se pueden generar más códigos en su perfil de cuenta.",
    "You can generate more codes by signing in and accessing your profile.": "Puede generar más códigos iniciando sesión y accediendo a su perfil.",
    "Error copying emergency codes to the clipboard.": "Error al copiar códigos de emergencia al portapapeles.",
    "Enter the authentication code displayed by your multi-factor device or provided to you.": "Ingrese el código de autenticación que se muestra en su dispositivo de factores múltiples o que le ha sido proporcionado.",
    "Open the <b>Thomson Reuters Authenticator</b> app on your mobile device and point your device's camera at your monitor to scan the code below.": "Abra la <b>aplicación Thomson Reuters Authenticator</b> en su dispositivo móvil y apunte la cámara de su dispositivo hacia su monitor para escanear el código siguiente.",
    "You have set up the following multi-factor methods:": "Ha configurado los siguientes métodos de múltiples factores:",
    "Device ID": "Código del dispositivo",
    "Enter the 9-character device ID starting with the letters TR from the back of your Thomson Reuters Authenticator card.": "Ingrese el código del dispositivo de 9 caracteres que comienza con las letras TR de la parte posterior de su tarjeta Thomson Reuters Authenticator.",
    "Enter the one-time code displayed on your multi-factor device.": "Ingrese el código de único acceso que se muestra en su dispositivo de múltiples factores.",
    "Learn more about multi-factor devices": "Conozca más sobre dispositivos de múltiples factores",
    "Use a multi-factor device": "Utilice un dispositivo de múltiples factores",
    "Use a multi-factor device like a card that displays a code to enter.": "Utilice un dispositivo de múltiples factores como una tarjeta que muestra un código para ingresar.",
    "Validate your multi-factor device": "Valide su dispositivo de múltiples factores",
    "Incorrect Device ID or Code. Please try again.": "ID o código incorrecto del dispositivo. Por favor, vuelva a intentarlo.",
    "Thomson Reuters Authenticator Card": "Tarjeta de Authenticator de Thomson Reuters",
    "Save Emergency Access Codes": "Guardar códigos de acceso de emergencia",
    "Save or print these codes to a secure location for use when your primary MFA device is unavailable (e.g., if you get a new phone). You can use each code only once, but you can generate more codes in your account profile": "Guarde o imprima estos códigos en una ubicación segura para usar cuando su dispositivo MFA principal no esté disponible (por ejemplo, si obtiene un teléfono nuevo). Puede usar cada código solo una vez, pero puede generar más códigos en el perfil de su cuenta",
    or: or$1,
    Download: Download,
    "Learn more about Emergency Access Codes": "Más información sobre los códigos de acceso de emergencia",
    "Sign-in Help": "Ayuda para Iniciar sesión",
    "System Status": "Estado del sistema",
    "Your Browser is not supported": "Su navegador no es compatible",
    "To log in to Onvio, please use one of the supported internet browsers below.": "Para iniciar sesión en Onvio, utilice uno de los navegadores de Internet compatibles de la lista.",
    "Your firm's license is no longer active. Please contact your administrator.": "Su licencia del Estudio ya no está activa. Por favor, póngase en contacto con su administrador.",
    "Please enter a valid password. Your password cannot contain personal information associated with your account.": "Por favor introduzca una contraseña válida. La contraseña no puede contener información personal asociada a su cuenta.",
    "Your firm's license is inactive": "La licencia de su Estudio Contable está inactiva",
    "Refer to <a class=\"trta1-howAndHelp-link\" target=\"_blank\" rel=\"noopener\" href=\"https://cs.thomsonreuters.com/ua/login_security/cs_us_en/mfa-troubleshooting.htm\"> Help & How To Center </a> for possible solutions": "Consulte la <a class=\"trta1-howAndHelp-link\" target=\"_blank\" rel=\"noopener\" href=\"https://cs.thomsonreuters.com/ua/login_security/cs_us_en/mfa-troubleshooting.htm\"> Ayuda y el Centro de instrucciones </a> para encontrar posibles soluciones",
    "Acknowledge and Ignore Warning": "Reconocer e ignorar la advertencia",
    "Contact your Onvio administrator.": "Póngase en contacto con su administrador de Onvio.",
    "Contact your administrator.": "Póngase en contacto con su administrador.",
    "Email Address": "Dirección de Correo Electrónico",
    "End of support for Windows 7, Server 2008 / 2008 R2": "Fin del soporte para Windows 7, Server 2008 / 2008 R2",
    "Let's get started": "Empecemos",
    "Microsoft Window Server 2008 / 2008 R2 Announcement": "Anuncio de Microsoft Window Server 2008 / 2008 R2",
    "Microsoft Windows 7 Announcement": "Anuncio de Microsoft Windows 7",
    "Onvio requires two-step verification. You only have to configure this once, and it won't take long.": "Onvio requiere verificación en dos pasos. Solo tienes que configurar esto una vez, y no tomará mucho tiempo.",
    "Password contains prohibited characters": "La contraseña contiene caracteres prohibidos.",
    "Please close this window and try again.": "Por favor cierre esta ventana y vuelva a intentarlo.",
    "Read about account security": "Obtén más información sobre la seguridad de la cuenta",
    "Secure your account": "Tu cuenta no está verificada",
    "Set up two-step verification": "Configurar la verificación en dos pasos",
    "Sign back in": "Volver a iniciar sesión",
    "Sign in": "Iniciar sesión",
    "Thomson Reuters will no longer support its products on Windows 7 operating systems or Windows Server 2008 or 2008 R2 beginning January 14, 2020. We strongly urge you to upgrade any workstations or servers that require access to Thomson Reuters products to a supported operating system prior to January 14, 2020. Please find more information at the links below:": "Thomson Reuters ya no admitirá sus productos en los sistemas operativos Windows 7 o Windows Server 2008 o 2008 R2 a partir del 14 de enero de 2020. Le recomendamos encarecidamente que actualice cualquier estación de trabajo o servidor que requiera acceso a los productos de Thomson Reuters a un sistema operativo compatible antes del 14 de enero de 2020. Encuentre más información en los siguientes enlaces:",
    "View system status": "Ver el estado del sistema",
    "You don't have access": "No tienes acceso",
    "You're signed out": "Está deslogueado",
    "You don't have access to this product": "No tenés acceso a este producto",
    "Select the module you wish to access and try again": "Seleccioná el módulo al que deseás acceder y volvé a intentarlo:",
    "Client Center": "Portal Cliente",
    "Employee Portal": "Portal del empleado"
  };

  var Password$2 = "Mot de passe";
  var Back$2 = "Retour";
  var OK$2 = "OK";
  var Reset$2 = "Réinitialiser";
  var Retry$2 = "Réessayez";
  var Cancel$2 = "Annuler";
  var Next$2 = "Suivant";
  var Go$2 = "Aller";
  var Close$1 = "Fermer";
  var Done$2 = "Terminé";
  var Choose$2 = "Choisir";
  var Code$2 = "Code";
  var Finish$2 = "Terminer";
  var Copy$2 = "Copier";
  var Print$2 = "Imprimer";
  var or$2 = "ou";
  var Download$1 = "Télécharger";
  var frCA = {
    "Email Address (Thomson Reuters ID)": "Adresse Courriel (Thomson Reuters ID)",
    "Sign in with your Thomson Reuters ID": "Connectez-vous avec votre Thomson Reuters ID",
    "Your Thomson Reuters ID is the email address you use to sign in to your Onvio and/or CS Web (cs.thomsonreuters.com) accounts.": "Votre Thomson Reuters ID est l’adresse courriel que vous utilisez pour vous connecter à votre compte Onvio.",
    "Sign in with your NetStaff CS account": "Connectez-vous avec votre compte DT Portail-Client",
    Password: Password$2,
    "Reset Password": "Réinitialiser le mot de passe",
    "Manage Account": "Gestion de compte",
    "CS Professional Suite Security Help": "Aide relative à la sécurité de la Suite Professionnelle DT",
    "Need an account? Contact your administrator": "Besoin d’un compte? Contactez votre administrateur.",
    "ONVIO Sign In Security Help": "Aide relative à la sécurité de la connexion ONVIO",
    "Need an account? Please create a new account": "Besoin d’un compte? Veuillez créer un nouveau compte",
    "Internet Access Required": "Connexion Internet requise",
    "To help protect the confidential data belonging to your firm and your clients and to comply with new IRS requirements, Thomson Reuters is adding usernames and passwords to access our Tax &amp; Accounting products.": "Pour aider à protéger les données confidentielles de votre cabinet et de vos clients, Thomson Reuters ajoute des noms d’utilisateurs et des mots de passe pour que vous puissiez avoir accès aux produits d’impôt et de comptabilité.",
    "To sign in, please connect this computer to the internet then restart the application.": "Pour vous connecter, veuillez connecter cet ordinateur à Internet et redémarrer l’application.",
    "Learn more about these new security measures.": "Renseignez-vous sur ces nouvelles mesures de sécurité.",
    "For your firm to access this software, one of your firm's administrators needs to upgrade your accounts at <a href=\"<%= cswebHost %>/myaccount\" target=\"_blank\">cs.thomsonreuters.com/myaccount</a>.": "Pour que votre cabinet ait accès à ce logiciel, un des administrateurs de votre cabinet doit mettre à niveau les comptes.",
    "Learn More About New Security Measures": "Renseignez-vous sur les nouvelles mesures de sécurité",
    "Please enter your email address.": "Veuillez saisir votre adresse courriel.",
    "Please enter your login and email address.": "Veuillez saisir votre identifiant de connexion et votre adresse courriel.",
    Back: Back$2,
    "Reset My Password": "Réinitialiser mon mot de passe",
    "Continue to sign in page": "Continuer vers la page de connexion",
    "https://onvio.us/ua/help/us-en/staff/core/setup/thomson-reuters-account.htm": "https://onvio.us/ua/help/us-fr/staff/core/setup/thomson-reuters-account.htm",
    "Instructions for resetting your password have been sent to your registered email address.": "Des directives pour réinitialiser votre mot de passe ont été envoyées à l’adresse courriel que vous avez enregistrée.",
    "Go To Sign In": "Allez dans Connexion",
    "Please create a new password that meets <a id=\"trta1-toggle-pwd-requirements\" href=\"javascript:void(0)\">requirements</a>.": "Veuillez créer un nouveau mot de passe qui répond aux <a id=\"trta1-toggle-pwd-requirements\" href=\"javascript:void(0)\">exigences</a>.",
    "Your password has expired. Please create a new one that meets <a id=\"trta1-toggle-expired-pwd-requirements\" href=\"javascript:void(0)\">requirements</a>.": "Votre mot de passe est échu. Veuillez en créer un nouveau qui répond aux <a id=\"trta1-toggle-expired-pwd-requirements\" href=\"javascript:void(0)\">exigences</a>.",
    "Your password <strong>must</strong> have <span>at least 8 characters</span> including all of the following:": "Votre mot de passe <strong>doit</strong> comporter <span>au moins 8 caractères</span>, incluant tous les caractères suivants :",
    "At least 1 uppercase letter (A-Z)": "Au moins une lettre majuscule (A-Z)",
    "At least 1 lowercase letter (a-z)": "Au moins une lettre minuscule (a-z)",
    "At least 1 digit (0-9)": "Au moins un chiffre (0-9)",
    "At least 1 symbol (e.g. ! @ # $ % ^ &amp; *)": "Au moins un symbole (e.g. ! @ # $ % ^ &amp; *)",
    "Your password should <strong>not</strong> use:": "Votre mot de passe ne doit <strong>pas</strong> contenir :",
    "Leading or trailing spaces": "Des espaces à gauche ou à droite",
    "Words from the dictionary": "Des mots du dictionnaire",
    "Your user ID": "Votre ID utilisateur",
    "Sequential letters or numbers such as \"abc\" or \"123\"": "Des lettres ou des chiffres en séquence comme abc ou \"abc\" or \"123\"",
    "Show typing": "Afficher la saisie",
    "Hide typing": "Cacher la saisie",
    "New Password": "Nouveau mot de passe",
    "Confirm New Password": "Confirmer le nouveau mot de passe",
    "Change My Password": "Changer mon mot de passe",
    "You've successfully changed your password.": "Vous avez changé votre mot de passe avec succès.",
    OK: OK$2,
    "Your password needs to be updated. Please <a href=\"<%= netfirmWebHost %>\" target=\"_blank\"> log in</a> and change your password.": "Votre mot de passe doit être mis à jour. Veuillez vous <a href=\"<%= netfirmWebHost %>\" target=\"_blank\">connecter</a> et changer votre mot de passe.",
    "Back To Sign In": "Retour à la connexion",
    "Unlocking your account.": "Déverrouillage de votre compte.",
    "Your password will expire soon": "Votre mot de passe viendra bientôt à échéance",
    "Your password will expire in <em id=\"trta1-pwdexpdays\">2</em> days.": "Votre mot de passe arrive à échéance dans <em id=\"trta1-pwdexpdays\">2</em> jours.",
    "Your password will expire in <em>1</em> day.": "Votre mot de passe viendra à échéance dans <em>un</em> jour.",
    "Your password will expire <em>today</em>.": "Votre mot de passe vient à échéance <em>aujourd’hui</em>.",
    "Do you want to change it now?": "Voulez-vous le changer maintenant?",
    "Change my password": "Changer maintenant",
    "Do it later": "Plus tard",
    "Your session is ending soon": "Votre session se termine bientôt",
    "Your session will end in:": "Votre session se termine dans :",
    Reset: Reset$2,
    "Multi-factor authentication required": "Authentification multifacteurs requise",
    "The firm requires you to enable multi-factor authentication before signing in. Please complete the multi-factor authentication setup wizard to continue.": "Le cabinet exige que vous activiez l'authentification multifacteurs avant de vous connecter. Veuillez compléter l'assistant de configuration de l'authentification multifacteurs pour continuer.",
    "Set Up Now": "Configurer",
    "Finding your paired device.": "Trouvez votre appareil jumelé.",
    Retry: Retry$2,
    "Notifying your paired device.": "Notification de votre appareil jumelé en cours.",
    "Check your device!": "Vérifiez votre appareil!",
    "Approve your request<br> in the Thomson Reuters Authenticator app": "Approuvez votre demande<br> dans l’application Thomson Reuters Authenticator",
    "Didn't get a notification? <a href=\"javascript:void(0)\" data-trta1-dest=\"trta1-mfa-choosedevice\">Resend it</a> or <a href=\"javascript:void(0)\" data-trta1-dest=\"trta1-mfa-approvecode\">enter a code</a>": "Vous n’avez pas reçu de notification? <a href=\"javascript:void(0)\" data-trta1-dest=\"trta1-mfa-choosedevice\">Renvoyez une notification</a> ou <a href=\"javascript:void(0)\" data-trta1-dest=\"trta1-mfa-approvecode\">saisissez un code</a>",
    "No phone? Contact your firm's administrator": "Vous n’avez pas de téléphone? Contactez l’administrateur de votre cabinet",
    "Cancel Request": "Annuler la demande",
    "Didn't get a notification? <a href=\"javascript:void(0)\" data-trta1-dest=\"trta1-mfa-choosedevice\">Resend it</a> or": "Vous n’avez pas reçu de notification? <a href=\"javascript:void(0)\" data-trta1-dest=\"trta1-mfa-choosedevice\">Renvoyez une notification</a> ou",
    "Enter code": "Saisissez le code",
    "Retrieving authentication token.": "Récupération du jeton d’authentification",
    "You've been authenticated.": "Vous avez été authentifié.",
    "Please wait while we sign you into your account…": "Veuillez patienter pendant que nous vous connectons à votre compte…",
    "Multifactor authentication is currently unavailable.": "L’authentification multifacteurs n’est présentement pas disponible.",
    "Thomson Reuters": "Thomson Reuters",
    "You are using an <strong>outdated</strong> browser. Please upgrade your browser to improve security.": "Vous utilisez un navigateur <strong>obsolète</strong>. Veuillez actualiser le navigateur pour améliorer la sécurité.",
    "Multi-factor Authentication Setup": "Configuration de l’authentification multifacteurs",
    "<strong>Increase security for your account</strong> Passwords can be hacked, but using multi-factor authentication adds another layer of security to your account.": "<strong>Augmentez la sécurité de votre compte</strong> Les mots de passe peuvent être piratés, mais utiliser l’authentification multifacteurs ajoute un autre niveau de sécurité à votre compte.",
    "<strong>How long will it take to set up?</strong> Minutes.": "<strong>Combien de temps prendra la configuration?</strong> Quelques minutes.",
    "<strong>How will this affect me?</strong> You will need to approve each sign in request on your smartphone once a day and after each time you log out.": "<strong>De quelle façon cela m’affectera-t-il?</strong> Vous devrez approuver chaque demande de connexion sur votre téléphone intelligent une fois par jour et après chaque déconnexion.",
    Cancel: Cancel$2,
    "Get Started": "Commencer",
    "Install the Thomson Reuters Authenticator app on your smartphone or tablet.": "Installez l’application Thomson Reuters Authenticator sur votre téléphone intelligent ou tablette.",
    "Download on the Apple App Store": "Téléchargez sur le magasin App Store d’Apple.",
    "Get it on Google Play": "Obtenez l’application sur Google Play",
    Next: Next$2,
    "Generating QR code.": "Génération d’un code QR.",
    "Open the Thomson Reuters Authenticator app and scan the QR code below.": "Ouvrez l’application Thomson Reuters Authenticator et balayez le code QR ci-dessous.",
    "Retrieving device info.": "Récupération des informations sur l’appareil",
    "You have paired your account with <strong id=\"trta1-mfs-devicename\">this device</strong>. You will need to approve each sign in request on this device once a day and after each time you log out.": "Vous avez jumelé votre compte avec <strong id=\"trta1-mfs-devicename\">cet appareil</strong>. Vous devrez approuver chaque demande d’ouverture de session sur cet appareil une fois par jour et après chaque déconnexion.",
    "Got It": "J’ai compris",
    "Please wait…": "Veuillez patienter…",
    "Enter your authentication code": "Saisissez votre code d’authentification",
    "Invalid code. Please enter a valid authentication code.": "Code invalide. Veuillez saisir un code d’authentification valide.",
    "Enter the code provided by your adminstrator": "Saisissez le code fourni par votre administrateur",
    "Set up your mobile device": "Configurez votre appareil mobile",
    "Password must be a minimum of 8 characters and contain at least one uppercase letter, one lowercase letter, one digit, and one symbol, with no leading or trailing spaces.": "Le mot de passe doit comporter au moins 8 caractères et contenir au moins une lettre majuscule, une lettre minuscule, un chiffre et un symbole, sans espace avant ou arrière.",
    "Incorrect Email Address or Password. Please try again.": "Adresse électronique incorrecte ou mot de passe incorrect. Veuillez réessayer.",
    "Too many sign in attempts. Please check for unlock email or try later.": "Trop de tentatives de connexion. Veuillez vérifier si vous avez reçu un courriel de déverrouillage ou essayez plus tard.",
    "Please change your password.": "Veuillez modifier votre mot de passe.",
    "Please complete the required fields.": "Veuillez remplir les champs requis.",
    "Deactivated account. Contact your administrator or accountant.": "Compte désactivé. Communiquez avec votre administrateur ou votre comptable.",
    "There was an error sending the email. Please try again.": "Une erreur s'est produite lors de l'envoi du courriel. Veuillez réessayer.",
    "Please choose a password you have not already used.": "Choisissez un mot de passe que vous n'avez pas déjà utilisé.",
    "Your account has been unlocked.": "Votre compte a été débloqué.",
    "You've been signed out due to inactivity. Sign in to resume.": "Vous avez été déconnecté en raison de l'inactivité. Connectez-vous pour reprendre.",
    "You've exceeded maximum usage time. Please sign in again.": "Vous avez dépassé le temps d'utilisation maximum. Veuillez vous connecter à nouveau.",
    "Incorrect Login or Password. Please try again.": "Identifiant ou mot de passe incorrect. Veuillez réessayer.",
    "Missing data required to reset password. Please try again.": "Données manquantes requises pour réinitialiser le mot de passe. Veuillez réessayer.",
    "Missing data required to unlock account. Please try again.": "Données manquantes requises pour déverrouiller le compte. Veuillez réessayer.",
    "Timed out waiting for device approval. Resend notification or enter code.": "Temporisé en attendant l'approbation de l'appareil. Renvoyez une notification ou saisissez un code.",
    "Invalid code. Please try again.": "Code invalide. Veuillez réessayer.",
    "Passwords Don't Match": "Les mots de passe ne correspondent pas",
    "Please wait.": "Veuillez patienter.",
    "Success!": "Succès!",
    "An unexpected error occurred. Please try again.": "Une erreur inattendue s’est produite. Veuillez réessayer.",
    "An unexpected error occurred while redirecting your request.": "Une erreur inattendue s'est produite lors de la redirection de votre demande.",
    "The server did not respond in time. Please try again.": "Le serveur n'a pas répondu à temps. Veuillez réessayer.",
    "An error occurred with your request. Please try again.": "Une erreur s'est produite avec votre demande. Veuillez réessayer.",
    "Please provide a valid {{label}}.": "Veuillez fournir un {{label}} valide.",
    "{{label}} is required.": "{{label}} est requis.",
    "Timed out waiting for scan. Please go back and try again.": "Temporisé en attente de numérisation. Veuillez revenir en arrière et réessayer.",
    "Your account is locked. Please contact your administrator.": "Votre compte est verrouillé. Veuillez contacter votre administrateur.",
    Go: Go$2,
    "Sorry, there was an issue on our end. Please try again.": "Désolé, nous avons éprouvé un problème de notre côté. Veuillez réessayer.",
    "Your registration link has expired. Please contact the firm for a new one.": "Le lien de votre inscription est expiré. Veuillez communiquer avec le cabinet pour en recevoir un nouveau.",
    "Make your account even more secure!": "Sécurisez encore plus votre compte!",
    "Add an additional level of security in case your password is ever compromised. Confirm your identity using your mobile device.": "Ajoutez un niveau de sécurité supplémentaire au cas où la sécurité de votre mot de passe s'avérait compromise. Confirmez votre identité à l'aide de votre appareil mobile.",
    "Learn more about multi-factor authentication.": "En savoir plus sur l'authentification multifacteurs.",
    "Remind Me Later": "Rappelez-moi plus tard",
    Close: Close$1,
    Done: Done$2,
    "Update Password": "Mettre à jour le mot de passe",
    "Please enter your email address to update your password.": "Veuillez saisir votre adresse courriel pour mettre à jour votre mot de passe.",
    "Sign In": "Se connecter",
    "Please provide a valid password.": "Veuillez fournir un mot de passe valide.",
    "Password contains prohibited characters.": "Le mot de passe contient des caractères interdits.",
    "Password is too similar to a common or blacklisted password.": "Ce mot de passe est trop similaire à un mot de passe commun ou interdit.",
    "Ignore warning": "Ignorer l'avertissement",
    "Your browser is not supported for use with this application. Please try again using the latest version of one of the following browsers.": "Votre navigateur n'est pas pris en charge avec cette application. Veuillez réessayer en utilisant la dernière version de l'un des navigateurs suivants.",
    "Using a browser that’s no longer supported by the vendor is a security risk. Click one of the links below to upgrade to a current browser.": "L'utilisation d'un navigateur qui n'est plus pris en charge par le fournisseur constitue un risque de sécurité. Cliquez sur l'un des liens ci-dessous pour passer à un navigateur plus récent.",
    "Your Browser is Outdated": "Votre navigateur est obsolète",
    "A few minutes.": "Quelques minutes.",
    "After installing and opening the app, click Next.": "Après avoir installé et ouvert l'application, cliquer sur Suivant.",
    Choose: Choose$2,
    "Choose multi-factor option": "Choisir l'option multifacteurs",
    Code: Code$2,
    "Download and install Thomson Reuters Authenticator app": "Télécharger et installer l'application Thomson Reuters Authenticator",
    "Download and install an alternate multi-factor app": "Télécharger et installer une autre application multifacteurs",
    "Enter the authentication code displayed by the Authenticator app.": "Saisir le code d'authentification affiché par l'application Authenticator.",
    "Enter the code displayed by your alternate multi-factor app.": "Saisir le code affiché par votre application multifacteurs alternative.",
    Finish: Finish$2,
    "For your firm to access this software, one of your firm's administrators needs to upgrade your accounts at <a target=\"_blank\" rel=\"noopener\" href=\"<%= cswebHost %>/myaccount\">cs.thomsonreuters.com/myaccount</a>.": "Pour que votre entreprise puisse accéder à ce logiciel, l'un des administrateurs de votre entreprise doit mettre à niveau vos comptes sur <a target=\"_blank\" rel=\"noopener\" href=\"<%= cswebHost %>/myaccount\">cs.thomsonreuters.com/myaccount</a>.",
    "How long will it take to set up?": "Combien de temps prendra la configuration?",
    "How will this affect me?": "De quelle façon cela m’affectera-t-il?",
    "Increase security for your account": "Augmenter la sécurité de votre compte",
    "Invalid value entered.": "Valeur invalide saisie.",
    "Learn more about third-party MFA apps": "Pour en savoir plus sur les applications AFM tierces",
    "Learn which MFA option is right for you": "Découvrez quelle option AFM vous convient",
    "My Multi-Factor App": "Mon application multifacteurs",
    "Name this multi-factor option": "Nommer cette option multifacteurs",
    "Need an account? Contact your administrator.": "Besoin d’un compte? Contactez votre administrateur.",
    "Need an account? Create one now.": "Besoin d’un compte? Créez-en un maintenant",
    "Next steps after setting up MFA": "Prochaines étapes après avoir configuré l'AFM",
    "On your mobile device, open the app store and download and install the <b>Thomson Reuters Authenticator</b> app.": "Sur votre appareil mobile, ouvrez la boutique d'applications, téléchargez et installez l'application <b>Thomson Reuters Authenticator</b>.",
    "Open the <b>Thomson Reuters Authenticator app</b> on your mobile device and point your device's camera at your monitor to scan the code below.": "Ouvrez l'application <b>Thomson Reuters Authenticator</b> sur votre appareil mobile et pointez l'appareil photo de votre appareil sur votre moniteur pour scanner le code ci-dessous.",
    "Pairing Successful!": "Appariement réussi !",
    "Passwords can be hacked, but using multi-factor authentication adds another layer of security to your account.": "Les mots de passe peuvent être piratés, mais l'utilisation de l’authentification multifacteurs ajoute un niveau de sécurité supplémentaire à votre compte.",
    "Receive notifications on your mobile device and sign in with a single touch.": "Recevez des notifications sur votre appareil mobile et connectez-vous avec une seule touche.",
    "Registering your device.": "Enregistrer votre appareil.",
    "Scan Code": "Scanner le code",
    "Step 1": "Étape 1",
    "Step 2": "Étape 2",
    "Tell me how": "Dites-moi comment",
    "The alternate method must be time-based one time password (TOTP) compliant. Download now at the <a target=\"_blank\" rel=\"noopener\" href=\"https://itunes.apple.com/<%= appleStoreCountryCode %>/app/thomson-reuters-authenticator/id1155604687?mt=8&amp;l=<%= appleStoreLangCode %>\">Apple App Store</a> or the <a target=\"_blank\" rel=\"noopener\" href=\"https://play.google.com/store/apps/details?id=com.thomsonreuters.trta.authenticator&amp;pcampaignid=MKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1&amp;hl=<%= googleStoreLangCode %>\">Google Play Store</a>.": "L'autre méthode doit se conformer au mot de passe temporaire à usage unique (TOTP). Téléchargez maintenant à partir du <a target=\"_blank\" rel=\"noopener\" href=\"https://itunes.apple.com/<%= appleStoreCountryCode %>/app/thomson-reuters-authenticator/id1155604687?mt=8&amp;l=<%= appleStoreLangCode %>\">App Store d'Apple</a> ou de <a target=\"_blank\" rel=\"noopener\" href=\"https://play.google.com/store/apps/details?id=com.thomsonreuters.trta.authenticator&amp;pcampaignid=MKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1&amp;hl=<%= googleStoreLangCode %>\">Google Play Store</a>.",
    "The alternate method must be time-based one time password (TOTP) compliant. Download now at the <a target=\"_blank\" rel=\"noopener\" href=\"https://itunes.apple.com/us/app/thomson-reuters-authenticator/id1155604687?mt=8&amp;l=en-us\">Apple App Store</a> or the <a target=\"_blank\" rel=\"noopener\" href=\"https://play.google.com/store/apps/details?id=com.thomsonreuters.trta.authenticator&amp;pcampaignid=MKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1&amp;hl=en\">Google Play Store</a>.": "L'autre méthode doit se conformer au mot de passe temporaire à usage unique (TOTP). Téléchargez maintenant à partir du <a target=\"_blank\" rel=\"noopener\" href=\"https://itunes.apple.com/<%= appleStoreCountryCode %>/app/thomson-reuters-authenticator/id1155604687?mt=8&amp;l=<%= appleStoreLangCode %>\">App Store d'Apple</a> ou de <a target=\"_blank\" rel=\"noopener\" href=\"https://play.google.com/store/apps/details?id=com.thomsonreuters.trta.authenticator&amp;pcampaignid=MKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1&amp;hl=<%= googleStoreLangCode %>\">Google Play Store</a>.",
    "The alternate method must be time-based one time password (TOTP) compliant. Download now at the <a target=\"_blank\" rel=\"noopener\" href=\"https://itunes.apple.com/ca/app/thomson-reuters-authenticator/id1155604687?mt=8&amp;l=fr-ca\">Apple App Store</a> or the <a target=\"_blank\" rel=\"noopener\" href=\"https://play.google.com/store/apps/details?id=com.thomsonreuters.trta.authenticator&amp;pcampaignid=MKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1&amp;hl=fr-ca\">Google Play Store</a>.": "L'autre méthode doit se conformer au mot de passe temporaire à usage unique (TOTP). Téléchargez maintenant à partir du <a target=\"_blank\" rel=\"noopener\" href=\"https://itunes.apple.com/fr/app/thomson-reuters-authenticator/id1155604687?mt=8&amp;l=fr-ca\">App Store d'Apple</a> ou de <a target=\"_blank\" rel=\"noopener\" href=\"https://play.google.com/store/apps/details?id=com.thomsonreuters.trta.authenticator&amp;pcampaignid=MKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1&amp;hl=fr-ca\">Google Play Store</a>.",
    "This option requires you to enter a code each time you sign in.": "Cette option nécessite que vous saisissiez un code chaque fois que vous vous connectez.",
    "Thomson Reuters Authenticator": "Thomson Reuters Authenticator",
    "Use Thomson Reuters Authenticator (recommended)": "Utiliser Thomson Reuters Authenticator (recommandé)",
    "Use a third-party multi-factor app": "Utiliser une application multifacteurs tierce",
    "Use your alternate multi-factor app to scan the code below.": "Utiliser votre application multifacteurs alternative pour scanner le code ci-dessous.",
    "Validate your alternate multi-factor app": "Valider votre application multifacteurs alternative",
    "You can use Thomson Reuters Authenticator (recommended), or a different multi-factor app.": "Vous pouvez utiliser Thomson Reuters Authenticator (recommandé) ou une autre application multifacteurs.",
    "You have set up multi-factor authentication for your account. You will need to approve each sign-in request on your device each time you sign in with this account.": "Vous avez configuré l'authentification multifacteurs pour votre compte. Vous devrez approuver chaque requête de connexion sur votre appareil chaque fois que vous vous connectez avec ce compte.",
    "You will need to approve each sign-in request on your device each time you sign in with this account.": "Vous devrez approuver chaque requête de connexion sur votre appareil chaque fois que vous vous connectez avec ce compte.",
    "Your password needs to be updated. Please <a target=\"_blank\" rel=\"noopener\" href=\"<%= netfirmWebHost %>\">log in</a> and change your password.": "Votre mot de passe doit être mis à jour. Veuillez <a target=\"_blank\" rel=\"noopener\" href=\"<%= netfirmWebHost %>\">vous connecter</a> et modifier votre mot de passe.",
    Copy: Copy$2,
    "Emergency Access Codes": "Codes d'accès d'urgence",
    "Emergency codes copied to the clipboard for pasting to a safe place.": "Codes d'urgence copiés dans le presse-papiers pour être collés dans un endroit sûr.",
    "Generating emergency codes.": "Générer des codes d'urgence",
    "If you lose access to your mobile device, you can use one of these emergency codes to sign in to your account. Each code may be used only once.": "Si vous perdez l'accès à votre appareil mobile, vous pouvez utiliser l'un de ces codes d'urgence pour vous connecter à votre compte. Chaque code ne peut être utilisé qu'une seule fois.",
    "Missing firmId parameter.": "Paramètre firmId manquant",
    "Multi-Factor Authentication Setup": "Configuration de l’authentification multifacteurs",
    Print: Print$2,
    "These codes are like the key to your office - keep them in a safe place only you can access!": "Ces codes sont comme la clé de votre bureau - gardez-les dans un endroit sûr auquel vous seul pouvez accéder!",
    "Use one of these codes when this device is inaccessible. Print or save the codes to a secure location. Each code can only be used once, but more codes can be generated in your account profile.": "Utilisez l'un de ces codes lorsque cet appareil est inaccessible. Imprimez ou enregistrez les codes dans un emplacement sécurisé. Chaque code ne peut être utilisé qu'une seule fois, mais d'autres codes peuvent être générés dans votre profil de compte.",
    "You can generate more codes by signing in and accessing your profile.": "Vous pouvez générer plus de codes en vous connectant et en accédant à votre profil.",
    "Error copying emergency codes to the clipboard.": "Erreur lors de la copie des codes d'urgence dans le presse-papiers.",
    "Enter the authentication code displayed by your multi-factor device or provided to you.": "Saisissez le code d'authentification affiché par votre appareil multifacteurs ou qui vous a été fourni.",
    "Open the <b>Thomson Reuters Authenticator</b> app on your mobile device and point your device's camera at your monitor to scan the code below.": "Ouvrez l'application <b>Thomson Reuters Authenticator</b> sur votre appareil mobile et pointez l'appareil photo de votre appareil sur votre moniteur pour scanner le code ci-dessous.",
    "You have set up the following multi-factor methods:": "Vous avez configuré les méthodes multifacteurs suivantes :",
    "Device ID": "Identifiant d'appareil",
    "Enter the 9-character device ID starting with the letters TR from the back of your Thomson Reuters Authenticator card.": "Saisissez l'identifiant d'appareil à 9 caractères commençant par les lettres TR à l'arrière de votre carte Thomson Reuters Authenticator.",
    "Enter the one-time code displayed on your multi-factor device.": "Saisissez le code unique affiché sur votre appareil multifacteurs.",
    "Learn more about multi-factor devices": "Pour en savoir plus sur les appareils multifacteurs",
    "Use a multi-factor device": "Utilisez un appareil multifacteurs",
    "Use a multi-factor device like a card that displays a code to enter.": "Utilisez un appareil multifacteur comme une carte qui affiche un code à saisir.",
    "Validate your multi-factor device": "Validez votre appareil multifacteurs",
    "Incorrect Device ID or Code. Please try again.": "Identifiant d'appareil ou code incorrect. Veuillez réessayer.",
    "Thomson Reuters Authenticator Card": "Carte Thomson Reuters Authenticator",
    "Save Emergency Access Codes": "Enregistrer les codes d'accès d'urgence",
    "Save or print these codes to a secure location for use when your primary MFA device is unavailable (e.g., if you get a new phone). You can use each code only once, but you can generate more codes in your account profile": "Enregistrez ou imprimez ces codes dans un emplacement sécurisé pour pouvoir les utiliser lorsque votre périphérique d'AFM principal n'est pas disponible (par exemple, si vous avez un nouveau téléphone). Vous ne pouvez utiliser chaque code qu'une seule fois, mais vous pouvez générer plus de codes dans votre profil de compte.",
    or: or$2,
    Download: Download$1,
    "Learn more about Emergency Access Codes": "Pour en savoir plus sur les codes d'accès d'urgence",
    "Sign-in Help": "Aide relative à la connexion",
    "System Status": "État du système",
    "Your Browser is not supported": "Votre navigateur n’est pas pris en charge",
    "To log in to Onvio, please use one of the supported internet browsers below.": "Pour vous connecter à Onvio, veuillez utiliser un des navigateurs Internet pris en charge ci-dessous.",
    "Your firm's license is no longer active. Please contact your administrator.": "La licence de votre cabinet n'est plus active. Veuillez communiquer avec votre administrateur.",
    "Please enter a valid password. Your password cannot contain personal information associated with your account.": "Veuillez saisir un mot de passe valide. Votre mot de passe ne peut pas contenir de renseignements personnels associés à votre compte.",
    "Your firm's license is inactive": "La licence de votre cabinet est inactive",
    "Refer to <a class=\"trta1-howAndHelp-link\" target=\"_blank\" rel=\"noopener\" href=\"https://cs.thomsonreuters.com/ua/login_security/cs_us_en/mfa-troubleshooting.htm\"> Help & How To Center </a> for possible solutions": "Reportez-vous au Centre <a class=\"trta1-howAndHelp-link\" target=\"_blank\" rel=\"noopener\" href=\"https://cs.thomsonreuters.com/ua/login_security/cs_us_en/mfa-troubleshooting.htm\"> d'aide et de documentation </a> pour connaître les solutions possibles.",
    "Acknowledge and Ignore Warning": "Confirmer et ignorer l'avertissement",
    "Contact your Onvio administrator.": "Contactez votre administrateur Onvio.",
    "Contact your administrator.": "Contactez votre administrateur.",
    "Email Address": "Adresse courriel",
    "End of support for Windows 7, Server 2008 / 2008 R2": "Fin de la prise en charge de Windows 7, Server 2008 / 2008 R2",
    "Let's get started": "Commençons",
    "Microsoft Window Server 2008 / 2008 R2 Announcement": "Annonce de Microsoft Window Server 2008 / 2008 R2",
    "Microsoft Windows 7 Announcement": "Annonce de Microsoft Windows 7",
    "Onvio requires two-step verification. You only have to configure this once, and it won't take long.": "Onvio nécessite une vérification en deux étapes. Vous n'avez qu'à le configurer une seule fois, et cela ne prendra pas longtemps.",
    "Password contains prohibited characters": "Le mot de passe contient des caractères interdits",
    "Please close this window and try again.": "Veuillez fermer cette fenêtre et essayer de nouveau.",
    "Read about account security": "En savoir plus sur la sécurité du compte",
    "Secure your account": "Sécuriser votre compte",
    "Set up two-step verification": "Configurer la vérification en deux étapes",
    "Sign back in": "Se reconnecter",
    "Sign in": "Se connecter",
    "Thomson Reuters will no longer support its products on Windows 7 operating systems or Windows Server 2008 or 2008 R2 beginning January 14, 2020. We strongly urge you to upgrade any workstations or servers that require access to Thomson Reuters products to a supported operating system prior to January 14, 2020. Please find more information at the links below:": "Thomson Reuters ne prendra plus en charge ses produits sur les systèmes d'exploitation Windows 7 ou Windows Server 2008 ou 2008 R2 à compter du 14 janvier 2020. Nous vous invitons vivement à mettre à niveau tous les postes de travail ou serveurs nécessitant l'accès aux produits Thomson Reuters vers un système d'exploitation pris en charge avant le 14 janvier 2020. Vous trouverez plus d'informations sur les liens ci-dessous :",
    "View system status": "Afficher l’état du système",
    "You don't have access": "Vous n'avez pas accès",
    "You're signed out": "Vous êtes déconnecté",
    "You don't have access to this product": "Vous n'avez pas accès à ce produit",
    "Select the module you wish to access and try again": "Sélectionnez le module auquel vous souhaitez accéder et réessayez :",
    "Client Center": "Centre-Client",
    "Employee Portal": "Portail des employés"
  };

  var Password$3 = "Wachtwoord";
  var Back$3 = "Terug";
  var OK$3 = "OK";
  var Reset$3 = "Resetten";
  var Retry$3 = "Opnieuw proberen";
  var Cancel$3 = "Annuleren";
  var Next$3 = "Volgende";
  var Go$3 = "Volgende";
  var Close$2 = "Afsluiten";
  var Done$3 = "Gereed";
  var Choose$3 = "Selecteer";
  var Code$3 = "Code";
  var Finish$3 = "Afwerking";
  var Copy$3 = "Kopiëren";
  var Print$3 = "Afdrukken";
  var nlNL = {
    "Email Address (Thomson Reuters ID)": "E-mailadres (Thomson Reuters ID)",
    "Sign in with your Thomson Reuters ID": "Meld u aan met uw Thomson Reuters ID",
    "Your Thomson Reuters ID is the email address you use to sign in to your Onvio and/or CS Web (cs.thomsonreuters.com) accounts.": "Uw Thomson Reuters ID is het e-mailadres dat u gebruikt om u aan te melden bij uw Onvio- en / of CS Web-account (cs.thomsonreuters.com).",
    "Sign in with your NetStaff CS account": "Meld u aan met uw NetStaff CS account",
    Password: Password$3,
    "Reset Password": "Wachtwoord Resetten",
    "Manage Account": "Account beheren",
    "CS Professional Suite Security Help": "Helpfunctie Beveiliging CS Professional Suite",
    "Need an account? Contact your administrator": "Heeft u een account nodig? Neem contact op met uw beheerder",
    "ONVIO Sign In Security Help": "Helpfunctie Beveiliging ONVIO Inloggen",
    "Need an account? Please create a new account": "Heeft u een account nodig? Maak een nieuw account aan",
    "Internet Access Required": "Internetverbinding vereist",
    "To help protect the confidential data belonging to your firm and your clients and to comply with new IRS requirements, Thomson Reuters is adding usernames and passwords to access our Tax &amp; Accounting products.": "Om de vertrouwelijke gegevens van uw kantoor en uw klanten te helpen beschermen en ter naleving van de nieuwe IRS-vereisten, voegt Thomson Reuters gebruikersnamen en wachtwoorden toe om toegang te krijgen tot onze Belasting &amp; Boekhouding producten.",
    "To sign in, please connect this computer to the internet then restart the application.": "Om in te loggen, verbind deze computer met het internet en herstart de toepassing.",
    "Learn more about these new security measures.": "Meer informatie over deze nieuwe beveiligingsmaatregelen.",
    "For your firm to access this software, one of your firm's administrators needs to upgrade your accounts at <a href=\"<%= cswebHost %>/myaccount\" target=\"_blank\">cs.thomsonreuters.com/myaccount</a>.": "Om voor uw kantoor toegang te krijgen tot deze software, dient een van uw kantoorbeheerders uw accounts te upgraden voor <a href=\"<%= cswebHost %>/myaccount\" target=\"_blank\">cs.thomsonreuters.com/myaccount</a>.",
    "Learn More About New Security Measures": "Meer Informatie Over Nieuwe Beveiligingsmaatregelen",
    "Please enter your email address.": "Voer uw e-mailadres in.",
    "Please enter your login and email address.": "Voer uw login en e-mailadres in.",
    Back: Back$3,
    "Reset My Password": "Reset mijn wachtwoord",
    "Instructions for resetting your password have been sent to your registered email address.": "Instructies voor het resetten van uw wachtwoord zijn naar uw geregistreerde e-mailadres verzonden.",
    "Go To Sign In": "Ga naar inloggen",
    "Please create a new password that meets <a id=\"trta1-toggle-pwd-requirements\" href=\"javascript:void(0)\">requirements</a>.": "Maak een nieuw wachtwoord dat voldoet aan de <a id=\"trta1-toggle-pwd-requirements\" href=\"javascript:void(0)\">wensen</a>.",
    "Your password has expired. Please create a new one that meets <a id=\"trta1-toggle-expired-pwd-requirements\" href=\"javascript:void(0)\">requirements</a>.": "Je wachtwoord is verlopen. Maak een nieuwe die voldoet aan de <a id=\"trta1-toggle-expired-pwd-requirements\" href=\"javascript:void(0)\">wensen</a>.",
    "Your password <strong>must</strong> have <span>at least 8 characters</span> including all of the following:": "Uw wachtwoord <strong>moet</strong> minstens <span>8 tekens</span> met inbegrip van alle van de volgende:",
    "At least 1 uppercase letter (A-Z)": "Ten minste 1 hoofdletter (A-Z)",
    "At least 1 lowercase letter (a-z)": "Ten minste 1 kleine letter (a-z)",
    "At least 1 digit (0-9)": "Ten minste 1 getal (0-9)",
    "At least 1 symbol (e.g. ! @ # $ % ^ &amp; *)": "Ten minste 1 symbool (e.g. ! @ # $ % ^ &amp; *)",
    "Your password should <strong>not</strong> use:": "Uw wachtwoord moet <strong>niet</strong> bevatten:",
    "Leading or trailing spaces": "Spaties ervoor of erna",
    "Words from the dictionary": "Woorden uit het woordenboek",
    "Your user ID": "Uw gebruikers-ID",
    "Sequential letters or numbers such as \"abc\" or \"123\"": "Opeenvolgende letters of getallen zoals \"abc\" or \"123\"",
    "Show typing": "Typen tonen",
    "Hide typing": "Typen verbergen",
    "New Password": "Nieuw wachtwoord",
    "Confirm New Password": "Bevestig nieuw wachtwoord",
    "Change My Password": "Wijzig mijn wachtwoord",
    "You've successfully changed your password.": "U hebt uw wachtwoord met succes gewijzigd.",
    OK: OK$3,
    "Your password needs to be updated. Please <a href=\"<%= netfirmWebHost %>\" target=\"_blank\"> log in</a> and change your password.": "Uw wachtwoord moet worden bijgewerkt. Gelieve <a href=\"<%= netfirmWebHost %>\" target=\"_blank\">inloggen</a> en uw wachtwoord te wijzigen.",
    "Back To Sign In": "Terug Naar Inloggen",
    "Unlocking your account.": "Bezig met het ontgrendelen van uw account.",
    "Your password will expire soon": "Uw wachtwoord zal binnenkort vervallen",
    "Your password will expire in <em id=\"trta1-pwdexpdays\">2</em> days.": "Uw wachtwoord zal verlopen in <em id=\"trta1-pwdexpdays\">2</em> dagen.",
    "Your password will expire in <em>1</em> day.": "Uw wachtwoord vervalt over <em>1</em> dag.",
    "Your password will expire <em>today</em>.": "Uw wachtwoord vervalt <em>vandaag</em>.",
    "Do you want to change it now?": "Wilt u het nu wijzigen?",
    "Change my password": "Wijzig mijn wachtwoord",
    "Do it later": "Doe het later",
    "Your session is ending soon": "Uw sessie zal spoedig vervallen",
    "Your session will end in:": "Your session will end in:",
    Reset: Reset$3,
    "Multi-factor authentication required": "Multi-factor authenticatie is vereist",
    "Your firm now requires all staff and administrators to sign in with multi-factor authentication.": "Uw kantoor vereist nu dat alle personeelsleden en beheerders inloggen met multi-factor authenticatie.",
    "You need to set up multi-factor authentication before continuing.": "U dient multi-factor authenticatie in te stellen voordat u verder gaat.",
    "Set Up Now": "Stel Nu In",
    "Finding your paired device.": "Zoeken naar uw gekoppelde apparaat.",
    Retry: Retry$3,
    "Notifying your paired device.": "Bezig met het sturen van een melding naar uw gekoppelde apparaat.",
    "Check your device!": "Controleer uw apparaat!",
    "Approve your request<br> in the Thomson Reuters Authenticator app": "Uw verzoek goedkeuren<br> in de Thomson Reuters Authenticator app",
    "Didn't get a notification? <a href=\"javascript:void(0)\" data-trta1-dest=\"trta1-mfa-choosedevice\">Resend it</a> or <a href=\"javascript:void(0)\" data-trta1-dest=\"trta1-mfa-approvecode\">enter a code</a>": "Geen melding ontvangen? <a href=\"javascript:void(0)\" data-trta1-dest=\"trta1-mfa-choosedevice\">Stuur melding opnieuw</a> of <a href=\"javascript:void(0)\" data-trta1-dest=\"trta1-mfa-approvecode\">voer code in</a>",
    "No phone? Contact your firm's administrator": "Geen telefoon? Neem contact op met uw kantoorbeheerder",
    "Cancel Request": "Verzoek annuleren",
    "Didn't get a notification? <a href=\"javascript:void(0)\" data-trta1-dest=\"trta1-mfa-choosedevice\">Resend it</a> or": "Geen melding ontvangen? <a href=\"javascript:void(0)\" data-trta1-dest=\"trta1-mfa-choosedevice\">Stuur melding opnieuw</a> of",
    "Enter code": "Code invoeren",
    "Retrieving authentication token.": "Bezig met het ophalen van authenticatietoken.",
    "Success!": "Succes!",
    "You've been authenticated.": "U bent geauthenticeerd.",
    "Please wait while we sign you into your account…": "Even geduld tewijl wij u inloggen op uw account…",
    "Multifactor authentication is currently unavailable.": "Multifactor authenticatie is op dit moment niet beschikbaar.",
    "Thomson Reuters": "Thomson Reuters",
    "You are using an <strong>outdated</strong> browser. Please upgrade your browser to improve security.": "U gebruikt een <strong>verouderde</strong> browser. Upgrade uw browser om de bescherming te verbeteren.",
    "Multi-factor Authentication Setup": "Multi-factor Authenticatie Instellen",
    "<strong>Increase security for your account</strong> Passwords can be hacked, but using multi-factor authentication adds another layer of security to your account.": "<strong>Verbeter de beveiliging van uw account</strong> Wachtwoorden kunnen worden gestolen, en multi-factor authenticatie voegt een extra beveiligingslaag toe aan uw account.",
    "<strong>How long will it take to set up?</strong> Minutes.": "<strong>Hoe lang duurt het om dit in te stellen?</strong> Minuten.",
    "<strong>How will this affect me?</strong> You will need to approve each sign in request on your smartphone once a day and after each time you log out.": "<strong>Welke consequenties heeft dit voor mij?</strong> U dient elk inlogverzoek op uw smartphone één keer per dag goed te keuren, en elke keer nadat u bent uitgelogd.",
    Cancel: Cancel$3,
    "Get Started": "Aan de slag",
    "Install the Thomson Reuters Authenticator app on your smartphone or tablet.": "Installeer de Thomson Reuters Authenticator app op uw smartphone of tablet.",
    "Download on the Apple App Store": "Downloaden in de Apple App Store",
    "Get it on Google Play": "Downloaden via Google Play",
    Next: Next$3,
    "Generating QR code.": "Bezig met het genereren van de QR-code.",
    "Open the Thomson Reuters Authenticator app and scan the QR code below.": "Open de Thomson Reuters Authenticator app en scan de hieronder vermelde QR-code hieronder.",
    "Retrieving device info.": "Bezig met het ophalen van apparaatgegevens.",
    "You have paired your account with <strong id=\"trta1-mfs-devicename\">this device</strong>. You will need to approve each sign in request on this device once a day and after each time you log out.": "U hebt uw account gekoppeld aan <strong id=\"trta1-mfs-devicename\">dit apparaat</strong>. U dient elke inlogpoging op dit apparaat eenmaal per dag en na elke keer dat u uitlogt goed te keuren.",
    "Got It": "Begrepen",
    "Please wait…": "Even geduld…",
    "Enter your authentication code": "Voer uw authenticatiecode in",
    "Invalid code. Please enter a valid authentication code.": "Ongeldige code. Voer een geldige authenticatiecode in.",
    "Enter the code provided by your adminstrator": "Voer de door uw beheerder verstrekte code in",
    "Set up your mobile device": "Stel uw mobiele apparaat in",
    "Password must be a minimum of 8 characters and contain at least one uppercase letter, one lowercase letter, one digit, and one symbol, with no leading or trailing spaces.": "Wachtwoord moet minimaal 8 tekens bevatten en tenminste één hoofdletter, een kleine letter, een cijfer en een symbool bevatten, zonder voor- of achterliggende spaties.",
    "Incorrect Email Address or Password. Please try again.": "Incorrect e-mailadres of wachtwoord. Probeer het opnieuw.",
    "Too many sign in attempts. Please check for unlock email or try later.": "Te veel aanmeldpogingen. Controleer voor ontvangst van een ontgrendel e-mail of probeer het later.",
    "Please change your password.": "Wijzig alstublieft uw wachtwoord.",
    "Please complete the required fields.": "Vul alstublieft de vereiste velden in.",
    "Deactivated account. Contact your administrator or accountant.": "Uw account is gedeactiveerd. Neem contact op met uw beheerder.",
    "There was an error sending the email. Please try again.": "Er is een fout opgetreden bij het versturen van de e-mail. Probeer het opnieuw.",
    "Please choose a password you have not already used.": "Kies alstublieft een wachtwoord dat u nog niet hebt gebruikt.",
    "Your account has been unlocked.": "Uw account is ontgrendeld.",
    "You've been signed out due to inactivity. Sign in to resume.": "Je bent uitgelogd vanwege inactiviteit. Log in om door te gaan.",
    "You've exceeded maximum usage time. Please sign in again.": "U heeft de maximale gebruikstijd overschreden. Log opnieuw in.",
    "Incorrect Login or Password. Please try again.": "Onjuiste gebruikersnaam of wachtwoord. Probeer het opnieuw.",
    "Missing data required to reset password. Please try again.": "Ontbrekende gegevens die nodig zijn om wachtwoord te resetten. Probeer het opnieuw.",
    "Missing data required to unlock account. Please try again.": "Ontbrekende gegevens die nodig zijn om het account te ontgrendelen. Probeer het opnieuw.",
    "Timed out waiting for device approval. Resend notification or enter code.": "Wachten op apparaat goedkeuring time-out. Stuur melding opnieuw of voer code in.",
    "Invalid code. Please try again.": "Ongeldige code. Probeer het opnieuw.",
    "Passwords Don't Match": "Wachtwoorden komen niet overeen",
    "Please wait.": "Even geduld aub.",
    "An unexpected error occurred. Please try again.": "Er is een onverwachte fout opgetreden. Probeer het opnieuw.",
    "An unexpected error occurred while redirecting your request.": "Er is een onverwachte fout opgetreden tijdens het doorverwijzen van uw aanvraag.",
    "The server did not respond in time. Please try again.": "De server reageerde niet op tijd. Probeer het opnieuw.",
    "An error occurred with your request. Please try again.": "Er is een fout opgetreden bij uw aanvraag. Probeer het opnieuw.",
    "Please provide a valid {{label}}.": "Geef een geldige {{label}} op.",
    "{{label}} is required.": "{{label}} is verplicht.",
    "Timed out waiting for scan. Please go back and try again.": "Wachten op scan timed-out. Ga terug en probeer het opnieuw.",
    "Your account is locked. Please contact your administrator.": "Uw account is geblokkeerd. Neem contact op met uw beheerder.",
    Go: Go$3,
    "Sorry, there was an issue on our end. Please try again.": "Sorry, was er een probleem aan onze kant. Probeer het opnieuw.",
    "Your registration link has expired. Please contact the firm for a new one.": "Uw registratielink is vervallen. Neem contact op met uw kantoor voor een nieuwe.",
    "Make your account even more secure!": "Maak uw account nog veiliger!",
    "Add an additional level of security in case your password is ever compromised. Confirm your identity using your mobile device.": "Voeg een extra beveiligingsniveau toe voor het geval dat uw wachtwoord ooit gecompromitteerd raakt. Bevestig uw identiteit met behulp van uw mobiele apparaat.",
    "Learn more about multi-factor authentication.": "Meer informatie over multi-factor authenticatie.",
    "Remind Me Later": "Herinner Me Later",
    Close: Close$2,
    Done: Done$3,
    "Update Password": "Wachtwoord Updaten",
    "Please enter your email address to update your password.": "Vul uw e-mailadres in om uw wachtwoord te updaten.",
    "Sign In": "Inloggen",
    "Please provide a valid password.": "Voer een geldig wachtwoord in.",
    "Password contains prohibited characters.": "Wachtwoord bevat verboden tekens.",
    "Password is too similar to a common or blacklisted password.": "Dit wachtwoord lijkt te veel op een gemeen of op de zwarte lijst gezet wachtwoord.",
    "Ignore warning": "Waarschuwing negeren",
    "Your browser is not supported for use with this application. Please try again using the latest version of one of the following browsers.": "Uw browser wordt niet ondersteund voor gebruik met deze applicatie. Probeer het opnieuw met de nieuwste versie van een van de volgende browsers.",
    "Using a browser that’s no longer supported by the vendor is a security risk. Click one of the links below to upgrade to a current browser.": "Het gebruik van een browser die niet meer door de leverancier wordt ondersteund, is een beveiligingsrisico. Klik op een van de onderstaande links om een upgrade naar een huidige browser uit te voeren.",
    "Your Browser is Outdated": "Uw browser is verouderd",
    "A few minutes.": "Een paar minuten?",
    "After installing and opening the app, click Next.": "Klik na het installeren en openen van de app op Volgende.",
    Choose: Choose$3,
    "Choose multi-factor option": "Kies een multi-factor optie",
    Code: Code$3,
    "Download and install Thomson Reuters Authenticator app": "Download en installeer de app Thomson Reuters Authenticator",
    "Download and install an alternate multi-factor app": "Download en installeer een alternatieve multi-factor-app",
    "Enter the authentication code displayed by the Authenticator app.": "Voer de verificatiecode in die wordt weergegeven door de Authenticator-app.",
    "Enter the code displayed by your alternate multi-factor app.": "Voer de code in die wordt weergegeven door uw alternatieve multi-factor app.",
    Finish: Finish$3,
    "For your firm to access this software, one of your firm's administrators needs to upgrade your accounts at <a target=\"_blank\" rel=\"noopener\" href=\"<%= cswebHost %>/myaccount\">cs.thomsonreuters.com/myaccount</a>.": "Voor uw bedrijf om toegang tot deze software te krijgen, moet een van de beheerders van uw bedrijf uw accounts upgraden op <a target=\"_blank\" rel=\"noopener\" href=\"<%= cswebHost %>/myaccount\">cs.thomsonreuters.com/myaccount</a>.",
    "How long will it take to set up?": "Hoe lang duurt het om dit in te stellen?",
    "How will this affect me?": "Welke consequenties heeft dit voor mij?",
    "Increase security for your account": "Verhoog de beveiliging voor uw account",
    "Invalid value entered.": "Ongeldige waarde ingevoerd.",
    "Learn more about third-party MFA apps": "Meer informatie over MFA-apps van derden",
    "Learn which MFA option is right for you": "Ontdek welke MFA-optie voor u geschikt is",
    "My Multi-Factor App": "Mijn Multi-Factor-app",
    "Name this multi-factor option": "Noem deze multi-factoroptie",
    "Need an account? Contact your administrator.": "Heeft u een account nodig? Neem contact op met uw beheerder.",
    "Need an account? Create one now.": "Heeft u een account nodig? Maak deze nu aan.",
    "Next steps after setting up MFA": "Volgende stappen na het instellen van MFA",
    "On your mobile device, open the app store and download and install the <b>Thomson Reuters Authenticator</b> app.": "Open de app store op uw mobiele apparaat en download en installeer de app <b>Thomson Reuters Authenticator</b>.",
    "Open the <b>Thomson Reuters Authenticator app</b> on your mobile device and point your device's camera at your monitor to scan the code below.": "Open de <b>Thomson Reuters Authenticator-app</b> op uw mobiele apparaat en richt de camera van uw apparaat op uw monitor om de onderstaande code te scannen.",
    "Pairing Successful!": "koppeling was succesvol.",
    "Passwords can be hacked, but using multi-factor authentication adds another layer of security to your account.": "Verbeter de beveiliging van uw account Wachtwoorden kunnen worden gestolen, en multi-factor authenticatie voegt een extra beveiligingslaag toe aan uw account.",
    "Receive notifications on your mobile device and sign in with a single touch.": "Ontvang meldingen op uw mobiele apparaat en log in met één aanraking.",
    "Registering your device.": "Uw apparaat registreren.",
    "Scan Code": "scancode",
    "Step 1": "Stap 1",
    "Step 2": "Stap 2",
    "Tell me how": "Vertel me hoe",
    "The alternate method must be time-based one time password (TOTP) compliant. Download now at the <a target=\"_blank\" rel=\"noopener\" href=\"https://itunes.apple.com/<%= appleStoreCountryCode %>/app/thomson-reuters-authenticator/id1155604687?mt=8&amp;l=<%= appleStoreLangCode %>\">Apple App Store</a> or the <a target=\"_blank\" rel=\"noopener\" href=\"https://play.google.com/store/apps/details?id=com.thomsonreuters.trta.authenticator&amp;pcampaignid=MKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1&amp;hl=<%= googleStoreLangCode %>\">Google Play Store</a>.": "De alternatieve methode moet op tijd gebaseerd eenmalig wachtwoord (TOTP) zijn. Download nu op de <a target=\"_blank\" rel=\"noopener\" href=\"https://itunes.apple.com/<%= appleStoreCountryCode %>/app/thomson-reuters-authenticator/id1155604687?mt=8&amp;l=<%= appleStoreLangCode %>\">Apple App Store</a> of <a target=\"_blank\" rel=\"noopener\" href=\"https://play.google.com/store/apps/details?id=com.thomsonreuters.trta.authenticator&amp;pcampaignid=MKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1&amp;hl=<%= googleStoreLangCode %>\">Google Play Store</a>.",
    "This option requires you to enter a code each time you sign in.": "Voor deze optie moet u elke keer dat u inlogt een code invoeren.",
    "Thomson Reuters Authenticator": "Thomson Reuters Authenticator",
    "Use Thomson Reuters Authenticator (recommended)": "Gebruik Thomson Reuters Authenticator (aanbevolen)",
    "Use a third-party multi-factor app": "Gebruik een multi-factor app van derden",
    "Use your alternate multi-factor app to scan the code below.": "Gebruik uw alternatieve multi-factor app om de onderstaande code te scannen.",
    "Validate your alternate multi-factor app": "Valideer uw alternatieve multi-factor-app",
    "You can use Thomson Reuters Authenticator (recommended), or a different multi-factor app.": "U kunt Thomson Reuters Authenticator gebruiken (aanbevolen) of een andere app met meerdere factoren.",
    "You have set up multi-factor authentication for your account. You will need to approve each sign-in request on your device each time you sign in with this account.": "U hebt multi-factor authenticatie voor uw account ingesteld. U moet elk aanmeldingsverzoek op uw apparaat goedkeuren telkens wanneer u inlogt met dit account.",
    "You will need to approve each sign-in request on your device each time you sign in with this account.": "U moet elk aanmeldingsverzoek op uw apparaat goedkeuren telkens wanneer u inlogt met dit account.",
    "Your password needs to be updated. Please <a target=\"_blank\" rel=\"noopener\" href=\"<%= netfirmWebHost %>\">log in</a> and change your password.": "Uw wachtwoord moet worden bijgewerkt. Gelieve <a target=\"_blank\" rel=\"noopener\" href=\"<%= netfirmWebHost %>\">in te loggen</a> en uw wachtwoord te wijzigen.",
    Copy: Copy$3,
    "Emergency Access Codes": "Noodtoegangscodes",
    "Emergency codes copied to the clipboard for pasting to a safe place.": "Noodcodes gekopieerd naar het klembord om op een veilige plek te plakken.",
    "Generating emergency codes.": "Alarmcodes genereren.",
    "If you lose access to your mobile device, you can use one of these emergency codes to sign in to your account. Each code may be used only once.": "Als u de toegang tot uw mobiele apparaat verliest, kunt u een van deze noodcodes gebruiken om u aan te melden bij uw account. Elke code mag slechts één keer worden gebruikt.",
    "Missing firmId parameter.": "Ontbrekende firmId-parameter.",
    "Multi-Factor Authentication Setup": "Multi-factor Authenticatie Instellen",
    Print: Print$3,
    "These codes are like the key to your office - keep them in a safe place only you can access!": "Deze codes zijn als de sleutel tot uw kantoor - bewaar ze op een veilige plek die alleen toegankelijk is voor u!",
    "Use one of these codes when this device is inaccessible. Print or save the codes to a secure location. Each code can only be used once, but more codes can be generated in your account profile.": "Gebruik een van deze codes wanneer dit apparaat niet toegankelijk is. Druk de codes af of sla ze op naar een veilige locatie. Elke code kan slechts één keer worden gebruikt, maar er kunnen meer codes in uw accountprofiel worden gegenereerd.",
    "You can generate more codes by signing in and accessing your profile.": "U kunt meer codes genereren door u aan te melden en toegang te krijgen tot uw profiel.",
    "Error copying emergency codes to the clipboard.": "Fout bij het kopiëren van noodcodes naar het klembord.",
    "Enter the authentication code displayed by your multi-factor device or provided to you.": "Voer de verificatiecode in die wordt weergegeven door uw multi-factor apparaat of aan u wordt verstrekt.",
    "Open the <b>Thomson Reuters Authenticator</b> app on your mobile device and point your device's camera at your monitor to scan the code below.": "Open de app <b>Thomson Reuters Authenticator</b> op uw mobiele apparaat en richt de camera van uw apparaat op uw monitor om de onderstaande code te scannen.",
    "You have set up the following multi-factor methods:": "U hebt de volgende multifactormethoden ingesteld:"
  };

  var Password$4 = "Senha";
  var Back$4 = "Voltar";
  var OK$4 = "OK";
  var Reset$4 = "Redefinir";
  var Retry$4 = "Tentar novamente";
  var Cancel$4 = "Cancelar";
  var Next$4 = "Avançar";
  var Go$4 = "Continuar";
  var Close$3 = "Fechar";
  var Done$4 = "Concluído";
  var Choose$4 = "Escolher";
  var Code$4 = "Código";
  var Finish$4 = "Finalizar";
  var Copy$4 = "Copiar";
  var Print$4 = "Imprimir";
  var or$3 = "ou";
  var Download$2 = "Download";
  var ptBR = {
    "Email Address (Thomson Reuters ID)": "Endereço de E-mail (Thomson Reuters ID)",
    "Sign in with your Thomson Reuters ID": "Logue com seu Thomson Reuters ID",
    "Your Thomson Reuters ID is the email address you use to sign in to your Onvio and/or CS Web (cs.thomsonreuters.com) accounts.": "Seu Thomson Reuters ID é o endereço de e-mail que você utiliza para logar em sua conta Onvio e/ou CS Web (cs.thomsonreuters.com).",
    "Sign in with your NetStaff CS account": "Logue com seu NetStaff CS conta",
    Password: Password$4,
    "Reset Password": "Redefinir Senha",
    "Manage Account": "Gerenciar Conta",
    "CS Professional Suite Security Help": "Ajuda sobre Segurança do CS Professional Suite",
    "Need an account? Contact your administrator": "Precisa de uma conta? Entre em contato com seu administrador",
    "ONVIO Sign In Security Help": "Ajuda sobre Segurança de Registro do ONVIO",
    "Need an account? Please create a new account": "Precisa de uma conta? Crie uma conta nova",
    "Internet Access Required": "Acesso à Internet Exigido",
    "To help protect the confidential data belonging to your firm and your clients and to comply with new IRS requirements, Thomson Reuters is adding usernames and passwords to access our Tax &amp; Accounting products.": "Para ajudar a proteger os dados confidenciais que pertencem à sua empresa e a seus clientes, e cumprir com os novos requisitos de IRS, a Thomson Reuters está adicionando nomes de usuário e senhas para acessar nossos produtos Tributários &amp; Contábeis.",
    "To sign in, please connect this computer to the internet then restart the application.": "Para se registrar, conecte este computador à Internet e, em seguida, reinicie o aplicativo.",
    "Learn more about these new security measures.": "Saiba mais sobre essas novas medidas de segurança.",
    "For your firm to access this software, one of your firm's administrators needs to upgrade your accounts at <a href=\"<%= cswebHost %>/myaccount\" target=\"_blank\">cs.thomsonreuters.com/myaccount</a>.": "Para que sua empresa acesse esse software, um dos administradores da sua empresa precisa fazer upgrade de suas contas em <a href=\"<%= cswebHost %>/myaccount\" target=\"_blank\">cs.thomsonreuters.com/myaccount</a>.",
    "Learn More About New Security Measures": "Saiba Mais sobre Novas Medidas de Segurança",
    "Please enter your email address.": "Insira seu endereço de e-mail.",
    "Please enter your login and email address.": "Insira seu login e endereço de e-mail.",
    Back: Back$4,
    "Reset My Password": "Redefinir Minha Senha",
    "Instructions for resetting your password have been sent to your registered email address.": "Instruções para a redefinição da sua senha foram enviadas para seu endereço de e-mail registrado.",
    "Go To Sign In": "Ir para Login",
    "Please create a new password that meets <a id=\"trta1-toggle-pwd-requirements\" href=\"javascript:void(0)\">requirements</a>.": "Por favor, crie uma nova senha que atenda <a id=\"trta1-toggle-pwd-requirements\" href=\"javascript:void(0)\">requisitos</a>.",
    "Your password has expired. Please create a new one that meets <a id=\"trta1-toggle-expired-pwd-requirements\" href=\"javascript:void(0)\">requirements</a>.": "Sua senha expirou. Por favor, crie uma nova que atenda <a id=\"trta1-toggle-expired-pwd-requirements\" href=\"javascript:void(0)\">requisitos</a>.",
    "Your password <strong>must</strong> have <span>at least 8 characters</span> including all of the following:": "Sua senha <strong>deve</strong> ter <span>pelo menos 8 caracteres</span>, incluindo todos os seguintes:",
    "At least 1 uppercase letter (A-Z)": "Pelo menos 1 letra maiúscula (A-Z)",
    "At least 1 lowercase letter (a-z)": "Pelo menos 1 letra minúscula (a-z)",
    "At least 1 digit (0-9)": "Pelo menos 1 dígito (0-9)",
    "At least 1 symbol (e.g. ! @ # $ % ^ &amp; *)": "Pelo menos 1 símbolo (e.g. ! @ # $ % ^ &amp; *)",
    "Your password should <strong>not</strong> use:": "Sua senha <strong>não</strong> deve conter:",
    "Leading or trailing spaces": "Espaços iniciais ou finais",
    "Words from the dictionary": "Palavras do dicionário",
    "Your user ID": "Sua identificação de usuário",
    "Sequential letters or numbers such as \"abc\" or \"123\"": "Letras ou números sequenciais como \"abc\" or \"123\"",
    "Show typing": "Exibir digitação",
    "Hide typing": "Ocultar digitação",
    "New Password": "Nova Senha",
    "Confirm New Password": "Confirmar Nova Senha",
    "Change My Password": "Alterar Minha Senha",
    "You've successfully changed your password.": "Você alterou sua senha com êxito.",
    OK: OK$4,
    "Your password needs to be updated. Please <a href=\"<%= netfirmWebHost %>\" target=\"_blank\"> log in</a> and change your password.": "Sua senha precisa ser atualizada. Por favor <a href=\"<%= netfirmWebHost %>\" target=\"_blank\">login</a> e altere sua senha.",
    "Back To Sign In": "Retornar ao Login",
    "Unlocking your account.": "Desbloqueio da sua conta.",
    "Your password will expire soon": "Sua senha expirará em breve",
    "Your password will expire in <em id=\"trta1-pwdexpdays\">2</em> days.": "Sua senha expirará em <em id=\"trta1-pwdexpdays\">2</em> dias.",
    "Your password will expire in <em>1</em> day.": "Sua senha expirará em <em>1</em> dia.",
    "Your password will expire <em>today</em>.": "Sua senha expirará <em>hoje</em>.",
    "Do you want to change it now?": "Deseja alterá-la agora?",
    "Change my password": "Alterar minha senha",
    "Do it later": "Fazer isso depois",
    "Your session is ending soon": "Sua sessão será encerrada em breve",
    "Your session will end in:": "Your session will end in:",
    Reset: Reset$4,
    "Multi-factor authentication required": "Autenticação multifatores exigida",
    "The firm requires you to enable multi-factor authentication before signing in. Please complete the multi-factor authentication setup wizard to continue.": "O escritório exige que você habilite a autenticação multi-fatores antes de fazer login. Por favor, complete o assistente de configuração de autenticação multi-fatores para continuar.",
    "Set Up Now": "Configurar Agora",
    "Finding your paired device.": "Localização do seu dispositivo emparelhado.",
    Retry: Retry$4,
    "Notifying your paired device.": "Notificar seu dispositivo emparelhado.",
    "Check your device!": "Verifique seu dispositivo!",
    "Approve your request<br> in the Thomson Reuters Authenticator app": "Aprovar sua solicitação<br> no aplicativo Thomson Reuters Authenticator",
    "Didn't get a notification? <a href=\"javascript:void(0)\" data-trta1-dest=\"trta1-mfa-choosedevice\">Resend it</a> or <a href=\"javascript:void(0)\" data-trta1-dest=\"trta1-mfa-approvecode\">enter a code</a>": "Não recebeu uma notificação? <a href=\"javascript:void(0)\" data-trta1-dest=\"trta1-mfa-choosedevice\">Reenvie a notificação</a> ou <a href=\"javascript:void(0)\" data-trta1-dest=\"trta1-mfa-approvecode\">insira o código</a>",
    "No phone? Contact your firm's administrator": "Está sem telefone? Entre em contato com o administrador da empresa",
    "Cancel Request": "Cancelar Solicitação",
    "Didn't get a notification? <a href=\"javascript:void(0)\" data-trta1-dest=\"trta1-mfa-choosedevice\">Resend it</a> or": "Não recebeu uma notificação? <a href=\"javascript:void(0)\" data-trta1-dest=\"trta1-mfa-choosedevice\">Reenvie a notificação</a> ou",
    "Enter code": "Inserir código",
    "Retrieving authentication token.": "Recuperação do token de autenticação.",
    "Success!": "Sucesso!",
    "Continue to sign in page": "Continuar para a página de cadastro",
    "https://onvio.us/ua/help/us-en/staff/core/setup/thomson-reuters-account.htm": "https://onvio.us/ua/help/us-en/staff/core/setup/thomson-reuters-account.htm",
    "You've been authenticated.": "Você foi autenticado.",
    "Please wait while we sign you into your account…": "Espere enquanto registramos você em sua conta...",
    "Multifactor authentication is currently unavailable.": "No momento, a autenticação multifatores está indisponível.",
    "Thomson Reuters": "Thomson Reuters",
    "You are using an <strong>outdated</strong> browser. Please upgrade your browser to improve security.": "Você está usando um navegador <strong>desatualizado</strong>. Por favor, atualize seu navegador para aprimorar a segurança.",
    "Multi-factor Authentication Setup": "Configuração da Autenticação Multifatores",
    "<strong>Increase security for your account</strong> Passwords can be hacked, but using multi-factor authentication adds another layer of security to your account.": "<strong>Aumente a segurança da sua conta</strong> Senhas podem ser hackeadas, mas o uso da autenticação multifatores acrescenta outra camada de segurança à sua conta.",
    "<strong>How long will it take to set up?</strong> Minutes.": "<strong>Quanto tempo demorará para configurar?</strong> Minutos.",
    "<strong>How will this affect me?</strong> You will need to approve each sign in request on your smartphone once a day and after each time you log out.": "<strong>Como isso irá me afetar?</strong> Você precisará aprovar cada solicitação de login em seu smartphone uma vez por dia e depois de cada logout.",
    Cancel: Cancel$4,
    "Get Started": "Iniciar",
    "Install the Thomson Reuters Authenticator app on your smartphone or tablet.": "Instale o aplicativo Thomson Reuters Authenticator em seu smartphone ou tablet.",
    "Download on the Apple App Store": "Fazer Download na Apple App Store",
    "Get it on Google Play": "Obtê-lo no Google Play",
    Next: Next$4,
    "Generating QR code.": "Geração do código QR.",
    "Open the Thomson Reuters Authenticator app and scan the QR code below.": "Abra o aplicativo Thomson Reuters Authenticator e digitalize o código QR abaixo.",
    "Retrieving device info.": "Recuperação das informações do dispositivo.",
    "You have paired your account with <strong id=\"trta1-mfs-devicename\">this device</strong>. You will need to approve each sign in request on this device once a day and after each time you log out.": "Você emparelhou sua conta com <strong id=\"trta1-mfs-devicename\">nesse dispositivo</strong>. Você precisará aprovar cada solicitação de login nesse dispositivo uma vez por dia e depois de cada vez que você desconectar.",
    "Got It": "Entendi",
    "Please wait…": "Aguarde...",
    "Enter your authentication code": "Insira seu código de autenticação",
    "Invalid code. Please enter a valid authentication code.": "Código inválido. Insira um código de autenticação válido.",
    "Enter the code provided by your adminstrator": "Inserir o código fornecido pelo seu administrador",
    "Set up your mobile device": "Configurar seu dispositivo móvel",
    "Password must be a minimum of 8 characters and contain at least one uppercase letter, one lowercase letter, one digit, and one symbol, with no leading or trailing spaces.": "A senha deve ter um mínimo de 8 caracteres e conter pelo menos uma letra maiúscula, uma letra minúscula, um dígito e um símbolo, sem espaços no conteúdo.",
    "Incorrect Email Address or Password. Please try again.": "Endereço de email ou senha incorretos. Por favor, tente novamente.",
    "Too many sign in attempts. Please check for unlock email or try later.": "Muitas tentativas de login. Verifique se há e-mail de desbloqueio ou tente mais tarde.",
    "Please change your password.": "Por favor, altere sua senha.",
    "Please complete the required fields.": "Complete os campos obrigatórios.",
    "Deactivated account. Contact your administrator or accountant.": "Conta desativada. Contate o usuário administrador ou seu contador.",
    "There was an error sending the email. Please try again.": "Ocorreu um erro ao enviar o e-mail. Por favor, tente novamente.",
    "Please choose a password you have not already used.": "Escolha uma senha que você ainda não usou.",
    "Your account has been unlocked.": "Sua conta foi desbloqueada.",
    "You've been signed out due to inactivity. Sign in to resume.": "Você foi desconectado devido à inatividade. Faça login para continuar.",
    "You've exceeded maximum usage time. Please sign in again.": "Você excedeu o tempo máximo de uso. Faça login novamente.",
    "Incorrect Login or Password. Please try again.": "Login ou senha incorretos. Por favor, tente novamente.",
    "Missing data required to reset password. Please try again.": "Faltam dados obrigatórios para redefinir a senha. Por favor, tente novamente.",
    "Missing data required to unlock account. Please try again.": "Faltam dados obrigatórios para desbloquear sua conta. Por favor, tente novamente.",
    "Timed out waiting for device approval. Resend notification or enter code.": "Tempo de espera esgotado para aprovação do dispositivo. Reenvie a notificação ou insira o código.",
    "Invalid code. Please try again.": "Código inválido. Por favor, tente novamente.",
    "Passwords Don't Match": "As senhas não coincidem",
    "Please wait.": "Por favor, espere.",
    "An unexpected error occurred. Please try again.": "Um erro inesperado ocorreu. Por favor, tente novamente.",
    "An unexpected error occurred while redirecting your request.": "Ocorreu um erro inesperado ao redirecionar sua solicitação.",
    "The server did not respond in time. Please try again.": "O servidor não respondeu a tempo. Por favor, tente novamente.",
    "An error occurred with your request. Please try again.": "Ocorreu um erro com sua solicitação. Por favor, tente novamente.",
    "Please provide a valid {{label}}.": "Forneça um {{label}} válido.",
    "{{label}} is required.": "{{label}} é requerido.",
    "Timed out waiting for scan. Please go back and try again.": "Tempo de espera esgotado para varredura. Por favor volte e tente novamente.",
    "Your account is locked. Please contact your administrator.": "Sua conta foi bloqueada. Entre em contato com o administrador.",
    Go: Go$4,
    "Sorry, there was an issue on our end. Please try again.": "Desculpe, ocorreu um problema do nosso lado. Por favor, tente novamente.",
    "Your registration link has expired. Please contact the firm for a new one.": "Seu link de registro expirou. Entre em contato com a firma para obter um novo.",
    "Make your account even more secure!": "Torne sua conta ainda mais segura!",
    "Add an additional level of security in case your password is ever compromised. Confirm your identity using your mobile device.": "Adicione um nível extra de segurança para caso sua senha seja comprometida. Confirme a sua identidade usando seu dispositivo móvel.",
    "Learn more about multi-factor authentication.": "Saiba mais sobre a autenticação de dois fatores.",
    "Remind Me Later": "Lembrar Mais Tarde",
    Close: Close$3,
    Done: Done$4,
    "Update Password": "Atualizar Senha",
    "Please enter your email address to update your password.": "Por favor, informe seu endereço de e-mail para atualizar sua senha.",
    "Sign In": "Entrar",
    "Please provide a valid password.": "Forneça uma senha válida.",
    "Password contains prohibited characters.": "A senha contém caracteres proibidos.",
    "Password is too similar to a common or blacklisted password.": "Esta senha é muito comum ou considerada como insegura.",
    "Ignore warning": "Ignorar aviso",
    "Your browser is not supported for use with this application. Please try again using the latest version of one of the following browsers.": "Seu navegador não é compatível para uso desta aplicação. Por favor, tente novamente usando a versão mais recente de um dos navegadores seguintes.",
    "Using a browser that’s no longer supported by the vendor is a security risk. Click one of the links below to upgrade to a current browser.": "Utilizar um navegador que não possui mais suporte pelo fornecedor é um risco a segurança. \n Clique em um dos links abaixo para atualizar para um navegador atual.",
    "Your Browser is Outdated": "Seu navegador está desatualizado",
    "A few minutes.": "Em alguns minutos",
    "After installing and opening the app, click Next.": "Depois de instalar e abrir o aplicativo, clique em Avançar.",
    Choose: Choose$4,
    "Choose multi-factor option": "Escolha a opção multi-fatores",
    Code: Code$4,
    "Download and install Thomson Reuters Authenticator app": "Baixe e instale o aplicativo Thomson Reuters Authenticator",
    "Download and install an alternate multi-factor app": "Baixe e instale um aplicativo de autentificação multi-fatores alternativo",
    "Enter the authentication code displayed by the Authenticator app.": "Digite o código de autenticação exibido pelo aplicativo Authenticator.",
    "Enter the code displayed by your alternate multi-factor app.": "Digite o código exibido pelo seu aplicativo multi-fatores alternativo.",
    Finish: Finish$4,
    "For your firm to access this software, one of your firm's administrators needs to upgrade your accounts at <a target=\"_blank\" rel=\"noopener\" href=\"<%= cswebHost %>/myaccount\">cs.thomsonreuters.com/myaccount</a>.": "Para sua empresa acessar esse software, um dos administradores do seu escritório precisa fazer a atualização das suas contas em <a target=\"_blank\" rel=\"noopener\" href=\"<%= cswebHost %>/myaccount\">cs.thomsonreuters.com/myaccount</a>.",
    "How long will it take to set up?": "Quanto tempo demorará para configurar?",
    "How will this affect me?": "Como isso irá me afetar?",
    "Increase security for your account": "Aumentar a segurança da sua conta",
    "Invalid value entered.": "Valor inválido digitado",
    "Learn more about third-party MFA apps": "Saiba mais sobre aplicativos MFA de terceiros",
    "Learn which MFA option is right for you": "Saiba qual é a opção de MFA certa para você",
    "My Multi-Factor App": "Meu aplicativo multi-fatores",
    "Name this multi-factor option": "Nomeie esta opção multi-fatores",
    "Need an account? Contact your administrator.": "Precisa de uma conta? Entre em contato com seu administrador",
    "Need an account? Create one now.": "Precisa de uma conta? Criar uma agora",
    "Next steps after setting up MFA": "Próximas etapas após configurar o MFA",
    "On your mobile device, open the app store and download and install the <b>Thomson Reuters Authenticator</b> app.": "No seu dispositivo móvel, abra a loja de aplicativos, baixe e instale o aplicativo <b>Thomson Reuters Authenticator</b>.",
    "Open the <b>Thomson Reuters Authenticator app</b> on your mobile device and point your device's camera at your monitor to scan the code below.": "Abra o <b>aplicativo Thomson Reuters Authenticator</b> no seu dispositivo móvel e aponte a câmera do seu dispositivo para o monitor para verificar o código abaixo.",
    "Pairing Successful!": "Emparelhamento bem sucedido!",
    "Passwords can be hacked, but using multi-factor authentication adds another layer of security to your account.": "Senhas podem ser hackeadas, mas o uso da autenticação multi-fatores acrescenta outra camada de segurança à sua conta.",
    "Receive notifications on your mobile device and sign in with a single touch.": "Receba notificações no seu dispositivo móvel e faça login com um único toque.",
    "Registering your device.": "Registrando seu dispositivo.",
    "Scan Code": "Digitalizar Código QR",
    "Step 1": "Passo 1",
    "Step 2": "Passo 2",
    "Tell me how": "Me diga como",
    "The alternate method must be time-based one time password (TOTP) compliant. Download now at the <a target=\"_blank\" rel=\"noopener\" href=\"https://itunes.apple.com/<%= appleStoreCountryCode %>/app/thomson-reuters-authenticator/id1155604687?mt=8&amp;l=<%= appleStoreLangCode %>\">Apple App Store</a> or the <a target=\"_blank\" rel=\"noopener\" href=\"https://play.google.com/store/apps/details?id=com.thomsonreuters.trta.authenticator&amp;pcampaignid=MKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1&amp;hl=<%= googleStoreLangCode %>\">Google Play Store</a>.": "O método alternativo deve ser compatível geração de chaves de validação baseadas no tempo (TOTP). Faça o download agora no <a target=\"_blank\" rel=\"noopener\" href=\"https://itunes.apple.com/<%= appleStoreCountryCode %>/app/thomson-reuters-authenticator/id1155604687?mt=8&amp;l=<%= appleStoreLangCode %>\">Apple App Store</a> or the <a target=\"_blank\" rel=\"noopener\" href=\"https://play.google.com/store/apps/details?id=com.thomsonreuters.trta.authenticator&amp;pcampaignid=MKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1&amp;hl=<%= googleStoreLangCode %>\">Google Play Store</a>.",
    "This option requires you to enter a code each time you sign in.": "Essa opção exige que você insira um código toda vez que fizer login.",
    "Thomson Reuters Authenticator": "Thomson Reuters Authenticator",
    "Use Thomson Reuters Authenticator (recommended)": "Use o Thomson Reuters Authenticator (recomendado)",
    "Use a third-party multi-factor app": "Use um aplicativo de autenticação multi-fatores de terceiros",
    "Use your alternate multi-factor app to scan the code below.": "Use seu aplicativo de autenticação multi-fatores alternativo para digitalizar o código abaixo.",
    "Validate your alternate multi-factor app": "Valide seu aplicativo de autenticação multi-fatores alternativo",
    "You can use Thomson Reuters Authenticator (recommended), or a different multi-factor app.": "Você pode usar o Thomson Reuters Authenticator (recomendado) ou um aplicativo de autenticação multi-fatores diferente.",
    "You have set up multi-factor authentication for your account. You will need to approve each sign-in request on your device each time you sign in with this account.": "Você configurou a autenticação multi-fatores para sua conta. Você precisará aprovar cada solicitação de login no seu dispositivo sempre que fizer login com essa conta.",
    "You will need to approve each sign-in request on your device each time you sign in with this account.": "Você precisará aprovar cada solicitação de login no seu dispositivo sempre que fizer login com essa conta.",
    "Your password needs to be updated. Please <a target=\"_blank\" rel=\"noopener\" href=\"<%= netfirmWebHost %>\">log in</a> and change your password.": "Sua senha precisa ser atualizada. <a target=\"_blank\" rel=\"noopener\" href=\"<%= netfirmWebHost %>\">Faça login</a> e altere sua senha.",
    Copy: Copy$4,
    "Emergency Access Codes": "Códigos de acesso de emergência",
    "Emergency codes copied to the clipboard for pasting to a safe place.": "Códigos de emergência copiados da área de transferência para colar em um local seguro.",
    "Generating emergency codes.": "Gerando códigos de emergência.",
    "If you lose access to your mobile device, you can use one of these emergency codes to sign in to your account. Each code may be used only once.": "Se você perder o acesso no seu dispositivo móvel, poderá usar um desses códigos de emergência para fazer login na sua conta. Cada código pode ser usado apenas uma vez.",
    "Missing firmId parameter.": "Parâmetro de firmId ausente.",
    "Multi-Factor Authentication Setup": "Configuração da autenticação multi-fatores",
    Print: Print$4,
    "These codes are like the key to your office - keep them in a safe place only you can access!": "Esses códigos são como a chave do seu escritório - mantenha-os em um local seguro que só você pode acessar!",
    "Use one of these codes when this device is inaccessible. Print or save the codes to a secure location. Each code can only be used once, but more codes can be generated in your account profile.": "Utilize um desses códigos quando este dispositivo estiver inacessível. Imprima ou salve os códigos em um local seguro. Cada código só pode ser usado uma vez, mas mais códigos podem ser gerados no perfil da sua conta.",
    "You can generate more codes by signing in and accessing your profile.": "Você pode gerar mais códigos fazendo login e acessando seu perfil.",
    "Error copying emergency codes to the clipboard.": "Erro ao copiar códigos de emergência para a área de transferência.",
    "Enter the authentication code displayed by your multi-factor device or provided to you.": "Digite o código de autenticação exibido pelo seu dispositivo multi-fatores ou o código fornecido a você.",
    "Open the <b>Thomson Reuters Authenticator</b> app on your mobile device and point your device's camera at your monitor to scan the code below.": "Abra o aplicativo <b>Thomson Reuters Authenticator</b> no seu dispositivo móvel e aponte a câmera do seu dispositivo para o monitor para escanear o código abaixo.",
    "You have set up the following multi-factor methods:": "Você configurou os seguintes métodos de multi-fatores:",
    "Device ID": "ID do dispositivo",
    "Enter the 9-character device ID starting with the letters TR from the back of your Thomson Reuters Authenticator card.": "Digite o ID do dispositivo com 9 caracteres, começando com as letras TR na parte de trás do seu cartão do Thomson Reuters Authenticator.",
    "Enter the one-time code displayed on your multi-factor device.": "Digite o código único exibido no seu dispositivo multifator.",
    "Learn more about multi-factor devices": "Saiba mais sobre dispositivos multifator",
    "Use a multi-factor device": "Use um dispositivo multifator",
    "Use a multi-factor device like a card that displays a code to enter.": "Use um dispositivo multifator que exibe um código para inserir como um cartão.",
    "Validate your multi-factor device": "Valide seu dispositivo multifator",
    "Incorrect Device ID or Code. Please try again.": "ID ou código do dispositivo incorreto. Por favor, tente novamente.",
    "Thomson Reuters Authenticator Card": "Cartão do Thomson Reuters Authenticator",
    "Save Emergency Access Codes": "Salvar códigos de acesso de emergência",
    "Save or print these codes to a secure location for use when your primary MFA device is unavailable (e.g., if you get a new phone). You can use each code only once, but you can generate more codes in your account profile": "Salve ou imprima esses códigos em um local seguro para uso quando seu dispositivo MFA principal estiver indisponível (por exemplo, se você estiver com um novo telefone). Você pode usar cada código apenas uma vez, mas pode gerar mais códigos no perfil da sua conta",
    or: or$3,
    Download: Download$2,
    "Learn more about Emergency Access Codes": "Saiba mais sobre códigos de acesso de emergência",
    "Sign-in Help": "Ajuda de Login",
    "System Status": "Status do sistema",
    "Your Browser is not supported": "Seu navegador não é suportado",
    "To log in to Onvio, please use one of the supported internet browsers below.": "Para se conectar no Onvio, por favor utilize um dos navegadores suportados abaixo.",
    "Your firm's license is no longer active. Please contact your administrator.": "A licença do seu escritório não está mais ativa. Entre em contato com o administrador.",
    "Please enter a valid password. Your password cannot contain personal information associated with your account.": "Por favor insira uma senha válida. Sua senha não pode conter informações pessoais associados à sua conta.",
    "Your firm's license is inactive": "A licença da sua empresa está inativa",
    "Refer to <a class=\"trta1-howAndHelp-link\" target=\"_blank\" rel=\"noopener\" href=\"https://cs.thomsonreuters.com/ua/login_security/cs_us_en/mfa-troubleshooting.htm\"> Help & How To Center </a> for possible solutions": "Consulte a <a class=\"trta1-howAndHelp-link\" target=\"_blank\" rel=\"noopener\" href=\"https://cs.thomsonreuters.com/ua/login_security/cs_us_en/mfa-troubleshooting.htm\"> Ajuda e Como Centralizar </a> para possíveis soluções",
    "Acknowledge and Ignore Warning": "Reconhecer e Ignorar Aviso",
    "Contact your Onvio administrator.": "Entre em contato com o administrador do Onvio.",
    "Contact your administrator.": "Entre em contato com o administrador.",
    "Email Address": "Endereço de E-mail",
    "End of support for Windows 7, Server 2008 / 2008 R2": "Fim do suporte para Windows 7, Server 2008 / 2008 R2",
    "Let's get started": "Vamos começar",
    "Microsoft Window Server 2008 / 2008 R2 Announcement": "Comunicado do Microsoft Window Server 2008 / 2008 R2",
    "Microsoft Windows 7 Announcement": "Anúncio do Microsoft Windows 7",
    "Onvio requires two-step verification. You only have to configure this once, and it won't take long.": "O Onvio requer verificação em duas etapas. Você só tem que configurar isso uma vez, e não vai demorar muito.",
    "Password contains prohibited characters": "A senha contém caracteres proibidos",
    "Please close this window and try again.": "Feche esta janela e tente novamente.",
    "Read about account security": "Leia sobre a segurança da conta",
    "Secure your account": "Proteja a sua conta",
    "Set up two-step verification": "Configurar a verificação em duas etapas",
    "Sign back in": "Iniciar sessão novamente",
    "Sign in": "Entrar",
    "Thomson Reuters will no longer support its products on Windows 7 operating systems or Windows Server 2008 or 2008 R2 beginning January 14, 2020. We strongly urge you to upgrade any workstations or servers that require access to Thomson Reuters products to a supported operating system prior to January 14, 2020. Please find more information at the links below:": "A Thomson Reuters deixará de oferecer suporte a seus produtos em sistemas operacionais Windows 7 ou Windows Server 2008 ou 2008 R2 a partir de 14 de janeiro de 2020. Recomendamos vivamente que atualize quaisquer estações de trabalho ou servidores que necessitem de acesso aos produtos Thomson Reuters para um sistema operacional suportado antes de 14 de janeiro de 2020. Por favor, encontre mais informações nos links abaixo:",
    "View system status": "Situação do sistema",
    "You don't have access": "Você não tem acesso",
    "You're signed out": "Você está desconectado",
    "You don't have access to this product": "Você não tem acesso a este produto",
    "Select the module you wish to access and try again": "Selecione o produto que deseja acessar e tente novamente:",
    "Client Center": "Portal do Cliente",
    "Employee Portal": "Portal do Empregado"
  };

  var Back$5 = "Back";
  var Cancel$5 = "Cancel";
  var Choose$5 = "Choose";
  var Code$5 = "Code";
  var Copy$5 = "Copy";
  var Done$5 = "Done";
  var Finish$5 = "Finish";
  var Go$5 = "Go";
  var Next$5 = "Next";
  var OK$5 = "OK";
  var Password$5 = "Password";
  var Print$5 = "Print";
  var Reset$5 = "Reset";
  var Retry$5 = "Retry";
  var or$4 = "or";
  var enGB = {
    "A few minutes.": "A few minutes.",
    "Acknowledge and Ignore Warning": "Acknowledge and Ignore Warning",
    "Add an additional level of security in case your password is ever compromised. Confirm your identity using your mobile device.": "Add an additional level of security in case your password is ever compromised. Confirm your identity using your mobile device.",
    "After installing and opening the app, click Next.": "After installing and opening the app, click Next.",
    "An error occurred with your request. Please try again.": "An error occurred with your request. Please try again.",
    "An unexpected error occurred while redirecting your request.": "An unexpected error occurred while redirecting your request.",
    "An unexpected error occurred. Please try again.": "An unexpected error occurred. Please try again.",
    "Approve your request<br> in the Thomson Reuters Authenticator app": "Approve your request<br> in the Thomson Reuters Authenticator app",
    "At least 1 digit (0-9)": "At least 1 digit (0-9)",
    "At least 1 lowercase letter (a-z)": "At least 1 lowercase letter (a-z)",
    "At least 1 symbol (e.g. ! @ # $ % ^ &amp; *)": "At least 1 symbol (e.g. ! @ # $ % ^ &amp; *)",
    "At least 1 uppercase letter (A-Z)": "At least 1 uppercase letter (A-Z)",
    Back: Back$5,
    "Back To Sign In": "Back To Sign In",
    "CS Professional Suite Security Help": "CS Professional Suite Security Help",
    Cancel: Cancel$5,
    "Cancel Request": "Cancel Request",
    "Change My Password": "Change My Password",
    "Change my password": "Change my password",
    "Check your device!": "Check your device!",
    Choose: Choose$5,
    "Choose multi-factor option": "Choose multi-factor option",
    Code: Code$5,
    "Confirm New Password": "Confirm New Password",
    Copy: Copy$5,
    "Contact your Onvio administrator": "Contact your Onvio administrator",
    "Deactivated account. Contact your administrator or accountant.": "Deactivated account. Contact your administrator or accountant.",
    "Device ID": "Device ID",
    "Didn't get a notification? <a href=\"javascript:void(0)\" data-trta1-dest=\"trta1-mfa-choosedevice\">Resend it</a> or": "Didn't get a notification? <a href=\"javascript:void(0)\" data-trta1-dest=\"trta1-mfa-choosedevice\">Resend it</a> or",
    "Didn't get a notification? <a href=\"javascript:void(0)\" data-trta1-dest=\"trta1-mfa-choosedevice\">Resend it</a> or <a href=\"javascript:void(0)\" data-trta1-dest=\"trta1-mfa-approvecode\">enter a code</a>": "Didn't get a notification? <a href=\"javascript:void(0)\" data-trta1-dest=\"trta1-mfa-choosedevice\">Resend it</a> or <a href=\"javascript:void(0)\" data-trta1-dest=\"trta1-mfa-approvecode\">enter a code</a>",
    "Do it later": "Do it later",
    "Do you want to change it now?": "Do you want to change it now?",
    Done: Done$5,
    "Download and install Thomson Reuters Authenticator app": "Download and install Thomson Reuters Authenticator app",
    "Download and install an alternate multi-factor app": "Download and install an alternate multi-factor app",
    "Email Address": "Email Address",
    "Email Address (Thomson Reuters ID)": "Email Address (Thomson Reuters ID)",
    "Emergency Access Codes": "Emergency Access Codes",
    "Emergency codes copied to the clipboard for pasting to a safe place.": "Emergency codes copied to the clipboard for pasting to a safe place.",
    "End of support for Windows 7, Server 2008 / 2008 R2": "End of support for Windows 7, Server 2008 / 2008 R2",
    "Enter code": "Enter code",
    "Enter the 9-character device ID starting with the letters TR from the back of your Thomson Reuters Authenticator card.": "Enter the 9-character device ID starting with the letters TR from the back of your Thomson Reuters Authenticator card.",
    "Enter the authentication code displayed by the Authenticator app.": "Enter the authentication code displayed by the Authenticator app.",
    "Enter the authentication code displayed by your multi-factor device or provided to you.": "Enter the authentication code displayed by your multi-factor device or provided to you.",
    "Enter the code displayed by your alternate multi-factor app.": "Enter the code displayed by your alternate multi-factor app.",
    "Enter the one-time code displayed on your multi-factor device.": "Enter the one-time code displayed on your multi-factor device.",
    "Enter your authentication code": "Enter your authentication code",
    "Error copying emergency codes to the clipboard.": "Error copying emergency codes to the clipboard.",
    "Finding your paired device.": "Finding your paired device.",
    Finish: Finish$5,
    "For your firm to access this software, one of your firm's administrators needs to upgrade your accounts at <a target=\"_blank\" rel=\"noopener\" href=\"<%= cswebHost %>/myaccount\">cs.thomsonreuters.com/myaccount</a>.": "For your firm to access this software, one of your firm's administrators needs to upgrade your accounts at <a target=\"_blank\" rel=\"noopener\" href=\"<%= cswebHost %>/myaccount\">cs.thomsonreuters.com/myaccount</a>.",
    "Generating QR code.": "Generating QR code.",
    "Generating emergency codes.": "Generating emergency codes.",
    "Get Started": "Get Started",
    "Let's get started": "Let's get started",
    Go: Go$5,
    "Go To Sign In": "Go To Sign In",
    "Hide typing": "Hide typing",
    "How long will it take to set up?": "How long will it take to set up?",
    "How will this affect me?": "How will this affect me?",
    "If you lose access to your mobile device, you can use one of these emergency codes to sign in to your account. Each code may be used only once.": "If you lose access to your mobile device, you can use one of these emergency codes to sign in to your account. Each code may be used only once.",
    "Ignore warning": "Ignore warning",
    "Incorrect Device ID or Code. Please try again.": "Incorrect Device ID or Code. Please try again.",
    "Incorrect Email Address or Password. Please try again.": "Incorrect Email Address or Password. Please try again.",
    "Incorrect Login or Password. Please try again.": "Incorrect Login or Password. Please try again.",
    "Increase security for your account": "Increase security for your account",
    "Instructions for resetting your password have been sent to your registered email address.": "Instructions for resetting your password have been sent to your registered email address.",
    "Internet Access Required": "Internet Access Required",
    "Invalid code. Please try again.": "Invalid code. Please try again.",
    "Invalid value entered.": "Invalid value entered.",
    "Leading or trailing spaces": "Leading or trailing spaces",
    "Learn More About New Security Measures": "Learn More About New Security Measures",
    "Learn more about Emergency Access Codes": "Learn more about Emergency Access Codes",
    "Learn more about multi-factor authentication.": "Learn more about multi-factor authentication.",
    "Learn more about multi-factor devices": "Learn more about multi-factor devices",
    "Learn more about these new security measures.": "Learn more about these new security measures.",
    "Learn more about third-party MFA apps": "Learn more about third-party MFA apps",
    "Learn which MFA option is right for you": "Learn which MFA option is right for you",
    "Make your account even more secure!": "Make your account even more secure!",
    "Manage Account": "Manage Account",
    "Microsoft Window Server 2008 / 2008 R2 Announcement": "Microsoft Window Server 2008 / 2008 R2 Announcement",
    "Microsoft Windows 7 Announcement": "Microsoft Windows 7 Announcement",
    "Missing data required to reset password. Please try again.": "Missing data required to reset password. Please try again.",
    "Missing data required to unlock account. Please try again.": "Missing data required to unlock account. Please try again.",
    "Missing firmId parameter.": "Missing firmId parameter.",
    "Multi-Factor Authentication Setup": "Multi-Factor Authentication Setup",
    "Multi-factor authentication required": "Multi-factor authentication required",
    "Multifactor authentication is currently unavailable.": "Multifactor authentication is currently unavailable.",
    "My Multi-Factor App": "My Multi-Factor App",
    "Name this multi-factor option": "Name this multi-factor option",
    "Need an account? Contact your administrator.": "Need an account? Contact your administrator.",
    "Need an account? Create one now.": "Need an account? Create one now.",
    "New Password": "New Password",
    Next: Next$5,
    "Next steps after setting up MFA": "Next steps after setting up MFA",
    "No phone? Contact your firm's administrator": "No phone? Contact your firm's administrator",
    "Notifying your paired device.": "Notifying your paired device.",
    OK: OK$5,
    "ONVIO Sign In Security Help": "ONVIO Sign In Security Help",
    "On your mobile device, open the app store and download and install the <b>Thomson Reuters Authenticator</b> app.": "On your mobile device, open the app store and download and install the <b>Thomson Reuters Authenticator</b> app.",
    "Open the <b>Thomson Reuters Authenticator</b> app on your mobile device and point your device's camera at your monitor to scan the code below.": "Open the <b>Thomson Reuters Authenticator</b> app on your mobile device and point your device's camera at your monitor to scan the code below.",
    "Outdated Operating System Detected": "Outdated Operating System Detected",
    "Pairing Successful!": "Pairing Successful!",
    Password: Password$5,
    "Password contains prohibited characters": "Password contains prohibited characters",
    "Password is too similar to a common or blacklisted password.": "Password is too similar to a common or blacklisted password.",
    "Password must be a minimum of 8 characters and contain at least one uppercase letter, one lowercase letter, one digit, and one symbol, with no leading or trailing spaces.": "Password must be a minimum of 8 characters and contain at least one uppercase letter, one lowercase letter, one digit, and one symbol, with no leading or trailing spaces.",
    "Passwords Don't Match": "Passwords Don't Match",
    "Passwords can be hacked, but using multi-factor authentication adds another layer of security to your account.": "Passwords can be hacked, but using multi-factor authentication adds another layer of security to your account.",
    "Please change your password.": "Please change your password.",
    "Please choose a password you have not already used.": "Please choose a password you have not already used.",
    "Please complete the required fields.": "Please complete the required fields.",
    "Please create a new password that meets <a id=\"trta1-toggle-pwd-requirements\" href=\"javascript:void(0)\">requirements</a>.": "Please create a new password that meets <a id=\"trta1-toggle-pwd-requirements\" href=\"javascript:void(0)\">requirements</a>.",
    "Please enter your email address.": "Please enter your email address.",
    "Please enter your login and email address.": "Please enter your login and email address.",
    "Please provide a valid password.": "Please provide a valid password.",
    "Please provide a valid {{label}}.": "Please provide a valid {{label}}.",
    "Please wait while we sign you into your account…": "Please wait while we sign you into your account…",
    "Please wait.": "Please wait.",
    "Please wait…": "Please wait…",
    Print: Print$5,
    "Receive notifications on your mobile device and sign in with a single touch.": "Receive notifications on your mobile device and sign in with a single touch.",
    "Registering your device.": "Registering your device.",
    "Remind Me Later": "Remind Me Later",
    Reset: Reset$5,
    "Reset My Password": "Reset My Password",
    "Reset Password": "Reset Password",
    "Retrieving authentication token.": "Retrieving authentication token.",
    "Retrieving device info.": "Retrieving device info.",
    Retry: Retry$5,
    "Save Emergency Access Codes": "Save Emergency Access Codes",
    "Save or print these codes to a secure location for use when your primary MFA device is unavailable (e.g., if you get a new phone). You can use each code only once, but you can generate more codes in your account profile": "Save or print these codes to a secure location for use when your primary MFA device is unavailable (e.g., if you get a new phone). You can use each code only once, but you can generate more codes in your account profile",
    "Scan Code": "Scan Code",
    "Sequential letters or numbers such as \"abc\" or \"123\"": "Sequential letters or numbers such as \"abc\" or \"123\"",
    "Set Up Now": "Set Up Now",
    "Show typing": "Show typing",
    "Sign back in": "Sign back in",
    "Sign In": "Sign In",
    "Sign in with your NetStaff CS account": "Sign in with your NetStaff CS account",
    "Sign in with your Thomson Reuters ID": "Sign in with your Thomson Reuters ID",
    "Sorry, there was an issue on our end. Please try again.": "Sorry, there was an issue on our end. Please try again.",
    "Your registration link has expired. Please contact the firm for a new one.": "Your registration link has expired. Please contact the firm for a new one.",
    "Step 1": "Step 1",
    "Step 2": "Step 2",
    "Success!": "Success!",
    "System Status": "System Status",
    "Tell me how": "Tell me how",
    "Continue to sign in page": "Continue to sign in page",
    "Sign in": "Sign in",
    "The alternate method must be time-based one time password (TOTP) compliant. Download now at the <a target=\"_blank\" rel=\"noopener\" href=\"https://itunes.apple.com/<%= appleStoreCountryCode %>/app/thomson-reuters-authenticator/id1155604687?mt=8&amp;l=<%= appleStoreLangCode %>\">Apple App Store</a> or the <a target=\"_blank\" rel=\"noopener\" href=\"https://play.google.com/store/apps/details?id=com.thomsonreuters.trta.authenticator&amp;pcampaignid=MKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1&amp;hl=<%= googleStoreLangCode %>\">Google Play Store</a>.": "The alternate method must be time-based one time password (TOTP) compliant. Download now at the <a target=\"_blank\" rel=\"noopener\" href=\"https://itunes.apple.com/<%= appleStoreCountryCode %>/app/thomson-reuters-authenticator/id1155604687?mt=8&amp;l=<%= appleStoreLangCode %>\">Apple App Store</a> or the <a target=\"_blank\" rel=\"noopener\" href=\"https://play.google.com/store/apps/details?id=com.thomsonreuters.trta.authenticator&amp;pcampaignid=MKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1&amp;hl=<%= googleStoreLangCode %>\">Google Play Store</a>.",
    "The firm requires you to enable multi-factor authentication before signing in. Please complete the multi-factor authentication setup wizard to continue.": "The firm requires you to enable multi-factor authentication before signing in. Please complete the multi-factor authentication setup wizard to continue.",
    "The server did not respond in time. Please try again.": "The server did not respond in time. Please try again.",
    "There was an error sending the email. Please try again.": "There was an error sending the email. Please try again.",
    "These codes are like the key to your office - keep them in a safe place only you can access!": "These codes are like the key to your office - keep them in a safe place only you can access!",
    "This option requires you to enter a code each time you sign in.": "This option requires you to enter a code each time you sign in.",
    "Thomson Reuters": "Thomson Reuters",
    "Thomson Reuters Authenticator": "Thomson Reuters Authenticator",
    "Thomson Reuters Authenticator Card": "Thomson Reuters Authenticator Card",
    "Thomson Reuters will no longer support its products on Windows 7 operating systems or Windows Server 2008 or 2008 R2 beginning January 14, 2020. We strongly urge you to upgrade any workstations or servers that require access to Thomson Reuters products to a supported operating system prior to January 14, 2020. Please find more information at the links below:": "Thomson Reuters will no longer support its products on Windows 7 operating systems or Windows Server 2008 or 2008 R2 beginning January 14, 2020. We strongly urge you to upgrade any workstations or servers that require access to Thomson Reuters products to a supported operating system prior to January 14, 2020. Please find more information at the links below:",
    "Timed out waiting for device approval. Resend notification or enter code.": "Timed out waiting for device approval. Resend notification or enter code.",
    "Timed out waiting for scan. Please go back and try again.": "Timed out waiting for scan. Please go back and try again.",
    "To help protect the confidential data belonging to your firm and your clients and to comply with new IRS requirements, Thomson Reuters is adding usernames and passwords to access our Tax &amp; Accounting products.": "To help protect the confidential data belonging to your firm and your clients and to comply with new IRS requirements, Thomson Reuters is adding usernames and passwords to access our Tax &amp; Accounting products.",
    "To log in to Onvio, please use one of the supported internet browsers below.": "To log in to Onvio, please use one of the supported internet browsers below.",
    "To sign in, please connect this computer to the internet then restart the application.": "To sign in, please connect this computer to the internet then restart the application.",
    "Too many sign in attempts. Please check for unlock email or try later.": "Too many sign in attempts. Please check for unlock email or try later.",
    "Unlocking your account.": "Unlocking your account.",
    "Use Thomson Reuters Authenticator (recommended)": "Use Thomson Reuters Authenticator (recommended)",
    "Use a multi-factor device": "Use a multi-factor device",
    "Use a multi-factor device like a card that displays a code to enter.": "Use a multi-factor device like a card that displays a code to enter.",
    "Use a third-party multi-factor app": "Use a third-party multi-factor app",
    "Use your alternate multi-factor app to scan the code below.": "Use your alternate multi-factor app to scan the code below.",
    "Validate your alternate multi-factor app": "Validate your alternate multi-factor app",
    "Validate your multi-factor device": "Validate your multi-factor device",
    "Words from the dictionary": "Words from the dictionary",
    "You can generate more codes by signing in and accessing your profile.": "You can generate more codes by signing in and accessing your profile.",
    "You can use Thomson Reuters Authenticator (recommended), or a different multi-factor app.": "You can use Thomson Reuters Authenticator (recommended), or a different multi-factor app.",
    "You have set up multi-factor authentication for your account. You will need to approve each sign-in request on your device each time you sign in with this account.": "You have set up multi-factor authentication for your account. You will need to approve each sign-in request on your device each time you sign in with this account.",
    "You have set up the following multi-factor methods:": "You have set up the following multi-factor methods:",
    "You will need to approve each sign-in request on your device each time you sign in with this account.": "You will need to approve each sign-in request on your device each time you sign in with this account.",
    "You're signed out": "You're signed out",
    "You've been authenticated.": "You've been authenticated.",
    "You've been signed out due to inactivity. Sign in to resume.": "You've been signed out due to inactivity. Sign in to resume.",
    "You've exceeded maximum usage time. Please sign in again.": "You've exceeded maximum usage time. Please sign in again.",
    "You've successfully changed your password.": "You've successfully changed your password.",
    "Your Browser is not supported": "Your Browser is not supported",
    "Your Thomson Reuters ID is the email address you use to sign in to your Onvio and/or CS Web (cs.thomsonreuters.com) accounts.": "Your Thomson Reuters ID is the email address you use to sign in to your Onvio and/or CS Web (cs.thomsonreuters.com) accounts.",
    "Your account has been unlocked.": "Your account has been unlocked.",
    "Your account is locked. Please contact your administrator.": "Your account is locked. Please contact your administrator.",
    "Your firm's license is inactive": "Your firm's license is inactive",
    "Your password <strong>must</strong> have <span>at least 8 characters</span> including all of the following:": "Your password <strong>must</strong> have <span>at least 8 characters</span> including all of the following:",
    "Your password has expired. Please create a new one that meets <a id=\"trta1-toggle-expired-pwd-requirements\" href=\"javascript:void(0)\">requirements</a>.": "Your password has expired. Please create a new one that meets <a id=\"trta1-toggle-expired-pwd-requirements\" href=\"javascript:void(0)\">requirements</a>.",
    "Your password needs to be updated. Please <a target=\"_blank\" rel=\"noopener\" href=\"<%= netfirmWebHost %>\">log in</a> and change your password.": "Your password needs to be updated. Please <a target=\"_blank\" rel=\"noopener\" href=\"<%= netfirmWebHost %>\">log in</a> and change your password.",
    "Your password should <strong>not</strong> use:": "Your password should <strong>not</strong> use:",
    "Your password will expire <em>today</em>.": "Your password will expire <em>today</em>.",
    "Your password will expire in <em id=\"trta1-pwdexpdays\">2</em> days.": "Your password will expire in <em id=\"trta1-pwdexpdays\">2</em> days.",
    "Your password will expire in <em>1</em> day.": "Your password will expire in <em>1</em> day.",
    "Your password will expire soon": "Your password will expire soon",
    "Your session is ending soon": "Your session is ending soon",
    "Your session will end in:": "Your session will end in:",
    "Your user ID": "Your user ID",
    "You don't have access": "You don't have access",
    or: or$4,
    "{{label}} is required.": "{{label}} is required.",
    "Sign-in Help": "Sign-in Help",
    "View system status": "View system status",
    "Your firm's license is no longer active. Please contact your administrator.": "Your firm's license is no longer active. Please contact your administrator.",
    "Please enter a valid password. Your password cannot contain personal information associated with your account.": "Please enter a valid password. Your password cannot contain personal information associated with your account.",
    "Refer to <a class=\"trta1-howAndHelp-link\" target=\"_blank\" rel=\"noopener\" href=\"https://cs.thomsonreuters.com/ua/login_security/cs_us_en/mfa-troubleshooting.htm\"> Help & How To Center </a> for possible solutions": "Refer to <a class=\"trta1-howAndHelp-link\" target=\"_blank\" rel=\"noopener\" href=\"https://cs.thomsonreuters.com/ua/login_security/cs_us_en/mfa-troubleshooting.htm\"> Help & How To Centre </a> for possible solutions",
    "Contact your Onvio administrator.": "Contact your Onvio administrator.",
    "Contact your administrator.": "Contact your administrator.",
    "Onvio requires two-step verification. You only have to configure this once, and it won't take long.": "Onvio requires two-step verification. You only have to configure this once, and it won't take long.",
    "Please close this window and try again.": "Please close this window and try again.",
    "Read about account security": "Read about account security",
    "Secure your account": "Secure your account",
    "Set up two-step verification": "Set up two-step verification",
    "https://onvio.us/ua/help/us-en/staff/core/setup/thomson-reuters-account.htm": "https://onvio.us/ua/help/us-en/staff/core/setup/thomson-reuters-account.htm",
    "You don't have access to this product": "You do not have access to this product",
    "Select the module you wish to access and try again": "Select the product you wish to access and try again:",
    "Client Center": "Client Centre",
    "Employee Portal": "Employee Portal"
  };

  var locales = {
    'en-CA': enCA,
    'es-AR': esAR,
    'fr-CA': frCA,
    'nl-NL': nlNL,
    'pt-BR': ptBR,
    'en-GB': enGB
  };

  var template$1 = "<form name=\"trta1-mfs-choosetype\">\n  <h3 t8>Choose multi-factor option</h3>\n  <div class=\"trta1-form-instructions\">\n    <p t8>You can use Thomson Reuters Authenticator (recommended), or a different multi-factor app.</p>\n    <p>\n      <a t8 target=\"_blank\" rel=\"noopener\" class=\"trta1-type-trid-only trta1-type-onvio-only\" href=\"<%= onvioHelpDomain %>/ua/help/<%= onvioHelpLangCode %>/<%= onvioHelpUserType %>/core/common/choosing-multi-factor-option.htm\">Learn which MFA option is right for you</a>\n      <a t8 target=\"_blank\" rel=\"noopener\" class=\"trta1-type-csweb-only trta1-type-netfirm-only\" href=\"http://cs.thomsonreuters.com/ua/login_security/cs_us_en/mfa-setup.htm#choosemfa\">Learn which MFA option is right for you</a>\n      <a t8 target=\"_blank\" rel=\"noopener\" class=\"trta1-type-netfirmdt-only\" href=\"http://cs.thomsonreuters.com/ua/netfirm/admin_drtax_<%= dtHelpLocale %>/common/choosing-multi-factor-option.htm\">Learn which MFA option is right for you</a>\n    </p>\n  </div>\n  <div class=\"trta1-carousel\">\n    <button class=\"trta1-carousel-left-nav\" aria-label=\"Previous options\">&lt;</button>\n    <ul>\n      <li class=\"mfs-choose-tr-auth-app trta1-carousel-item-selected\">\n        <h4 t8>Use Thomson Reuters Authenticator (recommended)</h4>\n        <div class=\"tr-auth-app-bg trta1-clearfix\">\n          <p t8>Receive notifications on your mobile device and sign in with a single touch.</p>\n          <button t8 class=\"trta1-btn-primary\" data-trta1-dest=\"trta1-mfs-install\">Choose</button>\n        </div>\n      </li>\n      <li class=\"mfs-choose-third-party-app\">\n        <h4 t8>Use a third-party multi-factor app</h4>\n        <div class=\"thirdparty-app-bg trta1-clearfix\">\n          <p t8>This option requires you to enter a code each time you sign in.</p>\n          <button t8 class=\"trta1-btn-primary\" data-trta1-dest=\"trta1-mfs-3p-install\">Choose</button>\n        </div>\n      </li>\n      <li class=\"mfs-choose-device\">\n        <h4 t8>Use a multi-factor device</h4>\n        <div class=\"device-bg trta1-clearfix\">\n          <p t8>Use a multi-factor device like a card that displays a code to enter.</p>\n          <button t8 class=\"trta1-btn-primary\" data-trta1-dest=\"trta1-mfs-pairdevice\">Choose</button>\n        </div>\n      </li>\n    </ul>\n    <button class=\"trta1-carousel-right-nav\" aria-label=\"Next option\">&gt;</button>\n  </div>\n  <div class=\"trta1-carousel-pos-indicator\">\n  </div>\n  <div class=\"trta1-btn-group\">\n    <div><button t8 data-trta1-dest=\"trta1-mfs-intro\" type=\"button\">Back</button></div>\n  </div>\n</form>\n";

  var CAROUSEL_ITEM_SELECTED_CLASS = 'trta1-carousel-item-selected';
  var CAROUSEL_POS_SELECTED_CLASS = 'trta1-carousel-pos-selected';

  function init$1(rootElem, options, trAuth) {
    var form = rootElem.querySelector('form[name=trta1-mfs-choosetype]');
    var carouselLeftNav = form.querySelector('.trta1-carousel-left-nav');
    var carouselRightNav = form.querySelector('.trta1-carousel-right-nav');
    var carouselPosIndicator = form.querySelector('.trta1-carousel-pos-indicator');
    var carouselItemSelectedIdx = 0;
    var chooseDeviceOption = form.querySelector('.mfs-choose-device');
    var chooseThirdPartyAppOption = form.querySelector('.mfs-choose-third-party-app');

    // toggle showing device (card) option based on enableMFACards setting
    chooseDeviceOption.classList[options.enableMFACards ? 'remove' : 'add']('trta1-hide');
    // toggle showing device (third-party app) option based on enableThirdPartyApp setting
    chooseThirdPartyAppOption.classList[options.enableThirdPartyApp ? 'remove' : 'add']('trta1-hide');

    var visibleCarouselItems = form.querySelectorAll('.trta1-carousel li:not(.trta1-hide)');

    // create carousel indicators
    var ul = document.createElement('ul');
    ul.classList += ' trta1-carousel-items';
    for (var i = 0; i < visibleCarouselItems.length; i++) {
      var option = i + 1;
      var li = document.createElement('li');
      var button = document.createElement('button');
      button.setAttribute('id', 'indicatorButton'+i);
      if (i === 0) {
        button.setAttribute('aria-current', 'Show option ' + option);
        button.classList.add('trta1-carousel-pos-selected');
      } else {
        button.setAttribute('aria-label', 'Show option ' + option);
      }
      li.appendChild(button);
      ul.appendChild(li);
    }

    carouselPosIndicator.appendChild(ul);

    if(visibleCarouselItems.length < 2) {
      carouselLeftNav.classList.add('trta1-hide');
      carouselRightNav.classList.add('trta1-hide');
      carouselPosIndicator.classList.add('trta1-hide');
    }

    trAuth.listen('click', function(evt) {
      if (evt.target.matches('.mfs-choose-tr-auth-app button')) {
        options.state.mfsChosenType = 'tr-app';
      } else if (evt.target.matches('.mfs-choose-third-party-app button')) {
        options.state.mfsChosenType = '3p-app';
      }
    }, form);

    trAuth.listen('click', function(evt) {
      selectRelativeCarouselItem('prev');
    }, carouselLeftNav);

    trAuth.listen('click', function(evt) {
      selectRelativeCarouselItem('next');
    }, carouselRightNav);

    trAuth.listen('click', function(evt) {
      if (evt.target.tagName.toLowerCase() !== 'button') { return; }
      var positions = Array.from(carouselPosIndicator.querySelectorAll('button'));
      selectCarouselItem(positions.indexOf(evt.target));
    }, carouselPosIndicator);

    function selectRelativeCarouselItem(direction) {
      var modifier;
      if(direction === 'next') {
        modifier = 1;
      } else {
        modifier = (direction === 'prev') ? -1 : 0;
      }
      carouselItemSelectedIdx += modifier;
      var totalItems = visibleCarouselItems.length;
      carouselItemSelectedIdx = carouselItemSelectedIdx < 0 ? totalItems - 1 : carouselItemSelectedIdx;
      selectCarouselItem(carouselItemSelectedIdx % totalItems);
    }

    function selectCarouselItem(idx) {
      var items = visibleCarouselItems;
      var positions = carouselPosIndicator.querySelectorAll('button');
      form.querySelector('.' + CAROUSEL_ITEM_SELECTED_CLASS).classList.remove(CAROUSEL_ITEM_SELECTED_CLASS);
      form.querySelector('.' + CAROUSEL_POS_SELECTED_CLASS).classList.remove(CAROUSEL_POS_SELECTED_CLASS);
      items[idx].classList.add(CAROUSEL_ITEM_SELECTED_CLASS);
      positions[idx].classList.add(CAROUSEL_POS_SELECTED_CLASS);
      changeIndicatorButtonAriaAttributeValue(idx);
    }

    function changeIndicatorButtonAriaAttributeValue(index) {
      for (var i = 0; i < visibleCarouselItems.length; i++) {
        var option = i + 1;
        var button = document.querySelector('#indicatorButton'+i);
        if (i === index) {
          button.setAttribute('aria-current', 'Show option ' + option);
          button.removeAttribute('aria-label');
        } else {
          button.setAttribute('aria-label', 'Show option ' + option);
          button.removeAttribute('aria-current');
        }
      }
    }
  }

  var chooseType = {
    template: template$1,
    init: init$1
  };

  var template$2 = "<form name=\"trta1-mfs-emergencycodes\" method=\"post\" action=\"<%= authSvcHost %>/api/mfa/v1/factors/emergency-codes\" tr-autosubmit novalidate>\n  <div class=\"trta1-processing-only trta1-error-only\">\n    <div class=\"trta1-form-instructions\">\n      <p t8>Generating emergency codes.</p>\n    </div>\n    <div class=\"trta1-btn-group\">\n      <div><button t8 data-trta1-dest=\"trta1-$close\" type=\"button\">Cancel</button></div>\n      <div><button t8 data-trta1-dest=\"trta1-$retry\">Retry</button></div>\n    </div>\n  </div>\n  <div class=\"trta1-success-only\">\n    <h3 t8>Save Emergency Access Codes</h3>\n    <div class=\"trta1-form-instructions\">\n      <p t8>Save or print these codes to a secure location for use when your primary MFA device is unavailable (e.g., if you get a new phone). You can use each code only once, but you can generate more codes in your account profile</p>\n      <p t8 class=\"trta1-print-only\">If you lose access to your mobile device, you can use one of these emergency codes to sign in to your account. Each code may be used only once.</p>\n      <p t8 class=\"trta1-print-only\">You can generate more codes by signing in and accessing your profile.</p>\n      <div>\n          <p class=\"trta1-icon-warning trta1-print\"></p>\n          <p t8 class=\"trta1-print\">These codes are like the key to your office - keep them in a safe place only you can access!</p>\n      </div>\n      <p>\n        <a t8 target=\"_blank\" rel=\"noopener\" class=\"trta1-type-trid-only trta1-type-onvio-only help-link\" href=\"<%= onvioHelpDomain %>/ua/help/<%= onvioHelpLangCode %>/<%= onvioHelpUserType %>/core/common/generate-own-temporary-access-codes.htm\">Learn more about Emergency Access Codes</a>\n        <a t8 target=\"_blank\" rel=\"noopener\" class=\"trta1-type-csweb-only trta1-type-netfirm-only help-link\" href=\"https://cs.thomsonreuters.com/ua/login_security/cs_us_en/generating-temporary-mfa-codes.htm\">Learn more about Emergency Access Codes</a>\n        <a t8 target=\"_blank\" rel=\"noopener\" class=\"trta1-type-netfirmdigita-only help-link\" href=\"http://cs.thomsonreuters.com/ua/netfirm/nc_user_digita_<%= digitaHelpLocale %>/common/generating-temporary-mfa-codes.htm\">Learn more about Emergency Access Codes</a>\n        <a t8 target=\"_blank\" rel=\"noopener\" class=\"trta1-type-netfirmdt-only help-link\" href=\"http://cs.thomsonreuters.com/ua/netfirm/nc_user_drtax_<%= dtHelpLocale %>/common/generating-temporary-mfa-codes.htm\">Learn more about Emergency Access Codes</a>\n      </p>\n    </div>\n    <ul class=\"mfs-ecodes-list trta1-print\"></ul>\n    <ul class=\"mfs-ecodes-links\">\n      <li><button type=\"button\" t8 class=\"trta1-btn-primary mfs-ecodes-copy-btn\">Copy</button></li>\n      <span t8>or</span>\n      <li><button type=\"button\" t8 class=\"trta1-btn-primary mfs-ecodes-print-btn\">Print</button></li>\n    </ul>\n    <div t8 class=\"trta1-form-msg-warning mfs-ecodes-copied-msg\">Emergency codes copied to the clipboard for pasting to a safe place.</div>\n    <div t8 class=\"trta1-form-msg-error mfs-ecodes-copy-failed-msg\">Error copying emergency codes to the clipboard.</div>\n    <input type=\"hidden\" name=\"type\" value=\"C\">\n    <input type=\"hidden\" name=\"address\" value=\"COTP\">\n    <div class=\"trta1-btn-group\">\n      <div><button t8 data-trta1-dest=\"trta1-$close\" class=\"trta1-btn-secondary mfs-ecodes-done-btn\" disabled=\"disabled\">Done</button></div>\n    </div>\n  </div>\n</form>\n";

  function init$2(rootElem, options, trAuth) {
    var form = rootElem.querySelector('form[name=trta1-mfs-emergencycodes]');
    var codesList = form.querySelector('.mfs-ecodes-list');
    var printLink = form.querySelector('.mfs-ecodes-print-btn');
    var copyLink = form.querySelector('.mfs-ecodes-copy-btn');
    var copiedMsg = form.querySelector('.mfs-ecodes-copied-msg');
    var copyFailedMsg = form.querySelector('.mfs-ecodes-copy-failed-msg');
    var doneBtn = form.querySelector('.mfs-ecodes-done-btn');
    var exitBtn = rootElem.querySelector('.trta1-dialog-close');

    trAuth.listen('trta1-mfs-emergencycodes-success', function(evt) {
      options.state.emergencyCodesClipboardText = '';
      exitBtn.classList.add('trta1-hide');
      trAuth.removeNodes(codesList.childNodes);
      evt.detail.data.forEach(function(factor) {
        var li = document.createElement('li');
        var formattedSecret = factor.otpSecret.substring(0, 4) + ' ' + factor.otpSecret.substring(4);
        var text = document.createTextNode(formattedSecret + '\r');
        options.state.emergencyCodesClipboardText += formattedSecret + '\r\n';
        li.appendChild(text);
        codesList.appendChild(li);
      });
    }, rootElem);

    trAuth.listen('trta1-mfs-emergencycodes-error', function(evt) {
      // if user isn't yet fully authenticated, close and require auth
      if(evt.detail.status === 403){
        trAuth.changeForm('trta1-$close');
      }
    }, rootElem);

    trAuth.listen('click', function() {
      // enable Done button
      doneBtn['removeAttribute']('disabled', 'disabled');
      var html = '<style>\
      body { margin: 40px; font-family: sans-serif; }\
      .trta1-icon-warning:before { font-size: 1.5em; content: "⚠"; vertical-align: middle; }\
      ul { list-style: none; }\
      li:before { font-size: 1.5em; content: "☐"; vertical-align: baseline; margin: 5px; }\
    </style>';
      // Render print elements into a blank tab/window.
      // WARNING: no user generated content, otherwise there is an XSS risk!
      Array.from(rootElem.querySelectorAll('h1, h2')).concat(
        Array.from(form.querySelectorAll('h3, .trta1-print, .trta1-print-only'))
      ).forEach(function(el) {
        html += el.outerHTML;
      });
      trAuth.openPrintWindow(html, options.state.$t('Emergency Access Codes'));
    }, printLink);

    trAuth.listen('click', function() {
      copyReset();

      if ('clipboard' in window.navigator) {
        navigator.clipboard.writeText(options.state.emergencyCodesClipboardText)
          .then(copySuccess)
          .catch(clipboardCopyFallback);
      } else {
        clipboardCopyFallback();
      }
    }, copyLink);

    trAuth.listen('click', function() {
      trAuth.trigger('tr-mfs-success');
    }, doneBtn, true);

    function clipboardCopyFallback() {
      var input = document.createElement('textarea');
      document.body.appendChild(input);
      input.value = options.state.emergencyCodesClipboardText;

      // sadly focus and select will sometimes fail in IWebBrowser2 (embedded)
      try {
        input.focus();
        input.select();
        // enable Done button
        doneBtn['removeAttribute']('disabled', 'disabled');
      } catch(e) {
        copyFail();
        return;
      }

      var success = document.execCommand('copy');
      document.body.removeChild(input);
      success ? copySuccess() : copyFail();
    }
    function copyReset() {
      copiedMsg.style.display = 'none';
      copyFailedMsg.style.display = 'none';
    }
    function copySuccess() {
      copiedMsg.classList.add('trta1-form-msg');
      copiedMsg.style.display = 'block';
      // enable Done button
      doneBtn['removeAttribute']('disabled', 'disabled');
    }
    function copyFail() {
      copyFailedMsg.classList.add('trta1-form-msg');
      copyFailedMsg.style.display = 'block';
    }
  }

  var emergencyCodes = {
    template: template$2,
    init: init$2
  };

  var template$3 = "<form name=\"trta1-mfs-pairdevice\" method=\"post\" action=\"<%= authSvcHost %>/api/mfa/v1/factors/device\" novalidate tr-goto-onsuccess=\"trta1-mfs-devicelookup\">\n  <h3 t8>Validate your multi-factor device</h3>\n  <div>\n    <h4 t8>Step 1</h4>\n    <p t8>Enter the 9-character device ID starting with the letters TR from the back of your Thomson Reuters Authenticator card.</p>\n    <p>\n      <a t8 target=\"_blank\" rel=\"noopener\" class=\"trta1-type-trid-only trta1-type-onvio-only\" href=\"<%= onvioHelpDomain %>/ua/help/<%= onvioHelpLangCode %>/<%= onvioHelpUserType %>/core/common/learn-about-multi-factor-devices.htm\">Learn more about multi-factor devices</a>\n      <a t8 target=\"_blank\" rel=\"noopener\" class=\"trta1-type-csweb-only trta1-type-netfirm-only\" href=\"http://cs.thomsonreuters.com/ua/login_security/cs_us_en/mfa-setup.htm#choosemfa\">Learn more about multi-factor devices</a>\n    </p>\n    <label>\n      <div t8>Device ID</div>\n      <input required pattern=\"(t|T)(r|R)\\s?\\d{3}\\s?\\d{4}\" name=\"rawDeviceId\" autocomplete=\"off\" maxlength=\"11\" tr-nosend>\n    </label>\n  </div>\n  <div>\n    <h4 t8>Step 2</h4>\n    <p t8>Enter the one-time code displayed on your multi-factor device.</p>\n    <label>\n      <div t8>Code</div>\n      <input required pattern=\"\\d{3}\\s?\\d{3}\" name=\"rawCode\" autocomplete=\"off\" maxlength=\"7\" tr-nosend>\n    </label>\n  </div>\n  <input type=\"hidden\" name=\"type\" value=\"A\">\n  <input type=\"hidden\" name=\"deviceId\">\n  <input type=\"hidden\" name=\"code\" tr-noconvert>\n  <div class=\"trta1-btn-group\">\n    <div><button t8 data-trta1-dest=\"trta1-mfs-choosetype\" type=\"button\">Back</button></div>\n    <div class=\"trta1-next-btn-container\"><button t8 class=\"trta1-btn-primary\">Next</button></div>\n  </div>\n</form>\n";

  function init$3(rootElem, options, trAuth) {
    var form = rootElem.querySelector('form[name=trta1-mfs-pairdevice]');
    var rawDeviceIdInput = form.querySelector('[name=rawDeviceId]');
    var rawCodeInput = form.querySelector('[name=rawCode]');
    var deviceIdInput = form.querySelector('[name=deviceId]');
    var codeInput = form.querySelector('[name=code]');

    trAuth.listen('submit', function() {
      deviceIdInput.value = rawDeviceIdInput.value.replace(/\s/g, '').toUpperCase();
      codeInput.value = rawCodeInput.value.replace(/\s/g, '');
    }, form);

    trAuth.listen('trta1-mfs-pairdevice-success', function(evt) {
      // use state bag for factorData, so subsequent steps will have what they need
      options.state.factorData = evt.detail.data;
    }, rootElem);

    trAuth.listen('trta1-mfs-pairdevice-error', function() {
      trAuth.focusFirstEnabledField(form, function(field) {
        return field === rawCodeInput;
      });
    }, rootElem);

    trAuth.listen('trta1-mfs-pairdevice-exit', function() {
      form.reset();
    }, rootElem);
  }

  var pairDevice = {
    template: template$3,
    init: init$3
  };

  var template$4 = "<form name=\"trta1-mfs-registerdevice\" method=\"post\" action=\"<%= authSvcHost %>/api/mfa/v1/factors/_id_/register\" tr-goto-onsuccess=\"trta1-mfs-devicelookup\" tr-autosubmit novalidate>\n<div class=\"trta1-form-instructions\">\n  <p t8>Registering your device.</p>\n</div>\n<div class=\"trta1-btn-group\">\n  <div><button t8 data-trta1-dest=\"trta1-mfs-choosetype\" type=\"button\">Back</button></div>\n  <div><button t8 data-trta1-dest=\"trta1-$retry\">Retry</button></div>\n</div>\n</form>\n";

  function init$4(rootElem, options, trAuth) {
    var form = rootElem.querySelector('form[name=trta1-mfs-registerdevice]');

    trAuth.listen('submit', function(evt) {
      var factorData = options.state.factorData;
      var registerPayload = trAuth.seekObjPath('formOverrides.trta1-mfs-registerdevice.payload', options, true);
      var deviceName = options.state.mfsChosenType === 'tr-app-totp' ?
        options.state.$t('Thomson Reuters Authenticator'):
        options.state.$t('My Multi-Factor App');

      form.action = form.action.replace(/[^\/]+\/register$/, factorData.factorId + '/register');
      registerPayload.mfarId = factorData.mfarId;
      registerPayload.factor = { name: deviceName, address: '' };
    }, form);
  }

  var registerDevice = {
    template: template$4,
    init: init$4
  };

  var template$5 = "<form name=\"trta1-mfs-scancode\" method=\"get\" action=\"<%= authSvcHost %>/api/mfa/v1/requests/_id_\" class=\"trta1-nodisable\" novalidate>\n  <h3 t8 class=\"mfs-type-tr-app-only\">Scan Code</h3>\n  <h3 t8 class=\"mfs-type-3p-app-only\">Validate your alternate multi-factor app</h3>\n  <div class=\"mfs-type-tr-app-only\">\n    <p t8>Open the <b>Thomson Reuters Authenticator</b> app on your mobile device and point your device's camera at your monitor to scan the code below.</p>\n  </div>\n  <div class=\"mfs-type-3p-app-only\">\n    <h4 t8>Step 1</h4>\n    <p t8>Use your alternate multi-factor app to scan the code below.</p>\n  </div>\n  <div class=\"trta1-mfs-qrcode\"></div>\n  <div class=\"mfs-manual-code-container\">\n    <h4 t8 class=\"mfs-type-3p-app-only\">Step 2</h4>\n    <p t8 class=\"mfs-type-3p-app-only\">Enter the code displayed by your alternate multi-factor app.</p>\n    <p t8 class=\"mfs-type-tr-app-only\">Enter the authentication code displayed by the Authenticator app.</p>\n    <label>\n      <div t8>Code</div>\n      <input required pattern=\"\\d{3,4}\\s?\\d{3,4}\" name=\"mfs-manual-code\" autocomplete=\"off\" maxlength=\"9\" tr-nosend>\n    </label>\n  </div>\n  <div class=\"trta1-btn-group\">\n    <div><button t8 data-trta1-dest=\"trta1-mfs-choosetype\" type=\"button\">Back</button></div>\n    <div class=\"trta1-next-btn-container\"><button t8 class=\"trta1-btn-primary\">Next</button></div>\n  </div>\n</form>\n";

  function init$5(rootElem, options, trAuth) {
    var form = rootElem.querySelector('form[name=trta1-mfs-scancode]');
    var cancelScanPoll;

    trAuth.listen('trta1-mfs-scancode-enter', function(event) {
      // if we haven't already gotten a code, go gen
      if (!options.state.qrCode) {
        trAuth.changeForm('trta1-mfs-gencode', rootElem);
        return;
      }

      var chosenType = options.state.mfsChosenType || 'tr-app';
      var manualCodeContainer = form.querySelector('.mfs-manual-code-container');
      var manualCode = manualCodeContainer.querySelector('[name=mfs-manual-code]');
      var factorData = options.state.factorData;
      var nextBtn = form.querySelector('.trta1-next-btn-container');

      // reset tr-app-totp to tr-app
      if (chosenType === 'tr-app-totp') options.state.mfsChosenType = 'tr-app';

      form.action = form.action.replace(/\/requests\/.*$/, '/requests/' + factorData.mfarId);
      form.classList.remove('mfs-type-tr-app', 'mfs-type-3p-app');
      form.classList.add('mfs-type-' + chosenType);

      if (chosenType === 'tr-app') {
        manualCodeContainer.style.display = 'none';
        nextBtn.style.display = 'none';

        manualCode.required = false;

        // poll for success
        cancelScanPoll = trAuth.pollFormRequest(
          form,
          // test fn
          function(evt) {
            return evt.detail.data.status === 'SUCCEEDED';
          },
          // success fn
          function() {
            options.state.qrCode = null; // once a request has been validated it is used up, wipe qrCode
            trAuth.changeForm('trta1-mfs-devicelookup', rootElem);
          },
          // timeout fn
          function() {
            trAuth.updateFormState(form, 'error', options, 'timeout');
            manualCodeContainer.style.display = 'block';
            manualCode.required = true;
            nextBtn.style.display = 'block';
            // switch to totp mode so user can enter code
            options.state.mfsChosenType = 'tr-app-totp';
          },
          null, // errorFn
          2, // delay
          60 // timeout seconds

          // roll with defaults for rest of params
          // leadingEdge = false, continueOnError = false
        );
      } else { // 3rd-party-app
        manualCodeContainer.style.display = 'block';
        nextBtn.style.display = 'block';
        manualCode.required = true;
      }

    }, rootElem);

    trAuth.listen('submit', function(evt) {
      var headers = trAuth.seekObjPath('formOverrides.trta1-mfs-scancode.headers', options, true),
        factorData = options.state.factorData;

      if (options.state.mfsChosenType === 'tr-app') {
        form.method = 'get';
        form.action = form.action.replace(/(\/validate)?$/, '');
        delete headers.authorization;

      } else { // type is 3p-app or tr-app-totp
        var code = form.elements['mfs-manual-code'].value.replace(/\s/g, '');
        form.method = 'post';
        form.action = form.action.replace(/(\/validate)?$/, '/validate');
        headers.authorization = 'OTP ' + code + ':' + factorData.factorId;
      }
    }, form);

    trAuth.listen('trta1-mfs-scancode-success', function(evt) {
      if (options.state.mfsChosenType === 'tr-app') return;
      // type is 3p-app or tr-app-totp
      form.reset();
      options.state.qrCode = null; // once a request has been validated it is used up, wipe qrCode
      trAuth.changeForm('trta1-mfs-registerdevice', rootElem);
    }, rootElem);

    trAuth.listen('trta1-mfs-scancode-error', function(evt) {
      form.reset();
      trAuth.focusFirstEnabledField(form);
    }, rootElem);

    trAuth.listen('trta1-mfs-scancode-exit', function(evt) {
      if (cancelScanPoll) {
        cancelScanPoll();
        cancelScanPoll = null;
      }
      form.reset();
    }, rootElem);
  }

  var scanCode = {
    template: template$5,
    init: init$5
  };

  var index = {
    approveCode: approveCode,
    locales: locales,
    chooseType: chooseType,
    emergencyCodes: emergencyCodes,
    pairDevice: pairDevice,
    registerDevice: registerDevice,
    scanCode: scanCode
  };

  return index;

}());
//# sourceMappingURL=bundle.js.map
(function(window) {
  'use strict';

  var trAuth = window.trAuth;
  var unsupportedOperatingSystems = ['6001', '6002', '6003', '7600', '7601'];

  var MFA_NAG_DISMISS_KEY = 'tr-auth-mfnag-dismissday';
  var MFA_SHOULD_NAG_KEY = 'tr-auth-mfnag-display';
  var FIRM_IS_LOCKED_OUT = 'Firm is locked out.';
  var mfaLocation;
  var signInLocation;

  /* jshint multistr: true */
  var moduleTemplate = '\
    <section id="trid-auth">\
      <h1 t8>Thomson Reuters</h1>\
      <h2 t8 class="trta1-netfirm-subhead">Sign in with your NetStaff CS account</h2>\
      <h2 class="trta1-trid-subhead">\
        <span t8>Sign in with your Thomson Reuters ID</span>\
        <span class="trta1-icon-question"></span>\
        <p t8 class="trta1-trid-help trta1-visually-hidden">Your Thomson Reuters ID is the email address you use to sign in to your Onvio and/or CS Web (cs.thomsonreuters.com) accounts.</p>\
      </h2>\
      <form id="trta1-auth" name="trta1-signin" method="post" action="<%= authSvcHost %>/api/auth/v2/login" novalidate>\
        <label>\
          <span t8 id="tr-auth-uid-label" class="trta1-placeholder-label">Email Address (Thomson Reuters ID)</span>\
          <span class="trta1-icon-user">\
            <input t8 type="email" name="uid" aria-labelledby="tr-auth-uid-label" data-qe-id="trauth-signin-uid" placeholder="Email Address (Thomson Reuters ID)" required pattern=".*\\S+.*" maxlength="250" autocorrect="off" autocapitalize="off" spellcheck="false">\
          </span>\
        </label>\
        <label>\
          <span t8 id="tr-auth-pwd-label" class="trta1-placeholder-label">Password</span>\
          <span class="trta1-icon-lock">\
            <input t8 type="password" name="pwd" aria-labelledby="tr-auth-pwd-label" data-qe-id="trauth-signin-pwd" placeholder="Password" required pattern=".*\\S+.*" maxlength="50">\
          </span>\
          <span class="trta1-align-right"><a t8 id="trta1-resetpwd-link" data-trta1-dest="trta1-reqpwdreset" href="javascript:void(0)">Reset Password</a></span>\
        </label>\
        <div class="trta1-btn-group">\
          <button t8 name="signinBtn" data-qe-id="trauth-signin-btn" class="trta1-btn-primary" tr-nosend>Sign In</button>\
        </div>\
        <footer class="trta1-signin-trid-footer">\
          <a t8 target="_blank" rel="noopener" href="<%= cswebHost %>/myaccount/login.aspx">Manage Account</a><br>\
          <a t8 target="_blank" rel="noopener" href="https://cs.thomsonreuters.com/ua/login_security/cs_us_en/cs-professional-suite-application-security-overview.htm"><%= csHelpLinkText %></a>\
          <span class="trta1-separator trta1-system-status-link"> | </span>\
          <a t8 class="trta1-system-status-link" target="_blank" rel="noopener" href="<%= systemStatusLink %>">System Status</a>\
          <p t8>Need an account? Contact your administrator.</p>\
        </footer>\
        <footer class="trta1-signin-netfirm-footer">\
          <a t8 target="_blank" rel="noopener" href="https://cs.thomsonreuters.com/ua/login_security/cs_us_en/cs-professional-suite-application-security-overview.htm"><%= csHelpLinkText %></a>\
          <span class="trta1-separator trta1-system-status-link"> | </span>\
          <a t8 class="trta1-system-status-link" target="_blank" rel="noopener" href="<%= systemStatusLink %>">System Status</a>\
        </footer>\
        <footer class="trta1-signin-onvio-footer">\
          <a t8 target="_blank" rel="noopener" href="<%= onvioHelpDomain %>/ua/help/<%= onvioHelpLangCode %>/<%= onvioHelpUserType %>/<%= onvioHelpSubDirectory %>/onvio-login-security-overview.htm"><%= onvioHelpLinkText %></a>\
          <span class="trta1-separator trta1-system-status-link"> | </span>\
          <a t8 class="trta1-system-status-link" target="_blank" rel="noopener" href="<%= systemStatusLink %>">System Status</a>\
        </footer>\
        <footer class="trta1-signin-csweb-footer">\
          <a t8 href="<%= cswebHost %>/myaccount/nu.aspx">Need an account? Create one now.</a>\
          <label class="trta1-system-status-link"><a t8 target="_blank" rel="noopener" href="<%= systemStatusLink %>">System Status</a></label>\
        </footer>\
      </form>\
      <form id="trta1-auth0-signin" class="trta1-auth0-signin-redirect-screen" name="trta1-auth0-signin" novalidate>\
        <div class="trta1-btn-group">\
          <button t8 id="trta1-auth0-continue-signin-btn" class="trta1-btn-primary" tr-nosend>Continue to sign in page</button>\
        </div>\
        <footer class="trta1-auth0-signin-trid-footer">\
          <a t8 target="_blank" rel="noopener" href="<%= cswebHost %>/myaccount/login.aspx">Manage Account</a><br>\
          <a t8 target="_blank" rel="noopener" href="https://cs.thomsonreuters.com/ua/login_security/cs_us_en/cs-professional-suite-application-security-overview.htm"><%= csHelpLinkText %></a>\
          <span class="trta1-separator trta1-system-status-link"> | </span>\
          <a t8 class="trta1-system-status-link" target="_blank" rel="noopener" href="<%= systemStatusLink %>">System Status</a>\
          <p t8>Need an account? Contact your administrator.</p>\
        </footer>\
        <footer class="trta1-auth0-signin-netfirm-footer">\
          <a t8 target="_blank" rel="noopener" href="https://cs.thomsonreuters.com/ua/login_security/cs_us_en/cs-professional-suite-application-security-overview.htm"><%= csHelpLinkText %></a>\
          <span class="trta1-separator trta1-system-status-link"> | </span>\
          <a t8 class="trta1-system-status-link" target="_blank" rel="noopener" href="<%= systemStatusLink %>">System Status</a>\
        </footer>\
        <footer class="trta1-auth0-signin-onvio-footer">\
          <a t8 target="_blank" rel="noopener" href="<%= onvioHelpDomain %>/ua/help/<%= onvioHelpLangCode %>/<%= onvioHelpUserType %>/<%= onvioHelpSubDirectory %>/onvio-login-security-overview.htm"><%= onvioHelpLinkText %></a>\
          <span class="trta1-separator trta1-system-status-link"> | </span>\
          <a t8 class="trta1-system-status-link" target="_blank" rel="noopener" href="<%= systemStatusLink %>">System Status</a>\
        </footer>\
        <footer class="trta1-auth0-signin-csweb-footer">\
          <a t8 href="<%= cswebHost %>/myaccount/nu.aspx">Need an account? Create one now.</a>\
          <label class="trta1-system-status-link"><a t8 target="_blank" rel="noopener" href="<%= systemStatusLink %>">System Status</a></label>\
        </footer>\
      </form>\
      <form id="trta1-auth-redirect" class="trta1-signin-redirect-screen auth0-login-form" name="trta1-signin-auth0-redirect" novalidate>\
        <h3 t8 class="SignOn-card-heading">Let\'s get started</h3>\
        <div class="trta1-btn-group">\
          <button t8 id="trauth-continue-signin-btn" class="trid-auth-continue-ciam-button trta1-btn-primary SignOn-card-button SignOn-card-button-login" tr-nosend>Sign in</button>\
        </div>\
        <footer class="trta1-signin-trid-footer SignOn-card-footer">\
          <a t8 class="trta1-system-status-link SignOn-card-link" target="_blank" rel="noopener" href="<%= systemStatusLink %>">View system status</a>\
        </footer>\
      </form>\
      <form id="trta1-auth-redirect-signout" class="trta1-signin-redirect-screen auth0-login-form" name="trta1-signin-auth0-redirect-signout" novalidate>\
        <h3 t8 class="SignOn-card-heading">You\'re signed out</h3>\
        <div class="trta1-btn-group">\
          <button t8 id="trauth-continue-signout-btn" class="trid-auth-continue-ciam-button trta1-btn-primary SignOn-card-button SignOn-card-button-login" tr-nosend>Sign back in</button>\
        </div>\
        <footer class="trta1-signin-trid-footer SignOn-card-footer">\
          <a t8 class="trta1-system-status-link SignOn-card-link" target="_blank" rel="noopener" href="<%= systemStatusLink %>">View system status</a>\
        </footer>\
      </form>\
      <form name="trta1-mfnag">\
        <h3><p t8>Make your account even more secure!</p></h3>\
        <div class="trta1-form-instructions shield-bg">\
          <p t8>Add an additional level of security in case your password is ever compromised. Confirm your identity using your mobile device.</p>\
          <p class="trta1-cs-help"><a t8 target="_blank" rel="noopener" href="http://cs.thomsonreuters.com/ua/login_security/cs_us_en/mfa-overview.htm">Learn more about multi-factor authentication.</a></p>\
          <p class="trta1-hide trta1-onvio-help"><a t8 target="_blank" rel="noopener" href="<%= onvioHelpDomain %>/ua/help/<%= onvioHelpLangCode %>/<%= onvioHelpUserType %>/core/common/mfa-reminder.htm">Learn more about multi-factor authentication.</a></p>\
          <p class="trta1-hide trta1-dt-help"><a t8 target="_blank" rel="noopener" href="http://cs.thomsonreuters.com/ua/netfirm/nc_drtax_<%= dtHelpLocale %>/common/drtax-mfa-overview.htm">Learn more about multi-factor authentication.</a></p>\
        </div>\
        <div class="trta1-btn-group">\
          <div><button t8 id="trta1-mfs-later">Remind Me Later</button></div>\
          <div><button t8 class="trta1-btn-primary trta1-mfs-go">Set Up Now</button></div>\
        </div>\
      </form>\
      <form name="trta1-offlinerequirement">\
        <h3 t8 class="trta1-icon-warning">Internet Access Required</h3>\
        <div class="trta1-form-instructions">\
          <p t8>To help protect the confidential data belonging to your firm and your clients and to comply with new IRS requirements, Thomson Reuters is adding usernames and passwords to access our Tax & Accounting products.</p>\
          <p t8>To sign in, please connect this computer to the internet then restart the application.</p>\
          <p class="trta1-cs-help"><a t8 target="_blank" rel="noopener" href="https://cs.thomsonreuters.com/ua/login_security/cs_us_en/cs-professional-suite-application-security-overview.htm">Learn more about these new security measures.</a></p>\
          <p class="trta1-hide trta1-onvio-help"><a t8 target="_blank" rel="noopener" href="<%= onvioHelpDomain %>/ua/help/<%= onvioHelpLangCode %>/<%= onvioHelpUserType %>/<%= onvioHelpSubDirectory %>/onvio-login-security-overview.htm">Learn more about these new security measures.</a></p>\
        </div>\
      </form>\
      <form name="trta1-migrationcheck" method="get" action="<%= authSvcHost %>/api/auth/v1/firms/migration" tr-autosubmit tr-goto-onerror="trta1-signin" novalidate>\
      </form>\
      <form name="trta1-intro">\
        <div class="trta1-form-instructions">\
          <p t8>To help protect the confidential data belonging to your firm and your clients and to comply with new IRS requirements, Thomson Reuters is adding usernames and passwords to access our Tax & Accounting products.</p>\
          <p t8>For your firm to access this software, one of your firm&apos;s administrators needs to upgrade your accounts at <a target="_blank" rel="noopener" href="<%= cswebHost %>/myaccount">cs.thomsonreuters.com/myaccount</a>.</p>\
        </div>\
        <div class="trta1-btn-group">\
          <a t8 target="_blank" rel="noopener" class="trta1-btn-primary" href="https://cs.thomsonreuters.com/ua/login_security/cs_us_en/cs-professional-suite-application-security-overview.htm">Learn More About New Security Measures</a>\
        </div>\
      </form>\
      <form name="trta1-reqpwdreset" method="post" action="<%= authSvcHost %>/api/auth/v1/password/reset" tr-goto-onsuccess="trta1-pwdresetreqsent" novalidate>\
        <div class="trta1-form-instructions">\
          <p t8>Please enter your email address.</p>\
        </div>\
        <div class="trta1-form-instructions trta1-form-instructions-netfirm trta1-hide">\
          <p t8>Please enter your login and email address.</p>\
        </div>\
        <label><span t8>Email Address (Thomson Reuters ID)</span>\
          <input type="email" name="uid" required pattern=".*\\S+.*" maxlength="250" autocorrect="off" autocapitalize="off" spellcheck="false">\
        </label>\
        <label class="trta1-hide"><span t8>Email Address</span>\
          <input type="email" name="email" required maxlength="250" autocorrect="off" autocapitalize="off" spellcheck="false" disabled>\
        </label>\
        <div class="trta1-btn-group">\
          <div><button t8 data-trta1-dest="trta1-$back" type="button">Back</button></div>\
          <div><button t8 class="trta1-btn-primary">Reset My Password</button></div>\
        </div>\
      </form>\
      <form name="trta1-operating-system-check" tr-autosubmit method="get" action="<%= authSvcHost %>/api/reminder/v1/nag/_id_">\
      </form>\
      <form name="trta1-unsupported-operating-system" method="" action="<%= authSvcHost %>/api/reminder/v1/nag/">\
        <h3 t8>Outdated Operating System Detected</h3>\
        <div class="trta1-form-instructions">\
          <p t8>Thomson Reuters will no longer support its products on Windows 7 operating systems or Windows Server 2008 or 2008 R2 beginning January 14, 2020. We strongly urge you to upgrade any workstations or servers that require access to Thomson Reuters products to a supported operating system prior to January 14, 2020. Please find more information at the links below:</p>\
        </div>\
        <div class="trta1-btn-group">\
          <button id="trta1-dismissosnag" t8 class="trta1-btn-primary">Acknowledge and Ignore Warning</button>\
        </div>\
        <div class="os-help-links">\
          <ul>\
            <li><a t8 target="_blank" rel="noopener" href="https://cs.thomsonreuters.com/ua/account-and-application-mgmt/systems/windows-7-end-of-support.htm">End of support for Windows 7, Server 2008 / 2008 R2</li></a>\
            <li><a t8 target="_blank" rel="noopener" href="https://www.microsoft.com/en-us/windows/windows-7-end-of-life-support-information?icid=CXSMC_win7upgrade">Microsoft Windows 7 Announcement</li></a>\
            <li><a t8 target="_blank" rel="noopener" href="https://www.microsoft.com/en-us/cloud-platform/windows-server-2008">Microsoft Window Server 2008 / 2008 R2 Announcement</li></a>\
          </ul>\
        </div>\
      </form>\
      <form name="trta1-pwdresetreqsent">\
        <div class="trta1-form-instructions">\
          <p t8>Instructions for resetting your password have been sent to your registered email address.</p>\
        </div>\
        <div class="trta1-btn-group">\
          <button t8 data-trta1-dest="trta1-signin" class="trta1-btn-primary">Go To Sign In</button>\
        </div>\
      </form>\
      <form name="trta1-pwdreset" method="put" action="<%= authSvcHost %>/api/profiles/v2/password/reset" tr-goto-onsuccess="trta1-pwdreset-complete" novalidate>\
        <div class="trta1-form-instructions">\
          <p t8>Please create a new password that meets <a id="trta1-toggle-pwd-requirements" href="javascript:void(0)">requirements</a>.</p>\
        </div>\
        <div class="trta1-form-instructions trta1-form-instructions-pwdexpired trta1-hide">\
          <p t8>Your password has expired. Please create a new one that meets <a id="trta1-toggle-expired-pwd-requirements" href="javascript:void(0)">requirements</a>.</p>\
        </div>\
        <div id="trta1-pwd-requirements" class="trta1-hide">\
          <p t8>Your password <strong>must</strong> have <span>at least 8 characters</span> including all of the following:</p>\
          <ul>\
            <li t8>At least 1 uppercase letter (A-Z)</li>\
            <li t8>At least 1 lowercase letter (a-z)</li>\
            <li t8>At least 1 digit (0-9)</li>\
            <li t8>At least 1 symbol (e.g. ! @ # $ % ^ & *)</li>\
          </ul>\
          <p t8>Your password should <strong>not</strong> use:</p>\
          <ul>\
            <li t8>Leading or trailing spaces</li>\
            <li t8>Words from the dictionary</li>\
            <li t8>Your user ID</li>\
            <li t8>Sequential letters or numbers such as "abc" or "123"</li>\
          </ul>\
        </div>\
        <span class="trta1-align-right">\
          <a t8 id="trta1-pwd-showtyping" href="javascript:void(0)">Show typing</a>\
          <a t8 id="trta1-pwd-hidetyping" class="trta1-hide" href="javascript:void(0)">Hide typing</a>\
        </span>\
        <label><span t8>New Password</span>\
          <input type="password" t8 name="password" pattern="^(?=.*[A-Z])(?=.*[a-z])(?=.*\\d)(?=.*[^A-Za-z\\d\\s])\\S.{6,}\\S$" required maxlength="50" title="Password must be a minimum of 8 characters and contain at least one uppercase letter, one lowercase letter, one digit, and one symbol, with no leading or trailing spaces.">\
        </label>\
        <label><span t8>Confirm New Password</span>\
          <input type="password" name="password2" required maxlength="50">\
        </label>\
        <div class="trta1-btn-group">\
          <button t8 class="trta1-btn-primary">Reset My Password</button>\
        </div>\
        <div class="trta1-btn-group trta1-btn-group-pwdexpired trta1-btn-group-pwdexpiring trta1-hide">\
          <div><button t8 data-trta1-dest="trta1-$back" type="button">Back</button></div>\
          <div><button t8 class="trta1-btn-primary">Change My Password</button></div>\
        </div>\
      </form>\
      <form name="trta1-pwdreset-complete">\
        <div class="trta1-form-instructions">\
          <p t8>You&apos;ve successfully changed your password.</p>\
        </div>\
        <div class="trta1-btn-group">\
          <button t8 data-trta1-dest="trta1-signin" class="trta1-btn-primary">Go To Sign In</button>\
        </div>\
        <div class="trta1-btn-group trta1-btn-group-authcomplete trta1-hide">\
          <button t8 id="trta1-pwdresetcompleteokbtn" class="trta1-btn-primary">OK</button>\
        </div>\
      </form>\
      <form name="trta1-pwdreset-netfirm">\
        <div class="trta1-form-instructions">\
          <p t8>Your password needs to be updated. Please <a target="_blank" rel="noopener" href="<%= netfirmWebHost %>">log in</a> and change your password.</p>\
        </div>\
        <div class="trta1-btn-group">\
          <button t8 data-trta1-dest="trta1-signin" class="trta1-btn-primary">Back To Sign In</button>\
        </div>\
        <div class="trta1-btn-group trta1-btn-group-authcomplete trta1-hide">\
          <button t8 id="trta1-pwdresetnetfirmokbtn" class="trta1-btn-primary">OK</button>\
        </div>\
      </form>\
      <form name="trta1-requnlock" method="put" action="<%= authSvcHost %>/api/auth/v1/login/unblock" tr-autosubmit tr-goto-onsuccess="trta1-requnlock-complete" novalidate>\
        <div class="trta1-form-instructions">\
          <p t8>Unlocking your account.</p>\
        </div>\
        <div class="trta1-btn-group">\
          <button t8 data-trta1-dest="trta1-signin" class="trta1-btn-primary">Go To Sign In</button>\
        </div>\
      </form>\
      <form name="trta1-requnlock-complete">\
        <div class="trta1-btn-group">\
          <button t8 data-trta1-dest="trta1-signin" class="trta1-btn-primary">Go To Sign In</button>\
        </div>\
      </form>\
       <form name="trta1-pwdexpiring">\
        <h3 t8>Your password will expire soon</h3>\
        <div class="trta1-form-instructions">\
          <p t8 id="trta1-pwdexpirestwoormoredays-txt">Your password will expire in <em id="trta1-pwdexpdays">2</em> days.</p>\
          <p t8 id="trta1-pwdexpiresoneday-txt" class="trta1-hide">Your password will expire in <em>1</em> day.</p>\
          <p t8 id="trta1-pwdexpireszerodays-txt" class="trta1-hide">Your password will expire <em>today</em>.</p>\
          <p t8>Do you want to change it now?</p>\
        </div>\
        <div class="trta1-btn-group">\
          <div><button t8 id="trta1-chgpwdnowbtn">Change my password</button></div>\
          <div><button t8 class="trta1-btn-primary" id="trta1-chgpwdlaterbtn">Do it later</button></div>\
        </div>\
      </form>\
      <form name="trta1-sessionending">\
        <h3 t8>Your session is ending soon</h3>\
        <div class="trta1-form-instructions">\
          <p t8>Your session will end in:</p>\
          <p id="trta1-signout-countdown">2:00</p>\
        </div>\
        <div class="trta1-btn-group">\
          <button t8 class="trta1-btn-primary">Reset</button>\
        </div>\
      </form>\
      <form name="trta1-mfsrequired">\
        <h3 t8>Multi-factor authentication required</h3>\
        <div class="trta1-form-instructions">\
          <p t8>The firm requires you to enable multi-factor authentication before signing in. Please complete the multi-factor authentication setup wizard to continue.</p>\
        </div>\
        <div class="trta1-btn-group">\
          <div><button t8 data-trta1-dest="trta1-$back" type="button">Back</button></div>\
          <div><button t8 class="trta1-btn-primary trta1-mfs-go">Set Up Now</button></div>\
        </div>\
      </form>\
      <form name="trta1-mfarequired-screen" class="auth0-login-form">\
        <h3 t8 class="SignOn-card-heading">Secure your account</h3>\
        <div class="trta1-form-instructions SignOn-card-supportingText ">\
          <p t8>Onvio requires two-step verification. You only have to configure this once, and it won\'t take long.</p>\
        </div>\
        <div class="trta1-btn-group">\
          <div><button t8 id="trta1-mfa-required" class="trta1-mfa-required SignOn-card-button">Set up two-step verification</button></div>\
          <div>\
            <a t8 href="<%= aboutAccountSecLink %>" target="_blank" class="SignOn-card-link">Read about account security</a>\
          </div>\
        </div>\
      </form>\
      <form name="trta1-account-error-screen">\
        <div class="trta1-form-instructions">\
           <p t8>Your firm\'s license is no longer active. Please contact your administrator.</p>\
        </div>\
        <div class="trta1-btn-group">\
          <div><button t8 id="trta1-back-to-signin">Back</button></div>\
        </div>\
      </form>\
      <form class="auth0-login-form" name="trta1-account-error-auth0-screen">\
        <div class="trta1-form-instructions">\
          <div class="tr-login-user-image" aria-hidden="true"></div>\
          <h3 t8 class="SignOn-card-heading">You don\'t have access</h3>\
          <p t8 class="SignOn-card-supportingText"><%= appMessageAdministrator %></p>\
        </div>\
        <div class="trta1-form-instructions-no-access-to-module trta1-hide">\
          <div class="tr-login-user-image" aria-hidden="true"></div>\
          <h3 t8 class="SignOn-card-heading">You don\'t have access to this product</h3>\
          <p t8 class="SignOn-card-supportingText">Select the module you wish to access and try again</p>\
          <div class="SignOn-card-productLinks">\
            <a t8 class="SignOn-card-link" target="_blank" rel="noopener" href="<%= clientCenterLink %>">Client Center</a>\
            <a t8 class="SignOn-card-link" target="_blank" rel="noopener" href="<%= employeePortalLink %>">Employee Portal</a>\
            <a class="SignOn-card-link" target="_blank" rel="noopener" href="<%= onBalanceLink %>">OnBalance</a>\
          </div>\
        </div>\
        <footer class="trta1-signin-trid-footer SignOn-card-footer">\
          <a t8 class="trta1-system-status-link SignOn-card-link" target="_blank" rel="noopener" href="<%= systemStatusLink %>">View system status</a>\
        </footer>\
      </form>\
      <form name="trta1-firm-lock-credit-hold-screen">\
        <div class="trta1-form-instructions">\
           <p t8>Your firm\'s license is no longer active. Please contact your administrator.</p>\
        </div>\
        <div class="trta1-btn-group">\
          <div><button t8 id="trta1-back-to-signin">Back</button></div>\
        </div>\
      </form>\
      <form class="auth0-login-form" name="trta1-firm-lock-credit-hold-new-screen">\
        <div class="trta1-form-instructions">\
          <div class="tr-login-user-image" aria-hidden="true"></div>\
          <h3 t8 class="SignOn-card-heading">You don\'t have access</h3>\
          <p t8 class="SignOn-card-supportingText"><%= appMessageAdministrator %></p>\
        </div>\
        <footer class="trta1-signin-trid-footer SignOn-card-footer">\
          <a t8 class="trta1-system-status-link SignOn-card-link" target="_blank" rel="noopener" href="<%= systemStatusLink %>">View system status</a>\
        </footer>\
      </form>\
      <form class="auth0-login-form" name="trta1-firm-lock-new-screen">\
        <div class="trta1-form-instructions">\
          <div class="tr-login-technology-image" aria-hidden="true"></div>\
          <h3 t8 class="SignOn-card-heading">Your firm\'s license is inactive</h3>\
          <p t8 class="SignOn-card-supportingText"><%= appMessageAdministrator %></p>\
        </div>\
        <footer class="trta1-signin-trid-footer SignOn-card-footer">\
          <a t8 class="trta1-system-status-link SignOn-card-link" target="_blank" rel="noopener" href="<%= systemStatusLink %>">View system status</a>\
        </footer>\
      </form>\
      <form name="trta1-mfa-choosedevice" method="get" action="<%= authSvcHost %>/api/mfa/v1/factors" tr-autosubmit novalidate>\
        <div class="trta1-form-instructions">\
          <p t8>Finding your paired device.</p>\
        </div>\
        <div class="trta1-btn-group">\
          <div><button t8 data-trta1-dest="<%= cancelDestForm %>" type="button">Cancel</button></div>\
          <div><button t8 data-trta1-dest="trta1-$retry">Retry</button></div>\
        </div>\
      </form>\
      <form name="trta1-mfa-notifydevice" method="post" action="<%= authSvcHost %>/api/mfa/v1/requests" tr-autosubmit novalidate>\
        <div class="trta1-form-instructions">\
          <p t8>Notifying your paired device.</p>\
        </div>\
        <div class="trta1-btn-group">\
          <div><button t8 data-trta1-dest="<%= cancelDestForm %>" type="button">Cancel</button></div>\
          <div><button t8 data-trta1-dest="trta1-$retry">Retry</button></div>\
        </div>\
      </form>\
      <form name="trta1-mfa-awaitapproval" method="get" action="<%= authSvcHost %>/api/mfa/v1/requests/_id_" class="trta1-nodisable" novalidate>\
        <h3 t8>Check your device!</h3>\
        <div class="trta1-form-instructions">\
          <p t8>Approve your request<br> in the Thomson Reuters Authenticator app</p>\
        </div>\
        <fieldset>\
          <p t8>Didn&apos;t get a notification? <a href="javascript:void(0)" data-trta1-dest="trta1-mfa-choosedevice">Resend it</a> or <a href="javascript:void(0)" data-trta1-dest="trta1-mfa-approvecode">enter a code</a>\
          </p>\
          <p t8>No phone? Contact your firm&apos;s administrator</p>\
        </fieldset>\
        <div class="trta1-btn-group">\
          <a t8 data-trta1-dest="<%= cancelDestForm %>" href="javascript:void(0)">Cancel Request</a>\
        </div>\
      </form>\
      <form name="trta1-mfa-retrievetoken" method="post" action="<%= authSvcHost %>/api/auth/v1/jwt/mfa/_id_" tr-autosubmit novalidate>\
        <div class="trta1-form-instructions">\
          <p t8>Retrieving authentication token.</p>\
        </div>\
        <div class="trta1-btn-group">\
          <div><button t8 data-trta1-dest="<%= cancelDestForm %>" type="button">Cancel</button></div>\
          <div><button t8 data-trta1-dest="trta1-$retry">Retry</button></div>\
        </div>\
      </form>\
      <form name="trta1-postauth">\
      </form>\
      <form name="trta1-authcomplete">\
        <h3 t8 class="success-shield-bg">Success!</h3>\
        <div class="trta1-form-instructions">\
          <p t8>You\'ve been authenticated.</p>\
          <p t8 class="trta1-pleasewait">Please wait while we sign you into your account&hellip;</p>\
        </div>\
      </form>\
      <form name="trta1-auth0-signin-redirect" method="post" action="<%= authSvcHost %>/api/security/v1/oidc/login" tr-autosubmit novalidate class="trta1-not-display-success">\
        <div class="trta1-form-instructions">\
        </div>\
      </form>\
      <form name="trta1-auth0-redirect" method="get" action="<%= authSvcHost %>/api/security/v2/environments" tr-autosubmit>\
        <div class="trta1-form-instructions">\
        </div>\
      </form>\
      <form name="trta1-auth0-code-exchange" class="trta1-not-display-wait" method="post" action="<%= authSvcHost %><%= auth0Endpoint %>" tr-autosubmit>\
        <div class="trta1-form-instructions">\
        </div>\
      </form>\
      <form name="trta1-mfa-unavailable">\
        <div class="trta1-form-instructions">\
          <p t8>Multifactor authentication is currently unavailable.</p>\
          <p t8 class="trta1-pleasewait">Please wait while we sign you into your account&hellip;</p>\
        </div>\
      </form>\
      <form name="trta1-elevated-mfa-unavailable">\
        <div class="trta1-form-instructions">\
          <p t8>Multifactor authentication is currently unavailable.</p>\
          <p t8>Please close this window and try again.</p>\
        </div>\
      </form>\
    ' +

    // Append templates for external es modules
    trAuth.submodules.approveCode.template +

      '<div class="trta1-debug"></div>\
    </section>\
  ';
  /* jshint multistr: false */

  function prepDataForMfaForms(opts, uid, jwt) {
    // set uid for device notify name
    var notifyPayload = trAuth.seekObjPath('formOverrides.trta1-mfa-notifydevice.payload', opts, true);
    notifyPayload.name = uid;

    if (jwt) {
      [
        'formOverrides.trta1-mfa-choosedevice.headers',
        'formOverrides.trta1-mfa-notifydevice.headers',
        'formOverrides.trta1-mfa-awaitapproval.headers',
        'formOverrides.trta1-mfa-retrievetoken.headers'
      ].forEach(function(overridePath) {
        trAuth.seekObjPath(overridePath, opts, true).authorization = 'Bearer ' + jwt;
      });
    }
  }

  function prepareAuthSuccessData(evt, opts) {
    var token, uds, data = null;

    if (!opts.offline) {
      token = evt.detail.data && evt.detail.data.tokenValue;
      uds = evt.detail.data && evt.detail.data.uds;
      if (token) {
        data = { data: {
          token: token,
          decodedToken: window.jwt_decode(token),
          uds: uds
        }};
      }
    }
    return data;
  }

  function init(options) {
    var rootElem, signinForm, pwdResetForm, pwdExpiringForm, resetPwds, signinUidInput, signinPwdInput,
      signinMsgs, reqPwdResetForm, systemStatusOption, signinAuth0Forms, systemStatusOptionAuth0;

    options = options || { locale: 'en-US' };

    window.trAuth.shadowDomElem = options.shadowDomElem;

    var $t = trAuth.getTranslateFn(options.locale);
    var defaultOptions = {
      type: 'trid',
      templateData: {// This template data will be translated later so do not delete the translations keys that come in the json file related to the template data
        cswebHost: 'https://cs.thomsonreuters.com',
        onvioHelpDomain: 'https://onvio.us',
        onvioHelpLinkText: 'ONVIO Sign In Security Help',
        csHelpLinkText: 'CS Professional Suite Security Help',
        onvioHelpUserType: 'staff',
        onvioHelpSubDirectory: 'core/setup',
        authSvcHost: 'https://onvio.us',
        netfirmWebHost: 'https://secure.netlinksolution.com',
        cancelDestForm: 'trta1-$start',
        clientCenterLink: 'https://onvio.com.br',
        employeePortalLink: 'https://onvio.com.br/portaldoempregado/auth',
        onBalanceLink: 'https://onbalance.thomsonreuters.com.br',
        systemStatusLink: '',
        appMessageAdministrator: getAppMessageAdministrator(options.sp),
        aboutAccountSecLink: retrieveAboutAccountSecLink(),
        signInHelpLink: $t('https://onvio.us/ua/help/us-en/staff/core/setup/thomson-reuters-account.htm'),
        auth0Endpoint: fetchAuthCodeSessionsV2IACStatus() ? '/api/security/v2/oidc/auth-code/session' : '/api/security/v1/oidc/auth-code/session',
      },
      flow: { type: 'auth', data: {} },
      formStateMessages: {
        'error': {
          /* Custom service reason keys */
          // https://git.sami.int.thomsonreuters.com/bluemoon/authentication-aggregator/blob/develop/authentication-aggregator-lib/src/main/java/com/tr/bluemoon/auth/LoginErrorCode.java
          'INVALID_CREDENTIALS': $t('Incorrect Email Address or Password. Please try again.'),
          'ACCOUNT_LOCKED_OUT': $t('Too many sign in attempts. Please check for unlock email or try later.'),
          'RATE_LIMIT_REACHED': $t('Too many sign in attempts. Please check for unlock email or try later.'),
          'PASSWORD_EXPIRED': $t('Please change your password.'),
          'MISSING_PARAMETER': $t('Please complete the required fields.'),
          // 'USER_NOT_FOUND': '',
          'USER_INACTIVE': $t('Deactivated account. Contact your administrator or accountant.'),
          'EMAIL_SEND_ERROR': $t('There was an error sending the email. Please try again.'),
          // 'INVALID_TOKEN': '',
          'PASSWORD_ALREADY_USED': $t('Please choose a password you have not already used.'),
          // these should default to unknown error as something went wrong if you see them
          // 'MFA_SETUP_REQUIRED': '',
          // 'MFA_AUTHENTICATION_REQUIRED': '',
          'INVALID_PASSWORD_FORMAT': $t('Please change your password.'),
          // Contact not found.
          'CONTACT_NOT_FOUND_EXCEPTION': $t('Your firm\'s license is no longer active. Please contact your administrator.'),
          // Wrong primary product.
          'PRIMARY_PRODUCT_MISMATCHING': $t('Your firm\'s license is no longer active. Please contact your administrator.'),
          // Firm is locked out.
          'FIRM_CREDIT_HOLD': $t('Your firm\'s license is no longer active. Please contact your administrator.'),
          // Firm is locked out.
          'FIRM_LOCKED_OUT': $t('Your firm\'s license is no longer active. Please contact your administrator.'),

          /* Custom client-side keys */
          'ourIssueTryAgain': $t('Sorry, there was an issue on our end. Please try again.'),
          'unlockAcct': $t('Your account has been unlocked.'),
          'inactivitySignout': $t('You\'ve been signed out due to inactivity. Sign in to resume.'),
          'forcedSignout': $t('You\'ve exceeded maximum usage time. Please sign in again.'),
          'expiredRegistration': $t('Your registration link has expired. Please contact the firm for a new one.'),
          'invalidCredentialsNetfirm': $t('Incorrect Login or Password. Please try again.')
        }
      },
      formOverrides: {
        'trta1-signin': {
          statusMap: {
            '404': 500
          },
          formStateMessages: {
            'error': {
              'MISSING_PARAMETER_FIRM_ID': $t('Missing firmId parameter.'),
            }
          }
        },
        'trta1-auth0-code-exchange': {
          headers: {
            'content-type': 'application/x-www-form-urlencoded',
          },
        },
        'trta1-pwdreset': {
          headers: {
            'content-type': 'application/x-www-form-urlencoded',
          },
          formStateMessages: {
            'error': {
              'MISSING_PARAMETER': $t('Missing data required to reset password. Please try again.'),
              'PASSWORD_VIOLATES_RULES': $t('Please provide a valid password.'),
              'PASSWORD_CONTAINS_PROHIBITED_CHARS': $t('Password contains prohibited characters'),
              'PASSWORD_TOO_COMMON': $t('Password is too similar to a common or blacklisted password.'),
              'PASSWORD_CONTAINS_USERINFO': $t('Please enter a valid password. Your password cannot contain personal information associated with your account.'),
            }
          }
        },
        'trta1-requnlock': {
          headers: {
            'content-type': 'application/x-www-form-urlencoded',
          },
          formStateMessages: {
            'error': {
              'MISSING_PARAMETER': $t('Missing data required to unlock account. Please try again.'),
            }
          }
        },
        'trta1-mfa-awaitapproval': {
          formStateMessages: {
            // only display form state msgs for error
            'processing': null,
            'success': null,
            'error': { 'timeout': $t('Timed out waiting for device approval. Resend notification or enter code.') }
          }
        },
        'trta1-mfa-approvecode': {
          formStateMessages: {
            'error': {
              'unauthorized': $t('Invalid code. Please try again.'),
              '401': $t('Invalid code. Please try again.')
            }
          }
        }
      }
    };

    options = trAuth.objAssignDeep({}, trAuth.getDefaultOptions(options.locale), defaultOptions, options);

    // Verify if it is from desktop app and for onvio and trid
    if (options.sp === 'csdesktop' && (options.type === 'onvio' || options.type === 'trid' || options.type === 'netfirm') ) {
      // Make a get request to get IACs
      var xhr = new XMLHttpRequest();
      xhr.open('GET', '/api/security/v2/environments', false);
      xhr.send();
      // Check if Auth0 is enabled
      try {
        var iac = JSON.parse(xhr.responseText);
        var isAuth0enabled = iac.InfrastructureAccessControls.indexOf('Platform_DisableAuth0Phase3') == -1;
        // If Auth0 is enabled show the new 'continue to sign in button'
        if(isAuth0enabled){
          options.startingForm = 'trta1-auth0-signin';
        }
      } catch (error){
        // If there is an error just continue and it will show the legacy form
        window.console.log('Could not get IACs, so continue with the previous flow');
      }
    }

    if(options.auth0Code && options.auth0State) {
      options.flow = { type: 'auth0-code-exchange', data: { auth0Code: options.auth0Code, auth0State: options.auth0State } };
    }

    if(!options.auth0Code && options.auth0State) {
      options.startingForm = 'trta1-account-error-auth0-screen';
    }

    // setup flow data
    switch (options.flow.type) {
      case 'auth-elevated':
        if (!options.flow.data.jwt) break;
        options.startingForm = 'trta1-mfa-choosedevice';
        prepDataForMfaForms(options, options.flow.data.uid, options.flow.data.jwt);
        break;
      case 'auth-2nd-factor':
        if (!options.flow.data.jwt) break;
        options.startingForm = 'trta1-mfa-choosedevice';
        prepDataForMfaForms(options, options.flow.data.uid, options.flow.data.jwt);
        options.templateData.cancelDestForm = 'trta1-$close';
        break;
      case 'auth0-code-exchange':
        if (!options.flow.data.auth0Code) break;
        options.startingForm = 'trta1-auth0-code-exchange';
        break;
    }

    if (options.isLogout == 'true'){
      options.startingForm = 'trta1-signin-auth0-redirect-signout';
    }

    // Add system status link to templateData
    if (options.statusPage) {
      options.templateData.systemStatusLink = options.statusPage.url;
      options.templateData.onvioHelpLinkText = 'Sign-in Help';
      options.templateData.csHelpLinkText = 'Sign-in Help';
    }

    // if init of trid fails, exit
    if (!trAuth.init(options)) return;
    // add in computed template data, e.g. onvioHelpLangCode
    var templateData = trAuth.objAssignDeep({}, options.templateData, { onvioHelpLangCode: options.locale.toLowerCase().split('-').reverse().join('-'),  dtHelpLocale: options.locale.toLowerCase().split('-').reverse().join('_'),  digitaHelpLocale: options.locale.toLowerCase().split('-').reverse().join('_') });

    rootElem = trAuth.renderTemplate(trAuth.template(moduleTemplate, options), templateData, null, null, options.locale);

    // cached selectors
    signinForm = rootElem.querySelector('form[name=trta1-signin]');
    signinUidInput = signinForm.elements.uid;
    signinPwdInput = signinForm.elements.pwd;
    reqPwdResetForm = rootElem.querySelector('form[name="trta1-reqpwdreset"]');
    pwdResetForm = rootElem.querySelector('form[name="trta1-pwdreset"]');
    pwdExpiringForm = rootElem.querySelector('form[name="trta1-pwdexpiring"]');
    resetPwds = pwdResetForm.querySelectorAll('[name=password], [name=password2]');
    systemStatusOption = signinForm.querySelectorAll('.trta1-system-status-link');

    // toggle system status link based on statusPage.url setting
    Array.from(systemStatusOption).forEach(function(item, index) {
      systemStatusOption[index].classList[options.statusPage && options.statusPage.url ? 'remove' : 'add']('trta1-hide');
    });

    if(hideSystemStatus()) {
      // Select the two Auth0 forms one for login and one for logout
      signinAuth0Forms = rootElem.querySelectorAll('form[name=trta1-signin-auth0-redirect], form[name=trta1-signin-auth0-redirect-signout], form[name=trta1-account-error-auth0-screen]');
      Array.from(signinAuth0Forms).forEach(function(item, ind) {
        // Pickup the system status link and hide it
        systemStatusOptionAuth0 =  signinAuth0Forms[ind].querySelectorAll('.trta1-system-status-link');
        Array.from(systemStatusOptionAuth0).forEach(function(item, index) {
          systemStatusOptionAuth0[index].classList.add('trta1-hide');
        });
      });
    }

    // initialize submodules
    trAuth.submodules.approveCode.init(rootElem, options, trAuth);

    // dynamic options
    if (options.type === 'netfirm') {
      // create if it doesn't exist
      signinMsgs = trAuth.seekObjPath('formOverrides.trta1-signin.formStateMessages.error', options, true);
      signinMsgs.INVALID_CREDENTIALS = defaultOptions.formStateMessages.error.invalidCredentialsNetfirm;
    }

    function storeSigninData(uid, pwd) {
      // save off values for post mfa success retrieval, #8442
      var signinVals = trAuth.seekObjPath('formOverrides.trta1-signin.values', options, true);
      signinVals.uid = uid || signinUidInput.value;
      signinVals.pwd = pwd || signinPwdInput.value;
    }
    function clearSigninData() {
      var signinVals = trAuth.seekObjPath('formOverrides.trta1-signin.values', options, true);
      // keep uid, so user doesn't have to enter it again
      // signinVals.uid = undefined;
      signinVals.pwd = undefined;
    }

    // events
    trAuth.listen('trta1-auth-enter', function(evt) {
      if (options.inactivitySignout === true)
        trAuth.updateFormState(evt.target, 'error', options, 'inactivitySignout');
      if (options.forcedSignout === true)
        trAuth.updateFormState(evt.target, 'error', options, 'forcedSignout');
      if (options.expiredRegistration === true)
        trAuth.updateFormState(evt.target, 'error', options, 'expiredRegistration');
    }, signinForm);

    trAuth.listen('submit', function(evt) {
      var form = evt.target;
      form.classList.add('trta1-submitted');
      if (!trAuth.validateForm(form, options)) {
        trAuth.focusFirstEnabledField(form, function(field) {
          return !field.validity.valid;
        });
        return;
      }
    }, signinForm);

    trAuth.listen('trta1-auth-exit', function() {
      signinPwdInput.value = '';
    }, signinForm);

    // CXG - New entry point for NetFirm MFA nag
    trAuth.listen('trta1-auth-mfnag', function(evt) {
      var detail  = { key: evt.detail.data.tokenValue };

      // create so that it can be used down the line...
      var data = { authSuccessEvt: { detail: { data: { tokenValue : evt.detail.data.tokenValue}}}};
      options.data = data;

      // save off values for post mfa success retrieval, #8442
      storeSigninData();

      prepDataForMfaForms(options, signinUidInput.value, detail.key);
      trAuth.changeForm('trta1-mfnag', rootElem, detail);
    }, signinForm);

    trAuth.listen('trta1-auth-error', function(evt) {
      var primaryError = trAuth.getPrimaryError(evt.detail), detail;

      // trigger auth section error event
      trAuth.trigger('tr-auth-error', evt.detail);

      if (!primaryError) return;

      detail  = { type: primaryError.reason, key: primaryError.key };

      // handle primary reason
      switch (detail.type) {
        case 'MISSING_PARAMETER':
          var msgs = trAuth.getFormStateMsgs(signinForm, options), msg;
          if (detail.key === 'firmId') {
            msg = msgs.error.MISSING_PARAMETER_FIRM_ID;
            trAuth.updateFormMsg(signinForm, msg);
          } else { // some other param is missing; validate
            trAuth.validateForm(signinForm, options);
          }
          break;
        case FIRM_IS_LOCKED_OUT:
          trAuth.updateFormMsg(signinForm, defaultOptions.formStateMessages.error.FIRM_LOCKED_OUT);
          break;
        case 'INVALID_CREDENTIALS':
        case 'RATE_LIMIT_REACHED':
          // assume pwd is invalid for user convenience
          trAuth.focusFirstEnabledField(signinForm, function(field) {
            return field === signinPwdInput;
          });
          break;
        case 'PASSWORD_EXPIRED':
        case 'INVALID_PASSWORD_FORMAT':
        case 'PASSWORD_VIOLATES_RULES':
        case 'PASSWORD_CONTAINS_PROHIBITED_CHARS':
        case 'PASSWORD_CONTAINS_USERINFO':
        case 'PASSWORD_TOO_COMMON':
          // todo: when services support pwd reset for NF users remove this
          if (/^(netfirm|netfirmrest)$/i.test(primaryError.domain)) {
            trAuth.changeForm('trta1-pwdreset-netfirm', rootElem, detail);
            break;
          }
          trAuth.changeForm('trta1-pwdreset', rootElem, detail);
          break;
        case 'MFA_SETUP_REQUIRED':
          // save off values for post mfa success retrieval, #8442
          storeSigninData();

          prepDataForMfaForms(options, signinUidInput.value);
          trAuth.changeForm('trta1-mfsrequired', rootElem, detail);
          break;
        case 'MFA_AUTHENTICATION_REQUIRED':
          // save off values for post mfa success retrieval, #8442
          storeSigninData();

          prepDataForMfaForms(options, signinUidInput.value, detail.key);
          trAuth.changeForm('trta1-mfa-choosedevice', rootElem, detail);
          break;
      }
    }, signinForm);

    trAuth.listen('trta1-mfa-choosedevice-success', function(evt) {
      trAuth.changeForm('trta1-mfa-notifydevice', rootElem, evt.detail);
    }, rootElem);

    function shouldNag() {
      var store = trAuth.store(MFA_SHOULD_NAG_KEY);
      return store && (store === 'true');
    }

    function shouldNagOS() {
      // if not VO and os is not supported && not nagged yet
      return !options.isVO &&
             options.osCurrentBuildNumber &&
             unsupportedOperatingSystems.indexOf(options.osCurrentBuildNumber.toString()) > -1 &&
             !options.osNagged &&
             !options.osChecked;
    }

    // Responsible for kicking off the process of setting up MFA
    function setupMFA(formName, authKey) {
      trAuth.listen('click', function(evt) {
        evt.preventDefault();
        var uid = trAuth.seekObjPath('formOverrides.trta1-signin.values', options).uid;

        // unload auth, trigger mfs
        trAuth.modules.auth.destroy();
        trAuth.modules.mfs.init(trAuth.objAssignDeep({}, options, {
          title: null,
          startingForm: 'trta1-mfs-intro',
          templateData: {
            uid: uid
          },
          enableMFACards: false,
          headers: {
            authorization: 'Bearer ' + authKey
          }
        }, options.mfsOptions));

        // listen once for close
        trAuth.listen('tr-dialog-user-closed', function(evt) {
          // let destroy finish
          setTimeout(function() {
            var opts = trAuth.objAssignDeep({}, options, {
              startingForm: 'trta1-signin'
            });

            // if we are closing after a successful device pairing
            if (evt.detail.form === 'trta1-mfs-emergencycodes') {
              opts.startingForm = 'trta1-mfa-choosedevice';
              opts.templateData.cancelDestForm = 'trta1-signin';
              opts.generateCodes = true;
              prepDataForMfaForms(opts, uid, authKey);
            } else {
              clearSigninData();
            }

            trAuth.modules.auth.init(opts);
          });
        }, null, true);

      }, rootElem.querySelector('form[name=' + formName + '] .trta1-mfs-go'), true);
    }

    function getMfNagKey() {
      var key, overrides, uid;

      // retrieve the uid
      overrides = options.formOverrides['trta1-signin'];
      if (overrides.values && overrides.values.uid) {
        uid = overrides.values.uid;
        key = MFA_NAG_DISMISS_KEY + '-' + uid;
      }

      return key;
    }

    function getMfarId() {
      return trAuth.getLastFormResp('trta1-mfa-notifydevice').data.id;
    }

    function getTruid() {
      var authSuccessEvt = trAuth.seekObjPath('data.authSuccessEvt', options, true);
      var token = authSuccessEvt &&
                  authSuccessEvt.detail &&
                  authSuccessEvt.detail.data &&
                  authSuccessEvt.detail.data.tokenValue;
      if(!token) {
        return null;
      }
      var decodedJWT = window.jwt_decode(token);
      var truid = decodedJWT.sub;
      return truid;
    }

    trAuth.listen('trta1-mfa-approvecode-success', function() {
      secondFactorRequestSuccessful(getMfarId());
    }, rootElem);

    function secondFactorRequestSuccessful(mfarId) {
      if (options.flow.type === 'auth-2nd-factor') {
        var token = options.flow.data.jwt;
        var detail = { data: {
          mfarId: mfarId,
          token: token,
          decodedToken: window.jwt_decode(token)
        }};

        options.state.exitCode = 0; // success

        // todo: deprecate; for now keep backwards compat with 1.23.0
        detail.data.jwt = token;
        trAuth.trigger('tr-auth-2nd-factor-success', detail);
        // end

        trAuth.trigger('tr-auth-success', detail);

        trAuth.modules.auth.destroy();
      } else { // get Onvio full priv JWT
        trAuth.changeForm('trta1-mfa-retrievetoken', rootElem);
      }
    }

    // .trta1-mfs-go button click
    trAuth.listen('trta1-mfsrequired-enter', function(evt) {
      setupMFA('trta1-mfsrequired', evt.detail.key);
    }, rootElem);

    trAuth.listen('trta1-auth-success', function() {
      storeSigninData();
    }, signinForm);

    trAuth.listen('trta1-migrationcheck-success', function(evt) {
      var destForm = evt.detail.data.migrationStarted === true ? 'trta1-signin' : 'trta1-intro';
      trAuth.changeForm(destForm, rootElem);
    }, rootElem);

    trAuth.listen('trta1-pwdreset-enter', function(evt) {
      var type = evt.detail && evt.detail.type,
        cpid = evt.detail && evt.detail.key,
        auth = evt.detail && evt.detail.auth,
        payload, headers;

      if (type === 'PASSWORD_EXPIRED') {
        pwdResetForm.classList.add('trta1-pwdexpired');
      } else if (type === 'PASSWORD_EXPIRING') {
        pwdResetForm.classList.add('trta1-pwdexpiring');
      }
      if (cpid) {
        payload = trAuth.seekObjPath('formOverrides.trta1-pwdreset.payload', options, true);
        payload.cpid = cpid;
      }
      if (auth) {
        /*
          Profiles does not have an endpoint to accept a JWT for PW reset. We
          are going to send that case to AuthAgg, since long term we want all PW
          reset going there anyway
        */
        var action = evt.target && evt.target.action;
        if(action) {
          var actionHost = action.substring(0, action.indexOf('api'));
          evt.target.action = actionHost + 'api/auth/v1/password';
          evt.target.querySelector("[name=password]").name = 'pwd';
          evt.target.querySelector("[name=password2]").name = 'pwd2';
          headers = trAuth.seekObjPath('formOverrides.trta1-pwdreset.headers', options, true);
          headers.authorization = 'Bearer ' + auth;
          headers['content-type'] = 'application/json;charset=utf-8';
        }
      }
    }, rootElem);

    trAuth.listen('trta1-pwdreset-exit', function() {
      // clean up state from trta1-pwdreset-enter
      pwdResetForm.classList.remove('trta1-pwdexpired');
      pwdResetForm.classList.remove('trta1-pwdexpiring');
    }, pwdResetForm);

    // trAuth.listen('trta1-pwdreset-success', function() {
      // todo: figure out a better way to do auto login after pwd reset
      // var uid = options.formOverrides['trta1-pwdreset'].payload.uid;
      // if (uid) {
      //   signinUidInput.value = uid;
      //   signinPwdInput.value = pwdResetForm.elements.pwd.value;
      //   trAuth.changeForm('trta1-signin', rootElem);
      //   trAuth.trigger('submit', null, signinForm);
      // } else {
      // }
    // }, pwdResetForm);

    trAuth.listen('trta1-reqpwdreset-enter', function() {
      // sync email/login from signin
      reqPwdResetForm.elements.uid.value = signinUidInput.value;
    }, reqPwdResetForm);

    trAuth.listen('trta1-requnlock-complete-enter', function(evt) {
      trAuth.updateFormState(evt.target, 'success', options, 'unlockAcct');
    }, rootElem);

    // validation for password reset pwd pwdconfirm match
    trAuth.listen('input propertychange', function(evt) {
      if (resetPwds[1].setCustomValidity) { // feature check so IE9 won't throw
        if(resetPwds[0].value !== resetPwds[1].value) {
          resetPwds[1].setCustomValidity($t('Passwords Don\'t Match'));
        } else {
          resetPwds[1].setCustomValidity('');
        }
      }
      if (evt.target === resetPwds[0]) {
        trAuth.trigger('propertychange', null, resetPwds[1]);
      }
    }, pwdResetForm);

    // show/hide toggles for pwdReset
    trAuth.listen('click', function(evt) {
      switch(evt.target.id) {
        case 'trta1-toggle-pwd-requirements':
        case 'trta1-toggle-expired-pwd-requirements':
          pwdResetForm.querySelector('#trta1-pwd-requirements').classList.toggle('trta1-hide');
          evt.preventDefault();
          break;
        case 'trta1-pwd-showtyping':
          Array.from(resetPwds).forEach(function(field) {
            field.type = 'text';
          });
          evt.target.classList.add('trta1-hide');
          evt.target.nextElementSibling.classList.remove('trta1-hide');
          evt.preventDefault();
          break;
        case 'trta1-pwd-hidetyping':
          Array.from(resetPwds).forEach(function(field) {
            field.type = 'password';
          });
          evt.target.classList.add('trta1-hide');
          evt.target.previousElementSibling.classList.remove('trta1-hide');
          evt.preventDefault();
          break;
      }
    }, pwdResetForm);

    // factor types
    // P=TRPushApp, T=3rdPartyTOTPApp, C=emergencyAccessCode, B=24hrBackupCode
    var factorTypeValue = { P: 1, T: 2, C: 3, B: 4 };
    var unsupportedFactorValue = 10;
    trAuth.listen('trta1-mfa-notifydevice-enter', function(evt) {
      var formPayload = trAuth.seekObjPath('formOverrides.trta1-mfa-notifydevice.payload', options, true);
      // copy and sort factors
      // so that the last 'push' device registered sorts to top
      formPayload.factors = evt.detail.data.slice().sort(function (a, b) {
        var aCreateDate = new Date(a.registered),
          bCreateDate = new Date(b.registered);

        // ascending order on factor value, descending order on create time
        // accommodate not-yet-supported factors
        return (factorTypeValue[a.type] || unsupportedFactorValue) - (factorTypeValue[b.type] || unsupportedFactorValue) ||
          bCreateDate.getTime() - aCreateDate.getTime();
      });
    }, rootElem);

    trAuth.listen('trta1-mfa-notifydevice-success', function(evt) {
      var formPayload = trAuth.seekObjPath('formOverrides.trta1-mfa-notifydevice.payload', options, true);
      var pushFactors = formPayload.factors.filter(function(factor) {
        return factor.type === 'P';
      });

      // If there are no emergency access codes, generate them after MFA
      // var hasCodes = formPayload.factors.filter(function(factor){
      //   return factor.type === 'C';
      // }).length > 0;
      // options.generateCodes = !hasCodes;

      // Only occurs when killswitch is on. If so, trigger success
      if (evt.detail.data && evt.detail.data.status === 'SUCCEEDED'){
        options.flow.type = 'auth-2nd-factor'
        secondFactorRequestSuccessful();
        return;
      }

      trAuth.changeForm('trta1-mfa-' + (pushFactors.length ? 'awaitapproval': 'approvecode'), rootElem, evt.detail);
    }, rootElem);

    var cancelAwaitApprovalPoll;
    trAuth.listen('trta1-mfa-awaitapproval-enter', function(evt) {
      var form = evt.target;
      var mfarId = getMfarId();

      form.action = form.action.replace(/\/[^/]*$/, '/' + mfarId);

      // poll for success
      cancelAwaitApprovalPoll = trAuth.pollFormRequest(
        form,
        // test fn
        function(evt) {
          return evt.detail.data.status === 'SUCCEEDED';
        },
        // success fn
        function() {
          secondFactorRequestSuccessful(mfarId);
        },
        // timeout fn
        function() {
          trAuth.updateFormState(form, 'error', options, 'timeout');
          /*
            Just double checking that we are stand in the correct form.
            The service provider is desktop only for now
            The help link will be available for US only at this time,
              so the isAValidDomain() function just check if the domain is a US one
          */
          if(form.name==="trta1-mfa-awaitapproval" && options.sp==="csdesktop" && isAValidDomain()){
            /* Doing this to make sure that the hyperlink will be added as html and not as plain text */
            form.querySelector('.trta1-form-msg').innerHTML+= "<br>" + $t("Refer to <a class=\"trta1-howAndHelp-link\" target=\"_blank\" rel=\"noopener\" href=\"https://cs.thomsonreuters.com/ua/login_security/cs_us_en/mfa-troubleshooting.htm\"> Help & How To Center </a> for possible solutions");
          }
        }
        // roll with defaults for rest of params
        // errorFn = null, delay = 2, timeout = 40, leadingEdge = false, continueOnError = false
      );

    }, rootElem);

    trAuth.listen('trta1-mfa-awaitapproval-exit', function() {
      if (cancelAwaitApprovalPoll) {
        cancelAwaitApprovalPoll();
        cancelAwaitApprovalPoll = null;
      }
    }, rootElem);

    trAuth.listen('trta1-mfa-retrievetoken-enter', function(evt) {
      var form = evt.target;
      form.action = form.action.replace(/\/[^/]*$/, '/' + getMfarId());
    }, rootElem);

    trAuth.listen('trta1-operating-system-check-enter', function(evt) {
      var form = evt.target;
      var nagPayload = trAuth.seekObjPath('formOverrides.trta1-operating-system-check.payload', options, true);
      nagPayload.key = 'Windows7';
      form.action = form.action.replace(/\/[^/]*$/, '/' + getTruid());
    }, rootElem);

    trAuth.listen('trta1-operating-system-check-success', function(evt) {
      var nextForm = 'trta1-postauth';
      var nagData = evt.detail && evt.detail.data
      evt.detail.data.windowsNag = nagData[0];
      if(!evt.detail.data.windowsNag){
        nextForm = 'trta1-unsupported-operating-system';
      } else {
        var nagDismissDate = getStartOfDaySysTime(evt.detail.data.windowsNag.lastNaggedAt);
        var today = getStartOfDaySysTime();
        var daysSinceNag = Math.max(0, Math.round((today - nagDismissDate) / (24 * 60 * 60 * 1000)));
        if( daysSinceNag >= 14 ) {
          nextForm = 'trta1-unsupported-operating-system';
        }
      }
      options.osChecked = true;
      trAuth.changeForm(nextForm, rootElem, evt.detail);
    }, rootElem);

    // os nag check fails
    trAuth.listen('trta1-operating-system-check-error', function(evt) {
      trAuth.changeForm('trta1-authcomplete', rootElem, evt.detail);
    }, rootElem);

    trAuth.listen('trta1-unsupported-operating-system-enter', function(evt) {

      var form = evt.target;
      var lastWindowsNagTime = evt.detail.data[0];
      form.setAttribute('method', (lastWindowsNagTime ? 'PUT' : 'POST'));
      var authSuccessEvt = trAuth.seekObjPath('data.authSuccessEvt', options, true);
      var token = authSuccessEvt &&
                  authSuccessEvt.detail &&
                  authSuccessEvt.detail.data &&
                  authSuccessEvt.detail.data.tokenValue;
      trAuth.seekObjPath('formOverrides.trta1-unsupported-operating-system.headers', options, true).authorization = 'Bearer ' + token;
      var nagPayload = trAuth.seekObjPath('formOverrides.trta1-unsupported-operating-system.payload', options, true);
      nagPayload.lastNaggedAt = new Date().toISOString();
      nagPayload.userId = getTruid();
      if(lastWindowsNagTime && lastWindowsNagTime.id) nagPayload.id = lastWindowsNagTime.id;
      nagPayload.key = 'Windows7';

    }, rootElem);
    trAuth.listen('trta1-auth0-code-exchange-enter', function(evt) {
      trAuth.seekObjPath('formOverrides.trta1-auth0-code-exchange.payload', options, true).code = options.auth0Code;
      trAuth.seekObjPath('formOverrides.trta1-auth0-code-exchange.payload', options, true).state = options.auth0State;
    }, rootElem);
    trAuth.listen('trta1-auth0-code-exchange-success', function(evt) {
      trAuth.trigger('tr-auth-success', prepareAuthSuccessData(evt, options));
      trAuth.trigger('trta1-auth0-complete-hidden-success', evt.detail);
      trAuth.modules.auth.destroy();
    }, rootElem);
    trAuth.listen('trta1-auth0-code-exchange-error', function (evt) {

      var xhr = new XMLHttpRequest();
      xhr.open('GET', '/api/security/v2/environments', false);
      xhr.send();
      var isAuth0enabled;
      // Check if Auth0 is enabled
      try {
        var iac = JSON.parse(xhr.responseText);
        isAuth0enabled = iac.InfrastructureAccessControls.indexOf('Platform_DisableAuth0Phase2') == -1;

      } catch (error){

      }

      var primaryError = trAuth.getPrimaryError(evt.detail), detail;

      // trigger auth section error event
      // trAuth.trigger('tr-auth-error', evt.detail);

      if (!primaryError) return;

      detail  = { type: primaryError.reason };
      var location = evt.detail && evt.detail.headers && evt.detail.headers.location;

      if(detail.type === 'MFA_AUTHENTICATION_REQUIRED') {
        mfaLocation = location;
        trAuth.changeForm('trta1-mfarequired-screen', rootElem);
      }

      if((detail.type === 'CONTACT_NOT_FOUND_EXCEPTION' || detail.type === 'PRIMARY_PRODUCT_MISMATCHING')) {
        if(isAuth0enabled) {
          trAuth.changeForm('trta1-account-error-auth0-screen', rootElem);

          // show/hide no access to product card
          showNoAccessToProductCard(rootElem, options.type);
        } else{
          trAuth.changeForm('trta1-account-error-screen', rootElem);
        }
        signInLocation = location;
      }

      if(detail.type === 'FIRM_CREDIT_HOLD') {
        if(isAuth0enabled) {
            trAuth.changeForm('trta1-firm-lock-credit-hold-new-screen', rootElem);
          } else{
            trAuth.changeForm('trta1-firm-lock-credit-hold-screen', rootElem);
          }
        signInLocation = location;
      }

      if(detail.type === 'FIRM_LOCKED_OUT') {
        if(isAuth0enabled) {
            trAuth.changeForm('trta1-firm-lock-new-screen', rootElem);
          } else{
            trAuth.changeForm('trta1-firm-lock-credit-hold-screen', rootElem);
          }
        signInLocation = location;
      }
    }, rootElem);
    trAuth.listen('click', function() {
       if(mfaLocation) {
         window.location.href = mfaLocation;
       } else {
         // error, no location in header
         // go to legacy sign-in, may need to update later
         trAuth.changeForm('trta1-signin', rootElem);
       }
    }, rootElem.querySelector('#trta1-mfa-required'));
    trAuth.listen('click', function(evt) {
      window.location = '/login';
    }, rootElem.querySelector('#trta1-back-to-signin'));
    trAuth.listen('trta1-auth0-redirect-enter', function(evt) {
      trAuth.seekObjPath('formOverrides.trta1-auth0-redirect.payload', options, true).type = undefined;
      trAuth.seekObjPath('formOverrides.trta1-auth0-redirect.payload', options, true).sp = undefined;
      trAuth.seekObjPath('formOverrides.trta1-auth0-redirect.payload', options, true).redirectUri = undefined;
      trAuth.seekObjPath('formOverrides.trta1-auth0-redirect.payload', options, true).adjustHash = undefined;
    }, rootElem);
    trAuth.listen('trta1-auth0-redirect-error', function(evt) {
      trAuth.changeForm('trta1-signin-auth0-redirect', rootElem);
    }, rootElem);

    trAuth.listen('trta1-auth0-redirect-success', function(evt) {

      var IACs = evt.detail && evt.detail.data && evt.detail.data.InfrastructureAccessControls;
      if(IACs) {
        var isAuth0Phase2Disabled = IACs.includes('Platform_DisableAuth0Phase2');
        if(isAuth0Phase2Disabled) {
          trAuth.changeForm('trta1-signin-auth0-redirect', rootElem);
        } else {
          trAuth.changeForm('trta1-signin-auth0-redirect', rootElem);
        }
      } else {
        trAuth.changeForm('trta1-signin-auth0-redirect', rootElem);
      }

    }, rootElem);

    trAuth.listen('click', function (){
      retrieveAuth0LoginUri(options.type, options.sp, options.auth0Redirect || location.protocol + '//' + location.host, options.adjustHash)
        .then(function (response) {
          var location = response.headers.get('location');
          if(location) {
            window.location.href = location;
          } else {
            trAuth.changeForm('trta1-signin-auth0-redirect', rootElem);
          }
        }).catch(function() {
          trAuth.changeForm('trta1-signin-auth0-redirect', rootElem);
        });
    }, rootElem.querySelector('#trauth-continue-signin-btn'));

    trAuth.listen('click', function (){
      retrieveAuth0LoginUri(options.type, options.sp, options.auth0Redirect || location.protocol + '//' + location.host, options.adjustHash)
        .then(function (response) {
          var location = response.headers.get('location');
          if(location) {
            window.location.href = location;
          } else {
            trAuth.changeForm('trta1-signin-auth0-redirect', rootElem);
          }
        }).catch(function() {
          trAuth.changeForm('trta1-signin-auth0-redirect', rootElem);
        });
    }, rootElem.querySelector('#trauth-continue-signout-btn'));

    trAuth.listen('trta1-auth0-signin-redirect-enter', function(evt) {
      trAuth.seekObjPath('formOverrides.trta1-auth0-signin-redirect.payload', options, true).redirectUri = location.origin + location.pathname;
    }, rootElem);
    trAuth.listen('trta1-auth0-signin-redirect-error', function(evt) {
      trAuth.changeForm('trta1-signin-auth0-redirect', rootElem);
    }, rootElem);

    trAuth.listen('trta1-auth0-signin-redirect-success', function(evt) {
      var location = evt.detail && evt.detail.headers && evt.detail.headers.location;
      if(location) {
        window.location.href = location;
      } else {
        // error, no location in header
        // go to auth0 sign-in again
        trAuth.changeForm('trta1-signin-auth0-redirect', rootElem);
      }
    }, rootElem);

    trAuth.listen('click', function (){
      trAuth.changeForm('trta1-auth0-signin-redirect', rootElem);
    }, rootElem.querySelector('#trta1-auth0-continue-signin-btn'));

    function getStartOfDaySysTime(sysTime) {
      return (new Date((new Date(sysTime || +new Date())).toDateString())).getTime();
    }

    /**
      Listener that will be called after successful login and/or multi-factor authentiation
      cxg
    **/
    trAuth.listen('trta1-auth-success trta1-mfa-retrievetoken-success', function(evt) {

      // save off the successfully authentication event
      trAuth.seekObjPath('data', options, true).authSuccessEvt = evt;
      rootElem.classList.add('trta1-authcomplete');

      // if codes are required, generate
      if(options.generateCodes) {
        var authKey = evt.detail.data.tokenValue;
        var uid = trAuth.seekObjPath('formOverrides.trta1-signin.values', options).uid;
        trAuth.modules.auth.destroy();
        trAuth.modules.mfs.init(trAuth.objAssignDeep({}, options, {
          title: null,
          startingForm: 'trta1-mfs-emergencycodes-check',
          templateData: {
            uid: uid
          },
          headers: {
            authorization: 'Bearer ' + authKey
          }
        }, options.mfsOptions));

        // listen once for close
        trAuth.listen('tr-dialog-user-closed', function(evt) {
          // let destroy finish
          setTimeout(function() {
            var opts = trAuth.objAssignDeep({}, options, {
              startingForm: 'trta1-signin'
            });

            // if we are closing after a successful device pairing
            if (evt.detail.form === 'trta1-mfs-emergencycodes' || evt.detail.form === 'trta1-mfs-emergencycodes-check') {
              opts.startingForm = 'trta1-postauth';
              var data = { authSuccessEvt: { detail: { data: { tokenValue : authKey}}}};
              opts.data = data;
              opts.templateData.cancelDestForm = 'trta1-signin';

              prepDataForMfaForms(opts, uid, authKey);
            } else {
              clearSigninData();
            }

            trAuth.modules.auth.init(opts);
          });
        }, null, true);
      }
      var nextForm = 'trta1-postauth';

      trAuth.changeForm(nextForm, rootElem, evt.detail);

    }, rootElem);

    trAuth.listen('trta1-postauth-enter', function(evt) {
      var doMultiFactorNag = false,
        nextForm = 'trta1-authcomplete',
        daysTillExp,
        dismissDay,
        mfnagStoredDate,
        mfnagDismissDate,
        daysTillNag;
      var authSuccessEvt = trAuth.seekObjPath('data.authSuccessEvt', options, true);
      var authSuccessEvtType = authSuccessEvt && authSuccessEvt.type;
      var exp = authSuccessEvt.detail && authSuccessEvt.detail.data && authSuccessEvt.detail.data.passwordExpiration;
      var detail = evt.detail;
      // if authentication is successful (without mfa), need to check if we need to nag the user about setting up mfa
      if(!options.disableMfaNag && authSuccessEvtType && authSuccessEvtType === 'trta1-auth-success') {
        var mfNagKey = getMfNagKey();
        // retrieve the stored dismiss date and compare it to today
        if(mfNagKey) {
          mfnagStoredDate = trAuth.store(mfNagKey);
        } else {
          mfnagStoredDate = trAuth.store(MFA_NAG_DISMISS_KEY);
        }

        if(mfnagStoredDate === null) {
          // since we have no date, automatically nag
          doMultiFactorNag = true;
          nextForm = 'trta1-mfnag';
        } else {
          mfnagDismissDate = new Date(mfnagStoredDate);

          // calculate the number of days from dismiss day
          daysTillNag = Math.round(Math.abs(((new Date()).getTime() - mfnagDismissDate.getTime()) / (24 * 60 * 60 * 1000)));
          if(daysTillNag > 30) {
            doMultiFactorNag = true;
            nextForm = 'trta1-mfnag';
          }
        }
      }

      // store the mfa nag incase pwd expiration is needed
      trAuth.store(MFA_SHOULD_NAG_KEY, doMultiFactorNag.toString());

      if( shouldNagOS() ){
        nextForm = 'trta1-operating-system-check';
      }

      // check for password expiring soon
      if (!options.pwdNagged && typeof exp === 'number') {
        daysTillExp = Math.max(0, Math.round((getStartOfDaySysTime(exp) - getStartOfDaySysTime()) / (24 * 60 * 60 * 1000))); // 1 day in ms
        dismissDay = trAuth.store('tr-auth-pwdexp-dismissday');

        if (
          // 5 or less days
          daysTillExp <= 5 &&
          (
            // desktop and first launch (desktop can't use localStorage)
            (options.sp === 'csdesktop' && options.payload.launchReason === 'InitialLogin') ||
            // not desktop and not dismissed today
            (options.sp !== 'csdesktop' && dismissDay !== (new Date()).toDateString())
          )
        ) {
          nextForm = 'trta1-pwdexpiring';
          if(detail && detail.data) {
            detail.data.daysTillPwdExp = daysTillExp;
          } else {
            detail = { data: { daysTillPwdExp: daysTillExp } };
          }
        }
      }
      trAuth.changeForm(nextForm, rootElem, detail);
    }, rootElem);

    /**
      Listener that will be called when the password reset completion screen is displayed
    **/
    trAuth.listen('click', function() {
      trAuth.changeForm('trta1-postauth', rootElem);
    }, rootElem.querySelector('#trta1-pwdresetcompleteokbtn'));

    trAuth.listen('click', function() {
      trAuth.changeForm('trta1-postauth', rootElem);
    }, rootElem.querySelector('#trta1-pwdresetnetfirmokbtn'));

    trAuth.listen('click', function() {
      options.osNagged = true;
      trAuth.changeForm('trta1-postauth', rootElem);
    }, rootElem.querySelector('#trta1-dismissosnag'));

    /**
      Listener that will be called when the mfa nag screen is displayed
    **/
    trAuth.listen('trta1-mfnag-enter', function(evt) {
      // CXG - I needed the ability to setup nag for NetFirm
      if(options.type === 'netfirm') {
        setupMFA('trta1-mfnag', evt.detail.key || evt.detail.data.tokenValue);
      } else {
        var authSuccessEvt = options.data.authSuccessEvt;
        setupMFA('trta1-mfnag', authSuccessEvt.detail.data.tokenValue);
      }
    }, rootElem);

    // setup mfa...do it later
    trAuth.listen('click', function(evt) {
      var mfNagKey = getMfNagKey();
      if(mfNagKey) {
        trAuth.store(mfNagKey, (new Date()).toDateString());
      } else {
        trAuth.store(MFA_NAG_DISMISS_KEY, (new Date()).toDateString());
      }

      var nextForm = 'trta1-postauth';
      trAuth.changeForm(nextForm, rootElem, evt.detail);

    }, rootElem.querySelector('#trta1-mfs-later'));


    trAuth.listen('trta1-pwdexpiring-enter', function(evt) {
      options.pwdNagged = true;
      var daysTillExp = evt.detail && evt.detail.data.daysTillPwdExp;
      if (typeof daysTillExp !== 'number') return;

      pwdExpiringForm.querySelector('#trta1-pwdexpdays').textContent = daysTillExp;
      pwdExpiringForm.classList[daysTillExp === 0 ? 'add' : 'remove']('trta1-pwdexpireszerodays');
      pwdExpiringForm.classList[daysTillExp === 1 ? 'add' : 'remove']('trta1-pwdexpiresoneday');
    }, rootElem);

    // pwdexpiring do it later
    trAuth.listen('click', function(evt) {
      trAuth.store('tr-auth-pwdexp-dismissday', (new Date()).toDateString());
      var nextForm = 'trta1-postauth';

      trAuth.changeForm(nextForm, rootElem, evt.detail);

    }, rootElem.querySelector('#trta1-chgpwdlaterbtn'));

    // pwdexpiring change now
    trAuth.listen('click', function(evt) {
      evt.preventDefault();

      // todo: when services support pwd reset for NF users remove this
      if (/^(netfirm|netfirmrest)$/i.test(options.data.authSuccessEvt.detail.data.domain)) {
        trAuth.changeForm('trta1-pwdreset-netfirm', rootElem);
      } else {
        trAuth.changeForm('trta1-pwdreset', rootElem, {
          auth: options.data.authSuccessEvt.detail.data.tokenValue,
          type: 'PASSWORD_EXPIRING'
        });
      }
    }, rootElem.querySelector('#trta1-chgpwdnowbtn'));

    trAuth.listen('trta1-authcomplete-enter', function() {
      // set values in DOM for desktop to retrieve, #8442
      var form = rootElem.querySelector('form[name=trta1-signin]'),
        overrides = options.formOverrides['trta1-signin'];
      if (overrides.values) {
        Object.keys(overrides.values).forEach(function(fieldName) {
          var value = overrides.values[fieldName];
          // jshint eqnull:true
          if (value == null) return;

          form.elements[fieldName].value = value;
        });
      }

      setTimeout(function() {
        options.state.exitCode = 0; // success
        // trigger auth section success event

        trAuth.trigger('tr-auth-success', prepareAuthSuccessData(options.data.authSuccessEvt, options));
        // delay to next execution cycle so event can bubble
        setTimeout(function() {
          // blank out uid/pwd to keep things secure
          signinUidInput.value = '';
          signinPwdInput.value = '';
        });
      }, 125); // wait 1/8 beat
    }, rootElem);

    // Cleanup
    trAuth.listen('tr-dialog-before-destroy', dialogBeforeDestroy, null);
    function dialogBeforeDestroy() {
      trAuth.modules.auth.destroy(true);
    }
    trAuth.modules.auth.destroy = function(dialogTriggered) {
      if (rootElem) {
        trAuth.unlisten('tr-dialog-before-destroy', dialogBeforeDestroy, null);
        trAuth.trigger('tr-auth-exit', { data: { exitCode: options.state.exitCode }});
        document.documentElement.classList.remove('trta1-auth-active');
        rootElem = null;
      }
      if (!dialogTriggered) trAuth.destroy();
    };

    // setup debug
    if (options.payload && options.payload.firmId) {
      var el;
      if (window.trAuth.shadowDomElem) {
        el = window.trAuth.shadowDomElem;
      } else {
        el = document;
      }
      el.querySelector('.trta1-debug').textContent = 'fid:' + options.payload.firmId;
    }

    // ready
    document.documentElement.classList.add('trta1-auth-active');
    trAuth.trigger('tr-auth-ready', options);
    trAuth.moduleReady(rootElem, options);

    return trAuth.getRootElem();
  }

  trAuth.modules.auth = {
    init: init
  };

  function retrieveAuth0LoginUri(type, sp, redirectUri, adjustHash) {
    var domain = window.location.origin.match(/^https?\:\/\/([^\/?#]+)(?:[\/?#]|$)/i)[1].split('onvio')[1];
    var cookieLangValue = (document.cookie.match('(^|; )BMLanguageCode=([^;]*)') || '')[2];
    var locale;

    switch (domain) {
      case '.com.ar':
        locale = 'es-AR';
        break;
      case '.com.br':
        locale = (cookieLangValue)? cookieLangValue: 'pt-BR';
        break;
      case '.co.uk':
        locale = 'en-GB';
        break;
      case '.ca':
        locale = (cookieLangValue)? cookieLangValue: 'en-CA';
        break;
      case '.us':
      default:
        locale = 'en-US';
        break;
    }

    // Set default locale for onbalance.thomsonreuters.com.br and onbalance.thomsonreuters.com.ar
    domain = window.location.origin.match(/^https?\:\/\/([^\/?#]+)(?:[\/?#]|$)/i)[1].split('onbalance.thomsonreuters')[1];
    switch (domain) {
      case '.com.br':
        locale = 'pt-BR';
        break;
      case '.com.ar':
        locale = 'es-AR';
        break;
    }

    // Take the proper locale to test in localhost
    if(window.location.hostname.toLowerCase() === 'localhost'){
      locale = (cookieLangValue)? cookieLangValue: 'en-US';
    }

    return fetch('/api/security/v1/oidc/login', {
      method: 'post',
      headers: {
        'Content-Type': 'application/json;charset=utf-8',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        type: type,
        sp: sp,
        redirectUri: redirectUri,
        adjustHash: adjustHash,
        lang: locale
      })
    });
  }

  function isAValidDomain(){
    var domain = window.location.origin.match(/^https?\:\/\/([^\/?#]+)(?:[\/?#]|$)/i)[1].split('onvio')[1];

    switch (domain) {
      case '.us': return true;
      default: return false;
    }
  }

  function hideSystemStatus(){
    var url = window.location.origin;
    var domain = url.match(/^https?\:\/\/([^\/?#]+)(?:[\/?#]|$)/i)[1].split('onvio')[1];
    // Disable system status link on BR and AR region, is enabled for any other region
    switch (domain) {
      case '.com.br':
          return true;
      case '.com.ar':
          return true;
      case '.ca':
          return true;
    }
    // Disable system status link in onbalance.thomsonreuters.com.br and onbalance.thomsonreuters.com.ar
    domain = url.match(/^https?\:\/\/([^\/?#]+)(?:[\/?#]|$)/i)[1].split('onbalance.thomsonreuters')[1];
    switch (domain) {
      case '.com.br':
        return true;
      case '.com.ar':
        return true;
    }
    return false;
  }

  function retrieveAboutAccountSecLink(){
    var domain = window.location.origin.match(/^https?\:\/\/([^\/?#]+)(?:[\/?#]|$)/i)[1].split('onvio')[1];

    switch (domain) {
      case '.co.uk':
        return '/ua/help/gb-en/staff/core/setup/2sv-overview.htm';
      case '.us':
      default:
        return '/ua/help/us-en/staff/core/setup/2sv-overview.htm';
    }
  }

  // Return the message Contact your Onvio administrator.
  function getAppMessageAdministrator(type){
    switch (type) {
      case 'employeeportal':
      case 'onbalance':
        return 'Contact your administrator.';
      // For onvio and other cases
      default:
        return 'Contact your Onvio administrator.';
    }
  }

  function showNoAccessToProductCard(rootElem, type){
    var domain = window.location.origin.match(/^https?\:\/\/([^\/?#]+)(?:[\/?#]|$)/i)[1].split('onvio')[1];
    if (domain !== '.com.br') return;

    if (type === 'onvio') {
      // hide basic instructions card
      var accountErrorBasicInstructionsCard = rootElem.querySelector('form.auth0-login-form[name="trta1-account-error-auth0-screen"] div.trta1-form-instructions');
      accountErrorBasicInstructionsCard.classList.add('trta1-hide');

      // show select module instructions card
      var accountErrorNoAccessToModulesCard = rootElem.querySelector('form.auth0-login-form[name="trta1-account-error-auth0-screen"] div.trta1-form-instructions-no-access-to-module');
      accountErrorNoAccessToModulesCard.classList.remove('trta1-hide');
    }
  }

  function fetchAuthCodeSessionsV2IACStatus() {
    var xhr = new XMLHttpRequest();
    xhr.open('GET', '/api/security/v2/environments', false);
    xhr.send();

    // check in iacs if Platform_EnableOnvioSTID is there if yes return true.This will call v2/oidc/auth-code/session endpoint in place
    // of v1/oidc/auth-code/session to get OnvioSTID (new jwt)
    try {
      var iac = JSON.parse(xhr.responseText);
      var isV2Enabled = iac.InfrastructureAccessControls.indexOf('Platform_EnableOnvioSTID') != -1;
      return isV2Enabled;
    } catch (error) {
      // If there is an error just continue and it will show the legacy form
      window.console.log('Could not get IACs, so continue with the previous flow');
      return false;
    }
  }

})(window);
(function(window) {
  'use strict';

  var trAuth = window.trAuth;

  var appleStoreLangCodeMap = {
    'en-US': 'en-us',
    'en-AU': 'en-us',
    'en-CA': 'en-us',
    'en-GB': 'en-us',
    'en-IN': 'en-us',
    'es-AR': 'es-mx',
    'fr-CA': 'fr-ca',
    'nl-NL': 'nl-nl',
    'pt-BR': 'pt-br'
  };
  var googleStoreLangCodeMap = {
    'en-US': 'en',
    'en-AU': 'en',
    'en-CA': 'en',
    'en-GB': 'en',
    'en-IN': 'en',
    'es-AR': 'es-419',
    'fr-CA': 'fr-ca',
    'nl-NL': 'nl',
    'pt-BR': 'pt-br'
  };

  var otpauthTemplate = 'otpauth://totp/<%= env %>Thomson%20Reuters%20ID:<%= uid %>?secret=<%= otpSecret %>&issuer=<%= env %>Thomson%20Reuters%20ID&algorithm=SHA1&digits=6&period=30&a=<%= factorId %>&m=<%= mfarId %>&url=<%= url %>';

  /* jshint multistr: true */
  var moduleTemplate = '\
    <section id="trta1-mfs" aria-label="Multi-Factor Authentication Setup">\
      <h1 t8 class="trta1-print-only" area-hidden="true">Thomson Reuters</h1>\
      <h2 t8 role="heading">Multi-Factor Authentication Setup</h2>\
      <button data-trta1-dest="trta1-$close" class="trta1-dialog-close" autofocus aria-label="Close" role="button" aria-hidden="true">&times;</button>\
      <form name="trta1-mfs-intro">\
        <div class="trta1-form-instructions" tabindex="-1">\
          <h3 class="trta1-heading-inner" t8>Increase security for your account</h3>\
          <p t8>Passwords can be hacked, but using multi-factor authentication adds another layer of security to your account.</p>\
          <h3 class="trta1-heading-inner" t8>How long will it take to set up?</h3>\
          <p t8>A few minutes.</p>\
          <h3 class="trta1-heading-inner" t8>How will this affect me?</h3>\
          <p t8>You will need to approve each sign-in request on your device each time you sign in with this account.</p>\
        </div>\
        <div class="trta1-btn-group">\
          <div><button t8 data-trta1-dest="trta1-$close" type="button" aria-label="cancel">Cancel</button></div>\
          <div><button t8 data-trta1-dest="trta1-mfs-choosetype" class="trta1-btn-primary-get" aria-label="Get Started">Get Started</button></div>\
        </div>\
      </form>\
      <form name="trta1-mfs-install">\
        <h3 t8>Download and install Thomson Reuters Authenticator app</h3>\
        <div class="trta1-form-instructions">\
          <p t8>On your mobile device, open the app store and download and install the <b>Thomson Reuters Authenticator</b> app.</p>\
          <p>\
            <a t8 target="_blank" rel="noopener" class="trta1-type-trid-only trta1-type-onvio-only" href="<%= onvioHelpDomain %>/ua/help/<%= onvioHelpLangCode %>/<%= onvioHelpUserType %>/core/common/thomson-reuters-authenticator-installation-and-permissions.htm">Tell me how</a>\
            <a t8 target="_blank" rel="noopener" class="trta1-type-netfirm-only trta1-type-csweb-only" href="http://cs.thomsonreuters.com/ua/login_security/cs_us_en/mfa-setup.htm#app">Tell me how</a>\
            <a t8 target="_blank" rel="noopener" class="trta1-type-netfirmdt-only" href="https://cs.thomsonreuters.com/ua/netfirm/nc_drtax_<%= dtHelpLocale %>/common/thomson-reuters-authenticator-installation-and-permissions.htm">Tell me how</a>\
          </p>\
          <ul class="shield-bg">\
            <li><a target="_blank" rel="noopener" class="trta1-appleStore-link" href="https://itunes.apple.com/<%= appleStoreCountryCode %>/app/thomson-reuters-authenticator/id1155604687?mt=8&l=<%= appleStoreLangCode %>" style="display:inline-block;overflow:hidden;background:url(//linkmaker.itunes.apple.com/assets/shared/badges/<%= appleStoreLangCode %>/appstore-lrg.svg) no-repeat;width:135px;height:40px;background-size:contain;"></a></li>\
            <li><a target="_blank" rel="noopener" class="trta1-googleStore-link" href="https://play.google.com/store/apps/details?id=com.thomsonreuters.trta.authenticator&pcampaignid=MKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1&hl=<%= googleStoreLangCode %>"><img src="https://play.google.com/intl/en_us/badges/images/generic/<%= googleStoreLangCode %>_badge_web_generic.png"></a></li>\
            <!--li><a t8 id="trta1-authapp-email-link" href="javascript:void(0)">Email me a link</a></li-->\
          </ul>\
          <p t8>After installing and opening the app, click Next.</p>\
        </div>\
        <div class="trta1-btn-group">\
          <div><button t8 data-trta1-dest="trta1-mfs-choosetype" type="button">Back</button></div>\
          <div><button t8 data-trta1-dest="trta1-mfs-gencode" class="trta1-btn-primary">Next</button></div>\
        </div>\
      </form>\
      <form name="trta1-mfs-3p-install">\
        <h3 t8>Download and install an alternate multi-factor app</h3>\
        <div class="trta1-form-instructions">\
          <p>\
            <a t8 target="_blank" rel="noopener" class="trta1-type-trid-only trta1-type-onvio-only" href="<%= onvioHelpDomain %>/ua/help/<%= onvioHelpLangCode %>/<%= onvioHelpUserType %>/core/common/learning-about-third-party-multi-factor-apps.htm">Learn more about third-party MFA apps</a>\
            <a t8 target="_blank" rel="noopener" class="trta1-type-netfirm-only trta1-type-csweb-only" href="http://cs.thomsonreuters.com/ua/login_security/cs_us_en/mfa-setup.htm#choosemfa">Learn more about third-party MFA apps</a>\
            <a t8 target="_blank" rel="noopener" class="trta1-type-netfirmdt-only" href="https://cs.thomsonreuters.com/ua/netfirm/nc_drtax_<%= dtHelpLocale %>/common/learning-about-third-party-multi-factor-apps.htm">Learn more about third-party MFA apps</a>\
          </p>\
          <p t8>The alternate method must be time-based one time password (TOTP) compliant. Download now at the <a target="_blank" rel="noopener" href="https://itunes.apple.com/<%= appleStoreCountryCode %>/app/thomson-reuters-authenticator/id1155604687?mt=8&l=<%= appleStoreLangCode %>">Apple App Store</a> or the <a target="_blank" rel="noopener" href="https://play.google.com/store/apps/details?id=com.thomsonreuters.trta.authenticator&pcampaignid=MKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1&hl=<%= googleStoreLangCode %>">Google Play Store</a>.</p>\
          <p t8 class="thirdparty-app-bg">After installing and opening the app, click Next.</p>\
        </div>\
        <div class="trta1-btn-group">\
          <div><button t8 data-trta1-dest="trta1-mfs-choosetype" type="button">Back</button></div>\
          <div><button t8 data-trta1-dest="trta1-mfs-gencode" class="trta1-btn-primary">Next</button></div>\
        </div>\
      </form>\
      <form name="trta1-mfs-gencode" method="post" action="<%= authSvcHost %>/api/mfa/v1/factors" novalidate>\
        <div class="trta1-form-instructions">\
          <p t8>Generating QR code.</p>\
        </div>\
        <input type="hidden" name="type" value="T">\
        <input type="hidden" name="address" value="TOTP">\
        <div class="trta1-btn-group">\
          <div><button t8 data-trta1-dest="trta1-mfs-choosetype" type="button">Back</button></div>\
          <div><button t8 data-trta1-dest="trta1-$retry">Retry</button></div>\
        </div>\
      </form>\
      <form name="trta1-mfs-devicelookup" method="get" action="<%= authSvcHost %>/api/mfa/v1/factors/_id_" tr-autosubmit tr-goto-onsuccess="trta1-mfs-paired" novalidate>\
        <div class="trta1-form-instructions">\
          <p t8>Retrieving device info.</p>\
        </div>\
        <div class="trta1-btn-group">\
          <div><button t8 data-trta1-dest="<%= cancelDestForm %>" type="button">Cancel</button></div>\
          <div><button t8 data-trta1-dest="trta1-$retry">Retry</button></div>\
        </div>\
      </form>\
      <form name="trta1-mfs-emergencycodes-check" method="get" action="<%= authSvcHost %>/api/mfa/v1/factors" tr-autosubmit novalidate>\
      </form>\
      <form name="trta1-mfs-paired" method="put" action="<%= authSvcHost %>/api/mfa/v1/factors/_id_" novalidate>\
        <div class="trta1-form-instructions">\
          <h3 t8 class="success-shield-bg">Pairing Successful!</h3>\
          <p t8>You have set up multi-factor authentication for your account. You will need to approve each sign-in request on your device each time you sign in with this account.</p>\
          <!--p t8>You have paired your account with <b id="trta1-mfs-devicename">this device</b>.</p>\
          <h4 t8>What can I expect?</h4>\
          <p t8>You will need to approve each sign-in request on your device each time you sign in with this account. To add or remove a paired device, go to your account settings.</p>\
          <h4 t8>What\'s left to do?</h4>\
          <p t8>Name your device. Confirm the pairing. Generate emergency access codes.</p>\
          <h4 t8>Need help?</h4>\
          <p><a t8 target="_blank" rel="noopener" href="">Learn more about the new security system.</a></p-->\
          <label><span t8>Name this multi-factor option</span>\
            <input type="text" name="device-name" required pattern=".*\\S+.*" maxlength="250" tr-nosend>\
          </label>\
          <p>\
            <a t8 target="_blank" rel="noopener" class="trta1-type-trid-only trta1-type-onvio-only" href="<%= onvioHelpDomain %>/ua/help/<%= onvioHelpLangCode %>/<%= onvioHelpUserType %>/core/common/understanding-next-steps-after-multi-factor-authentication-setup.htm">Next steps after setting up MFA</a>\
            <a t8 target="_blank" rel="noopener" class="trta1-type-netfirm-only trta1-type-csweb-only" href="https://cs.thomsonreuters.com/ua/login_security/cs_us_en/understanding-next-steps-after-multi-factor-authentication-setup.htm">Next steps after setting up MFA</a>\
            <a t8 target="_blank" rel="noopener" class="trta1-type-netfirmdt-only" href="https://cs.thomsonreuters.com/ua/netfirm/nc_drtax_<%= dtHelpLocale %>/common/understanding-next-steps-after-multi-factor-authentication-setup.htm">Next steps after setting up MFA</a>\
          </p>\
        </div>\
        <div class="trta1-btn-group">\
          <button t8>Finish</button>\
        </div>\
      </form>\
    ' +

    // Append templates for external es modules
    trAuth.submodules.chooseType.template +
    trAuth.submodules.scanCode.template +
    trAuth.submodules.registerDevice.template +
    trAuth.submodules.emergencyCodes.template +
    trAuth.submodules.pairDevice.template +

    '</section>\
  ';
  /* jshint multistr: false */

  function init(options) {
    var rootElem, qrCodeContainer, deviceNameInput;

    options = options || { locale: 'en-US' };

    var $t = trAuth.getTranslateFn(options.locale);
    var defaultOptions = {
      type: 'trid',
      enableMFACards: false,
      enableThirdPartyApp: true,
      templateData: {
        authSvcHost: 'https://onvio.us',
        onvioHelpDomain: 'https://onvio.us',
        onvioHelpUserType: 'staff',
        cancelDestForm: 'trta1-$start',
      },
      formOverrides: {
        'trta1-mfs-gencode': {
          payload: {
            name: 'device'
          }
        },
        'trta1-mfs-scancode': {
          formStateMessages: {
            // only display form state msgs for error
            'processing': null,
            'success': null,
            'error': {
              'timeout': $t('Timed out waiting for scan. Please go back and try again.'),
              'unauthorized': $t('Invalid code. Please try again.'),
              '401': $t('Invalid code. Please try again.')
            }
          }
        },
        'trta1-mfs-pairdevice': {
          formStateMessages: {
            'error': {
              'bad request': $t('Incorrect Device ID or Code. Please try again.'),
              '400': $t('Incorrect Device ID or Code. Please try again.'),
              'unauthorized': $t('Incorrect Device ID or Code. Please try again.'),
              '401': $t('Incorrect Device ID or Code. Please try again.')
            }
          }
        }
      }
    };

    options = trAuth.objAssignDeep({}, trAuth.getDefaultOptions(options.locale), defaultOptions, options);

    // if init of trid fails, exit
    if (!trAuth.init(options)) return;

    var tmplData = trAuth.objAssignDeep({}, options.templateData, {
      onvioHelpLangCode: options.locale.toLowerCase().split('-').reverse().join('-'),
      dtHelpLocale: options.locale.toLowerCase().split('-').reverse().join('_'),
      digitaHelpLocale: options.locale.toLowerCase().split('-').reverse().join('_'),
      appleStoreCountryCode: options.locale.split('-')[1].toLowerCase(),
      appleStoreLangCode: appleStoreLangCodeMap[options.locale],
      googleStoreLangCode: googleStoreLangCodeMap[options.locale]
    });

    rootElem = trAuth.renderTemplate(trAuth.template(moduleTemplate, options), tmplData, null, null, options.locale);

    qrCodeContainer = rootElem.querySelector('.trta1-mfs-qrcode');
    deviceNameInput = rootElem.querySelector('form[name=trta1-mfs-paired] input[name=device-name]');

    // initialize submodules
    trAuth.submodules.chooseType.init(rootElem, options, trAuth);
    trAuth.submodules.scanCode.init(rootElem, options, trAuth);
    trAuth.submodules.registerDevice.init(rootElem, options, trAuth);
    trAuth.submodules.emergencyCodes.init(rootElem, options, trAuth);
    trAuth.submodules.pairDevice.init(rootElem, options, trAuth);

    trAuth.listen('trta1-mfs-gencode-enter', function(evt) {
      // if we've already got a code, continue
      if (options.state.qrCode) {
        trAuth.changeForm('trta1-mfs-scancode', rootElem);
        return;
      }

      trAuth.trigger('submit', null, evt.target);
    }, rootElem);

    trAuth.listen('trta1-mfs-gencode-success', function(evt) {
      var tmpl = otpauthTemplate,
        svcUrl = options.templateData.authSvcHost,
        qrTmplDataOverrides = { uid: encodeURIComponent(options.templateData.uid) },
        // note: not an ideal way to get ENV
        env = svcUrl.replace(/^https?:\/\/([^/]+).*$/, function(url, host) {
          env = host.split('.')[0];
          if (/^(ci|demo|qed)$/.test(env)) return env.toUpperCase() + '%20';
          if (/^(localhost(:\d+)?|\d+)$/.test(env)) return 'LOCAL';
          return ''; // leave PROD blank
        }),
        qrText;

      // use state bag for factorData, so subsequent steps will have what they need
      options.state.factorData = evt.detail.data;

      // add proper override data to qrText based on env
      if (env === 'LOCAL') {
        // default svc url to demo
        qrTmplDataOverrides.url = encodeURIComponent('https://demo.onvio.us');
        qrTmplDataOverrides.env = 'DEMO%20';
      } else { // otherwise
        qrTmplDataOverrides.url = encodeURIComponent(svcUrl);
        qrTmplDataOverrides.env = env;
      }

      qrText = trAuth.template(tmpl, options)(trAuth.objAssignDeep({}, evt.detail.data, qrTmplDataOverrides));
      // Clean up since QRCode lib won't if it created nodes previously
      while (qrCodeContainer.firstChild) {
        qrCodeContainer.removeChild(qrCodeContainer.firstChild);
      }
      options.state.qrCode = new window.QRCode(qrCodeContainer, {
          text: qrText,
          width: 207,
          height: 207,
          colorDark : "#000000",
          colorLight : "#ffffff",
          correctLevel : window.QRCode.CorrectLevel.L
      });

      // remove tooltip that qrCode puts in
      qrCodeContainer.removeAttribute('title');
      trAuth.changeForm('trta1-mfs-scancode', rootElem, evt.detail);
    }, rootElem);

    trAuth.listen('trta1-mfs-devicelookup-enter', function(evt) {
      var form = evt.target;
      form.action = form.action.replace(/\/[^/]*$/, '/' + options.state.factorData.factorId);
    }, rootElem);

    trAuth.listen('trta1-mfs-paired-enter', function(evt) {
      var form = evt.target;
      form.action = form.action.replace(/\/[^/]*$/, '/' + trAuth.getLastFormResp('trta1-mfs-devicelookup').data.id);
      var deviceName = evt.detail.data && evt.detail.data.name || options.state.$t('Thomson Reuters Authenticator Card');
      if (deviceName) {
        // plug device name into paragraph
        // rootElem.querySelector('#trta1-mfs-devicename').textContent = deviceName;
        deviceNameInput.value = deviceName;
      }
    }, rootElem);

    trAuth.listen('submit', function() {
      var factor = trAuth.getLastFormResp('trta1-mfs-devicelookup').data;
      factor.name = deviceNameInput.value;
      trAuth.seekObjPath('formOverrides.trta1-mfs-paired', options, true).payload = factor;
    }, rootElem.querySelector('form[name=trta1-mfs-paired]'));

    trAuth.listen('trta1-mfs-paired-success', function(evt) {
      trAuth.changeForm('trta1-mfs-emergencycodes-check', rootElem, evt.detail);
    }, rootElem);

    trAuth.listen('trta1-mfs-emergencycodes-check-success', function(evt){
      var hasCodes = evt.detail.data && evt.detail.data.filter(function(factor){
        return factor.type === 'C';
      }).length > 0;
      if(!hasCodes) {
        trAuth.changeForm('trta1-mfs-emergencycodes', rootElem, evt.detail);
      } else {
        // go to success
        options.state.exitCode = 0; // success
        trAuth.trigger('tr-mfs-success');
        // pause for 1/2 beat before closing dialog so user can see success
        setTimeout(trAuth.changeForm, 500, 'trta1-$close');
      }
    }, rootElem);

    // Cleanup
    trAuth.listen('tr-dialog-before-destroy', dialogBeforeDestroy, null);
    function dialogBeforeDestroy() {
      trAuth.modules.mfs.destroy(true);
    }
    trAuth.modules.mfs.destroy = function(dialogTriggered) {
      if (rootElem) {
        trAuth.unlisten('tr-dialog-before-destroy', dialogBeforeDestroy, null);
        trAuth.trigger('tr-mfs-exit', { data: { exitCode: options.state.exitCode }});
        document.documentElement.classList.remove('trta1-mfs-active');
        rootElem = null;
      }
      if (!dialogTriggered) trAuth.destroy();
    };

    document.documentElement.classList.add('trta1-mfs-active');
    trAuth.trigger('tr-mfs-ready');
    trAuth.moduleReady(rootElem, options);
    return trAuth.getRootElem();
  }

  trAuth.modules.mfs = {
    init: init
  };

})(window);

/*! matchMedia() polyfill - Test a CSS media type/query in JS. Authors & copyright (c) 2012: Scott Jehl, Paul Irish, Nicholas Zakas, David Knight. MIT license */

window.matchMedia || (window.matchMedia = function() {
    "use strict";

    // For browsers that support matchMedium api such as IE 9 and webkit
    var styleMedia = (window.styleMedia || window.media);

    // For those that don't support matchMedium
    if (!styleMedia) {
        var style       = document.createElement('style'),
            script      = document.getElementsByTagName('script')[0],
            info        = null;

        style.type  = 'text/css';
        style.id    = 'matchmediajs-test';

        if (!script) {
          document.head.appendChild(style);
        } else {
          script.parentNode.insertBefore(style, script);
        }

        // 'style.currentStyle' is used by IE <= 8 and 'window.getComputedStyle' for all other browsers
        info = ('getComputedStyle' in window) && window.getComputedStyle(style, null) || style.currentStyle;

        styleMedia = {
            matchMedium: function(media) {
                var text = '@media ' + media + '{ #matchmediajs-test { width: 1px; } }';

                // 'style.styleSheet' is used by IE <= 8 and 'style.textContent' for all other browsers
                if (style.styleSheet) {
                    style.styleSheet.cssText = text;
                } else {
                    style.textContent = text;
                }

                // Test if media query is true or false
                return info.width === '1px';
            }
        };
    }

    return function(media) {
        return {
            matches: styleMedia.matchMedium(media || 'all'),
            media: media || 'all'
        };
    };
}());

/*! matchMedia() polyfill addListener/removeListener extension. Author & copyright (c) 2012: Scott Jehl. MIT license */
(function(){
    // Bail out for browsers that have addListener support
    if (window.matchMedia && window.matchMedia('all').addListener) {
        return false;
    }

    var localMatchMedia = window.matchMedia,
        hasMediaQueries = localMatchMedia('only all').matches,
        isListening     = false,
        timeoutID       = 0,    // setTimeout for debouncing 'handleChange'
        queries         = [],   // Contains each 'mql' and associated 'listeners' if 'addListener' is used
        handleChange    = function(evt) {
            // Debounce
            clearTimeout(timeoutID);

            timeoutID = setTimeout(function() {
                for (var i = 0, il = queries.length; i < il; i++) {
                    var mql         = queries[i].mql,
                        listeners   = queries[i].listeners || [],
                        matches     = localMatchMedia(mql.media).matches;

                    // Update mql.matches value and call listeners
                    // Fire listeners only if transitioning to or from matched state
                    if (matches !== mql.matches) {
                        mql.matches = matches;

                        for (var j = 0, jl = listeners.length; j < jl; j++) {
                            listeners[j].call(window, mql);
                        }
                    }
                }
            }, 30);
        };

    window.matchMedia = function(media) {
        var mql         = localMatchMedia(media),
            listeners   = [],
            index       = 0;

        mql.addListener = function(listener) {
            // Changes would not occur to css media type so return now (Affects IE <= 8)
            if (!hasMediaQueries) {
                return;
            }

            // Set up 'resize' listener for browsers that support CSS3 media queries (Not for IE <= 8)
            // There should only ever be 1 resize listener running for performance
            if (!isListening) {
                isListening = true;
                window.addEventListener('resize', handleChange, true);
            }

            // Push object only if it has not been pushed already
            if (index === 0) {
                index = queries.push({
                    mql         : mql,
                    listeners   : listeners
                });
            }

            listeners.push(listener);
        };

        mql.removeListener = function(listener) {
            for (var i = 0, il = listeners.length; i < il; i++){
                if (listeners[i] === listener){
                    listeners.splice(i, 1);
                }
            }
        };

        return mql;
    };
}());

/*
 * matchmedia-ng (c) 2014 Jason Kulatunga, Inc. | http://analogj.mit-license.org/
 */
(function(window, angular, undefined) {
'use strict';

angular.module("matchmedia-ng", []).
    provider('matchmedia', function (){

        ///////////////////////////////////////////////////////////////////////
        // Configuration
        ///////////////////////////////////////////////////////////////////////
        /**
         *
         * these settings can be changed by injecting matchmediaProvider into
         * the config function of your module and
         * changing the matchmediaProvider.rules with your own rule key value
         * pairs E.G.

         *  angular.module('app').config(['matchmediaProvider', function (matchmediaProvider) {
         *      matchmediaProvider.rules.phone = "(max-width: 500px)";
         *      matchmediaProvider.rules.desktop: = "(max-width: 1500px)";
         *  }]);
         *
         * default values taken from twitter bootstrap :
         * https://github.com/twitter/bootstrap/blob/master/less/responsive-utilities.less
         */
        var matchmedia = {
            rules: {
                print : "print",
                screen : "screen",
                phone : "(max-width: 767px)",
                tablet : "(min-width: 768px) and (max-width: 979px)",
                desktop : "(min-width: 980px)",
                portrait : "(orientation: portrait)",
                landscape : "(orientation: landscape)"
            }
        };
        matchmedia.$get = ['$window','safeApply', 'logger', function($window, safeApply, logger) {

            logger.log('Creating matchmedia');

            ///////////////////////////////////////////////////////////////////////
            // Private Methods
            ///////////////////////////////////////////////////////////////////////
            function createSafeListener(cb, $scope){
                return function(mediaQueryList){
                    safeApply(function() {
                        cb(mediaQueryList);
                    },$scope);
                };
            }

            ///////////////////////////////////////////////////////////////////////
            // Public Methods
            ///////////////////////////////////////////////////////////////////////
            //should never be called directly, but is available for custom calls.
            var matchmediaService = {};

            /**
             * @param {string} query media query to listen on.
             * @param {function(mediaQueryList)} listener Function to call when the media query is matched.
             * @returns {function()} Returns a deregistration function for this listener.
             */
            matchmediaService.on = function(query, listener, $scope) {
                var supportsMatchMedia = $window.matchMedia !== undefined && !!$window.matchMedia('all').addListener;
                if(supportsMatchMedia) {
                    logger.log('adding listener for query: '+ query);
                    var mediaQueryList = $window.matchMedia(query);
                    var handler = createSafeListener(listener, $scope);
                    mediaQueryList.addListener(handler);
                    //immediately return the current mediaQueryList;
                    handler(mediaQueryList);

                    return function() {
                        logger.log('removing listener from query: '+ query);
                        mediaQueryList.removeListener(handler);

                    };
                }
            };
            /**
             * @param {string} query media query to test.
             * @returns {mediaQueryList} Returns a boolean.
             */
            matchmediaService.is = function(query) {
                logger.log('test query: '+ query);
                return $window.matchMedia(query).matches;
            };



            ///////////////////////////////////////////////////////////////////////
            // Aliased Methods
            ///////////////////////////////////////////////////////////////////////
            matchmediaService.onPrint = function(listener, $scope){
                return matchmediaService.on(matchmedia.rules.print,listener, $scope);
            };
            matchmediaService.onScreen = function(listener, $scope){
                return matchmediaService.on(matchmedia.rules.screen,listener, $scope);
            };
            matchmediaService.onPhone = function(listener, $scope){
                return matchmediaService.on(matchmedia.rules.phone,listener, $scope);
            };
            matchmediaService.onTablet = function(listener, $scope){
                return matchmediaService.on(matchmedia.rules.tablet,listener, $scope);
            };
            matchmediaService.onDesktop = function(listener, $scope){
                return matchmediaService.on(matchmedia.rules.desktop,listener, $scope);
            };
            matchmediaService.onPortrait = function(listener, $scope){
                return matchmediaService.on(matchmedia.rules.portrait,listener, $scope);
            };
            matchmediaService.onLandscape = function(listener, $scope){
                return matchmediaService.on(matchmedia.rules.landscape,listener, $scope);
            };

            matchmediaService.isPrint = function(){
                return matchmediaService.is(matchmedia.rules.print);
            };
            matchmediaService.isScreen = function(){
                return matchmediaService.is(matchmedia.rules.screen);
            };
            matchmediaService.isPhone = function(){
                return matchmediaService.is(matchmedia.rules.phone);
            };
            matchmediaService.isTablet = function(){
                return matchmediaService.is(matchmedia.rules.tablet);
            };
            matchmediaService.isDesktop = function(){
                return matchmediaService.is(matchmedia.rules.desktop);
            };
            matchmediaService.isPortrait = function(){
                return matchmediaService.is(matchmedia.rules.portrait);
            };
            matchmediaService.isLandscape = function(){
                return matchmediaService.is(matchmedia.rules.landscape);
            };
            return matchmediaService;
        }];
        return matchmedia;
    })
    .directive('ajMatchmedia', ['matchmedia', function(matchmedia) {
        return {
            restrict: 'E',
            scope: {
                'queryListener': '&',
                'queryMatches': '='
            },
            link: function(scope, element, attrs, controllers) {
                var deregister;

                if (attrs.on && attrs.queryListener) {
                    if (attrs.on.slice(0, 2) === 'on' && matchmedia[attrs.on] !== 'undefined') {
                        deregister = matchmedia[attrs.on](function(mediaQueryList) {
                            scope.queryListener({mediaQueryList: mediaQueryList});
                        });
                    } else {
                        deregister = matchmedia.on(attrs.on, function(mediaQueryList) {
                            scope.queryListener({mediaQueryList: mediaQueryList});
                        });
                    }
                    scope.$on('$destroy', deregister);
                } else if (attrs.is && attrs.queryMatches) {
                    if (attrs.is.slice(0, 2) === 'is' && matchmedia[attrs.is] !== 'undefined') {
                        scope.queryMatches = matchmedia[attrs.is]();
                    } else {
                        scope.queryMatches = matchmedia.is(attrs.is);
                    }
                }
            }
        };
    }])
    .factory('safeApply', ['$rootScope',function($rootScope) {
        return function(fn, $scope) {
            $scope = $scope || $rootScope;
            var phase = $scope.$root.$$phase;
            if(phase == '$apply' || phase == '$digest') {
                if (fn) {
                    $scope.$eval(fn);
                }
            } else {
                if (fn) {
                    $scope.$apply(fn);
                } else {
                    $scope.$apply();
                }
            }
        };
    }])
    .provider('logger', function(){
        this.DEVMODE = false;

        this.setDEVMODE = function(devmode){
            this.DEVMODE = devmode;
        };

        this.$get = ['$window', '$log', function($window, $log) {
            var DEVMODE = this.DEVMODE;
            var logger = {};
            logger.log = function(){
                if (DEVMODE) $log.info(arguments);
            };
            logger.always = function(){
                $log.info(arguments);
            };
            return logger;
        }];
    });
})(window, window.angular);

/**
 * @license
 * NavMore <https://github.com/pinkhominid/navmore>
 * A navigation list decorator that produces a responsive horizontal nav menu.
 * Written with ES5 and CSS3. No dependencies.
 *
 * Copyright pinkhominid
 * Released under MIT License <https://raw.githubusercontent.com/pinkhominid/navmore/master/LICENSE>
 *
 * Chrome/Firefox/Safari/Opera/Edge/IE11
 *
 * TODO
 * fix msie
 * support keyboard navigation
 * support varied nav item tags
 * improve animation
 * calc'ed height of droplist
 * a way to denote items outside of viewport in sub-lists (e.g. gradients)
 */

;(function(window) {
  var document = window.document;

  window.navmore = function(nav) {
    var mainList = nav.querySelector('ul');
    var moreItem = createElementFromString('<li class="hidden"><a class="navmore-moreitem" href="javascript:void(0)">More&hellip;</a><ul></ul></li>');
    var moreList = moreItem.querySelector('ul');
    var navItemTagNames = 'A, H1'; // NOTE: css currently supports A, H1
    var selected;
    var unthrottleResize;

    function init() {
      mainList.appendChild(moreItem);
      nav.classList.add('navmore');
      // add top-level interactive elements to tabindex
      forEachFirstChildByTagName(mainList, navItemTagNames, addToTabIndex);

      // Public API
      nav.navmore = {
        reset: reorgNav, // recalc/rerender nav items
        collapse: collapse, // collapse dropped menus
        getSelected: getSelected, // get selected hierarchy as array [leaf, ..., root]
        setSelected: setSelected, // set selected leaf item then update hierarchy
        setMoreItemText: setMoreItemText, // update the text for the more item
        destroy: destroy // cleanup all traces of navmore
      };

      // listeners
      unthrottleResize = throttle('resize', 'optimizedResize');
      window.addEventListener('optimizedResize', reorgNav, false);
      window.addEventListener('click', handleTap, false);
      window.addEventListener('keypress', handleKeyPress, false);

      /* bootstrap */
      reorgNav();
    }

    /* BEHAVIORS */

    function isFlex() {
      return nav.classList.contains('navmore-flex') || nav.classList.contains('navmore-flexgrow');
    }

    function isNavLeafItem(target) {
      // has href and not javascript:void(0)
      return target.href && target.href.indexOf('http') === 0;
    }

    function handleTap(e) {
      // retarget tap to account for nested elements
      var target = retargetBubbleEventByTagName(e, mainList, navItemTagNames);
      if (!target) {
        collapse();
        return;
      }

      var isLeaf = isNavLeafItem(target);
      // toggle tapped navItem focus
      if (!isLeaf && isItemFocused(target)) {
        // clear focus for tapped navItem and all descendants
        forEachDescendantsByTagName(target.parentNode, navItemTagNames, blurItem);
        // remove nested descendants from tabindex
        removeNestedFromTabIndex(target.parentNode);
        return;
      }

      collapse();
      removeNestedFromTabIndex();

      if (isLeaf) {
        setSelected(target);
      } else { // is branch
        // focus ancestor navItems
        forEachAncestorSiblingsByTagName(target, mainList, 'UL', navItemTagNames, focusItem);
        // if list is nested, add parent list to tabindex
        var upperLevelList = getClosestAncestorByTagName(target, mainList, 'UL');
        if(upperLevelList) {
          forEachFirstChildByTagName(upperLevelList, navItemTagNames, addToTabIndex);
        }
        var parentList = getClosestAncestorByTagName(target, mainList, 'LI');
        // make nested list items selectable via keyboard
        forEachFirstChildByTagName(parentList.querySelector('ul'), navItemTagNames, addToTabIndex);
        // focus tapped navItem
        focusItem(target);
      }
    }

    function handleKeyPress(e) {
      var key = e.which || e.keyCode;
      // treat "enter" press like tap
      if (key === 13) {
        handleTap(e);
      }
    }

    function getLastMainItem() {
      var lastMainItem = moreList.parentElement.previousElementSibling;
      return lastMainItem ? lastMainItem.firstElementChild : null;
    }

    function getFirstMoreItem() {
      var firstMoreItem = moreList.firstElementChild;
      return firstMoreItem ? firstMoreItem.firstElementChild : null;
    }

    function reorgNav() {
      var lastMainItem = getLastMainItem(),
        firstMoreItem = getFirstMoreItem();

      // move items from moreList to mainList
      while (firstMoreItem && (!lastMainItem || !isOverflowing(lastMainItem))) {
        mainList.insertBefore(firstMoreItem.parentElement, moreItem);

        lastMainItem = firstMoreItem;
        firstMoreItem = getFirstMoreItem();
        // update while removing from moreList in the case More item itself overflows the list
        updateMoreItemHidden();
      }
      // move items from mainList to moreList
      while (lastMainItem && isOverflowing(lastMainItem)) {
        moreList.insertBefore(lastMainItem.parentElement, moreList.firstElementChild);

        lastMainItem = getLastMainItem();
        // update while adding to moreList in the case More item itself overflows the list
        updateMoreItemHidden();
      }
      // updates
      if (moreList.childElementCount > 0 && selected) {
        // refresh selected
        setSelected(selected);
      }
    }

    function updateMoreItemHidden() {
        moreItem.classList[moreList.childElementCount === 0 ? 'add' : 'remove']('hidden');
    }

    function isOverflowing(lastMainItem) {
      if (isFlex()) {
        return getAutoClientWidth(lastMainItem) > lastMainItem.clientWidth;
      } else {
        return mainList.scrollWidth > mainList.clientWidth;
      }
    }

    function collapse() {
      // clear focus for all navItems
      forEachDescendantsByTagName(mainList, navItemTagNames, blurItem);
    }

    function removeNestedFromTabIndex(target) {
      // get nested lists, for each nested list, remove links from tabindex
      forEachDescendantsByTagName(target || mainList, 'UL', function(list){
        forEachDescendantsByTagName(list, navItemTagNames, removeFromTabIndex);
      });
    }

    function setSelected(item) {
      // clear selected for all navItems
      forEachDescendantsByTagName(mainList, navItemTagNames, deselectItem);

      if (!item) {
        selected = null;
      } else if (item && hasTagName(item, navItemTagNames) && isNavLeafItem(item)) {
        // store selected
        selected = item;
        // mark navItem as selected
        selectItem(item);
        // mark ancestor navItems as selected
        forEachAncestorSiblingsByTagName(item, mainList, 'UL', navItemTagNames, selectItem);
      }

      return nav;
    }

    /* returns array of selected items ordered from leaf (bottom) to root (top) */
    function getSelected() {
      return Array.prototype.slice.call(mainList.querySelectorAll('.selected')).reverse();
    }

    function setMoreItemText(text) {
      moreItem.firstChild.textContent = text;
      reorgNav();
    }

    function destroy() {
      mainList.removeChild(moreItem);
      nav.classList.remove('navmore');

      delete nav.navmore;

      unthrottleResize();
      window.removeEventListener('optimizedResize', reorgNav, false);
      window.removeEventListener('click', handleTap, false);
      window.removeEventListener('keypress', handleKeyPress, false);
    }

    /* BOOTSTRAP */
    init();

    return nav;
  };

  /* UTILS */

  // from MDN with modifications
  // https://developer.mozilla.org/en-US/docs/Web/Events/resize
  function throttle(type, name, obj) {
    obj = obj || window;
    var running = false;
    var func = function() {
      if (running) { return; }
      running = true;
      requestAnimationFrame(function() {
        triggerEvent(name, obj);
        running = false;
      });
    };
    var removeFunc = function() {
      obj.removeEventListener(type, func);
    };
    obj.addEventListener(type, func, false);
    return removeFunc;
  }

  // MDN
  function triggerEvent(name, obj) {
    var evt;
    try { evt = new CustomEvent(name); }
    catch(e) {
      evt = document.createEvent('Event');
      evt.initEvent(name, true, true);
    }
    obj.dispatchEvent(evt);
  }

  function createElementFromString(s) {
    var div = document.createElement('div');
    div.innerHTML = s;
    return div.firstChild;
  }

  function getAutoClientWidth(el) {
    var text = el.textContent.trim(),
      style = window.getComputedStyle(el),
      /* get font values separately for firefox :( */
      font = [
        style.getPropertyValue('font-weight'),
        style.getPropertyValue('font-size'),
        style.getPropertyValue('font-family')
      ],
      padLeft = parseInt(style.getPropertyValue('padding-left')),
      padRight = parseInt(style.getPropertyValue('padding-right'));

    return Math.floor(getTextWidth(text, font.join(' ')) + padLeft + padRight);
  }

  // http://stackoverflow.com/a/21015393
  function getTextWidth(text, font) {
    // re-use canvas object for better performance
    var canvas = getTextWidth.canvas || (getTextWidth.canvas = document.createElement('canvas'));
    var context = canvas.getContext('2d');
    context.font = font;
    var metrics = context.measureText(text);
    return metrics.width;
  }

  function hasTagName(node, tagNames) {
    // tagNames is comma delimited
    return tagNames.split(/\s*,\s*/).indexOf(node.tagName) > -1;
  }

  function retargetBubbleEventByTagName(evt, stopNode, tagNames) {
    var target = evt.target;
    if (!target.nodeType || !stopNode.contains(target)) return null;
    if (!hasTagName(target, tagNames)) {
      return getClosestAncestorByTagName(target, stopNode, tagNames);
    }
    return target;
  }

  function getClosestAncestorByTagName(startNode, stopNode, tagNames) {
    while (startNode) {
      startNode = startNode.parentNode;
      if (!stopNode.contains(startNode) || startNode === stopNode) {
        break;
      }
      if (hasTagName(startNode, tagNames)) {
        return startNode;
      }
    }
    return null;
  }

  function forEachFirstChildByTagName(startNode, tagNames, fn) {
    var children = startNode.children
    for (i = 0; i < children.length; i++) {
      if(children[i].firstElementChild && hasTagName(children[i].firstElementChild, tagNames)) {
        fn(children[i].firstElementChild);
      }
    }
  }

  function forEachDescendantsByTagName(startNode, tagNames, fn) {
    var descendants = startNode.querySelectorAll(tagNames), i;
    for (i = 0; i < descendants.length; i++) {
      fn(descendants[i]);
    }
  }

  function forEachAncestorSiblingsByTagName(startNode, stopNode, ancestorTags, focusTags, fn) {
    var ancestor, i, node;
    do {
      ancestor = getClosestAncestorByTagName(startNode, stopNode, ancestorTags);
      if (ancestor) {
        for (i = 0; i < ancestor.parentNode.children.length; i++) {
          node = ancestor.parentNode.children[i];
          if (hasTagName(node, focusTags)) {
            fn(node);
          }
        }
      }
      startNode = ancestor;
    } while (startNode);
  }

  function focusItem(item) {
    item.classList.add('focused');
  }

  function isItemFocused(item) {
    return item.classList.contains('focused');
  }

  function blurItem(item) {
    item.classList.remove('focused');
  }

  function selectItem(item) {
    item.classList.add('selected');
  }

  function deselectItem(item) {
    item.classList.remove('selected');
  }
  function removeFromTabIndex(item) {
    item.tabIndex = -1;
  }
  function addToTabIndex(item) {
    item.tabIndex = 0;
  }

})(window);

(function(w){
    'use strict';
    // https://gist.github.com/joelambert/1002116
    /**
     * Behaves the same as setInterval except uses requestAnimationFrame() where possible for better performance
     * @param {function} fn The callback function
     * @param {int} delay The delay in milliseconds
     */
    w.requestInterval = function(fn, delay){
        var start = new Date().getTime(),
            handle = {};

        function loop(){
            var current = new Date().getTime(),
                delta = current - start;

            if(delta >= delay) {
                fn.call();
                start = new Date().getTime();
            }

            handle.value = w.requestAnimationFrame(loop);
        }

        handle.value = w.requestAnimationFrame(loop);
        return handle;
    };

    /**
     * Behaves the same as clearInterval except uses cancelRequestAnimationFrame() where possible for better performance
     * @param {(int|object)} handle The callback function
     */
    w.clearRequestInterval = function(handle){
        w.cancelAnimationFrame(handle.value);
    };
})(window);

// http://james.padolsey.com/javascript/element-datastorage/
(function(w){
    'use strict';

    var cache = [0],
        expando = 'data' + (+new Date());

    function data(elem) {

        var cacheIndex = elem[expando],
            nextCacheIndex = cache.length;

        if(!cacheIndex) {
            cacheIndex = elem[expando] = nextCacheIndex;
            cache[cacheIndex] = {};
        }

        return cache[cacheIndex];

    }

    w.bmDataCache = data;

})(window);

/* Adapted from https://github.com/thorst/jquery-idletimer

MIT License

Copyright (c) 2013 Paul Irish

Permission is hereby granted, free of charge, to any person
obtaining a copy of this software and associated documentation
files (the "Software"), to deal in the Software without
restriction, including without limitation the rights to use,
copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the
Software is furnished to do so, subject to the following
conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES
OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT
HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR
OTHER DEALINGS IN THE SOFTWARE. */
(function(w){
    'use strict';

    w.bmIdleTimer = function(firstParam, elem){
        var opts;

        if(typeof firstParam === 'object'){
            opts = firstParam;
            firstParam = null;
        } else if(typeof firstParam === 'number'){
            opts = { timeout: firstParam };
            firstParam = null;
        }

        // element to watch
        elem = elem || document;
        opts = opts || {};

        opts = extendObject({
            idle: false,                // indicates if the user is idle
            timeout: 30000,             // the amount of time (ms) before the user is considered idle
            events: [
                'mousemove',
                'keydown',
                'wheel',
                'DOMMouseScroll',
                'mousewheel',
                'mousedown',
                'touchstart',
                'touchmove',
                'MSPointerDown',
                'MSPointerMove'
            ] // define active events
        }, opts);

        var obj = w.bmDataCache(elem).idleTimerObj || {};

        /* (intentionally not documented)
         * Toggles the idle state and fires an appropriate event.
         * @return {void}
         */
        // var toggleIdleState = function(e){
        var toggleIdleState = function(){
            var obj = w.bmDataCache(elem).idleTimerObj || {};

            // toggle the state
            obj.idle = !obj.idle;

            // store toggle state date time
            obj.olddate = +new Date();

            // create a custom event, with state and name space
            var evt;
            var evtName = (obj.idle ? 'idle' : 'active') + '.bmIdleTimer';

            // create custom event based on browser support
            try {
                evt = new CustomEvent(evtName);
            } catch(e) {
                evt = document.createEvent('Event');
                evt.initEvent(evtName, true, true);
            }

            // trigger event on object with elem and copy of obj
            elem.dispatchEvent(evt, extendObject({}, obj));
        };

        /**
         * Handle event triggers
         * @return {void}
         * @method event
         * @static
         */
        var handleEvent = function(e){
            var obj = w.bmDataCache(elem).idleTimerObj || {};

            // this is already paused, ignore events for now
            if(obj.remaining !== null){
                return;
            }

            /*
            mousemove is kinda buggy, it can be triggered when it should be idle.
            Typically is happening between 115 - 150 milliseconds after idle triggered.
            @psyafter & @kaellis report "always triggered if using modal (jQuery ui, with overlay)"
            @thorst has similar issues on ios7 "after $.scrollTop() on text area"
            */
            if (e.type === 'mousemove') {
                // if coord are same, it didn't move
                if (e.pageX === obj.pageX && e.pageY === obj.pageY) {
                    return;
                }
                // if coord don't exist how could it move
                if (typeof e.pageX === 'undefined' && typeof e.pageY === 'undefined') {
                    return;
                }
                // under 200 ms is hard to do, and you would have to stop, as continuous activity will bypass this
                var elapsed = (+new Date()) - obj.olddate;
                if (elapsed < 200) {
                    return;
                }
            }

            // clear any existing timeout
            clearTimeout(obj.tId);

            // if the idle timer is enabled, flip
            if (obj.idle) {
                toggleIdleState(e);
            }

            // store when user was last active
            obj.lastActive = +new Date();

            // update mouse coord
            obj.pageX = e.pageX;
            obj.pageY = e.pageY;

            // set a new timeout
            obj.tId = setTimeout(toggleIdleState, obj.timeout);
        };

        /**
         * Restore initial settings and restart timer
         * @return {void}
         * @method reset
         * @static
         */
        var reset = function(){
            var obj = w.bmDataCache(elem).idleTimerObj || {};

            // reset settings
            obj.idle = obj.idleBackup;
            obj.olddate = +new Date();
            obj.lastActive = obj.olddate;
            obj.remaining = null;

            // reset Timers
            clearTimeout(obj.tId);
            if (!obj.idle) {
                obj.tId = setTimeout(toggleIdleState, obj.timeout);
            }
        };

        /**
         * Store remaining time, stop timer
         * You can pause from an idle OR active state
         * @return {void}
         * @method pause
         * @static
         */
        var pause = function(){
            var obj = w.bmDataCache(elem).idleTimerObj || {};

            // this is already paused
            if(obj.remaining !== null){ return; }

            // define how much is left on the timer
            obj.remaining = obj.timeout - ((+new Date()) - obj.olddate);

            // clear any existing timeout
            clearTimeout(obj.tId);
        };

        /**
         * Start timer with remaining value
         * @return {void}
         * @method resume
         * @static
         */
        var resume = function(){
            var obj = w.bmDataCache(elem).idleTimerObj || {};

            // this isn't paused yet
            if(obj.remaining === null){ return; }

            // start timer
            if (!obj.idle){
                obj.tId = setTimeout(toggleIdleState, obj.remaining);
            }

            // clear remaining
            obj.remaining = null;
        };

        /**
         * Stops the idle timer. This removes appropriate event handlers
         * and cancels any pending timeouts.
         * @return {void}
         * @method destroy
         * @static
         */
        var destroy = function(){
            //clear any pending timeouts
            var obj = w.bmDataCache(elem).idleTimerObj || {};
            clearTimeout(obj.tId);

            //Remove data
            delete w.bmDataCache(elem).idleTimerObj;

            //detach the event handlers
            opts.events.forEach(function(eventName){
                elem.removeEventListener(eventName, idleTimerHandler);
            });
        };

        /**
        * Returns the time until becoming idle
        * @return {number}
        * @method remainingtime
        * @static
        */
        var remainingtime = function(){
            var obj = w.bmDataCache(elem).idleTimerObj || {};

            //If idle there is no time remaining
            if (obj.idle){ return 0; }

            //If its paused just return that
            if (obj.remaining !== null){ return obj.remaining; }

            //Determine remaining, if negative idle didn't finish flipping, just return 0
            var remaining = obj.timeout - ((+new Date()) - obj.lastActive);
            if(remaining < 0){ remaining = 0; }

            //If this is paused return that number, else return current remaining
            return remaining;
        };

        // determine which function to call
        if(firstParam === null && typeof obj.idle !== 'undefined'){
            // they think they want to init, but it already is, just reset
            reset();
            return elem;
        } else if(firstParam === null){
            // they want to init
        } else if(firstParam !== null && typeof obj.idle === 'undefined'){
            // they want to do something, but it isnt init
            // not sure the best way to handle this
            return false;
        } else if(firstParam === 'destroy'){
            destroy();
            return elem;
        } else if(firstParam === 'pause'){
            pause();
            return elem;
        } else if(firstParam === 'resume'){
            resume();
            return elem;
        } else if(firstParam === 'reset'){
            reset();
            return elem;
        } else if(firstParam === 'getRemainingTime'){
            return remainingtime();
        } else if(firstParam === 'getElapsedTime'){
            return (+new Date()) - obj.olddate;
        } else if(firstParam === 'getLastActiveTime'){
            return obj.lastActive;
        } else if(firstParam === 'isIdle'){
            return obj.idle;
        }

        /* (intentionally not documented)
         * Handles a user event indicating that the user isn't idle. namespaced with internal idleTimer
         * @param {Event} event A DOM2-normalized event object.
         * @return {void}
         */
        opts.events.forEach(function(eventName){
            // elem.addEventListener(eventName + '._idleTimer', idleTimerHandler, false);
            elem.addEventListener(eventName, idleTimerHandler, false);
        });

        // Internal Object Properties, This isn't all necessary, but we
        // explicitly define all keys here so we know what we are working with
        obj = extendObject({}, {
            olddate : +new Date(),          // the last time state changed
            lastActive: +new Date(),       // the last time timer was active
            idle : opts.idle,               // current state
            idleBackup : opts.idle,         // backup of idle parameter since it gets modified
            timeout : opts.timeout,         // the interval to change state
            remaining : null,               // how long until state changes
            tId : null,                     // the idle timer setTimeout
            pageX : null,                   // used to store the mouse coord
            pageY : null
        });

        // set a timeout to toggle state. May wish to omit this in some situations
        if (!obj.idle) {
            obj.tId = setTimeout(toggleIdleState, obj.timeout);
        }

        // store our instance on the object
        w.bmDataCache(elem).idleTimerObj = obj;

        return elem;

        /////////////

        // Extend a JavaScript object with the key/value pairs of another.
        // https://plainjs.com/javascript/utilities/merge-two-javascript-objects-19/
        function extendObject(obj, src) {
            Object.keys(src).forEach(function(key){
                obj[key] = src[key];
            });

            return obj;
        }

        function idleTimerHandler(e){
            handleEvent(e);
        }
    };
})(window);

(function(w){
    'use strict';

    /**
     * var jid = q.push(function (done, data) { console.log(data); done(); }, 30000, 'hello world!'); // log 'hello world!' every 30 secs
     * q.stop(jid); // disable specified job
     * q.start(jid); // enabled specified job
     * q.stop(); // disable all jobs
     * q.start(); // enable all jobs
     */
    w.bmJobQueue = function(resolution){
        var tId, q = [], self = this,
        // use Joe Lambert's requestInterval if available
        intervalFn = w.requestInterval || setInterval,
        clearFn = w.clearRequestInterval || clearInterval;

        resolution = resolution || 5000;

        // if we have the bmIdleTimer plugin, make Q smarter about idle states
        if(w.bmIdleTimer && w.bmDataCache){
          // does the document element already have idleTimer data
          if(!w.bmDataCache(w.document).idleTimerObj){
            w.bmIdleTimer(180000); // make sure it's started, 3 min idle
          }

          // event listeners to respond to bmIdleTimer events
          w.document.addEventListener('idle.bmIdleTimer', function(){ self.stop(); }, false);
          w.document.addEventListener('active.bmIdleTimer', function(){ self.start(); }, false);
        }

        this.push = function(fn, interval, data, context){
            var job;

            if(fn){
                if(!q.length){
                    self.start(); // start processing once we get first job
                }

                job = {fn: fn, interval: interval || 0, context: context || window, enabled: 1, running: 0, last: 0, data: data };
                runJob(job);
                q.push(job);

                return q.length; // jobId
            } else {
                return null;
            }
        };

        this.start = function(jobId){
            var job;
            if(jobId){
                job = q[jobId - 1];

                if(job){
                    job.enabled = 1;
                }
            } else if(!tId){
                mainLoop();
                tId = intervalFn(mainLoop, resolution);
            }
        };

        this.stop = function(jobId){
            var job;

            if(jobId){
                job = q[jobId - 1];

                if(job){
                  job.enabled = 0;
                }
            } else if(tId){
                clearFn(tId); tId = null;
            }
        };

        this.remove = function(jobId){
            if(jobId){
              q[jobId - 1] = null;
            }
        };

        this.update = function(jobId, fn, interval, data, context){
            var job;

            if(jobId){
                job = q[jobId - 1];

                if(job){
                    job.fn = fn || job.fn;
                    job.interval = interval !== undefined ? interval : job.interval;
                    job.data = data !== undefined ? data : job.data;
                    job.context = context !== undefined ? context : job.context;
                }
            }
        };

        /////////////

        function mainLoop(){
            var i, job;

            for (i = 0; i < q.length; i++){
                job = q[i];

                if(job && job.enabled && !job.running && (+new Date() - job.last >= job.interval)){
                    runJob(job);
                }
            }
        }

        function runJob(job){
            job.running = 1;
            job.fn.call(job.context, function (){ // callback
                job.running = 0;
                job.last = +new Date();
            }, job.data);
        }
    };
})(window);

/**
 * Top-level module for bluemoon-components
 */
(function(window, angular) {
    'use strict';

    // The following is an HTTPS guarantee for all Blue Moon apps.
    // The ideal, of course, is this happens via server redirect.
    if (window.location.protocol === 'http:') {
        // TODO: copied from environment.js, needs to DRYed and broken out to be available immediately
        var hostname = location.hostname.toLowerCase(),
            isCiEnv = /^ci\./.test(hostname),
            isLocalEnv = /^(localhost|0\.0\.0\.0|127\.0\.0\.1)$/.test(hostname);

        if (!isCiEnv && !isLocalEnv) { // limit to DEMO+
            window.location.protocol = 'https';
        }
    }

    // blank module for dev, overwritten for dist
    angular.module('bluemoon.components.templates', []);

    angular.module('bluemoon.components', [
        'bluemoon.components.templates',
        'bluemoon.components.app',
        'bluemoon.components.header',
        'bluemoon.components.staffHeader',
        'bluemoon.components.nav',
        'bluemoon.components.main',
        'bluemoon.components.busyLoader',
        'bluemoon.components.bluemoonForceDesktop',
        'bluemoon.components.i18n',
        'bluemoon.components.bluemoonRequiredMark',
        'bluemoon.components.modal',
        'bluemoon.help',
        'bmPermission',
        'bmLicense',
        'bmAccess',
        'bmEnvironment',
        'bmUser',
        'bmUserTermsSignatory',
        'bmPreferenceService',
        'bmImageUploadModal',
        'bmProfilePhoto',
        'bmViewPortalBanner'
    ]);

})(window, window.angular);

(function(angular) {
    'use strict';

    var util = {

        // http://stackoverflow.com/a/8809472
        generateUUID: function() {
            /* jshint ignore:start */
            var d = new Date().getTime();
            var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
                var r = (d + Math.random() * 16)%16 | 0;
                d = Math.floor(d / 16);
                return (c == 'x' ? r : (r&0x7 | 0x8)).toString(16);
            });
            return uuid;
            /* jshint ignore:end */
        },

        // TRMR gotta be different
        generateTRMRGUID: function(uuid) {
            if (!uuid) { uuid = util.generateUUID(); }
            return uuid.replace(/-/g, '');
        },

        // Simple cookie handling (doesn't encode/decode)
        cookie: function(key, val, path, infinite) {
            if (val === undefined) { // get
                return (document.cookie.match('(^|; )' + key + '=([^;]*)') || 0)[2];
            }

            var pathSeg = path ? '; path=' + path : '';
            var expiresSeg = infinite ? '; expires=Fri, 31 Dec 9999 23:59:59 GMT' : '';

            if (val === null) { // delete
                document.cookie = key + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT' + pathSeg;
            } else { // set
                document.cookie = key + '=' + val + pathSeg + expiresSeg;
            }
        },

        // Given an object tree, return flat Array of dot-notated, compound keys
        // (e.g. {a1:{b1:'x',b2:{c1:'y'}},a2:'z'} -> ['a1.b1','a1.b2.c1','a2'])
        flattenKeys: function(obj, filter) {
            var flat = [];
            function traverse(obj, key) {
                var compound;
                for (var prop in obj) {
                    compound = key ? key + '.' + prop : prop;
                    if (typeof obj[prop] === 'object') {
                        traverse(obj[prop], compound);
                    } else {
                        if (filter) {
                            if (!filter(obj, prop, compound)) { continue; }
                        }
                        flat.push(compound);
                    }
                }
            }
            traverse(obj);
            return flat;
        },

        // overwritten by angular.extend
        extend: function() {
            throw new Error('Not implemented.');
        },

        // http://stackoverflow.com/a/9229821
        // some consumers don't use underscore/lodash
        uniq: function(a) {
            var seen = {};
            var out = [];
            var len = a.length;
            var j = 0;
            for(var i = 0; i < len; i++) {
                 var item = a[i];
                 if(seen[item] !== 1) {
                       seen[item] = 1;
                       out[j++] = item;
                 }
            }
            return out;
        },

        // safe way to decode html entities in a string w/o opening yourself up to script injection
        decodeHtmlEntities: function(str) {
            var txt = document.createElement('textarea');
            txt.innerHTML = str;
            return txt.value;
        },

        isNullOrEmpty: function(str){
            return angular.isUndefined(str) || str === null || str === '';
        },

        // https://developer.mozilla.org/en-US/docs/Web/API/Location
        parseUri: function(href){
            if(util.isNullOrEmpty(href)){
                return undefined;
            }

            var url = document.createElement('a');
            url.href = href;
            return url;

            // url.href;      https://developer.mozilla.org/en-US/search?q=URL#search-results-close-container
            // url.protocol;  https:
            // url.host;      developer.mozilla.org
            // url.hostname;  developer.mozilla.org
            // url.port;      (blank - https assumes port 443)
            // url.pathname;  /en-US/search
            // url.search;    ?q=URL
            // url.hash;      #search-results-close-container
            // url.origin;    https://developer.mozilla.org
        },
        /**
         * https://gist.github.com/maxwihlborg/1911a28f988444db3ddc
         * Simple debounce function; usage:
         *
         * Create a function that only can be called once every 500 ms
         *
         *      var df = debounce(function() {
         *          ... func body ...
         *      }, 500)
         *
         * Bind the function to an event
         *
         *      document.addEventListener('keydown', df);
         *
         * @param fn   {function} function you want to debounce
         * @param wait {number}   interval wait in ms
         */
        debounce: function(fn, wait) {
            var timeout;
            return function() {
                var ctx = this, args = arguments;
                clearTimeout(timeout);
                timeout = setTimeout(function() {
                    fn.apply(ctx, args);
                }, wait || 100);
            };
        },
        //  reference - https://github.com/PunitSoniME/alt-lodash/blob/main/src/object/get.ts
        getValueFromKey: function(object, path, defaultValue) {
            // If path is not defined or it has false value
            if (!path) { return undefined; }
            // Check if path is string or array. Regex : ensure that we do not have '.' and brackets.
            // Regex explained: https://regexr.com/58j0k
            var pathArray = Array.isArray(path) ? path : path.match(/([^[.\]])+/g);

            if (pathArray === null) { return defaultValue; }
            // Find value
            var result = (pathArray).reduce(function(prevObj, key) { return prevObj && prevObj[key]; },
                object
            );
            // If found value is undefined return default value; otherwise return the value
            return result === undefined ? defaultValue : result;
        }
    };

    /* ANGULAR */
    util.extend = angular.extend;

    angular.module('bluemoon.components.util', [])
        .value('bmUtil', util);

})(window.angular);

(function(angular){
    'use strict';

    angular.module('bmTokenStorage', [])
    .service('bmTokenStorage', ['bmUtil', function (bmUtil) {
        var storageKey = 'onvio-uds-token';
        var cookieKey = 'UDSLongToken';
        this.clean = function() {
            if (window.localStorage) {
                window.localStorage.removeItem(storageKey);
            }
            if (window.sessionStorage) {
                window.sessionStorage.removeItem(storageKey);
            }
            bmUtil.cookie(cookieKey, null);
            bmUtil.cookie(cookieKey, null, '/');
        };

        this.set = function(token) {
            if (window.localStorage) {
                window.localStorage.setItem(storageKey, token);
            }
            if (window.sessionStorage) {
                window.sessionStorage.setItem(storageKey, token);
            }
            bmUtil.cookie(cookieKey, token, '/');
        };
        this.get = function(){
            return bmUtil.cookie(cookieKey) || window.sessionStorage.getItem(storageKey);
        };
    }]);
  })(window.angular);

(function(window, angular){
    'use strict';

    angular.module('bluemoon.components.i18n', ['pascalprecht.translate', 'bluemoon.components.util', 'bmEnvironment'])

        .config(['$httpProvider', '$translateProvider', 'bmEnvCountryDefaultLang', function($httpProvider, $translateProvider, countryDefaultLang) {
            $httpProvider.interceptors.push('bmHttpAcceptLangInterceptor');

            $translateProvider.useStorage('languageStorageManager');
            $translateProvider.preferredLanguage(countryDefaultLang);
            $translateProvider.fallbackLanguage('en-US');
        }])

        .value('bmLanguageCookieName', 'BMLanguageCode')

        .factory(
            'languageStorageManager',
            ['bmUtil', 'bmLanguageCookieName', 'bmEnvCountryDefaultLang', function(bmUtil, bmLanguageCookieName, defaultLang) {

                var factory = {};

                var languageCookieOptions = {
                    name: bmLanguageCookieName,
                    path: '/',
                    infinite: 'true',
                };

                function set(name, value){
                    // Override any cookie name passed in
                    name = languageCookieOptions.name;
                    bmUtil.cookie(name, value, languageCookieOptions.path, languageCookieOptions.infinite);
                }

                factory.set = set;
                factory.put = set;

                factory.get = function(name){
                    // Override any cookie name passed in
                    name = languageCookieOptions.name;
                    return bmUtil.cookie(name) || defaultLang;
                };

                return factory;
            }]
        )

        .factory('bmLanguageManager', ['$q', '$translate', 'languageStorageManager', 'bmEnvironment', 'bmEnvCountryDefaultLang',
            function($q, $translate, languageStorageManager, bmEnvironment, bmEnvCountryDefaultLang){

            var factory = {
                getLoadedLanguageAsync: getLoadedLanguageAsync,
                getLanguagesAsync: getLanguagesAsync,
                setUserLanguageAsync: setUserLanguageAsync,
                getCurrentLanguage: getCurrentTranslateLanguageCode,
                updatedUserLanguage: ''
            };

            var languageLoadRetry = 0;

            return factory;

            //////////

            function getLoadedLanguageAsync(){
                var currentLanguage;
                var currentLanguageCode = getCurrentTranslateLanguageCode();

                return bmEnvironment.getSupportedLanguagesAsync().then(function(languages){
                    if(angular.isUndefined(languages) || languages.length === 0){
                        return { code: bmEnvCountryDefaultLang };
                    }

                    for(var counter = 0; counter < languages.length; counter++){
                        if(languages[counter].code === currentLanguageCode){
                            currentLanguage = languages[counter];
                            break;
                        }
                    }

                    // Was a current supported language found?
                    if(angular.isDefined(currentLanguage)){
                        return currentLanguage;
                    }

                    languageLoadRetry++;

                    // Avoid an endless loop
                    if(languageLoadRetry > 1){
                        return { code: bmEnvCountryDefaultLang };
                    }

                    // Set translate to default language and try again
                    return $translate.use(bmEnvCountryDefaultLang).then(function(){
                        return getLoadedLanguageAsync();
                    });
                });
            }

            function getLanguagesAsync(includeLoadedLanguage){
                return getLanguageListAsync(includeLoadedLanguage).then(function(languages){
                    return languages;
                });
            }

            function setUserLanguageAsync(languageCode){
                var deferred, curr = getCurrentTranslateLanguageCode();
                if (curr !== languageCode) {
                    return $translate.use(languageCode).then(function(){
                        languageStorageManager.set('BMLanguageCode', languageCode);
                        factory.updatedUserLanguage = languageCode;
                    });
                } else {
                    deferred = $q.defer();
                    deferred.resolve();
                    return deferred.promise;
                }
            }

            //////////

            function getLanguageListAsync(includeLoadedLanguage){
                var languageList = [];

                return getLoadedLanguageAsync().then(function(currentLanguage){
                    var currentLanguageCode = currentLanguage.code;

                    return bmEnvironment.getSupportedLanguagesAsync().then(function(languages){
                        if(angular.isUndefined(languages)){
                            return languageList;
                        }

                        for(var counter = 0; counter < languages.length; counter++){
                            if(languages[counter].code === currentLanguageCode && !includeLoadedLanguage){
                                continue;
                            }

                            // Get the translated description for the loaded language
                            angular.extend(languages[counter], getTranslatedDescription(languages[counter], currentLanguageCode));

                            languageList.push(languages[counter]);
                        }

                        return languageList;
                    });
                });
            }

            function getCurrentTranslateLanguageCode(){
                var currentLanguageCode = $translate.proposedLanguage();

                if(angular.isUndefined(currentLanguageCode)){
                    currentLanguageCode = $translate.use();
                }

                return currentLanguageCode;
            }

            function getTranslatedDescription(language, translateCode){
                // Default to the language description itself
                var description = {
                    translatedDescription: language.description
                };

                if(angular.isUndefined(language.translations)){
                    return description;
                }

                for(var counter = 0; counter < language.translations.length; counter++){
                    if(language.translations[counter].code === translateCode){
                        description.translatedDescription = language.translations[counter].description;
                        break;
                    }
                }

                return description;
            }
        }])

        .directive('bmLanguageSelect', ['bmLanguageManager', '$timeout', function(bmLanguageManager, $timeout){
            return {
                restrict: 'E',
                replace: true,
                templateUrl: 'components/i18n/language-select.2js.html',
                scope: {
                    selectedLanguageCode: '=',
                    name: '@',
                    includeEmptyOption: '&',
                    selectionRequired: '&',
                    onChange: '&',
                    ngDisabled: '='
                },
                link: function (scope, element) {
                    function loadLangList() {
                        bmLanguageManager.getLanguagesAsync(true).then(function(languages){
                            scope.languageList = languages;

                            // Create local scope in order to not overwrite data bound scope value
                            scope.selectedLanguage = {
                                code: scope.selectedLanguageCode
                            };
                        });
                    }

                    loadLangList();

                    scope.$watch('selectedLanguageCode', function(newValue, oldValue) {
                        if (newValue && newValue !== oldValue) {
                            scope.selectedLanguage = {
                                code: newValue
                            };

                            scope.selectionChanged();
                        }
                    });

                    scope.$on('bmLanguageChangeSuccess', loadLangList);

                    // Set watches here so can actually pass attribute as a boolean
                    scope.$watch('includeEmptyOption()', function(newValue){
                        scope.showEmpty = newValue;
                    });

                    scope.$watch('selectionRequired()', function(newValue){
                        scope.required = newValue;
                    });

                    scope.$watch('ngDisabled', function(newValue){
                        scope.disabled = newValue;
                    });

                    scope.selectionChanged = function(){
                        // Set data bound value to new selection
                        scope.selectedLanguageCode = scope.selectedLanguage.code;

                        if(typeof scope.onChange !== 'undefined'){
                            // Hack to have model updated before change is fired (ngModelOptions failed)
                            $timeout(function(){
                                scope.onChange({ language: scope.selectedLanguageCode });
                            }, 0);
                        }
                    };

                    // copied straight from bento select control
                    // Add IE and Firefox version for better UI look and feel
                    if (window.navigator.userAgent.search(/MSIE 9/gi) !== -1) {
                      element.addClass('ie9');
                    } else if (window.navigator.userAgent.search(/MSIE 10/gi) !== -1) {
                      element.addClass('ie10');
                    } else if (window.navigator.userAgent.search(/Firefox/gi) !== -1) {
                      element.addClass('firefox');
                      element.append('<div class="bento-select-border"></div>');
                    }
                }
            };
        }])

        //  This is a workaround for https://github.com/angular-translate/angular-translate/issues/855
        .service('GlobalTranslateRefreshService', ['$translate', function($translate) {

            var _translationRefreshPromise;

            this.refresh = function() {
                return !_translationRefreshPromise ?
                    (_translationRefreshPromise = $translate.refresh()) :
                    _translationRefreshPromise;
            };
        }])

        .run(['$rootScope', function($rootScope){
            $rootScope.$on('$translateChangeSuccess', function(event, args){
                $rootScope.$broadcast('bmLanguageChangeSuccess', { language: args.language });
            });
        }])

        .service('bmHttpAcceptLangInterceptor', HttpAcceptLangInterceptor);

    function HttpAcceptLangInterceptor(languageStorageManager) {
        this.request = function(conf) {
            if (!conf.headers['Accept-Language']) {
                var lang = languageStorageManager.get();

                if (lang) {
                    conf.headers['Accept-Language'] = lang;
                }
            }
            return conf;
        };
    }

    HttpAcceptLangInterceptor.$inject = ['languageStorageManager'];
})(window, window.angular);

(function(MessageFormat){
    'use strict';

    if (MessageFormat && MessageFormat.plurals) {
        // This is similar to the "en" entry from version 0.3.1 of the messageformat.js file
        MessageFormat.plurals.xx = function (n) {
            return n === 1 ? 'one' : 'other';
        };
    }

})(window.MessageFormat);

/**
 * Blue Moon Components - session module
 */
(function(angular) {
    'use strict';

    var tokenType = 'UDSLongToken',
        staffDestUrl = '/staff/',
        clientDestUrl = '/client/',
        atendimentoClientDestUrl = '/atendimento-client/',
        clientBetaDestUrl = '/clientcenter/',
        employeePortalDestUrl = '/portaldoempregado/',
        employeeDestUrl = '/samba-employee-center/',
        employerDestUrl = '/samba-employer-center/',
        esalesCustomerDestUrl = '/samba-esales-customer-center/',
        destinationQueryStringKey = 'd',
        destinationStorageKey = 'bmViewPortalReturnUrl',
        clientMyPayOnboardingUrl = '/uspayrollonboarding/center/#/views/client',
        refAccountantMyPayOnboardingUrl = '/uspayrollonboarding/center/#/views/accountant',
        viewPortalUrlV1 = '/api/security/v1/sessions/view-portal',
        viewPortalUrlV2 = '/api/security/v2/sessions/view-portal',
        exitViewPortalUrl = '/api/security/v1/sessions/view-portal/exit',
        checkPointARUrl = '/sso/',
        sambaDestUrl = '/smb/',
        emergingAccountsUrl = '/ustax/#/dashboard',
        grantsMap = {
            // staff
            'Applications.Onvio': 'staff',
            'OnvioSetup.Contacts': 'staff.setup.contacts',
            'OnvioSetup.Messages': 'staff.setup.messages',
            'OnvioSetup.Appearances': 'staff.setup.appearances',
            'OnvioSetup.Offices': 'staff.setup.offices',
            'OnvioSetup.Staff': 'staff.setup.staff',
            'OnvioSetup.Clients': 'staff.setup.clients',
            'OnvioSetup.Firm': 'staff.setup.firm',
            'OnvioDrive.Documents': 'staff.documents',
            'OnvioDrive.FirmDocuments': 'staff.documents.firm',
            'OnvioDrive.MyDocuments': 'staff.documents.my',
            'OnvioDrive.ClientDocuments': 'staff.documents.client',
            // client
            'Platform.ccVnext': 'client.beta',
            'Applications.OnvioClientHub': 'client',
            'OnvioClientDrive.Drive': 'client.documents',
            'TaxCenter.Tax': 'client.tax',
            'MyPayClientOnboarding.ClientOnboarding' : 'client.mypayonboarding',
            'MyPayOnboarding.ReferringAccountant': 'staff.mypayonboarding.refaccountant',
            'Applications.Samba' : 'samba',
            // employee portal employee
            'BREmployeePortal.BREmployeePortal':'employeeportal.employee',
            // employee
            'SaMBa.Employee': 'samba.employee.center',
            // employer
            'SaMBa.Employer': 'samba.employer.center',
            //esales
            'SaMBa.ESalesCenter': 'samba.employer.center',
            'SaMBa.ESalesCustomerCenter': 'samba.esales.customer.center',
            // csadmin
            'AuthApp.UberAdmin': 'csadmin',
            'AuthApp.Admin': 'csadmin',
            'AuthApp.Staff': 'csadmin',
            // Emerging Accounts
            'USTax.PlatformEA': 'emergingaccounts'
        },
        userUrl = '/api/profiles/v1/users',
        deleteSessionUrl = '/api/security/v1/sessions/logout',
        deleteOIDCSessionUrl = '/api/security/v2/oidc/logout',
        cookieDeepLink = 'bmDeepLink',
        cookieCheckPoint = 'bmCheckPointOrigin';

    // Use separate data object to eliminate circular dependencies in interceptors
    function AuthenticatedSessionData($q) {
        var self = this;

        this.deferred = {
            all: $q.defer(),
            meta: $q.defer(),
            bindings: $q.defer()
        };

        // synchronous access
        this.meta = {};
        this.bindings = {};

        // asynchronous access
        this.get = function() {
            return self.deferred.all.promise;
        };
        this.getMeta = function() {
            return self.deferred.meta.promise;
        };
        this.getBindings = function() {
            return self.deferred.bindings.promise;
        };
    }

    function AuthenticatedSession(
        $window,
        $document,
        $log,
        $location,
        $q,
        $http,
        $rootScope,
        $uibModal,
        httpAuthInterceptor,
        sessionMetadataUrl,
        sessionMetadataUrlV2,
        sessionBindingsUrl,
        authWaypointUrl,
        defaultDestinationUrl,
        ssoUrl,
        ssoTokenKey,
        authenticatedSessionData,
        bmUtil,
        bmTheme,
        bmLanguageManager,
        bmEnvironmentConst,
        bmEnvironment,
        bmAccess,
        csWebLoginUriMap,
        bmTokenStorage) {

        var unloadCancelledTimeout;
        var self = this;
        var destroying = false;

        // data
        self.data = authenticatedSessionData;

        // methods
        self.create = create;
        self.createWithJwt = createWithJwt;
        self.createWithOptions = createWithOptions;
        self.createWithLongToken = createWithLongToken;
        self.createViaSsoToken = createViaSsoToken;
        self.load = load;
        self.loadMeta = loadMeta;
        self.loadBindings = loadBindings;
        self.destroy = destroy;
        self.destroyAuth0 = destroyAuth0;
        self.getRequestedDestination = getRequestedDestination;
        self.viewPortal = viewPortal;
        self.exitViewPortal = exitViewPortal;
        self.switchAccountWithLongToken = switchAccountWithLongToken;

        function create(uid, pwd, beforeRedirectAction) {
            var options = {data: {
                username: uid,
                password: pwd
            }};
            return createWithOptions(options, beforeRedirectAction);
        }

        function createViaSsoToken(token) {
            var options = {
                method: 'GET',
                url: ssoUrl + '?' + ssoTokenKey + '=' + token
            };
            return createWithOptions(options);
        }

        function createWithJwt(jwt) {
            return createWithOptions({
                method: 'POST',
                url: '/api/security/v2/sessions/jwt',
                headers: { Authorization: 'Bearer ' + jwt }
            });
        }

        function createWithOptions(options, beforeRedirectAction) {
            var defaultOptions = {
                method: 'POST',
                url: sessionMetadataUrlV2,
                bmNoAuth: true
            };
            var promise = $http(angular.extend(defaultOptions, options));

            // if attempting to create a new session, dump old token
            bmTokenStorage.clean();

            promise.then(function(resp) {
                createWithLongToken(resp.data.LongToken, beforeRedirectAction);
            });

            return promise;
        }

        function createWithLongToken(longToken, beforeRedirectAction){
            var preferredDest = getRequestedDestination($location);
            var cookieValue = (document.cookie.match('(^|; )' + cookieDeepLink + '=([^;]*)') || '')[2];
            // success, propagate token to apps in other tabs/windows
            bmTokenStorage.set(longToken);

            updateUserLanguage();

            if (cookieValue !== undefined) {
                var deepLink = $window.location.origin + cookieValue;
                // Delete the bmDeepLink cookie
                document.cookie = cookieDeepLink + '=/; path=/; Max-Age=0; Secure';
                if (beforeRedirectAction) {
                    beforeRedirectAction().finally(function afterAction() {
                        $window.location.href = deepLink;
                    });
                } else {
                    $window.location.href = deepLink;
                }
            } else if (!preferredDest) {
                // get bindings to determine where to send user
                loadBindings().then(function () {
                    self.destUrl = '';
                    var grants = self.data.bindings.Grants,
                        access = self.data.bindings.Access;

                    if (isSamba(grants)) {
                        self.destUrl = sambaDestUrl;
                    } else if (isEmergingAccounts(grants)) {
                        self.destUrl = emergingAccountsUrl;
                    } else if (isCheckPoint() || isAuth0CheckPoint()) {
                        //Redirect at checkpointAr login url with SSO Token
                        beforeRedirectAction = evaluateBeforeDirectionExecution.bind(self, beforeRedirectAction, longToken);
                    } else if (isStaff(grants)) {
                        self.destUrl = staffDestUrl;
                    } else if (isMyPayOnboardingClient(grants)) {
                        self.destUrl = clientMyPayOnboardingUrl;
                    } else if (isClientBeta(grants, access)) {
                        self.destUrl = clientBetaDestUrl;
                    } else if (isAtendimentoClient(grants)) {
                        self.destUrl = atendimentoClientDestUrl;
                    } else if (isClient(grants)) {
                        self.destUrl = clientDestUrl;
                    } else if (isMyPayOnboardingRefAccountant(grants)) {
                        self.destUrl = refAccountantMyPayOnboardingUrl;
                    } else if (isEmployeePortalEmployee(grants)) {
                        self.destUrl = employeePortalDestUrl;
                    } else if (isEmployee(grants)) {
                        self.destUrl = employeeDestUrl;
                    } else if (isEmployer(grants)) {
                        self.destUrl = employerDestUrl;
                    } else if (isEsalesCustomerCenter(grants)) {
                        self.destUrl = esalesCustomerDestUrl;
                    } else if (isStaffDocumentsBasic(grants)) {
                        // OnvioDocumentsBasic
                        self.destUrl = staffDestUrl;
                    } else if (isCsAdmin(grants)) {
                        // redirect to an actual CSWeb uri - #8747
                        self.destUrl = csWebLoginUriMap[bmEnvironmentConst.type];
                    }
                    if (beforeRedirectAction) {
                        beforeRedirectAction().finally(function afterAction() {
                            // goto destination page after completion of promise
                            gotoDestinationPage($window, $location, self.destUrl || defaultDestinationUrl);
                        });
                    } else {
                        // goto destination page
                        gotoDestinationPage($window, $location, self.destUrl || defaultDestinationUrl);
                    }
                });
            } else {
                if (beforeRedirectAction) {
                    beforeRedirectAction().finally(function afterAction() {
                        // goto destination page after completion of promise
                        gotoDestinationPage($window, $location, defaultDestinationUrl);
                    });
                } else {
                    // goto destination page
                    gotoDestinationPage($window, $location, defaultDestinationUrl);
                }
            }

        }

        function switchAccountWithLongToken(longToken, beforeRedirectAction){
            // dump old token
            bmTokenStorage.clean();

            // propagate new token to apps in other tabs/windows
            bmTokenStorage.set(longToken);

            updateUserLanguage();
            // get bindings to determine where to send user
            // purposely set cache to false in order to get updated token
            loadBindings({ cache: false }).then(function (){
                var destUrl,
                    grants = self.data.bindings.Grants,
                    access = self.data.bindings.Access;

                if (isSamba(grants)) {
                    destUrl = sambaDestUrl;
                } else if (isStaff(grants)){
                    destUrl = staffDestUrl;
                } else if(isMyPayOnboardingClient(grants)) {
                    destUrl = clientMyPayOnboardingUrl;
                } else if (isClientBeta(grants, access)) {
                    destUrl = clientBetaDestUrl;
                } else if (isAtendimentoClient(grants)) {
                    destUrl = atendimentoClientDestUrl;
                } else if (isClient(grants)) {
                    destUrl = clientDestUrl;
                } else if(isMyPayOnboardingRefAccountant(grants)) {
                    destUrl = refAccountantMyPayOnboardingUrl;
                } else if(isEmployeePortalEmployee(grants)) {
                    destUrl = employeePortalDestUrl;
                } else if (isEmployee(grants)) {
                    destUrl = employeeDestUrl;
                } else if (isEmployer(grants)) {
                    destUrl = employerDestUrl;
                } else if (isEsalesCustomerCenter(grants)){
                    destUrl = esalesCustomerDestUrl;
                } else if (isStaffDocumentsBasic(grants)){
                    // OnvioDocumentsBasic
                    destUrl = staffDestUrl;
                } else if (isCsAdmin(grants)) {
                    // redirect to an actual CSWeb uri - #8747
                    destUrl = csWebLoginUriMap[bmEnvironmentConst.type];
                }

                if(beforeRedirectAction) {
                    beforeRedirectAction().finally(function afterAction() {
                        // goto destination page after completion of promise
                        gotoDestinationPage($window, $location, destUrl || defaultDestinationUrl);
                    });
                } else {
                    // goto destination page
                    gotoDestinationPage($window, $location, destUrl || defaultDestinationUrl);
                }
            });
        }

        function viewPortal(contactId, companyId, userId) {
            var viewPortalUrl = viewPortalUrlV2;
            return bmAccess.has('ClientCenterV2PreviewToggle').then(function() {
                // If using V2 of the toggle, there's no need to use V2 of the view portal end point
                viewPortalUrl = viewPortalUrlV1;
            })
            .catch(angular.noop)
            .finally(function() {
                var req = $http.post(viewPortalUrl, { id: contactId, companyId: companyId, userId: userId });
                req.then(
                    function(resp) {
                        // replace session token with new impersonated session token
                        bmTokenStorage.set(resp.data.LongToken);
                        // store full origin url so we can return
                        window.sessionStorage.setItem(destinationStorageKey, location.href);
                        // TODO: don't hardcode destination, look up and take them to home context
                        bmAccess.has('ClientCenterVnext').then(function() {
                            window.location.href = clientBetaDestUrl;
                        }).catch(function() {
                            if (bmEnvironment.isBrCountryCode()){
                                window.location.href = atendimentoClientDestUrl;
                            } else {
                                window.location.href = clientDestUrl;
                            }
                        });
                    },
                    function(resp) {
                        if (resp.status === 403 && !!resp.data && !!resp.data.message && resp.data.message === 'CC_USER_HAS_BETA') {
                            resp.config.global = false;
                            window.location.href = clientBetaDestUrl;
                        }
                    }
                );
                return req;
            });
        }

        function exitViewPortal() {
            var req = $http.post(exitViewPortalUrl);
            req.then(function(resp) {
                // replace session token with new impersonated session token
                bmTokenStorage.set(resp.data.LongToken);
                // return to origin url or staff
                var returnUrl = window.sessionStorage.getItem(destinationStorageKey) || staffDestUrl;
                window.sessionStorage.removeItem(destinationStorageKey);
                window.location.href = returnUrl;
            });
            return req;
        }

        function updateUserLanguage() {
            var promise, lang = bmLanguageManager.updatedUserLanguage;

            if (lang) {
                promise = loadMeta().then(function(resp) {
                    return $http({
                        method: 'PUT', // PATCH?
                        url: userUrl + '/' + resp.data.PrismGuid,
                        data: {
                            language: lang,
                            firstName: resp.data.FirstName,
                            lastName: resp.data.LastName,
                            email: resp.data.EmailAddress
                        }
                    });
                });
            } else {
                var deferred = $q.defer();
                deferred.resolve();
                promise = deferred.promise;
            }

            return promise;
        }

        function isStaff(grants) {
            return grants.indexOf('staff') > -1;
        }

        function isClientBeta(grants, access) {
            return ((grants.indexOf('client.beta') > -1) || (access.indexOf('ClientCenterVnext') > -1)) && isClient(grants);
        }

        function isAtendimentoClient(grants) {
            return grants.indexOf('client') > -1 && !isStaff(grants) && bmEnvironment.isBrCountryCode();
        }

        function isClient(grants) {
            return grants.indexOf('client') > -1 && !isStaff(grants);
        }

        function isMyPayOnboardingClient(grants){
            return grants.indexOf('client.mypayonboarding') > -1 && !isStaff(grants);
        }

        function isMyPayOnboardingRefAccountant(grants){
            return grants.indexOf('staff.mypayonboarding.refaccountant') > -1;
        }

        function isSamba(grants){
            return grants.indexOf('samba') > -1 && !isMyPayOnboardingClient(grants) && !isEmployee(grants) && !isEmployer(grants) &&!isEsalesCustomerCenter(grants);
        }

        function isEmployeePortalEmployee(grants) {
            return grants.indexOf('employeeportal.employee') > -1 && bmEnvironment.isBrCountryCode();
        }

        function isEmployee(grants){
            return grants.indexOf('samba.employee.center') > -1;
        }

        function isEmployer(grants){
            return grants.indexOf('samba.employer.center') > -1;
        }

        function isEsalesCustomerCenter(grants){
            return grants.indexOf('samba.esales.customer.center') > -1;
        }

        function isStaffDocumentsBasic(grants){
            return grants.indexOf('staff.setup.firm') > -1 && grants.indexOf('staff.setup.clients') > -1;
        }

        function isCsAdmin(grants){
            return grants.indexOf('csadmin') > -1;
        }

        function isCheckPoint(){
            return $location.search().mafUrl;
        }

        function isAuth0CheckPoint() {
            // If cookie bmCheckPointOrigin exists
            // The function bmUtil.cookie always returns string or undefined
            return ((bmUtil.cookie(cookieCheckPoint) !== undefined) && (bmUtil.cookie(cookieCheckPoint) !== ''));
        }

        function isEmergingAccounts(grants){
            return grants.indexOf('emergingaccounts') > -1;
        }

        function evaluateBeforeDirectionExecution(beforeRedirectAction, longToken){
            if(beforeRedirectAction){
                 return beforeRedirectAction()
                 .then(setAuthCheckpointUrl.bind(self, longToken));
             } else {
                  return setAuthCheckpointUrl(longToken);
             }
        }

        function setAuthCheckpointUrl(longToken){
            var defer = $q.defer();
            getCheckpointARSso(longToken).then(function(ssoUrl){
                self.destUrl = getCheckpointUrl(ssoUrl);
                defer.resolve();
            });
            return defer.promise;
        }

        // Get SSO token with UDS Long token for CheckpointAR vertical
        function getCheckpointARSso(longToken) {
            return $http({
                method: 'POST',
                url: '/api/security/v1/sso',
                data: {
                    Vertical: 'CheckpointAR',
                    Path: checkPointARUrl
                },
                headers: { Authorization: 'UDSLongToken' + longToken }
            });
        }

        //Return checkpoint url with mafUrl place in cookie bmCheckPointOrigin and SSOTotken
        function getCheckpointUrl(SsoUrl) {
            var startingUrl;
            if($location.search().mafUrl){
                startingUrl = $location.search().mafUrl;
            } else {
                startingUrl = bmUtil.cookie(cookieCheckPoint);
                bmUtil.cookie(cookieCheckPoint, null);
            }
            return SsoUrl.data.Url + '&redirect=' + startingUrl;
        }

        function loadMeta(conf) {
            var meta = $http.get(sessionMetadataUrl, angular.extend({ cache: true }, conf));

            // refresh
            if (conf && conf.cache === false && self.data.meta.CreatedDateTime) {
                self.data.meta = {};
                self.data.deferred.meta = $q.defer();
                self.data.deferred.all = $q.defer();
            }

            meta.then(function(resp) {
                var data = resp.data;

                // convenience data
                if (data.FirstName) {
                    data.FullName = data.FirstName + ' ' + data.LastName;
                    data.Initials = data.FirstName.charAt(0) + data.LastName.charAt(0);
                } else {
                    data.FullName = data.LastName;
                    data.Initials = data.LastName.charAt(0);
                }

                self.data.meta = data;
                self.data.deferred.meta.resolve(data);

                return data;
            }, function(resp) {
                self.data.deferred.meta.reject(resp);
            });

            return meta;
        }

        function loadBindings(conf) {
            var bindings = $http.get(sessionBindingsUrl, angular.extend({ cache: true }, conf));

            // refresh
            if (conf && conf.cache === false && self.data.bindings.ApplicationConfiguration) {
                self.data.bindings = {};
                self.data.deferred.bindings = $q.defer();
                self.data.deferred.all = $q.defer();
            }

            bindings.then(function(resp) {
                var data = resp.data,
                    frpMap = data.FeatureResourcePermissions.FeatureResourcePermissionsMap,
                    iacs = data.InfrastructureAccessControls;

                // add grants array for convenience
                data.Grants = bmUtil.flattenKeys(frpMap, filterGrants).map(function(key) {
                    return grantsMap[key];
                });

                // add iac array
                data.Access = iacs;

                // persist theme identifier (companyId) in a cookie for pre-auth branding (e.g. login page)
                if (isClient(data.Grants) || isStaff(data.Grants)) {
                    bmTheme.persistTheme(data.ApplicationConfiguration.CompanyId);
                }

                self.data.bindings = data;
                self.data.deferred.bindings.resolve(data);

                return data;
            }, function(resp) {
                self.data.deferred.bindings.reject(resp);
            });

            return bindings;
        }

        function load(conf) {
            var meta = loadMeta(conf),
                bindings = loadBindings(conf),
                all = $q.all([meta, bindings]);

            all.then(function() {
                self.data.deferred.all.resolve(authenticatedSessionData);
            }, function(resp) {
                self.data.deferred.all.reject(resp);
            });

            return self.data.deferred.all.promise;
        }

        function filterGrants(obj, prop) {
            return obj[prop] === 'Granted';
        }

        function destroy(waypointUrl) {
            destroying = true;

            // goto login page, no return dest
            gotoWaypointPage($window, waypointUrl || authWaypointUrl);

            // goto login page, set return dest to current url - no hash location
            // gotoWaypointPage($window, authWaypointUrl, $window.location.href.split('#')[0]);
        }

        function destroyAuth0(waypointUrl) {
            destroying = true;
            destroySession();
            $window.location.href = waypointUrl;
        }

        function destroySession() {
            var token;
            $window.clearTimeout(unloadCancelledTimeout);
            if (destroying) {
                token = bmTokenStorage.get();
                bmTokenStorage.clean();
                $window.sessionStorage.clear();
                if(navigator.sendBeacon) {
                    if(isOnvioSTIDEnabled()) {
                        // use send beacon to send delete request
                        var param = new Blob(
                            [],
                            {type : 'application/json'}
                          );
                          navigator.sendBeacon(deleteOIDCSessionUrl, param);
                    } else {
                        // use send beacon to send delete request
                      var params = new Blob(
                        [JSON.stringify({'longToken': token})],
                        {type : 'application/json'}
                      );
                      navigator.sendBeacon(deleteSessionUrl, params);
                    }
                } else if(isOnvioSTIDEnabled()) {
                    destroyOnvioSTIDSession();
                } else {
                    // make synchronous session delete request ($http can't do sync)
                    // to guarantee this occurs before unloading
                    var req = new $window.XMLHttpRequest();
                    req.open('DELETE', sessionMetadataUrl, false); // false = synchronous
                    req.setRequestHeader('Authorization', tokenType + ' ' + token);
                    req.send(null);
                    $log.info('Sorry, while we are aware that synchronous XHR is generally bad, in this case it is intentional.');
                }
            }
        }

        function getRequestedDestination() {
            var dest = $location.search()[destinationQueryStringKey], hash;
            if (dest) {
                hash = $location.hash();
                if (hash) {
                    // concat hash for full dest
                    dest = dest + '#' + hash;
                }
                dest = decodeURIComponent(dest);
            }
            return dest;
        }

        function gotoDestinationPage($window, $location, fallbackUrl) {
            $window.location.href = getRequestedDestination($location) || fallbackUrl;
        }

        function destroyOnvioSTIDSession() {
            // make synchronous session delete request ($http can't do sync)
            // to guarantee this occurs before unloading
            var request = new $window.XMLHttpRequest();
            request.open('POST', deleteOIDCSessionUrl, false); // false = synchronous
            request.withCredentials = true;
            request.send();
        }

        function isOnvioSTIDEnabled(){
            return bmAccess.has('Platform_EnableOnvioSTID').then(function(){
                return true;
            }).catch(function(){
                return false;
            });
        }

        $window.addEventListener('beforeunload', function() {
            unloadCancelledTimeout = $window.setTimeout(function() {
                // unload was cancelled, reset state
                destroying = false;
            }, 1000);
        }, false);

        $window.addEventListener('unload', function() {
            destroySession();
        }, false);
    }

    function HttpAnalyticsInterceptor(bmUtil, $rootScope) {
        this.request = function(conf) {
            var callId = bmUtil.generateUUID();
            var chainId = bmUtil.generateUUID();
            conf.headers['x-call-id'] = callId;
            conf.headers['x-chain-id'] = chainId;
            $rootScope.$emit('$httpRequestEvent', {
                url: conf.url,
                method: conf.method,
                'x-call-id': callId,
                'x-chain-id': chainId
            });
            return conf;
        };
    }

    function HttpTimeoutInterceptor(httpTimeout) {
        this.request = function(conf) {
            if (angular.isUndefined(conf.timeout)) {
                conf.timeout = httpTimeout;
            }
            return conf;
        };
    }

    function HttpAuthInterceptorProvider() {
        var redirect = true,
            auth = true;

        this.auth = function(val) {
            auth = val;
        };
        this.redirect = function(val) {
            redirect = val;
        };

        this.$get = ['$window', '$location', '$document', '$q', 'authWaypointUrl', 'bmTokenStorage','bmEnvironmentConst', 'bmUtil','$injector',
            function($window, $location, $document, $q, authWaypointUrl, bmTokenStorage, bmEnvironmentConst, bmUtil, $injector) {

                return {
                    request: function(conf) {
                        if (auth && conf.bmNoAuth !== true) {
                            var token = bmTokenStorage.get();

                            if (token) {
                                conf.headers.Authorization = tokenType + ' ' + token;
                            }
                        }
                        return conf;
                    },
                    responseError: function(resp) {
                        if (resp.status === 401 && redirect && resp.config.bmAuthRedirect !== false) {
                            $injector.get('bmAccess').not('Platform_DisableAuth0Phase2').then(function () {
                                var origin = $window.location.origin;
                                var domain = origin.match(/^https?\:\/\/([^\/?#]+)(?:[\/?#]|$)/i)[1].split('onvio')[1];
                                var auth0ClientIdLogout = bmEnvironmentConst.auth0ClientId;
                                // If it is CA and have fr-CA we use the region locale Auth0 client ID
                                if (domain === '.ca' && bmUtil.cookie('BMLanguageCode') === 'fr-CA') {
                                    auth0ClientIdLogout = bmEnvironmentConst.auth0RegionLocaleClientId;
                                }

                                // for development purposes
                                if (bmEnvironmentConst.isLocalType) {
                                    origin = origin + '/login';
                                }

                                createAuth0Client({ domain: bmEnvironmentConst.auth0Domain, client_id: auth0ClientIdLogout }).then(function(auth0) { // jshint ignore:line
                                    resp.config.global = false;
                                    // Validate that pathname includes / at the end
                                    var trailingSlash = ($window.location.pathname.search(/\/$/) !== -1) ? '' : '/';
                                    var destinationUrl = $window.location.pathname + trailingSlash + $window.location.search + $window.location.hash;
                                    // remove 'notfound' at the end if it exists
                                    destinationUrl = destinationUrl.replace(/\/notfound$/, '/');
                                    // Create cookie on this space
                                    // if dest, encode it in waypoint so we can return after auth
                                    document.cookie = cookieDeepLink + '=' + destinationUrl + '; path=/; Max-Age=7200; Secure';

                                    // Limit of minutes to clear the session for csdesktop app
                                    var minutes = 6;
                                    if($location.search().timestamp){
                                        var now = new Date();
                                        var timeRequested = new Date(decodeURIComponent($location.search().timestamp).substring(0,19));

                                        if(!(timeRequested instanceof Date) || isNaN(timeRequested)){
                                            auth0.logout({returnTo: origin});
                                        }
                                        var timeDiff = Math.abs(now - timeRequested);
                                        minutes = Math.floor(timeDiff / (1000 * 60));
                                    }

                                    // Validate if it's from csdesktop and the timestamp to skip the logout
                                    if($location.search().from === 'csdesktop' && minutes <= 5){
                                        // If the url is for migration dashboard remove the additional parameters
                                        // to avoid the url be double encoded at the end by the MFE migration dashboard
                                        if(destinationUrl.indexOf('dashboard') !== -1){
                                            var fixedDestinationUrl = destinationUrl.substring(0, destinationUrl.indexOf('dashboard') + 9);
                                            document.cookie = cookieDeepLink + '=' + fixedDestinationUrl + '; path=/; Max-Age=7200; Secure';
                                        }
                                        gotoWaypointPage($window, origin);
                                    } else {
                                        auth0.logout({returnTo: origin});
                                    }
                                });
                            }).catch(angular.noop);
                            $injector.get('bmAccess').has('Platform_DisableAuth0Phase2').then(function() {
                                // don't get caught up in the global error handler
                                resp.config.global = false;
                                // goto login page, set return dest to current url
                                gotoWaypointPage($window, authWaypointUrl, $window.location.href);
                            }).catch(angular.noop);
                        }
                        return $q.reject(resp);
                    }
                };
            }];
        }

    var globalHttpServerError = { type: 'danger', msg: 'A server error ocurred.', closeable: true };
    function HttpLogInterceptor($timeout, $q, $rootScope) {
        this.responseError = function(resp) {
            // bump to next event loop, so error/catch can disable it if handled
            $timeout(function() {
                if (resp.config.global !== false) {
                    // make copy and add response obj
                    var errCopy = angular.copy(globalHttpServerError);
                    errCopy.detail = resp;

                    if (!$rootScope.bmErrors) {
                        $rootScope.bmErrors = [];
                    }

                    $rootScope.bmErrors.unshift(errCopy);
                }
            });
            return $q.reject(resp);
        };
    }

    function gotoWaypointPage($window, waypointUrl, destinationUrl) {
        var href = waypointUrl;

        // if dest, encode it in waypoint so we can return after auth
        if (destinationUrl) {
            // remove 'notfound' at the end if it exists
            destinationUrl = destinationUrl.replace(/\/notfound$/, '/');
            // append hash if necessary
            if (waypointUrl.indexOf('#') === -1) {
                href += '#/';
            }
            // append appropriate "hashSearch" delimiter
            href += /#.*\?/.test(waypointUrl) ? '&' : '?';
            // append dest as "hashSearch" param
            href += destinationQueryStringKey + '=' + encodeURIComponent(destinationUrl);
        }

        $window.location.href = href;
    }

    function config($httpProvider) {
        $httpProvider.interceptors.push('HttpAuthInterceptor');
        $httpProvider.interceptors.push('HttpLogInterceptor');
        $httpProvider.interceptors.push('HttpTimeoutInterceptor');
        $httpProvider.interceptors.push('HttpAnalyticsInterceptor');
    }

    //This function is used for the domain switch between linked accounts.
    function processSsoLogin($log, ssoUrl, ssoTokenKey, bmTokenStorage, ssoToken) {
        var ssoApi = ssoUrl + '?' + ssoTokenKey + '=' + ssoToken + '&pre-created=true';
        var request = new XMLHttpRequest();
        /* A synchronous XHR is made to retrieve the long token before other calls can be successfully made.
           Future improvement: a more elegant approach is to use an asynchronous call (which is more pattern consistent)
           and use the event trigger to manually boostrap the Angular(JS) components */
        $log.info('A synchronous XHR is used to retrieve the sso long token before all other calls can be made');
        request.open('GET', ssoApi, false);
        request.send(null);
        if (request.status === 200) {
          var longToken = (JSON.parse(request.responseText)).LongToken;
          bmTokenStorage.clean();
          bmTokenStorage.set(longToken);
        } else {
          $log.info('Sso login failed: ' + request.responseText);
        }
    }

    function run($window, $location, $timeout, $rootScope, $http, $translate, $log, bmUtil, bmTokenStorage, authenticatedSessionData, bmAnalyticsService, ssoUrl, ssoTokenKey) {
        var ssoToken = $location.search().token;
        if (ssoToken) {
            processSsoLogin($log, ssoUrl, ssoTokenKey, bmTokenStorage, ssoToken);
        }

        authenticatedSessionData.get().then(function(data) {
            $http.defaults.headers.common['x-company-id'] = data.bindings.ApplicationConfiguration.CompanyId;

            // DEPRECATED
            $http.defaults.headers.common['x-cobalt-security-userguid'] = data.meta.PrismGuid;
            // x-user-id will replace x-cobalt-security-userguid
            $http.defaults.headers.common['x-user-id'] = data.meta.PrismGuid;

            // DEPRECATED
            $http.defaults.headers.common['x-cobalt-security-sessionid'] = data.meta.SessionId;
            // x-session-id will replace x-cobalt-security-sessionid
            $http.defaults.headers.common['x-session-id'] = data.meta.SessionId;
        });

        logHttpReqestAnalyticsEvents($rootScope, bmAnalyticsService);

        // delay till next event loop so all initial requests have same rootGuid
        // regardless of redirection
        $timeout(function() {
            $rootScope.$on('$stateChangeSuccess', setRouteId);
            $rootScope.$on('$routeChangeSuccess', setRouteId);
        });

        // localize global http response error msg
        function localize() {
            $translate('bm.session.servererror').then(function(val) {
                globalHttpServerError.msg = val;
            });
        }
        $timeout(function() {
            localize(); // localize now (well..next cycle, to get around refresh bug)
            $rootScope.$on('bmLanguageChangeSuccess', localize); // localize on lang change
        });

        function logHttpReqestAnalyticsEvents($rootScope, bmAnalyticsService) {
            $rootScope.$on('$httpRequestEvent', function(evt, data) {
                bmAnalyticsService.track('Browser HTTP request', data);
            });
        }

        function setRouteId() {
            var uuid = bmUtil.generateUUID();
            var guid = bmUtil.generateTRMRGUID(uuid);
            // DEPRECATED
            $http.defaults.headers.common['x-cobalt-pcid'] = guid;
            // x-route-id will replace x-cobalt-pcid
            $http.defaults.headers.common['x-route-id'] = uuid;
        }

        // bootstrap a value for startup requests
        setRouteId();
    }

    // ANGULAR

    AuthenticatedSessionData.$inject = ['$q'];

    AuthenticatedSession.$inject = [
        '$window',
        '$document',
        '$log',
        '$location',
        '$q',
        '$http',
        '$rootScope',
        '$uibModal',
        'HttpLogInterceptor',
        'sessionMetadataUrl',
        'sessionMetadataUrlV2',
        'sessionBindingsUrl',
        'authWaypointUrl',
        'defaultDestinationUrl',
        'ssoUrl',
        'ssoTokenKey',
        'AuthenticatedSessionData',
        'bmUtil',
        'bmTheme',
        'bmLanguageManager',
        'bmEnvironmentConst',
        'bmEnvironment',
        'bmAccess',
        'csWebLoginUriMap',
        'bmTokenStorage'
    ];

    HttpLogInterceptor.$inject = [
        '$timeout',
        '$q',
        '$rootScope'
    ];

    HttpTimeoutInterceptor.$inject = [
        'httpTimeout'
    ];

    HttpAnalyticsInterceptor.$inject = [
        'bmUtil',
        '$rootScope'
    ];

    config.$inject = ['$httpProvider'];

    run.$inject = ['$window',
        '$location',
        '$timeout',
        '$rootScope',
        '$http',
        '$translate',
        '$log',
        'bmUtil',
        'bmTokenStorage',
        'AuthenticatedSessionData',
        'bmAnalyticsService',
        'ssoUrl',
        'ssoTokenKey'
    ];

    angular.module('bluemoon.components.session', [
        'bluemoon.components.util',
        'bmTokenStorage',
        'bluemoon.components.theme',
        'bluemoon.components.i18n',
        'pascalprecht.translate',
        'bmEnvironment',
        'bluemoon.components.analytics'
    ])

        .value('sessionMetadataUrl', '/api/security/v1/sessions')
        .value('sessionMetadataUrlV2', '/api/security/v2/sessions')
        .value('sessionBindingsUrl', '/api/security/v1/session-bindings')
        .value('ssoUrl', '/api/security/v1/sso')
        .value('authWaypointUrl', '/login/')
        .value('defaultDestinationUrl', staffDestUrl)
        .value('ssoTokenKey', 'token')
        .value('httpTimeout', 60000) // 60 seconds
        .value('csWebLoginUriMap', {
            'LOCAL': 'https://cswebdev.int.thomsonreuters.com/myaccount/login.aspx',
            'UNKNOWN': 'https://cswebdev.int.thomsonreuters.com/myaccount/login.aspx',
            'CI': 'https://cswebdev.int.thomsonreuters.com/myaccount/login.aspx',
            'DEMO': 'https://cswebdev.int.thomsonreuters.com/myaccount/login.aspx',
            'QED': 'https://cswebqa.int.thomsonreuters.com/myaccount/login.aspx',
            'PROD': 'https://cs.thomsonreuters.com/myaccount/login.aspx'
        })
        .service('AuthenticatedSession', AuthenticatedSession)
        .service('AuthenticatedSessionData', AuthenticatedSessionData)
        .provider('HttpAuthInterceptor', HttpAuthInterceptorProvider)
        .service('HttpLogInterceptor', HttpLogInterceptor)
        .service('HttpTimeoutInterceptor', HttpTimeoutInterceptor)
        .service('HttpAnalyticsInterceptor', HttpAnalyticsInterceptor)

        .config(config)
        .run(run);

})(window.angular);

/**
 * Blue Moon Components - theme module
 */
(function(angular) {
    'use strict';

    angular.module('bluemoon.components.theme', ['bluemoon.components.util'])
        .value('bmThemeCookieName', 'bmTheme')
        .value('bmThemeType', 'staff') // default to staff
        .value('bmThemeUrl', '/api/profiles/v1/themes')
        .value('bmThemeHeaderUrl', '/api/profiles/v1/themes/header')
        .service('bmTheme', Theme);

    Theme.$inject = [
        '$http',
        '$document',
        '$q',
        'bmThemeUrl',
        'bmThemeHeaderUrl',
        'bmThemeType',
        'bmUtil',
        'bmEnvironment',
        'bmThemeCookieName'
    ];

    function Theme($http, $document, $q, themeUrl, themeHeaderUrl, themeType, util, env, themeCookieName) {
        var self = this,
            promise;

        // properties
        self.data = {
            themeType: themeType
            // header: {...}
            // advert: {...}
        };
        self.useTheme = (themeType === 'client' || !!util.cookie(themeCookieName));

        // methods
        self.load = load;
        self.loadHeader = loadHeader;

        // available for theme override
        self.applyTheme = applyTheme;

        self.persistTheme = persistTheme;

        function persistTheme(companyId) {
            util.cookie(themeCookieName, companyId, '/', true);
        }

        function loadHeader(companyId, refresh) {
            return load(companyId, themeHeaderUrl, refresh);
        }

        // todo: figure out best way to differentiate staff/client/employee
        function load(params, url, refresh) {

            // todo: make sure params match the promise
            if (!refresh && promise) { return promise; }

            url = url || themeUrl;

            if (self.useTheme) {
                if (!angular.isDefined(params)) {
                    params = util.cookie(themeCookieName);
                }
                if (angular.isDefined(params)) {
                    if (typeof params !== 'object') {
                        params = { company: params }; // default to company
                    }
                    // if the response is cached refreshed data will be incorrect
                    promise = $http.get(url, { params: params });
                    promise.then(function(resp) {
                        self.data.header = resp.data;
                    });
                }
            }

            if (!promise) {
                var deferred = $q.defer();
                promise = deferred.promise;
                self.data.header = null;
                deferred.resolve({ data: self.data });
            }

            promise.then(function() {
                resolveAdvertData();
            });

            return promise;
        }

        // Note: this is something that could and maybe should be pushed behind the service
        // layer as it's biz logic that is spilling out to the client
        function resolveAdvertData() {
            var img, txt, href, useAdvert = false, country = env.getCountryCode();

            if (self.data.header) {
                txt = self.data.header.loginPageText;
                img = self.data.header.loginPageImage;
                useAdvert = !!(txt || img);
            }

            if (!self.useTheme && !txt && !img) {
                switch (country) {
                    case 'us':
                        /* NOTE: can't drive it from data due to versioning of img, supply country
                           so consumer can construct a class and declare an image path in css.
                           This should be refactored to use server-side img data which is more
                           consistent with the way we do branding logos. */
                        // img = 'components/img/synergy2015.jpg';
                        href = 'http://cs.thomsonreuters.com/SYNERGY/';
                        break;
                    case 'uk':
                        // see above coment
                        // img = 'components/img/synergy2015-gb.jpg';
                        href = 'https://www.digita.com';
                        break;
                    case 'ca':
                        // add when ready
                        break;
                }
                if (href) {
                    useAdvert = true;
                }
            }

            if (useAdvert) {
                self.data.advert = { country: country, img: img, text: txt, href: href };
            }
        }

        function applyTheme() {
            // todo: should apply theme try to load the theme first?
            var html = angular.element($document[0].documentElement);
            var colors = self.data.header ? self.data.colors : undefined;

            if (!colors) { return; }

            var head = html.find('head'),
                headerFill = normalizeHex(colors.headerFillColor),
                headerText = normalizeHex(colors.headerTextColor),
                altHeaderFill = hexToRgba('#888888', 0.2),
                //altHeaderText = (headerText === '#ffffff' ? '#ddd' : hexToRgba(headerText, 0.5)),
                buttonFill = normalizeHex(colors.buttonFillColor),
                buttonText = normalizeHex(colors.buttonTextColor),
                // todo: sanitize css values, move selectors to appropriate components?
                // try to template this as html
                style = angular.element([
                    '<style>',
                        '.btn.btn-primary {',
                            'color:', buttonText, ' !important;',
                            'background-color:', buttonFill, ' !important;',
                            'border-color:', 'rgba(0,0,0,.2) !important', ';', // ?
                        '}',
                        '.btn.btn-primary:hover {',
                            'border-color:', 'rgba(0,0,0,.4) !important', ';', // ?
                        '}',
                        '.nav-pills > li.active > a,',
                        '.nav-pills > li > a:hover,',
                        '.nav-pills > li > a:focus {',
                            'color:', buttonFill, ' !important;',
                        '}',
                        'bm-nav ul a.bm-header-active {',
                            'border-color:', buttonFill, ' !important;',
                        '}',
                        'bm-header {',
                            'background-color:', headerFill, ';',
                            'color:', headerText, ';',
                        '}',
                        'bm-header header h1 em {',
                            'color:', buttonFill, ';',
                        '}',
                        'bm-header a {',
                            'color:', headerText, ';',
                        '}',
                        'bm-header-active a > .bm-icon,',
                        'bm-header a .bm-profile-photo .initials {',
                            'border-color:', headerText, ';',
                        '}',
                        'bm-header a:focus {',
                            'color:', headerText, ';',
                        '}',
                        'bm-header a:hover > .bm-icon,',
                        'bm-header a:focus > .bm-icon,',
                        'bm-header [dropdown].open > a > .bm-icon {',
                            'border-color:', headerText, ';',
                        '}',
                        'bm-header a:hover,',
                        '.mask-active .bm-header-nav-toggle,',
                        'bm-header [dropdown].open > a {',
                            'color:', headerText, ';',
                            'background-color:', altHeaderFill, ';',
                        '}',
                        'bm-header .dropdown-menu > li > a:hover,',
                        'bm-header .dropdown-menu > li > a:focus,',
                        'bm-header .dropdown-menu > .active > a,',
                        'bm-header .dropdown-menu > .active > a:hover,',
                        'bm-header .dropdown-menu > .active > a:focus {',
                            'color:', buttonText, ' !important;',
                            'background-color:', buttonFill, ';',
                        '}',
                    '</style>'
                ].join(''));

            head.append(style);
        }
    }

    // variation on http://stackoverflow.com/a/5624139
    function normalizeHex(hex) {
        // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
        var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
        hex = hex.replace(shorthandRegex, function(m, r, g, b) {
            return r + r + g + g + b + b;
        });
        return hex.toLowerCase();
    }
    function hexToRgba(hex, a) {
        hex = normalizeHex(hex);
        var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
        return result ? 'rgba(' +
            parseInt(result[1], 16) + ',' +
            parseInt(result[2], 16) + ',' +
            parseInt(result[3], 16) + ',' +
            a + ')'
        : null;
    }

})(window.angular);

(function(window, angular){
    'use strict';

    var queue = new window.bmJobQueue();

    angular.module('bmJobQueue', [])
    .value('bmJobQueue', queue);
})(window, window.angular);

(function (angular) {
    'use strict';

    angular.module('bluemoon.passwordValidation', []);
})(window.angular);

(function (angular) {
    'use strict';

    angular.module('bluemoon.passwordValidation').factory('PasswordValidationFactory', passwordValidation);
    passwordValidation.$inject = ['$q', '$translate', '$http', 'bmEnvironment'];

    function passwordValidation($q, $translate, $http, bmEnvironment) {
        return {
            loadPasswordRules: function() {
                var deferred = $q.defer();
                bmEnvironment.getRoute('ProfileServices').then(function(url){
                    url += '/v2/password/rules';
                    $http.get(url, {headers: { 'Accept': 'application/json' }}).then(function(response){
                        var pwReqs = response.data;

                        var translatePromises = [
                            $translate('bm.password.validation.characterRule'),
                            $translate('bm.password.validation.numberRule'),
                            $translate('bm.password.validation.lowerCaseRule'),
                            $translate('bm.password.validation.upperCaseRule'),
                            $translate('bm.password.validation.specialCharactersRule'),
                            $translate('bm.password.validation.containsProhibitedCharacters')
                        ];

                        $q.all(translatePromises).then(function(translations){

                            deferred.resolve(
                                {
                                    charClassReq: pwReqs.classes,
                                    charLengthReq: pwReqs.chars,
                                    rules:
                                    {
                                        characterLengthRule:
                                        {
                                            label : translations[0],
                                            test : function (password) {
                                                return password && password.length >= pwReqs.chars;
                                            }
                                        },
                                        characterTypeRules: [
                                            {
                                                label : translations[1],
                                                test : function (password) {
                                                    return password && /[0-9]/.test(password);
                                                }
                                            },
                                            {
                                                label : translations[2],
                                                test : function (password) {
                                                    return password && /[a-z]/.test(password);
                                                }
                                            },
                                            {
                                                label : translations[3],
                                                test : function (password) {
                                                    return password && /[A-Z]/.test(password);
                                                }
                                            },
                                            {
                                                label : translations[4] + ' ` ~ ! @ # $ % ^ & * ( ) _ - + < = > { } [ ] \\ | : ; " \' , . ? /',
                                                test : function (password) {
                                                    return password && /[`~\!@#\$%\^&\*\(\)_\-+<=>{}\[\]\\\|:;\"\',\.\?\/]+/.test(password);
                                                }
                                            }
                                        ],
                                        prohibitedCharacterRule:
                                        {
                                            label : translations[5],
                                            test : function (password) {
                                                return password && /[^a-zA-Z0-9`~/\\\[\]+=|(){}:;'"<>,.?!@#$%^&*\-_¡¢¤¥´ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖØÙÚÛÜÝÞßàáâãäåæçèéêëìíîïðñòóôõöøùúûüýþÿ]/.test(password);
                                            },
                                            getInvalidChars : function (password) {
                                                var matches = new Set();
                                                var pattern = /[^a-zA-Z0-9`~/\\\[\]+=|(){}:;'"<>,.?!@#$%^&*\-_¡¢¤¥´ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖØÙÚÛÜÝÞßàáâãäåæçèéêëìíîïðñòóôõöøùúûüýþÿ]/g;
                                                var match = pattern.exec(password);

                                                while(match){
                                                    matches.add(match[0]);
                                                    match = pattern.exec(password);
                                                }
                                                return Array.from(matches);
                                            }

                                        }
                                    }
                                }
                            );
                        });
                    });

                });
                return deferred.promise;
            }
        };
    }
})(window.angular);

(function (angular) {
    'use strict';

    angular.module('bluemoon.passwordValidation').directive('bmPasswordValidation', passwordValidation);
    passwordValidation.$inject = ['PasswordValidationFactory'];

    function passwordValidation(PasswordValidationFactory) {
        return {
            restrict: 'EA',
            templateUrl: 'components/password-validation/password-validation.2js.html',
            scope: {
                password: '=password'
            },
            controller: ['$scope', function ($scope) {
                PasswordValidationFactory.loadPasswordRules().then(function (resp) {
                    angular.extend($scope, resp);
                });
            }]
        };
    }
}(window.angular));

(function(angular) {
    'use strict';

    angular.module('bluemoon.components.bluemoonRequiredMark', ['pascalprecht.translate'])
        .filter('bluemoonRequiredMark', bluemoonRequiredMark)
        .filter('bmRequiredMark', bluemoonRequiredMark);

    bluemoonRequiredMark.$inject = ['$translate'];
    function bluemoonRequiredMark($translate) {
        return function(input, makeRequired) {
            if(typeof makeRequired === 'undefined' || makeRequired === null) {
                makeRequired = true;
            }
            if(angular.isFunction(input)) {
                input = input();
            }
            if (!makeRequired) {
                return input;
            }
            return $translate.instant(
                'Bluemoon.Components.BluemoonRequiredMark.RequiredFieldLabel',
                { 'n0': input });
        };
    }
}(window.angular));

/// <reference path="~/node_modules/angular/angular.js" />
(function(angular) {
    'use strict';
    var module = angular.module('bluemoon.components.ConfirmNavigationController', []);
    module.controller('bluemoon.components.ConfirmNavigationController',
        ['$scope', '$uibModalInstance', function($scope, $uibModalInstance) {
            $scope.ok = function() {
                //alert("ok clicked");
                $uibModalInstance.close(false);
            };

            $scope.save = function() {
                //alert("save clicked");
                $uibModalInstance.close(true);
            };

            $scope.cancel = function() {
                //alert("cancel clicked");
                $uibModalInstance.dismiss('cancel');
            };
        }]);

}(window.angular));

/// <reference path="~/node_modules/angular/angular.js" />
(function(angular) {
    'use strict';
    angular.module('bluemoon.components.SaveInProgressModalController', [])
        .controller('bluemoon.components.SaveInProgressModalController',
    [
        '$scope', '$uibModalInstance', function($scope, $uibModalInstance) {
            $scope.cancel = function() {
                $uibModalInstance.dismiss('cancel');
            };
        }
    ]);

}(window.angular));

(function(window, angular, Rx) {
    'use strict';
    // this service is based on this article:
    // http://markcampbell.me/tutorial/2013/10/08/preventing-navigation-in-an-angularjs-project.html
    var NavigationUtils = (function() {
        var _$inject = [
            '$injector',
            '$rootScope',
            '$location',
            '$log',
            '$uibModal',
            'fef.Utils',
            'fef.PromiseUtils',
            '$translate'
        ];

        function NavigationUtilsImpl(
            $injector,
            $rootScope,
            $location,
            $log,
            $uibModal,
            utils,
            promiseUtils,
            $translate) {

            var preventNavigation = false;
            var preventNavigationUrl = null;
            var dialogOpen = false;
            var onSaveFunc = null;
            var _promise = null;
            var _assumeSave = false;
            var $state = $injector.has('$state') ? $injector.get('$state') : null;

            this.allowNavigation = function() {
                preventNavigation = false;
                onSaveFunc = null;
                // don't modify onbeforeunload event while unit testing
                if(!utils.exists(angular.mock)) {
                    window.onbeforeunload = null;
                }
            };

            this.preventNavigation = function(saveFunc, assumeSave) {
                var self = this;
                if(utils.exists(saveFunc) && !angular.isFunction(saveFunc)) {
                    throw new Error('NavigationUtils.preventNavigation: invalid argument saveFunc. Was expecting a function or null/undefined.');
                }

                if(!utils.exists(assumeSave)) {
                    assumeSave = false;
                }
                _assumeSave = assumeSave;
                onSaveFunc = saveFunc;
                preventNavigation = true;
                preventNavigationUrl = $location.absUrl();
                // don't modify onbeforeunload event while unit testing
                if(!utils.exists(angular.mock)) {
                    window.onbeforeunload = function(e) {
                        var ret = self.handleOnBeforeUnload(e);
                        e.returnValue = ret;
                        return ret;
                    };
                }
            };

            /**
             * Captures the required information prior to preventing a state change so it can be re-issued at a later date
             */
            this.pauseStateChange = function (toState, toParams, fromState, fromParams) {
                return {
                    toState: toState ? toState.name : undefined,
                    toParams: toParams ? angular.copy(toParams) : {},
                    fromState: fromState ? fromState.name : undefined,
                    fromParams: fromParams ? angular.copy(fromParams) : {},
                };
            };

            /**
             * Continues a state change that was previously prevented (usually whilst another process such as saving takes place before navigating away)
             */
            this.continueStateChange = function ($state, stateChange) {

                // When working with multiple levels, the id parameter will need to be specified to avoid conflict (e.g. id -> childId -> grandChildId)
                var idStateParam = $state.params.idParam || 'id';

                if(
                    /* originally coming from a 'new' item */
                    stateChange.fromParams[idStateParam] === 'new' &&
                    /* going to a 'new' item */
                    stateChange.toParams[idStateParam] === 'new' &&
                    /* the current state has been updated with an id that is not 'new' (i.e. has been saved) */
                    $state.params[idStateParam] !== 'new' &&
                    /* VERY SPECIFIC: when going to a different state (to avoid a situation such as 'Save & New' updating the id incorrectlly) */
                    stateChange.toState !== stateChange.fromState &&
                    /* VERY SPECIFIC: when coming from the 'general' tab */
                    stateChange.fromState.substr(stateChange.fromState.length - 8, 8) === '.general' &&
                    /* VERY SPECIFIC: when going to a sibling or child state */
                    stateChange.toState.substr(0, stateChange.fromState.length - 8) === stateChange.fromState.substr(0, stateChange.fromState.length - 8)
                    ) {
                    // Update the params to include the newly saved item id
                    stateChange.toParams[idStateParam] = $state.params[idStateParam];
                }

                $state.go(stateChange.toState, stateChange.toParams);

            };

            /**
             * DEPRECATED. Pass a saveFunc to preventNavigation instead.
             */
            this.setPromise = function(promise) {
                _promise = promise;
            };

            var locationChangeStartSubject = new Rx.ReplaySubject(1);
            /**
             * DEPRECATED (probably)
             */
            this.locationChangeStart = function() {
                return this.locationChangeStartSubject.asObservable();
            };

            if(typeof $state !== 'undefined' && $state !== null) {
                this.handleStateChangeStart = function(event, toState, toParams, fromState, fromParams) {
                    var self = this;
                    // tried to navigate while the dialog is open. go ahead and prevent it.
                    // User must dismiss the dialog before continuing.
                    // We only want one dialog at a time. This might catch a double click on
                    // the back button, for instance.
                    if(dialogOpen) {
                        event.preventDefault();
                        return;
                    }

                    if(preventNavigation) {
                        event.preventDefault();
                        dialogOpen = true;
                        var modalInstance;
                        // Capture the parts of the state change that we paused so it can be continued later
                        var pausedStateChange = self.pauseStateChange(toState, toParams, fromState, fromParams);
                        var finishNavigation = function() {
                            dialogOpen = false;
                            preventNavigation = false;
                            // Continue the paused state change
                            self.continueStateChange($state, pausedStateChange);
                        };

                        if(_assumeSave) {
                            if(utils.exists(_promise)) {
                                throw new Error('NavigationUtils.handleStateChangeStart: setting the promise not supported when assumeSave is set to true.');
                            }

                            if(!utils.exists(onSaveFunc)) {
                                throw new Error('NavigationUtils.handleLocationChangeStart: was expecting onSaveFunc to be a function.');
                            }
                            var savePromise = onSaveFunc();
                            savePromise['finally'](function() {
                                dialogOpen = false;
                            });

                            return savePromise.then(function() {
                                finishNavigation();
                            });
                        } else {
                            if(_promise !== null) {
                                modalInstance = $uibModal.open({
                                    templateUrl: 'components/navigation-utils/save-in-progress-modal.2js.html',
                                    controller: 'bluemoon.components.SaveInProgressModalController'
                                });
                                modalInstance.result.then(function() {

                                })['finally'](function() {
                                    dialogOpen = false;
                                });

                                return _promise.then(
                                    function() { // success
                                        modalInstance.dismiss('cancel');
                                        finishNavigation();
                                    },
                                    function() { // error
                                        modalInstance.opened.then(function() {
                                            modalInstance.dismiss('cancel');
                                        });
                                    }
                                );

                            } else {
                                modalInstance = $uibModal.open({
                                    templateUrl: 'components/navigation-utils/confirm-navigation.2js.html',
                                    controller: 'bluemoon.components.ConfirmNavigationController'
                                });
                                modalInstance.result.then(function(saveClicked) {
                                    if(saveClicked) {
                                        if(!utils.exists(onSaveFunc)) {
                                            throw new Error('NavigationUtils.handleLocationChangeStart: was expecting onSaveFunc to be a function.');
                                        }
                                        return onSaveFunc().then(function() {
                                            finishNavigation();
                                        });
                                    } else {
                                        finishNavigation();
                                    }
                                    return promiseUtils.resolvedPromise();
                                })['finally'](function() {
                                    dialogOpen = false;
                                });
                            }
                        }
                    } else {
                        self.allowNavigation();
                    }
                };
            }

            /**
             * DEPRECATED. Use handleStateChangeStart for now.
             */
            this.handleLocationChangeStart = function(event, next, current) {
                var self = this;
                if(_assumeSave) {
                    throw new Error('NavigationUtils.handleLocationChangeStart: assumeSave option not yet supported. Use handleStateChangeStart instead.');
                }
                locationChangeStartSubject.onNext({
                    event: event,
                    next: next,
                    current: current
                });

                // tried to navigate while the dialog is open. go ahead and prevent it.
                // User must dismiss the dialog before continuing.
                // We only want one dialog at a time. This might catch a double click on
                // the back button, for instance.
                if(dialogOpen) {
                    event.preventDefault();
                    return;
                }

                if(preventNavigationUrl !== current || preventNavigationUrl === null) {
                    self.allowNavigation();
                    return;
                }

                if(preventNavigation) {
                    event.preventDefault();
                    dialogOpen = true;
                    var modalInstance;

                    var finishNavigation = function() {
                        preventNavigation = false;
                        var indexOfUrl = $location.absUrl().indexOf($location.url(), 0);
                        var newUrl = next.substr(indexOfUrl, next.length - indexOfUrl);
                        $location.url(newUrl);
                    };

                    if (_promise !== null) {
                        modalInstance = $uibModal.open({
                            templateUrl: 'components/navigation-utils/save-in-progress-modal.2js.html',
                            controller: 'bluemoon.components.SaveInProgressModalController'
                        });
                        modalInstance.result.then(function() {

                        })['finally'](function() {
                            dialogOpen = false;
                        });

                        return _promise.then(
                            function() { // success
                                modalInstance.dismiss('cancel');
                                finishNavigation();
                            },
                            function() { // error
                                modalInstance.opened.then(function() {
                                    modalInstance.dismiss('cancel');
                                });
                            }
                        );

                    } else {
                        modalInstance = $uibModal.open({
                            templateUrl: 'components/navigation-utils/confirm-navigation.2js.html',
                            controller: 'bluemoon.components.ConfirmNavigationController'
                        });
                        modalInstance.result.then(function(saveClicked) {
                            if (saveClicked) {
                                if (!utils.exists(onSaveFunc)) {
                                    throw new Error('NavigationUtils.handleLocationChangeStart: was expecting onSaveFunc to be a function.');
                                }
                                return onSaveFunc().then(function() {
                                    finishNavigation();
                                });
                            } else {
                                finishNavigation();
                            }
                            return promiseUtils.resolvedPromise();
                        })['finally'](function() {
                            dialogOpen = false;
                        });
                    }
                } else {
                    self.allowNavigation();
                }
            };

            this.handleOnBeforeUnload = function(e) {
                // What should we do if the dialog is already open?
                // probably still bring up the browser dialog over the top of it.
                if(preventNavigation && $location.absUrl() === preventNavigationUrl) {
                    e.returnValue = $translate.instant('Bluemoon.Components.NavigationUtils.ConfirmNavigation.BrowserMessage');
                    return e.returnValue;
                }
                e.preventDefault();
            };

            /**
             * Intended to be called on $stateChangeStart in an application. It will look for a redirectTo property on a state
             * object which is a string indicating the name of another state which should be redirected to instead of loading the first state.
             * One use case for this is where we had a state previously and then introduced child states and we want to make
             * the parent state redirect to a child as the default state if you try to go to the parent.
             **/
            this.useRedirectToIfPresentOnState = function(event, toState, toParams){
                if (toState.redirectTo) {
                    event.preventDefault();

                    // location: 'replace' will "update url and also replace last history record",
                    // which fixes a bug where the back button gets stuck on redirected pages.
                    $state.go(toState.redirectTo, toParams, {location: 'replace'});
                }
            };
        }
        NavigationUtilsImpl.$inject = _$inject;
        return NavigationUtilsImpl;
    }());

    angular.module('bluemoon.components.NavigationUtils', [
        'fef',
        'ui.bootstrap.modal',
        'pascalprecht.translate',
        'bluemoon.components.ConfirmNavigationController',
        'bluemoon.components.SaveInProgressModalController'
    ]).service('bluemoon.components.NavigationUtils', NavigationUtils);

}(window, window.angular, window.Rx));

(function() {
    'use strict';
    var ValidationUtils = (function() {
        function ValidationUtils($parse, $q, $translate, utils, bmUtil, notifications) {
            this.$parse = $parse;
            this.$q = $q;
            this.$translate = $translate;
            this.utils = utils;
            this.notifications = notifications;
            this.bmUtil = bmUtil;
        }
        ValidationUtils.prototype.processValidationErrors = function(data, response) {
            if(!this.utils.exists(response)) {
                throw new Error('bmValidationUtils: response is required.');
            }
            if(!this.utils.exists(response.error) || !this.utils.exists(response.error.errors) || !this.utils.exists(data)) {
                return;
            }
            for(var i = 0; i < response.error.errors.length; i++) {
                var error = response.error.errors[i];
                // following the JsonPath root object convention.

                var newLocationValue = null;
                var errorParentObject = data;

                if(error.location.indexOf('$.') === 0) {
                    newLocationValue = error.location.substring(2);
                    errorParentObject = this.bmUtil.getValueFromKey(data, newLocationValue);
                }
                if(!this.utils.exists(errorParentObject)) {
                    console.error('Provided error location did not match data. error[' + i + '].location: ' + error.location + ' data: ' + JSON.stringify(data));
                    continue;
                }
                this.setErrorForField(errorParentObject, error.locationField, error);
            }
        };

        ValidationUtils.prototype.getErrorForField = function(data, fieldName) {
            if(!this.utils.stringIsNonBlank(fieldName)) {
                throw new Error('bmValidationUtils.getErrorForField: fieldName is required');
            }
            if(this.utils.exists(data) && this.utils.exists(data.$error)) {
                var fieldError = data.$error[fieldName];
                if(this.utils.exists(fieldError)) {
                    return fieldError.message;
                }
            }
            return '';
        };
        ValidationUtils.prototype.setErrorForField = function (data, fieldName, error) {
            if (angular.isString(error)) {
                error = { message: error };
            }
            if(!this.utils.exists(data.$error)) {
                data.$error = {};
            }
            if(fieldName) {
                data.$error[fieldName] = error;
            } else {
                data.$error.$row = error;
            }
        };

        ValidationUtils.prototype.clearErrorForField = function(data, fieldName) {
            if(!this.utils.stringIsNonBlank(fieldName)) {
                throw new Error('bmValidationUtils.clearErrorForField: fieldName is required');
            }
            if(this.utils.exists(data) && this.utils.exists(data.$error)) {
                data.$error[fieldName] = undefined;
            }
        };

        ValidationUtils.prototype.clearErrors = function(request) {
            for(var field in request) {
                if(request.hasOwnProperty(field)) {
                    if(field === '$error') {
                        request[field] = undefined;
                    } else {
                        var val = request[field];
                        if(val !== null && typeof val === 'object') {
                            this.clearErrors(val);
                        }
                    }
                }
            }
        };

        ValidationUtils.prototype.processErrors = function(data, errorResult, suppressErrors) {
            var error = null;
            var showError = suppressErrors ? false : true;

            if(data === null && errorResult.status === -1) {
                // This occurs when the service is too slow
                error = this.$translate.instant('Bluemoon.Components.ValidationUtils.NoResponseError');
                // Disable the generic "A server error occurred" message.
                errorResult.config.global = false;
            } else if(typeof errorResult === 'string') {
                // error is a plain string, assume that's the error to display?
                error = errorResult;
            } else if (this.utils.exists(errorResult) && this.utils.exists(errorResult.data) && this.utils.exists(errorResult.status) && this.utils.exists(errorResult.headers) && typeof errorResult.headers === 'function' && errorResult.status !== 401 && errorResult.status !== 403 && (errorResult.status < 500 || errorResult.status >= 600)) {
                // Disable the generic "A server error occurred" message.
                errorResult.config.global = false;

                // it's probably an http error. Authorization related errors are handled
                // elsewhere, and result in a redirection, so we don't do anything here for those
                var headers = errorResult.headers();
                var contentType = headers['content-type'];
                contentType = contentType || headers['Content-Type'];
                contentType = contentType || headers['CONTENT-TYPE'];
                if(!this.utils.exists(contentType) || contentType.indexOf('application/json') < 0) {
                    error = errorResult.statusText;
                } else {
                    if(typeof errorResult.data === 'object') {
                        // it's an object, so for now assume it's a validation
                        // error and process it directly.
                        this.processValidationErrors(data, errorResult.data);
                        if(this.utils.exists(errorResult.data.error) && this.utils.exists(errorResult.data.error.message)) {
                            error = errorResult.data.error.message;
                        }
                    } else if(typeof errorResult.data === 'string') {
                        error = errorResult.data;
                    }
                }
            } else {
                showError = false;
            }
            if(!this.utils.stringIsNonBlank(error)) {
                error = this.$translate.instant('Bluemoon.Components.ValidationUtils.GenericValidationError');
            }
            if(showError) {
                this.notifications.setError(error);
            }
        };

        ValidationUtils.prototype.errorForFunc = function() {
            var _this = this;
            return function(data, fieldName) {
                return _this.getErrorForField(data, fieldName);
            };
        };

        ValidationUtils.prototype.clearErrorForFunc = function() {
            var _this = this;
            return function(data, fieldName) {
                _this.clearErrorForField(data, fieldName);
            };
        };

        ValidationUtils.prototype.validatePromise = function(data, promise, suppressErrors) {
            var _this = this;
            return promise.then(function(value) {
                if(_this.utils.exists(data) && _this.utils.exists(value)) {
                    var rawData = data;
                    rawData.id = value.id;
                    rawData.created = value.created;
                    rawData.updated = value.updated;
                    rawData.deleted = value.deleted;
                }
                return value;
            }, function(error) {
                _this.processErrors(data, error, suppressErrors);
                return _this.$q.reject(error);
            });
        };
        ValidationUtils.$inject = ['$parse', '$q', '$translate', 'fef.Utils', 'bmUtil', 'bluemoon.components.Notifications'];
        return ValidationUtils;
    })();
    angular.module('bmValidationUtils', [
        'fef',
        'pascalprecht.translate',
        'bluemoon.components.Notifications',
        'bluemoon.components.util'
    ]).service('bmValidationUtils', ValidationUtils);
})();

(function() {
    'use strict';
    var HttpUtils = (function() {
        function HttpUtils($q, utils, bmValidationUtils) {
            this.$q = $q;
            this.utils = utils;
            this.bmValidationUtils = bmValidationUtils;
        }
        HttpUtils.prototype.getDataFromHttpResponse = function(response) {
            if(this.utils.exists(response)) {
                if(this.utils.exists(response.status) && response.status >= 400) {
                    return this.$q.reject(response);
                }
                if(this.utils.exists(response.data)) {
                    return response.data;
                } else {
                    return null;
                }
            }
            return null;
        };
        HttpUtils.prototype.unwrapHttpPromise = function(promise) {
            var _this = this;
            return promise.then(function(response) { return _this.getDataFromHttpResponse(response); });
        };
        HttpUtils.prototype.unwrapAndValidateHttpPromise = function(data, promise, suppressErrors) {
            return this.bmValidationUtils.validatePromise(data, this.unwrapHttpPromise(promise), suppressErrors);
        };
        HttpUtils.prototype.getStrippedObject = function(resource, prefix, suffix) {
            var _this = this;
            if(!this.utils.exists(resource) || typeof resource !== 'object') {
                return resource;
            }
            if(!this.utils.exists(prefix)) {
                prefix = '$';
            }
            if(!this.utils.exists(suffix)) {
                suffix = 'Expanded';
            }
            var _prefix = prefix.replace(/\$/g, '\\$');
            var _suffix = suffix.replace(/\$/g, '\\$');
            var copy = angular.copy(resource);
            var prefixRegex = new RegExp('^' + _prefix + '.+$', 'g');
            var suffixRegex = new RegExp('^.+' + _suffix + '$', 'g');
            Object.keys(resource).forEach(function(propertyName) {
                var property = resource[propertyName];
                var acopy = copy;
                if((angular.isString(propertyName) && _this.utils.stringIsNonBlank(_prefix) && propertyName.match(prefixRegex)) || (angular.isString(propertyName) && _this.utils.stringIsNonBlank(_suffix) && propertyName.match(suffixRegex))) {
                    delete acopy[propertyName];
                } else if(typeof property === 'object') {
                    acopy[propertyName] = _this.getStrippedObject(property, prefix, suffix);
                }
            });
            return copy;
        };
        HttpUtils.$inject = [
            '$q',
            'fef.Utils',
            'bmValidationUtils'
        ];
        return HttpUtils;
    })();
    angular.module('bmHttpUtils', [
        'fef',
        'bmValidationUtils'
    ]).service('bmHttpUtils', HttpUtils);
})();

(function(window, angular, Rx) {
    'use strict';

    var Alert = (function() {
        function AlertImpl(type, message) {
            if(type !== 'error' && type !== 'info' && type !== 'success') {
                throw new Error('bluemoon.components.Alert: error type must be either \'error\' or \'info\'.');
            }
            if(!angular.isString(message)) {
                throw new Error('bluemoon.components.Alert: error message must be a string');
            }
            this.type = type;
            this.message = message;
        }

        AlertImpl.isAlert = function(obj) {
            return typeof obj === 'undefined' || obj === null ||
                (angular.isObject(obj) &&
                angular.isString(obj.type) &&
                (obj.type === 'error' || obj.type === 'info' || obj.type === 'success') &&
                angular.isString(obj.message));
        };

        return AlertImpl;
    }());

    var Toast = (function() {
        function ToastImpl(message) {
            this.message = message;
        }

        ToastImpl.isToast = function(obj) {
            return angular.isObject(obj) && angular.isString(obj.message);
        };

        return ToastImpl;
    }());

    var Notifications = (function() {
        var _$inject = ['fef.SanityChecks', 'fef.Utils'];
        function NotificationsImpl(sanityChecks, utils) {
            /// <param name="sanityChecks" type="fef.SanityChecks" />
            /// <param name="utils" type="fef.Utils" />
            sanityChecks.checkConstructorUsage(this, NotificationsImpl);
            var self = this;

            /** @private */
            this._utils = utils;

            // I'm not using a caching subject here instead of a field pair,
            // because this is just a simple service.

            /** @private */
            this._alert = null;
            /** @private */
            this._alertStream = new Rx.Subject();
            this._alertStream.subscribe(function(alert) {
                self._alert = alert;
            });

            /** @private */
            this._toastStream = new Rx.Subject();
        }
        NotificationsImpl.$inject = _$inject;

        /**
         * Constructor function for an Alert.
         */
        NotificationsImpl.prototype.Alert = Alert;

        /**
         * Constructor function for a Toast.
         */
        NotificationsImpl.prototype.Toast = Toast;

        /**
         * Set the global alert. Replaces any existing message. Subscribers
         * to the error stream will be notified that the error message changed.
         * @param {Alert} alert The message to set, or null/undefined to clear the error.
         */
        NotificationsImpl.prototype.setAlert = function(alert) {
            if(!Alert.isAlert(alert)) {
                throw new Error('bluemoon.components.Notifications: alert object was badly formed.');
            }
            this._alertStream.onNext(angular.copy(alert));
        };

        /**
         * Set the global error alert. Replaces the existing error or info alert.
         * Subscribers to the alert stream will be notified that the alert changed.
         * @param {string} errorMessage The error message, or null/undefined to clear the alert.
         */
        NotificationsImpl.prototype.setError = function(errorMessage) {
            if(this._utils.exists(errorMessage) && !angular.isString(errorMessage)) {
                throw new Error('Notifications.setError: errorMessage must be a string.');
            }
            if(!this._utils.stringIsNonBlank(errorMessage)) {
                this._alertStream.onNext(null);
            } else {
                this._alertStream.onNext(new Alert('error', errorMessage));
            }
        };

        /**
         * Set the global info alert. Replaces the existing error or info alert.
         * Subscribers to the alert stream will be notified that the alert changed.
         * @param {string} infoMessage The info message, or null/undefined to clear the alert.
         */
        NotificationsImpl.prototype.setInfo = function(infoMessage) {
            if(this._utils.exists(infoMessage) && !angular.isString(infoMessage)) {
                throw new Error('Notifications.setInfo: infoMessage must be a string.');
            }
            if(!this._utils.stringIsNonBlank(infoMessage)) {
                this._alertStream.onNext(null);
            } else {
                this._alertStream.onNext(new Alert('info', infoMessage));
            }
        };

        /**
         * Set the global info alert. Replaces the existing error, info or success alert.
         * Subscribers to the alert stream will be notified that the alert changed.
         * @param {string} successMessage The success message, or null/undefined to clear the alert.
         */
        NotificationsImpl.prototype.setSuccess = function(successMessage) {
            if(this._utils.exists(successMessage) && !angular.isString(successMessage)) {
                throw new Error('Notifications.setSuccess: successMessage must be a string.');
            }
            if(!this._utils.stringIsNonBlank(successMessage)) {
                this._alertStream.onNext(null);
            } else {
                this._alertStream.onNext(new Alert('success', successMessage));
            }
        };

        /**
         * Gets the current alert.
         * @returns {Alert}
         */
        NotificationsImpl.prototype.getAlert = function() {
            return angular.copy(this._alert);
        };

        /**
         * Gets the event stream for changes to the error message.
         * @returns {Rx.Observable}
         * @example
         * var subscription = notifications.errorStream().subscribe(function(errorMessage) {
         *   alert('Error: ' + errorMessage);
         * });
         */
        NotificationsImpl.prototype.alertStream = function() {
            return this._alertStream.asObservable();
        };

        /**
         * An event stream of 'error' type alerts.
         * @returns {Rx.Observable} Observable of Alert objects.
         */
        NotificationsImpl.prototype.errorAlertStream = function() {
            var self = this;
            return self.alertStream().filter(function(alert) {
                return self._utils.exists(alert) && alert.type === 'error';
            });
        };

        /**
         * An event stream of 'info' type alerts.
         */
        NotificationsImpl.prototype.infoAlertStream = function() {
            var self = this;
            return this.alertStream().filter(function(alert) {
                return self._utils.exists(alert) && alert.type === 'info';
            });
        };

        /**
         * Add a new toast object to the list. Any subscribers to the toast
         * stream will be notified that a new toast was added.
         * @param {Object} toastObj The new toast object. TODO: define this interface?
         */
        NotificationsImpl.prototype.addToast = function(toastObj) {
            if(!Toast.isToast(toastObj)) {
                throw new Error('Notifications.addToast: toastObject was badly formed.');
            }
            this._toastStream.onNext(angular.copy(toastObj));
        };

        /**
         * Event stream representing new toasts as they are added.
         * @example
         * var subscription = notifications.toastStream().subscribe(function(toast) {
         *   alert('toast: ' + toast);
         * });
         */
        NotificationsImpl.prototype.toastStream = function() {
            return this._toastStream.asObservable();
        };

        return NotificationsImpl;
    }());

    angular.module('bluemoon.components.Notifications', ['fef']).service('bluemoon.components.Notifications',
        Notifications);

}(window, window.angular, window.Rx));

(function(angular) {
    'use strict';

    var httpStatusCodes = {
        'continue'                        : 100, // [RFC7231,Section6.2.1]
        'switchingProtocols'              : 101, // [RFC7231,Section6.2.2]
        'processing'                      : 102, // [RFC2518]
        'ok'                              : 200, // [RFC7231,Section6.3.1]
        'created'                         : 201, // [RFC7231,Section6.3.2]
        'accepted'                        : 202, // [RFC7231,Section6.3.3]
        'nonAuthoritativeInformation'     : 203, // [RFC7231,Section6.3.4]
        'noContent'                       : 204, // [RFC7231,Section6.3.5]
        'resetContent'                    : 205, // [RFC7231,Section6.3.6]
        'partialContent'                  : 206, // [RFC7233,Section4.1]
        'multiStatus'                     : 207, // [RFC4918]
        'alreadyReported'                 : 208, // [RFC5842]
        'imUsed'                          : 226, // [RFC3229]
        'multipleChoices'                 : 300, // [RFC7231,Section6.4.1]
        'movedPermanently'                : 301, // [RFC7231,Section6.4.2]
        'found'                           : 302, // [RFC7231,Section6.4.3]
        'seeOther'                        : 303, // [RFC7231,Section6.4.4]
        'notModified'                     : 304, // [RFC7232,Section4.1]
        'useProxy'                        : 305, // [RFC7231,Section6.4.5]
        'temporaryRedirect'               : 307, // [RFC7231,Section6.4.7]
        'permanentRedirect'               : 308, // [RFC7238]
        'badRequest'                      : 400, // [RFC7231,Section6.5.1]
        'unauthorized'                    : 401, // [RFC7235,Section3.1]
        'paymentRequired'                 : 402, // [RFC7231,Section6.5.2]
        'forbidden'                       : 403, // [RFC7231,Section6.5.3]
        'notFound'                        : 404, // [RFC7231,Section6.5.4]
        'methodNotAllowed'                : 405, // [RFC7231,Section6.5.5]
        'notAcceptable'                   : 406, // [RFC7231,Section6.5.6]
        'proxyAuthenticationRequired'     : 407, // [RFC7235,Section3.2]
        'requestTimeout'                  : 408, // [RFC7231,Section6.5.7]
        'conflict'                        : 409, // [RFC7231,Section6.5.8]
        'gone'                            : 410, // [RFC7231,Section6.5.9]
        'lengthRequired'                  : 411, // [RFC7231,Section6.5.10]
        'preconditionFailed'              : 412, // [RFC7232,Section4.2]
        'payloadTooLarge'                 : 413, // [RFC7231,Section6.5.11]
        'uriTooLong'                      : 414, // [RFC7231,Section6.5.12]
        'unsupportedMediaType'            : 415, // [RFC7231,Section6.5.13]
        'requestedRangeNotSatisfiable'    : 416, // [RFC7233,Section4.4]
        'expectationFailed'               : 417, // [RFC7231,Section6.5.14]
        'unprocessableEntity'             : 422, // [RFC4918]
        'locked'                          : 423, // [RFC4918]
        'failedDependency'                : 424, // [RFC4918]
        'upgradeRequired'                 : 426, // [RFC7231,Section6.5.15]
        'preconditionRequired'            : 428, // [RFC6585]
        'tooManyRequests'                 : 429, // [RFC6585]
        'requestHeaderFieldsTooLarge'     : 431, // [RFC6585]
        'internalServerError'             : 500, // [RFC7231,Section6.6.1]
        'notImplemented'                  : 501, // [RFC7231,Section6.6.2]
        'badGateway'                      : 502, // [RFC7231,Section6.6.3]
        'serviceUnavailable'              : 503, // [RFC7231,Section6.6.4]
        'gatewayTimeout'                  : 504, // [RFC7231,Section6.6.5]
        'httpVersionNotSupported'         : 505, // [RFC7231,Section6.6.6]
        'variantAlsoNegotiates'           : 506, // [RFC2295]
        'insufficientStorage'             : 507, // [RFC4918]
        'loopDetected'                    : 508, // [RFC5842]
        'notExtended'                     : 510, // [RFC2774]
        'networkAuthenticationRequired'   : 511  // [RFC6585]
    };
    angular.module('bluemoon.components.httpStatusCodes', [])
        .constant('bluemoon.components.httpStatusCodes', httpStatusCodes);

})(window.angular);

(function(angular){
    'use strict';

    angular.module('bmHttpCache', [])
    .factory('bmHttpCacheHelper', bmHttpCacheHelper)
    .config(configInterceptor);

    /////////

    bmHttpCacheHelper.$inject = ['$cacheFactory'];

    // bmCache config value is time in milliseconds
    // clear cache, pass with value as 0 or less
    // can specifically call clear cache method
    function bmHttpCacheHelper($cacheFactory){
        var lookup = {};

        return {
            request: checkRequest,
            response: checkResponse,
            invalidateHttpCache: invalidateHttpCache
        };

        /////////

        function checkRequest(conf){
            // not setting the config cache property will result in a fresh request and the
            // response will not affect the value stored in cache. any subsequent requests that set
            // set the config cache property will receive what was stored in cache. consumers must
            // invalidate the cache as necessary in order to not receive stale data.

            // would conf really ever be undefined?
            if(!conf){
                return conf;
            }

            // only cache GET requests and those that specify bmCache
            // would method really ever be undefined?
            if((conf.method && conf.method.toUpperCase() !== 'GET') || angular.isUndefined(conf.bmCache)){
                return cleanRequestConfig(conf);
            }

            var httpDefaultCache = $cacheFactory.get('$http');
            var cacheVal = httpDefaultCache.get(conf.url);

            // always opting in to store response in cache if bmCache is defined in http config
            conf.cache = true;

            // no response stored in cache yet so move on
            // the response will be stored in cache
            if(!cacheVal){
                return conf;
            }

            // do we have a stale cached value?
            var timeNow = Date.now();
            var cachedTime = lookup[conf.url];

            // difference between the time now and the cached time greater than the stale interval
            // or the stale interval is being reset specifically
            if(angular.isUndefined(cachedTime) ||  conf.bmCache <= 0 || ((timeNow - cachedTime) > conf.bmCache)){
                invalidateHttpCache(conf.url);
            }

            // the response will be stored in cache
            return conf;
        }

        function checkResponse(resp){
            // track the initial date/time of when response was put into cache
            // this is not a running cache timer
            if(resp && resp.config && resp.config.bmCache && !lookup[resp.config.url]){
                lookup[resp.config.url] = Date.now();
            }

            return resp;
        }

        // allow for invalidating cache brute force
        function invalidateHttpCache(url){
            if(!url){
                return;
            }

            var httpDefaultCache = $cacheFactory.get('$http');
            var cacheVal = httpDefaultCache.get(url);

            // remove from http cache
            if(cacheVal){
                httpDefaultCache.remove(url);
            }

            // remove from hash lookup
            if(lookup[url]){
                delete lookup[url];
            }
        }

        function cleanRequestConfig(conf){
            if(conf && conf.bmCache){
                delete conf.bmCache;
            }

            return conf;
        }
    }

    ///////////

    configInterceptor.$inject = ['$httpProvider'];

    function configInterceptor($httpProvider){
        $httpProvider.interceptors.push('bmHttpCacheHelper');
    }
})(window.angular);

angular.module('bluemoon.components.templates', ['components/bm-image-upload-modal/bm-image-upload-modal.2js.html', 'components/bm-user-availability/bm-user-availability.2js.html', 'components/checkpoint-engage/checkpoint-engage.2js.html', 'components/client-notifications/client-notifications-list.2js.html', 'components/header/bm-staff-custom-header.2js.html', 'components/header/bm-staff-header.2js.html', 'components/header/documents-header-button.2js.html', 'components/header/header.2js.html', 'components/header/timer-header-button.2js.html', 'components/help/help.2js.html', 'components/i18n/language-select.2js.html', 'components/linked-accounts/linked-accounts-dialog.2js.html', 'components/linked-accounts/linked-accounts.2js.html', 'components/linking-merge/linking-merge-modal.2js.html', 'components/main/main.2js.html', 'components/modal/modal-base.2js.html', 'components/modal/modal-default.2js.html', 'components/multi-factor-user/multi-factor-user-settings.2js.html', 'components/multi-factor-user/multi-factor-user.2js.html', 'components/multi-factor/multi-factor-profile-modal.2js.html', 'components/multi-factor/multi-factor-profile.2js.html', 'components/nav/nav.2js.html', 'components/navigation-utils/confirm-navigation.2js.html', 'components/navigation-utils/save-in-progress-modal.2js.html', 'components/not-found/bm-staff-not-found.2js.html', 'components/password-validation/password-validation.2js.html', 'components/preview-trial-widget/preview-trial-widget.2js.html', 'components/privacy-policy/privacy-policy.2js.html', 'components/profile-photo-select/profile-photo-select.2js.html', 'components/session/cc-vnext-modal.2js.html', 'components/support-id/support-id.2js.html', 'components/terms-signatory/terms-signatory-modal.2js.html', 'components/view-portal-banner/view-portal-banner.2js.html', 'my-account/link-auth/link-auth-modal.2js.html', 'my-account/my-account-licensee.2js.html', 'my-account/my-account-skinny.2js.html', 'my-account/my-account.2js.html', 'security-questions/security-questions.2js.html', 'update-password/update-password.2js.html', 'user-profile/view-profile-modal.2js.html']);

angular.module("components/bm-image-upload-modal/bm-image-upload-modal.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/bm-image-upload-modal/bm-image-upload-modal.2js.html",
    "<div class=\"bento-modal bm-image-upload-modal\">\n" +
    "    <button type=\"button\" class=\"close\" aria-hidden=\"true\" ng-click=\"vm.close()\" data-qe-id=\"bm-components-bmImageUploadModalCtrl-closeButton\">\n" +
    "      <i class=\"bento-icon-close-x\"></i>\n" +
    "    </button>\n" +
    "    <div class=\"modal-header\"><h2>{{vm.uploadTitleText}}</h2></div>\n" +
    "    <div class=\"modal-body bm-modal-body\">\n" +
    "        <!-- make it look like bento-alert -->\n" +
    "        <div class=\"bento-alert-container\" ng-if=\"vm.alerts.length > 0\">\n" +
    "            <div ng-repeat=\"alert in vm.alerts\" class=\"alert bento-alert alert-dismissable\" role=\"alert\" ng-class=\"{'alert-success': alert.type === 'success', 'alert-warning': alert.type === 'warning', 'alert-info': alert.type === 'info', 'alert-danger': alert.type === 'danger'}\">\n" +
    "                <span>\n" +
    "                    {{alert.msg}}\n" +
    "                </span>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div ng-class=\"{'bm-flex-row center-vertically' : vm.hasOptions}\">\n" +
    "            <div ng-class=\"{'col-md-8 col-sm-8 col-xs-8' : vm.hasOptions}\">\n" +
    "                <!-- progress indicator -->\n" +
    "                <div class=\"profile-progress\" ng-if=\"vm.progress !== 0\">\n" +
    "                    <span translate=\"bm.components.common.uploading\"></span>\n" +
    "                    <div class=\"bento-progressbar\">\n" +
    "                    <div uib-progressbar value=\"vm.progress\" animate=\"true\" type=\"vm.progressType\">{{vm.progress}}%</div>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "                <!-- photo drop/select -->\n" +
    "                <div ng-if=\"!vm.selectedImageSrc && vm.progress === 0\">\n" +
    "                    <div ng-file-drop ng-file-select ng-model=\"vm.selectedFile\" class=\"drop-box align-center\" drag-over-class=\"drag-over\" ng-multiple=\"false\" allow-dir=\"true\" accept=\"'image/*'\" ng-accept=\"'image/*'\" ng-capture=\"'camera'\" ng-file-change=\"vm.fileOnChange($files, $event, $rejectedFiles)\">\n" +
    "                        <i class=\"glyphicon glyphicon-picture\"></i>\n" +
    "                        <div class=\"drop-box-text\">{{vm.dragImageText}}</div>\n" +
    "                        <div class=\"drop-box-text\">\n" +
    "                            - <span translate=\"bm.components.common.or\"></span> -\n" +
    "                        </div>\n" +
    "                        <div class=\"drop-box-text\">\n" +
    "                            <button class=\"btn btn-default btn-dynamic btn-text-ellipsis\" tabindex=\"0\" data-qe-id=\"bm-components-bmImageUploadModalCtrl-browseImageButton\">{{vm.uploadImageButtonText}}</button>\n" +
    "                        </div>\n" +
    "                        <div ng-if=\"vm.currentImage && vm.deletable\" class=\"drop-box-text\">\n" +
    "                            - <span translate=\"bm.components.common.or\"></span> -\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                    <div ng-if=\"vm.currentImage && vm.deletable\" class=\"align-center\">\n" +
    "                        <button class=\"btn btn-default btn-dynamic\" ng-click=\"vm.delete()\">\n" +
    "                            {{vm.deleteImageButtonText}}\n" +
    "                        </button>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "                <!-- photo crop -->\n" +
    "                <div ng-if=\"vm.selectedImageSrc && vm.progress === 0\">\n" +
    "                    <div>\n" +
    "                        <span translate=\"bm.image.upload.cropPhotoInstructions\"></span> {{vm.saveImageButtonText}}.\n" +
    "                    </div>\n" +
    "                    <div class=\"crop-area\">\n" +
    "                        <ui-cropper\n" +
    "                            image=\"vm.selectedImageSrc\"\n" +
    "                            result-image=\"vm.croppedImage\"\n" +
    "                            area-type=\"{{ vm.cropShape }}\"\n" +
    "                            aspect-ratio=\"vm.aspectRatio\"\n" +
    "                            area-min-size=\"vm.areaMinSize\"\n" +
    "                            area-init-size=\"vm.areaInitSize\"\n" +
    "                            result-image-size=\"vm.resultImageSize\"></ui-cropper>\n" +
    "                    </div>\n" +
    "                    <div class=\"crop-area-text\">\n" +
    "                        <a ng-href=\"\" tabindex=\"0\" ng-click=\"vm.selectedImageSrc = undefined\" data-qe-id=\"bm-components-bmImageUploadModalCtrl-uploadAnotherImageLink\">{{vm.uploadAnotherImageText}}</a>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "            <!-- photo location -->\n" +
    "            <div class=\"col-md-4 col-sm-4 col-xs-4\" ng-if=\"vm.hasOptions\">\n" +
    "                <div ng-if=\"vm.options.label\">\n" +
    "                    {{vm.options.label}}\n" +
    "                </div>\n" +
    "                <p>\n" +
    "                    <div ng-repeat=\"choice in vm.options.choices\">\n" +
    "                        <div class=\"option-choice\">\n" +
    "                            <input class=\"option-choice-checkbox\" type=\"checkbox\" name=\"{{choice}}\" value=\"{{choice}}\" ng-checked=\"$first\" ng-click=\"optionChoiceCheckboxClick($event)\" data-qe-id=\"bm-components-bmImageUploadModalCtrl-{{choice}}\">\n" +
    "                            <label for=\"{{choice}}\">{{choice}}</label>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                </p>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"modal-footer clearfix\">\n" +
    "        <button class=\"btn btn-primary btn-dynamic\" ng-click=\"vm.save()\" ng-disabled=\"!vm.selectedImageSrc\" data-qe-id=\"bm-components-bmImageUploadModalCtrl-setImageButton\">\n" +
    "            {{vm.saveImageButtonText}}\n" +
    "        </button>\n" +
    "        <button class=\"btn btn-default btn-dynamic\" ng-click=\"vm.cancel()\" translate=\"Bluemoon.Components.Common.Actions.Cancel\" data-qe-id=\"bm-components-bmImageUploadModalCtrl-cancelButton\"></button>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("components/bm-user-availability/bm-user-availability.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/bm-user-availability/bm-user-availability.2js.html",
    "<div class=\"bm-availability clearfix\">\n" +
    "    <span class=\"dropdown bento-dropdown pull-left\" uib-dropdown>\n" +
    "      <button class=\"dropdown-toggle btn btn-default btn-icon\" uib-dropdown-toggle>\n" +
    "        <span class=\"bm-inline-dot bm-selected-dot\" ng-class=\"'bm-' + selectedDot + '-dot'\"></span>\n" +
    "        <span class=\"sr-only\" translate=\"bm.header.profileMenu.StatusSelectOptions\"></span>\n" +
    "        <i class=\"bento-icon-chevron-down\"></i>\n" +
    "      </button>\n" +
    "      <ul role=\"menu\" class=\"dropdown-menu dropdown-menu-left bm-availability-dots clearfix\">\n" +
    "        <li>\n" +
    "            <a href role=\"menuitemradio\" ng-attr-aria-checked=\"{{ availabilityText === 'Available' }}\" ng-click=\"changeStatus('Available','green')\">\n" +
    "                <div class=\"bm-dot bm-green-dot pull-left\"></div>\n" +
    "                <div class=\"bm-dot-text pull-left\">{{statusText.available}}</div>\n" +
    "            </a>\n" +
    "        </li>\n" +
    "        <li>\n" +
    "            <a href role=\"menuitemradio\" ng-attr-aria-checked=\"{{ availabilityText === 'Away' }}\" ng-click=\"changeStatus('Away','yellow')\">\n" +
    "                <div class=\"bm-dot bm-yellow-dot pull-left\"></div>\n" +
    "                <div class=\"bm-dot-text pull-left\">{{statusText.away}}</div>\n" +
    "            </a>\n" +
    "        </li>\n" +
    "        <li>\n" +
    "            <a href role=\"menuitemradio\" ng-attr-aria-checked=\"{{ availabilityText === 'Busy' }}\" ng-click=\"changeStatus('Busy','red')\">\n" +
    "                <div class=\"bm-dot bm-red-dot pull-left\"></div>\n" +
    "                <div class=\"bm-dot-text pull-left\">{{statusText.busy}}</div>\n" +
    "            </a>\n" +
    "        </li>\n" +
    "      </ul>\n" +
    "    </span>\n" +
    "    <label for=\"bmAvailablity\" class=\"sr-only\" translate=\"bm.header.profileMenu.UserStatus\"></label>\n" +
    "    <input type=\"text\" name=\"bmAvailablity\" id=\"bmAvailablity\" ng-model=\"availabilityText\" ng-blur=\"changeStatusText()\" class=\"form-control bm-availability-text-box pull-left\" />\n" +
    "</div>\n" +
    "");
}]);

angular.module("components/checkpoint-engage/checkpoint-engage.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/checkpoint-engage/checkpoint-engage.2js.html",
    "<form name=\"$ctrl.checkpointForm\" role=\"form\" class=\"css-form\" novalidate>\n" +
    "  <h3 class=\"bm-modal-title\" translate=\"bm.header.checkpoint.header\"></h3>\n" +
    "  <!-- error display - make it look like bento-alert -->\n" +
    "  <div class=\"bento-alert-container\" ng-if=\"$ctrl.alerts.length > 0\">\n" +
    "    <div ng-repeat=\"alert in $ctrl.alerts\" class=\"alert bento-alert alert-dismissable\" role=\"alert\" ng-class=\"{'alert-success': alert.type === 'success', 'alert-warning': alert.type === 'warning', 'alert-info': alert.type === 'info', 'alert-danger': alert.type === 'danger'}\">\n" +
    "      <span>\n" +
    "        {{alert.msg}}\n" +
    "        </span>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "  <!-- creds not entered -->\n" +
    "  <div class=\"row\" ng-if=\"!$ctrl.credsExist && $ctrl.hasPermission\">\n" +
    "    <div class=\"col-sm-8\">\n" +
    "      <div class=\"form-group\" ng-class=\"{ 'has-error': $ctrl.checkpointForm.uid.$error.required && $ctrl.checkpointForm.uid.$touched }\">\n" +
    "        <label for=\"uid\"><span translate=\"bm.header.checkpoint.userName\"></span> *</label>\n" +
    "        <input type=\"text\" class=\"form-control\" id=\"uid\" name=\"uid\" ng-model=\"$ctrl.userData.uid\" required maxlength=\"50\" autocapitalize=\"off\" spellcheck=\"false\" autofocus />\n" +
    "        <div class=\"msg\" translate=\"bm.header.checkpoint.userNameRequired\"></div>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "  <div class=\"row\" ng-if=\"!$ctrl.credsExist && $ctrl.hasPermission\">\n" +
    "    <div class=\"col-sm-8\">\n" +
    "      <div class=\"form-group\" ng-class=\"{ 'has-error': $ctrl.checkpointForm.pwd.$error.required && $ctrl.checkpointForm.pwd.$touched }\">\n" +
    "        <label for=\"pwd\"><span translate=\"bm.header.viewProfile.password\"></span> *</label>\n" +
    "        <input type=\"password\" class=\"form-control\" id=\"pwd\" name=\"pwd\" ng-model=\"$ctrl.userData.pwd\" required maxlength=\"50\" />\n" +
    "        <div class=\"msg\" translate=\"bm.header.checkpoint.passwordRequired\"></div>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "  <div class=\"row\" ng-if=\"!$ctrl.credsExist && $ctrl.hasPermission\">\n" +
    "    <div class=\"col-sm-10\">\n" +
    "      <label class=\"checkbox\">\n" +
    "        <input type=\"checkbox\" ng-model=\"$ctrl.userData.agree\" /> <span translate=\"bm.header.checkpoint.agreeLicense\"></span>\n" +
    "      </label>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "  <div class=\"modal-required bm-required-fields\" ng-if=\"!$ctrl.credsExist && $ctrl.hasPermission\">\n" +
    "    * <span translate=\"bm.components.common.requiredField\"></span>\n" +
    "  </div>\n" +
    "  <!-- creds already entered -->\n" +
    "  <div class=\"row bm-checkpoint-remove-text\" ng-if=\"$ctrl.credsExist && $ctrl.hasPermission\">\n" +
    "    <div class=\"col-sm-8\">\n" +
    "      {{$ctrl.removeText}}\n" +
    "    </div>\n" +
    "  </div>\n" +
    "  <div class=\"modal-footer\">\n" +
    "    <button type=\"submit\" class=\"btn btn-primary\" ng-click=\"$ctrl.actions.saveUserData()\" ng-if=\"!$ctrl.credsExist && $ctrl.hasPermission\" translate=\"Bluemoon.Components.Common.Actions.Save\"></button>\n" +
    "    <button type=\"button\" class=\"btn btn-primary\" ng-click=\"$ctrl.actions.deleteUserData()\" ng-if=\"$ctrl.credsExist && $ctrl.hasPermission\" translate=\"bm.components.common.remove\"></button>\n" +
    "    <button type=\"button\" class=\"btn btn-default\" ng-click=\"$ctrl.actions.cancelUserData()\" translate=\"Bluemoon.Components.Common.Actions.Cancel\"></button>\n" +
    "  </div>\n" +
    "</form>\n" +
    "");
}]);

angular.module("components/client-notifications/client-notifications-list.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/client-notifications/client-notifications-list.2js.html",
    "<div class=\"bm-ntfs-virt-list\" bm-flex-col>\n" +
    "    <p ng-if=\"hasZeroItems && !isLoading\" class=\"zero-items-warn\" translate=\"bm.header.profileMenu.zeroNotifications\"></p>\n" +
    "\n" +
    "    <div ng-if=\"!hasZeroItems\" class=\"bm-ntfs-settings bm-animate-if\">\n" +
    "        <a ng-href=\"\" ng-click=\"markAllNotificationsRead()\" translate=\"bm.header.profileMenu.markAllNotificationsRead\"></a>\n" +
    "    </div>\n" +
    "\n" +
    "    <div ng-if=\"!hasZeroItems\" id=\"bm-ntfs-vertical-container\" bm-flex-grow>\n" +
    "        <div ng-repeat=\"item in notifications\" class=\"bm-ntfs-repeated-item bm-animate-if\" ng-class=\"{'bm-last-notification': $last}\" bm-notifications-last-repeat-task bm-flex-row>\n" +
    "            <div class=\"bm-ntfs-indicator-col\" bm-flex-col>\n" +
    "                <div class=\"bm-ntfs-indicator-item\">\n" +
    "                    <i class=\"glyphicon glyphicon-info-sign\"></i>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "            <div class=\"bm-ntfs-message-col\" bm-flex-col flex-grow>\n" +
    "                <div class=\"bm-ntfs-text\" ng-click=\"markNotificationRead(item,$event)\" ng-class=\"{'bm-ntfs-text-unread': item.unread}\">\n" +
    "                    <div ng-bind-html=\"item.onvioNotificationText\"></div>\n" +
    "                    <div class=\"bm-ntfs-date\">\n" +
    "                        {{ getFormattedTime(item.timestamp) }}\n" +
    "                        <a ng-href=\"\" class=\"bm-ntfs-mark\" ng-click=\"markNotificationRead(item,$event)\">\n" +
    "                            <span ng-if=\"item.unread\" translate=\"bm.header.profileMenu.markNotificationsRead\"></span>\n" +
    "                        </a>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "            <div class=\"bm-ntfs-delete-col\" bm-flex-col>\n" +
    "                <div>\n" +
    "                    <a ng-href=\"\" ng-click=\"deleteNotification(item, $index)\"><i class=\"bento-icon-close-x\" uib-tooltip=\"{{deleteTranslated}}\" tooltip-placement=\"left\" tooltip-class=\"bm-ntfs-delete-tooltip\" tooltip-popup-delay=\"500\" aria-hidden=\"true\"></i></a>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("components/header/bm-staff-custom-header.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/header/bm-staff-custom-header.2js.html",
    "<bm-header class=\"custom-header\">\n" +
    "    <em data-translate=\"bm.staffHeader.brandName\"></em>\n" +
    "    <span data-translate=\"bm.staffHeader.productName\"></span>\n" +
    "    <bm-header-icon><ng-transclude ng-transclude-slot=\"icon\"></ng-transclude></bm-header-icon>\n" +
    "    <bm-header-profile><ng-transclude ng-transclude-slot=\"profile\"></ng-transclude></bm-header-profile>\n" +
    "</bm-header>\n" +
    "");
}]);

angular.module("components/header/bm-staff-header.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/header/bm-staff-header.2js.html",
    "<bm-header>\n" +
    "    <em data-translate=\"bm.staffHeader.brandName\"></em>\n" +
    "    <span data-translate=\"bm.staffHeader.productName\"></span>\n" +
    "</bm-header>\n" +
    "");
}]);

angular.module("components/header/documents-header-button.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/header/documents-header-button.2js.html",
    "<li bm-if-perm=\"OnvioDrive.Documents\">\n" +
    "    <a role=\"link\" aria-label=\"{{ 'Bluemoon.Shell.Navigation.Documents' | translate }}\" data-qe-id=\"bm-components-bmDocumentsHeaderButton\" ng-click=\"openDocuments()\"\n" +
    "        title=\"{{ 'Bluemoon.Shell.Navigation.Documents' | translate }}{{clientSpecificTitle}}\">\n" +
    "        <i class=\"bento-icon-file-room\"></i></a>\n" +
    "</li>\n" +
    "");
}]);

angular.module("components/header/header.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/header/header.2js.html",
    "<header ng-click=\"header.clearAppMenuActive()\" bm-flex-row>\n" +
    "    <ul ng-if=\"!header.hideMenus\" class=\"bm-header-left-menu\" bm-flex-row>\n" +
    "        <li bm-if-not-perm=\"USTax.PlatformEA\">\n" +
    "            <a href role=\"link\" aria-label=\"{{ 'bm.header.appMenu.toggle' | translate }}\" id=\"bm-header-app-menu-toggle\" class=\"bm-header-app-menu-toggle\" title=\"{{ 'bm.header.appMenu.toggle' | translate }}\" ng-click=\"header.toggleAppMenuActive()\">\n" +
    "                <i class=\"bento-icon-hamburger-menu\"></i>\n" +
    "            </a>\n" +
    "        </li>\n" +
    "    </ul>\n" +
    "    <!-- header image and text not required for huge? -->\n" +
    "    <div class=\"title_container\">\n" +
    "        <!-- <img ng-if=\"header.theme.header.headerImage\" ng-src=\"{{ header.theme.header.headerImage }}\"> -->\n" +
    "        <span ng-transclude></span> <!-- <span ng-bind=\"header.theme.header.headerLine1\"></span> -->\n" +
    "    </div>\n" +
    "    <!-- App specific menu items !-->\n" +
    "    <ul ng-if=\"!header.hideMenus\" class=\"bm-header-center-menu\" bm-flex-grow bm-flex-row>\n" +
    "        <!-- Preview / Trial mode message -->\n" +
    "        <li bm-if-perm-some=\"['Platform.Trial', 'Platform.PreviewMode']\">\n" +
    "            <preview-trial-widget></preview-trial-widget>\n" +
    "        </li>\n" +
    "        <!-- onvio messenger shortcut -->\n" +
    "        <li ng-if=\"header.showBRMessenger\">\n" +
    "            <a data-qe-id=\"bm-components-bmHeader-onvioMessengerButton\" href=\"javascript:void(0)\" ng-click=\"header.openOnvioMessenger()\" title=\"{{ 'bm.header.shell.onvioMessengerBtn' | translate }}\" >\n" +
    "                <i class=\"bento-icon-bubble\"></i>\n" +
    "                <span ng-if=\"header.onvioMessengerUnreadNotificationsCount > 0\" class=\"badge bm-badge-active\">{{ header.onvioMessengerUnreadNotificationsCount }}</span>\n" +
    "            </a>\n" +
    "        </li>\n" +
    "        <!-- client dashboard icon -->\n" +
    "        <li ng-if=\"header.hasClientDashboard\">\n" +
    "            <a data-qe-id=\"bm-components-bmHeader-clientDashboardButton\" role=\"link\" aria-label=\"{{ 'Bluemoon.Shell.Navigation.ClientDashboard' | translate }}\" target=\"_blank\" href=\"/staff/#/client-dashboard{{header.clientSpecificUrl}}\" title=\"{{ 'Bluemoon.Shell.Navigation.ClientDashboard' | translate }}{{header.clientSpecificTitle}}\"><i class=\"bento-icon-vcard\"></i></a>\n" +
    "        </li>\n" +
    "        <li html-element-id=\"bm-header-timer-button\" bm-timer-header-button=\"header.isTimerDropdownOpen\" client-specific-title=\"header.clientSpecificTitle\"></li>\n" +
    "        <li bm-documents-header-button not-staff-client=\"header.notStaffClient\" client-specific-url=\"header.clientSpecificUrl\" client-specific-title=\"header.clientSpecificTitle\"></li>\n" +
    "    </ul>\n" +
    "    <ul ng-if=\"!header.hideMenus\" class=\"bm-header-right-menu bm-header-right-menu-items\" bm-flex-row>\n" +
    "        <li ng-if=\"header.isEligibleForPendoGuidanceHub\" data-qe-id=\"{{ header.mfaQeId }}\">\n" +
    "            <a href=\"javascript:void(0)\" aria-label=\"{{ 'bm.header.pendo.resourceCenter' | translate}}\" title=\"{{ 'bm.header.pendo.resourceCenter' | translate}}\" data-qe-id=\"{{ header.pendoGuidanceHubDataQeId }}\">\n" +
    "                <i class=\"pendo-resource-center-icon\"></i>\n" +
    "            </a>\n" +
    "        </li>\n" +
    "        <li bm-if-has-no-access=\"PlatformHideHelp\">\n" +
    "            <bm-help-dropdown is-dropdown-open=\"header.isHelpDropdownOpen\"></bm-help-dropdown>\n" +
    "        </li>\n" +
    "        <li class=\"new-notification-icon-container\" ng-if=\"header.enableNewNotificationPanelIAC === true\">\n" +
    "            <a role=\"link\" href=\"javascript:void(0)\" id=\"new-notification-icon-button\" data-qe-id=\"{{ header.newNotificationIconQeId }}\"\n" +
    "            aria-label=\"{{ 'bm.header.profileMenu.notifications' | translate }}\">\n" +
    "                <i class=\"new-notification-icon\"></i>\n" +
    "                <span class=\"badge new-notification-count\"></span>\n" +
    "            </a>\n" +
    "        </li>\n" +
    "        <!-- Begining of the linked accounts header -->\n" +
    "        <li id=\"bmLinkedAccountsDropdown\" ng-if=\"header.hasAccountSwitchingIAC && !header.hasNewDesignIAC \">\n" +
    "            <div ng-show=\"header.linkedAccountFound\">\n" +
    "            <!-- Dropdown Menu-->\n" +
    "            <div id=\"bmLinkedAccountsMenu\" uib-dropdown is-open=\"header.isLinkedAccountsDropdownOpen\" class=\"dropdown bento-dropdown dropdown-menu-right bm-header-dropdown\">\n" +
    "                <a ng-if=\"header.showLinkedAccountsMenu\" ng-disabled=\"header.disableLinkedAccountsMenu\" id=\"bm-header-linked-accounts-dropdown-toggle\" uib-dropdown-toggle>\n" +
    "                    <span class=\"bm-header-linked-accounts-dropdown\"\n" +
    "                        title=\"{{header.selectedLinkedAccount.displayedName}}&#013{{header.selectedLinkedAccount.companyName}}\">\n" +
    "                        <span class=\"bm-header-menu-linked-accounts-item\">{{header.selectedLinkedAccount.displayedName}}</span>\n" +
    "                        <span class=\"bm-header-menu-linked-accounts-item\">{{header.selectedLinkedAccount.companyName}}</span>\n" +
    "                    </span>\n" +
    "                    <i ng-if=\"header.showLinkedAccountsMenu\" class=\"bento-icon-caret-down\"></i>\n" +
    "                </a>\n" +
    "                <span ng-if=\"!header.showLinkedAccountsMenu\" class=\"bm-header-linked-accounts-dropdown bm-header-linked-account-span\"\n" +
    "                    title=\"{{header.selectedLinkedAccount.displayedName}}&#013{{header.selectedLinkedAccount.companyName}}\">\n" +
    "                    <span class=\"bm-header-menu-linked-accounts-item\">{{header.selectedLinkedAccount.displayedName}}</span>\n" +
    "                    <span class=\"bm-header-menu-linked-accounts-item\">{{header.selectedLinkedAccount.companyName}}</span>\n" +
    "                </span>\n" +
    "\n" +
    "                <!-- <ul class=\"dropdown-menu dropdown-menu-right dropdown-menu-linked-accounts\"> -->\n" +
    "                <ul class=\"dropdown-menu dropdown-menu-linked-accounts\">\n" +
    "                    <li id=\"bmLinkedAccountDropdownMenuHeader\" class=\"dropdown-menu-section-heading-linked-accounts\"><span translate=\"bm.header.linkedAccounts.header\"></span>\n" +
    "                        <span style=\"float: right\"><a class=\"linked-accounts-manager-link\" ng-click=\"header.openManageLinkedAccountsDialog()\" translate=\"bm.header.viewProfile.linkedAccounts.manage\"></a></span>\n" +
    "                    </li>\n" +
    "                    <!-- <li class=\"divider\"></li> -->\n" +
    "                    <li ng-repeat=\"linkedAccount in header.linkedAccounts\">\n" +
    "                        <div class=\"divider\"></div>\n" +
    "                        <div class=\"dropdown-menu-item-linked-accounts\" ng-click=\"header.switchAccount(linkedAccount.linkedAccountId)\"\n" +
    "                            title=\"{{linkedAccount.displayedName}}&#013{{linkedAccount.companyName}}\">\n" +
    "                            <div id=\"linkedAccountAccountName\" class=\"bm-menu-linked-accounts-item\">{{linkedAccount.displayedName}}</div>\n" +
    "                            <div class=\"bm-menu-linked-accounts-item\">{{linkedAccount.companyName}}</div>\n" +
    "                        </div>\n" +
    "                    </li>\n" +
    "                </ul>\n" +
    "            </div>\n" +
    "            </div>\n" +
    "        </li>\n" +
    "        <!-- End of linked accounts header -->\n" +
    "        <li ng-if=\"header.enableNewNotificationPanelIAC === true\" class=\"new-header-menu\" ng-transclude=\"icon\" uib-dropdown>\n" +
    "            <a href id=\"bm-header-profile-dropdown-toggle\" uib-dropdown-toggle title=\"{{ 'bm.header.userMenu.toggle' | translate }}\">\n" +
    "                <i class=\"bento-icon-user\" ng-if=\"!header.user.photo && !header.user.initials\"></i>\n" +
    "                <bm-profile-photo-select image=\"header.user.photo\" initials=\"{{ header.user.initials }}\" shape=\"circle\" size=\"small\" view-only=\"true\"></bm-profile-photo-select>\n" +
    "            </a>\n" +
    "\n" +
    "            <ul class=\"dropdown-menu header-custom-dropdown\" uib-dropdown-menu>\n" +
    "                <li role=\"menuitem\">\n" +
    "                    <a href data-qe-id=\"bm-components-bmHeader-view-profile\" id=\"bm-header-profile-menu-viewLink\" ng-click=\"header.openProfileModal()\" translate=\"bm.header.profileMenu.viewProfile\"></a>\n" +
    "                </li>\n" +
    "                <li role=\"menuitem\" bm-if-perm=\"OnvioSetup.UserPreferences\">\n" +
    "                    <a href data-qe-id=\"bm-components-bmHeader-user-preferences\" ng-if=\"header.hasPrefs\" ng-click=\"header.showUserPreferences()\" id=\"bm-header-profile-menu-viewPreferences\"\n" +
    "                    translate=\"bm.userPreferences\"></a>\n" +
    "                </li>\n" +
    "                <li class=\"divider menu-divider\"></li>\n" +
    "                \n" +
    "                <li role=\"menuitem\">\n" +
    "                    <bm-profile-photo-select image=\"header.user.photo\" initials=\"{{ header.user.initials }}\" shape=\"circle\" size=\"small\" view-only=\"false\" is-new-menu=\"true\"></bm-profile-photo-select>\n" +
    "                </li>\n" +
    "                \n" +
    "                <li role=\"menuitem\">\n" +
    "                    <a href data-qe-id=\"bm-components-bmHeader-sign-out\" id=\"bm-header-signout-link\" ng-click=\"header.signOut()\" translate=\"bm.header.userMenu.signOut\"></a>\n" +
    "                </li>\n" +
    "            </ul>\n" +
    "        </li>\n" +
    "          \n" +
    "        <li ng-if=\"header.enableNewNotificationPanelIAC === false\" ng-transclude=\"icon\" ng-click=\"header.toggleProfileMenuActive()\">\n" +
    "            <a href id=\"bm-header-profile-dropdown-toggle\" title=\"{{ 'bm.header.userMenu.toggle' | translate }}\">\n" +
    "                <i class=\"bento-icon-user\" ng-if=\"!header.user.photo && !header.user.initials\"></i>\n" +
    "                <bm-profile-photo-select image=\"header.user.photo\" initials=\"{{ header.user.initials }}\" shape=\"circle\" size=\"small\" view-only=\"true\"></bm-profile-photo-select>\n" +
    "                <span ng-if=\"header.totalUnreadCount > 0\" class=\"badge bm-header-profile-badge\">{{header.totalUnreadCount}}</span>\n" +
    "            </a>\n" +
    "        </li>\n" +
    "    </ul>\n" +
    "</header>\n" +
    "<div id=\"bm-header-app-menu\" ng-class=\"{ 'bm-header-app-menu-active': header.appMenuActive }\">\n" +
    "    <header>\n" +
    "        <h2 translate=\"bm.header.appsMenu.title\"></h2>\n" +
    "        <button class=\"bm-header-menu-close-btn\" ng-click=\"header.clearAppMenuActive()\" id=\"bm-header-menu-close-btn\"  aria-label=\"{{'bm.header.appMenu.CloseMenuBtn' | translate }}\">\n" +
    "            <span class=\"sr-only\" translate=\"bm.header.appMenu.CloseMenuBtn\"></span>\n" +
    "            <i class=\"bento-icon-close-x bm-header-menu-close-btn-icon\"></i>\n" +
    "        </button>\n" +
    "    </header>\n" +
    "    <ul>\n" +
    "        <li bm-if-perm-some=\"['Applications.K1Analyzer', 'UltraTaxCS.UTPLicense']\">\n" +
    "            <div class=\"bm-header-section-title\">\n" +
    "                <span translate=\"bm.header.appsMenu.OnvioApplications\" bm-flex-grow></span>\n" +
    "            </div>\n" +
    "        </li>\n" +
    "        <li bm-if-perm=\"Applications.BRPayroll\">\n" +
    "            <a href=\"/br-payroll\" target=\"_blank\" ng-click=\"header.launchApp($event)\" bm-flex-row title=\"{{ bm.header.appsMenu.brPayroll | translate }}\">\n" +
    "              <span translate=\"bm.header.appsMenu.brPayroll\" bm-flex-grow></span>\n" +
    "              <i class=\"bento-icon-newtab\"></i>\n" +
    "            </a>\n" +
    "        </li>\n" +
    "        <li bm-if-perm=\"Applications.BREscrita\">\n" +
    "            <a href=\"/br-escrita-fiscal\" target=\"_blank\" ng-click=\"header.launchApp($event)\" bm-flex-row title=\"{{ bm.header.appsMenu.brTax | translate }}\">\n" +
    "              <span translate=\"bm.header.appsMenu.brTax\" bm-flex-grow></span>\n" +
    "              <i class=\"bento-icon-newtab\"></i>\n" +
    "            </a>\n" +
    "        </li>\n" +
    "        <li bm-if-perm=\"Applications.BRAccounting\">\n" +
    "            <a href=\"/br-accounting\" target=\"_blank\" ng-click=\"header.launchApp($event)\" bm-flex-row title=\"{{ bm.header.appsMenu.brAccounting | translate }}\">\n" +
    "              <span translate=\"bm.header.appsMenu.brAccounting\" bm-flex-grow></span>\n" +
    "              <i class=\"bento-icon-newtab\"></i>\n" +
    "            </a>\n" +
    "        </li>\n" +
    "        <li bm-if-perm=\"Applications.BRProcess\">\n" +
    "            <a ng-href=\"{{header.session.bindings.RoutingTable.GesttaProcess}}\" target=\"_blank\" ng-click=\"header.sso($event); header.launchApp($event)\" bm-flex-row title=\"{{ 'bm.header.appsMenu.gesttaprocess' | translate }}\">\n" +
    "                <span translate=\"bm.header.appsMenu.gesttaprocess\" bm-flex-grow></span>\n" +
    "                <i class=\"bento-icon-newtab\"></i>\n" +
    "            </a>\n" +
    "        </li>\n" +
    "        <li ng-if=\"!header.allClientsNewPortalDoClienteIAC && ((header.hasNewPortalDoClienteIAC && !header.hasNewPortalDoClienteFRP) ||\n" +
    "		!header.hasNewPortalDoClienteIAC)\">\n" +
    "            <a bm-if-perm=\"Applications.BRAtendimento\" href=\"/atendimento/\" target=\"_blank\" ng-click=\"header.launchApp($event)\" bm-flex-row title=\"{{ 'bm.header.appsMenu.atendimentoProductName' | translate }}\">\n" +
    "                <span translate=\"bm.header.appsMenu.atendimentoProductName\" bm-flex-grow></span>\n" +
    "                <i class=\"bento-icon-newtab\"></i>\n" +
    "            </a>\n" +
    "        </li>\n" +
    "		<li ng-if=\"header.allClientsNewPortalDoClienteIAC || (header.hasNewPortalDoClienteIAC && header.hasNewPortalDoClienteFRP)\">\n" +
    "			<a bm-if-perm=\"Applications.BRAtendimento\" href=\"/br-portal-do-cliente/\" data-qe-id=\"br-portal-do-cliente-menu-item\" target=\"_blank\" ng-click=\"header.launchApp($event)\" bm-flex-row title=\"{{ 'bm.header.appsMenu.atendimentoProductName' | translate }}\">\n" +
    "				<span translate=\"bm.header.appsMenu.atendimentoProductName\" bm-flex-grow></span>\n" +
    "				<i class=\"bento-icon-newtab\"></i>\n" +
    "			</a>\n" +
    "		</li>\n" +
    "        <li ng-if=\"header.hasMessengerIAC\">\n" +
    "            <a href=\"/br-messenger/\" target=\"_blank\" ng-click=\"header.launchApp($event)\" bm-flex-row title=\"{{ 'bm.header.appsMenu.messengerProductName' | translate }}\">\n" +
    "                <span translate=\"bm.header.appsMenu.messengerProductName\" bm-flex-grow></span>\n" +
    "                <i class=\"bento-icon-newtab\"></i>\n" +
    "            </a>\n" +
    "        </li>\n" +
    "        <li bm-if-perm=\"Applications.Onvio\">\n" +
    "            <a id=\"bm-header-apps-staff-link\" href=\"/staff/\" target=\"_blank\" ng-click=\"header.launchApp($event)\" bm-flex-row title=\"{{ 'bm.header.appsMenu.staffProductNameCenter' | translate }}\">\n" +
    "                <span translate=\"bm.header.appsMenu.staffProductNameCenter\" bm-flex-grow></span>\n" +
    "                <i class=\"bento-icon-newtab\"></i>\n" +
    "            </a>\n" +
    "        </li>\n" +
    "        <li bm-if-perm=\"Applications.OnvioClientHub\">\n" +
    "            <a ng-if=\"!(header.hasCCVNextIAC || header.hasCCVNextFRP)\" id=\"bm-header-apps-client-link\" href=\"/client/\" target=\"_blank\" ng-click=\"header.launchApp($event)\" bm-flex-row title=\"{{ 'bm.header.appsMenu.clientProductName' | translate }}\">\n" +
    "                <span translate=\"bm.header.appsMenu.clientProductName\" bm-flex-grow></span>\n" +
    "                <i class=\"bento-icon-newtab\"></i>\n" +
    "            </a>\n" +
    "            <a ng-if=\"header.hasCCVNextIAC || header.hasCCVNextFRP\" href=\"/clientcenter/\" target=\"_blank\" ng-click=\"header.launchApp($event)\" bm-flex-row title=\"{{ 'bm.header.appsMenu.clientProductName' | translate }}\">\n" +
    "                <span translate=\"bm.header.appsMenu.clientProductName\" bm-flex-grow></span>\n" +
    "                <i class=\"bento-icon-newtab\"></i>\n" +
    "            </a>\n" +
    "        </li>\n" +
    "        <li bm-if-perm=\"Applications.USAdvisoryTools\">\n" +
    "            <a href=\"/advisory/\" target=\"_blank\" ng-click=\"header.launchApp($event)\" bm-flex-row title=\"{{ 'bm.header.appsMenu.advisoryToolsProductName' | translate }}\">\n" +
    "                <span translate=\"bm.header.appsMenu.advisoryToolsProductName\" bm-flex-grow></span>\n" +
    "                <i class=\"bento-icon-newtab\"></i>\n" +
    "            </a>\n" +
    "        </li>\n" +
    "        <li bm-if-perm=\"Applications.USFixedAssets\">\n" +
    "            <a href=\"/fixedassets/\" target=\"_blank\" ng-click=\"header.launchApp($event)\" bm-flex-row title=\"{{ 'bm.header.appsMenu.fixedAssetsProductName' | translate }}\">\n" +
    "                <span translate=\"bm.header.appsMenu.fixedAssetsProductName\" bm-flex-grow></span>\n" +
    "                <i class=\"bento-icon-newtab\"></i>\n" +
    "            </a>\n" +
    "        </li>\n" +
    "        <li bm-if-perm=\"Applications.AUTax\">\n" +
    "            <a bm-if-perm-some=\"['Applications.CATax', 'Applications.UKTax', 'Applications.USTax']\" href=\"/autax/\" target=\"_blank\" ng-click=\"header.launchApp($event)\" bm-flex-row title=\"{{ 'bm.header.appsMenu.autaxProductName' | translate }}\">\n" +
    "                <span translate=\"bm.header.appsMenu.autaxProductName\" bm-flex-grow></span>\n" +
    "                <i class=\"bento-icon-newtab\"></i>\n" +
    "            </a>\n" +
    "            <a bm-if-not-perm-some=\"['Applications.CATax', 'Applications.UKTax', 'Applications.USTax']\" href=\"/autax/\" target=\"_blank\" ng-click=\"header.launchApp($event)\" bm-flex-row title=\"{{ 'bm.header.appsMenu.onviotaxProductName' | translate }}\">\n" +
    "                <span translate=\"bm.header.appsMenu.onviotaxProductName\" bm-flex-grow></span>\n" +
    "                <i class=\"bento-icon-newtab\"></i>\n" +
    "            </a>\n" +
    "        </li>\n" +
    "        <li bm-if-perm=\"Applications.CATax\">\n" +
    "            <a bm-if-perm-some=\"['Applications.AUTax', 'Applications.UKTax', 'Applications.USTax']\" href=\"/staff/#/setup/core/projects?orderBy=projectNumber%20desc\" target=\"_blank\" ng-click=\"header.launchApp($event)\" bm-flex-row title=\"{{ 'bm.header.appsMenu.cataxProductName' | translate }}\">\n" +
    "                <span translate=\"bm.header.appsMenu.cataxProductName\" bm-flex-grow></span>\n" +
    "                <i class=\"bento-icon-newtab\"></i>\n" +
    "            </a>\n" +
    "            <a bm-if-not-perm-some=\"['Applications.AUTax', 'Applications.UKTax', 'Applications.USTax']\" href=\"/staff/#/setup/core/projects?orderBy=projectNumber%20desc\" target=\"_blank\" ng-click=\"header.launchApp($event)\" bm-flex-row title=\"{{ 'bm.header.appsMenu.onviotaxProductName' | translate }}\">\n" +
    "                <span translate=\"bm.header.appsMenu.onviotaxProductName\" bm-flex-grow></span>\n" +
    "                <i class=\"bento-icon-newtab\"></i>\n" +
    "            </a>\n" +
    "        </li>\n" +
    "        <li bm-if-perm=\"Applications.UKTax\">\n" +
    "            <a bm-if-perm-some=\"['Applications.AUTax', 'Applications.CATax', 'Applications.USTax']\" href=\"/uktax/\" target=\"_blank\" ng-click=\"header.launchApp($event)\" bm-flex-row title=\"{{ 'bm.header.appsMenu.uktaxProductName' | translate }}\">\n" +
    "                <span translate=\"bm.header.appsMenu.uktaxProductName\" bm-flex-grow></span>\n" +
    "                <i class=\"bento-icon-newtab\"></i>\n" +
    "            </a>\n" +
    "            <a bm-if-not-perm-some=\"['Applications.AUTax', 'Applications.CATax', 'Applications.USTax']\" href=\"/uktax/\" target=\"_blank\" ng-click=\"header.launchApp($event)\" bm-flex-row title=\"{{ 'bm.header.appsMenu.onviotaxProductName' | translate }}\">\n" +
    "                <span translate=\"bm.header.appsMenu.onviotaxProductName\" bm-flex-grow></span>\n" +
    "                <i class=\"bento-icon-newtab\"></i>\n" +
    "            </a>\n" +
    "        </li>\n" +
    "        <li bm-if-perm=\"Applications.USTax\">\n" +
    "            <a bm-if-perm-some=\"['Applications.AUTax', 'Applications.CATax', 'Applications.UKTax']\" href=\"/ustax/\" target=\"_blank\" ng-click=\"header.launchApp($event)\" bm-flex-row title=\"{{ 'bm.header.appsMenu.ustaxProductName' | translate }}\">\n" +
    "                <span translate=\"bm.header.appsMenu.ustaxProductName\" bm-flex-grow></span>\n" +
    "                <i class=\"bento-icon-newtab\"></i>\n" +
    "            </a>\n" +
    "            <a bm-if-not-perm-some=\"['Applications.AUTax', 'Applications.CATax', 'Applications.UKTax']\" href=\"/ustax/\" target=\"_blank\" ng-click=\"header.launchApp($event)\" bm-flex-row title=\"{{ 'bm.header.appsMenu.onviotaxProductName' | translate }}\">\n" +
    "                <span translate=\"bm.header.appsMenu.onviotaxProductName\" bm-flex-grow></span>\n" +
    "                <i class=\"bento-icon-newtab\"></i>\n" +
    "            </a>\n" +
    "        </li>\n" +
    "        <li bm-if-perm=\"Applications.CATaxDashboard\">\n" +
    "            <a bm-if-perm-some=\"['Applications.AUTaxDashboard', 'Applications.USTaxDashboard', 'Applications.UKTaxDashboard']\" href=\"/catax/hub/#/dashboard\" target=\"_blank\" ng-click=\"header.launchApp($event)\" bm-flex-row title=\"{{ 'bm.header.appsMenu.caTaxDashboardProductName' | translate }}\">\n" +
    "                <span translate=\"bm.header.appsMenu.caTaxDashboardProductName\" bm-flex-grow></span>\n" +
    "                <i class=\"bento-icon-newtab\"></i>\n" +
    "            </a>\n" +
    "            <a bm-if-not-perm-some=\"['Applications.AUTaxDashboard', 'Applications.USTaxDashboard', 'Applications.UKTaxDashboard']\" href=\"/catax/hub/#/dashboard\" target=\"_blank\" ng-click=\"header.launchApp($event)\" bm-flex-row title=\"{{ 'bm.header.appsMenu.taxDashboardProductName' | translate }}\">\n" +
    "                <span translate=\"bm.header.appsMenu.taxDashboardProductName\" bm-flex-grow></span>\n" +
    "                <i class=\"bento-icon-newtab\"></i>\n" +
    "            </a>\n" +
    "        </li>\n" +
    "        <li bm-if-perm=\"Applications.MyPayOnboarding\">\n" +
    "            <a href=\"/uspayrollonboarding/center/#/views/staff\" target=\"_blank\" ng-click=\"header.launchApp($event)\" bm-flex-row title=\"{{ 'bm.header.appsMenu.mypayOnboardingProductName' | translate }}\">\n" +
    "                <span translate=\"bm.header.appsMenu.mypayOnboardingProductName\" bm-flex-grow></span>\n" +
    "                <i class=\"bento-icon-newtab\"></i>\n" +
    "            </a>\n" +
    "        </li>\n" +
    "        <li bm-if-perm=\"Applications.UKSecretarial\">\n" +
    "            <a href=\"/secretarial/\" target=\"_blank\" ng-click=\"header.launchApp($event)\" bm-flex-row title=\"{{ 'bm.header.appsMenu.ukSecretarialProductName' | translate }}\">\n" +
    "                <span translate=\"bm.header.appsMenu.ukSecretarialProductName\" bm-flex-grow></span>\n" +
    "                <i class=\"bento-icon-newtab\"></i>\n" +
    "            </a>\n" +
    "        </li>\n" +
    "        <li bm-if-perm=\"Applications.UKCompanyFormations\">\n" +
    "            <a href=\"/formations/\" target=\"_blank\" ng-click=\"header.launchApp($event)\" bm-flex-row title=\"{{ 'bm.header.appsMenu.ukCompanyFormationsProductName' | translate }}\">\n" +
    "                <span translate=\"bm.header.appsMenu.ukCompanyFormationsProductName\" bm-flex-grow></span>\n" +
    "                <i class=\"bento-icon-newtab\"></i>\n" +
    "            </a>\n" +
    "        </li>\n" +
    "        <li bm-if-perm=\"Applications.GTPT\">\n" +
    "            <a href=\"/gptp/#/projects\" target=\"_blank\" ng-click=\"header.launchApp($event)\" bm-flex-row title=\"{{ 'bm.header.appsMenu.gtptSeed' | translate }}\">\n" +
    "                <span translate=\"bm.header.appsMenu.gtptSeed\" bm-flex-grow></span>\n" +
    "                <i class=\"bento-icon-newtab\"></i>\n" +
    "            </a>\n" +
    "        </li>\n" +
    "        <li bm-if-perm=\"MyPayOnboarding.ReferringAccountant\">\n" +
    "            <a href=\"/uspayrollonboarding/center/#/views/accountant\" target=\"_blank\" ng-click=\"header.launchApp($event)\" bm-flex-row title=\"{{ 'bm.header.appsMenu.mypayReferringAcct' | translate }}\">\n" +
    "                <span translate=\"bm.header.appsMenu.mypayReferringAcct\" bm-flex-grow></span>\n" +
    "                <i class=\"bento-icon-newtab\"></i>\n" +
    "            </a>\n" +
    "        </li>\n" +
    "        <li bm-if-perm-some=\"['Applications.TrialBalance','Applications.CheckpointEngage']\">\n" +
    "            <!-- show trial balance if user has both -->\n" +
    "            <a bm-if-perm=\"Applications.TrialBalance\" href=\"/trialbalance/\" target=\"_blank\" ng-click=\"header.launchApp($event)\" bm-flex-row title=\"{{ 'bm.header.appsMenu.TrialBalance' | translate }}\">\n" +
    "                <span translate=\"bm.header.appsMenu.TrialBalance\" bm-flex-grow></span>\n" +
    "                <i class=\"bento-icon-newtab\"></i>\n" +
    "            </a>\n" +
    "            <!-- otherwise, show checkpoint -->\n" +
    "            <a bm-if-not-perm=\"Applications.TrialBalance\" href=\"/checkpoint/\" target=\"_blank\" ng-click=\"header.launchApp($event)\" bm-flex-row title=\"{{ 'bm.header.appsMenu.checkpointEngageProductName' | translate }}\">\n" +
    "                <span translate=\"bm.header.appsMenu.checkpointEngageProductName\" bm-flex-grow></span>\n" +
    "                <i class=\"bento-icon-newtab\"></i>\n" +
    "            </a>\n" +
    "        </li>\n" +
    "        <li bm-if-perm=\"Applications.EstudioOne-VAT\">\n" +
    "            <a ng-href=\"{{header.session.bindings.RoutingTable['EstudioOne-VAT']}}\" target=\"_blank\" ng-click=\"header.sso($event); header.launchApp($event)\" bm-flex-row title=\"{{ 'bm.header.appsMenu.EstudioOne-VAT' | translate }}\">\n" +
    "                <span translate=\"bm.header.appsMenu.EstudioOne-VAT\" bm-flex-grow></span>\n" +
    "                <i class=\"bento-icon-newtab\"></i>\n" +
    "            </a>\n" +
    "        </li>\n" +
    "        <li bm-if-perm=\"Applications.EstudioOne-Payroll\">\n" +
    "            <a ng-href=\"{{header.session.bindings.RoutingTable['EstudioOne-Payroll']}}\" target=\"_blank\" ng-click=\"header.sso($event); header.launchApp($event)\" bm-flex-row title=\"{{ 'bm.header.appsMenu.EstudioOne-Payroll' | translate }}\">\n" +
    "                <span translate=\"bm.header.appsMenu.EstudioOne-Payroll\" bm-flex-grow></span>\n" +
    "                <i class=\"bento-icon-newtab\"></i>\n" +
    "            </a>\n" +
    "        </li>\n" +
    "        <li bm-if-perm=\"Applications.EstudioOne-Accounting\">\n" +
    "            <a ng-href=\"{{header.session.bindings.RoutingTable['EstudioOne-Accounting']}}\" target=\"_blank\" ng-click=\"header.sso($event); header.launchApp($event)\" bm-flex-row title=\"{{ 'bm.header.appsMenu.EstudioOne-Accounting' | translate }}\">\n" +
    "                <span translate=\"bm.header.appsMenu.EstudioOne-Accounting\" bm-flex-grow></span>\n" +
    "                <i class=\"bento-icon-newtab\"></i>\n" +
    "            </a>\n" +
    "        </li>\n" +
    "        <li bm-if-perm=\"Applications.EstudioOne-FixedAssets\">\n" +
    "            <a ng-href=\"{{header.session.bindings.RoutingTable['EstudioOne-FixedAssets']}}\" target=\"_blank\" ng-click=\"header.sso($event); header.launchApp($event)\" bm-flex-row title=\"{{ 'bm.header.appsMenu.EstudioOne-FixedAssets' | translate }}\">\n" +
    "                <span translate=\"bm.header.appsMenu.EstudioOne-FixedAssets\" bm-flex-grow></span>\n" +
    "                <i class=\"bento-icon-newtab\"></i>\n" +
    "            </a>\n" +
    "        </li>\n" +
    "        <li bm-if-perm=\"Applications.Integra\">\n" +
    "            <a ng-href=\"{{header.session.bindings.RoutingTable.Integra}}\" target=\"_blank\" ng-click=\"header.sso($event); header.launchApp($event)\" bm-flex-row title=\"{{ 'bm.header.appsMenu.Integra' | translate }}\">\n" +
    "                <span translate=\"bm.header.appsMenu.Integra\" bm-flex-grow></span>\n" +
    "                <i class=\"bento-icon-newtab\"></i>\n" +
    "            </a>\n" +
    "        </li>\n" +
    "        <li bm-if-perm=\"Applications.CheckpointAR\">\n" +
    "            <a ng-href=\"{{header.session.bindings.RoutingTable.CheckpointAR}}\" target=\"_blank\" ng-click=\"header.sso($event); header.launchApp($event)\" bm-flex-row title=\"{{ 'bm.header.appsMenu.CheckpointAR' | translate }}\">\n" +
    "                <span translate=\"bm.header.appsMenu.CheckpointAR\" bm-flex-grow></span>\n" +
    "                <i class=\"bento-icon-newtab\"></i>\n" +
    "            </a>\n" +
    "        </li>\n" +
    "        <li bm-if-perm=\"Applications.ARTaxAmnesty\">\n" +
    "            <a href=\"/amnesty/\" target=\"_blank\" ng-click=\"header.launchApp($event)\" bm-flex-row title=\"{{ 'bm.header.appsMenu.arTaxAmnestyProductName' | translate }}\">\n" +
    "                <span translate=\"bm.header.appsMenu.arTaxAmnestyProductName\" bm-flex-grow></span>\n" +
    "                <i class=\"bento-icon-newtab\"></i>\n" +
    "            </a>\n" +
    "        </li>\n" +
    "        <li bm-if-perm=\"Applications.ARGrossIncomeTax\">\n" +
    "            <a href=\"/ar-gross-income-tax/\" target=\"_blank\" ng-click=\"header.launchApp($event)\" bm-flex-row title=\"{{ 'bm.header.appsMenu.arGrossIncomeTaxProductName' | translate }}\">\n" +
    "                <span translate=\"bm.header.appsMenu.arGrossIncomeTaxProductName\" bm-flex-grow></span>\n" +
    "                <i class=\"bento-icon-newtab\"></i>\n" +
    "            </a>\n" +
    "        </li>\n" +
    "        <li bm-if-perm=\"Applications.ARInvestmentAccounts\">\n" +
    "            <a href=\"/arinvestmentaccountsapplication/#/projects\" target=\"_blank\" ng-click=\"header.launchApp($event)\" bm-flex-row title=\"{{ 'bm.header.appsMenu.arInvestmentAccts' | translate }}\">\n" +
    "                <span translate=\"bm.header.appsMenu.arInvestmentAccts\" bm-flex-grow></span>\n" +
    "                <i class=\"bento-icon-newtab\"></i>\n" +
    "            </a>\n" +
    "        </li>\n" +
    "        <li bm-if-perm=\"Applications.Accounts\">\n" +
    "            <a href=\"/accounts/\" target=\"_blank\" ng-click=\"header.launchApp($event)\" bm-flex-row title=\"{{ 'bm.header.appsMenu.ukAccts' | translate }}\">\n" +
    "                <span translate=\"bm.header.appsMenu.ukAccts\" bm-flex-grow></span>\n" +
    "                <i class=\"bento-icon-newtab\"></i>\n" +
    "            </a>\n" +
    "        </li>\n" +
    "        <li bm-if-perm=\"Applications.UKVAT\">\n" +
    "            <a href=\"/ukvat/\" target=\"_blank\" ng-click=\"header.launchApp($event)\" bm-flex-row title=\"{{ 'bm.header.appsMenu.ukVat' | translate }}\">\n" +
    "                <span translate=\"bm.header.appsMenu.ukVat\" bm-flex-grow></span>\n" +
    "                <i class=\"bento-icon-newtab\"></i>\n" +
    "            </a>\n" +
    "        </li>\n" +
    "        <li bm-if-perm=\"Applications.BRBoxE\">\n" +
    "            <a href=\"/boxe/\" target=\"_blank\" ng-click=\"header.launchApp($event)\" bm-flex-row title=\"{{ 'bm.header.appsMenu.brBoxE' | translate }}\">\n" +
    "                <span translate=\"bm.header.appsMenu.brBoxE\" bm-flex-grow></span>\n" +
    "                <i class=\"bento-icon-newtab\"></i>\n" +
    "            </a>\n" +
    "        </li>\n" +
    "        <li bm-if-perm=\"Applications.AUActivityStatements\">\n" +
    "            <a href=\"/auactivitystatements/\" target=\"_blank\" ng-click=\"header.launchApp($event)\" bm-flex-row title=\"{{ bm.header.appsMenu.activityStatements | translate }}\">\n" +
    "                <span translate=\"bm.header.appMenu.activityStatements\" bm-flex-grow></span>\n" +
    "                <i class=\"bento-icon-newtab\"></i>\n" +
    "            </a>\n" +
    "        </li>\n" +
    "        <li bm-if-perm=\"Applications.OnvioBRSupport\">\n" +
    "            <a ng-href=\"{{header.session.bindings.RoutingTable.OnvioBRSupport}}\" target=\"_blank\" ng-click=\"header.sso($event); header.launchApp($event)\" bm-flex-row title=\"{{ 'bm.header.appsMenu.OnvioBRSupport' | translate }}\">\n" +
    "                <span translate=\"bm.header.appsMenu.OnvioBRSupport\" bm-flex-grow></span>\n" +
    "                <i class=\"bento-icon-newtab\"></i>\n" +
    "            </a>\n" +
    "        </li>\n" +
    "        <li bm-if-perm=\"Applications.ARIncomeTax\">\n" +
    "            <a href=\"/ar-tax/\" target=\"_blank\" ng-click=\"header.launchApp($event)\" bm-flex-row title=\"{{ bm.header.appsMenu.arIncomeTax | translate }}\">\n" +
    "                <span translate=\"bm.header.appsMenu.arIncomeTax\" bm-flex-grow></span>\n" +
    "                <i class=\"bento-icon-newtab\"></i>\n" +
    "            </a>\n" +
    "        </li>\n" +
    "        <li bm-if-perm=\"Applications.CLEcomex\">\n" +
    "            <a href=\"/cl-ecomex\" target=\"_blank\" ng-click=\"header.launchApp($event)\" bm-flex-row title=\"{{ bm.header.appsMenu.ecomex | translate }}\">\n" +
    "                <span translate=\"bm.header.appsMenu.ecomex\" bm-flex-grow></span>\n" +
    "                <i class=\"bento-icon-newtab\"></i>\n" +
    "            </a>\n" +
    "        </li>\n" +
    "        <li bm-if-perm=\"Applications.PEEcomex\">\n" +
    "            <a href=\"/pe-ecomex\" target=\"_blank\" ng-click=\"header.launchApp($event)\" bm-flex-row title=\"{{ bm.header.appsMenu.ecomex | translate }}\">\n" +
    "                <span translate=\"bm.header.appsMenu.ecomex\" bm-flex-grow></span>\n" +
    "                <i class=\"bento-icon-newtab\"></i>\n" +
    "            </a>\n" +
    "        </li>\n" +
    "        <li bm-if-perm=\"Applications.ConfirmationAV\">\n" +
    "            <a href=\"/confirmationav\" target=\"_blank\" ng-click=\"header.launchApp($event)\" bm-flex-row title=\"{{ bm.header.appsMenu.confirmationassetverification | translate }}\">\n" +
    "                <span translate=\"bm.header.appsMenu.confirmationassetverification\" bm-flex-grow></span>\n" +
    "                <i class=\"bento-icon-newtab\"></i>\n" +
    "            </a>\n" +
    "        </li>\n" +
    "        <li bm-if-perm-some=\"['Applications.K1Analyzer', 'UltraTaxCS.UTPLicense']\">\n" +
    "            <div class=\"bm-header-section-title\">\n" +
    "                <span translate=\"bm.header.appsMenu.OtherApplications\" bm-flex-grow></span>\n" +
    "            </div>\n" +
    "        </li>\n" +
    "        <li bm-if-perm=\"Applications.K1Analyzer\">\n" +
    "            <a target=\"_blank\" ng-click=\"header.launchK1Analyzer($event)\" bm-flex-row title=\"{{ 'bm.header.appsMenu.K1Analyzer' | translate }}\">\n" +
    "                <span translate=\"bm.header.appsMenu.K1Analyzer\" bm-flex-grow></span>\n" +
    "                <div id=\"k1analyzer\" bento-busy-loader=\"header.isLoaderBusy\" bento-busy-loader-size=\"small\">\n" +
    "                    <i class=\"bento-icon-newtab\" ng-class=\"{'bm-visibility-hidden': header.isLoaderBusy}\"></i>\n" +
    "                </div>\n" +
    "            </a>\n" +
    "        </li>\n" +
    "        <ng-container bm-if-has-no-access=\"CoreDisableEfileDashboardWidget\">\n" +
    "            <li bmp-if-firm-permission=\"UltraTaxCS.UTPLicense\">\n" +
    "                <a target=\"_blank\" ng-click=\"header.launchUltraTaxEfileUrl($event)\" bm-flex-row title=\"{{ 'bm.header.appsMenu.UltraETax' | translate }}\">\n" +
    "                    <span translate=\"bm.header.appsMenu.UltraETax\" bm-flex-grow></span>\n" +
    "                    <div id=\"ultraETax\" bento-busy-loader=\"header.isLoaderBusy\" bento-busy-loader-size=\"small\">\n" +
    "                        <i class=\"bento-icon-newtab\" ng-class=\"{'bm-visibility-hidden': header.isLoaderBusy}\"></i>\n" +
    "                    </div>\n" +
    "                </a>\n" +
    "            </li>\n" +
    "        </ng-container>\n" +
    "    </ul>\n" +
    "</div>\n" +
    "<div id=\"bm-header-profile-menu\" ng-transclude=\"profile\" bm-flex-col ng-class=\"{ 'bm-header-profile-menu-active': header.profileMenuActive }\">\n" +
    "    <header class=\"clearfix\">\n" +
    "        <button class=\"bm-header-menu-close-btn\" ng-click=\"header.clearProfileMenuActive()\" aria-label=\"{{'bm.header.profileMenu.CloseProfileMenuBtn' | translate}}\">\n" +
    "            <span class=\"sr-only\" translate=\"bm.header.profileMenu.CloseProfileMenuBtn\"></span>\n" +
    "            <i class=\"bento-icon-close-x bm-header-menu-close-btn-icon\"></i>\n" +
    "        </button>\n" +
    "        <h2 id=\"bm-header-profile-menu-userName\" ng-bind=\"header.user.fullName\"></h2>\n" +
    "        <p id=\"bm-header-profile-menu-email\" ng-bind=\"header.user.email\" title=\"{{ 'bm.header.profileMenu.emailTooltip' | translate }}\"></p>\n" +
    "        <a href ng-if=\"header.enableNewNotificationPanelIAC === false\" id=\"bm-header-profile-menu-viewLink\" ng-click=\"header.openProfileModal()\" translate=\"bm.header.profileMenu.viewProfile\"></a>\n" +
    "        <div bm-if-perm=\"OnvioSetup.UserPreferences\">\n" +
    "            <a href ng-if=\"header.hasPrefs && header.enableNewNotificationPanelIAC === false\" ng-click=\"header.showUserPreferences()\" id=\"bm-header-profile-menu-viewPreferences\"\n" +
    "                translate=\"bm.userPreferences\"></a>\n" +
    "        </div>\n" +
    "        <div bento-alert bento-alert-object=\"alerts\"></div>\n" +
    "        <bm-profile-photo-select image=\"header.user.photo\" shape=\"circle\" ng-click=\"header.clearProfileMenuActive()\"></bm-profile-photo-select>\n" +
    "        <button role=\"button\" id=\"bm-header-signout-link\" class=\"btn btn-primary\" ng-click=\"header.signOut()\" translate=\"bm.header.userMenu.signOut\"></button>\n" +
    "    </header>\n" +
    "    <div bm-if-not-perm=\"USTax.PlatformEA\" id=\"bm-header-profile-menu-setAvail\" class=\"clearfix\">\n" +
    "        <bm-user-availability></bm-user-availability>\n" +
    "    </div>\n" +
    "    <uib-tabset id=\"bm-header-profile-menu-tabs\" class=\"tabs-top\" bm-flex-grow bm-flex-col>\n" +
    "        <uib-tab>\n" +
    "            <uib-tab-heading>\n" +
    "                <span translate=\"bm.header.profileMenu.notifications\"></span><span ng-if=\"header.unreadNotificationsCount > 0\" class=\"badge\">{{ header.unreadNotificationsCount }}</span>\n" +
    "            </uib-tab-heading>\n" +
    "            <bm-client-notifications-list></bm-client-notifications-list>\n" +
    "        </uib-tab>\n" +
    "        <uib-tab>\n" +
    "            <uib-tab-heading>\n" +
    "                <span translate=\"bm.header.profileMenu.messages\"></span><span ng-if=\"header.unreadMessagesCount > 0\" class=\"badge\">{{ header.unreadMessagesCount }}</span>\n" +
    "            </uib-tab-heading>\n" +
    "            <p class=\"zero-items-warn\" translate=\"bm.header.profileMenu.zeroMessages\"></p>\n" +
    "        </uib-tab>\n" +
    "    </uib-tabset>\n" +
    "</div>\n" +
    "<div class=\"bm-header-modal-mask\" ng-class=\"{ 'bm-header-app-menu-active': header.appMenuActive, 'bm-header-profile-menu-active': header.profileMenuActive }\" ng-click=\"header.clearMenuActive()\"></div>\n" +
    "");
}]);

angular.module("components/header/timer-header-button.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/header/timer-header-button.2js.html",
    "<li bm-if-perm=\"TimeAndBilling.TimeAndExpense\" ng-show=\"vm.timerDirectiveLoaded\">\n" +
    "    <span uib-dropdown auto-close=\"disabled\" is-open=\"vm.isTimerDropdownOpen\" class=\"dropdown bento-dropdown dropdown-menu-center bm-header-dropdown\">\n" +
    "        <a data-qe-id=\"bm-components-bmTimerHeaderButton\" role=\"link\" aria-label=\"{{ 'bm.header.timers.toggle' | translate }}\" href uib-dropdown-toggle title=\"{{ 'bm.header.timers.toggle' | translate }}{{vm.clientSpecificTitle}}\"><i class=\"bento-icon-stopwatch\"></i><span class=\"badge\" ng-class=\"{ 'bm-badge-active': vm.badge.active}\">{{vm.badge.number}}</span><span class=\"bm-header-menu-item-text\" translate=\"bm.header.timers.toggle\"></span></a>\n" +
    "        <div class=\"dropdown-menu dropdown-menu-center bm-timer-center\">\n" +
    "            <time-and-expense-timer id=\"bm-header-timer-control\" time-and-expense-timer-is-dropdown-open=\"vm.isTimerDropdownOpen\", time-and-expense-timer-badge=\"vm.badge\"/>\n" +
    "        </div>\n" +
    "    </span>\n" +
    "</li>\n" +
    "");
}]);

angular.module("components/help/help.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/help/help.2js.html",
    "<span id=\"bm-header-help-dropdown\" uib-dropdown is-open=\"help.isHelpDropdownOpen\" class=\"dropdown bento-dropdown dropdown-menu-right bm-header-dropdown\">\n" +
    "    <a id=\"bm-header-help-dropdown-toggle\" role=\"link\" aria-label=\"{{ 'bm.header.helpMenu.toggle' | translate }}\" href uib-dropdown-toggle title=\"{{ 'bm.header.helpMenu.toggle' | translate }}\" data-qe-id=\"bm-components-bmhelpdropdown-onvio-center-main-menu-onvio-help\">\n" +
    "        <i class=\"bento-icon-question\"></i>\n" +
    "        <span class=\"bm-header-menu-item-text\" translate=\"bm.header.helpMenu.toggle\"></span>\n" +
    "    </a>\n" +
    "    <ul class=\"dropdown-menu\" ng-controller=\"HelpCtrl\"\n" +
    "        ng-class=\"{'dropdown-menu-right': !useMenuLeft, 'dropdown-menu-left': useMenuLeft}\">\n" +
    "        <!-- Search field -->\n" +
    "        <li ng-click=\"$event.stopPropagation()\">\n" +
    "            <div class=\"input-group\">\n" +
    "                <span class=\"input-group-addon\" ng-click=\"helpSearch()\">\n" +
    "                    <span class=\"glyphicon glyphicon-search\"></span>\n" +
    "                </span>\n" +
    "                <label class=\"sr-only\" for=\"bm-header-help-search\" translate=\"bm.header.helpMenu.searchLabel\"></label>\n" +
    "                <input bento-reset type=\"text\" id=\"bm-header-help-search\" class=\"form-control\" placeholder=\"{{ searchInput.placeholderTxt }}\" ng-model=\"searchInput.text\" ng-keypress=\"searchKeyPress($event)\">\n" +
    "            </div>\n" +
    "        </li>\n" +
    "        <li class=\"divider\"></li>\n" +
    "        <!-- Suggested Topics -->\n" +
    "        <li ng-if=\"currentCountry !== 'AR'\" class=\"dropdown-menu-section-heading\" translate=\"bm.header.helpMenu.topicsHeading\"></li>\n" +
    "        <li ng-if=\"currentCountry !== 'AR'\" ng-repeat=\"menu in help.topics\">\n" +
    "            <a ng-href=\"{{ formatTopicUrl(help, menu.url) }}\" target=\"_blank\">{{menu.title}}</a>\n" +
    "        </li>\n" +
    "        <li ng-if=\"currentCountry !== 'AR'\" class=\"divider\"></li>\n" +
    "        <!-- Additional assistance -->\n" +
    "        <li class=\"dropdown-menu-section-heading\" translate=\"bm.header.helpMenu.assistanceHeading\"></li>\n" +
    "        <li ng-if=\"currentCountry === 'AR'\" >\n" +
    "            <a ng-href=\"{{ arHelpAndTrainingLink }}\" target=\"_blank\" rel=”noreferrer noopener” translate=\"bm.header.helpMenu.arHelpAndTrainingLink\"></a>\n" +
    "        </li>\n" +
    "        <li ng-if=\"help && help.howToUrl && currentCountry !== 'AR'\" >\n" +
    "            <a ng-href=\"{{ howToLink() }}\" target=\"_blank\" translate=\"bm.header.helpMenu.siteLinkText\"></a>\n" +
    "        </li>\n" +
    "        <li ng-if=\"countryCode === 'us'\">\n" +
    "            <a ng-href=\"{{alertsAndNoticesLink}}\" target=\"_blank\" translate=\"bm.header.helpMenu.alertsAndNotices\"></a>\n" +
    "        </li>\n" +
    "        <li ng-if=\"countryCode === 'us'\">\n" +
    "            <a ng-href=\"{{videoLibraryLink}}\" target=\"_blank\" translate=\"bm.header.helpMenu.videoLibrary\"></a>\n" +
    "        </li>\n" +
    "        <li ng-if=\"countryCode === 'us'\">\n" +
    "            <a ng-href=\"{{contactSupportLink}}\" target=\"_blank\" translate=\"bm.header.helpMenu.contactSupport\"></a>\n" +
    "        </li>\n" +
    "        <!-- <li ng-if=\"countryCode === 'us'\">\n" +
    "            <a ng-href=\"{{communityLink}}\" target=\"_blank\" translate=\"bm.header.helpMenu.community\"></a>\n" +
    "        </li> -->\n" +
    "        <li ng-if=\"countryCode === 'us'\">\n" +
    "            <a ng-href=\"{{ideaIncubatorLink}}\" target=\"_blank\" translate=\"bm.header.helpMenu.ideaIncubator\"></a>\n" +
    "        </li>\n" +
    "\n" +
    "        <!-- privacy policy -->\n" +
    "        <li>\n" +
    "            <bm-privacy-policy-link aria-hidden=\"true\"></bm-privacy-policy-link>\n" +
    "        </li>\n" +
    "        <!-- support id -->\n" +
    "        <li ng-click=\"$event.stopPropagation()\">\n" +
    "            <bm-support-id-link aria-hidden=\"true\"></bm-support-id-link>\n" +
    "        </li>\n" +
    "        <li ng-if=\"currentCountry === 'AR'\">\n" +
    "            <a data-qe-id=\"bm-components-bmHeader-ar-service-request\" ng-href=\"javascript:void(0)\" translate=\"bm.header.helpMenu.arServiceRequest\" ng-click=\"openEstudioOneSupport()\"></a>\n" +
    "        </li>\n" +
    "    </ul>\n" +
    "</span>\n" +
    "");
}]);

angular.module("components/i18n/language-select.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/i18n/language-select.2js.html",
    "<div bento-select>\n" +
    "    <select\n" +
    "        id=\"{{ name }}\"\n" +
    "        name=\"{{ name }}\"\n" +
    "        class=\"form-control\"\n" +
    "        ng-model=\"selectedLanguage\"\n" +
    "        ng-change=\"selectionChanged()\"\n" +
    "        ng-required=\"required\"\n" +
    "        ng-options=\"language.translatedDescription for language in languageList track by language.code\"\n" +
    "        ng-disabled=\"disabled\">\n" +
    "        <option value=\"\" ng-if=\"showEmpty\"></option>\n" +
    "    </select>\n" +
    "</div>\n" +
    "");
}]);

angular.module("components/linked-accounts/linked-accounts-dialog.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/linked-accounts/linked-accounts-dialog.2js.html",
    "<div>\n" +
    "	<button type=\"button\" class=\"close\" aria-hidden=\"true\" ng-click=\"vm.closeDialog()\">\n" +
    "    	<i class=\"bento-icon-close-x\"></i>\n" +
    "  	</button>\n" +
    "	<bm-linked-accounts user=\"vm.user\" shared-data=\"vm.sharedProfile\"></bm-linked-accounts>\n" +
    "</div>");
}]);

angular.module("components/linked-accounts/linked-accounts.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/linked-accounts/linked-accounts.2js.html",
    "<div>\n" +
    "<form id=\"linkedAccountsForm\" name=\"vm.linkedAccountsForm\" role=\"form\" class=\"css-form\" novalidate>\n" +
    "	<div id=\"formView\" bento-busy-loader=\"vm.isLoaderBusy\" bento-busy-loader-size=\"default\">\n" +
    "	<h3 class=\"bm-modal-title\" translate=\"bm.header.linkedAccounts.header\"></h3>\n" +
    "	<!-- Alerts -->\n" +
    "	<div class=\"bento-alert-container\" ng-if=\"vm.alerts.length > 0\">\n" +
    "		<div ng-repeat=\"alert in vm.alerts\" class=\"alert bento-alert alert-dismissable\" role=\"alert\" ng-class=\"{'alert-success' : alert.type === 'success', 'alert-warning' : alert.type === 'warning', 'alert-info' : alert.type === 'info', 'alert-danger' : alert.type === 'danger'}\">\n" +
    "			<span>\n" +
    "				{{alert.msg}}\n" +
    "			</span>\n" +
    "		</div>\n" +
    "	</div>\n" +
    "    <div class=\"form-group\">\n" +
    "        <button id=\"bmcAddAccountButton\" ng-click=\"vm.openMergeLinkingAccountDialog()\">\n" +
    "            <i id=\"bmcAddAccountIcon\" class=\"bento-icon-add\"></i> <label id=\"bmcAddAccount\" translate=\"bm.linkedAccounts.add\"></label>\n" +
    "        </button>\n" +
    "    </div>\n" +
    "\n" +
    "	<div id=\"linkedAccountsMainView\" ng-if=\"vm.user\">\n" +
    "		<div class=\"row\">\n" +
    "			<div class=\"col-sm-12\">\n" +
    "				<div class=\"form-group\">\n" +
    "					<label bm-if-has-access=\"Platform_DisableAuth0Phase2\"><span translate=\"bm.components.linkedAccounts.emailAddressMsg\"></span>&nbsp;<span id=\"userEmail\">{{vm.user.email}}</span></label>\n" +
    "                    <label bm-if-has-no-access=\"Platform_DisableAuth0Phase2\"><span translate=\"bm.components.linkedAccounts.emailAddressMsgAuth0\"></span>&nbsp;<span id=\"userEmail\">{{vm.user.email}}</span></label>\n" +
    "				</div>\n" +
    "			</div>\n" +
    "		</div>\n" +
    "		<div class=\"row\" id=\"noLinkedAccountsRow\" ng-if=\"vm.showAccounts == false\">\n" +
    "			<span translate=\"bm.components.linkedAccounts.noAccounts\"></span>\n" +
    "		</div>\n" +
    "		<!-- Flexgrid -->\n" +
    "		<div class=\"row\" id=\"linkedAccountsRow\" ng-if=\"vm.showAccounts\">\n" +
    "			<wj-flex-grid\n" +
    "				control=\"vm.flexgrid\"\n" +
    "				items-source=\"vm.gridData\"\n" +
    "				items-source-changed=\"refreshGrid(this.flexgrid)\"\n" +
    "				class=\"bmLinkedAccountsFlexgrid\">\n" +
    "				<wj-flex-grid-column min-width=\"65\" max-width=\"65\" header=\"{{'bm.components.linkedAccounts.active' | translate}}\" binding=\"active\" is-read-only=\"{{vm.hasOneAccount}}\" align=\"center\"></wj-flex-grid-column>\n" +
    "				<wj-flex-grid-column min-width=\"65\" max-width=\"65\" header=\"{{'bm.components.linkedAccounts.home' | translate}}\" is-read-only=\"{{vm.hasOneAccount}}\" align=\"center\">\n" +
    "					<wj-flex-grid-cell-template cell-type=\"Cell\">\n" +
    "						<input type=\"radio\" ng-change=\"vm.defaultChanged()\" ng-model=\"vm.selectedDefaultLinkAccountId\" value=\"{{$item.linkedAccountId}}\">\n" +
    "					</wj-flex-grid-cell-template>\n" +
    "				</wj-flex-grid-column>\n" +
    "				<wj-flex-grid-column width=\"*\" header=\"{{'bm.components.linkedaccounts.accountName' | translate}}\" binding=\"accountName\" is-read-only=\"true\"> </wj-flex-grid-column>\n" +
    "				<wj-flex-grid-column min-width=\"175\" max-width=\"175\" header=\"{{'bm.components.linkedAccounts.nickname' | translate}}\" binding=\"displayedNickname\" is-read-only=\"false\">\n" +
    "					<wj-flex-grid-cell-template cell-type=\"Cell\">\n" +
    "						<div class=\"columnDisplayedNickname\">\n" +
    "							<div class=\"bmLinkedAccountsNickname\">\n" +
    "								<span id=\"accountName\" ng-if=\"$item.displayedNickname === ''\" translate=\"bm.components.linkedaccounts.accountName\"></span>\n" +
    "								<span ng-if=\"$item.displayedNickname !== ''\">{{$item.displayedNickname}}</span>\n" +
    "							</div>\n" +
    "							<div clase=\"bmLinkedAccountsEdit\">\n" +
    "								<span class=\"bento-icon-edit grid-action-item\"\n" +
    "									ng-click=\"\"\n" +
    "									data-tooltip-placement=\"top\"\n" +
    "									data-tooltip-trigger=\"mouseenter\"\n" +
    "									data-uib-tooltip=\"{{'bm.components.linkedAccounts.edit' | translate}}\"\n" +
    "									data-tooltip-append-to-body=\"true\">\n" +
    "								</span>\n" +
    "							</div>\n" +
    "						</div>\n" +
    "					</wj-flex-grid-cell-template>\n" +
    "				</wj-flex-grid-column>\n" +
    "				<wj-flex-grid-column width=\"*\" header=\"{{'bm.components.linkedAccounts.firm' | translate}}\" binding=\"companyName\" is-read-only=\"true\"></wj-flex-grid-column>\n" +
    "			</wj-flex-grid>\n" +
    "		</div>\n" +
    "		<!-- End of grid -->\n" +
    "		<div class=\"row\"><p>\n" +
    "			<div class=\"col-sm-12\">\n" +
    "				<div class=\"form-group\" id=\"linkedAccountDetail\">\n" +
    "					<label>\n" +
    "						<span translate=\"bm.components.linkedAccounts.activeAccount\"></span>\n" +
    "					</label>\n" +
    "					<label>\n" +
    "						<span translate=\"bm.components.linkedAccounts.homeAccount\"></span>\n" +
    "					</label>\n" +
    "				</div>\n" +
    "			</div>\n" +
    "		</p></div>\n" +
    "	</div>\n" +
    "	<div class=\"modal-footer\">\n" +
    "		<button type=\"submit\" class=\"btn btn-primary bm-animate-if\" ng-click=\"vm.saveLinkedAccounts()\" ng-show=\"vm.user && (vm.linkedAccounts.length > 0)\" translate=\"Bluemoon.Components.Common.Actions.Save\"></button>\n" +
    "		<button type=\"button\" class=\"btn btn-default bm-animate-if\" ng-click=\"vm.cancelLinkedAccounts()\" translate=\"bm.components.common.close\"></button>\n" +
    "	</div>\n" +
    "	</div>\n" +
    "</form>\n" +
    "</div>\n" +
    "");
}]);

angular.module("components/linking-merge/linking-merge-modal.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/linking-merge/linking-merge-modal.2js.html",
    "<form name=\"vm.linkingAccountForm\" role=\"form\" class=\"css-form was-validated\">\n" +
    "    <div class=\"bento-modal bm-profile\">\n" +
    "        <button type=\"button\" class=\"close\" aria-hidden=\"true\" ng-click=\"vm.closeAddAccount()\">\n" +
    "            <i class=\"bento-icon-close-x\"></i>\n" +
    "        </button>\n" +
    "        <div class=\"modal-header\" translate=\"bm.linkingAccountMerge.title\"></div>\n" +
    "        <div class=\"bento-alert-container\" ng-if=\"vm.alerts.length > 0\">\n" +
    "            <div ng-repeat=\"alert in vm.alerts\" class=\"alert bento-alert alert-dismissable\" role=\"alert\" ng-class=\"{'alert-success' : alert.type === 'success', 'alert-warning' : alert.type === 'warning', 'alert-info' : alert.type === 'info', 'alert-danger' : alert.type === 'danger'}\">\n" +
    "                <span>\n" +
    "                    {{alert.msg}}\n" +
    "                </span>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div class=\"modal-body bm-modal-body\">\n" +
    "            <div class=\"form-group\">\n" +
    "                <label><span translate=\"bm.linkingAccountMerge.info\"></span><br><strong><span id=\"userEmail\">{{vm.user.email}}</span></strong></label>\n" +
    "            </div>\n" +
    "\n" +
    "            <div class=\"form-group\">\n" +
    "                <label for=\"email\"><span translate=\"bm.linkingMerge.email\"></span> *</label>\n" +
    "                <input type=\"input\" class=\"form-control\"  placeholder=\"name@domain.com\" id=\"email\" name=\"email\" ng-model = \"vm.linkingAccount.uid\" required maxlength=\"250\" />\n" +
    "                <div class=\"msg\" translate=\"bm.linkingAccountForm.emailRequired\"></div>\n" +
    "            </div>\n" +
    "\n" +
    "            <div class=\"form-group\">\n" +
    "                <label for=\"pwd\"><span translate=\"bm.header.viewProfile.password\"></span> *</label>\n" +
    "                <input type=\"password\"  class=\"form-control\" id=\"pwd\" name=\"pwd\" ng-model = \"vm.linkingAccount.pwd\" required maxlength=\"200\" />\n" +
    "                <div class=\"msg invalid-feedback\" translate=\"bm.header.checkpoint.passwordRequired\"></div>\n" +
    "            </div>\n" +
    "\n" +
    "            <button type=\"submit\" class=\"btn btn-primary bm-animate-if\" ng-click=\"vm.addLinkingAccount()\" translate=\"Bluemoon.Components.Common.Actions.Save\"></button>\n" +
    "            <button type=\"button\" class=\"btn btn-primary bm-animate-if\" ng-click=\"vm.closeAddAccount()\" translate=\"Bluemoon.Components.Common.Actions.Cancel\"></button>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</form>\n" +
    "");
}]);

angular.module("components/main/main.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/main/main.2js.html",
    "<main ng-transclude></main>\n" +
    "");
}]);

angular.module("components/modal/modal-base.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/modal/modal-base.2js.html",
    "<button ng-if=\"showClose\" type=\"button\" class=\"close\" aria-hidden=\"true\" ng-click=\"$close()\">\n" +
    "	<i class=\"bento-icon-close-x\"></i>\n" +
    "</button>\n" +
    "<div ng-include=\"templateUrl\"></div>\n" +
    "<div class=\"modal-footer\">\n" +
    "	<button ng-repeat=\"button in buttons\" ng-class=\"[ 'btn', (!!button.primary ? 'btn-primary' : 'btn-default') ]\" ng-click=\"(button.dismiss === true ? $dismiss(button.value) : $close(button.value))\">{{button.text}}</button>\n" +
    "</div>");
}]);

angular.module("components/modal/modal-default.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/modal/modal-default.2js.html",
    "<div class=\"modal-header\">\n" +
    "	{{vars.title}}\n" +
    "</div>\n" +
    "<div class=\"modal-body\">\n" +
    "	<p>\n" +
    "        {{vars.body}}\n" +
    "	</p>\n" +
    "</div>");
}]);

angular.module("components/multi-factor-user/multi-factor-user-settings.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/multi-factor-user/multi-factor-user-settings.2js.html",
    "<div id=\"mfaUserSettingsDiv\">\n" +
    "	<button type=\"button\" class=\"close\" aria-hidden=\"true\" ng-click=\"vm.close()\">\n" +
    "		<i class=\"bento-icon-close-x\"></i>\n" +
    "	</button>\n" +
    "	<div class=\"modal-header\">\n" +
    "		<span translate=\"bm.components.mfa.user.name\"></span>\n" +
    "	</div>	\n" +
    "	<div class=\"modal-body\">\n" +
    "		<div id=\"mfaModalBody\">\n" +
    "			<!-- <div id=\"busyLoading\"  ng-show=\"vm.isLoading\"> -->\n" +
    "			<div id=\"busyLoading\" ng-show=\"vm.busyLoading\">\n" +
    "				<p><span translate=\"bm.components.common.loading\"></span>...</p>\n" +
    "			</div>\n" +
    "			<div id=\"noDevice\"  ng-show=\"(!vm.busyLoading) && (vm.registeredFactors.length == 0)\">\n" +
    "				<p><span translate=\"bm.components.mfa.user.nodevice\"></span>.</p>\n" +
    "			</div>\n" +
    "			<div id=\"hasDevice\" ng-show=\"vm.registeredFactors.length > 0\">\n" +
    "				<div><p>\n" +
    "					<span translate=\"bm.components.mfa.user.device\"></span>: \n" +
    "					<div id=\"userDevice\">{{vm.userDevice}}</div>\n" +
    "				</p></div>\n" +
    "				<div>\n" +
    "					<p translate=\"bm.components.mfa.user.lostphone\"></p>\n" +
    "					<!-- Lost phone or don't have access to the Thomson Reuters Authetication app? -->\n" +
    "					<!-- Generate a temporary, 24-hour numerical code -->\n" +
    "					<p translate=\"bm.components.mfa.user.invalidate\"></p>\n" +
    "					<!-- for use in place of the app. Generating a code for this user will invalidate any previously-generated codes that you created for their account -->\n" +
    "				</div>\n" +
    "				<button class=\"btn btn-primary\" ng-click=\"vm.generateAccessCode()\" translate=\"bm.components.mfa.user.generate\"></button>\n" +
    "				<div ng-if=\"vm.authCode\" id=\"temporaryAccessCodeDiv\">\n" +
    "					<span translate=\"bm.components.mfa.user.tempcode\"></span>:<span id=\"temporaryAccessCodeLBL\">{{vm.authCode}}</span>\n" +
    "				</div>\n" +
    "			</div>\n" +
    "		</div>\n" +
    "	</div>\n" +
    "	<div class=\"modal-footer\">\n" +
    "		<button class=\"btn btn-primary\" ng-click=\"vm.close()\" translate=\"bm.components.common.close\"></button>\n" +
    "	</div>\n" +
    "</div>");
}]);

angular.module("components/multi-factor-user/multi-factor-user.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/multi-factor-user/multi-factor-user.2js.html",
    "<div id=\"mfaUserDiv\" ng-show=\"vm.isMfaAvailable\">\n" +
    "	<div class=\"row\">\n" +
    "		<div class=\"col-md-6\">			\n" +
    "			<label id=\"mfaLbl\" translate=\"bm.components.mfa.user.name\"></label>\n" +
    "		</div>\n" +
    "	</div>\n" +
    "	<div class=\"row\">\n" +
    "		<div class=\"col-md-6\">\n" +
    "			<button id=\"viewSettingsBtn\" type=\"button\" class=\"btn btn-default\" translate=\"bm.components.common.viewsettings\" ng-click=\"vm.openMfaSettingsModal()\"></button>			\n" +
    "		</div>\n" +
    "	</div>\n" +
    "\n" +
    "<!-- \n" +
    "	<div>\n" +
    "		<button id=\"viewSettingsBtn\" type=\"button\" class=\"btn btn-primary\" translate=\"bm.components.common.viewsettings\" ng-click=\"vm.openMfaSettingsModal()\">	\n" +
    "		</button>\n" +
    "		<label id=\"mfaLbl\" translate=\"bm.components.mfa.user.name\"></label>\n" +
    "	</div>\n" +
    " -->	\n" +
    "</div>");
}]);

angular.module("components/multi-factor/multi-factor-profile-modal.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/multi-factor/multi-factor-profile-modal.2js.html",
    "<form name=\"vm.confirmDeviceForm\" role=\"form\" class=\"css-form\" novalidate>\n" +
    "  <div class=\"bento-modal\">\n" +
    "    <div class=\"modal-body\">\n" +
    "      <p translate=\"bm.header.viewProfile.mfaConfirmRemove\" ng-if=\"vm.modalAction === 'remove'\"></p>\n" +
    "      <p translate=\"bm.components.header.viewProfile.mfaConfirmAdd\" ng-if=\"vm.modalAction === 'add'\"></p>\n" +
    "      <div class=\"row\">\n" +
    "        <div class=\"col-sm-8\">\n" +
    "          <div class=\"form-group\" ng-class=\"{'has-error' : vm.confirmDeviceForm.userPassword.$invalid && ((vm.confirmDeviceForm.userPassword.$touched && vm.confirmDeviceForm.userPassword.$dirty) || vm.confirmDeviceForm.$submitted)}\">\n" +
    "            <label for=\"userPassword\"><span translate=\"bm.components.common.password\"></span> *</label>\n" +
    "            <input class=\"form-control\" type=\"password\" id=\"userPassword\" name=\"userPassword\" ng-model=\"vm.user.password\" bm-focus=\"true\" required />\n" +
    "            <div class=\"msg\" ng-messages=\"vm.confirmDeviceForm.userPassword.$error\" ng-if=\"vm.confirmDeviceForm.userPassword.$touched || vm.confirmDeviceForm.$submitted\">\n" +
    "              <span ng-message=\"required\">{{'bm.header.checkpoint.passwordRequired'|translate}}</span>\n" +
    "          </div>\n" +
    "          </div>\n" +
    "          * <span translate=\"bm.components.common.requiredField\"></span>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "    <div class=\"modal-footer\">\n" +
    "      <button type=\"submit\" class=\"btn btn-primary btn-dynamic\" ng-click=\"vm.confirmDevice()\" translate=\"BM.Components.UpdatePassword.ConfirmPassword\"></button>\n" +
    "      <button class=\"btn btn-default btn-dynamic\" ng-click=\"vm.cancelDevice()\" translate=\"Bluemoon.Components.Common.Actions.Cancel\"></button>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</form>\n" +
    "");
}]);

angular.module("components/multi-factor/multi-factor-profile.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/multi-factor/multi-factor-profile.2js.html",
    "<div class=\"bm-mfa-profile\">\n" +
    "    <h3 class=\"bm-modal-title\" translate=\"bm.header.viewProfile.multifactorTitle\"></h3>\n" +
    "    <div class=\"row bm-lg-top-margin\">\n" +
    "        <div class=\"col-sm-12\">\n" +
    "          <span ng-if=\"$ctrl.required\" translate=\"bm.header.viewProfile.mfaRequired\"></span>\n" +
    "          <span ng-if=\"!$ctrl.required\" translate=\"bm.header.viewProfile.mfaOptional\"></span>\n" +
    "          <!-- TODO: NEED THE CORRECT LINK HERE FOR MFA HELP -->\n" +
    "          <a role=\"button\" class=\"btn btn-link btn-icon\" target=\"_blank\" ng-href=\"{{$ctrl.helpLink || '/ua/help/' + $ctrl.helpLangCode + '/staff/core/common/mfa-overview.htm'}}\">\n" +
    "            <span class=\"btn-icon-text\" translate=\"bm.header.viewProfile.mfaLearnMore\"></span>\n" +
    "            <i class=\"bento-icon-arrow-forward\"></i>\n" +
    "          </a>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"row\">\n" +
    "      <div class=\"col-sm-12\">\n" +
    "        <h4 translate=\"bm.header.viewProfile.mfaOptions.header\"></h4>\n" +
    "        <div translate=\"bm.header.viewProfile.mfaOptions.description\" ng-if=\"$ctrl.mutliFactorComplete\"></div>\n" +
    "        <div class=\"device-container\">\n" +
    "          <div translate=\"bm.header.viewProfile.mfaAccountNotPaired\" ng-if=\"!$ctrl.mutliFactorComplete\"></div>\n" +
    "          <div ng-repeat=\"factor in $ctrl.devices\">\n" +
    "              <span>{{factor.name}}</span>\n" +
    "              <a role=\"button\" class=\"btn btn-link btn-icon\" ng-click=\"$ctrl.actions.openConfirmModal('remove', factor)\" ng-if=\"!$ctrl.required || $ctrl.required && $ctrl.devices.length > 1\">\n" +
    "                <i class=\"bento-icon-remove\"></i>\n" +
    "              </a>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "        <a role=\"button\" class=\"add-link\" ng-href=\"\" ng-click=\"$ctrl.actions.openConfirmModal('add')\" translate=\"bm.header.viewProfile.mfaAddOption\"></a>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "    <div class=\"row\">\n" +
    "      <div class=\"col-sm-12\" ng-if=\"$ctrl.mutliFactorComplete\">\n" +
    "        <h4 translate=\"bm.header.viewProfile.mfaEmergencyCodes.header\"></h4>\n" +
    "        <p translate=\"bm.header.viewProfile.mfaEmergencyCodes.desc\"></p>\n" +
    "        <button type=\"button\" class=\"btn btn-default\" translate=\"bm.header.viewProfile.mfaEmergencyCodes.generate\" ng-click=\"$ctrl.actions.openConfirmModal('generate')\"></button>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "  ");
}]);

angular.module("components/nav/nav.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/nav/nav.2js.html",
    "<nav class=\"navmore-flex\" ng-transclude></nav>\n" +
    "");
}]);

angular.module("components/navigation-utils/confirm-navigation.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/navigation-utils/confirm-navigation.2js.html",
    "<div class=\"modal-header\">\n" +
    "	{{'Bluemoon.Components.NavigationUtils.ConfirmNavigation.Title' | translate}}\n" +
    "</div>\n" +
    "\n" +
    "<div class=\"modal-body\">\n" +
    "	<p>{{'Bluemoon.Components.NavigationUtils.ConfirmNavigation.BodyMessage' | translate}}</p>\n" +
    "</div>\n" +
    "\n" +
    "<div class=\"modal-footer\">\n" +
    "    <!-- TODO: These strings should be under FEF namespace -->\n" +
    "	<button type=\"button\" class=\"btn btn-primary\" data-ng-click=\"save()\">{{'Bluemoon.Components.Common.Actions.Save' | translate}}</button>\n" +
    "	<button type=\"button\" class=\"btn btn-default\" data-ng-click=\"ok()\">{{'Bluemoon.Components.Common.Actions.DoNotSave' | translate}}</button>\n" +
    "	<button type=\"button\" class=\"btn btn-default\" data-ng-click=\"cancel()\">{{'Bluemoon.Components.Common.Actions.Cancel' | translate}}</button>\n" +
    "</div>\n" +
    "\n" +
    "");
}]);

angular.module("components/navigation-utils/save-in-progress-modal.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/navigation-utils/save-in-progress-modal.2js.html",
    "<div class=\"modal-header\">\n" +
    "    <h3>{{'Bluemoon.Components.SaveInProgressModal.Title' | translate}}</h3>\n" +
    "</div>\n" +
    "\n" +
    "<div class=\"modal-body\">\n" +
    "    <p>{{'Bluemoon.Components.SaveInProgressModal.BodyMessage' | translate}}</p>\n" +
    "</div>\n" +
    "\n" +
    "<div class=\"modal-footer\">\n" +
    "</div>\n" +
    "");
}]);

angular.module("components/not-found/bm-staff-not-found.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/not-found/bm-staff-not-found.2js.html",
    "<div class=\"container-fluid\">\n" +
    "    <div class=\"row\">\n" +
    "        <h4 data-translate=\"Bluemoon.Components.Staff.NotFound.MainText\"></h4><br/>\n" +
    "        <a class=\"btn btn-primary\" href=\"/staff/#/\" data-translate=\"Bluemoon.Components.Staff.NotFound.GoToDashboard\"></a>\n" +
    "    </div>\n" +
    "</div>");
}]);

angular.module("components/password-validation/password-validation.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/password-validation/password-validation.2js.html",
    "<div class=\"bm-password-validation\">\n" +
    "    <span translate>bm.password.validation.mustHaveStart</span> <span class=\"{{rules.characterLengthRule.test(password) ? 'passing' : 'failing-required'}}\" translate=\"bm.password.validation.characterRule\" translate-value-val=\"{{charLengthReq}}\"></span> <span translate=\"bm.password.validation.mustHaveEnd\" translate-value-val=\"{{charClassReq}}\"></span>\n" +
    "    <ul>\n" +
    "        <div ng-repeat=\"rule in rules.characterTypeRules\">\n" +
    "            <li class=\"{{ rule.test(password) ? 'passing' : 'failing-optional' }}\">{{ rule.label }}</li>\n" +
    "        </div>\n" +
    "    </ul>\n" +
    "    <p/>\n" +
    "    <span translate>bm.password.validation.excludeTitle</span>\n" +
    "    <ul>\n" +
    "        <li translate>bm.password.validation.excludeWords</li>\n" +
    "        <li translate>bm.password.validation.excludeUserId</li>\n" +
    "        <li translate>bm.password.validation.excludeSequential</li>\n" +
    "    </ul>\n" +
    "</div>\n" +
    "");
}]);

angular.module("components/preview-trial-widget/preview-trial-widget.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/preview-trial-widget/preview-trial-widget.2js.html",
    "<div id=\"previewTrialWidget\" class=\"previewMode\" ng-if=\"vm.preview\">\n" +
    "	<div id=\"previewTrialContent\">\n" +
    "		<p><span translate=\"bm.header.previewTrial.previewMode.intro\"></span> <span class=\"orange\" translate=\"bm.header.previewTrial.previewMode.preview\"></span> <span translate=\"bm.header.previewTrial.previewMode.mode\"></span></p>\n" +
    "	</div>\n" +
    "</div>\n" +
    "<div id=\"previewTrialWidget\" class=\"trialMode\" ng-if=\"vm.trial\">\n" +
    "	<div id=\"previewTrialContent\">\n" +
    "		<p><span translate=\"bm.header.previewTrial.trialMode.intro\"></span> {{vm.days}} <span translate=\"bm.header.previewTrial.trialMode.days\"></span></p>\n" +
    "		<a role=\"button\" class=\"btn\" ng-href=\"{{vm.modeButtonLink}}\" translate=\"bm.header.previewTrial.trialMode.button\"></a>\n" +
    "	</div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("components/privacy-policy/privacy-policy.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/privacy-policy/privacy-policy.2js.html",
    "<a href=\"{{$ctrl.privacyUri}}\" target=\"_blank\" translate=\"bm.components.privacyPolicy\"></a>\n" +
    "");
}]);

angular.module("components/profile-photo-select/profile-photo-select.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/profile-photo-select/profile-photo-select.2js.html",
    "<div ng-class=\"{ 'menu-for-new-profile': vm.isNewMenu }\">\n" +
    "    <div class=\"bm-profile-photo\" ng-class=\"{ 'img-circle' : vm.shape === 'circle', 'lg-photo' : vm.size === 'large', 'sm-photo' : vm.size === 'small' }\" ng-if=\"!vm.isNewMenu\">\n" +
    "        <span class=\"initials\" ng-if=\"!vm.selectEnabled && vm.initials && !vm.image\">{{ vm.initials }}</span>\n" +
    "        <div class=\"silhouette\" ng-style=\"vm.selectedStyle\" ng-if=\"!vm.selectEnabled && vm.image\"></div>\n" +
    "        <a class=\"select-profile\" data-qe-id=\"bm-components-bmHeader-change-photo\" href=\"\" ng-click=\"vm.openPhotoModal()\" ng-if=\"vm.selectEnabled\">\n" +
    "            <div class=\"silhouette\" ng-style=\"vm.selectedStyle\"></div>\n" +
    "            <span class=\"silhouette-change\" translate=\"bm.header.accountDialog.addProfileImage\"></span>\n" +
    "        </a>\n" +
    "    </div>\n" +
    "\n" +
    "    <!-- For new profile menu, we need only text -->\n" +
    "    <a class=\"select-profile\" data-qe-id=\"bm-components-bmHeader-change-photo\" href=\"\" ng-click=\"vm.openPhotoModal()\" ng-if=\"vm.isNewMenu && vm.selectEnabled\">\n" +
    "        <div class=\"silhouette\" ng-style=\"vm.selectedStyle\"></div>\n" +
    "        <span class=\"silhouette-change\" translate=\"bm.header.accountDialog.addProfileImage\"></span>\n" +
    "    </a>\n" +
    "\n" +
    "    <bm-image-upload-modal api=\"vm.imageUploadApi\"></bm-image-upload-modal>\n" +
    "</div>");
}]);

angular.module("components/session/cc-vnext-modal.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/session/cc-vnext-modal.2js.html",
    "<button type=\"button\" class=\"close\" aria-hidden=\"true\" ng-click=\"$close()\">\n" +
    "	<i class=\"bento-icon-close-x\"></i>\n" +
    "</button>\n" +
    "<div class=\"modal-header\">\n" +
    "	Client Preview Unavailable for Beta Users\n" +
    "</div>\n" +
    "<div class=\"modal-body\">\n" +
    "	<p>\n" +
    "        We are still developing the client preview for the beta version of\n" +
    "        Client Center. We will notify you as we release new features so that\n" +
    "        you can give us your valuable feedback.<br/><br/>\n" +
    "\n" +
    "        If you need to view your client’s portal, close this message,\n" +
    "        change the Client Center Version switch to \"Current\" above the\n" +
    "        client's Client Center Access toggle, save your changes, and then click\n" +
    "        preview again. You won’t lose any data if you switch.\n" +
    "	</p>\n" +
    "</div>\n" +
    "<div class=\"modal-footer\">\n" +
    "	<button class=\"btn btn-primary\" ng-click=\"$close()\">Ok</button>\n" +
    "</div>");
}]);

angular.module("components/support-id/support-id.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/support-id/support-id.2js.html",
    "<div ng-show=\"$ctrl.enabled\">\n" +
    "    <a ng-click=\"$ctrl.showId=!$ctrl.showId\" href=\"\" target=\"_blank\" translate=\"bm.components.supportId\"></a>\n" +
    "\n" +
    "    <div ng-show=\"$ctrl.showId\" class=\"support-id-display input-group\">\n" +
    "        <span class=\"input-group-addon\" ng-click=\"$ctrl.copyToClip();\">\n" +
    "            <span class=\"glyphicon glyphicon-copy\"></span>\n" +
    "        </span>\n" +
    "        <input id=\"support-id-text\" type=\"text\" placeholder=\"loading\" ng-model=\"$ctrl.supportId\" readonly>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("components/terms-signatory/terms-signatory-modal.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/terms-signatory/terms-signatory-modal.2js.html",
    "<div class=\"bento-modal bm-terms-signatory\">\n" +
    "    <div class=\"modal-header\" translate>\n" +
    "        bm.terms.signatory.title\n" +
    "    </div>\n" +
    "    <div class=\"modal-body\">\n" +
    "        <div class=\"bm-signatory-view\" ng-bind-html=\"vm.displayText\"></div>\n" +
    "        <span class=\"bm-signatory-instructions\" translate>\n" +
    "            bm.terms.signatory.instructions\n" +
    "        </span>\n" +
    "    </div>\n" +
    "    <div class=\"modal-footer\">\n" +
    "        <button class=\"btn btn-primary btn-dynamic\" ng-click=\"vm.setAgreement(true)\" translate>\n" +
    "            bm.terms.signatory.agree\n" +
    "        </button>\n" +
    "        <button class=\"btn btn-default btn-dynamic\" ng-click=\"vm.setAgreement(false)\" translate>\n" +
    "            bm.terms.signatory.disagree\n" +
    "        </button>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("components/view-portal-banner/view-portal-banner.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/view-portal-banner/view-portal-banner.2js.html",
    "<header ng-class=\"{ 'unresolved-theme': banner.unresolvedTheme }\">\n" +
    "    <div id=\"view-portal-banner-left-side\">\n" +
    "        <span translate=\"bm.viewPortalBanner.viewingMsg\"></span><span> {{ banner.uname }}</span>\n" +
    "    </div>\n" +
    "    <div id=\"view-portal-banner-right-side\">\n" +
    "        <button class=\"btn btn-default\" translate=\"bm.viewPortalBanner.doneBtn\" ng-click=\"banner.exitViewPortalMode()\"></button>\n" +
    "    </div>\n" +
    "</header>\n" +
    "");
}]);

angular.module("my-account/link-auth/link-auth-modal.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("my-account/link-auth/link-auth-modal.2js.html",
    "<form name=\"vm.verifyLoginForm\" role=\"form\" class=\"css-form\" novalidate>\n" +
    "  <div class=\"bento-modal\" bento-busy-loader=\"vm.isLoaderBusy\" bento-busy-loader-size=\"default\">\n" +
    "    <h3 class=\"modal-header\" translate=\"BM.Components.EmailInUseHeader\"></h3>\n" +
    "    <div class=\"modal-body\">\n" +
    "        <p translate=\"BM.Components.AccountLinkDescription\"></p>\n" +
    "        <!-- Commenting out for now, but may be needed for later -->\n" +
    "        <!-- <a translate=\"BM.Components.TRID\"></a> -->\n" +
    "        <div class=\"row\">\n" +
    "            <div class=\"col-sm-8\">\n" +
    "                <div class=\"form-group\" ng-class=\"{'has-error' : vm.verifyLogin.pwd.$invalid && ((vm.verifyLogin.pwd.$touched && vm.verifyLogin.pwd.$dirty) || vm.verifyLogin.$submitted)}\">\n" +
    "                    <label for=\"pwd\"><span translate=\"bm.components.common.password\"></span> *</label>\n" +
    "                    <input class=\"form-control\" type=\"password\" id=\"pwd\" name=\"pwd\" ng-model=\"vm.pwd\" bm-focus=\"true\" required />\n" +
    "                    <div class=\"msg\" ng-messages=\"vm.verifyLogin.pwd.$error\" ng-if=\"vm.verifyLogin.pwd.$touched || vm.verifyLogin.$submitted\">\n" +
    "                        <span ng-message=\"required\">{{'bm.header.checkpoint.passwordRequired'|translate}}</span>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"modal-footer\">\n" +
    "        <button type=\"submit\" class=\"btn btn-primary bm-animate-if\" ng-click=\"vm.linkAccounts()\" translate=\"Bluemoon.Components.Common.Actions.LinkAccounts\"></button>\n" +
    "        <button type=\"button\" class=\"btn btn-default bm-animate-if\" ng-click=\"vm.changeEmail()\" translate=\"Bluemoon.Components.Common.Actions.ChangeEmail\"></button>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</form>\n" +
    "\n" +
    "");
}]);

angular.module("my-account/my-account-licensee.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("my-account/my-account-licensee.2js.html",
    "<form name=\"vm.myAccountForm\" role=\"form\" class=\"css-form\" novalidate>\n" +
    "  <h3 class=\"bm-modal-title\" translate=\"bm.header.accountDialog.header\"></h3>\n" +
    "  <!-- show a banner that looks like an alert -->\n" +
    "  <div ng-if=\"vm.user\" class=\"bento-alert-container bm-profile-btm-margin\">\n" +
    "    <div class=\"alert bento-alert alert-info\" role=\"alert\" translate=\"bm.header.viewProfile.licenseeBanner\">\n" +
    "    </div>\n" +
    "  </div>\n" +
    "  <div ng-if=\"vm.user\" class=\"bm-animate-if\">\n" +
    "    <!-- name -->\n" +
    "    <div class=\"row bm-profile-btm-margin\">\n" +
    "      <div class=\"col-sm-8 col-md-6\">\n" +
    "        <span translate=\"bm.header.viewProfile.nameLabel\"></span>: {{ vm.localUser.fullName }}\n" +
    "      </div>\n" +
    "    </div>\n" +
    "    <!-- email -->\n" +
    "    <div class=\"row\">\n" +
    "      <div class=\"col-sm-8 col-md-6\">\n" +
    "        <div class=\"form-group\" ng-class=\"{ 'has-error': vm.userIdError !== ''}\">\n" +
    "          <label for=\"userId\"><span translate=\"bm.header.accountDialog.emailLabel\"></span> *</label>\n" +
    "          <input class=\"form-control\" type=\"email\" id=\"userId\" name=\"userId\" ng-model=\"vm.localUser.email\" ng-blur='vm.validateUserId(false)' bm-validate-email required>\n" +
    "          <div class=\"msg\">{{ vm.userIdError }}</div>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "    <div class=\"modal-required bm-required-fields\" ng-if=\"vm.localUser\">\n" +
    "      * <span translate=\"bm.components.common.requiredField\"></span>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "  <div class=\"modal-footer\">\n" +
    "    <button type=\"submit\" class=\"btn btn-primary bm-animate-if\" ng-click=\"vm.saveUser()\" ng-if=\"vm.user\" translate=\"Bluemoon.Components.Common.Actions.Save\"></button>\n" +
    "    <button type=\"button\" class=\"btn btn-default bm-animate-if\" ng-click=\"vm.cancelUser()\" translate=\"Bluemoon.Components.Common.Actions.Cancel\"></button>\n" +
    "  </div>\n" +
    "  <!-- alerts -->\n" +
    "  <div bento-alert bento-alert-object=\"vm.alerts\"></div>\n" +
    "</form>\n" +
    "");
}]);

angular.module("my-account/my-account-skinny.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("my-account/my-account-skinny.2js.html",
    "<form name=\"vm.myAccountForm\" role=\"form\" class=\"css-form\" novalidate>\n" +
    "  <h3 class=\"bm-modal-title\" translate=\"bm.header.accountDialog.header\"></h3>\n" +
    "  <div ng-if=\"vm.user\" class=\"bm-animate-if\">\n" +
    "    <!-- email -->\n" +
    "    <div class=\"row\">\n" +
    "      <div class=\"col-sm-8 col-md-6\">\n" +
    "        <div class=\"form-group\" ng-class=\"{ 'has-error': vm.userIdError !== ''}\">\n" +
    "          <label for=\"userId\"><span translate=\"bm.header.accountDialog.emailLabel\"></span> *</label>\n" +
    "          <input class=\"form-control\" type=\"email\" id=\"userId\" name=\"userId\" ng-maxlength=\"250\" ng-model=\"vm.localUser.email\" ng-blur='vm.validateUserId(false)' bm-validate-email required>\n" +
    "          <div class=\"msg\">{{ vm.userIdError }}</div>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "    <!-- name -->\n" +
    "    <div class=\"row\">\n" +
    "        <div class=\"col-sm-4 col-md-3\">\n" +
    "            <div class=\"form-group\" ng-class=\"{'has-error' : ((vm.myAccountForm.firstName.$error.required || vm.myAccountForm.firstName.$error.maxlength) && vm.myAccountForm.firstName.$dirty)}\">\n" +
    "          <label for=\"firstName\"><span translate=\"BM.Components.AccountInformation.FirstName\"></span> *</label>\n" +
    "              <input class=\"form-control\" type=\"text\" id=\"firstName\" name=\"firstName\" ng-model=\"vm.localUser.firstName\" required ng-maxlength=\"100\" />\n" +
    "              <div ng-if=\"vm.myAccountForm.firstName.$error.required\" class=\"msg\" translate=\"BM.Components.AccountInformation.FirstNameInstructions\"></div>\n" +
    "              <div ng-if=\"vm.myAccountForm.firstName.$error.maxlength\" class=\"msg\" translate=\"BM.Components.AccountInformation.NameLength.Instructions\"></div>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "      <div class=\"col-sm-4 col-md-3\" bm-if-has-no-access=\"BR_HideProfileMiddleName\">\n" +
    "        <div class=\"form-group\">\n" +
    "            <label for=\"middleName\" translate=\"BM.Components.AccountInformation.MiddleName\"></label>\n" +
    "            <input class=\"form-control\" type=\"text\" id=\"middleName\" name=\"middleName\" ng-model=\"vm.localUser.middleName\" />\n" +
    "        </div>\n" +
    "      </div>\n" +
    "      <div class=\"col-sm-4 col-md-3\">\n" +
    "        <div class=\"form-group\" ng-class=\"{'has-error' : ((vm.myAccountForm.lastName.$error.required || vm.myAccountForm.lastName.$error.maxlength) && vm.myAccountForm.lastName.$dirty)}\">\n" +
    "          <label for=\"lastName\"><span translate=\"BM.Components.AccountInformation.LastName\"></span> *</label>\n" +
    "          <input class=\"form-control\" type=\"text\" id=\"lastName\" name=\"lastName\" ng-model=\"vm.localUser.lastName\" ng-maxlength=\"100\" required />\n" +
    "          <div ng-if=\"vm.myAccountForm.lastName.$error.required\" class=\"msg\" translate=\"BM.Components.AccountInformation.LastName.Instructions\"></div>\n" +
    "          <div ng-if=\"vm.myAccountForm.lastName.$error.maxlength\" class=\"msg\" translate=\"BM.Components.AccountInformation.NameLength.Instructions\"></div>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "    <div class=\"modal-required bm-required-fields\" ng-if=\"vm.localUser\">\n" +
    "        * <span translate=\"bm.components.common.requiredField\"></span>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "  <div class=\"modal-footer\">\n" +
    "      <button type=\"submit\" class=\"btn btn-primary bm-animate-if\" ng-click=\"vm.saveUser()\" ng-if=\"vm.user\" translate=\"Bluemoon.Components.Common.Actions.Save\"></button>\n" +
    "      <button type=\"button\" class=\"btn btn-default bm-animate-if\" ng-click=\"vm.cancelUser()\" translate=\"Bluemoon.Components.Common.Actions.Cancel\"></button>\n" +
    "  </div>\n" +
    "  <!-- alerts -->\n" +
    "  <div bento-alert bento-alert-object=\"vm.alerts\"></div>\n" +
    "</form>\n" +
    "");
}]);

angular.module("my-account/my-account.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("my-account/my-account.2js.html",
    "<form name=\"vm.myAccountForm\" role=\"form\" class=\"css-form\" novalidate>\n" +
    "  <div bm-if-has-no-access=\"Platform_DisableAuth0Phase2\" bento-toolbar class=\"navbar navbar-default bento-toolbar bento-custom-toolbar-refresh-button\"\n" +
    "     toolbar-data=\"vm.toolbarButtons\">\n" +
    "  </div>\n" +
    "  <h3 class=\"bm-modal-title\" translate=\"bm.header.accountDialog.header\"></h3>\n" +
    "  <!-- Error -->\n" +
    "  <!-- make it look like bento-alert -->\n" +
    "  <div class=\"bento-alert-container\" ng-if=\"!vm.showTerms && vm.alerts.length > 0\">\n" +
    "      <div ng-repeat=\"alert in vm.alerts\" class=\"alert bento-alert alert-dismissable\" role=\"alert\" ng-class=\"{'alert-success': alert.type === 'success', 'alert-warning': alert.type === 'warning', 'alert-info': alert.type === 'info', 'alert-danger': alert.type === 'danger'}\">\n" +
    "          <span>\n" +
    "              {{alert.msg}}\n" +
    "          </span>\n" +
    "      </div>\n" +
    "  </div>\n" +
    "  <div class=\"bm-animate-if\" ng-if=\"vm.showTerms\">\n" +
    "    <h3 translate=\"bm.terms.signatory.title\"></h3>\n" +
    "    <div class=\"bm-terms-signatory\">\n" +
    "      <div class=\"bm-signatory-view\" ng-bind-html=\"vm.termsDisplayText\"></div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "  <div ng-if=\"vm.user && !vm.showTerms\" class=\"bm-animate-if\">\n" +
    "    <!-- email -->\n" +
    "    <div bm-if-has-access=\"Platform_DisableAuth0Phase2\" class=\"row\">\n" +
    "      <div class=\"col-sm-8 col-md-6\">\n" +
    "        <div class=\"form-group\" ng-class=\"{ 'has-error': vm.userIdError !== ''}\">\n" +
    "          <label for=\"userId\"><span translate=\"bm.header.accountDialog.emailLabel\"></span> *</label>\n" +
    "          <div>\n" +
    "              <input class=\"form-control\" type=\"email\" id=\"userId\" name=\"userId\" ng-model=\"vm.localUser.email\" ng-blur='vm.validateUserId(false)' ng-maxlength=\"250\" bm-validate-email required>\n" +
    "          </div>\n" +
    "          <div class=\"msg\">{{ vm.userIdError }}</div>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "    <div bm-if-has-no-access=\"Platform_DisableAuth0Phase2\" class=\"row\">\n" +
    "        <div class=\"col-sm-8 col-md-6\">\n" +
    "            <label for=\"userId\"><span translate=\"bm.header.accountDialog.emailLabel\"></span></label>\n" +
    "            <p>{{vm.localUser.email}}</p>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "    <!-- name -->\n" +
    "    <div bm-if-has-access=\"Platform_DisableAuth0Phase2\" class=\"row\">\n" +
    "        <div class=\"col-sm-4 col-md-3\">\n" +
    "            <div class=\"form-group\" ng-class=\"{'has-error' : ((vm.myAccountForm.firstName.$error.required || vm.myAccountForm.firstName.$error.maxlength) && vm.myAccountForm.firstName.$dirty)}\">\n" +
    "          <label for=\"firstName\"><span translate=\"BM.Components.AccountInformation.FirstName\"></span> *</label>\n" +
    "              <input class=\"form-control\" type=\"text\" id=\"firstName\" name=\"firstName\" ng-model=\"vm.localUser.firstName\" required ng-maxlength=\"100\"/>\n" +
    "              <div ng-if=\"vm.myAccountForm.firstName.$error.required\" class=\"msg\" translate=\"BM.Components.AccountInformation.FirstNameInstructions\"></div>\n" +
    "              <div ng-if=\"vm.myAccountForm.firstName.$error.maxlength\" class=\"msg\" translate=\"BM.Components.AccountInformation.NameLength.Instructions\"></div>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "      <div class=\"col-sm-4 col-md-3\" bm-if-has-no-access=\"BR_HideProfileMiddleName\">\n" +
    "        <div class=\"form-group\">\n" +
    "            <label for=\"middleName\" translate=\"BM.Components.AccountInformation.MiddleName\"></label>\n" +
    "            <input class=\"form-control\" type=\"text\" id=\"middleName\" name=\"middleName\" ng-model=\"vm.localUser.middleName\" />\n" +
    "        </div>\n" +
    "      </div>\n" +
    "      <div class=\"col-sm-4 col-md-3\">\n" +
    "        <div class=\"form-group\" ng-class=\"{'has-error' : ((vm.myAccountForm.lastName.$error.required || vm.myAccountForm.lastName.$error.maxlength) && vm.myAccountForm.lastName.$dirty)}\">\n" +
    "          <label for=\"lastName\"><span translate=\"BM.Components.AccountInformation.LastName\"></span> *</label>\n" +
    "          <input class=\"form-control\" type=\"text\" id=\"lastName\" name=\"lastName\" ng-model=\"vm.localUser.lastName\" required ng-maxlength=\"100\"/>\n" +
    "          <div ng-if=\"vm.myAccountForm.lastName.$error.required\" class=\"msg\" translate=\"BM.Components.AccountInformation.LastName.Instructions\"></div>\n" +
    "          <div ng-if=\"vm.myAccountForm.lastName.$error.maxlength\" class=\"msg\" translate=\"BM.Components.AccountInformation.NameLength.Instructions\"></div>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "    <div bm-if-has-no-access=\"Platform_DisableAuth0Phase2\" class=\"row\">\n" +
    "        <div class=\"col-sm-8 col-md-6\">\n" +
    "            <label for=\"userId\"><span translate=\"bm.header.viewProfile.nameLabel\"></span></label>\n" +
    "            <p>{{vm.localUser.firstName + ' ' + vm.localUser.lastName}}</p>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "    <!-- language -->\n" +
    "    <div class=\"row\" ng-if=\"vm.languageList.length > 1\">\n" +
    "      <div class=\"col-sm-8 col-md-4\">\n" +
    "        <div class=\"form-group\" ng-class=\"{ 'has-error': vm.myAccountForm.language.$dirty && vm.myAccountForm.language.$invalid }\">\n" +
    "            <label for=\"language\"><span translate=\"bm.header.accountDialog.languageLabel\"></span> *</label>\n" +
    "            <bm-language-select name=\"language\" selected-language-code=\"vm.localUser.language\" include-empty-option=\"false\" selection-required=\"true\" on-change=\"vm.languageChanged(language)\"></bm-language-select>\n" +
    "            <div class=\"msg\" translate=\"bm.header.accountDialog.languageRequiredError\"></div>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "      <button ng-if=\"vm.isVisibleLanguageUpdateButton()\" type=\"submit\" class=\"btn btn-primary bm-animate-if bm-update-button-account-info\" ng-click=\"vm.updateLanguageCIAM()\" translate=\"Bluemoon.Components.Common.Actions.Update\"></button>\n" +
    "    </div>\n" +
    "    <div bm-if-has-access=\"Platform_DisableAuth0Phase2\" class=\"modal-required bm-required-fields\" ng-if=\"vm.localUser\">\n" +
    "        * <span translate=\"bm.components.common.requiredField\"></span>\n" +
    "    </div>\n" +
    "    <p bm-if-has-no-access=\"Platform_DisableAuth0Phase2\"><span translate=\"BM.Components.AccountInformation.ManageAccountLabel\"></span></p>\n" +
    "  </div>\n" +
    "  <div class=\"modal-footer\">\n" +
    "      <button ng-if=\"vm.isVisibleSaveButton()\" type=\"submit\" class=\"btn btn-primary bm-animate-if\" ng-click=\"vm.saveUser()\" translate=\"Bluemoon.Components.Common.Actions.Save\"></button>\n" +
    "      <button bm-if-has-no-access=\"Platform_DisableAuth0Phase2\" type=\"link\" class=\"btn btn-primary bm-animate-if\"><a translate=\"Bluemoon.Components.Common.Actions.Manage\" href=\"{{vm.auth0ProfileUrl}}\" target=\"_blank\"></a><i class=\"bento-icon-arrow-forward\"></i></button>\n" +
    "      <button type=\"button\" class=\"btn btn-default bm-animate-if\" ng-click=\"vm.cancelUser()\" ng-if=\"!vm.showTerms\" translate=\"Bluemoon.Components.Common.Actions.Cancel\"></button>\n" +
    "      <a role=\"button\" class=\"btn btn-link bm-animate-if\" ng-click=\"vm.showTerms=true\" ng-if=\"!vm.showStaffTerms && vm.hasTermsSignatory && !vm.showTerms\" translate=\"bm.header.accountDialog.showTerms\"></a>\n" +
    "      <a role=\"button\" class=\"btn btn-link bm-animate-if\" ng-click=\"vm.showTerms=false\" ng-if=\"!vm.showStaffTerms && vm.hasTermsSignatory && vm.showTerms\" translate=\"bm.header.accountDialog.hideTerms\"></a>\n" +
    "      <a role=\"button\" class=\"btn btn-link bm-animate-if\" href=\"{{vm.termsLink}}\" target=\"_blank\" ng-if=\"vm.showStaffTerms\" translate=\"bm.header.accountDialog.showTerms\"></a>\n" +
    "  </div>\n" +
    "</form>\n" +
    "");
}]);

angular.module("security-questions/security-questions.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("security-questions/security-questions.2js.html",
    "<form name=\"vm.securityQuestionsForm\" role=\"form\" class=\"css-form\" novalidate>\n" +
    "    <h3 class=\"bm-modal-title\" translate=\"BM.Components.SecurityQuestions.Header\"></h3>\n" +
    "    <!-- Error -->\n" +
    "    <!-- make it look like bento-alert -->\n" +
    "    <div class=\"bento-alert-container\" ng-if=\"vm.alerts.length > 0\">\n" +
    "        <div ng-repeat=\"alert in vm.alerts\" class=\"alert bento-alert alert-dismissable\" role=\"alert\" ng-class=\"{'alert-success': alert.type === 'success', 'alert-warning': alert.type === 'warning', 'alert-info': alert.type === 'info', 'alert-danger': alert.type === 'danger'}\">\n" +
    "            <span>\n" +
    "                {{alert.msg}}\n" +
    "            </span>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div ng-if=\"vm.questions.length > 0\">\n" +
    "      <div ng-repeat=\"question in vm.questions\">\n" +
    "        <div class=\"row\">\n" +
    "          <div class=\"col-sm-12\">\n" +
    "            <div class=\"form-group\" ng-class=\"{ 'has-error': question.questionError !== ''}\">\n" +
    "              <label for=\"question{{ $index + 1 }}\"><span translate=\"BM.Components.SecurityQuestion.QuestionTag\"></span> {{ $index + 1 }} *</label>\n" +
    "              <div bento-select>\n" +
    "                <select\n" +
    "                  name=\"question{{ $index + 1 }}\"\n" +
    "                  id=\"question{{ $index + 1 }}\"\n" +
    "                  ng-model=\"question.selectedQuestion\"\n" +
    "                  ng-options=\"masterQuestion.question for masterQuestion in question.masterList track by masterQuestion.questionId\"\n" +
    "                  ng-change=\"vm.processQuestionSelect($index, question)\"\n" +
    "                  class=\"form-control\">\n" +
    "                  <option value=\"\"></option>\n" +
    "                </select>\n" +
    "              </div>\n" +
    "              <div class=\"msg\">{{ question.questionError }}</div>\n" +
    "            </div>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "        <div class=\"row\">\n" +
    "          <div class=\"col-sm-12\">\n" +
    "            <div class=\"form-group\" ng-class=\"{ 'has-error': question.answerError !== '', 'bm-form-group-pair': ($index + 1) !== vm.questions.length }\">\n" +
    "              <label for=\"answer{{ $index + 1 }}\"><span translate=\"BM.Components.SecurityQuestion.AnswerTag\"></span> *</label>\n" +
    "              <input class=\"form-control\" type=\"text\" id=\"answer{{ $index + 1 }}\" name=\"answer{{ $index + 1 }}\" ng-model=\"question.answer\" ng-blur=\"vm.validateAnswer(question, false)\" ng-focus=\"vm.clearDefaultAnswer(question)\" />\n" +
    "              <div class=\"msg\">{{ question.answerError }}</div>\n" +
    "            </div>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "    <div class=\"modal-required bm-required-fields\" ng-if=\"vm.questions.length > 0\">\n" +
    "        * <span translate=\"bm.components.common.requiredField\"></span>\n" +
    "    </div>\n" +
    "    <div class=\"modal-footer\">\n" +
    "        <button type=\"submit\" class=\"btn btn-primary btn-circ btn-dynamic\" ng-click=\"vm.saveQuestions()\" ng-if=\"vm.questions.length > 0\" translate=\"Bluemoon.Components.Common.Actions.Save\"></button>\n" +
    "        <button type=\"button\" class=\"btn btn-default btn-circ btn-dynamic\" ng-click=\"vm.cancelQuestions()\" translate=\"Bluemoon.Components.Common.Actions.Cancel\"></button>\n" +
    "  </div>\n" +
    "</form>\n" +
    "");
}]);

angular.module("update-password/update-password.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("update-password/update-password.2js.html",
    "<form name=\"vm.updatePasswordForm\" role=\"form\" class=\"css-form\" novalidate>\n" +
    "    <h3 class=\"bm-modal-title\" translate=\"BM.Components.UpdatePassword\"></h3>\n" +
    "    <!-- Error -->\n" +
    "    <!-- make it look like bento-alert -->\n" +
    "    <div class=\"bento-alert-container\" ng-if=\"vm.alerts.length > 0\">\n" +
    "        <div ng-repeat=\"alert in vm.alerts\" class=\"alert bento-alert alert-dismissable\" role=\"alert\" ng-class=\"{'alert-success': alert.type === 'success', 'alert-warning': alert.type === 'warning', 'alert-info': alert.type === 'info', 'alert-danger': alert.type === 'danger'}\">\n" +
    "            <span>\n" +
    "                {{alert.msg}}\n" +
    "            </span>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"row\">\n" +
    "        <div class=\"col-sm-12\">\n" +
    "            <div class=\"form-group\" ng-class=\"{ 'has-error': vm.updatePasswordForm.currentPassword.$error.required && vm.updatePasswordForm.currentPassword.hasVisited }\">\n" +
    "                <label for=\"currentPassword\"><span translate=\"BM.Components.UpdatePassword.CurrentPassword\"></span> *</label>\n" +
    "                <a href class=\"pull-right no-underline\" ng-click=\"vm.showPassword = !vm.showPassword\">\n" +
    "                 <span ng-if=\"vm.showPassword == true\">\n" +
    "                    <span translate=\"BM.Components.UpdatePassword.Hide\">\n" +
    "                    </span>\n" +
    "                </span>\n" +
    "                <span ng-if =\"vm.showPassword == false || vm.showPassword == undefined\">\n" +
    "                    <span translate=\"BM.Components.UpdatePassword.Show\">\n" +
    "                    </span>\n" +
    "                </span></a>\n" +
    "                <input class=\"form-control\" id=\"currentPassword\" name=\"currentPassword\" bm-focus=\"true\" type=\"{{ vm.showPassword ? 'text' : 'password' }}\" ng-model=\"vm.currentPassword\" required maxlength=\"50\"/>\n" +
    "                <div class=\"msg\" role=\"alert\" translate=\"BM.Components.UpdatePassword.CurrentPassword.Instructions\"></div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"row\">\n" +
    "        <div class=\"col-sm-12\">\n" +
    "            <div class=\"form-group\" ng-class=\"{ 'has-error': vm.newPasswordError !== ''}\">\n" +
    "                <label for=\"newPassword\" ><span translate=\"BM.Components.UpdatePassword.NewPassword\"></span> *</label>\n" +
    "                <input class=\"form-control\" id=\"newPassword\" name=\"newPassword\" type=\"{{ vm.showPassword ? 'text' : 'password' }}\" ng-model=\"vm.newPassword\" ng-blur=\"vm.validatePasswordFields(false)\" required maxlength=\"50\"/>\n" +
    "                <div class=\"msg\" role=\"alert\">{{ vm.newPasswordError }}</div>\n" +
    "                <div class=\"bm-msg-valid\" ng-show=\"vm.newPasswordError === '' && vm.passwordIsValidated\">\n" +
    "                    <span class=\"glyphicon glyphicon-ok\"></span>\n" +
    "                    <span translate=\"BM.Components.UpdatePassword.PasswordAcceptable\"></span>\n" +
    "                </div>\n" +
    "                <div bm-password-validation password=\"vm.newPassword\" ng-show=\"vm.updatePasswordForm.newPassword.hasFocus\"></div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"row\">\n" +
    "        <div class=\"col-sm-12\">\n" +
    "            <div class=\"form-group\" ng-class=\"{ 'has-error': vm.isConfirmPasswordInvalid()}\">\n" +
    "                 <label for=\"confirmPassword\"><span translate=\"BM.Components.UpdatePassword.ConfirmPassword\"></span> *</label>\n" +
    "                <input class=\"form-control\" id=\"confirmPassword\" name=\"confirmPassword\" type=\"{{ vm.showPassword ? 'text' : 'password' }}\" ng-model=\"vm.confirmPassword\" ng-blur=\"vm.setConfirmPasswordOutOfFocus()\" ng-focus=\"vm.setConfirmPasswordInFocus()\" maxlength=\"50\"/>\n" +
    "                <div class=\"msg\" role=\"alert\">{{ vm.confirmPasswordError }}</div>\n" +
    "                <div class=\"bm-msg-valid\" ng-show=\"vm.isConfirmPasswordValid() && vm.newPasswordError === ''\">\n" +
    "                    <span class=\"glyphicon glyphicon-ok\"></span>\n" +
    "                    <span translate=\"BM.Components.UpdatePassword.PasswordConfirmed\"></span>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"modal-required bm-required-fields\">\n" +
    "        * <span translate=\"bm.components.common.requiredField\"></span>\n" +
    "    </div>\n" +
    "    <div class=\"modal-footer\">\n" +
    "        <button type=\"submit\" class=\"btn btn-primary btn-circ btn-dynamic\" ng-click=\"vm.savePassword()\" translate=\"Bluemoon.Components.Common.Actions.Save\"></button>\n" +
    "        <button type=\"button\" class=\"btn btn-default btn-circ btn-dynamic\" ng-click=\"vm.cancelPassword()\" translate=\"Bluemoon.Components.Common.Actions.Cancel\"></button>\n" +
    "    </div>\n" +
    "</form>\n" +
    "");
}]);

angular.module("user-profile/view-profile-modal.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("user-profile/view-profile-modal.2js.html",
    "<div class=\"bento-modal bm-profile\">\n" +
    "  <button type=\"button\" class=\"close\" aria-hidden=\"true\" ng-click=\"vm.closeProfile()\">\n" +
    "    <i class=\"bento-icon-close-x\"></i>\n" +
    "  </button>\n" +
    "  <div class=\"modal-header\" translate=\"bm.header.userMenu.toggle\"></div>\n" +
    "  <div class=\"modal-body bm-modal-body\">\n" +
    "    <uib-tabset class=\"tabs-left bm-tab-animation\">\n" +
    "      <!-- account information -->\n" +
    "      <uib-tab data-qe-id=\"bm-profile-acct-tab\" deselect=\"vm.tabDeselect('account')\">\n" +
    "        <uib-tab-heading>\n" +
    "          <span translate=\"bm.header.viewProfile.account\"></span><i class=\"bento-icon-warning bm-unsaved-changes\" title=\"{{vm.translatedUnsaved}}\" aria-hidden=\"true\" ng-if=\"vm.sharedProfile.hasUnsavedAccount\"></i>\n" +
    "        </uib-tab-heading>\n" +
    "        <bm-my-account-info languages=\"vm.languages\" user=\"vm.user\" shared-data=\"vm.sharedProfile\"></bm-my-account-info>\n" +
    "      </uib-tab>\n" +
    "      <!-- change password -->\n" +
    "      <uib-tab bm-if-has-access=\"Platform_DisableAuth0Phase2\" data-qe-id=\"bm-profile-chgpwd-tab\" deselect=\"vm.tabDeselect('password')\">\n" +
    "        <uib-tab-heading>\n" +
    "          <span translate=\"bm.header.viewProfile.password\"></span><i class=\"bento-icon-warning bm-unsaved-changes\" title=\"{{vm.translatedUnsaved}}\" aria-hidden=\"true\" ng-if=\"vm.sharedProfile.hasUnsavedPassword\"></i>\n" +
    "        </uib-tab-heading>\n" +
    "        <bm-update-password user=\"vm.user\" shared-data=\"vm.sharedProfile\"></bm-update-password>\n" +
    "      </uib-tab>\n" +
    "      <!-- linked accounts -->\n" +
    "      <uib-tab data-qe-id=\"bm-profile-linked-accts-tab\" select=\"vm.tabSelect('linkedAccounts')\" deselect=\"vm.tabDeselect('linkedAccounts')\" bm-if-has-access=\"PPE-AccountSwitching\">\n" +
    "        <uib-tab-heading>\n" +
    "            <div class=\"bm-multi-tab-heading bm-multi-tab-center\">\n" +
    "              <span translate=\"bm.header.viewProfile.linkedAccounts\"></span>\n" +
    "              <i class=\"bento-icon-warning bm-multi-tab-unsaved-changes\" title=\"{{vm.translatedUnsaved}}\" aria-hidden=\"true\" ng-if=\"vm.sharedProfile.hasUnsavedLinkedAccounts\"></i>\n" +
    "            </div>\n" +
    "        </uib-tab-heading>\n" +
    "        <bm-linked-accounts user=\"vm.user\" shared-data=\"vm.sharedProfile\"></bm-linked-accounts>\n" +
    "      </uib-tab>\n" +
    "      <!-- multifactor authentication -->\n" +
    "      <uib-tab bm-if-has-access=\"Platform_DisableAuth0Phase2\" data-qe-id=\"bm-profile-mfa-tab\" deselect=\"vm.tabDeselect('multi')\" bm-if-has-access=\"Platform_Enable2FA\">\n" +
    "        <uib-tab-heading>\n" +
    "          <span translate=\"bm.header.viewProfile.multifactorTitle\"></span>\n" +
    "        </uib-tab-heading>\n" +
    "        <bm-multifactor-profile user-data=\"vm.user\"></bm-multifactor-profile>\n" +
    "      </uib-tab>\n" +
    "      <!-- checkpoint engage credentials -->\n" +
    "      <uib-tab bm-if-perm=\"Applications.CheckpointEngage\" data-qe-id=\"bm-profile-ce-creds-tab\" deselect=\"vm.tabDeselect('checkpoint')\">\n" +
    "        <uib-tab-heading>\n" +
    "          <div class=\"bm-multi-tab-heading bm-multi-tab-center\">\n" +
    "            <span translate=\"bm.header.viewProfile.checkPointCredentials\"></span><i class=\"bento-icon-warning bm-unsaved-changes\" title=\"{{vm.translatedUnsaved}}\" aria-hidden=\"true\" ng-if=\"vm.sharedProfile.hasUnsavedCheckpoint\"></i>\n" +
    "          </div>\n" +
    "        </uib-tab-heading>\n" +
    "        <bm-checkpoint-credentials shared-data=\"vm.sharedProfile\"></bm-checkpoint-credentials>\n" +
    "      </uib-tab>\n" +
    "    </uib-tabset>\n" +
    "  </div>\n" +
    "</div>\n" +
    "");
}]);

/**
 * Blue Moon Components - App Directive
 */

// Global bluemoon-components-app
var bmcomponents;

(function(angular){
    'use strict';

    bmcomponents = angular.module('bluemoon.components.app', [
        'matchmedia-ng',
        'bluemoon.components.session',
        'bmUser'
    ])
        // PROD perf boost (missing fn in 1.2.25)
        // .config(['$compileProvider', function ($compileProvider) {
        //     var isNotProd = !/^onvio/.test(location.hostname);
        //     $compileProvider.debugInfoEnabled(isNotProd);
        // }])
        .directive('bmApp', bmApp);

    // guid used for replace in build process
    bmcomponents.version = '32.3.1';

    bmApp.$inject = ['$document', '$log', 'matchmedia', 'AuthenticatedSession', 'bmUser'];

    function bmApp($document, $log, matchmedia, authenticatedSession, bmUser) {

        return {
            restrict: 'EA',
            controller: [function() {}],
            link: function (scope, element, attrs) {
                var html = $document.find('html');

                if (attrs.bmApp !== 'pre-auth') {
                    /* load intrinsic post-auth objects */
                    authenticatedSession.load().then(function(data) {
                        $log.log('session:', { meta: data.meta, bindings: data.bindings });
                    }).finally(function() {
                        html.addClass('bm-resolved');
                    });
                    bmUser.load();
                }

                /* Mobile first cumulative media classes */

                /* Large devices (large desktops, 1200px and up) */
                var offMatchLg = matchmedia.on('(min-width: 1200px)', function(mql){
                    html.toggleClass('media-screen-lg-min', mql.matches);
                });
                /* Medium devices (desktops, 992px and up) */
                var offMatchMd = matchmedia.on('(min-width: 992px)', function(mql){
                    html.toggleClass('media-screen-md-min', mql.matches);
                });
                /* Small devices (tablets, 768px and up) */
                var offMatchSm = matchmedia.on('(min-width: 768px)', function(mql){
                    html.toggleClass('media-screen-sm-min', mql.matches);
                });
                /* XSmall default (phones, 0px and up) */
                var offMatchXs = matchmedia.on('(min-width: 0px)', function(mql){
                    html.toggleClass('media-screen-xs-min', mql.matches);
                });

                // cleanup
                element.on('$destroy', function () {
                    offMatchXs();
                    offMatchSm();
                    offMatchMd();
                    offMatchLg();
                });
            }
        };
    }

})(window.angular);

/**
 * Blue Moon Components - Header Directive
 */
(function(angular){
    'use strict';

    function bmHeader($window, $document, $rootScope, bmUtil, authenticatedSessionData) {

        return {
            restrict: 'EA',
            templateUrl: 'components/header/header.2js.html',
            scope: {
                notStaffClient: '<?'
            },
            transclude: {
                'profile': '?bmHeaderProfile',
                'icon': '?bmHeaderIcon',
            },
            require: '^bmApp',
            controller: bmHeaderCtrl,
            controllerAs: 'header',

            link: function (scope, element, attrs) {
                var html = angular.element($document[0].documentElement);
                var appLinkList = element[0].querySelector('#bm-header-app-menu ul');
                var appMenu = element[0].querySelector('#bm-header-app-menu');
                var profileMenu = element[0].querySelector('#bm-header-profile-menu');

                if (angular.isDefined(attrs.hidemenus)) {
                    scope.header.hideMenus = true;
                }

                // get app menu links after they render,
                // and disable the link that is the current app
                authenticatedSessionData.getBindings().then(function () {
                    setTimeout(function () {
                        var appLinks = appLinkList.querySelectorAll('a');
                        [].forEach.call(appLinks, function(link) {
                            if (link.href && location.href.indexOf(link.href) === 0) {
                                //jshint scripturl:true
                                link.href = 'javascript:void(0)';
                                link.target = '';
                                link.classList.add('selected');
                                return false;
                            }
                        });
                    }, 0);
                });

                scope.header.toggleLeftMenuMaskActive = function(force) {
                    scope.header.closeDropDowns();
                    html.toggleClass('left-menu-mask-active', force);
                };

                scope.header.toggleRightMenuMaskActive = function(force) {
                    scope.header.closeDropDowns();
                    html.toggleClass('right-menu-mask-active', force);
                };

                function windowResized() {
                    var applyNeeded = false;

                    if (scope.header.isAppsDropdownOpen ||
                        scope.header.isMsgsDropdownOpen ||
                        scope.header.isHelpDropdownOpen ||
                        scope.header.isTimerDropdownOpen ||
                        scope.header.isUserDropdownOpen ||
                        scope.header.isLinkedAccountsDropdownOpen) {

                        scope.header.closeDropDowns();
                        applyNeeded = true;
                    }

                    if (applyNeeded) {
                        scope.$apply();
                    }
                }

                // perform window resize actions
                $window.addEventListener('resize', windowResized, false);

                var offLocationChangeStart = $rootScope.$on('$locationChangeStart', bmUtil.debounce(scope.header.clearMenuActive, 500));

                var offLocationChangeSuccess = $rootScope.$on('$locationChangeSuccess', bmUtil.debounce(scope.header.updateCustomizedLinks, 500));

                var offLoadSuccess = $rootScope.$on('$viewContentLoaded', bmUtil.debounce(scope.header.updateCustomizedLinks, 500));

                // listeners
                var rmProfPhotoSelectedEvtListener = scope.$on('bmProfilePhotoSelected', scope.header.user.save);

                // authenticatedSessionData.getBindings().then(function(data) {
                //     theme.loadHeader(data.ApplicationConfiguration.CompanyId);
                // });

                // to remove menus from DOM for assistive technologies not to list them
                // and exclude them from page focus flow when menus are closed
                scope.header.updateDisplayState([appMenu, profileMenu], false)();
                var offMenuOpen = $rootScope.$on('bmAppMenuOpened', scope.header.updateDisplayState([appMenu], true));
                var offProfileMenuOpen = $rootScope.$on('bmProfileMenuOpened', scope.header.updateDisplayState([profileMenu], true));
                var offMenuClose = $rootScope.$on('bmAppClosedDropdowns', scope.header.updateDisplayState([appMenu, profileMenu], false));

                // cleanup
                element.on('$destroy', function () {
                    $window.removeEventListener('resize', windowResized, false);
                    offLocationChangeStart();
                    offLocationChangeSuccess();
                    offLoadSuccess();
                    rmProfPhotoSelectedEvtListener();
                    offMenuOpen();
                    offProfileMenuOpen();
                    offMenuClose();
                });
            }
        };
    }

    function bmHeaderCtrl(
        $window,
        $log,
        $rootScope,
        $q,
        $timeout,
        $uibModal,
        $location,
        $translate,
        $scope,
        authenticatedSession,
        bmUser,
        theme,
        myAccountService,
        bmAccess,
        bmPermission,
        bmLicense,
        bmModal,
        bmJobQueue,
        notificationsManager,
        bmTokenStorage,
        bmAnalyticsService,
        csScheduleItemViewV3Standalone,
        LinkedAccountsService,
        dmsClientService,
        $injector,
        $document,
        $http,
        bmMultifactorService,
        bmEnvironmentConst,
        bmEnvironment,
        bmUtil
    )
    {
        var self = this; // jshint ignore:line
        self.session = authenticatedSession.data;
        self.user = bmUser;
        self.theme = theme.data;
        self.hasStaffApp = false;
        self.hasClientApp = false;
        self.appMenuActive = false;
        self.profileMenuActive = false;
        self.totalUnreadCount = 0;
        self.unreadNotificationsCount = -1;
        self.unreadMessagesCount = -1;
        self.showBRMessenger = false;
        self.onvioMessengerUnreadNotificationsCount = -1;
        self.wsocketGestta = undefined;
        self.hasClientDashboard = false;
        self.clientSpecificUrl = '';
        self.clientSpecificTitle = '';
        self.notStaffClient = undefined;
        self.hasPrefs = false;
        self.isHelpDropdownOpen = false;
        // needed for linked accounts
        self.linkedAccounts = [];
        self.selectedLinkedAccount = undefined;

        self.showLinkedAccountsMenu = false;
        self.linkedAccountFound = false;
        self.sharedProfile = {};
        self.isLoaderBusy = false;
        self.hasCCVNextIAC = false;
        self.hasMessengerIAC = false;
        self.hasNewPortalDoClienteIAC = false;
        self.allClientsNewPortalDoClienteIAC = false;
        self.hasCCVNextFRP = false;
        self.hasNewPortalDoClienteFRP = false;
        self.hasNewDesignIAC = false;
        self.hasAccountSwitchingIAC = false;
        self.isUsCountryCode = $injector.get('bmEnvironment').isUsCountryCode();
        self.isUkCountryCode = $injector.get('bmEnvironment').isUkCountryCode();
        self.isArCountryCode = $injector.get('bmEnvironment').isArCountryCode();
        self.pendoGuidanceHubDataQeId = 'pendo-resource-center-icon-';
        self.mfaQeId = '';
        self.newNotificationIconQeId = 'new-notification-';
        if(self.isUsCountryCode){
            self.isEligibleForPendoGuidanceHub = $window.location.pathname.startsWith('/staff') || $window.location.pathname.startsWith('/ustax') || $window.location.pathname.startsWith('/trialbalance') ;
        } else if(self.isUkCountryCode){
            self.isEligibleForPendoGuidanceHub = $window.location.pathname.startsWith('/accounts');
        } else if(self.isArCountryCode){
            self.isEligibleForPendoGuidanceHub = true;
        } else {
            self.isEligibleForPendoGuidanceHub = false;
        }
        self.enableNewNotificationPanelIAC = null;
        setGuidanceHubDataQedValue();
        var linkedAccountSessionToken;
        var userJwt;
        // optional dependency on $state for user-preferences
        var $state = $injector.has('$state') ? $injector.get('$state') : null;

        bmAccess.has('ClientCenterVnext').then(function() {
            self.hasCCVNextIAC = true;
        }).catch(function() {
            self.hasCCVNextIAC = false;
        });

        bmAccess.has('Platform_NewNotificationPanel').then(function() {
            self.enableNewNotificationPanelIAC = true;
        }).catch(function () {
            self.enableNewNotificationPanelIAC = false;
        });

        bmAccess.has('BR_ShowOnvioMessenger').then(function() {
            self.hasMessengerIAC = true;
        }).catch(function() {
            self.hasMessengerIAC = false;
        });

        bmAccess.has('BR_ShowPortalDoClienteAllClients').then(function() {
			self.allClientsNewPortalDoClienteIAC = true;
		}).catch(function() {
			self.allClientsNewPortalDoClienteIAC = false;
		});

        bmAccess.has('BR_ShowPortalDoCliente').then(function() {
			self.hasNewPortalDoClienteIAC = true;
		}).catch(function() {
			self.hasNewPortalDoClienteIAC = false;
		});

        bmAccess.has('Platform_NewProfilePanel').then(function() {
            self.hasNewDesignIAC = true;
        }).catch(function() {
            self.hasNewDesignIAC = false;
        });

        bmAccess.has('PPE-AccountSwitching').then(function() {
            self.hasAccountSwitchingIAC = true;
        }).catch(function() {
            self.hasAccountSwitchingIAC = false;
        });

        bmPermission.has('Platform.ccVnext').then(function() {
            self.hasCCVNextFRP = true;
        }).catch(function() {
            self.hasCCVNextFRP = false;
        });

        bmPermission.has('OnvioBR.BR_PortalDoCliente').then(function() {
            self.hasNewPortalDoClienteFRP = true;
        }).catch(function() {
            self.hasNewPortalDoClienteFRP = false;
        });

        self.hasApps = function() {
            var frp = authenticatedSession.data.bindings.FeatureResourcePermissions;
            return frp ? Object.keys(frp.FeatureResourcePermissionsMap.Applications).length > 1 : false;
        };
        self.clearMenuActive = function() {
            self.clearAppMenuActive();
            self.clearProfileMenuActive();
        };
        self.clearAppMenuActive = function() {
            if (self.appMenuActive) {
                self.appMenuActive = false;
                self.toggleLeftMenuMaskActive(self.appMenuActive);
                bmAnalyticsService.track('Header App Menu Closed', { label: 'closeAppList' });
            }
        };
        self.clearProfileMenuActive = function() {
            if (self.profileMenuActive) {
                self.profileMenuActive = false;
                self.toggleRightMenuMaskActive(self.profileMenuActive);
                $rootScope.$broadcast('bmProfileMenuClosed');
            }
        };
        self.toggleAppMenuActive = function() {
            $timeout(function() {
                self.appMenuActive = !self.appMenuActive;
                self.toggleLeftMenuMaskActive(self.appMenuActive);

                if(self.appMenuActive){
                    $rootScope.$broadcast('bmAppMenuOpened');
                    bmAnalyticsService.track('Header App Menu Opened', { label: 'openAppList' });
                }
            });

            var interval = setInterval(function() {
                var closeBtn = document.getElementById('bm-header-menu-close-btn');
                if (closeBtn) {
                    closeBtn.focus();
                    clearInterval(interval);
                }
            }, 250);
        };
        self.toggleProfileMenuActive = function() {
            self.profileMenuActive = !self.profileMenuActive;
            self.toggleRightMenuMaskActive(self.profileMenuActive);

            if(self.profileMenuActive){
                $rootScope.$broadcast('bmProfileMenuOpened');
            }
        };
        self.closeDropDowns = function() {
            self.isAppsDropdownOpen = false;
            self.isMsgsDropdownOpen = false;
            self.isHelpDropdownOpen = false;
            self.isTimerDropdownOpen = false;
            self.isUserDropdownOpen = false;
            self.isLinkedAccountsDropdownOpen = false;

            $rootScope.$broadcast('bmAppClosedDropdowns');
        };

        self.updateDisplayState = function(els, state) {
            return function () {
                var defaultValue = ''; // value (e.g flex) that specified in css before update of display state
                var value = state ? defaultValue : 'none';
                els.forEach(function (el) {
                    if (el) {
                        // timeout to compensate css trnsition delay
                        $timeout(function() { el.style.display = value; }, 100);
                    }
                });
            };
        };

        $scope.$on('update-top-nav-buttons', function(event, opt) {
            if(opt.clientId) {
                var clientId = opt.clientId;
                self.updateCustomizedLinks(clientId);
            }
        });

        self.updateCustomizedLinks = function(clientId) {
            self.updateCustomizedProjectLinks();
            self.updateCustomizedDocumentsLink(clientId);
            self.updateCustomizedClientDashboardLink(clientId);
        };
        self.updateCustomizedProjectLinks = function() {
            var currentUrl = $location.path();

            //start by assuming this isn't customized
            self.clientSpecificUrl = '';
            self.clientSpecificTitle = '';

            // inspect the new url for /projects/UUID
            // if we find it, load the project and update client dashboard link
            if(currentUrl.indexOf('/projects/') > -1) {
                // get everything after that and check for a UUID
                var substring = currentUrl.substring(currentUrl.indexOf('/projects/') + 10);
                if(substring.length > 32) {
                    substring = substring.substring(0, 32);
                }
                if(substring.match(/\w{32}/)) {
                    // assuming we didn't find anything that isn't a word character, try loading the project
                    csScheduleItemViewV3Standalone.get({'scheduleItemId': substring, expand: 'clientView.name,clientView.id'}).then(function(scheduleItems) {
                        var scheduleItem = scheduleItems && scheduleItems.data && scheduleItems.data.items && scheduleItems.data.items[0];
                        if(scheduleItem && scheduleItem.clientView && scheduleItem.clientView.id && scheduleItem.clientView.name) {
                            self.clientSpecificUrl = '/' + scheduleItem.clientView.id;
                            self.clientSpecificTitle = ': ' + scheduleItem.clientView.name;
                        }
                    });
                }
            }
        };

        self.updateCustomizedDocumentsLink = function(clientId) {
            //start by assuming this isn't customized
            self.clientSpecificUrl = '';
            self.clientSpecificTitle = '';
            if(clientId && clientId.length === 32 && clientId.match(/\w{32}/)) {
                setClientData(clientId);
            } else {
                if(self.notStaffClient && self.notStaffClient.isNotStaffApplication && self.notStaffClient.clientId !== '') {
                    setClientData(self.notStaffClient.clientId);
                    return;
                }
                // find case insensitive /client/
                var currentUrl = $location.path().toLowerCase();
                if(currentUrl.indexOf('/clients/') > -1) {
                    // for tree nav not enabled
                    setClientSpecificUrlAndTitle(currentUrl, '/clients/');
                } else if(currentUrl.indexOf('/client/') > -1) {
                    // for tree nav enabled
                    setClientSpecificUrlAndTitle(currentUrl, '/client/');
                }
            }
        };

        function setClientSpecificUrlAndTitle(currentUrl, clientString) {
            var offsetLength = clientString.length;
            var substring = currentUrl.substring(currentUrl.indexOf(clientString) + offsetLength);
            if (substring.length >= 32) {
                // revert clientId back to upper case
                substring = substring.substring(0, 32).toUpperCase();
                if (substring.match(/\w{32}/)) {
                    dmsClientService.getCached(substring).then(function (result) {
                        if (result && result.data && result.data.name && result.data.id) {
                            self.clientSpecificUrl = '/' + result.data.id;
                            self.clientSpecificTitle = ': ' + result.data.name;
                        }
                    });
                }
            }
        }

        self.updateCustomizedClientDashboardLink = function(clientId) {
            //start by assuming this isn't customized
            self.clientSpecificUrl = '';
            self.clientSpecificTitle = '';
            if(clientId && clientId.length === 32 && clientId.match(/\w{32}/)) {
                setClientData(clientId);
            } else {
                if(self.notStaffClient && self.notStaffClient.isNotStaffApplication && self.notStaffClient.clientId !== '') {
                    setClientData(self.notStaffClient.clientId);
                    return;
                }
                var currentUrl = $location.url();
        // inspect the new url for /projects/UUID
        // if we find it, load the project and update client dashboard link
                if(currentUrl.indexOf('/client-dashboard') > -1) {
        // get everything after that and check for a UUID
                   var startIndexOfClientIdQueryParameter = 18;
                   var lengthOfClientId = 32;
                   var startIndexOfClientId = 9;
                   var lastIndexOfClientIdQueryParameter = 41;
                   var substring = currentUrl.substring(currentUrl.indexOf('/client-dashboard') + startIndexOfClientIdQueryParameter);
                        if(substring.length >= lengthOfClientId) {
                                     substring = substring.substring(startIndexOfClientId, lastIndexOfClientIdQueryParameter);
                         if(substring.match(/\w{32}/)) {
                    // assuming we didn't find anything that isn't a word character, try loading the project
                             setClientData(substring);
                }
            }
        }
    }
};

        function setClientData(clientId) {
            dmsClientService.getCached(clientId).then(function(result) {
                if(result && result.data && result.data.name && result.data.id) {
                    self.clientSpecificUrl = '/' + result.data.id;
                    self.clientSpecificTitle = ': ' + result.data.name;
                }
            });
        }

        var jwt; // cache jwt
        self.sso = function($event) {
            var link = $event.currentTarget;
            var href = link.href;
            var tokenType = 'UDSLongToken';
            var token = bmTokenStorage.get();
            if (!jwt) { // lazy jwt
                // get jwt given a UDSLongToken
                // make it synchronous ($http can't do sync) so we avoid window.open and popup blockers
                // not great, but the deprecation warning is a bluff
                var xhr = new $window.XMLHttpRequest();
                xhr.open('POST', '/api/security/v1/jwt/sessions', false); // false = synchronous
                xhr.setRequestHeader('Authorization', tokenType + ' ' + token);
                xhr.onreadystatechange = function() {
                    if (xhr.readyState !== 4 || xhr.status !== 201) { return; }
                    jwt = JSON.parse(xhr.responseText).token;
                };
                xhr.send();
                $log.info('Sorry, while we are aware that synchronous XHR is generally bad, in this case it is intentional.');
            }
            if (!jwt) { return; }
            link.href = href + (/\?/.test(href) ? '&' : '?') + 'token=' + jwt;
            // don't leave jwt laying around
            setTimeout(function() { link.href = href; }, 0);
        };

        self.getUserJwt = function() {
            var dfd = $q.defer();
            if (userJwt) {
                // Get cached user jwt
                dfd.resolve(userJwt);
            } else {
                // Request user jwt
                bmMultifactorService.getUserJwtToken(self.contactId).then(function (response) {
                    userJwt = response.data.token;
                    dfd.resolve(userJwt);
                });
            }
            return dfd.promise;
        };

        self.launchApp = function($event) {
            var link = $event.currentTarget;
            var href = link.href;

            bmAnalyticsService.track('External App Launched', {
                app: $event.currentTarget.parentElement.getAttribute('bm-if-perm'),
                url: href,
                label: 'appLaunch'
            });

            self.clearAppMenuActive();
        };
        self.launchK1Analyzer = function() {
            self.isLoaderBusy = true;
            // Get user's jwt token
            self.getUserJwt().then(function (jwt) {
                // Check if user is authorized in K1
                $http({
                    method: 'POST',
                    bmNoAuth: true,
                    url: '/api/auth/v1/external-login/k1-analyzer',
                    headers: { Authorization: 'Bearer ' + jwt },
                    data: {'emsFirmId': self.emsFirmId}
                }).then(function(response){
                    // Retrieve launch url
                    var link = response.headers('Location');
                    // Launch K1 analyzer app in new tab
                    self.isLoaderBusy = false;
                    self.clearAppMenuActive();
                    var win = window.open(link, '_blank');
                    win.focus();
                }, function() {
                    self.isLoaderBusy = false;
                    self.clearAppMenuActive();
                });
            });
        };

        self.launchUltraTaxEfileUrl = function() {
            var ultrataxEfileUrl = 'https://www.ultratax.com/#e-file';
            window.open(ultrataxEfileUrl, '_blank');
        };

        self.showUnauthorizedModal = function () {
            bmModal.modal({
                templateUrl: 'components/modal/modal-default.2js.html',
                showClose: false,
                vars: {
                    body: $translate.instant('bm.header.previewTrial.previewMode.UnauthorizedBody'),
                    title: $translate.instant('bm.header.previewTrial.previewMode.UnauthorizedTitle')
                },
                buttons: [
                    { text: $translate.instant('bm.header.previewTrial.previewMode.OKButton'), value: 1, primary: true }
                ]
            });
        };
        self.showUserPreferences = function () {
            bmPermission.has('Platform.PreviewMode')
                .then(function () {
                    self.showUnauthorizedModal();
                }).catch(function () {
                    $state.go('user-preferences');
                });
        };

        self.openProfileModal = function () {
            bmPermission.has('Platform.PreviewMode')
                .then(function () {
                    self.showUnauthorizedModal();
                }).catch(function () {
                    self.openViewProfileDialog();
                });
        };
        self.openViewProfileDialog = function(){
            // if profileevent attribute is specified, fire event, clear menu, return
            if($scope.profileEvent && $document[0].body) {
                $document[0].body.dispatchEvent(new Event('bm-profile-launched'));
                self.clearProfileMenuActive();
                return;
            }
            var modalOptions = {
                templateUrl: 'user-profile/view-profile-modal.2js.html',
                controller: 'bmViewProfileCtrl as vm',
                backdrop: 'static',
                windowClass: 'bm-custom-profile-modal',
                size: 'lg',
                resolve: {
                    languages: function(){
                        return [];
                    },
                    user: function(){
                        return undefined;
                    }
                }
            };

            self.clearProfileMenuActive();

            modalOptions.resolve = {
                languages: function(){
                    return myAccountService.getLanguageListAsync();
                },
                user: function(){
                    return myAccountService.getMyUserSettingsAsync().then(function(resp){
                        return resp.data;
                    });
                }
            };

            openModalWithOptions(modalOptions);
        };
        self.signOutTRAccount = function () {
            getLogoutUrl().then(function(logoutUrl){
                authenticatedSession.destroy(logoutUrl);
              }, function(){
                  authenticatedSession.destroy();
              });
        };
        self.signOut = function() {
          // Identify the environment
          bmAccess.has('Platform_DisableAuth0Phase2').then(function () {
            self.clearProfileMenuActive();
            self.closeDropDowns();
            // If Auth0 is disable just sign out
            self.signOutTRAccount();
          }).catch(function () {
            // Auth0 is enabled
            self.closeDropDowns();
            // For development purposes we choose the /login url
            var url = $window.location.origin;
            var redirectURL =
                (bmEnvironmentConst.isLocalType ?
                url + '/login'
                :url + '/#/logout');
            var domain = url.match(/^https?\:\/\/([^\/?#]+)(?:[\/?#]|$)/i)[1].split('onvio')[1];
            var auth0ClientIdLogout = bmEnvironmentConst.auth0ClientId;
            // If it is CA and have fr-CA we use the region locale Auth0 client ID
            if (domain === '.ca' && bmUtil.cookie('BMLanguageCode') === 'fr-CA') {
                auth0ClientIdLogout = bmEnvironmentConst.auth0RegionLocaleClientId;
            }
            var logoutUrl =
                'https://' + bmEnvironmentConst.auth0Domain +
                '/v2/logout?client_id=' + auth0ClientIdLogout +
                '&returnTo=' + redirectURL;
            authenticatedSession.destroyAuth0(logoutUrl);
          });
        };

        function openModalWithOptions(modalOptions){
            self.closeDropDowns();
            var instance = $uibModal.open(modalOptions);
            return instance;
        }

        function getLogoutUrl(){
            var themeParams;

            if(self.companyId){
                themeParams = { company: self.companyId };
            }

            return theme.load(themeParams).then(function(){
                if(theme.data && theme.data.header && theme.data.header.logoutUrl){
                    return theme.data.header.logoutUrl;
                }
            });
        }

        function setGuidanceHubDataQedValue() {
            if(self.isArCountryCode) {
                self.pendoGuidanceHubDataQeId += 'onvio-center-ar';
            } else if($window.location.pathname.startsWith('/trialbalance')) {
                self.pendoGuidanceHubDataQeId += 'trialbalance';
            } else if($window.location.pathname.startsWith('/accounts')) {
                self.pendoGuidanceHubDataQeId += 'accounts';
            } else {
                self.pendoGuidanceHubDataQeId += 'onvio-center';
            }

            var isMFAEnabled = bmUtil.cookie('mfa_enrolled') === 'true';
            self.mfaQeId = 'onvio-mfa-' + (isMFAEnabled ? 'enabled' : 'disabled');
        }

        function getUnreadCountJob(){
            // returns the job id
            return bmJobQueue.push(function(done){
                notificationsManager.getUnreadNotificationCounts().then(function(data){
                    updateNotificationsCount(data);

                    // job is done running
                    done();
                }, function(){
                    updateNotificationsCount();

                    // job is done running
                    done();
                });
            }, 240000, '** Notifications Refreshed **'); // refresh every 4 minutes
        }

        function updateNotificationsCount(data){
            if(angular.isUndefined(data)){
                self.totalUnreadCount = 0;
                self.unreadNotificationsCount = 0;
                self.unreadMessagesCount = 0;
            } else {
                self.unreadNotificationsCount = data.notifications || 0;
                self.unreadMessagesCount = data.messages || 0;
                self.totalUnreadCount = self.unreadNotificationsCount + self.unreadMessagesCount;
            }
        }

        $scope.$on('bmUpdateCompanyStaffServices', function(event, args) {
            if (args.firmName) {
                setupLinkedAccounts(args.firmName);
            }
        });

        /* Start Linked Accounts Functions */
        function setupLinkedAccounts(broadcastFirmName) {
            var pos = 0;
            var posFound = -1;

            for(pos = 0; pos < self.linkedAccounts.length; pos++) {
                //nickname
                if(!self.linkedAccounts[pos].displayedNickname || self.linkedAccounts[pos].displayedNickname === '') {
                    self.linkedAccounts[pos].displayedNickname = '';
                    self.linkedAccounts[pos].displayedName = self.linkedAccounts[pos].accountName;
                } else {
                    self.linkedAccounts[pos].displayedName = self.linkedAccounts[pos].displayedNickname;
                }
            }

            // setup view
            if(self.linkedAccounts.length > 1) {
                for(pos = 0; pos < self.linkedAccounts.length; pos++) {
                    if(self.linkedAccounts[pos].contactId === self.contactId) {
                        self.linkedAccountFound = true;
                        self.selectedLinkedAccount = self.linkedAccounts[pos];
                        posFound = pos;
                        pos = self.linkedAccounts.length;
                    }
                }
                // remove the account that were logged into
                if(posFound >= 0) {
                    self.linkedAccounts.splice(posFound, 1);
                }

                // if accounts still exist, display menu
                if(self.linkedAccounts.length > 0) {
                    self.showLinkedAccountsMenu = true;
                }
            } else {
                self.selectedLinkedAccount = self.linkedAccounts[0];
                self.showLinkedAccountsMenu = false;
                self.linkedAccountFound = true;
            }
            if (broadcastFirmName) {
                self.selectedLinkedAccount.companyName = broadcastFirmName;
            }
        }

        self.switchAccount = function(linkedAccountId) {
            $scope.$emit('bm-busy-loading-on');

            LinkedAccountsService.createLinkedAccountSession(linkedAccountId).then(function(response){
                if (response.data.RedirectingDomain) {
                    // redirect the window to the new domain with the sso token
                    var ssoUrl = response.data.RedirectingDomain;
                    var routingPath = response.data.RoutingPath;
                    if (routingPath) {
                      // remove the first '/' if it exists
                      var subPath = (routingPath.startsWith('/') && ssoUrl.endsWith('/')) ? routingPath.substring(1) : routingPath;
                      ssoUrl = ssoUrl + subPath;
                    }
                    if (ssoUrl.indexOf('#') < 0) {
                       // add '#' if it does not exist
                       ssoUrl = ssoUrl + '#/';
                    }
                    ssoUrl = ssoUrl + '?token=' + response.data.SsoTokenId;
                    $window.location.href = ssoUrl;
                } else {
                    // load the new session on the same domain
                    linkedAccountSessionToken = response.data.LongToken;
                    authenticatedSession.switchAccountWithLongToken(linkedAccountSessionToken);
                }
                $scope.$emit('bm-busy-loading-off');
            }).catch(function(error){
                console.log(error);
                $scope.$emit('bm-busy-loading-off');
            });
        };

        self.openManageLinkedAccountsDialog = function() {
            $log.info('Go manage the accounts');

            var modalOptions = {
                templateUrl: 'components/linked-accounts/linked-accounts-dialog.2js.html',
                controller: 'LinkedAccountsDialogCtrl as vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    user: function(){
                        return undefined;
                    },
                    sharedProfile: function(){
                        return {};
                    }
                }
            };

            modalOptions.resolve = {
                user: function(){
                    return self.user;
                },
                sharedProfile: function(){
                    return self.sharedProfile;
                }
            };

            openModalWithOptions(modalOptions);
        };
        /* End Linked Accounts Functions */

        self.openOnvioMessenger = function() {
            bmEnvironment.getRoute('OnvioBRMessenger').then(function(url){
                var jwt;
                var tokenType = 'UDSLongToken';
                var token = bmTokenStorage.get();
                if (!jwt) { // lazy jwt
                    // get jwt given a UDSLongToken
                    // make it synchronous ($http can't do sync) so we avoid window.open and popup blockers
                    // not great, but the deprecation warning is a bluff
                    var xhr = new $window.XMLHttpRequest();
                    xhr.open('POST', '/api/security/v1/jwt/sessions', false); // false = synchronous
                    xhr.setRequestHeader('Authorization', tokenType + ' ' + token);
                    xhr.onreadystatechange = function() {
                        if (xhr.readyState !== 4 || xhr.status !== 201) { return; }
                        jwt = JSON.parse(xhr.responseText).token;
                    };
                    xhr.send();
                    $log.info('Sorry, while we are aware that synchronous XHR is generally bad, in this case it is intentional.');
                }
                if (!jwt) { return; }
                url = url + (/\?/.test(url) ? '&' : '?') + 'token=' + jwt;
                // don't leave jwt laying around
                setTimeout(function() { $window.open(url, '_blank'); }, 0);
            });
        };

        self.getOnvioMessengerUnreadNotifications = function () {
            bmEnvironment.getRoute('GesttaWebSocket').then(function(url){
                var token = bmTokenStorage.get();
                $http({
                    method: 'POST',
                    url: '/api/br-messenger/v1/socket',
                    data: {},
                    headers: { Authorization: 'UDSLongToken' + token }
                }).then(function(gesttaToken){
                    var substractedToken = gesttaToken.data.token.split(' ')[1];
                    url = url + (/\?/.test(url) ? '&' : '?') + 'token=' + substractedToken;
                    try {
                        self.wsocketGestta = new WebSocket(url);
                        self.wsocketGestta.addEventListener('message', function(event) {
                            var responseObject = JSON.parse(event.data);
                            var contactId = self.contactId;
                            var notifCount = responseObject.data.metadata[contactId];
                            if (notifCount && typeof notifCount === 'number') {
                                self.onvioMessengerUnreadNotificationsCount = responseObject.data.metadata[contactId];
                            } else {
                                self.onvioMessengerUnreadNotificationsCount = 0;
                            }
                            $scope.$apply();
                        });
                    } catch(_e) {}
                }).catch(function(){
                    self.onvioMessengerUnreadNotificationsCount = 0;
                });
            });
        };

        function init(){
            self.closeDropDowns();

            if($scope.notStaffClient){
                self.notStaffClient = $scope.notStaffClient;
            }

            if(authenticatedSession.data){
                authenticatedSession.data.getBindings().then(function(data){
                    self.companyId = data.ApplicationConfiguration.CompanyId;
                    self.emsFirmId = data.ApplicationConfiguration.EmsFirmId;

                    // linked accounts
                    self.contactId = data.ApplicationConfiguration.ContactId;
                    LinkedAccountsService.getActiveOnvioLinkedAccounts().then(function(response){
                        self.linkedAccounts = response.data;
                        setupLinkedAccounts();
                    }).catch(function(error){
                        console.log(error);
                        self.linkedAccounts = [];
                        self.linkedAccountFound = false;
                    });

                });

                var notificationCountFetchJobIdWatch = $scope.$watch(function() { return self.enableNewNotificationPanelIAC; }, function(newValue) {
                    if(newValue === false) {
                        // start up the job for getting unread count
                        var jid = getUnreadCountJob();

                        bmJobQueue.start(jid); // enabled specified job

                        // kill the job when profile menu is open
                        $rootScope.$on('bmProfileMenuOpened', function(){
                            bmJobQueue.stop(jid);
                            bmJobQueue.remove(jid);

                            // get the most up-to-date counts so lists in tabs match header
                            notificationsManager.getUnreadNotificationCounts().then(function(data){
                                updateNotificationsCount(data);
                            });
                        });

                        // create new job and start is up so count is immediately refreshed
                        $rootScope.$on('bmProfileMenuClosed', function(){
                            jid = getUnreadCountJob();
                            bmJobQueue.start(jid);
                        });
                        notificationCountFetchJobIdWatch();
                    }
                });

                // update count when an item is read
                $rootScope.$on('bmNotificationMarkedAsRead', function(event, args){
                    if(angular.isDefined(args) && args.all === true){
                        self.unreadNotificationsCount = 0;
                    } else if(self.unreadNotificationsCount > 0){
                        self.unreadNotificationsCount -= 1;
                    }

                    self.totalUnreadCount = self.unreadNotificationsCount + self.unreadMessagesCount;
                });

                // update count when an item is read
                $rootScope.$on('bmMessagesMarkedAsRead', function(event, args){
                    if(angular.isDefined(args) && args.all === true){
                        self.unreadMessagesCount = 0;
                    } else if(self.unreadMessagesCount > 0){
                        self.unreadMessagesCount -= 1;
                    }

                    self.totalUnreadCount = self.unreadNotificationsCount + self.unreadMessagesCount;
                });

                // close nav menus when a bound html link is selected
                $rootScope.$on('bmNotificationHtmlClick', function(){
                    self.clearMenuActive();
                });
            }

            bmPermission.has('Applications.Onvio').then(function(){
                self.hasStaffApp = true;
            }).catch(angular.noop);

            bmPermission.has('Applications.OnvioClientHub').then(function(){
                self.hasClientApp = true;
            }).catch(angular.noop);

            try {
                angular.module('bm.userPreferences');
                $injector.get('userPreferencesService')
                    .hasPreferences()
                    .then(function(hasPrefs) {self.hasPrefs = hasPrefs;})
                    .catch(function() {self.hasPrefs = false;});
            } catch(e) {
                self.hasPrefs = false;
            }

            // must have IAC and FR
            // not available to users with documents basic
            bmAccess.has('Client_Dashboard').then(function(){
                return bmLicense.has('Onvio.ClientDashboard').then(function(){
                    return bmPermission.has('Onvio.ClientDashboard').then(function(){
                        return bmLicense.not('Applications.OnvioDocumentsBasic').then(function(){
                            return bmPermission.not('GFR.ClientFlow').then(function(){
                                self.hasClientDashboard = true;
                            });
                        });
                    });
                });
            }).catch(function() {
                self.hasClientDashboard = false;
                bmAnalyticsService.track('bmHeader: bmAccess.has(\'Client_Dashboard\') failed');
            });

            bmEnvironment.getEnvironmentAsync().then(function(env) {
                if (env.countryCode === 'AR') {
                    bmPermission.has(['Applications.BRChat'], true)
                        .then(function(hasPerm) {
                            self.showBRMessenger = hasPerm;
                            self.getOnvioMessengerUnreadNotifications();
                        });
                }
            });

            $rootScope.$on('$destroy', function() {
                if (self.wsocketGestta) {
                    self.wsocketGestta.close();
                }
            });
        }

        init();
    }

    bmHeader.$inject = ['$window', '$document', '$rootScope', 'bmUtil', 'AuthenticatedSessionData'];

    bmHeaderCtrl.$inject = [
        '$window',
        '$log',
        '$rootScope',
        '$q',
        '$timeout',
        '$uibModal',
        '$location',
        '$translate',
        '$scope',
        'AuthenticatedSession',
        'bmUser',
        'bmTheme',
        'myAccountService',
        'bmAccess',
        'bmPermission',
        'bmLicense',
        'bmModal',
        'bmJobQueue',
        'bmClientNotificationsListManager',
        'bmTokenStorage',
        'bmAnalyticsService',
        'csScheduleItemViewV3Standalone',
        'LinkedAccountsService',
        'dmsClientService',
        '$injector',
        '$document',
        '$http',
        'bmMultifactorService',
        'bmEnvironmentConst',
        'bmEnvironment',
        'bmUtil'
    ];

    angular.module('bluemoon.components.header', [
        'ui.bootstrap',
        'bento.services',
        'bento.select',
        'bento.tabs',
        'bluemoon.components.session',
        'bluemoon.components.theme',
        'bluemoon.passwordValidation',
        'bluemoon.components.header.timerButton',
        'bluemoon.components.header.documentsButton',
        'bmViewProfile',
        'bmUser',
        'bmAccess',
        'bmPermission',
        'bmLicense',
        'bmUserAvailability',
        'bmClientNotificationsList',
        'bluemoon.components.analytics',
        'bmPrivacyPolicy',
        'bmSupportId',
        'csScheduleItemViewV3Standalone',
        'bmLinkedAccounts',
        'bmPreviewTrialWidget',
        'pascalprecht.translate'
    ])

    .directive('bmHeader', bmHeader);

})(window.angular);

/**
 * Blue Moon Components - View Portal Banner Directive
 */
(function(angular){
    'use strict';

    function bmViewPortalBanner($document, sessionData) {

        return {
            restrict: 'EA',
            templateUrl: 'components/view-portal-banner/view-portal-banner.2js.html',
            transclude: true,
            require: '^bmApp',
            controller: bmViewPortalBannerCtrl,
            controllerAs: 'banner',
            link: function () {
                sessionData.getMeta().then(function(data) {
                    if (data.EmulateePrismGuid) {
                        var html = angular.element($document[0].documentElement)[0];
                        html.classList.add('bm-view-portal-mode');
                    }
                });
            }
        };
    }

    function bmViewPortalBannerCtrl(session, sessionData, theme) {
        var self = this; // jshint ignore:line

        // don't resolve (render) until theme is loaded
        self.unresolvedTheme = true;
        sessionData.getBindings().then(function(data) {
            theme.loadHeader(data.ApplicationConfiguration.CompanyId).then(function() {
                self.unresolvedTheme = false;
            });
        });

        sessionData.getMeta().then(function(data) {
            self.uname = data.FullName;
        });

        self.exitViewPortalMode = function() {
            session.exitViewPortal();
        };
    }

    bmViewPortalBanner.$inject = ['$document', 'AuthenticatedSessionData'];
    bmViewPortalBannerCtrl.$inject = ['AuthenticatedSession', 'AuthenticatedSessionData', 'bmTheme'];

    angular.module('bmViewPortalBanner', [
        'bluemoon.components.session'
    ])

    .directive('bmViewPortalBanner', bmViewPortalBanner);

})(window.angular);

/**
 * Blue Moon Components - Timer Header Button directive.
 * This is the timer menu that is to appear in the header next to the help button in all the apps.
 */
(function(angular){
    'use strict';

    function bmTimerHeaderButton($timeout) {

        return {
            restrict: 'EA',
            templateUrl: 'components/header/timer-header-button.2js.html',
            scope: {
                isTimerDropdownOpen: '=bmTimerHeaderButton',
                clientSpecificTitle: '=clientSpecificTitle',
                htmlElementId: '@'
            },
            link: function(scope, element) {
                // If we don't have the TimeAndExpense Timer code loaded, don't show this button at all.
                var unwatch = scope.$watch(function () { return element[0].querySelector('#bm-header-timer-control'); },
                    function (timerElement) {
                        if (timerElement && timerElement.childElementCount > 0) {
                            scope.vm.timerDirectiveLoaded = true;
                            unwatch();

                            // add an id to the main element if defined
                            if(angular.isDefined(scope.vm.htmlElementId)){
                                element.attr('id', scope.vm.htmlElementId);
                            }
                        }
                    });
                $timeout(function () {
                    // After a while, give up. No point in wasting cpu cycles by watching this forever.
                    unwatch();
                }, 6000);
            },
            bindToController: true,
            controller: function() {
                this.timerDirectiveLoaded = false;
            },
            controllerAs: 'vm'
        };
    }
    bmTimerHeaderButton.$inject = ['$timeout'];

    angular.module('bluemoon.components.header.timerButton', [
        'bluemoon.components.session',
        'bluemoon.components.templates',
        'bmPermission',
    ])

    .directive('bmTimerHeaderButton', bmTimerHeaderButton);

})(window.angular);

/**
 * Blue Moon Components - Documents Header Button directive.
 * This is the documents icon that takes the use to Documnets that is to appear
 in the header next to the help button in all the apps.
 */
(function(angular){
    'use strict';

    var _$inject = ['$state', 'bmPermission', 'bmAccess', '$q'];
    var bmDocumentsHeaderButton = function($state, bmPermission, bmAccess, $q) {
        return {
            scope: {
                clientSpecificUrl: '=',
                clientSpecificTitle: '=',
                notStaffClient: '<?'
            },
            templateUrl: 'components/header/documents-header-button.2js.html',
            link: function(scope) {
                scope.openDocuments = function () {
                    var notWithinStaff = scope.notStaffClient !== undefined && scope.notStaffClient.isNotStaffApplication;
                    var url = notWithinStaff ? '/staff/#/documents/all' : $state.href('allDocsRootList');
                    if(scope.clientSpecificUrl && scope.clientSpecificUrl.length > 32) {
                        var clientIdString = scope.clientSpecificUrl.substring(1, 33);
                        if(clientIdString.match(/\w{32}/)) {
                            if (notWithinStaff) {
                                var promises = [
                                    bmPermission.has('OnvioDrive.SuppressTree'),
                                    bmAccess.has('DMS_HideTreeView')
                                ];

                                return $q.all(promises).then(function() {
                                    url = '/staff/#/documents/clients/' + clientIdString + '/storage';
                                    window.open(url, '_blank');
                                },function() {
                                    url = '/staff/#/documents/client/' + clientIdString;
                                    window.open(url, '_blank');
                                });
                            } else {
                                url = $state.href('clientStorageList', {
                                    clientId: clientIdString
                                });
                                window.open(url, '_blank');
                            }
                        } else {
                            window.open(url, '_blank');
                        }
                    } else {
                        window.open(url, '_blank');
                    }
                };
            }
        };
    };

    bmDocumentsHeaderButton.$inject = _$inject;

    // bmDocumentsHeaderButton.$inject = ['$timeout'];

    angular.module('bluemoon.components.header.documentsButton', [
        'bluemoon.components.session',
        'bluemoon.components.templates',
        'bmPermission',
        'bmAccess'
    ])

    .directive('bmDocumentsHeaderButton', bmDocumentsHeaderButton);

})(window.angular);

/**
 * Blue Moon Components - Staff Header Directive
 */
(function(angular){
    'use strict';

    function bmStaffHeader() {
        return {
            restrict: 'EA',
            templateUrl: 'components/header/bm-staff-header.2js.html',
            scope: {
                profileEvent: '@profileEvent'
            }
        };
    }

    function bmStaffCustomHeader() {
        return {
            restrict: 'EA',
            templateUrl: 'components/header/bm-staff-custom-header.2js.html',
            transclude: {
                'profile': '?bmStaffCustomHeaderProfile',
                'icon': '?bmStaffCustomHeaderIcon',
            },
            scope: {
                profileEvent: '@profileEvent'
            },
        };
    }

    angular.module('bluemoon.components.staffHeader', [
        'bluemoon.components.header'
    ])

    .directive('bmStaffHeader', bmStaffHeader)
    .directive('bmStaffCustomHeader', bmStaffCustomHeader);

})(window.angular);

(function(angular) {
    'use strict';
    /*jshint sub:true*/
    // DEPRECATED - Use csScheduleItemViewV3Standalone
    angular.module('csScheduleItemV6Standalone', ['bluemoon.components.session']).service('csScheduleItemV6Standalone',
        ['$http', 'AuthenticatedSessionData',
        function($http, authenticatedSessionData) {
            return {
                get: function(params) {
                    var paramsCopy = angular.copy(params);
                    return authenticatedSessionData.get().then(function(sessionData) {
                        paramsCopy['companyId'] = sessionData.bindings.ApplicationConfiguration.CompanyId;
                        var url = '/api/core/v6/companies/{companyId}/schedule-items/{scheduleItemId}';
                        url = url.replace(/{companyId}/g, paramsCopy['companyId']);
                        url = url.replace(/{scheduleItemId}/g, paramsCopy['scheduleItemId']);

                        var query = {
                            'expand': paramsCopy['expand']
                        };
                        return $http({ url: url, method: 'GET', params: query, headers: {} });
                    });
                }

            };
        }]);
}(window.angular));

(function(angular) {
    'use strict';
    /*jshint sub:true*/
    angular.module('csScheduleItemViewV3Standalone', ['bluemoon.components.session']).service('csScheduleItemViewV3Standalone',
        ['$http', 'AuthenticatedSessionData',
        function($http, authenticatedSessionData) {
            return {
                get: function(params) {

                    var paramsCopy = angular.copy(params);
                    return authenticatedSessionData.get().then(function(sessionData) {
                        paramsCopy['companyId'] = sessionData.bindings.ApplicationConfiguration.CompanyId;
                        var url = '/api/core/v3/companies/{companyId}/schedule-item-views/search';
                        url = url.replace(/{companyId}/g, paramsCopy['companyId']);
                        var body = {
                            'excludeCount': true,
                            'expand': paramsCopy['expand'],
                            'filterSearchSort': {
                                'search': paramsCopy['scheduleItemId'],
                                'searchBy': 'id'
                            },
                            'includeAllOwners': true
                        };
                        return $http({ url: url, method: 'POST', data: body, headers: {} });
                    });
                }
            };
        }]);
}(window.angular));

(function(angular) {
    'use strict';

    angular.module('bluemoon.components.bluemoonForceDesktop', [])
    .directive('bluemoonForceDesktop', bluemoonForceDesktop)
    .directive('bmForceDesktop', bluemoonForceDesktop);

    bluemoonForceDesktop.$inject = ['$window'];
    function bluemoonForceDesktop($window) {
        return {
            restrict: 'A',
            replace: false,
            link: function(scope, element) {
                var w = angular.element($window);
                scope.getWindowSize = function() {
                    return { 'width': $window.innerWidth };
                };
                scope.$watch(scope.getWindowSize, function(newValue) {
                    // TODO - bootstrap medium and higher for now.
                    // Still want 'force-desktop' past bootstrap large,
                    // but at some point a HD screen may not want 'force-desktop'
                    if (newValue.width >= 992 /*&& newValue.width < 1200*/) {
                        element.addClass('force-desktop');
                    } else {
                        element.removeClass('force-desktop');
                    }
                }, true);

                w.bind('resize', function() {
                    scope.$apply();
                });
            }
        };
    }
})(window.angular);

(function (angular) {
    'use strict';

    function BmAnalyticsConfigProvider() {

        var provider = this;

        /* Remove permission via FRP. All environments (except local) should report */
        // provider.hasPermission = ['bmPermission', 'bmAnalyticsFRP', function(bmPermission, bmAnalyticsFRP){
        // return bmPermission.has(bmAnalyticsFRP);
        // }];
        provider.hasPermission = ['$q', function ($q) {
            var deferred = $q.defer();
            deferred.resolve(true);
            return deferred.promise;
        }];

        provider.$get = function () {
            return provider;
        };
    }

    // Product Insight integration #7833
    function productInsightIntegration(module) {
        module
            .config([
                'bmEnvironmentConst',
                'bluemoonAnalyticsProvider',
                function (env, bluemoonAnalyticsProvider) {
                    // all env except local
                    if (env.isProdType || env.isLowerType) {
                        bluemoonAnalyticsProvider.sendAnalyticsToProd(env.isProdType, function () {
                            bluemoonAnalyticsProvider.loadTRAACLibrary(function () {
                                bluemoonAnalyticsProvider.configAngulartics();
                            });
                        });
                    }
                }
            ])
            .run([
                'bmEnvironmentConst',
                'AuthenticatedSessionData',
                '$analytics',
                function (env, session, $analytics) {
                    // all env except local
                    if (env.isProdType || env.isLowerType) {
                        $analytics.setSuperProperties({
                            // NOTE: 'app' should be set by consumer
                            //'app': 'My Application Name in Human Readable Form',
                            'server': location.protocol + '//' + location.host,
                            'environment': env.type.toLowerCase()
                        });
                        session.getMeta().then(function (data) {
                            $analytics.setSuperProperties({
                                'uid': data.PrismGuid
                            });
                        }).catch(function () {
                            angular.noop('ng161');
                        });
                    }
                }
            ]);
    }

    function BmAnalyticsService($window, $analytics, $rootScope, $location, $injector, authenticatedSessionData, bmAnalyticsConfig) {
        var service = this;

        var performEventTracking = function (eventName, eventInfo) {
            service.defaultData().then(function (data) {
                var fullData = angular.extend({}, data, eventInfo);
                $analytics.eventTrack(eventName, fullData);
            }).catch(function () {
                angular.noop('ng161');
            });
        };

        var performPageViewedTracking = function (event, current) {
            service.defaultStateData().then(function (data) {
                data.controller = current.controller;
                data.state = current.name;
                data.page = $analytics.settings.pageTracking.basePath + $location.url();

                //NOTE: Could do pageTrack(url) but it wouldn't give us nearly as much info as I'm doing here.
                $analytics.eventTrack('Page Viewed', data);
            }).catch(function () {
                angular.noop('ng161');
            });
        };

        service.track = function (eventName, eventInfo) {
            service.ready().then(function () {
                performEventTracking(eventName, eventInfo);
            }).catch(function () {
                angular.noop('ng161');
            });
        };

        service.init = function () {
            service.ready().then(function () {
                $rootScope.$on('$stateChangeSuccess', function (event, current) {
                    performPageViewedTracking(event, current);
                });
            }).catch(function () {
                angular.noop('ng161');
            });
        };

        service.defaultData = function () {
            return authenticatedSessionData.get().then(function (data) {
                return {
                    category: 'bluemoon-event',
                    label: 'custom-event',
                    companyId: data.bindings.ApplicationConfiguration.CompanyId,
                    sessionId: data.meta.sessionId,
                    contactId: data.bindings.ApplicationConfiguration.ContactId,
                    testFirm: data.bindings.ApplicationConfiguration.TestFirm === 'true'
                };
            }).catch(function () {
                angular.noop('ng161');
            });
        };

        service.defaultStateData = function () {
            return authenticatedSessionData.get().then(function (data) {
                return {
                    companyId: data.bindings.ApplicationConfiguration.CompanyId,
                    sessionId: data.meta.sessionId,
                    contactId: data.bindings.ApplicationConfiguration.ContactId,
                    testFirm: data.bindings.ApplicationConfiguration.TestFirm === 'true'
                };
            }).catch(function () {
                angular.noop('ng161');
            });
        };

        service.hasPermission = function () {
            return $injector.invoke(bmAnalyticsConfig.hasPermission);
        };

        service.ready = function () {
            return service.hasPermission();
        };
    }

    BmAnalyticsService.$inject = ['$window', '$analytics', '$rootScope', '$location', '$injector', 'AuthenticatedSessionData', 'bmAnalyticsConfig'];

    function BmAnalyticsDirective(bmAnalyticsService) {

        function link(scope) {
            bmAnalyticsService.track(scope.eventName, scope.eventInfo);
        }

        return {
            restrict: 'EA',
            replace: true,
            scope: {
                eventName: '@',
                eventInfo: '@'
            },
            link: link
        };
    }

    BmAnalyticsDirective.$inject = ['bmAnalyticsService'];

    function BmAnalyticsOnDirective($q, $compile, analyticsService) {

        function link(scope, element, attr) {

            function getAnalyticsAttribute(bmAnalyticsAttribute) {
                return bmAnalyticsAttribute.replace('bm-analytics', 'analytics');
            }

            analyticsService.ready().then(function () {

                var promisesToWaitFor = [];

                angular.forEach(attr.$attr, function (bmAnalyticsAttr) {
                    if (bmAnalyticsAttr.indexOf('bm-analytics-') === 0) {
                        if (bmAnalyticsAttr === 'bm-analytics-properties') {
                            promisesToWaitFor.push(analyticsService.defaultData().then(function (data) {
                                var properties = attr[attr.$normalize(bmAnalyticsAttr)];
                                var fullData = properties ? angular.extend({}, data, JSON.parse(properties)) : '';
                                element.attr(getAnalyticsAttribute(bmAnalyticsAttr), JSON.stringify(fullData));
                            }));
                        } else if (bmAnalyticsAttr === 'bm-analytics-if') {
                            scope.analyticsIf = function () {
                                return scope.$eval(attr[attr.$normalize(bmAnalyticsAttr)]);
                            };
                            element.attr(getAnalyticsAttribute(bmAnalyticsAttr), 'analyticsIf()');
                        } else {
                            element.attr(getAnalyticsAttribute(bmAnalyticsAttr), attr[attr.$normalize(bmAnalyticsAttr)]);
                        }
                    }
                });

                $q.all(promisesToWaitFor).then(function () {
                    element.removeAttr('bm-analytics-on');
                    if (element.attr('bm-analytics-properties') === undefined) {
                        analyticsService.defaultData().then(function (data) {
                            element.attr(getAnalyticsAttribute('bm-analytics-properties'), JSON.stringify(data));
                            $compile(element)(scope);
                        });
                    } else {
                        $compile(element)(scope);
                    }
                });
            }).catch(function () {
                angular.noop('ng161');
            });

        }

        return {
            restrict: 'A',
            replace: true,
            link: link
        };
    }

    BmAnalyticsOnDirective.$inject = ['$q', '$compile', 'bmAnalyticsService'];

    var bmAnalyticsFRP = 'Onvio.Analytics';

    var module = angular.module('bluemoon.components.analytics', [
        'angulartics',
        'bluemoon.analytics',
        'bmEnvironment',
        'bmPermission',
        'bluemoon.components.session'
    ])
        .constant('bmAnalyticsFRP', bmAnalyticsFRP)
        .provider('bmAnalyticsConfig', BmAnalyticsConfigProvider)
        .service('bmAnalyticsService', BmAnalyticsService)
        .directive('bmAnalytics', BmAnalyticsDirective)
        .directive('bmAnalyticsOn', BmAnalyticsOnDirective)
        .config(['$analyticsProvider', function ($analyticsProvider) {
            $analyticsProvider.virtualPageviews(false);
        }])
        .run(['bmAnalyticsService', function (bmAnalyticsService) {
            bmAnalyticsService.init();
        }]);

    productInsightIntegration(module);

})(window.angular);

(function(angular) {
    'use strict';

    /*
     *  bmFocusOnEvent
     *
     *  Requires: onvio.setup.common.ITouchUtils, fef.Utils, bluemoon.components.Notifications
     *
     *  Scope type: none
     *
     *  Arguments:
     *      The main argument is an expression that evaluates to an angular event name (string).
     *      The bmFocusOnEventWithTouch argument (optional, default false) is an expression that evaluates to true or false.
     *        If true, the focus behavior will be enabled even on touch devices and hybrids where the user
     *        is currently using touch. Otherwise, the focus behavior will be disabled on these devices.
     *      The bmFocusOnEventElementSelector argument (optional, default undefined) is an expression that evaluates to a string.
     *        If provided, the focus behavior will apply to the first descendent that is returned by the provided element selector
     *        Otherwise, the focus behavior will apply to the element that this directive is on.
     *
     *  Description:
     *  Directive to listen for an event on scope (specified as an argument)
     *  and focus the element whenever the event fires. Does a $scope.$on on
     *  the element's scope, given the main argument as the event name, and
     *  gives the element focus when that event occurs. $broadcast that event
     *  from the element's scope (or one of its parent scopes), or $emit it from
     *  a child scope under the element, to cause the element to gain focus.
     */
    angular.module('bmFocusOnEvent',
        [
            'bluemoon.components.Notifications',
            'fef',
            'bmTouchUtils'
        ]).directive('bmFocusOnEvent', [
            '$timeout',
            '$log',
            'bluemoon.components.Notifications',
            'fef.Utils',
            'bmTouchUtils',
            function(
                $timeout,
                $log,
                notifications,
                utils,
                touchUtils
            ) {
                return {
                    link: function($scope, element, attrs) {
                        var enabledOnTouch = false;
                        var elementSelector;
                        var focused = false;
                        if(!utils.exists(attrs.bmFocusOnEvent)) {
                            throw new Error('bmFocusOnEvent requires an event argument');
                        }

                        if(utils.exists(attrs.bmFocusOnEventWithTouch)) {
                            enabledOnTouch = $scope.$eval(attrs.bmFocusOnEventWithTouch);
                        }
                        if (utils.exists(attrs.bmFocusOnEventElementSelector)) {
                            elementSelector = $scope.$eval(attrs.bmFocusOnEventElementSelector);
                        }
                        var deregister = null;
                        var getEventName = function() {
                            return $scope.$eval(attrs.bmFocusOnEvent);
                        };

                        var registerListener = function() {
                            if(deregister !== null) {
                                deregister();
                                deregister = null;
                            }
                            var eventName = getEventName();
                            if (utils.exists(eventName)) {
                                deregister = $scope.$on(eventName, function() {
                                    var focusElement = element;
                                    if (enabledOnTouch || !touchUtils.touchUsed()) {
                                        if (elementSelector) {
                                            focusElement = element.find(elementSelector);
                                            if (!focusElement) {
                                                // Don't do anything if the element could not be found.
                                                return;
                                            }
                                        }
                                        focused = false;
                                        focusElement.bind('focus', function(event) {
                                            focused = true;
                                            focusElement.unbind(event);
                                        });

                                        focusElement.focus();

                                        // If we are in a headless browser, focus() won't do anything.
                                        // But we still want to fire the events.
                                        // So, if the focus event hasn't yet been fired, do that here.
                                        if(!focused) {
                                            focusElement.triggerHandler('focus');
                                        }
                                    }
                                });
                            }
                        };

                        $scope.$watch(attrs.bmFocusOnEvent, registerListener);
                        registerListener();
                    }
                };
            }]);

}(window.angular));

(function() {
    'use strict';
    angular.module('bmFocusOnLink',
        ['bmTouchUtils', 'fef', 'bluemoon.components.Notifications'])
        .directive('bmFocusOnLink', [
        '$timeout',
        '$log',
        'bluemoon.components.Notifications',
        'fef.Utils',
        'bmTouchUtils',
        '$rootScope',
        function($timeout, $log, notifications, utils, touchUtils, $rootScope) {
            return {
                link: function(scope, instanceElement, instanceAttributes) {
                    var enabledAttribute = instanceAttributes.bmFocusOnLink;
                    if(!utils.stringIsNonBlank(enabledAttribute)) {
                        enabledAttribute = 'true';
                    }
                    var enabled = scope.$eval(enabledAttribute);
                    if(enabled) {
                        var enabledOnTouch = instanceAttributes.bmFocusOnLinkWithTouch;
                        if(!utils.exists(enabledOnTouch)) {
                            enabledOnTouch = false;
                        } else {
                            enabledOnTouch = scope.$eval(enabledOnTouch);
                        }
                        // the timeout is to allow the scope digest cycle to settle.
                        // otherwise the selection state may get lost as bindings
                        // fire callbacks and so on.
                        $timeout(function() {
                            var focusElement = function() {
                                if(enabledOnTouch || !touchUtils.touchUsed()) {
                                    instanceElement.focus();
                                    if(utils.exists(instanceElement.select) && angular.isFunction(instanceElement.select)) {
                                        instanceElement.select();
                                    }
                                }
                            };
                            // Focus only works if the control is visible.
                            if(instanceElement.is(':visible')) {
                                focusElement();
                            } else {
                                // Wait until the control becomes visible before trying to focus it.
                                var unwatch = $rootScope.$watch(function() { return instanceElement.is(':visible'); }, function(newValue) {
                                    if(newValue) {
                                        focusElement();
                                        if(utils.exists(unwatch)) {
                                            unwatch();
                                            unwatch = undefined;
                                        }
                                    }
                                });
                                // We run out of digest cycles in some cases (typically trying to add on most screens)
                                // So, trigger a digest every so-often if the control is visible and we haven't focused it yet.
                                var digestFunc = function() {
                                    if(utils.exists(unwatch)) {
                                        if(instanceElement.is(':visible')) {
                                            $rootScope.$digest();
                                        } else {
                                            $timeout(digestFunc, 250);
                                        }
                                    }
                                };
                                $timeout(digestFunc, 250);
                                // After some amount of time of being unable to focus the element, just give up.
                                $timeout(function() {
                                    if(utils.exists(unwatch)) {
                                        unwatch();
                                        unwatch = undefined;
                                    }
                                }, 2000);
                            }
                        }, 10);
                    }
                }
            };
        }
        ]);
}());

(function(angular){
    'use strict';

    // TODO: USE THIS TEMPORARILY UNTIL BENTO SELECT SUPPORTS CHANGE EVENT
    var module = angular.module('bmForceModelChange', []);

    module.directive('bmForceModelChange',function(){
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function(scope, element, attr) {
                scope.$watch(attr.ngModel, function(newValue, oldValue){
                    if(newValue && oldValue && newValue !== oldValue){
                        scope.$eval(attr.bmForceModelChange);
                    }
                });
            }
        };
    });
})(window.angular);

(function($) {
    'use strict';
    /* istanbul ignore next */
    var TouchUtils = (function() {
        function TouchUtils() {
            var _this = this;
            this._touchUsed = false;
            this._touchSupported = false;
            var onTouch = function() {
                _this._touchUsed = true;
            };
            var onNonTouch = function() {
                _this._touchUsed = false;
            };
            // Source: https://hacks.mozilla.org/2013/04/detecting-touch-its-the-why-not-the-how/
            if(('ontouchstart' in window) ||
                (navigator.maxTouchPoints > 0) ||
                (navigator.msMaxTouchPoints > 0)) {
                this._touchSupported = true;
                //var body = $('body');
                // This doesn't appear to be working #research
                $('body').on('pointerdown', function(event) {
                    if(event.pointerType === 'touch') {
                        onTouch();
                    } else {
                        onNonTouch();
                    }
                });
                $('body').on('pointermove', function(event) {
                    if(event.pointerType !== 'touch') {
                        onNonTouch();
                    }
                });
                $('body').bind('touchstart', function() {
                    onTouch();
                });
                $('body').bind('onmousemove', function() {
                    onNonTouch();
                });
            }
        }
        TouchUtils.prototype.touchSupported = function() {
            return this._touchSupported;
        };
        /**
         * Not currently working. #research
         */
        TouchUtils.prototype.touchUsed = function() {
            return this._touchUsed;
        };
        TouchUtils.$inject = [];
        return TouchUtils;
    })();
    angular.module('bmTouchUtils', []).service('bmTouchUtils', TouchUtils);
}(window.$));

(function(angular) {
    'use strict';

    angular.module('bmRightClick', [])

    .directive('bmRightClick', function($parse) {
        return function(scope, element, attrs) {
            var fn = $parse(attrs.bmRightClick);
            element.bind('contextmenu', function(event) {
                scope.$apply(function() {
                    fn(scope, {$event:event});
                });
            });
        };
    });

}(window.angular));

/**
 * Blue Moon Components - Nav Directive
 */
(function(angular){
    'use strict';
    var titleSeparator = '|';
    var docTitleReplacePtn = new RegExp('^.+\\s\\' + titleSeparator + '\\s');

    function bmNav($window, $document, $location, $rootScope, $timeout, $translate, authenticatedSessionData) {

        return {
            restrict: 'EA',
            templateUrl: 'components/nav/nav.2js.html',
            transclude: true,
            link: function(scope, element, attrs) {
                var nav,
                    doc = $document[0],
                    syncDocTitle,
                    offLocChgSuccess,
                    unwatchDocTitle,
                    offLangChgSuccess;

                var keyCodes = { esc: 27 };

                element.on({ keydown: function(e) {
                    if (e.which === keyCodes.esc) {
                        var selectedTree = Array.from(element.get(0).querySelectorAll('.focused'));
                        var rootActiveMenuEl = Array.isArray(selectedTree) && selectedTree[0];
                        nav.navmore.collapse();
                        if (rootActiveMenuEl) {
                            rootActiveMenuEl.focus();
                        }
                    }
                }});

                // update active nav item after binding data is loaded and allowed nav items show
                authenticatedSessionData.getBindings().then(function() {
                    // wait till next event loop
                    $timeout(function() {
                        // snapshot static configuration
                        syncDocTitle = scope.$eval(attrs.syncDocTitle) === true;

                        // init navigation menu
                        nav = $window.navmore(element.find('nav')[0]);
                        localizeMoreNavItem($translate, nav);

                        // update active nav item on startup
                        updateSelectedNavItem($rootScope, doc, nav, $location.absUrl());

                        // update active nav item on location change success
                        offLocChgSuccess = $rootScope.$on('$locationChangeSuccess', function (e, url) {
                            updateSelectedNavItem($rootScope, doc, nav, url);
                            // update document title
                            if (syncDocTitle) {
                                syncDocumentTitleWithNavSelection(doc, nav);
                            }
                        });

                        // update more item text on lang change
                        offLangChgSuccess = scope.$on('bmLanguageChangeSuccess', function() {
                            localizeMoreNavItem($translate, nav);
                            if (syncDocTitle) {
                                syncDocumentTitleWithNavSelection(doc, nav);
                            }
                        });

                        if (syncDocTitle) {
                            unwatchDocTitle = $rootScope.$watch(
                                function() {
                                    return doc.title;
                                },
                                function() {
                                    syncDocumentTitleWithNavSelection(doc, nav);
                                }
                            );
                            syncDocumentTitleWithNavSelection(doc, nav);
                        }
                    });
                });

                // cleanup
                element.on('$destroy', function () {
                    if (offLocChgSuccess) {
                        offLocChgSuccess();
                    }
                    if (offLangChgSuccess) {
                        offLangChgSuccess();
                    }
                    if (unwatchDocTitle) {
                        unwatchDocTitle();
                    }
                });
            }
        };

        function syncDocumentTitleWithNavSelection(doc, nav) {
            if (!nav || !nav.navmore) { return; }

            // find top-level selected nav item and use the text (post translation) to update the doc title

            var navSelectedArray = nav.navmore.getSelected();
            if (!navSelectedArray.length) { return; }

            var navSelectedText = navSelectedArray[navSelectedArray.length - 1].textContent.trim();
            if (!navSelectedText) { return; }

            var newTitle = navSelectedText + ' ' + titleSeparator + ' ' + doc.title.replace(docTitleReplacePtn, '');
            if (newTitle === doc.title) { return; }

            // offer subscribers a chance to cancel
            var detail = { oldValue: doc.title, newValue: newTitle, cancel: false };
            $rootScope.$emit('bmNavDocumentTitleBeforeChange', detail);
            if (detail.cancel) { return; }

            doc.title = newTitle;
        }
    }

    function localizeMoreNavItem($translate, nav) {
        $translate('bm.nav.more.item').then(function(more) {
            nav.navmore.setMoreItemText(more);
        });
    }

    function updateSelectedNavItem($rootScope, doc, nav, url) {
        var active = findActiveNavItem(nav, url);
        if (active) {
            // close expanded lists
            nav.navmore.collapse();
            // update selected nav item
            nav.navmore.setSelected(active);
            // fire event with new selection
            $rootScope.$broadcast('bmNavSelectionChanged', {
                selected: nav.navmore.getSelected()
            });
        }
    }

    // sync active nav item with location
    function findActiveNavItem(nav, url) {
        var i, j, candidates, candidate, candidateHrefNoQuery, matches, lastHrefChar, nextUrlChar, bestMatch,
            urlNoQuery = '#' + url.split('?')[0].split('#')[1];

        // find match candidates
        candidates = angular.element(nav).find('a');
        if (!candidates.length) { return; }

        // gather matches
        matches = [];
        for (i = 0; i < candidates.length; i++) {
            candidate = candidates[i];
            if (!candidate.hasAttribute('href')) { continue; }

            // Get all the hrefs represented by this parent link
            var hrefs = ((candidate.getAttribute('href') || '') + ',' + (candidate.getAttribute('bm-href-aliases') || '')).split(',');
            for(j = 0; j < hrefs.length; j++) {

                // strip off query string
                candidateHrefNoQuery = hrefs[j].split('?')[0];
                lastHrefChar = candidateHrefNoQuery.charAt(hrefs[j].length - 1);
                nextUrlChar = urlNoQuery.charAt(candidateHrefNoQuery.length);
                if (urlNoQuery.indexOf(candidateHrefNoQuery) === 0 &&
                    (lastHrefChar === '/' || !nextUrlChar.length || nextUrlChar === '/' || nextUrlChar === '?')) {
                        matches.push({ link: candidate, href: hrefs[j] });
                }
            }
        }

        // find best (longest) match
        for (i = 0; i < matches.length; i++) {
            if (!bestMatch) {
                bestMatch = matches[i];
            } else if (matches[i].href.length > bestMatch.href.length) {
                bestMatch = matches[i];
            }
        }

        return !!bestMatch ? bestMatch.link : undefined;
    }

    bmNav.$inject = ['$window', '$document', '$location', '$rootScope', '$timeout', '$translate', 'AuthenticatedSessionData'];

    angular.module('bluemoon.components.nav', [
        'bluemoon.components.session',
        'pascalprecht.translate'
    ])

    .directive('bmNav', bmNav);

})(window.angular);

/**
 * Blue Moon Components - Staff Not Found Directive
 */
(function(angular){
    'use strict';

    function bmStaffNotFound() {
        return {
            restrict: 'EA',
            templateUrl: 'components/not-found/bm-staff-not-found.2js.html'
        };
    }

    angular.module('bluemoon.components.staffNotFound', [
    ])

    .directive('bmStaffNotFound', bmStaffNotFound);

})(window.angular);

/**
 * Blue Moon Components - Main Directive
 */
(function(angular){
    'use strict';

    function bmMain() {

        return {
            restrict: 'EA',
            templateUrl: 'components/main/main.2js.html',
            transclude: true,
            controller: [function () {
            }],
            controllerAs: 'main',
            link: function () {
            }
        };
    }

    bmMain.$inject = [];

    angular.module('bluemoon.components.main', [
    ])

    .directive('bmMain', bmMain);

})(window.angular);

(function(angular){
    'use strict';

    angular.module('bluemoon.components.busyLoader', [
        'bento.busyloader'
    ])

    .value('bluemoon.components.busyLoader.defaultStartOffsetDefault', 2000)
    .value('bluemoon.components.busyLoader.defaultSize', 'default')

    .service('bmBusyLoaderDefaults', ['$injector',
        'bluemoon.components.busyLoader.defaultStartOffsetDefault',
        'bluemoon.components.busyLoader.defaultSize',
        function($injector, defaultStartOffset, defaultSize) {

            var _getValueFunction = function(key, defaultValue) {
                return function() {
                    return $injector.has(key) ? $injector.get(key) : defaultValue;
                };
            };

            this.startOffset = _getValueFunction('bluemoon.components.busyLoader.startOffset', defaultStartOffset);
            this.size = _getValueFunction('bluemoon.components.busyLoader.size', defaultSize);
    }])

    .directive('bmBusyLoader', [
        '$timeout',
        '$bentoBusyLoader',
        '$rootScope',
        'bmBusyLoaderDefaults',
        function (
            $timeout,
            $bentoBusyLoader,
            $rootScope,
            bmBusyLoaderDefaults){
            return {
                restrict: 'A',
                scope: {
                    bmBusyLoader: '='
                },
                link: function(scope, element){

                    var _defaults = {
                        offset: bmBusyLoaderDefaults.startOffset(),
                        size: bmBusyLoaderDefaults.size()
                    };

                    var _options = angular.extend({}, _defaults,
                        scope.bmBusyLoader || {});

                    var _requestTracker = 0;

                    //  Bento replaces style positions with relative, let's undo that
                    var _originalStylePosition = element[0].style.position;

                    var _busyLoader = $bentoBusyLoader.getNewLoader(element, _options.size);

                    if (_originalStylePosition) {
                        element[0].style.position = _originalStylePosition;
                    }

                    var _busyLoaderTimeout;

                    var _showLoader = function() {
                        _busyLoaderTimeout = $timeout(function(){
                            _busyLoader.show();
                        }, _options.offset);
                    };

                    var _hideLoader = function() {
                        $timeout.cancel(_busyLoaderTimeout);
                        _busyLoader.hide();
                    };

                    scope.$parent.$on('bm-busy-loading-on', function(event) {
                        if (!_requestTracker) {
                            _showLoader();
                        }
                        _requestTracker++;

                        if(angular.isFunction(event.stopPropagation)){
                            event.stopPropagation();
                        }
                    });

                    scope.$parent.$on('bm-busy-loading-off', function(event, options) {

                        var opt = angular.extend({}, options, {});

                        if (_requestTracker === 1 || opt.forceOff) {
                            _hideLoader();
                        }

                        _requestTracker = opt.forceOff ? 0 : Math.max(0, _requestTracker - 1);

                        if(angular.isFunction(event.stopPropagation)){
                            event.stopPropagation();
                        }
                    });

                    $rootScope.$on('$stateChangeStart', function(){
                        _hideLoader();
                        _requestTracker = 0;
                    });
                }
            };
        }
    ]);
})(window.angular);

(function (angular) {
    'use strict';

    angular.module('bluemoon.components.focus', [])

    .directive('bmFocus', ['$timeout',
        function($timeout) {
            return {
                restrict: 'A',
                link: function(scope, element, attrs) {
                    scope.$watch(attrs.bmFocus, function(value) {
                        if(value) {
                            $timeout(function() {
                                element[0].focus();
                            }, 700);
                        }
                    });
                }
            };
        }
    ]);
}(window.angular));

(function(angular) {
    'use strict';

    function Permission($q, authenticatedSessionData) {
        var self = this;

        // Can be use for route resolve to determine if you have permission.
        // For example,
        // resolve: {
        //     auth: function() {
        //         return bmPermission.has('OnvioDrive.MyDocuments').catch(function () {
        //             $state.go('notfound');
        //         })
        //     }
        // }
        self.has = function(perms, hasEvery) {
            return authenticatedSessionData.getBindings().then(function(data) {
                var grants = flattenObj(data.FeatureResourcePermissions.FeatureResourcePermissionsMap);
                var granted = false;

                if (angular.isArray(perms)) {
                    perms[hasEvery ? 'every' : 'some'](function(perm) {
                        granted = grants[perm] === 'Granted';
                        return granted;
                    });
                } else if (typeof perms === 'string') {
                    granted = grants[perms] === 'Granted';
                }
                if (granted) {
                    return granted;
                } else {
                    return $q.reject(granted);
                }
            });
        };

        self.hasSome = function(perms) {
            return self.has(perms);
        };

        self.hasEvery = function(perms) {
            return self.has(perms, true);
        };

        self.not = function(perms, hasEvery){
            var deferred = $q.defer();
            self.has(perms, hasEvery).then(function(){
                deferred.reject(false);
            }, function(){
                deferred.resolve(true);
            });
            return deferred.promise;
        };

        self.notSome = function(perms){
            return self.not(perms);
        };

        self.notEvery = function(perms){
            return self.not(perms, true);
        };

        self.hasFirmLicense = function(licenses, hasEvery) {
            return authenticatedSessionData.getBindings().then(function(data) {
                var grants = data.ApplicationConfiguration.Licenses;
                var granted = false;

                if (angular.isArray(licenses)) {
                    licenses[hasEvery ? 'every' : 'some'](function(license) {
                        granted = grants.indexOf(license) > -1;
                        return granted;
                    });
                } else if (typeof licenses === 'string') {
                    granted = grants.indexOf(licenses) > -1;
                }
                if (granted) {
                    return granted;
                } else {
                    return $q.reject(granted);
                }
            });
        };

        self.hasSomeFirmLicense = function(licenses) {
            return self.hasFirmLicense(licenses);
        };

        // has will reject promise on false value,
        // isGranted will resolve with one or many true/false values
        self.isGranted = function(perms) {
            var deferred = $q.defer();
            authenticatedSessionData.getBindings().then(function(data) {
                var grants = flattenObj(data.FeatureResourcePermissions.FeatureResourcePermissionsMap);
                var granted = null;

                if (angular.isArray(perms)) {
                    granted = perms.map(function(perm) {
                        return grants[perm] === 'Granted';
                    });
                } else if (typeof perms === 'string') {
                    granted = grants[perms] === 'Granted';
                }
                deferred.resolve(granted);
            });
            return deferred.promise;
        };
    }

    // Given an Object tree, return flat Object with compound, dot-notated keys
    // (e.g. {a1:{b1:'x',b2:{c1:'y'}},a2:'z'} -> {'a1.b1':'x','a1.b2.c1':'y','a2':'z'})
    function flattenObj(obj, filter) {
        var flat = {};
        function traverse(obj, key) {
            var compound, val;
            for (var prop in obj) {
                compound = key ? key + '.' + prop : prop;
                val = obj[prop];
                if (typeof val === 'object') {
                    traverse(val, compound);
                } else {
                    if (filter) {
                        if (!filter(obj, prop, compound)) { continue; }
                    }
                    flat[compound] = val;
                }
            }
        }
        traverse(obj);
        return flat;
    }

    /* adapted from angularJS 1.3.12 */
    function getBlockNodes(nodes) {
      // TODO(perf): just check if all items in `nodes` are siblings and if they are return the original
      //             collection, otherwise update the original collection.
      var node = nodes[0];
      var endNode = nodes[nodes.length - 1];
      var blockNodes = [node];

      do {
        node = node.nextSibling;
        if (!node) { break; }
        blockNodes.push(node);
      } while (node !== endNode);

      return angular.element(blockNodes);
    }

    /* adapted from ngIf angularJS 1.3.12 */
    function permissionDirective($animate, bmPermission) {
      return {
        multiElement: true,
        transclude: 'element',
        priority: 600,
        terminal: true,
        restrict: 'A',
        $$tlb: true,
        link: function($scope, $element, $attr, ctrl, $transclude) {
            var block, childScope, previousElements;

            function bmIfPermWatchAction(value) {
                handlePermAttrChange('bmIfPerm', value);
            }

            function bmIfPermEveryWatchAction(value) {
                handlePermAttrChange('bmIfPermEvery', value);
            }

            function bmIfPermSomeWatchAction(value) {
                handlePermAttrChange('bmIfPermSome', value);
            }

            function bmIfNotPermWatchAction(value){
                handlePermAttrChange('bmIfNotPerm', value);
            }

            function bmIfNotPermSomeWatchAction(value){
                handlePermAttrChange('bmIfNotPermSome', value);
            }

            function bmIfNotPermEveryWatchAction(value){
                handlePermAttrChange('bmIfNotPermEvery', value);
            }

            function bmIfFirmLicenseSomeWatchAction(value) {
                handlePermAttrChange('bmIfFirmLicenseSome', value);
            }

            function handlePermAttrChange(type, value) {
                bmPermission[type === 'bmIfPermEvery' ? 'hasEvery' : type === 'bmIfNotPermEvery' ? 'notEvery' : type === 'bmIfNotPerm' || type === 'bmIfNotPermSome' ? 'not' : 'has'](value || $attr[type]).then(function() {
                    if (!childScope) {
                      $transclude(function(clone, newScope) {
                        childScope = newScope;
                        clone[clone.length++] = document.createComment(' end ' + type + ': ' + $attr[type] + ' ');
                        // Note: We only need the first/last node of the cloned nodes.
                        // However, we need to keep the reference to the jqlite wrapper as it might be changed later
                        // by a directive with templateUrl when its template arrives.
                        block = {
                          clone: clone
                        };
                        $animate.enter(clone, $element.parent(), $element);
                      });
                    }
                }, function() {
                    if (previousElements) {
                      previousElements.remove();
                      previousElements = null;
                    }
                    if (childScope) {
                      childScope.$destroy();
                      childScope = null;
                    }
                    if (block) {
                      previousElements = getBlockNodes(block.clone);
                      $animate.leave(previousElements).then(function() {
                        previousElements = null;
                      });
                      block = null;
                    }
                });
            }

            if ($attr.bmIfPerm) {
                var unwatchIfPerm = $scope.$watch($attr.bmIfPerm, bmIfPermWatchAction);
            }
            if ($attr.bmIfPermEvery) {
                var unwatchIfPermEvery = $scope.$watch($attr.bmIfPermEvery, bmIfPermEveryWatchAction);
            }
            if ($attr.bmIfPermSome) {
                var unwatchIfPermSome = $scope.$watch($attr.bmIfPermSome, bmIfPermSomeWatchAction);
            }
            if($attr.bmIfNotPerm){
                var unwatchIfNotPerm = $scope.$watch($attr.bmIfNotPerm, bmIfNotPermWatchAction);
            }
            if($attr.bmIfNotPermSome){
                var unwatchIfNotPermSome = $scope.$watch($attr.bmIfNotPermSome, bmIfNotPermSomeWatchAction);
            }
            if ($attr.bmIfNotPermEvery) {
                var unwatchIfNotPermEvery = $scope.$watch($attr.bmIfNotPermEvery, bmIfNotPermEveryWatchAction);
            }
             if ($attr.bmIfFirmLicenseSome) {
                var unwatchIfFirmLicenseSome = $scope.$watch($attr.bmIfFirmLicenseSome, bmIfFirmLicenseSomeWatchAction);
            }

            // cleanup
            $element.on('$destroy', function () {
                if (unwatchIfPerm) { unwatchIfPerm(); }
                if (unwatchIfPermEvery) { unwatchIfPermEvery(); }
                if (unwatchIfPermSome) { unwatchIfPermSome(); }
                if (unwatchIfNotPerm) { unwatchIfNotPerm(); }
                if (unwatchIfNotPermSome) { unwatchIfNotPermSome(); }
                if (unwatchIfNotPermEvery) { unwatchIfNotPermEvery(); }
                if (unwatchIfFirmLicenseSome) { unwatchIfFirmLicenseSome(); }
            });
        }
      };
    }

    Permission.$inject = ['$q', 'AuthenticatedSessionData'];
    permissionDirective.$inject = ['$animate', 'bmPermission'];

    angular.module('bmPermission', ['bluemoon.components.session'])
        .service('bmPermission', Permission)
        .directive('bmIfPerm', permissionDirective)
        .directive('bmIfPermSome', permissionDirective)
        .directive('bmIfPermEvery', permissionDirective)
        .directive('bmIfNotPerm', permissionDirective)
        .directive('bmIfNotPermSome', permissionDirective)
        .directive('bmIfNotPermEvery', permissionDirective)
        .directive('bmIfFirmLicenseSome', permissionDirective);

 })(window.angular);

(function(angular) {
    'use strict';

    function Access($q, bmEnvironment) {
        var self = this;

        // Can be used for route resolve to determine if you have access.
        // For example,
        // resolve: {
        //     selfReg: bmAccess.has('SelfRegistration').catch(function () {
        //         $state.go('notfound');
        //     })
        // }
        self.has = function(accessControls, hasEvery) {
            return bmEnvironment.getEnvironmentAsync().then(function(data) {
                var grants = data.InfrastructureAccessControls;
                var granted = false;
                if (angular.isArray(accessControls)) {
                    accessControls[hasEvery ? 'every' : 'some'](function(accessControl) {
                        if (grants) {
                            granted = grants.indexOf(accessControl) > -1;
                        } else {
                            granted = false;
                        }
                        return granted;
                    });
                } else if (typeof accessControls === 'string') {
                    if (grants) {
                        granted = grants.indexOf(accessControls) > -1;
                    }
                }
                if (granted) {
                    return granted;
                } else {
                    return $q.reject(granted);
                }
            });
        };

        self.hasSome = function(accessControls) {
            return self.has(accessControls);
        };

        self.hasEvery = function(accessControls) {
            return self.has(accessControls, true);
        };

        self.not = function(accessControls){
            var deferred = $q.defer();
            self.has(accessControls).then(function(){
                deferred.reject(false);
            }, function(){
                deferred.resolve(true);
            });
            return deferred.promise;
        };

        self.notSome = function(accessControls){
            return self.not(accessControls);
        };

        self.notEvery = function(accessControls){
            return self.not(accessControls, true);
        };
    }

    /* adapted from angularJS 1.3.12 */
    function getBlockNodes(nodes) {
      // TODO(perf): just check if all items in `nodes` are siblings and if they are return the original
      //             collection, otherwise update the original collection.
      var node = nodes[0];
      var endNode = nodes[nodes.length - 1];
      var blockNodes = [node];

      do {
        node = node.nextSibling;
        if (!node) { break; }
        blockNodes.push(node);
      } while (node !== endNode);

      return angular.element(blockNodes);
    }

    /* adapted from ngIf angularJS 1.3.12 */
    function accessDirective($animate, bmAccess) {
      return {
        multiElement: true,
        transclude: 'element',
        priority: 600,
        terminal: true,
        restrict: 'A',
        $$tlb: true,
        link: function($scope, $element, $attr, ctrl, $transclude) {
            var block, childScope, previousElements;

            function bmIfHasAccessWatchAction(value) {
                handleAccessAttrChange('bmIfHasAccess', value);
            }

            function bmIfHasAccessEveryWatchAction(value) {
                handleAccessAttrChange('bmIfHasAccessEvery', value);
            }

            function bmIfHasAccessSomeWatchAction(value) {
                handleAccessAttrChange('bmIfHasAccessSome', value);
            }

            function bmIfHasNoAccessWatchAction(value){
                handleAccessAttrChange('bmIfHasNoAccess', value);
            }

            function bmIfHasNoAccessSomeWatchAction(value){
                handleAccessAttrChange('bmIfHasNoAccessSome', value);
            }

            function bmIfHasNoAccessEveryWatchAction(value){
                handleAccessAttrChange('bmIfHasNoAccessEvery', value);
            }

            function handleAccessAttrChange(type, value) {
                bmAccess[type === 'bmIfHasAccessEvery' ? 'hasEvery'
                    : type === 'bmIfHasNoAccessEvery' ? 'notEvery'
                    : type === 'bmIfHasNoAccess' || type === 'bmIfHasNoAccessSome' ? 'not'
                    : 'has'
                ](value || $attr[type]).then(function() {

                    if (!childScope) {
                      $transclude(function(clone, newScope) {
                        childScope = newScope;
                        clone[clone.length++] = document.createComment(' end ' + type + ': ' + $attr[type] + ' ');
                        // Note: We only need the first/last node of the cloned nodes.
                        // However, we need to keep the reference to the jqlite wrapper as it might be changed later
                        // by a directive with templateUrl when its template arrives.
                        block = {
                          clone: clone
                        };
                        $animate.enter(clone, $element.parent(), $element);
                      });
                    }
                }, function() {
                    if (previousElements) {
                      previousElements.remove();
                      previousElements = null;
                    }
                    if (childScope) {
                      childScope.$destroy();
                      childScope = null;
                    }
                    if (block) {
                      previousElements = getBlockNodes(block.clone);
                      $animate.leave(previousElements).then(function() {
                        previousElements = null;
                      });
                      block = null;
                    }
                });
            }

            if ($attr.bmIfHasAccess) {
                var unwatchIfHasAccess = $scope.$watch($attr.bmIfHasAccess, bmIfHasAccessWatchAction);
            }
            if ($attr.bmIfHasAccessEvery) {
                var unwatchIfHasAccessEvery = $scope.$watch($attr.bmIfHasAccessEvery, bmIfHasAccessEveryWatchAction);
            }
            if ($attr.bmIfHasAccessSome) {
                var unwatchIfHasAccessSome = $scope.$watch($attr.bmIfHasAccessSome, bmIfHasAccessSomeWatchAction);
            }
            if($attr.bmIfHasNoAccess){
                var unwatchIfHasNoAccess = $scope.$watch($attr.bmIfHasNoAccess, bmIfHasNoAccessWatchAction);
            }
            if($attr.bmIfHasNoAccessSome){
                var unwatchIfHasNoAccessSome = $scope.$watch($attr.bmIfHasNoAccessSome, bmIfHasNoAccessSomeWatchAction);
            }
            if ($attr.bmIfHasNoAccessEvery) {
                var unwatchIfHasNoAccessEvery = $scope.$watch($attr.bmIfHasNoAccessEvery, bmIfHasNoAccessEveryWatchAction);
            }

            // cleanup
            $element.on('$destroy', function () {
                if (unwatchIfHasAccess) { unwatchIfHasAccess(); }
                if (unwatchIfHasAccessEvery) { unwatchIfHasAccessEvery(); }
                if (unwatchIfHasAccessSome) { unwatchIfHasAccessSome(); }
                if (unwatchIfHasNoAccess) { unwatchIfHasNoAccess(); }
                if (unwatchIfHasNoAccessSome) { unwatchIfHasNoAccessSome(); }
                if (unwatchIfHasNoAccessEvery) { unwatchIfHasNoAccessEvery(); }
            });
        }
      };
    }

    Access.$inject = ['$q', 'bmEnvironment'];
    accessDirective.$inject = ['$animate', 'bmAccess'];

    angular.module('bmAccess', ['bmEnvironment'])
        .service('bmAccess', Access)
        .directive('bmIfHasAccess', accessDirective)
        .directive('bmIfHasAccessSome', accessDirective)
        .directive('bmIfHasAccessEvery', accessDirective)
        .directive('bmIfHasNoAccess', accessDirective)
        .directive('bmIfHasNoAccessSome', accessDirective)
        .directive('bmIfHasNoAccessEvery', accessDirective);

 })(window.angular);

(function(angular, location){
    'use strict';

    // NOTE: May need updating when adding domains
    var countryDefaultLangMap = {
        'ar': 'es-AR',
        'au': 'en-AU',
        'br': 'pt-BR',
        'ca': 'en-CA',
        'in': 'en-IN',
        'nl': 'nl-NL',
        'uk': 'en-GB',
        'us': 'en-US'
    };

    var tldCountryOverrideMap = {
        'com': 'us'
    };

    // NOTE: Must be updated when adding languages
    var supportedLanguages = [
        {
            // standardized language code
            code: 'en-US',
            // description in given language
            description: 'English (United States)',
            // countries where this language is available
            countryCodes: [
                'us'
            ],
            // description translations for other languages supported in country
            translations: [
                {
                    code: 'xx-XX',
                    description: '[Ʃƞɠļɨšɧ (Ǔƞɨƭȅɗ Ѕƭăƭȅš)!!!!!!!!]'
                }
            ]
        },
        {
            code: 'en-GB',
            description: 'English (United Kingdom)',
            countryCodes: [
                'uk'
            ],
            translations: [
                {
                    code: 'xx-XX',
                    description: '[Ʃƞɠļɨšɧ (Ǔƞɨƭȅɗ Ќɨƞɠɗǒɱ)!!!!!!!!]'
                }
            ]
        },
        {
            code: 'en-AU',
            description: 'English (Australia)',
            countryCodes: [
                'au'
            ],
            translations: [
                {
                    code: 'xx-XX',
                    description: '[Ʃƞɠļɨšɧ (Ăʊšƭɾăļɨă)!!!!!!!]'
                }
            ]
        },
        {
            code: 'en-CA',
            description: 'English (Canada)',
            countryCodes: [
                'ca'
            ],
            translations: [
                {
                    code: 'xx-XX',
                    description: '[Ʃƞɠļɨšɧ (Ĉăƞăɗă)!!!!!!]'
                },
                {
                    code: 'fr-CA',
                    description: 'Anglais (Canada)'
                }
            ]
        },
        {
            code: 'en-IN',
            description: 'English (India)',
            countryCodes: [
                'in'
            ],
            translations: [
                {
                    code: 'xx-XX',
                    description: '[Ʃƞɠļɨšɧ (ɨƞɗɨă)!!!!!!!!]'
                }
            ]
        },
        {
            code: 'fr-CA',
            description: 'Français (Canada)',
            countryCodes: [
                'ca'
            ],
            translations: [
                {
                    code: 'xx-XX',
                    description: '[Ƒɾăƞçăɨš (Ĉăƞăɗă)!!!!!!]'
                },
                {
                    code: 'en-CA',
                    description: 'French (Canada)'
                }
            ]
        },
        {
            code: 'es-AR',
            description: 'Español (Argentina)',
            countryCodes: [
                'ar'
            ],
            translations: [
                {
                    code: 'xx-XX',
                    description: '[Ʃšρăñǒļ (Ăɾɠȅƞƭɨƞă)!!!!!!!]'
                }
            ]
        },
        {
            code: 'pt-BR',
            description: 'Português (Brasil)',
            countryCodes: [
                'br'
            ],
            translations: [
                {
                    code: 'xx-XX',
                    description: '[Ƥǒɾƭʊɠʊêš (ßɾăšɨļ)!!!!!!]'
                }
            ]
        },
        {
            code: 'nl-NL',
            description: 'Nederlands (Nederland)',
            countryCodes: [
                'nl'
            ],
            translations: [
                {
                    code: 'xx-XX',
                    description: '[ƞêɗêɾļăƞɗš (ƞêɗêɾļăƞɗ)!!!!!!]'
                }
            ]
        },
        {
            code: 'xx-XX',
            description: '[Ƥšȅʊɗǒļǒĉăļɨʐȅɗ!!!!!]',
            countryCodes: [
                'us',
                'uk',
                'ca',
                'au',
                'in',
                'ar',
                'br',
                'nl'
            ],
            translations: [
                {
                    code: 'en-US',
                    description: 'Pseudolocalized'
                },
                {
                    code: 'en-GB',
                    description: 'Pseudolocalised'
                },
                {
                    code: 'en-CA',
                    description: 'Pseudolocalized'
                },
                {
                    code: 'en-AU',
                    description: 'Pseudolocalized'
                },
                {
                    code: 'en-IN',
                    description: 'Pseudolocalized'
                },
                {
                    code: 'es-AR',
                    description: 'Pseudo Localizada'
                },
                {
                    code: 'fr-CA',
                    description: 'Pseudo Localisée'
                },
                {
                    code: 'pt-BR',
                    description: 'Pseudo Localizada'
                },
                {
                    code: 'nl-NL',
                    description: 'Pseudo Gelokaliseerde'
                }
            ]
        }
    ];

    var auth0Constants = {
        domain: {
            prod: 'auth.thomsonreuters.com',
            nonProd: 'auth-nonprod.thomsonreuters.com'
        },
        onvioUSClientId: {
            prod: 'aFY7lhJ8020mivBuWVPTvGOfwCY1j0PT',
            nonProd: 'z4IjNxMseVlWLLG6KFKmf7gBaboyEWUD'
        },
        profileUrl: {
            prod: 'https://www.thomsonreuters.com',
            nonProd: 'https://www-tr-com-uat-ams.ewp.thomsonreuters.com'
        },
        myPayClientId: {
            prod: '',
            nonProd: 'S7fKW3nlDZjS0laPAwhxAOs5z3ArkLqw'
        },
        onvioUKClientId: {
            prod: 'Z4qxWZaRjgEWS1ojEqoT8GgqvRH8FuGP',
            nonProd: 'l244e5WqhQcNL7XVlkKwN4kjGyD0MdVA'
        },
        onvioCAClientId: {
            prod: 'ikcbw5dmEbuTgjiJAVi5LmiZUdMZW5Gf',
            nonProd: 'FkcfkiCZRQkdIaVOCclV4enlVTfcZVbC'
        },
        onvioCAFrClientId: {
            prod: 'QuwZR3WYIpX2miq5NpUaifgZU4SABrXc',
            nonProd: 'lMJEtc9AiJruheyGJXXdvRIgizN2TDqq'
        },
        onvioBRClientId:{
            prod: 'GBUpPpOUwBf4phSv9eIqF2xi8LSPsktK',
            nonProd: '58MkBk3Hrrzfl5gfVwjYdYOa2R6TIuGJ'
        },
        onvioBREnUsClientId:{
            prod: 'ghG5mUTaFVbHQaKwPUlGxk9MH8dUYnyr',
            nonProd: 'LJJM3fQVAKKe3SYP6c3oDdzRMPW97bDp'
        },
        onvioARClientId:{
            prod: 'cyG9HEnbS6Jt9LRVxYCDDA32HZuQDKc4',
            nonProd: 'hzFeIrZunDs73ZxKDXHNxzhoF0fgfV3h'
        },
        onbalanceBRClientId:{
            prod: 'XXWYWfoH35jr8OVLWRY5SI49UL03qpgu',
            nonProd: 'dqQWzOB6s1hZHUOunf3DD3272BTgxh2k'
        },
        onbalanceARClientId:{
            prod: 'p4HlqCux83nuFtGkLcgdpscTtA2KxVBu',
            nonProd: '8IDNPKg6WC2zpe88fbrlLQZMZqcNXIrL'
        }
    };

    var domainCountryCodePtn = /\.([a-z]+)$/,
        hostname = location.hostname.toLowerCase(),
        isProdEnv = !/^(lab\d*|qa\d*|sat\d*|localhost|\d+)\b/.test(hostname),
        isLowerEnv = /^(lab\d*|qa\d*|sat\d*)\b/.test(hostname),
        isLocalEnv = /^(localhost|0\.0\.0\.0|127\.0\.0\.1)$/.test(hostname),
        envType = isProdEnv ?
            'PROD' : isLowerEnv ?
                hostname.replace(/^(lab\d*|qa\d*|sat\d*)\..*/, '$1').toUpperCase() : isLocalEnv ?
                    'LOCAL' : 'UNKNOWN',
        isQedOrProd = /(PROD|SAT)/.test(envType),
        auth0DomainValue = isProdEnv ? auth0Constants.domain.prod: auth0Constants.domain.nonProd,
        auth0ClientIdValue = getAuth0ClientId(),
        auth0RegionLocaleClientIdValue = getAuth0RegionLocaleClientId(),
        auth0ProfileUrlValue = isProdEnv ? auth0Constants.profileUrl.prod: auth0Constants.profileUrl.nonProd;

    var environmentConst = {
        // caveat: if you use a machine IP address these will be false
        isProdType: isProdEnv,
        isQedOrProdType: isQedOrProd,
        // "lower" = lab, qa, or QED
        // caveat: if naming scheme stays from Onvio standard it will be false
        isLowerType: isLowerEnv,
        // caveat: if you use your IP address it will be false
        isLocalType: isLocalEnv,
        // possible values: 'PROD', 'QED', 'qa', 'lab', 'LOCAL', 'UNKNOWN'
        type: envType,
        defaultLang: getCountryDefaultLanguage(),
        auth0Domain: auth0DomainValue,
        auth0ClientId: auth0ClientIdValue,
        auth0RegionLocaleClientId: auth0RegionLocaleClientIdValue,
        auth0ProfileUrl: auth0ProfileUrlValue
    };

    function Environment($q, $http, $location, bmEnvironmentUrl){
        var factory = {
            load: getEnvironmentAsync,
            getEnvironmentAsync: getEnvironmentAsync,
            getSupportedLanguagesAsync: getSupportedLanguagesAsync,
            getCountryDefaultLanguage: getCountryDefaultLanguage,
            getCountryCode: getCountryCode,
            getPrimaryProduct: getPrimaryProduct,
            getRoute: getRoute,
            // older function-style prop to be deprecated, replaced by envConst
            isQedOrProdDomain: testQedOrProdDomain,

            /* Generated functions are available for each key in
               countryDefaultLangMap. For example,

               isUsCountryCode()
               isUkCountryCode()
               isCaCountryCode()
               isArCountryCode()
               isBrCountryCode()
            */
        };

        var environmentDeferred;

        generateCountryTestFns();
        return factory;

        ////////////////////////////////

        function testQedOrProdDomain(){
            return isQedOrProd;
        }

        function generateCountryTestFns() {
            var currentCode = getCountryCode();
            Object.keys(countryDefaultLangMap).forEach(function(code) {
                factory['is' + code.charAt(0).toUpperCase() + code.charAt(1) + 'CountryCode'] = function() {
                    return code === currentCode;
                };
            });
        }

        function getEnvironmentAsync(){
            if(environmentDeferred){
                return environmentDeferred.promise;
            }

            environmentDeferred = $q.defer();

            $http({
                method: 'GET',
                url: bmEnvironmentUrl,
                cache: true
            }).then(function(resp){
                environmentDeferred.resolve(resp.data);
            }, function(){
                environmentDeferred.resolve({});
            });

            return environmentDeferred.promise;
        }

        function getSupportedLanguagesAsync(){
            var languageList = [];
            var baseLanguages = angular.copy(supportedLanguages);

            return getEnvironmentAsync().then(function(environment){
                var locales = angular.isDefined(environment.locales) ? environment.locales : getDomainBasedLocales();

                for(var langIndex = 0; langIndex < baseLanguages.length; langIndex++){
                    if(locales.indexOf(baseLanguages[langIndex].code) >= 0){
                        languageList.push(baseLanguages[langIndex]);
                    }
                }

                return languageList;
            });
        }

        function getPrimaryProduct(){
            // default to onvio for now. may need to default to a product based on domain at some point?
            return getEnvironmentAsync().then(function(environment){
                return (environment.primaryProduct || 'onvio') || 'onvio';
            });
        }

        function getDomainBasedLocales(){
            var locales = [];
            var countryCode = getCountryCode();
            var baseLanguages = angular.copy(supportedLanguages);

            for(var counter = 0; counter < baseLanguages.length; counter++){
                if(baseLanguages[counter].countryCodes.indexOf(countryCode) >= 0){
                    locales.push(baseLanguages[counter].code);
                }
            }

            return locales;
        }

        function getRoute(routeName){
            if(angular.isUndefined(routeName) || routeName === ''){
                return $q.when('');
            }

            return getEnvironmentAsync().then(function(data){
                if(data.RoutingTable && data.RoutingTable[routeName]){
                    return data.RoutingTable[routeName];
                }

                return '';
            });
        }
    }

    function getCountryCode() {
        var matches = domainCountryCodePtn.exec(hostname);
        var tld = (matches && matches[1].toLowerCase()) || 'us';
        return tldCountryOverrideMap[tld] || tld;
    }

    // can't use $location service in config phase.
    // we need to set the default lang in angular translate during config
    function getCountryDefaultLanguage() {
        return countryDefaultLangMap[getCountryCode()] || 'en-US';
    }

    function getAuth0ClientId() {
        var url = window.location.origin;
        var domain = url.match(/^https?\:\/\/([^\/?#]+)(?:[\/?#]|$)/i)[1].split('onvio')[1];
        switch (domain) {
            case '.us':
                return isProdEnv ? auth0Constants.onvioUSClientId.prod: auth0Constants.onvioUSClientId.nonProd;
            case '.co.uk':
                return isProdEnv ? auth0Constants.onvioUKClientId.prod: auth0Constants.onvioUKClientId.nonProd;
            case '.ca':
                return isProdEnv ? auth0Constants.onvioCAClientId.prod: auth0Constants.onvioCAClientId.nonProd;
            case '.com.br':
                return isProdEnv ? auth0Constants.onvioBRClientId.prod: auth0Constants.onvioBRClientId.nonProd;
            case '.com.ar':
                return isProdEnv ? auth0Constants.onvioARClientId.prod: auth0Constants.onvioARClientId.nonProd;
        }
        domain = url.match(/^https?\:\/\/([^\/?#]+)(?:[\/?#]|$)/i)[1].split('mypaysolutions')[1];
        switch (domain) {
            case '.com':
                return isProdEnv ? auth0Constants.myPayClientId.prod: auth0Constants.myPayClientId.nonProd;
        }
        // Validate onbalance domain onbalance.thomsonreuters.com.br and onbalance.thomsonreuters.com.ar
        domain = url.match(/^https?\:\/\/([^\/?#]+)(?:[\/?#]|$)/i)[1].split('onbalance.thomsonreuters')[1];
        switch (domain) {
            case '.com.br':
                return isProdEnv ? auth0Constants.onbalanceBRClientId.prod : auth0Constants.onbalanceBRClientId.nonProd;
            case '.com.ar':
                return isProdEnv ? auth0Constants.onbalanceARClientId.prod : auth0Constants.onbalanceARClientId.nonProd;
        }
        // For localhost projects
        // Validate pathname for samba project /smb and returns default onbalance BR client id
        if (window.location.pathname.indexOf('/smb') > -1) {
            return isProdEnv ? auth0Constants.onbalanceBRClientId.prod: auth0Constants.onbalanceBRClientId.nonProd;
        }
        return isProdEnv ? auth0Constants.onvioUSClientId.prod: auth0Constants.onvioUSClientId.nonProd;
    }

    function getAuth0RegionLocaleClientId() {
        // Later we could include other domains like .com.br with different locale
        return isProdEnv ? auth0Constants.onvioCAFrClientId.prod: auth0Constants.onvioCAFrClientId.nonProd;
    }

    Environment.$inject = ['$q', '$http', '$location', 'bmEnvironmentUrl'];
    angular.module('bmEnvironment', [])
        .factory('bmEnvironment', Environment)
        .constant('bmEnvironmentConst', environmentConst)
        .value('bmEnvironmentUrl', '/api/security/v2/environments')
        // todo: deprecate bmEnvCountryDefaultLang since it's under bmEnvironmentConst
        .constant('bmEnvCountryDefaultLang', getCountryDefaultLanguage())
        .constant('bmSupportedLanguagesMetadata', supportedLanguages);

})(window.angular, window.location);

(function(angular){
    'use strict';

    angular.module('bmUserTermsSignatory', [
        'ui.bootstrap',
        'bluemoon.components.session',
        'bmUser'
    ])
    .factory('bmUserSignatory', bmUserSignatory)
    .controller('bmTermsSignatoryCtrl', bmTermsSignatoryCtrl)
    .directive('bmTermsSignatory',['$uibModal', 'AuthenticatedSession', 'bmUserSignatory', function($uibModal, session, bmUserSignatory){
        return {
            restrict: 'EA',
            link: function(){
                bmUserSignatory.getRequiredUserSignatoryAsync().then(function(signatory){
                    // Any signatories required?
                    if(angular.isDefined(signatory) && angular.isDefined(signatory.terms) && angular.isUndefined(signatory.signatory)){
                        var modalInstance = $uibModal.open({
                            templateUrl: 'components/terms-signatory/terms-signatory-modal.2js.html',
                            controller: 'bmTermsSignatoryCtrl as vm',
                            size: 'lg',
                            backdrop: 'static',
                            keyboard: false,
                            resolve: {
                                termsText: function(){
                                    return signatory.terms.text;
                                }
                            }
                        });

                        modalInstance.result.then(function(isSigned){
                            if(isSigned){
                                // Process signatory
                                bmUserSignatory.setSignatoryForTermsAsync(signatory.terms.id);
                            } else {
                                // Redirect to login page
                                session.destroy();
                            }
                        });
                    }
                }, function(response){
                    if (response) {
                        // Don't propogate error
                        response.config.global = false;
                    }
                });
            }
        };
    }]);

    //////////

    bmUserSignatory.$inject = ['$log', '$q', '$http','bmUser', 'AuthenticatedSessionData'];
    function bmUserSignatory($log, $q, $http, bmUser, sessionData){
        var factory = {
            getRequiredUserSignatoryAsync: getRequiredUserSignatoryAsync,
            setSignatoryForTermsAsync: setSignatoryForTermsAsync
        };

        return factory;

        //////////

        function getRequiredUserSignatoryAsync(){
            var signatory = { terms: undefined, signatory: undefined };

            return sessionData.getMeta().then(function(data) {
                // don't require user to accept terms if 'viewing portal as'
                if (!angular.isUndefined(data.EmulateePrismGuid)) {
                    return signatory;
                }

                return bmUser.load().then(function(){

                    return loadActiveTermsAsync(bmUser.companyId, bmUser.language).then(function(terms){
                        if(angular.isUndefined(terms)){
                            return signatory;
                        }

                        signatory.terms = terms;

                        return loadUserSignatoryForTermsAsync(bmUser, terms.id).then(function(data){
                            signatory.signatory = data;
                            return signatory;
                        });
                    });
                });
            });
        }

        function setSignatoryForTermsAsync(termsId){
            return bmUser.load().then(function(){
                return $http({
                    method: 'POST',
                    url: '/api/profiles/v1/companies/' + bmUser.companyId + '/terms/' + termsId + '/signatories',
                    headers: {
                        'Accept-Language': bmUser.language
                    },
                    data: { termsId: termsId, bluid: bmUser.bluId }
                }).then(function(response){
                    return response;
                }, function(response){
                    response.config.global = false;
                });
            });
        }

        //////////

        function loadActiveTermsAsync(companyId, language){
            return $http({
                method: 'GET',
                url: '/api/profiles/v1/companies/' + companyId + '/terms/active',
                headers: {
                    'Accept-Language': language
                }
            }).then(function(response){
                return response.data;
            }, function(response){
                // 404 = no active terms found
                if(response.status === 404){
                    response.config.global = false;
                    $log.info('Sorry, GET 404 (Not Found) for active terms is a possible valid response, no need for concern.');
                    return undefined;
                }

                return $q.reject(response);
            });
        }

        function loadUserSignatoryForTermsAsync(user, termsId){
            return $http({
                method: 'GET',
                url: '/api/profiles/v1/companies/' + user.companyId + '/terms/' + termsId + '/signatories/' + user.bluId,
                headers: {
                    'Accept-Language': user.language
                }
            }).then(function(response){
                return response.data;
            }, function(response){
                // 404 = no signatory found
                if(response.status === 404){
                    response.config.global = false;
                    $log.info('Sorry, GET 404 (Not Found) for signatories is a possible valid response, no need for concern.');
                    return undefined;
                }

                return $q.reject(response);
            });
        }
    }

    //////////

    bmTermsSignatoryCtrl.$inject = ['$sce', '$uibModalInstance', 'termsText'];
    function bmTermsSignatoryCtrl($sce, $uibModalInstance, termsText){
        /*jshint validthis:true */
        var vm = this;
        vm.setAgreement = setAgreement;
        vm.displayText = $sce.trustAsHtml(convertTermsTextToHtml(termsText));

        //////////

        function setAgreement(agreed){
            $uibModalInstance.close(agreed);
        }

        function convertTermsTextToHtml(text){
            return text.replace(/\r\n|\n\r|\n|\r/g, '<br />');
        }
    }
})(window.angular);

(function(angular) {
    'use strict';

    /* EXPORT */
    angular.module('bmUser', ['bluemoon.myAccount', 'bluemoon.components.util', 'bluemoon.components.i18n'])
        .service('bmUser', User);

    User.$inject = ['$window', 'myAccountService', 'bmUtil', 'bmLanguageManager', 'bmLanguageCookieName'];

    /**
     * Intrinsic current user
     */
    function User(window, usersService, util, langMgr, langCookieName) {
        var self = this;
        var imgDataPrefix = 'data:image;base64,';
        var loadPromise;

        /* PROPS */
        function init() {
            // id (string, optional): TRuid associated with this user in IAM,
            self.id = '';
            // email (string, optional): Email address,
            self.email = '';
            // firstName (string, optional): User's given name,
            self.firstName = '';
            // middleName (string, optional): User's middle name,
            self.middleName = '';
            // lastName (string, optional): User's last or family name,
            self.lastName = '';
            // suffix (string, optional): Post-nominal letters appended to a user's common name,
            self.suffix = '';
            // language (string, optional): User's first language,
            self.language = '';
            // photo (string, optional): User's profile photo,
            self.photo = '';
            // bluId (string, optional): BLUid or PrismGuid associated with this user,
            self.bluId = '';
            // companyId (string, optional): CompanyId associated with this user,
            self.companyId = '';
            // contactId (string, optional): ContactId associated with this user,
            self.contactId = '';
            // licensee (boolean, optional): User is a licensee for CSWeb
            self.licensee = false;
        }

        /* COMPUTEDS */
        window.Object.defineProperties(self, {
            'fullName': {
                enumerable: true,
                get: function() {
                    var delimiter = ' ';
                    // if (useMiddle === true && self.middleName) { delimiter += self.middleName + delimiter; }
                    return (self.firstName + delimiter + self.lastName).trim();
                }
            },
            'initials': {
                enumerable: true,
                get: function() {
                    var delimiter = '';
                    // if (useMiddle === true && self.middleName) { delimiter = self.middleName.charAt(0); }
                    return self.firstName.charAt(0) + delimiter + self.lastName.charAt(0);
                }
            },
            'languages': {
                enumerable: true,
                get: function() {
                    var prefs = [];

                    // cookie
                    var cookiePref = util.cookie(langCookieName);
                    if (cookiePref) { prefs.push(cookiePref); }

                    // service data
                    var asyncPref = self.language;
                    if (asyncPref) { prefs.push(asyncPref); }

                    // browser prefs
                    var navPrefs = window.navigator.languages;
                    if (navPrefs && navPrefs.length) {
                        prefs = prefs.concat(navPrefs);
                    } else {
                        // msie < 11
                        navPrefs = window.navigator.browserLanguage;
                        if (navPrefs) { prefs.push(navPrefs); }
                    }

                    return util.uniq(prefs); // elim dupes
                }
            }
        });

        /* METHODS */
        self.init = init;
        self.load = function(reload) {
            if (!loadPromise || reload === true) {
                loadPromise = usersService.getMyUserSettingsAsync();
                loadPromise.then(function(resp) {
                    if (resp.data.photo) {
                        resp.data.photo = imgDataPrefix + resp.data.photo;
                    }
                    // update data
                    util.extend(self, resp.data);

                    if (self.language) {
                        // update current lang to user's pref
                        langMgr.setUserLanguageAsync(self.language);
                    }
                });
            }

            return loadPromise;
        };
        self.save = function() {
            var obj;

            if (self.photo) {
                obj = angular.copy(self);
                obj.photo = obj.photo.split(';base64,')[1];
            } else {
                obj = self;
            }

            return usersService.saveUserAsync(obj);
        };

        init();
    }

})(window.angular);

(function(angular){
    'use strict';

    angular.module('bmFileReader', []);
})(window.angular);

(function(angular, FileReader){
    // http://odetocode.com/blogs/scott/archive/2013/07/03/building-a-filereader-service-for-angularjs-the-service.aspx
    // Note: Possible shim for IE 9 https://github.com/moxiecode/moxie
    'use strict';

    angular.module('bmFileReader').factory('bmFileReader', fileReader);
    fileReader.$inject = ['$q'];

    function fileReader($q)
    {
        return {
            readAsDataURL: readAsDataURL
        };

        /////////////

        function readAsDataURL(file, scope){
            var deferred = $q.defer();
            var reader = getReader(deferred, scope);
            reader.readAsDataURL(file);
            return deferred.promise;
        }

        function onLoad(reader, deferred, scope){
            return function(){
                if(angular.isUndefined(scope)){
                    return;
                }

                scope.$apply(function(){
                    deferred.resolve(reader.result);
                });
            };
        }

        function onError(reader, deferred, scope){
            return function(){
                if(angular.isUndefined(scope)){
                    return;
                }

                scope.$apply(function(){
                    deferred.reject(reader.result);
                });
            };
        }

        function onProgress(reader, scope){
            return function(event){
                if(angular.isUndefined(scope)){
                    return;
                }

                scope.$broadcast('fileProgress',
                    {
                        total: event.total,
                        loaded: event.loaded
                    });
            };
        }

        function getReader(deferred, scope){
            var reader = new FileReader();
            reader.onload = onLoad(reader, deferred, scope);
            reader.onerror = onError(reader, deferred, scope);
            reader.onprogress = onProgress(reader, scope);
            return reader;
        }
    }
})(window.angular, window.FileReader);

(function(angular){
    'use strict';

    angular.module('bmFileReader').directive('fileUploadPreview', filePreview);

    // TODO: COMPLETELY COPIED FROM STAFF. NEED TO REMOVE FROM STAFF.
    function filePreview(){
        return {
            scope: {
                previewCallback: '&previewCallback'
            },
            link: function(scope, element){
                element.bind('change', function(e){
                    var file = (e.srcElement || e.target).files[0];

                    // User defined callback to handle result of file read
                    scope.previewCallback({file: file});
                });
            }
        };
    }
})(window.angular);

(function (angular, Math) {
    'use strict';

    angular.module('bmImageUploadModal', [
        'ui.bootstrap',
        'pascalprecht.translate',
        'bluemoon.components.i18n',
        'angularFileUpload',
        'bmFileReader',
        'uiCropper',
        'bento.services',
        'bento.progressbar'
    ])

    .controller('bmImageUploadModalCtrl', [
        '$q', '$scope', '$uibModalInstance', '$translate', '$timeout', 'bmFileReader', 'config',
        function ($q, $scope, $uibModalInstance, $translate, $timeout, bmFileReader, config) {
            /*jshint validthis:true */
            var vm = this;

            vm.fileOnChange = fileOnChange;
            vm.close = closeModal;
            vm.save = saveImage;
            vm.cancel = cancelModal;
            vm.delete = deleteImage;
            vm.resetAlerts = resetAlerts;
            vm.croppedImage = '';
            vm.progress = 0;
            vm.aspectRatio = Number(config.aspectRatio);

            vm.blockingObject = { block: true };

            vm.cropper = {
                cropWidth: $scope.rectangleWidth,
                cropHeight: $scope.rectangleHeight
            };

            vm.rectangleWidth = 100;
            vm.rectangleHeight = 100;
            vm.areaInitSize = angular.isDefined(config.areaInitSize) ? config.areaInitSize : { w: vm.cropper.cropWidth, h: vm.cropper.cropHeight };
            vm.areaMinSize = angular.isDefined(config.areaMinSize) ? config.areaInitSize : undefined;
            vm.resultImageSize = angular.isDefined(config.resultImageSize) ? config.resultImageSize : undefined;

            vm.progressType = 'danger';
            vm.alerts = [];
            vm.cropShape = angular.isDefined(config.cropShape) && config.cropShape !== 'circle' ? config.cropShape : 'circle';
            vm.currentImage = angular.isDefined(config.image) && config.image !== '';
            vm.deletable = config.deletable;
            vm.options = angular.isDefined(config.options) ? config.options : undefined;
            vm.hasOptions = vm.options && vm.options.choices && vm.options.choices.length > 0;
            if(vm.hasOptions) {
                vm.options.selectedValue = vm.options.choices[0];
            }

            // configurable text options
            var promises = [
                $translate('bm.image.upload.title'),
                $translate('bm.image.upload.dragImage'),
                $translate('bm.image.upload.uploadImageButton'),
                $translate('bm.image.upload.deleteImageButton'),
                $translate('bm.image.upload.uploadAnotherImage'),
                $translate('bm.image.upload.saveImageButton')
            ];

            $q.all(promises).then(function (values) {
                vm.uploadTitleText = angular.isDefined(config.uploadTitleText) ? config.uploadTitleText : values[0];
                vm.dragImageText = angular.isDefined(config.dragImageText) ? config.dragImageText : values[1];
                vm.uploadImageButtonText = angular.isDefined(config.uploadImageButtonText) ? config.uploadImageButtonText : values[2];
                vm.deleteImageButtonText = angular.isDefined(config.deleteImageButtonText) ? config.deleteImageButtonText : values[3];
                vm.uploadAnotherImageText = angular.isDefined(config.uploadAnotherImageText) ? config.uploadAnotherImageText : values[4];
                vm.saveImageButtonText = angular.isDefined(config.saveImageButtonText) ? config.saveImageButtonText : values[5];
            });

            $scope.$on('fileProgress', function (e, progress) {
                var progressValue = Math.round((progress.loaded / progress.total) * 100);
                var progressType;

                if (progressValue < 25) {
                    progressType = 'danger';
                } else if (progressValue < 50) {
                    progressType = 'warning';
                } else if (progressValue < 75) {
                    progressType = 'info';
                } else {
                    progressType = 'success';
                }

                setProgress(progressValue, progressType);
            });

            $scope.optionChoiceCheckboxClick = function optionChoiceCheckboxClick(event) {
                $scope.vm.options.selectedValue = event.currentTarget.value;
                // force exactly one checkbox to be checked
                var checkboxes = document.querySelectorAll('input[class="option-choice-checkbox"]');
                checkboxes.forEach(function(item) {
                    if (item !== event.currentTarget) {
                        item.checked = false;
                    } else {
                        item.checked = true;
                    }
                });
            };
            ///////////

            function fileOnChange(files, event, rejectedFiles) {
                resetAlerts();

                if (files && files.length > 0) {
                    // Only selection/drop of one image
                    if (files.length > 1) {
                        $translate('bm.header.profileDialog.multipleFileMessage').then(function (value) {
                            addAlert(value, 'warning');
                        });

                        return;
                    }

                    bmFileReader.readAsDataURL(files[0], $scope).then(function (result) {
                        setProgress();

                        if (result.indexOf('data:image') >= 0) {
                            vm.selectedImageSrc = result;
                            return;
                        }

                        $translate('bm.header.profileDialog.invalidFileMessage').then(function (value) {
                            addAlert(value, 'warning');
                        });
                    }, function () {
                        setProgress();

                        $translate('bm.header.profileDialog.fileReadMessage').then(function (value) {
                            addAlert(value, 'danger');
                        });
                    });
                } else if (angular.isDefined(rejectedFiles) && rejectedFiles.length > 0) {
                    $translate('bm.header.profileDialog.invalidFileMessage').then(function (value) {
                        addAlert(value, 'warning');
                    });
                }
            }

            function setProgress(progress, progressType) {
                // Needed to update watch parameters set on scope for bento-progressbar
                $timeout(function () {
                    vm.progress = progress || 0;
                    vm.progressType = progressType || 'danger';
                }, 0);
            }

            function saveImage() {
                $uibModalInstance.close({ image: vm.croppedImage, selectedOptionValue: vm.hasOptions ? vm.options.selectedValue : undefined });
            }

            function closeModal() {
                $uibModalInstance.dismiss('close');
            }

            function deleteImage() {
                $uibModalInstance.close('');
            }

            function cancelModal() {
                $uibModalInstance.dismiss('cancel');
            }

            function addAlert(message, type) {
                resetAlerts();
                vm.alerts.push({ msg: message, type: type, closeable: true });
            }

            function resetAlerts() {
                vm.alerts = [];
            }
        }])

    .directive('bmImageUploadModal', ['$uibModal', function ($uibModal) {
            return {
                restrict: 'E',
                replace: false,
                scope: {
                    api: '='
                },
                link: function (scope) {
                    // provide an api to allow public configuration to  consumer directives
                    scope.internalApi = scope.api || {};

                    // public method for opening upload modal
                    scope.internalApi.openImageUploadModal = function (config) {
                        // setup the modal dialog
                        var modalInstance = $uibModal.open({
                            templateUrl: 'components/bm-image-upload-modal/bm-image-upload-modal.2js.html',
                            controller: 'bmImageUploadModalCtrl as vm',
                            size: 'md',
                            backdrop: 'static',
                            resolve: {
                                config: function () {
                                    return config;
                                }
                            }
                        });

                        modalInstance.result.then(function (result) {
                            // return the selected option
                            if(angular.isDefined(config.options) && angular.isDefined(config.options.selectedChoiceCallback)) {
                                config.options.selectedChoiceCallback(result.selectedOptionValue);
                            }
                            if(result === '') {
                                // to remove selected image
								config.imageUploadCallback('');
							} else {
                                 // return the selected image
                                config.imageUploadCallback(result.image);
                            }
                        }, function () {
                            // return nothing for consumer response to cancel action
                            if(angular.isDefined(config.options) && angular.isDefined(config.options.selectedChoiceCallback)) {
                                config.options.selectedChoiceCallback();
                            }
                            config.imageUploadCallback();
                        });
                    };
                }
            };
        }]);
})(window.angular, window.Math);

(function(angular){
    'use strict';

    angular.module('bmProfilePhoto', [
        'pascalprecht.translate',
        'bluemoon.components.i18n',
        'bmImageUploadModal'
    ])

    .controller('bmProfilePhotoSelectCtrl', ['bmPermission', 'bmModal','$q', '$scope', '$timeout', '$rootScope', '$translate', function(bmPermission, bmModal,$q, $scope, $timeout, $rootScope, $translate){
        /*jshint validthis:true */
        var vm = this;
        var uploadConfig = {
            imageUploadCallback: imageUploadCallback
        };
        vm.isNewMenu = angular.isDefined(vm.isNewMenu) ? vm.isNewMenu : false;
        // pick up translated strings
        $rootScope.$on('$bmLanguageChangeSuccess', function () {
            uploadConfig.uploadTitleText = $translate.instant('bm.header.profileDialog.header');
            uploadConfig.dragImageText = $translate.instant('bm.header.profileDialog.dragPhoto');
            uploadConfig.uploadImageButtonText = $translate.instant('bm.header.profileDialog.selectPhoto');
            uploadConfig.deleteImageButtonText = $translate.instant('bm.header.profileDialog.deletePhoto');
            uploadConfig.uploadAnotherImageText = $translate.instant('bm.header.profileDialog.uploadAnotherPhoto');
            uploadConfig.saveImageButtonText = $translate.instant('bm.header.profileDialog.setAsProfilePhoto');
        });

        // provide a shared api with the upload controller for sharing open function
        vm.imageUploadApi = vm.imageUploadApi || {};

        vm.openProfileSelect = function(){
            if(!vm.selectEnabled){
                return;
            }

            uploadConfig.image = vm.image;
            uploadConfig.cropShape = vm.cropShape;
            uploadConfig.deletable = true;
            vm.imageUploadApi.openImageUploadModal(uploadConfig);
        };

        $scope.$watch('vm.image', function(newValue, oldValue){
            if(angular.isDefined(newValue)){
                if(newValue !== ''){
                    vm.selectedStyle = { 'background-image' : 'url(' + newValue + ')' };
                } else if(angular.isDefined(oldValue) && oldValue !== '') {
                    // remove old photo style
                    vm.selectedStyle = undefined;
                }
            }
        });

        $scope.$watch('vm.viewOnly()', function(newValue){
            vm.selectEnabled = !newValue;
        });

        /////////////
        vm.openPhotoModal = function () {
            bmPermission.has('Platform.PreviewMode')
                .then(function () {
                    vm.showUnauthorizedModal();
                }).catch(function () {
                    vm.openProfileSelect();
                });
        };
        vm.showUnauthorizedModal = function () {
            bmModal.modal({
                templateUrl: 'components/modal/modal-default.2js.html',
                showClose: false,
                vars: {
                    body: $translate.instant('bm.header.previewTrial.previewMode.UnauthorizedBody'),
                    title: $translate.instant('bm.header.previewTrial.previewMode.UnauthorizedTitle')
                },
                buttons: [
                    { text: $translate.instant('bm.header.previewTrial.previewMode.OKButton'), value: 1, primary: true }
                ]
            });
        };
        function imageUploadCallback(profileImage){
            // undefined value means the photo selection was dismissed with no changes being made
            if(angular.isUndefined(profileImage)){
                return;
            }

            vm.image = profileImage;
            $timeout(function() {
                $scope.$emit('bmProfilePhotoSelected', profileImage);
            });
        }
    }])

    .directive('bmProfilePhotoSelect',[function(){
        return {
            restrict: 'E',
            replace: true,
            templateUrl: 'components/profile-photo-select/profile-photo-select.2js.html',
            scope: {
                image: '=',
                size: '@',
                shape: '@',
                cropShape: '@',
                viewOnly: '&',
                initials: '@',
                isNewMenu: '=?'
            },
            controller: 'bmProfilePhotoSelectCtrl',
            controllerAs: 'vm',
            bindToController: true
        };
    }]);
})(window.angular);

(function(angular){
    'use strict';

    var module = angular.module('bmUserAvailability', [
        'ui.bootstrap',
        'pascalprecht.translate',
        'bmUser'
    ]);

    module.directive('bmUserAvailability', ['$q', '$translate', '$rootScope', 'bmStaffAvailabilityManager',
        function($q, $translate, $rootScope, staffAvailabilityManager){
            return {
                restrict: 'E',
                replace: true,
                templateUrl: 'components/bm-user-availability/bm-user-availability.2js.html',
                scope: {
                },
                link: function(scope){
                    var user;

                    // set defaults
                    scope.statusText = {};
                    scope.selectedDot = 'gray';
                    scope.availabilityText = '';
                    scope.changeStatus = changeStatus;
                    scope.changeStatusText = changeStatusText;

                    // only load/refresh status when the profile menu is opened
                    $rootScope.$on('bmProfileMenuOpened', function(){
                        loadViewData();
                    });

                    ///////////////

                    function loadViewData(){
                        var promises = [
                            $translate('bm.header.status.available'),
                            $translate('bm.header.status.away'),
                            $translate('bm.header.status.busy'),
                            $translate('bm.header.status.offline'),
                            $translate('bm.header.status.idle'),
                            $translate('bm.header.status.online')
                        ];

                        $q.all(promises).then(function(results){
                            scope.statusText.available = results[0];
                            scope.statusText.away = results[1];
                            scope.statusText.busy = results[2];
                            scope.statusText.offline = results[3];

                            // call after translations in case an error is thrown and rejects $q.all
                            staffAvailabilityManager.getUserAvailability().then(function(userAvailability){
                                user = userAvailability;
                                setStatusDisplay(userAvailability);
                            }, function(){
                                user = {};
                                setStatusDisplay(undefined);
                            });
                        });
                    }

                    function setStatusDisplay(userAvailability){
                        if(angular.isUndefined(userAvailability)){
                            $translate(scope.statusText.offline).then(function(str) {
                                scope.availabilityText = str;
                            });
                            scope.selectedDot = 'gray';
                            return;
                        }

                        if(angular.isUndefined(userAvailability.statusMessage) || userAvailability.statusMessage === ''){
                            userAvailability.statusMessage = userAvailability.status;
                        }

                        var transId = 'bm.header.status.' + userAvailability.statusMessage.toLowerCase();
                        $translate(transId, {}, '', userAvailability.statusMessage).then(function(str) {
                            scope.availabilityText = str;
                        });

                        switch(userAvailability.status){
                            case 'Away':
                                scope.selectedDot = 'yellow';
                                break;
                            case 'Available':
                            case 'Online':
                                scope.selectedDot = 'green';
                                break;
                            case 'Busy':
                                scope.selectedDot = 'red';
                                break;
                            default:
                                scope.selectedDot = 'gray';
                        }
                    }

                    function changeStatus(status, color){
                        var updatedUser = angular.copy(user);
                        updatedUser.statusMessage = scope.statusText[status.toLowerCase()];
                        updatedUser.status = status;

                        staffAvailabilityManager.updateUserStatus(updatedUser).then(function(){
                            user = updatedUser;
                            scope.selectedDot = color;
                            scope.availabilityText = updatedUser.statusMessage;
                        });
                    }

                    function changeStatusText(){
                        // did the text even change?
                        if(scope.availabilityText === user.statusMessage){
                            return;
                        }

                        var updatedUser = angular.copy(user);
                        updatedUser.statusMessage = scope.availabilityText;

                        if(scope.selectedDot === 'gray'){
                            updatedUser.status = 'Available';
                        }

                        staffAvailabilityManager.updateUserStatus(updatedUser).then(function(){
                            user = updatedUser;

                            if(scope.selectedDot === 'gray'){
                                scope.selectedDot = 'green';
                            }
                        });
                    }
                }
            };
        }
    ]);

    module.factory('bmStaffAvailabilityManager', availablityManager);
    availablityManager.$inject = ['$http', 'bmUser'];

    function availablityManager($http, bmUser){
        var factory = {
            getUserAvailability: getUserAvailability,
            updateUserStatus: updateUserStatus
        };

        var api = '/api/profiles/v1/staff-availability';

        return factory;

        //////////

        function getUserAvailability(){
            return bmUser.load().then(function(){
                return $http.get(api + '/' + bmUser.contactId).then(function(resp){
                    if(angular.isUndefined(resp) || angular.isUndefined(resp.data) || angular.isUndefined(resp.data.staffAvailability) === 0){
                        return undefined;
                    }

                    var people = resp.data.staffAvailability;
                    var user = people.filter(function(person){
                        return person.self;
                    });

                    return user.length === 0 ? undefined : user[0];
                });
            });
        }

        function updateUserStatus(user){
            return $http({
                method: 'PUT',
                url: api,
                data: user
            });
        }
    }
})(window.angular);

(function(w, angular){
  'use strict';

  var module = angular.module('bmClientNotificationsList', ['pascalprecht.translate', 'bmJobQueue']);
  var notificationOptions = {
    itemsPerPage: 50,
    pageNumber: 1,
    scroller: undefined,
    scrollerWrapper: undefined,
    onScrollHandler: undefined,
    allLoaded: false,
    cleanUpScroller: undefined
  };

  // find the location of the element within the view
  function getOffset(el) {
    el = el.getBoundingClientRect();

    // rounding because IE is dumb
    return {
      left: w.Math.round(el.left + (w.scrollX || w.pageXOffset)),
      top: w.Math.round(el.top + (w.scrollY || w.pageYOffset)),
      bottom: w.Math.round(el.bottom + (w.scrollY  || w.pageYOffset))
    };
  }

  // taken directly from underscore _.now
  var now = Date.now || function(){
    return new Date().getTime();
  };

  // taken directly from underscore _.throttle
  var throttle = function(func, wait, options) {
    var context, args, result;
    var timeout = null;
    var previous = 0;

    if(!options){
      options = {};
    }

    var later = function(){
      previous = options.leading === false ? 0 : Date.now || now();
      timeout = null;
      result = func.apply(context, args);

      if(!timeout){
        context = args = null;
      }
    };

    var getNow = function(){
      return now;
    };

    return function(){
      var now = getNow();

      if(!previous && options.leading === false){
        previous = now;
      }

      var remaining = wait - (now - previous);
      context = this;
      args = arguments;

      if(remaining <= 0 || remaining > wait){
        if (timeout){
          clearTimeout(timeout);
          timeout = null;
        }

        previous = now;
        result = func.apply(context, args);

        if(!timeout){
          context = args = null;
        }
      } else if(!timeout && options.trailing !== false){
        timeout = setTimeout(later, remaining);
      }

      return result;
    };
  };

  module.directive('bmClientNotificationsList', ['$window', '$timeout', '$translate', 'bmClientNotificationsListManager', 'bmLanguageManager',
      function($window, $timeout, $translate, notificationsManager, bmLanguageManager){
    return {
      restrict: 'E',
      replace: true,
      templateUrl: 'components/client-notifications/client-notifications-list.2js.html',
      link: function($scope){
        var itemsPerPage = notificationOptions.itemsPerPage;
        var scrollHandler = onScrollHandler;
        var notificationMap;

        $scope.isLoading = false;
        $scope.hasZeroItems = true;
        $scope.markAllNotificationsRead = markAllNotificationsRead;
        $scope.markNotificationRead = markNotificationRead;
        $scope.deleteNotification = deleteNotification;
        $scope.getFormattedTime = getFormattedTime;

        // respond to profile menu events for loading notifications
        $scope.$on('bmProfileMenuOpened', handleOpenedMenu);
        $scope.$on('bmProfileMenuClosed', handleClosedMenu);

        // get translated tooltip for delete notification
        $translate('bm.components.common.delete').then(function(value){
          $scope.deleteTranslated = value;
        }, function(){
          $scope.deleteTranslated = 'Delete';
        });

        $scope.notifications = [];
        notificationOptions.scrollerWrapper = 'bm-ntfs-vertical-container';

        ////////////

        function loadNotifications(whichPage){
          $scope.isLoading = true;

          return notificationsManager.getNotificationList(whichPage, itemsPerPage).then(function(data){
            if(angular.isDefined(data) && angular.isDefined(data.items) && data.items.length > 0){
                $scope.hasZeroItems = false;
                notificationMap = notificationMap || {};

                // sort the items to display by most current descending
                data.items.sort(sortByDatesDescending);

                var currentItem;
                var newItems = [];

                // weed out any dupes
                for(var counter = 0; counter < data.items.length; counter++){
                  currentItem = data.items[counter];

                  // already loaded this notification?
                  if(notificationMap[currentItem.id]){
                    continue;
                  }

                  notificationMap[currentItem.id] = currentItem.id;
                  newItems.push(currentItem);
                }

                if(newItems.length > 0){
                  $scope.notifications = $scope.notifications.concat(newItems);
                }

                // hedge our bets just in case more notifications are returned than the total
                // or there are a bunch of dupes
                if($scope.notifications.length >= data.totalItems || data.items.length < itemsPerPage){
                  notificationOptions.allLoaded = true;
                } else if(angular.isUndefined(notificationOptions.onScrollHandler)){
                  // setup scroll handler to fire paging/scrolling events
                  notificationOptions.onScrollHandler = scrollHandler;
                }

                $scope.isLoading = false;
              } else {
                $scope.hasZeroItems = $scope.notifications.length === 0;
                $scope.isLoading = false;
              }
          }, function(){
              $scope.hasZeroItems = $scope.notifications.length === 0;
              $scope.isLoading = false;
          });
        }

        function onScrollHandler(){
          if(!$scope.isLoading && !notificationOptions.allLoaded){
            // get the viewport position of the last element
            var elements = document.querySelectorAll('.bm-last-notification');
            var element = elements[0];
            var positionFromTop = getOffset(element).top;

            // get the viewport position of the wrapper
            var wrapperElement = document.getElementById(notificationOptions.scrollerWrapper);
            var wrapperOffsets = getOffset(wrapperElement);

            // TODO: COULD TRY TO CALCULATE A BETTER LOADING SCENARIO USING WRAPPER HEIGHT
            // var wrapperHeight = wrapperOffsets.bottom - wrapperOffsets.top;

            // near the bottom of the scroller area - within 300 pixels (approximately 5 items) of the bottom
            if(positionFromTop - wrapperOffsets.bottom < 300){
              // TODO: THIS IS GOING TO NEED TO BE MORE COMPLICATED LOGIC
              loadNotifications(Math.floor($scope.notifications.length / itemsPerPage) + 1);
            }
          }
        }

        function handleOpenedMenu(){
          // always reload notifications when menu is opened in order to sync across sessions
          loadNotifications(1);
        }

        function handleClosedMenu(){
          // reset the notification settings so everything is reloaded fresh
          // give the profile menu some time to close before reset
          $timeout(function(){
            $scope.notifications = [];
            $scope.hasZeroItems = true;
            notificationMap = {};

            // remove notifications and cleanup
            if(angular.isDefined(notificationOptions.cleanUpScroller)){
              notificationOptions.cleanUpScroller();
            }
          }, 200);
        }

        function markAllNotificationsRead(){
          notificationsManager.markAllNotificationsRead().then(function(){
            // loop through current infiniteItems and mark them all as read
            angular.forEach($scope.notifications, function(notification){
              notification.unread = false;

              // update count badges
              $scope.$emit('bmNotificationMarkedAsRead', { all: true });
            });
          });
        }

        function markNotificationRead(notification, event){
          var isBoundHtmlClick = angular.isDefined(event.target.href) && event.target.href !== '';

          // already read?
          if(!notification.unread){
            if(isBoundHtmlClick){
              $scope.$emit('bmNotificationHtmlClick');
            }

            return;
          }

          notificationsManager.markNotificationRead(notification).then(function(){
            notification.unread = false;

            if(isBoundHtmlClick){
              // close of menu will trigger unread count update
              $scope.$emit('bmNotificationHtmlClick');
            } else {
              // update count badges
              $scope.$emit('bmNotificationMarkedAsRead');
            }
          });
        }

        function deleteNotification(notification, index){
          notificationsManager.deleteNotification(notification).then(function(){
            $scope.notifications.splice(index, 1);
            delete notificationMap[notification.id];

            // update count badges if deleted item was unread
            if(notification.unread){
              $scope.$emit('bmNotificationMarkedAsRead');
            }

            if($scope.notifications.length === 0){
              $scope.hasZeroItems = true;
            }

            // force a load of notifications if list is getting small as scroll event won't fire
            if(!$scope.isLoading && !notificationOptions.allLoaded && $scope.notifications.length < 30){
              loadNotifications(1);
            }
          });
        }

        function getFormattedTime(time){
          if(!time){
            return '';
          }

          if($window.moment){
            $window.moment.locale(bmLanguageManager.getCurrentLanguage());
            var now = $window.moment.utc();
            var notificationTime = $window.moment.utc(time);

            // today
            if(now.diff(notificationTime, 'days') <= 0){
              return notificationTime.from(now);
            }

            // different year
            if(now.diff(notificationTime, 'years') > 0){
              return notificationTime.format('MMMM D, YYYY');
            }

            return notificationTime.format('MMMM D');
          }

          return (new Date(time)).toLocaleString();
        }

        function sortByDatesDescending(first, second){
          var firstDate = (new Date(first.timestamp)).getTime();
          var secondDate = (new Date(second.timestamp)).getTime();

          if(isNaN(firstDate) && isNaN(secondDate)){
            return 0;
          }

          if(isNaN(firstDate)){
            return 1;
          }

          if(isNaN(secondDate)){
            return -1;
          }

          return secondDate - firstDate;
        }
      }
    };
  }]);

  module.directive('bmNotificationsLastRepeatTask', [function(){
    return function(scope) {
      // only 1 item in the list?
      if(scope.$first && scope.$last){
        return;
      }

      // initialize scroll events once the last repeated element is in the dom
      if(scope.$last){
        if(angular.isUndefined(notificationOptions.scroller) && angular.isDefined(notificationOptions.onScrollHandler)){
          var throttledScroll = throttle(notificationOptions.onScrollHandler);

          // reference the wrapper element
          notificationOptions.scroller = w.document.getElementById(notificationOptions.scrollerWrapper);
          notificationOptions.scroller.onscroll = throttledScroll;
          notificationOptions.cleanUpScroller = function(){
            notificationOptions.scroller.onscroll = null;
            notificationOptions.scroller = undefined;
            notificationOptions.onScrollHandler = undefined;
            notificationOptions.allLoaded = false;
          };
        }
      }
    };
  }]);

  module.factory('bmClientNotificationsListManager', notificationsManager);
  notificationsManager.$inject = ['$http'];

  function notificationsManager($http){
    var api = '/api/notifications/v1/notifications';

    return {
        getNotificationList: getNotificationList,
        getUnreadNotificationCounts: getUnreadNotificationCounts,
        markNotificationRead: markNotificationRead,
        markAllNotificationsRead: markAllNotificationsRead,
        deleteNotification: deleteNotification
    };

    //////////////////

    function getNotificationList(pageNumber, itemsPerPage){
        if(angular.isUndefined(pageNumber)){
          pageNumber = notificationOptions.pageNumber;
        }

        if(angular.isUndefined(itemsPerPage)){
          itemsPerPage = notificationOptions.itemsPerPage;
        }

        var httpConfig = {
            method: 'GET',
            url: api + '?types=direct&itemsPerPage=' + itemsPerPage + '&pageNumber=' + pageNumber
        };

        return $http(httpConfig).then(function(response){
            return response.data;
        });
    }

    function getUnreadNotificationCounts(){
      // cache for 5 seconds
      return $http({
        method: 'GET',
        url: api + '/unread',
        bmCache: 5000
      }).then(function(response) {
        return response.data;
      }, function(response){
        response.config.global = false;
      });
    }

    function markNotificationRead(notification){
      return $http({
        method: 'POST',
        url: api + '/read/' + notification.id
      });
    }

    function markAllNotificationsRead(){
      return $http({
        method: 'POST',
        url: api + '/read'
      });
    }

    function deleteNotification(notification){
      return $http({
        method: 'DELETE',
        url: api + '/' + notification.id
      });
    }
  }
})(window, window.angular);

(function(RegExp, angular){
  'use strict';

  // https://code.angularjs.org/1.5.11/docs/guide/forms - modifying built-in validators
  angular.module('bmValidateEmail', [])
  .directive('bmValidateEmail', function(){
    // taken from staff center contact setup validation
    var EMAIL_REGEXP = new RegExp('^((([a-z]|\\d|[!#\\$%&\'\\*\\+\\-\\/=\\?\\^_`{\\|}~]|[\\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF])+(\\.([a-z]|\\d|[!#\\$%&\'\\*\\+\\-' +
      '\\/=\\?\\^_`{\\|}~]|[\\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF])+)*)|((\\x22)((((\\x20|\\x09)*(\\x0d\\x0a))?(\\x20|\\x09)+)?(([\\x01-\\x08\\x0b' +
      '\\x0c\\x0e-\\x1f\\x7f]|\\x21|[\\x23-\\x5b]|[\\x5d-\\x7e]|[\\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF])|(\\\\([\\x01-\\x09\\x0b\\x0c\\x0d-\\x7f]|' +
      '[\\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF]))))*(((\\x20|\\x09)*(\\x0d\\x0a))?(\\x20|\\x09)+)?(\\x22)))@((([a-z]|\\d|[\\u00A0-\\uD7FF\\uF900-' +
      '\\uFDCF\\uFDF0-\\uFFEF])|(([a-z]|\\d|[\\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF])([a-z]|\\d|-|\\.|_|~|[\\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-' +
      '\\uFFEF])*([a-z]|\\d|[\\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF])))\\.)+(([a-z]|[\\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF])|(([a-z]|' +
      '[\\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF])([a-z]|\\d|-|\\.|_|~|[\\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF])*([a-z]|[\\u00A0-\\uD7FF' +
      '\\uF900-\\uFDCF\\uFDF0-\\uFFEF])))\\.?$', 'i');

    return {
      require: 'ngModel',
      restrict: '',
      link: function(scope, elm, attrs, ctrl) {
        // only apply the validator if ngModel is present and Angular has added the email validator
        if (ctrl && ctrl.$validators.email){
          // this will overwrite the default Angular email validator
          ctrl.$validators.email = function(modelValue){
              //The above regex is handling all special chars except DOT(.), so just added that condition check below.
            return ctrl.$isEmpty(modelValue) || ((EMAIL_REGEXP.test(modelValue) && modelValue.charAt(modelValue.length - 1) !== '.'));
          };
        }
      }
    };
  });
})(window.RegExp, window.angular);

(function(angular){
  'use strict';

  angular.module('bmCheckpointCredentials', [
    'pascalprecht.translate',
    'bento.modern',
    'bmPermission'
  ])
  .constant('bmCheckpointRoutes', {
    checkpointSetCredsApi: '/api/workpapers/v1/CheckpointLogin',
    checkpointExistsApi: '/api/workpapers/v1/CheckpointLogin/exists',
    checkpointSessionApi: '/api/smart/integration/v1/sessions'
  })
  .service('bmCheckpointManager', bmCheckpointManager)
  .component('bmCheckpointCredentials', {
    bindings: {
      sharedData: '='
    },
    templateUrl: 'components/checkpoint-engage/checkpoint-engage.2js.html',
    controller: CheckpointCredentialsController,
  });

  // Component Implementation
  CheckpointCredentialsController.$inject = ['$scope', '$translate', 'bmPermission', 'bmCheckpointManager'];
  function CheckpointCredentialsController($scope, $translate, bmPermission, bmCheckpointManager){
    /*jshint validthis:true */
    var ctrl = this;
    var masterData = { uid: '', pwd: '', agree: false };
    var loadedCreds;

    ctrl.$onInit = init;

    /////////////////////////

    function init(){
      ctrl.hasPermission = false;
      ctrl.credsExist = false;
      ctrl.alerts = [];
      ctrl.userData = angular.copy(masterData);
      // ctrl.entitlementData = {};

      // 2-way bound data object to pass information between tabs
      ctrl.sharedLocal = ctrl.sharedData;
      ctrl.sharedLocal.hasUnsavedCheckpoint = false;

      // Create method publicly available through 2-way data bound object
      ctrl.sharedLocal.setCheckpointDirty = setCheckpointDirty;

      // supported actions
      ctrl.actions = {
        saveUserData: saveUserData,
        cancelUserData: cancelUserData,
        deleteUserData: deleteUserData
      };

      // load up checkpoint credentials
      bmPermission.has('Applications.CheckpointEngage').then(function(){
        bmCheckpointManager.getCheckpointCredentials().then(function(creds){
          if(angular.isDefined(creds) && creds.Exists){
            ctrl.credsExist = true;
            loadedCreds = creds;

            bmCheckpointManager.getCheckpointEntitlementDataForSession().then(function(entitlementData){
              $translate('bm.header.checkpoint.removeTextWithName', { 'n0': entitlementData.fullName }).then(function(value){
                ctrl.removeText = value;
              });
            }, function(){
              $translate('bm.header.checkpoint.removeText').then(function(value){
                ctrl.removeText = value;
              });
            });

          } else {
            ctrl.credsExist = false;
          }

          ctrl.hasPermission = true;
        }, function(){
          ctrl.hasPermission = false;
          $translate('bm.header.checkpoint.permissionDenied').then(function(value){
            addAlert(value, 'danger');
          });
        });
      }, function(){
        ctrl.hasPermission = false;
        $translate('bm.header.checkpoint.permissionDenied').then(function(value){
          addAlert(value, 'danger');
        });
      });
    }

    function saveUserData(){
      resetAlerts();

      // is the form valid?
      if(ctrl.checkpointForm.$invalid){
        setFormValidity();
        return;
      }

      // agreed to license?
      if(ctrl.userData.agree === false){
        $translate('bm.header.checkpoint.licenseRequired').then(function(msg){
          addAlert(msg, 'danger');
        });

        return;
      }

      // all good, let's save the credentials
      $scope.$emit('bm-busy-loading-on');
      bmCheckpointManager.saveCheckpointCredentials({
        'apiversion': 1,
        'data': {
          'kind': 'credentials',
          'accessKey': '',
          'userName': ctrl.userData.uid,
          'password': ctrl.userData.pwd
        }
      }).then(function(result){
        $scope.$emit('bm-busy-loading-off');
        // add name to results for remove text display
        result.name = ctrl.userData.uid;
        handleSaveSuccessDisplay(result);
      }, function(error){
        $scope.$emit('bm-busy-loading-off');
        handleSaveErrorDisplay(error);
      });
    }

    function cancelUserData(){
      if(ctrl.sharedLocal.resetOnCancel){
        // clear the user data and reset form
        resetAlerts();
        resetEntryForm(true);
      }

      $scope.$emit('bmProfileCancelAction');
    }

    function resetEntryForm(resetData){
      if(resetData){
        ctrl.userData = angular.copy(masterData);
      }

      ctrl.checkpointForm.$setPristine();
      ctrl.checkpointForm.uid.$setPristine();
      ctrl.checkpointForm.uid.$setValidity('required', true);
      ctrl.checkpointForm.pwd.$setPristine();
      ctrl.checkpointForm.pwd.$setValidity('required', true);
    }

    function deleteUserData(){
      resetAlerts();

      // make sure the creds are loaded
      if(angular.isUndefined(loadedCreds)){
        handleDeleteErrorDisplay();
        return;
      }

      $scope.$emit('bm-busy-loading-on');
      bmCheckpointManager.deleteCheckpointCredentials(loadedCreds.UserDataId).then(function(){
        $scope.$emit('bm-busy-loading-off');
        handleDeleteSuccessDisplay();
      }, function(reject){
        $scope.$emit('bm-busy-loading-off');

        var error = { message: 'error' };

        // get the actual error data
        if(angular.isDefined(reject) && angular.isDefined(reject.data)){
          error = reject.data.error;

          if(angular.isUndefined(error.message) || error.message === ''){
            error.message = 'error';
          }
        }

        handleDeleteErrorDisplay(error);
      });
    }

    function setFormValidity(){
      $translate('BM.Components.IncompleteForm').then(function(msg){
        addAlert(msg, 'danger');
      });

      // toggle all validation messages
      if(ctrl.checkpointForm.uid.$error.required){
        ctrl.checkpointForm.uid.$setDirty();
        ctrl.checkpointForm.uid.$setTouched();
      }

      if(ctrl.checkpointForm.pwd.$error.required){
        ctrl.checkpointForm.pwd.$setDirty();
        ctrl.checkpointForm.pwd.$setTouched();
      }
    }

    function handleSaveSuccessDisplay(data){
      // wipe form entry
      resetEntryForm(true);

      if(angular.isUndefined(data)){
        handleSaveErrorDisplay(data);
        return;
      }

      if(data.message === 'success'){
        $translate('bm.header.checkpoint.saveSuccessful').then(function(value){
          addAlert(value, 'success');
        });
      } else {
        addAlert(data.message, 'success');
      }

      // setup as creds already entered
      $translate('bm.header.checkpoint.removeText', { 'n0': data.name }).then(function(value){
        ctrl.removeText = value;
      });

      ctrl.credsExist = true;
      loadedCreds = {
        Exists: true,
        UserDataId: data.Id
      };

      ctrl.sharedLocal.hasUnsavedCheckpoint = false;
    }

    function handleSaveErrorDisplay(data){
      // generic error message
      if(angular.isUndefined(data) || data.message === 'error'){
        $translate('bm.header.checkpoint.saveError').then(function(value){
          addAlert(value, 'danger');
        });

        return;
      }

      addAlert(data.message, 'danger');
    }

    function handleDeleteSuccessDisplay(){
      ctrl.credsExist = false;
      loadedCreds = null;

      $translate('bm.header.checkpoint.deleteSuccessful').then(function(value){
        addAlert(value, 'success');
      });
    }

    function handleDeleteErrorDisplay(data){
      if(angular.isUndefined(data) || data.message === 'error'){
       $translate('bm.header.checkpoint.deleteError').then(function(value){
          addAlert(value, 'danger');
        });

        return;
      }

      addAlert(data.message, 'danger');
    }

    function setCheckpointDirty(){
      var isClean = angular.equals(masterData, ctrl.userData);
      resetAlerts();

      // only reset the form if its visible
      if(ctrl.hasPermission && !ctrl.credsExist){
        resetEntryForm(false);
      }

      ctrl.sharedLocal.hasUnsavedCheckpoint = !isClean;
    }

    function addAlert(message, type){
      resetAlerts();
      ctrl.alerts.push({ msg: message, type: type, closeable: true, timeout: 2500 });
    }

    function resetAlerts(){
      ctrl.alerts.length = 0;
    }
  }

  // Service Implementation
  bmCheckpointManager.$inject = ['$q', '$http', 'bmCheckpointRoutes'];
  function bmCheckpointManager($q, $http, apiRoutes){
    /*jshint validthis:true */
    var self = this;

    self.getCheckpointCredentials = getCheckpointCredentials;
    self.saveCheckpointCredentials = saveCheckpointCredentials;
    self.deleteCheckpointCredentials = deleteCheckpointCredentials;
    self.getCheckpointEntitlementDataForSession = getCheckpointEntitlementDataForSession;

    ////////////////////////////

    function getCheckpointCredentials() {
      return $http({
        method: 'GET',
        url: apiRoutes.checkpointExistsApi,
        global: false
      }).then(function(resp){
        // return the actual crendential data
        return angular.isDefined(resp) && angular.isDefined(resp.data)? resp.data.data : resp;
      });
    }

    function saveCheckpointCredentials(creds){
      var deferred = $q.defer();

      if(angular.isUndefined(creds)){
        deferred.reject('NOCREDS');
        return deferred.promise;
      }

      $http({
        method: 'POST',
        url: apiRoutes.checkpointSetCredsApi,
        headers: {'Content-Type': 'application/json'},
        data: creds,
        global: false
      }).then(function(resp){
        // return the actual crendential data
        if(angular.isDefined(resp) && angular.isDefined(resp.data)){
          var data = resp.data.data || {};

          if(angular.isUndefined(data.message) || data.message === ''){
            data.message = 'success';
          }

          deferred.resolve(data);
        }

        // handle as generic success
        deferred.resolve();
      }, function(reject){
        // return the actual error data
        if(angular.isDefined(reject) && angular.isDefined(reject.data)){
          var error = reject.data.error || {};

          if(angular.isUndefined(error.message) || error.message === ''){
            error.message = 'error';
          }

          deferred.reject(error);
        }

        // handle as generic error
        deferred.reject();
      });

      return deferred.promise;
    }

    function deleteCheckpointCredentials(userDataId){
      var deferred = $q.defer();

      if(angular.isUndefined(userDataId)){
        deferred.reject('NOUSERDATAID');
        return deferred.promise;
      }

      return $http({
        method: 'DELETE',
        url: apiRoutes.checkpointSetCredsApi + '/' + userDataId,
        global: false
      });
    }

    function getCheckpointEntitlementDataForSession(){
      return $http({
        method: 'GET',
        url: apiRoutes.checkpointSessionApi,
        global: false
      }).then(function(resp){
        // return the actual crendential data
        return angular.isDefined(resp) && angular.isDefined(resp.data)? resp.data.data : resp;
      });
    }
  }
})(window.angular);

(function(angular){
  'use strict';

  angular.module('bmPreferenceService', [
    'bmEnvironment',
    'bluemoon.components.util'
  ])
  .service('bmPreferenceService', PreferenceService);

  PreferenceService.$inject = ['$window', '$q', '$http', 'bmEnvironment', 'bmUtil'];
  function PreferenceService($window, $q, $http, environment, bmUtil){
    /*jshint validthis:true */
    var self = this;

    self.getPreferences = getPreferences;
    self.getPreference = getPreference;
    self.addPreference = addPreference;
    self.removePreference = removePreference;

    ////////////////////////////

    // use the profile api returned from environments
    function getUserPreferenceApi(){
      return $q.when('/api/profiles/v1/preferences');
    }

    function getCompanyPreferenceApi(companyId){
      return $q.when('/api/profiles/v1/companies/' + companyId + '/preferences');
    }

    function getPreferences(companyId) {
      if(bmUtil.isNullOrEmpty(companyId)){
        return getUserPreferences();
      } else {
        return getCompanyPreferences(companyId);
      }
    }

    function getCompanyPreferences(companyId) {
      return getCompanyPreferenceApi(companyId).then(function(api){
        return $http.get(api).then(function(preferences){
          return preferences;
        });
      });
    }

    function getPreference(companyId, application, category) {
      if(bmUtil.isNullOrEmpty(companyId)){
        return getUserPreference(application, category);
      } else {
        return getCompanyPreference(companyId, application, category);
      }
    }

    function addPreference(companyId, preference) {
      if(bmUtil.isNullOrEmpty(companyId)){
        return addUserPreference(preference);
      } else {
        return addCompanyPreference(companyId, preference);
      }
    }

    function getCompanyPreference(companyId, application, category) {
      return getCompanyPreferenceApi(companyId).then(function(api){
        return $http({
          method: 'GET',
          url: api,
          params: {application: application, category: category}
        });
      });
    }

    function getUserPreference(application, category){
      return getUserPreferenceApi().then(function(api){
        return $http({
          method: 'GET',
          url: api,
          params: {application: application || '', category: category || ''}
        });
      });
    }

    function addCompanyPreference(companyId, preference) {
      return getCompanyPreference(companyId, preference.application, preference.category).then(function(response){
        var preferences = response.data;
        if(bmUtil.isNullOrEmpty(preferences) || preferences.length === 0){
          return createPreference(companyId, preference);
        } else {
          var preferenceId = preferences[0].id;
          return updatePreference(companyId, preference, preferenceId);
        }
      });
    }

    function createPreference(companyId, preference){
      return getCompanyPreferenceApi(companyId).then(function(api){
        return $http({
          method: 'POST',
          url: api,
          data: preference
        });
      });
    }

    function updatePreference(companyId, preference, preferenceId){
      return getCompanyPreferenceApi(companyId).then(function(api){
        return $http({
          method: 'PUT',
          url: api + '/' + preferenceId,
          data: preference
        });
      });
    }

    function removePreference() {
      // TODO
    }
    function getUserPreferences() {
      // TODO
    }
    function addUserPreference() {
      // TODO
    }
  }
})(window.angular);

(function(angular){
  'use strict';

  angular.module('bmMultifactorService', [
    'bmEnvironment',
    'bmAccess',
    'bmPreferenceService',
    'bluemoon.components.session',
    'bluemoon.components.util'
  ])
  .service('bmMultifactorService', MultifactorService);

  MultifactorService.$inject = ['$window', '$q', '$http', 'bmEnvironment', 'AuthenticatedSession', 'bmAccess', 'bmPreferenceService', 'bmUtil', 'languageStorageManager'];
  function MultifactorService($window, $q, $http, environment, session, bmAccess, preferenceService, bmUtil, langMgr){
    /*jshint validthis:true */
    var self = this;
    var authApi;
    var mfaApi;
    var productOptions;
    // TODO: COULD SET THIS AS A CONSTANT
    var products = {
      onvio: {
        sp: 'onvio',
        type: 'ONVIO'
      },
      auth: {
        sp: 'csweb',
        type: 'CSWEB'
      }
    };

    self.getFactors = getFactors;
    self.deleteFactors = deleteFactors;
    self.deleteFactor = deleteFactor;
    self.initFactorSetup = initFactorSetup;
    self.verifyLoginData = verifyLoginData;
    self.getAllFactors = getAllFactors;
    self.enableMultifactorAuthCode = enableMultifactorAuthCode;
    self.registerMultifactorAuthCode = registerMultifactorAuthCode;
    self.getUserJwtToken = getUserJwtToken;

    self.staffRequired = staffRequired;
    self.clientsRequired = clientsRequired;
    self.userRequired = userRequired;
    self.setStaffRequired = setStaffRequired;
    self.setClientsRequired = setClientsRequired;
    self.getMfaStaffPreference = getMfaStaffPreference;
    self.getMfaClientPreference = getMfaClientPreference;

    ////////////////////////////

    function getMfaProductOptions(){
      if(productOptions){
        return $q.when(productOptions);
      }

      return environment.getPrimaryProduct().then(function(productName){
        // default to onvio options
        productOptions = products[productName] ? products[productName] : products.onvio;
        return productOptions;
      });
    }

    // use the auth api returned from environments
    // ex. AuthenticationAggregatorServices: "https://demo.onvio.us/api/auth"
    function getAuthApiRoute(){
      if(authApi){
        return $q.when(authApi);
      }

      // make this work for local development
      if($window.location.host === 'localhost:9000'){
        authApi = 'https://localhost:9000';
        return $q.when(authApi);
      }

      return environment.getRoute('AuthenticationAggregatorServices').then(function(api){
        // make sure to use the protocol used by the browser host and not the route host
        var routeUri = bmUtil.parseUri(api);
        var hostUri = bmUtil.parseUri($window.location);
        authApi = hostUri.protocol + '//' + routeUri.host;
        return authApi;
      });
    }

    // use the mfa api returned from environments
    function getMfaApi(){
      if(mfaApi){
        return $q.when(mfaApi);
      }

      return getAuthApiRoute().then(function(api){
        mfaApi = api + '/api/mfa';
        return mfaApi;
      });
    }

    function getJwtToken(){
      // TODO: AT SOMEPOINT WE MAY NEED TO EXPLICITY FIND IT BASED ON PRODUCT TYPE
      // TO AVOID CLASHING CACHE OR EXPIRED TOKENS
      // onvio uses session storage
      var token = $window.sessionStorage.getItem('tr-auth-token');

      // csweb uses local storage
      if(bmUtil.isNullOrEmpty(token)){
        token = $window.localStorage.getItem('tr-auth-token');
      }

      return token;
    }

    function getBaseFactorsConfig(jwtToken){
      var jwt = jwtToken ? jwtToken : getJwtToken();

      if(jwt === null || angular.isUndefined(jwt) || jwt === ''){
        return null;
      }

      return {
        method: 'GET',
        bmNoAuth: true,
        bmAuthRedirect: false,
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'x-prevent-unauthorized': true,
          'Authorization': 'Bearer ' + jwt
        }
      };
    }

    function getFactors(allTypes){
      var config = getBaseFactorsConfig();

      if(config === null){
        // send back an empty array if jwt not found
        return $q.when([]);
      }

      // must have IAC in order to actually make request for factors
      // TODO: AT SOME POINT THIS IAC CHECK WILL NEED TO GO AWAY
      return bmAccess.has('Platform_Enable2FA').then(function(){
        return getMfaApi().then(function(api){
          config.url = api + '/v1/factors';
          // don't set errors as global
          config.global = false;

          return $http(config).then(function(resp){
            // really only want factors that are registered and devices
            var factors = [];

            // filter out any 24-hour codes
            if(angular.isArray(resp.data) && resp.data.length > 0){
              factors = resp.data.filter(function(factor){
                return allTypes ? true : angular.isString(factor.type) && factor.type.toUpperCase() !== 'B';
              });
            }

            return factors;
          }, function(){
            // TODO: MAY NEED TO HANDLE THIS DIFFERENTLY
            // send back an empty array if data failed to load
            return [];
          });
        });
      }).catch(function(){
        return [];
      });
    }

    function deleteFactors(factors, jwtToken){
      var deferred = $q.defer();
      if(!angular.isArray(factors) || factors.length === 0){
        deferred.reject('NOFACTORS');
        return deferred.promise;
      }

      var config = jwtToken ? getBaseFactorsConfig(jwtToken) : getBaseFactorsConfig();

      if(config === null){
        deferred.reject();
        return deferred.promise;
      }

      config.method = 'DELETE';

      return getMfaApi().then(function(api){
        config.url = api + '/v1/factors/';

        // don't set errors as global
        config.global = false;

        // need to send a delete for each factor
        var promises = [];

        angular.forEach(factors, function(factor){
          var factorConfig = angular.copy(config);
          factorConfig.url = factorConfig.url + factor.id;
          promises.push($http(factorConfig));
        });

        return $q.all(promises);
      });
    }
    function deleteFactor(factor){

      var config = getBaseFactorsConfig();

      if(config === null){
        $q.reject();
      }

      config.method = 'DELETE';

      return getMfaApi().then(function(api){
        config.url = api + '/v1/factors/';

        // don't set errors as global
        config.global = false;

        var factorConfig = angular.copy(config);
        factorConfig.url = factorConfig.url + factor.id;
        return $http(factorConfig);
      });
    }

    function enableMFACards() {
        return bmAccess.has('Platform_EnableMFACards').then(function() {
            return $q.resolve(true);
        }, function() {
            return $q.resolve(false);
        });
    }

    function initFactorSetup(email, showEmergencyCodesForm){
      var currentLang;

      return enableMFACards().then(function(enableMFACards) {
        return getAuthApiRoute().then(function(api){
          return getMfaProductOptions().then(function(options){
            currentLang = langMgr.get();
            var initSettings = {
              // targetElem: <targetContainer>,
              type: options.type,
              sp: options.sp,
              locale: currentLang,
              enableMFACards: enableMFACards,
              templateData: {
                authSvcHost: api,
                uid: email
              },
              headers: {
                authorization: 'Bearer ' + getJwtToken()
              }
            };
            if (showEmergencyCodesForm) {
              initSettings.startingForm = 'trta1-mfs-emergencycodes';
            }
            return $window.trAuth.modules.mfs.init(initSettings);
          });
        });
      });
    }

    function verifyLoginData(data){
      if(angular.isUndefined(data) || bmUtil.isNullOrEmpty(data.uid) || bmUtil.isNullOrEmpty(data.pwd)){
        var deferred = $q.defer();
        deferred.reject();
        return deferred.promise;
      }

      // TODO: RIGHT NOW THIS PASSWORD CHECK IS SET TO TRID INSTEAD OF PRODUCT OPTIONS
      // set the type just to be safe
      if(angular.isUndefined(data.type) || bmUtil.isNullOrEmpty(data.type)){
        data.type = 'TRID';
      }

      return getAuthApiRoute().then(function(api){
        return $http({
          method: 'POST',
          url: api + '/api/auth/v1/login/authentication',
          data: data,
          global: false
        });
      });
    }

    function staffRequired(companyId){
      if(angular.isUndefined(companyId)) {
        return $q.reject();
      }

      return getMfaStaffPreference(companyId).then(function(response){
          if(angular.isArray(response.data) && response.data.length > 0) {
            // there should only be one mfa-staff preference
            var preference = response.data[0];
            return preference.value && preference.value.required || false;
          }
          return false;
      });
    }

    function setStaffRequired(companyId, staffRequired) {
      if(angular.isUndefined(companyId) || angular.isUndefined(staffRequired)) {
        return $q.reject();
      }

      return setMfaStaffPreference(companyId, staffRequired);
    }

    function clientsRequired(companyId){
      if(angular.isUndefined(companyId)) {
        return $q.reject();
      }
      return getMfaClientPreference(companyId).then(function(response){
        if(angular.isArray(response.data) && response.data.length > 0) {
          // there should only be one mfa-client preference
          var preference = response.data[0];
          return preference.value && preference.value.required || false;
        }
        return false;
      });
    }

    function setClientsRequired(companyId, clientsRequired){
      if(angular.isUndefined(companyId) || angular.isUndefined(clientsRequired)) {
        $q.reject();
      }

      return setMfaClientPreference(companyId, clientsRequired);
    }

    function getMfaStaffPreference(companyId){
      var application = 'onvio';
      var category = 'mfa-staff';
      return preferenceService.getPreference(companyId, application, category);
    }

    function setMfaStaffPreference(companyId, staffRequired){
      var preference = {
        application: 'onvio',
        category: 'mfa-staff',
        value: { required: staffRequired }
      };
      return preferenceService.addPreference(companyId, preference);
    }

    function setMfaClientPreference(companyId, clientsRequired){
      var preference = {
        application: 'onvio',
        category: 'mfa-client',
        value: { required: clientsRequired }
      };
      return preferenceService.addPreference(companyId, preference);
    }

    function getMfaClientPreference(companyId){
      var application = 'onvio';
      var category = 'mfa-client';
      return preferenceService.getPreference(companyId, application, category);
    }

    function userRequired(){
      // TODO: DOES THIS APPLY TO CSWEB???
      var companyId = session.data.bindings.ApplicationConfiguration.CompanyId;
      var grants = session.data.bindings.Grants;
      var isStaff = grants.indexOf('staff') > -1;
      var isClient = grants.indexOf('client') > -1;
      var promises = [
        staffRequired(companyId),
        clientsRequired(companyId)
      ];

      return $q.all(promises).then(function(results){
        var staffIsRequired = results[0];
        var clientIsRequired = results[1];

        return (isClient && clientIsRequired) || (isStaff && staffIsRequired);
      }, function(){
        return false;
      });
    }

    function getAllFactors(jwtToken) {
      if(jwtToken === null || angular.isUndefined(jwtToken) || jwtToken === ''){
        // send back an empty array if jwt not found
        return $q.when([]);
      }

      var config = {
        method: 'GET',
        bmNoAuth: true,
        bmAuthRedirect: false,
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'x-prevent-unauthorized': true,
          'Authorization': 'Bearer ' + jwtToken
        }
      };

      return getMfaApi().then(function(api) {
        api = api + '/v1/factors';
        config.url = api;

        var factors = [];
        return $http(config).then(function(resp){
          if(angular.isArray(resp.data) && resp.data.length > 0){
            factors = resp.data;
          }
          factors = sortAuthCodeList(factors);
          return factors;
        });
      }).catch(function(){
        return [];
      });
    }

    function getUserJwtToken(contactId) {
      if(angular.isUndefined(contactId)){
        var deferred = $q.defer();
        deferred.reject({ data: 'Invalid contact - unable to get jwt token' });
        return deferred.promise;
      }

      var securityApi = '/api/security/v1/jwt/contacts/';
      var url = securityApi + contactId;
      var options = {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        }
      };

      return $http.post(url, options);
    }

    function enableMultifactorAuthCode(jwtToken) {
      var data = {'type': 'B', 'address': '24-hour code'};
      var options = {
        headers: {'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': 'Bearer ' + jwtToken,
            'x-prevent-unauthorized': true,
            'Cache-Control': 'no-cache'
        },
        bmNoAuth: true,
        bmAuthRedirect: false,
      };

      return getMfaApi().then(function(api) {
        var url = api + '/v1/factors';
        return $http.post(url, data, options);
      }).catch(function(resp){
        return resp;
      });
    }

    function registerMultifactorAuthCode(jwtToken, inputData) {
      var factor = {
        'name' : '24-hour code',
        'address' : 'Support'
      };
      var data = {
        'mfarId' : inputData.mfarId,
        'factor' : factor
      };
      var options = {
        headers : {
          'Content-Type' : 'application/json',
          'Accept' : 'application/json',
          'Authorization' : 'Bearer' + ' ' + jwtToken,
          'x-prevent-unauthorized': true,
          'Cache-Control' : 'no-cache'
        },
        bmNoAuth: true,
        bmAuthRedirect: false,
        timeout : 60000000
      };

      return getMfaApi().then(function(api) {
        var url = api + '/v1/factors/' + inputData.factorId + '/register';
        return $http.post(url, data, options);
      }).catch(function(resp){
        return resp;
      });
    }

    function sortAuthCodeList(authCodeList) {
      authCodeList.sort(function(a,b) {
        a = new Date(a.registered);
        b = new Date(b.registered);
        return b - a;
      });

      return authCodeList;
    }
  }
})(window.angular);

(function(angular){
  'use strict';

  angular.module('bmMultifactorProfile', [
    'ui.bootstrap',
    'pascalprecht.translate',
    'bento.modern',
    'bluemoon.components.util',
    'bmMultifactorService',
  ])
  .component('bmMultifactorProfile', {
    bindings: {
      userData: '<',
      helpLink: '@'
    },
    templateUrl: 'components/multi-factor/multi-factor-profile.2js.html',
    controller: MultifactorProfileController,
  });

  MultifactorProfileController.$inject = ['$window', '$rootScope', '$scope', '$timeout', '$translate', '$uibModal', 'bmMultifactorService', 'languageStorageManager'];
  function MultifactorProfileController($window, $rootScope, $scope, $timeout, $translate, $uibModal, mfaService, languageStorageManager){
    /*jshint validthis:true */
    var ctrl = this;
    var andText = 'and';
    var prefLang = languageStorageManager.get() || 'en-US';

    ctrl.$onInit = init;
    ctrl.helpLangCode = prefLang.toLowerCase().split('-').reverse().join('-');

    ////////////////////////////

    function init(){
      ctrl.user = ctrl.userData;
      ctrl.factors = [];
      ctrl.pairedDeviceText = '';
      ctrl.actions = {
        openConfirmModal: openConfirmModal,
        cancelProfile: cancelProfile
      };

      mfaService.userRequired().then(function(required){
        ctrl.required = required;
      });

      $timeout(function() {
        // localize now (well..next cycle, to get around refresh bug)
        localize();

        // localize on lang change (next cycle to debounce)
        $rootScope.$on('bmLanguageChangeSuccess', localize);
      }, 0);
    }

    function localize(){
      // set factors after text is translated
      $translate('bm.header.viewProfile.And').then(function(value){
        andText = value;
      }).finally(function(){
        setFactors();
      });
    }

    function setFactors(){
      // reset current list of factors
      ctrl.factors = [];

      mfaService.getFactors(true).then(function(factors){
        ctrl.factors = factors;
        setMultiComplete();
      });
    }

    function setMultiComplete(){
      ctrl.devices = ctrl.factors.filter(function(factor) {
        return angular.isString(factor.type) && factor.type.toUpperCase() !== 'B' && factor.type.toUpperCase() !== 'C';
      });
      ctrl.mutliFactorComplete = angular.isArray(ctrl.factors) && ctrl.factors.length > 0;
      // set paired device text
      if(ctrl.mutliFactorComplete){
        if(ctrl.factors.length === 1){
          ctrl.pairedDeviceText = '"' + ctrl.factors[0].name + '."';
        } else if(ctrl.factors.length === 2){
          ctrl.pairedDeviceText = '"' + ctrl.factors[0].name + '" ' + andText + ' "' + ctrl.factors[1].name + '."';
        } else {
          var isLast = false;

          for(var index = 0; index < ctrl.factors.length; index++){
            isLast = index === ctrl.factors.length - 1;

            if(index !== 0){
              ctrl.pairedDeviceText+= ', ';
            }

            ctrl.pairedDeviceText+= (isLast ? andText + ' ' : '') + '"' + ctrl.factors[index].name + (isLast ? '."' : '"');
          }
        }
      }
    }

    function cancelProfile(){
      $scope.$emit('bmProfileCancelAction');
    }

    function openConfirmModal(action, factor){
      var modalInstance = $uibModal.open({
        templateUrl: 'components/multi-factor/multi-factor-profile-modal.2js.html',
        controller: 'bmMfaConfirmDeviceCtrl as vm',
        backdrop: 'static',
        resolve: {
          action: function(){
            return action;
          },
          factor: function(){
            return factor;
          },
          // TODO: DO WE NEED THIS USER?
          user: function(){
            return ctrl.user;
          }
        }
      });

      modalInstance.result.then(function(isConfirmed){
        if(isConfirmed){
          if(action === 'add'){
            startMultiSetup(action);
          } else if(action === 'remove') {
            deleteFactor(factor);
          } else if (action === 'generate') {
            generateEmergencyCodes();
          }
        }
      });
    }
    function generateEmergencyCodes() {
      mfaService.initFactorSetup(ctrl.user.email, true);
    }
    function removeMulti(){
      $rootScope.$emit('bm-busy-loading-on');
      mfaService.getFactors(true).then(function(factors){
        ctrl.factors = factors;
        mfaService.deleteFactors(ctrl.factors).then(function(){
          setFactors();
          $rootScope.$emit('bm-busy-loading-off');
        }, function(){
          $rootScope.$emit('bm-busy-loading-off');
        });
      }, function(){
        $rootScope.$emit('bm-busy-loading-off');
      });
    }
    function deleteFactor(factor){
      $rootScope.$emit('bm-busy-loading-on');
      mfaService.deleteFactor(factor).then(function(){
        setFactors();
        $rootScope.$emit('bm-busy-loading-off');
      }, function(){
        $rootScope.$emit('bm-busy-loading-off');
      });
    }

    function startMultiSetup(action) {
      // make sure to use the local copy of email as it can be updated on account tab
      mfaService.initFactorSetup(ctrl.user.email).then(function(mfaDialog) {
        mfaDialog.addEventListener('tr-mfs-exit', function() {
          // done in $timeout in order for scope to update
          $timeout(function() {
            // remove existing factors first just to keep the added factor in the list
            // at this time only allowing 1 device to be setup
            // don't want to remove existing devices until new device is setup through auth component
            if (action === 'remove') {
              removeMulti();
            } else {
              setFactors();
            }
          }, 0);
        });
      });
    }
  }
})(window.angular);

(function(angular){
  'use strict';

  angular.module('bmMultifactorProfile').controller('bmMfaConfirmDeviceCtrl', confirmModalCtrl);

  confirmModalCtrl.$inject = ['$rootScope', '$uibModalInstance', 'bmMultifactorService', '$translate', 'bmUtil', 'action', 'user'];
  function confirmModalCtrl($rootScope, $uibModalInstance, mfaService, $translate, bmUtil, action, user){
    /*jshint validthis:true */
    var vm = this;
    vm.confirmDevice = confirmDevice;
    vm.cancelDevice = cancelDevice;
    vm.modalAction = bmUtil.isNullOrEmpty(action) ? 'add' : action;
    vm.user = { password: ''};

    ///////////

    function confirmDevice(){
      if(vm.confirmDeviceForm.$invalid || vm.confirmDeviceForm.userPassword.$invalid){
        return;
      }

      // TODO: RIGHT NOW THIS PASSWORD CHECK IS SET TO TRID INSTEAD OF PRODUCT OPTIONS
      var userData = { uid: user.email, pwd: vm.user.password, type: 'TRID' };

      mfaService.verifyLoginData(userData).then(function(){
        closeModal(true);
      }, function(){
        $translate('bm.header.viewProfile.mfaConfirmError').then(function(text){
          // TODO: IF THIS GOES TO A COMPONENT CHANGE TO NOT USE bmErrors
          if (!$rootScope.bmErrors){
            $rootScope.bmErrors = [];
          }

          $rootScope.bmErrors.push({type: 'danger', msg: text, timeout: 2500, closeable: true});
        });
      });
    }

    function cancelDevice(){
      closeModal(false);
    }

    function closeModal(isConfirmed){
      $uibModalInstance.close(isConfirmed);
    }
  }
})(window.angular);

(function(angular){
    'use strict';

    angular.module('bmMultifactorUser', ['bento.modern']);
})(window.angular);

(function(angular) {
    'use strict';

    angular.module('bmMultifactorUser').controller('MultifactorUserCtrl', MultifactorUserCtrl);
	MultifactorUserCtrl.$inject = ['$uibModal', 'bmAccess'];

	function MultifactorUserCtrl($uibModal, bmAccess){
        /*jshint validthis:true */
		var vm = this;

		// scope variables
		vm.isMfaAvailable = false;
		vm.contact = {};

		// scope functions
		vm.openMfaSettingsModal = openMfaSettingsModal;

		localStorage.setItem('Platform_Enable2FA', true);

		this.$onChanges = function(changes) {
			if (changes.contact.currentValue && changes.contact.currentValue.id) {
				initialize();
			}
		};

		function openMfaSettingsModal() {
			$uibModal.open({
				templateUrl: 'components/multi-factor-user/multi-factor-user-settings.2js.html',
				controller: 'MultifactorUserSettingsCtrl',
				controllerAs: 'vm',
				backdrop: 'static',
				size: 'md',
				resolve: {
					contactInfo: function(){
						return {
							id: vm.contact.id
						};
					}
				}
			});
		}

		function initialize() {
			// must have IAC in order to actually make request for factors
			// TODO: AT SOME POINT THIS IAC CHECK WILL NEED TO GO AWAY
			bmAccess.has('Platform_DisableAuth0Phase2').then(function(){
				if(vm.contact.userId) {
					//multifactorUserService.contact = vm.contact;

					// TODO: will need to lookup the companies mfa settings here
					vm.isMfaAvailable = true;
				}
			}).catch(angular.noop);
		}
    }
})(window.angular);

(function(angular){
    'use strict';

    angular.module('bmMultifactorUser')
        .component('bmMultifactorUser', {
            templateUrl: 'components/multi-factor-user/multi-factor-user.2js.html',
            bindings: {
                contact: '<'
            },
            controller: 'MultifactorUserCtrl',
            controllerAs: 'vm'
        });
})(window.angular);

(function(angular) {
    'use strict';

    angular.module('bmMultifactorUser').controller('MultifactorUserSettingsCtrl', multifactorUserSettingsCtrl);
    multifactorUserSettingsCtrl.$inject = ['$window', '$scope', '$uibModalInstance', 'bmMultifactorService', 'contactInfo'];

    function multifactorUserSettingsCtrl($window, $scope, $uibModalInstance, bmMultifactorService, contactInfo) {
        /*jshint validthis:true */
        var vm = this;
        vm.userDevice = 'Some Device';
        vm.authCode = '';
        vm.registeredFactors = [];
        vm.busyLoading = true;
        vm.contactInfo = contactInfo;

        var jwt = '';
        var registeredAuthCodes = [];
        var temporaryAuthCode = '';

        // functiion
        vm.close = closeModal;
        vm.generateAccessCode = generateAccessCode;

        // setup
        init();

        function init() {
            getJwtToken();
        }

        function closeModal() {
            $uibModalInstance.close();
        }

        function generateAccessCode() {
            if(registeredAuthCodes.length > 0) {
                removeAuthFactorAndRegenerate();
            } else {
                createAuthFactorAndRegister();
            }
        }

        function getJwtToken() {
            $scope.$emit('bm-busy-loading-on');
            bmMultifactorService.getUserJwtToken(contactInfo.id).then(function(resp){
                jwt = resp.data.token;
                getFactors();
            }, function(data) {
                vm.busyLoading = false;
                $scope.$emit('bm-busy-loading-off');
                console.log(data);
            });
        }

        function getFactors() {
            bmMultifactorService.getAllFactors(jwt).then(function(data){
                if(angular.isArray(data) && data.length > 0){
                    vm.registeredFactors = data.filter(function(factor){
                        return angular.isString(factor.type) && factor.type.toUpperCase() !== 'B' && factor.type.toUpperCase() !== 'C';
                    });

                    registeredAuthCodes = data.filter(function(factor){
                        return angular.isString(factor.type) && factor.type.toUpperCase() === 'B';
                    });

                    if(angular.isArray(vm.registeredFactors) && vm.registeredFactors.length > 0){
                        var registeredDevice;
                        var registeredDeviceList;
                        for(var pos = 0; pos < vm.registeredFactors.length; pos++) {
                            registeredDevice = vm.registeredFactors[pos];
                            if(pos === 0) {
                                registeredDeviceList = registeredDevice.name;
                            } else {
                                registeredDeviceList = registeredDeviceList + ', ' + registeredDevice.name;
                            }
                        }
                        vm.userDevice = registeredDeviceList;
                    }
                }
                vm.busyLoading = false;
                $scope.$emit('bm-busy-loading-off');
            }, function(data) {
                vm.busyLoading = false;
                $scope.$emit('bm-busy-loading-off');
                console.log(data);
            });
        }

        function removeAuthFactorAndRegenerate() {
            $scope.$emit('bm-busy-loading-on');
            bmMultifactorService.deleteFactors(registeredAuthCodes, jwt).then(function(){
                registeredAuthCodes = [];
                createAuthFactorAndRegister();
            }, function() {
                $scope.$emit('bm-busy-loading-off');
            });
        }

        function createAuthFactorAndRegister() {
            $scope.$emit('bm-busy-loading-on');
            bmMultifactorService.enableMultifactorAuthCode(jwt).then(function(response){
                var authFactor = response.data;
                var otpSecret = authFactor.otpSecret;
                temporaryAuthCode = otpSecret.substring(0, 4) + ' ' + otpSecret.substring(4);
                registerMultifactorAuthCode(authFactor);
            }, function() {
                $scope.$emit('bm-busy-loading-off');
            });
        }

        function registerMultifactorAuthCode(authFactor) {
            bmMultifactorService.registerMultifactorAuthCode(jwt, authFactor).then(function(response){
                var data = response.data;
                data.id = authFactor.factorId;
                registeredAuthCodes = [];
                registeredAuthCodes.push(data);
                vm.authCode = temporaryAuthCode;
                $scope.$emit('bm-busy-loading-off');
            }, function() {
                $scope.$emit('bm-busy-loading-off');
                //window.alert('Error in registerMultifactorAuthCode');
            });
        }
    }
})(window.angular);

(function(angular){
  'use strict';

  angular.module('bmPrivacyPolicy', [
    'pascalprecht.translate',
    'bluemoon.components.i18n'])
  .value('bmPrivacyPolicyUriMap', {
    'en-US': 'https://www.thomsonreuters.com/en/privacy-statement.html',
    'fr-CA': 'https://www.thomsonreuters.com/fr-ca/privacy-statement.html',
    'nl-NL': 'https://www.thomsonreuters.com/nl/privacy.html',
    'es-AR': 'https://www.thomsonreuters.com/es/declaracion-de-privacidad.html',
    'pt-BR': 'https://www.thomsonreuters.com/pt/declaracao-de-privacidade.html'
  })
  .component('bmPrivacyPolicyLink', {
    templateUrl: 'components/privacy-policy/privacy-policy.2js.html',
    controller: privacyPolicyLink,
  })
  .service('bmPrivacyPolicyService', privacyPolicyService);

  ////////////

  // Component implementation
  privacyPolicyLink.$inject = ['$scope', 'bmPrivacyPolicyService', 'bmPrivacyPolicyUriMap'];
  function privacyPolicyLink($scope, privacyService, privacyUriMap){
    /*jshint validthis:true */
    var ctrl = this;

    ctrl.$onInit = init;

    //////////////////////////////

    function init(){
      // load up initial version of privacy policy
      setPrivacyUri();

      // add language change event watch to change text when lanuage changes
      $scope.$on('bmLanguageChangeSuccess', setPrivacyUri);
    }

    function setPrivacyUri(){
      privacyService.getPrivacyPolicyUri().then(function(uri){
        ctrl.privacyUri = uri;
      }, function(){
        // fall back to US for any errors
        ctrl.privacyUri = privacyUriMap['en-US'];
      });
    }
  }

  // Service implementation
  privacyPolicyService.$inject = ['bmLanguageManager', 'bmPrivacyPolicyUriMap'];
  function privacyPolicyService(languageManager, privacyPolicyUriMap){
    /*jshint validthis:true */
    var self = this;

    self.getPrivacyPolicyUri = getPrivacyPolicyUri;

    //////////////////////

    function getPrivacyPolicyUri(){
      return languageManager.getLoadedLanguageAsync().then(function(language){
        return privacyPolicyUriMap[language.code] || privacyPolicyUriMap['en-US'];
      });
    }
  }
})(window.angular);

// Depends on IAC: OnvioSupportID

(function(angular){
  'use strict';

  angular.module('bmSupportId', [
    'pascalprecht.translate',
    'bluemoon.components.i18n',
    'bluemoon.components.analytics'])
  .component('bmSupportIdLink', {
    templateUrl: 'components/support-id/support-id.2js.html',
    controller: supportIdLink,
  })
  .service('bmSupportIdService', supportIdService);

  // Component implementation
  supportIdLink.$inject = ['bmSupportIdService', 'bmAccess', 'bmAnalyticsService'];
  function supportIdLink(supportIdService, bmAccess, bmAnalyticsService){
    /*jshint validthis:true */
    var ctrl = this;
    ctrl.$onInit = init;

    function init(){
      ctrl.enabled = false;
      ctrl.showId = false;
      ctrl.supportId = '';

      ctrl.copyToClip = copyToClip;
      ctrl.loadSupportId = loadSupportId;

      bmAccess.has('OnvioSupportID').then(function(access){
        ctrl.enabled = access;
        // Initial support ID load
        ctrl.loadSupportId();
      }).catch(function() {
        ctrl.enabled = false;
        bmAnalyticsService.track('bmSupportIdService: bmAccess.has(\'OnvioSupportId\') failed');
      });
    }

    function loadSupportId () {
      ctrl.supportId = supportIdService.getRouteId();
    }

    function copyToClip () {
      document.getElementById('support-id-text').select();
      document.execCommand('copy');
    }
  }

  // Service implementation
  function supportIdService(){
    /*jshint validthis:true */
    var self = this;
    self.getRouteId = getRouteId;

    function getRouteId () {
      var inj = window.angular.element(document.querySelector('[ng-app], [data-ng-app], html, body')).injector();
      var routeId = inj.get('$http').defaults.headers.common['x-route-id'];
      return routeId;
    }
  }
})(window.angular);

(function (angular) {
    'use strict';

    angular.module('bluemoon.help', [
        'bmEnvironment',
        'pascalprecht.translate'
    ]);

})(window.angular);

(function (angular) {
    'use strict';

    angular.module('bluemoon.help')
        .controller('HelpCtrl',
            ['$scope', '$rootScope', '$window', '$timeout', '$translate', 'helpService', 'bmEnvironment', 'bmUtil',
                function ($scope, $rootScope, $window, $timeout, $translate, helpService, bmEnv, bmUtil) {
                    var defaultUrlPrefix = '/ua/help';
                    var sambaUrlPrefix = '/ua/smb';
                    var isOpened = false;
                    updateComponentData('', '', {}, []);
                    setEnvironmentLinks();
                    $scope.searchInput = { text: '', placeholderTxt: $translate.instant('bm.header.helpMenu.searchLabel') };

                    function updateHelpData() {
                        updateComponentData('', '', {}, []);
                        helpService.load($scope.location).then(function (resp) {
                            updateComponentData(
                                resp.data.baseUrl,
                                resp.data.howToUrl,
                                resp.data.parameters,
                                resp.data.topics
                            );
                        });
                    }

                    function updateComponentData(baseUrl, howToUrl, parameters, topics) {
                        $scope.help = $scope.help ? $scope.help : {};
                        $scope.help.baseUrl = baseUrl;
                        $scope.help.howToUrl = howToUrl;
                        $scope.help.parameters = parameters;
                        $scope.help.topics = topics;
                    }

                    $scope.offLocChgSuccess = $rootScope.$on('$locationChangeSuccess', function () {
                        if (isOpened) {
                            updateHelpData();
                        }
                    });
                    $rootScope.$on('bmLanguageChangeSuccess', function () {
                        $scope.searchInput.placeholderTxt = $translate.instant('bm.header.helpMenu.searchLabel');
                    });
                    $scope.$on('$destroy', function () {
                        if ($scope.offLocChgSuccess) {
                            $scope.offLocChgSuccess();
                        }
                    });

                    $scope.$watch('help.isHelpDropdownOpen', function (opened) {
                        if (opened !== isOpened) {
                            isOpened = opened === true;
                            if (isOpened) {
                                updateHelpData();
                            }
                        }
                    });

                    $scope.formatSearchUrl = function (primaryProduct) {
                        var prefix;
                        switch (primaryProduct) {
                            case 'samba':
                            case 'recibos':
                                prefix = sambaUrlPrefix;
                                break;
                            default:
                                prefix = defaultUrlPrefix;
                                break;
                        }
                        var url = prefix + '/search_handler.htm?q=' + encodeURIComponent($scope.searchInput.text);

                        if ($scope.help && $scope.help.parameters) {
                            url += '&' + $scope.formatHelpParametersSuffix($scope.help);
                        }

                        return url;
                    };

                    $scope.formatHelpParametersSuffix = function (help) {
                        var suffix = '';
                        if (help.parameters) {
                            var skipAmperasand = true;
                            angular.forEach(help.parameters, function (value, key) {
                                if (skipAmperasand) {
                                    skipAmperasand = false;
                                } else {
                                    suffix += '&';
                                }

                                suffix += key + '=' + encodeURIComponent(value);
                            });
                        }

                        return suffix;
                    };

                    $scope.formatTopicUrl = function (help, menuUrl) {
                        var url = help.baseUrl + menuUrl;
                        if (help.parameters) {
                            url += '?' + $scope.formatHelpParametersSuffix(help);
                        }

                        return url;
                    };

                    $scope.helpSearch = function () {
                        // if recibos, update help path; #7986
                        bmEnv.load().then(function (data) {
                            var url = $scope.formatSearchUrl(data.primaryProduct);
                            $window.open(url, '_blank');
                        });
                    };

                    $scope.searchKeyPress = function ($event) {
                        if ($event && $event.keyCode === 13) { // Enter key
                            $timeout(function () {
                                $scope.helpSearch();
                            });
                        }
                    };

                    $scope.howToLink = function () {
                        if ($scope.help) {
                            var url = $scope.help.howToUrl;

                            if ($scope.help && $scope.help.parameters) {
                                url += '?' + $scope.formatHelpParametersSuffix($scope.help);
                            }

                            return url;
                        }

                        return '';
                    };

                    function setEnvironmentLinks () {
                        var country = bmEnv.getCountryCode();
                        $scope.countryCode = country;

                        bmEnv.getEnvironmentAsync().then(function (data) {
                            $scope.currentCountry = data.countryCode;
                        });

                        $scope.arHelpAndTrainingLink = 'https://clientes.thomsonreuters.com.ar/';

                        switch (country) {
                            default:
                                $scope.ideaIncubatorLink = 'http://ideaincubator.ideas.aha.io';
                                $scope.communityLink = 'https://tax.thomsonreuters.com/en/community';
                                $scope.contactSupportLink = 'https://onvio.us/ua/help/us-en/staff/core/common/contacting-our-support-team.htm';
                                $scope.alertsAndNoticesLink = 'https://onvio.us/ua/help/us-en/staff/core/solutions/onvio-current-information-and-alerts.htm';
                                $scope.videoLibraryLink = 'https://onvio.us/ua/help/us-en/staff/core/video-library-core.htm';
                                break;
                        }
                    }

                    $scope.openEstudioOneSupport = function() {
                        bmEnv.getRoute('EstudioOne-Support').then(function(url){
                            var jwt;
                            var tokenType = 'UDSLongToken';
                            var token = bmUtil.cookie(tokenType);

                            if (!jwt) { // lazy jwt
                                // get jwt given a UDSLongToken
                                // make it synchronous ($http can't do sync) so we avoid window.open and popup blockers
                                // not great, but the deprecation warning is a bluff
                                var xhr = new $window.XMLHttpRequest();
                                xhr.open('POST', '/api/security/v1/jwt/sessions', false); // false = synchronous
                                xhr.setRequestHeader('Authorization', tokenType + ' ' + token);
                                xhr.onreadystatechange = function() {
                                    if (xhr.readyState !== 4 || xhr.status !== 201) { return; }
                                    jwt = JSON.parse(xhr.responseText).token;
                                };
                                xhr.send();
                            }

                            if (!jwt) { return; }
                            url = url + (/\?/.test(url) ? '&' : '?') + 'token=' + jwt;
                            // don't leave jwt laying around
                            setTimeout(function() { $window.open(url, '_blank'); }, 0);
                        });
                    };
                }
            ]);
})(window.angular);

/**
 * Blue Moon Components - Help Dropdown Directive
 */
(function (angular) {
    'use strict';

    bmHelpDropdown.$inject = [];
    function bmHelpDropdown() {
        return {
            scope: {
                isDropdownOpen: '=?',
                location: '@?', // the remaining URL after the '#' ex. '/staff/setup/clients'. If absent, defaults to current location
                useMenuLeft: '=?' // Uses a left menu instead
            },
            templateUrl: 'components/help/help.2js.html',
            controller: 'HelpCtrl',
            controllerAs: 'help'
        };
    }

    angular.module('bluemoon.help').directive('bmHelpDropdown', bmHelpDropdown);
})(window.angular);

(function(angular) {
    'use strict';

    angular.module('bluemoon.help')
        .factory('helpService', ['$q', '$http', '$location',
            function ($q, $http, $location) {
                return {
                    load: function(location) {
                        if (location && typeof location !== 'string') {
                            throw new Error('Error: location argument should be a non-empty string');
                        }
                        var endpoint = '/api/profiles/v1/help';

                        // If a location was given, use it instead of the current url
                        var currentUrl = $location.absUrl();
                        if (location) {
                            currentUrl = $location.protocol() + '://' + $location.host() + location;
                        }
                        // Debug code to test on localhost
                        if ($location.host() === 'localhost') {
                            currentUrl = 'https://ci.onvio.us/staff/#' + (location ? location : $location.url());
                        }

                        var parameters = '?location=' + encodeURIComponent(currentUrl);
                        var config = {
                            url: endpoint + parameters,
                            method: 'GET',
                            cache: true
                        };

                        return $http(config).then(
                            function(resp) {
                                var defer = $q.defer();
                                defer.resolve(resp);
                                return defer.promise;
                            },
                            function(resp) {
                                resp.config.global = false;
                                return $q.reject(resp);
                            });
                    }
                };
            }
        ]);
})(window.angular);

(function (angular) {
    'use strict';

    var licenseApiUrl = '/api/provisioning/v1/licenses';

    function License($http, $q) {
        var self = this;

        // Can be used for route resolve to determine if you have license.
        // For example,
        // resolve: {
        //     selfReg: bmLicense.has('SelfRegistration').catch(function () {
        //         $state.go('notfound');
        //     })
        // }
        var grants = null;
        var grantsBlockedDefers = null;

        self.load = function () {
            if (grants) {
                return $q.when(grants);
            }

            // We need to run the query.
            // But, someone else may be currently running it, at which point we will just wait for that one call to finish.
            if (!grantsBlockedDefers) {
                grantsBlockedDefers = [];

                $http.get(licenseApiUrl).then(function (resp) {
                    // map into a format we prefer
                    grants = resp.data.featureResources.map(function (val) {
                        return val.feature + '.' + val.resource;
                    });

                    // Resolve all of the waiting promises
                    grantsBlockedDefers.forEach(function (defer) {
                        defer.resolve(grants);
                    });
                    return grants;
                }).catch(function () {
                    // Trigger failure to all of the waiting promises
                    grantsBlockedDefers.forEach(function (defer) {
                        defer.reject();
                    });
                }).finally(function () {
                    // Reset back to the original state.
                    grantsBlockedDefers = undefined;
                });
            }

            // Add ourselves to the list of promises waiting on the query.
            var currentDefer = $q.defer();
            grantsBlockedDefers.push(currentDefer);
            return currentDefer.promise;
        };

        self.hasSync = function (licenses, hasEvery) {
            if (!grants) {
                throw new Error('grants not loaded yet. You must use load() first.');
            }
            var granted = false;
            if (angular.isArray(licenses)) {
                licenses[hasEvery ? 'every' : 'some'](function (license) {
                    if (grants) {
                        granted = grants.indexOf(license) > -1;
                    } else {
                        granted = false;
                    }
                    return granted;
                });
            } else if (typeof licenses === 'string') {
                if (grants) {
                    granted = grants.indexOf(licenses) > -1;
                }
            }
            return granted;
        };
        self.has = function (licenses, hasEvery) {
            return self.load().then(function () {
                var granted = self.hasSync(licenses, hasEvery);
                if (granted) {
                    return granted;
                } else {
                    return $q.reject(granted);
                }
            });
        };

        self.hasSome = function(licenses) {
            return self.has(licenses);
        };

        self.hasEvery = function(licenses) {
            return self.has(licenses, true);
        };

        self.not = function(licenses){
            var deferred = $q.defer();
            self.has(licenses).then(function(){
                deferred.reject(false);
            }, function(){
                deferred.resolve(true);
            });
            return deferred.promise;
        };

        self.notSome = function(licenses){
            return self.not(licenses);
        };

        self.notEvery = function(licenses){
            return self.not(licenses, true);
        };
    }

    /* adapted from angularJS 1.3.12 */
    function getBlockNodes(nodes) {
      // TODO(perf): just check if all items in `nodes` are siblings and if they are return the original
      //             collection, otherwise update the original collection.
      var node = nodes[0];
      var endNode = nodes[nodes.length - 1];
      var blockNodes = [node];

      do {
        node = node.nextSibling;
        if (!node) { break; }
        blockNodes.push(node);
      } while (node !== endNode);

      return angular.element(blockNodes);
    }

    /* adapted from ngIf angularJS 1.3.12 */
    function licenseDirective($animate, bmLicense) {
      return {
        multiElement: true,
        transclude: 'element',
        priority: 600,
        terminal: true,
        restrict: 'A',
        $$tlb: true,
        link: function($scope, $element, $attr, ctrl, $transclude) {
            var block, childScope, previousElements;

            function bmIfHasLicenseWatchAction(value) {
                handleLicenseAttrChange('bmIfHasLicense', value);
            }

            function bmIfHasLicenseEveryWatchAction(value) {
                handleLicenseAttrChange('bmIfHasLicenseEvery', value);
            }

            function bmIfHasLicenseSomeWatchAction(value) {
                handleLicenseAttrChange('bmIfHasLicenseSome', value);
            }

            function bmIfHasNoLicenseWatchAction(value){
                handleLicenseAttrChange('bmIfHasNoLicense', value);
            }

            function bmIfHasNoLicenseSomeWatchAction(value){
                handleLicenseAttrChange('bmIfHasNoLicenseSome', value);
            }

            function bmIfHasNoLicenseEveryWatchAction(value){
                handleLicenseAttrChange('bmIfHasNoLicenseEvery', value);
            }

            function handleLicenseAttrChange(type, value) {
                bmLicense[type === 'bmIfHasLicenseEvery' ? 'hasEvery'
                    : type === 'bmIfHasNoLicenseEvery' ? 'notEvery'
                    : type === 'bmIfHasNoLicense' || type === 'bmIfHasNoLicenseSome' ? 'not'
                    : 'has'
                ](value || $attr[type]).then(function() {

                    if (!childScope) {
                      $transclude(function(clone, newScope) {
                        childScope = newScope;
                        clone[clone.length++] = document.createComment(' end ' + type + ': ' + $attr[type] + ' ');
                        // Note: We only need the first/last node of the cloned nodes.
                        // However, we need to keep the reference to the jqlite wrapper as it might be changed later
                        // by a directive with templateUrl when its template arrives.
                        block = {
                          clone: clone
                        };
                        $animate.enter(clone, $element.parent(), $element);
                      });
                    }
                }, function() {
                    if (previousElements) {
                      previousElements.remove();
                      previousElements = null;
                    }
                    if (childScope) {
                      childScope.$destroy();
                      childScope = null;
                    }
                    if (block) {
                      previousElements = getBlockNodes(block.clone);
                      $animate.leave(previousElements).then(function() {
                        previousElements = null;
                      });
                      block = null;
                    }
                });
            }

            if ($attr.bmIfHasLicense) {
                var unwatchIfHasLicense = $scope.$watch($attr.bmIfHasLicense, bmIfHasLicenseWatchAction);
            }
            if ($attr.bmIfHasLicenseEvery) {
                var unwatchIfHasLicenseEvery = $scope.$watch($attr.bmIfHasLicenseEvery, bmIfHasLicenseEveryWatchAction);
            }
            if ($attr.bmIfHasLicenseSome) {
                var unwatchIfHasLicenseSome = $scope.$watch($attr.bmIfHasLicenseSome, bmIfHasLicenseSomeWatchAction);
            }
            if($attr.bmIfHasNoLicense){
                var unwatchIfHasNoLicense = $scope.$watch($attr.bmIfHasNoLicense, bmIfHasNoLicenseWatchAction);
            }
            if($attr.bmIfHasNoLicenseSome){
                var unwatchIfHasNoLicenseSome = $scope.$watch($attr.bmIfHasNoLicenseSome, bmIfHasNoLicenseSomeWatchAction);
            }
            if ($attr.bmIfHasNoLicenseEvery) {
                var unwatchIfHasNoLicenseEvery = $scope.$watch($attr.bmIfHasNoLicenseEvery, bmIfHasNoLicenseEveryWatchAction);
            }

            // cleanup
            $element.on('$destroy', function () {
                if (unwatchIfHasLicense) { unwatchIfHasLicense(); }
                if (unwatchIfHasLicenseEvery) { unwatchIfHasLicenseEvery(); }
                if (unwatchIfHasLicenseSome) { unwatchIfHasLicenseSome(); }
                if (unwatchIfHasNoLicense) { unwatchIfHasNoLicense(); }
                if (unwatchIfHasNoLicenseSome) { unwatchIfHasNoLicenseSome(); }
                if (unwatchIfHasNoLicenseEvery) { unwatchIfHasNoLicenseEvery(); }
            });
        }
      };
    }

    License.$inject = ['$http', '$q'];
    licenseDirective.$inject = ['$animate', 'bmLicense'];

    angular.module('bmLicense', ['bluemoon.components.session'])
        .service('bmLicense', License)
        .directive('bmIfHasLicense', licenseDirective)
        .directive('bmIfHasLicenseSome', licenseDirective)
        .directive('bmIfHasLicenseEvery', licenseDirective)
        .directive('bmIfHasNoLicense', licenseDirective)
        .directive('bmIfHasNoLicenseSome', licenseDirective)
        .directive('bmIfHasNoLicenseEvery', licenseDirective);

 })(window.angular);

(function (angular) {
    'use strict';

    angular.module('bluemoon.myAccount', [
        'bluemoon.components.session',
        'pascalprecht.translate',
        'bluemoon.components.i18n',
        'bluemoon.components.util',
        'bmUserTermsSignatory',
        'bmHttpCache',
        'bmValidateEmail',
        'LinkedAccountsService'
    ]);
})(window.angular);

(function(angular) {
    'use strict';

    angular.module('bluemoon.myAccount').controller('MyAccountCtrl', myAccountCtrl);
    myAccountCtrl.$inject = ['$q', '$sce','$scope', '$window', '$uibModal', '$translate', 'bmUtil','bmAccess', 'myAccountService', 'bmUserSignatory', 'helpService', 'bmEnvironmentConst'];

    function myAccountCtrl($q, $sce, $scope, $window, $uibModal, $translate, bmUtil, bmAccess, myAccountService, bmUserSignatory, helpService, bmEnvironmentConst) {
        /*jshint validthis:true */
        var vm = this;
        var isSkinny = vm.display === 'skinny';
        var licenseeDisplay = false;
        var linkModalOpen = false;

        this.$onInit = function() {
            vm.saveUser = saveUser;
            vm.cancelUser = cancelUser;
            vm.validateUserId = validateUserId;
            vm.getTemplateUrl = getTemplateUrl;
            vm.openAccountLinkModal = openAccountLinkModal;
            vm.userIdError = '';
            vm.termsLink = '';
            vm.showStaffTerms = false;
            // 2-way bound data object to pass information between tabs
            vm.sharedLocal = vm.sharedData;
            vm.sharedLocal.hasUnsavedAccount = false;
            vm.isVisibleSaveButton = isVisibleSaveButton;
            vm.isVisibleLanguageUpdateButton = isVisibleLanguageUpdateButton;
            vm.updateLanguageCIAM = updateLanguageCIAM;
            var profileLanguage = (bmUtil.cookie('BMLanguageCode') !== undefined) ? bmUtil.cookie('BMLanguageCode') : bmEnvironmentConst.defaultLang;
            vm.auth0ProfileUrl = bmEnvironmentConst.auth0ProfileUrl + '/' + profileLanguage + '/profile';

            initializeView();
        };

        loadPlatformDisableAuth0Phase2Access();
        loadPlatformNotifyUpdatedEmail();

        function initializeView(){
            resetAlerts();

            // Create method publicly available through 2-way data bound object
            vm.sharedLocal.setAccountDirty = function(){
                setFormState();
            };

            // should terms link appear
            bmAccess.has('Platform_DisplayOnvioTerms').then(function() {
                vm.showStaffTerms = true;
                getTermsLink().then(function(termsLink) {
                    vm.termsLink = termsLink;
                });
            }).catch(angular.noop);
            // Make sure user settings were resolved
            if(angular.isUndefined(vm.user) || vm.user === ''){
                $translate('BM.Components.AccountInformation.LoadError').then(function(alert){
                    addAlert(alert, 'danger');
                });

                return;
            }

            // Set languages - passed on directive property
            vm.languageList = vm.languages;

            // Create a copy of the original user in order to track changes on save
            vm.localUser = angular.copy(vm.user);

            vm.savingUserInProgress = false;

            if(angular.isUndefined(vm.localUser.language)){
                vm.localUser.language = 'en-US';
            }

            // set a full name for display if it doesn't exist
            if(angular.isUndefined(vm.localUser.fullName)) {
                vm.localUser.fullName = (vm.localUser.firstName + ' ' + vm.localUser.lastName).trim();
            }
            vm.initialEmail = vm.localUser.email;
            // for skinny display - no terms necessary to be loaded
            if(!isSkinny){
                // load up any terms and conditions information
                bmUserSignatory.getRequiredUserSignatoryAsync().then(function(signatory){
                    setTermsDisplay(signatory);
                });
            }
        }

        // https://stackoverflow.com/questions/23065165/angularjs-directive-dynamic-templates
        function getTemplateUrl(displayType){
            // skinny displayType is used for CSWeb

            // lean towards onvio base template
            var baseTemplate = displayType === 'skinny' ? 'my-account/my-account-skinny.2js.html' : 'my-account/my-account.2js.html';

            // user not loaded
            if(angular.isUndefined(vm.user) || vm.user === ''){
                return baseTemplate;
            }

            // licensee version
            if(displayType === 'skinny' && vm.user.licensee){
                licenseeDisplay = true;
                return 'my-account/my-account-licensee.2js.html';
            }

            // stick with non-licensee version
            return baseTemplate;
        }

        function getTermsLink() {
            return helpService.load().then( function(response) {
                return (response.data.baseUrl.substring(0, response.data.baseUrl.indexOf('core')) + 'general-articles/terms-conditions-onvio.htm');
            });
        }

        function setTermsDisplay(signatory){
            if(angular.isDefined(signatory) && angular.isDefined(signatory.terms) && angular.isDefined(signatory.signatory)){
                vm.hasTermsSignatory = true;
                vm.termsDisplayText = $sce.trustAsHtml(signatory.terms.text);
            }
        }

        function loadPlatformDisableAuth0Phase2Access () {
            vm.hasDisableAuth0Phase2 = false;
            bmAccess.has('Platform_DisableAuth0Phase2').then(function() {
                vm.hasDisableAuth0Phase2 = true;
            }).catch(function () {
                vm.hasDisableAuth0Phase2 = false;
            });
        }

        function loadPlatformNotifyUpdatedEmail () {
            vm.hasNotifyUpdatedEmail = false;
            bmAccess.has('Platform_NotifyUpdatedEmail').then(function() {
                vm.hasNotifyUpdatedEmail = true;
            }).catch(function () {
                vm.hasNotifyUpdatedEmail = false;
            });
        }

        function isVisibleSaveButton() {
            vm.hasTerms = vm.user && !vm.showTerms;
            return vm.hasTerms && vm.hasDisableAuth0Phase2;
        }

        function isVisibleLanguageUpdateButton() {
            return vm.languageList.length > 1 && !vm.hasDisableAuth0Phase2;
        }

        function updateLanguageCIAM() {
            var language = { language: vm.localUser.language };
            saveUserLanguageCIAM(language);
        }

        function saveUserLanguageCIAM(language){
            resetAlerts();
            $scope.$emit('bm-busy-loading-on');
            myAccountService.saveUserLanguage(language).then(function(){
                $scope.$emit('bm-busy-loading-off');
                $translate('bm.header.viewProfile.account.saveSuccessful').then(function(value){
                    addAlert(value, 'success');
                    $window.location.reload();
                });
            }, function(){
                $scope.$emit('bm-busy-loading-off');
                $translate('Bluemoon.Components.ValidationUtils.GenericValidationError').then(function(value){
                    addAlert(value, 'danger');
                });
            });
        }

        vm.toolbarButtons = [{
            label : $translate.instant('onvio.setup.migrations.refresh'),
            icon  : 'bento-icon-refresh',
            action: function () {
                myAccountService.getMyUserSettingsAsync().then(function(resp) {
                   vm.localUser = resp.data;
                   vm.initialEmail = vm.localUser.email;
               });
            }
        }];

        function saveUser(){
            resetAlerts();
            cleanUserData();
            validateUserId(true);

            if(vm.userIdError !== ''){
                setFormInvalid();
                return;
            }

            validateUserIdAsync().then(function(){
                // do no want to save if the linking modal dialog is open
                if(linkModalOpen === false) {
                    if(vm.userIdError !== '' || vm.myAccountForm.$invalid){
                        setFormInvalid();
                        return;
                    }

                    var userToSave = getCleanUserSaveData(vm.localUser);
                    vm.savingUserInProgress = true;
                    var emailInUseVerify = vm.localUser.email !== vm.user.email;
                    $scope.$emit('bm-busy-loading-on');
                    myAccountService.saveUserCombined(userToSave, emailInUseVerify).then(function(){
                        $scope.$emit('bm-busy-loading-off');
                        vm.myAccountForm.$setPristine();
                        vm.sharedLocal.hasUnsavedAccount = false;

                        // keep user objects in sync
                        vm.user = angular.copy(vm.localUser);

                        // Always persist the language just in case there is an out-of-sync condition between saved settings and UI
                        myAccountService.persistLanguageAsync(userToSave.language);

                        if(!vm.hasNotifyUpdatedEmail || (vm.initialEmail === vm.localUser.email.trim()) ){
                            $translate('bm.header.viewProfile.account.saveSuccessful').then(function(value){
                                addAlert(value, 'success');
                            });
                        } else {
                            $translate('bm.header.viewProfile.account.emailChangedNotification').then(function(value){
                                addAlert(value, 'success');
                            });
                        }
                        vm.savingUserInProgress = false;
                    }, function(error){
                        $scope.$emit('bm-busy-loading-off');
                        // TODO: REPLACE THIS WITH A USEFUL ERROR MESSAGE
                        addAlert(error.data, 'danger');
                    });
                }
            }, function(){
                setFormInvalid();
            });
        }
        function openAccountLinkModal(uid) {
            linkModalOpen = true;
            var modalInstance = $uibModal.open({
                templateUrl: 'my-account/link-auth/link-auth-modal.2js.html',
                controller: 'LinkAuthCtrl as vm',
                backdrop: 'static',
                resolve: {
                    uid: function() {
                        return uid;
                    }
                }
            });
            modalInstance.result.then(function(result) {
                if(result !== 'change email') {
                    linkModalOpen = false;
                }
            }, function(reason) {
                linkModalOpen = false;
                resetAlerts();
                if(angular.isDefined(reason)) {
                    if(reason !== 'change email') {
                        addAlert(reason, 'danger');
                    }
                }
            });
        }

        function getCleanUserSaveData(user){
            return {
                email: user.email,
                firstName: user.firstName,
                middleName: angular.isUndefined(user.middleName) ? '' : user.middleName,
                lastName: user.lastName,
                language: user.language
            };
        }

        function cleanUserData() {
            // TODO: HACK TO AVOID BAMS INTEGRATION. PASS IN NAME PARSER METHODS
            if(angular.isDefined(vm.localUser.fullName)) {
                vm.localUser.fullName = vm.localUser.fullName.trim();
            }

            if(angular.isDefined(vm.localUser.email)) {
                vm.localUser.email = vm.localUser.email.trim();
            }
            if(angular.isDefined(vm.localUser.firstName)) {
                vm.localUser.firstName = vm.localUser.firstName.trim();
            }
            if(angular.isDefined(vm.localUser.middleName)) {
                vm.localUser.middleName = vm.localUser.middleName.trim();
            }
            if(angular.isDefined(vm.localUser.lastName)) {
                vm.localUser.lastName = vm.localUser.lastName.trim();
            }
        }

        function setFormInvalid(){
            var alert = '';
            $translate('BM.Components.IncompleteForm').then(function(data){
                alert = data;
                addAlert(alert, 'danger');
            });

            // fields don't exist on licensee display
            if(licenseeDisplay){
                return;
            }

            // Toggle all validation messages
            if(vm.myAccountForm.firstName.$error.required){
               vm.myAccountForm.firstName.$dirty = true;
            }

            if(vm.myAccountForm.firstName.$error.required){
               vm.myAccountForm.firstName.$dirty = true;
            }

            if(vm.myAccountForm.lastName.$error.required){
               vm.myAccountForm.lastName.$dirty = true;
            }

            // skinny form doesn't have language field
            if(!isSkinny && vm.myAccountForm.language.$error.required){
               vm.myAccountForm.language.$dirty = true;
            }
        }

        function allowAccountMergingAsync() {
            // check for access to account switching merging IAC
            return bmAccess.has('PPE-AccountSwitchingMerge');

        }

        function validateUserId(isFormSubmit){
            vm.userIdError = '';

            var emailBeforeAt = vm.myAccountForm.userId.$viewValue.split('@')[0];
            if(emailBeforeAt.length > 64) {
                $translate('BM.Components.EmailUserNameLengthExceededError').then(function(data){
                    vm.userIdError = data;
                });
                return;
            }
            // User id required
            if(vm.myAccountForm.userId.$error.required){
                $translate('BM.Components.EnterEmailAddressError').then(function(data){
                    vm.userIdError = data;
                });
                return;
            }

            if(vm.myAccountForm.userId.$invalid){
                $translate('BM.Components.EnterValidEmailError').then(function(data){
                    vm.userIdError = data;
                });
                return;
            }

            // We don't want to check the email when the 'on-blur' event is called if we are allowed to merge accounts
            allowAccountMergingAsync().catch(function() {
                if(isFormSubmit === false && linkModalOpen === false){
                    validateUserIdAsync();
                }
            });
        }

        function validateUserIdAsync(){
            $scope.$emit('bm-busy-loading-on');
            return myAccountService.loginAlreadyUsedAsync(vm.localUser.email).then(function(response){
                $scope.$emit('bm-busy-loading-off');
                var data = response.data;

                if(angular.isDefined(data) && data.results === 'found' && vm.user.email !== vm.localUser.email && !vm.savingUserInProgress){
                    return allowAccountMergingAsync().then(function() {
                        openAccountLinkModal(vm.localUser.email);
                    }, function() {
                        $translate('BM.Components.EmailInUseError').then(function(data){
                            vm.userIdError = data;
                        });
                    });
                }
            }, function(error){
                $scope.$emit('bm-busy-loading-off');

                var emailBeforeAt = vm.myAccountForm.userId.$viewValue.split('@')[0];
                if(emailBeforeAt.length > 64) {
                    $translate('BM.Components.EmailUserNameLengthExceededError').then(function(data){
                        vm.userIdError = data;
                    });
                    return;
                }

                if(vm.myAccountForm.userId.$error.required){
                    $translate('BM.Components.EnterEmailAddressError').then(function(data){
                        vm.userIdError = data;
                    });
                    return;
                } else if(vm.myAccountForm.userId.$invalid){
                    $translate('BM.Components.EnterValidEmailError').then(function(data){
                        vm.userIdError = data;
                    });
                    return;
                } else {
                    $translate('BM.Components.UnableToValidateEmailError').then(function(data){
                        vm.userIdError = data + error.data;
                  });
                }
            });
        }

        function cancelUser(){
            if(vm.sharedLocal.resetOnCancel){
                initializeView();
                setFormState();
            }

            $scope.$emit('bmProfileCancelAction');
        }

        function addAlert(message, type){
            resetAlerts();

            var alert = { msg: message, type: type };

            if(isSkinny || licenseeDisplay){
                alert.closeable = !licenseeDisplay;
                alert.timeout = 2500;
            }

            vm.alerts.push(alert);
        }

        function resetAlerts(){
            vm.alerts = [];
        }

        function setFormState(){

            var newUser = getCleanUserSaveData(vm.localUser);
            var initialUser = getCleanUserSaveData(vm.user);
            var isClean = angular.equals(newUser, initialUser);

            if(isClean){
                resetAlerts();
                // this assumes the initial value of email was valid
                vm.userIdError = '';
                vm.myAccountForm.$setPristine();
            } else {
                vm.myAccountForm.$setDirty();
            }

            vm.sharedLocal.hasUnsavedAccount = !isClean;
        }
    }
})(window.angular);

(function(angular){
    'use strict';

    angular.module('bluemoon.myAccount').factory('myAccountService', myAccountService);
    myAccountService.$inject = ['$q','$http', '$rootScope', '$translate', 'AuthenticatedSessionData', 'bmLanguageManager', 'bmHttpCacheHelper'];

    function myAccountService($q, $http, $rootScope, $translate, authenticatedSessionData, bmLanguageManager, bmHttpCacheHelper){
        var factory = {
            getUserSettingsAsync: getUserSettingsAsync,
            getMyUserSettingsAsync: getMyUserSettingsAsync,
            getNameSuffixListAsync: getNameSuffixListAsync,
            getNamePrefixListAsync: getNamePrefixListAsync,
            getLanguageListAsync: getLanguageListAsync,
            saveUserAsync: saveUserAsync,
            saveUser: saveUser,
            saveUserCombined: saveUserCombined,
            persistLanguageAsync: persistLanguageAsync,
            loginAlreadyUsedAsync: loginAlreadyUsedAsync,
            saveUserLanguage: saveUserLanguage
        };

        var userApi =  '/api/profiles/v1/users';
        return factory;

        //////////

        function getUserSettingsAsync(userTruId){
            if(angular.isUndefined(userTruId)){
                return $translate('bm.account.service.unableToLoadUser').then(function(val){
                    return getRejectedPromise(val);
                });

            }

            // cache for 10 seconds
            return $http({
                method: 'GET',
                url: userApi + '/' + userTruId,
                bmCache: 10000
            });
        }

        function getMyUserSettingsAsync(){
            var promises = [
                getUserTruidFromSession(),
                getCompanyIdFromSession(),
                getContactIdFromSession()
            ];

            return $q.all(promises).then(function(data){
                return getUserSettingsAsync(data[0]).then(function(response){
                    // Persist the user data in order to keep it all in one place
                    if(angular.isDefined(response) && angular.isDefined(response.data)){
                        response.data.bluId = data[0];
                        response.data.companyId = data[1];
                        response.data.contactId = data[2];
                    }

                    return response;
                });
            });
        }

        function getNameSuffixListAsync(languageCode){
            var url = '/api/core/v1/contacts/name-suffixes';
            return getNameAdditionsList(languageCode, url);
        }

        function getNamePrefixListAsync(languageCode){
            var url = '/api/core/v1/contacts/name-prefixes';
            return getNameAdditionsList(languageCode, url);
        }

        function getNameAdditionsList(languageCode, baseUrl){
            if(angular.isUndefined(languageCode) || languageCode === ''){
                languageCode = 'en-US';
            }

            var url = baseUrl + '?language=' + encodeURIComponent(languageCode);

            // cache for 10 minutes
            return $http({
                method: 'GET',
                url: url,
                bmNoAuth: true,
                bmCache: 600000
            }).then(function(response){
                var list = [];

                if(angular.isUndefined(response.data) || angular.isUndefined(response.data.values)){
                    return list;
                }

                var values = response.data.values;

                for(var counter = 0; counter < values.length; counter++){
                    list.push({
                        id: counter,
                        description: values[counter]
                    });
                }

                return list;
            });
        }

        function getLanguageListAsync(){
            return bmLanguageManager.getLanguagesAsync(true).then(function(languages){
                return languages;
            });
        }

        function saveUserAsync(user){
            return getUserTruidFromSession().then(function(userTruId) {

                if(angular.isUndefined(userTruId) || angular.isUndefined(user) || angular.isUndefined(user.email)){
                    return $translate('bm.account.service.unableToLoadUser').then(function(val){
                        return getRejectedPromise(val);
                    });
                }

                return loginAlreadyUsedAsync(user.email).then(function(response){
                    if(response.data.results === 'found'){
                        return $translate('BM.Components.EmailInUseError').then(function(val){
                            return getRejectedPromise(val);
                        });
                    }

                    return $http({
                        method: 'PUT',
                        url: userApi + '/' + userTruId,
                        data: user
                    }).then(function(){
                        bmHttpCacheHelper.invalidateHttpCache(userApi + '/' + userTruId);
                    });
                });
            });
        }

        function saveUser(user) {
            return getUserTruidFromSession().then(function(userTruId){
                if(angular.isUndefined(userTruId) || angular.isUndefined(user) || angular.isUndefined(user.email)){
                    return $translate('bm.account.service.unableToLoadUser').then(function(val){
                        return getRejectedPromise(val);
                    });
                }
                return $http({
                    method: 'PUT',
                    url: userApi + '/' + userTruId,
                    data: user
                }).then(function(){
                    bmHttpCacheHelper.invalidateHttpCache(userApi + '/' + userTruId);
                });
            });
        }

        function saveUserCombined(user, emailInUseVerify){
            return getUserTruidFromSession().then(function(userTruId) {

                if(angular.isUndefined(userTruId) || angular.isUndefined(user) || angular.isUndefined(user.email)){
                    return $translate('bm.account.service.unableToLoadUser').then(function(val){
                        return getRejectedPromise(val);
                    });
                }

                if (emailInUseVerify) {
                    return loginAlreadyUsedAsync(user.email).then(function(response){
                        if(response.data.results === 'found'){
                            return $translate('BM.Components.EmailInUseError').then(function(val){
                                return getRejectedPromise(val);
                            });
                        }

                        return $http({
                            method: 'PUT',
                            url: userApi + '/' + userTruId,
                            data: user
                        }).then(function(){
                            bmHttpCacheHelper.invalidateHttpCache(userApi + '/' + userTruId);
                        });
                    });
                }
                return $http({
                    method: 'PUT',
                    url: userApi + '/' + userTruId,
                    data: user
                }).then(function(){
                    bmHttpCacheHelper.invalidateHttpCache(userApi + '/' + userTruId);
                });
            });
        }

        function saveUserLanguage(language) {
            return getUserTruidFromSession().then(function(userTruId){
                if(angular.isUndefined(userTruId)){
                    return $translate('bm.account.service.unableToLoadUser').then(function(val){
                        return getRejectedPromise(val);
                    });
                }
                return $http({
                    method: 'PUT',
                    url: userApi + '/' + userTruId + '/language',
                    data: language
                }).then(function(){
                    bmHttpCacheHelper.invalidateHttpCache(userApi + '/' + userTruId + '/language');
                });
            });
        }

        function persistLanguageAsync(languageCode){
            var curr = bmLanguageManager.getCurrentLanguage();
            if (curr !== languageCode) {
                return bmLanguageManager.setUserLanguageAsync(languageCode).then(function() {
                    $rootScope.$broadcast('bmLanguageChangeByUserSuccess', { language: languageCode });
                });
            } else {
                var deferred = $q.defer();
                deferred.resolve();
                return deferred.promise;
            }
        }

        function getRejectedPromise(rejectReason){
            var deferred = $q.defer();

            if(angular.isString(rejectReason)){
                deferred.reject({ data: rejectReason });
            } else {
                $translate('bm.account.service.unableToProcessUserInfo').then(function(val){
                    deferred.reject({ data: val });
                });
            }

            return deferred.promise;
        }

        function loginAlreadyUsedAsync(email) {
            // No need to verify if email is same as what's in session
            return getEmailAddressFromSession().then(function(sessionEmail) {
                if(angular.isDefined(sessionEmail) && angular.isDefined(email) && email.toLowerCase() === sessionEmail.toLowerCase()){
                    var deferred = $q.defer();

                    deferred.resolve({
                        data: {
                            results: 'notfound'
                        }
                    });

                    return deferred.promise;
                }

                return $http({
                    method: 'GET',
                    url: userApi + '/login-in-use?login=' + encodeURIComponent(email)
                });
            });

        }

        function getUserTruidFromSession(){
            return authenticatedSessionData.getMeta().then(function(data){
                return data.PrismGuid;
            });
        }

        function getEmailAddressFromSession(){
            return authenticatedSessionData.getMeta().then(function(data){
                return data.EmailAddress;
            });
        }

        function getCompanyIdFromSession(){
            return authenticatedSessionData.getBindings().then(function(data){
                if(angular.isDefined(data) && angular.isDefined(data.ApplicationConfiguration)){
                    return data.ApplicationConfiguration.CompanyId;
                }

                return undefined;
            });
        }

        function getContactIdFromSession(){
            return authenticatedSessionData.getBindings().then(function(data){
                if(angular.isDefined(data) && angular.isDefined(data.ApplicationConfiguration)){
                    return data.ApplicationConfiguration.ContactId;
                }

                return undefined;
            });
        }
    }
})(window.angular);

(function(angular){
    'use strict';

    angular.module('bluemoon.myAccount').directive('bmMyAccountInfo', [function(){
        return {
            restrict: 'E',
            replace: true,
            template: function(elem, attrs){
                // https://stackoverflow.com/questions/23065165/angularjs-directive-dynamic-templates
                return '<ng-include src="vm.getTemplateUrl(\'' + attrs.display + '\')"/>';
            },
            scope: {
                languages: '=',
                user: '=',
                sharedData: '=',
                display: '@'
            },
            controller: 'MyAccountCtrl',
            controllerAs: 'vm',
            bindToController: true
        };
    }]);
})(window.angular);

(function(angular) {
    'use strict';
        angular.module('bluemoon.myAccount').controller('LinkAuthCtrl', linkAuthCtrl);
        linkAuthCtrl.$inject = [
            'bmAccess',
            '$templateRequest',
            '$scope',
            '$translate',
            '$location',
            '$uibModalInstance',
            'AuthenticatedSession',
            'bmMultifactorService',
            'LinkedAccountsService',
            'myAccountService',
            'languageStorageManager',
            '$compile',
            '$rootScope',
            'uid'
        ];
        function linkAuthCtrl(
            bmAccess,
            $templateRequest,
            $scope,
            $translate,
            $location,
            $uibModalInstance,
            session,
            mfaService,
            linkedAccountsService,
            myAccountService,
            langMgr,
            $compile,
            $rootScope,
            uid
        ) {
            /*jshint validthis:true */
            var vm = this;
            vm.linkAccounts = linkAccounts;
            vm.closeModal = closeModal;
            vm.changeEmail = changeEmail;
            vm.pwd = '';
            vm.isLoaderBusy = false;

            var linkingResult = 'change email';

            function linkAccounts() {
                if (vm.verifyLoginForm.$valid) {
                    vm.isLoaderBusy = true;
                    // TODO: RIGHT NOW THIS PASSWORD CHECK IS SET TO TRID INSTEAD OF PRODUCT OPTIONS
                    var userData = { uid: uid, pwd: vm.pwd, type: 'TRID' };
                    mfaService.verifyLoginData(userData).then(function(){
                        linkedAccountsService.linkExistingAccountWithLogin(userData.uid).then(function(linkedResp) {
                            linkingResult = linkedResp.data.LongToken;
                            session.switchAccountWithLongToken(linkingResult);
                            vm.isLoaderBusy = false;
                            closeModal();
                        }, function(error){
                            linkingResult = 'change email';
                            vm.isLoaderBusy = false;
                            if(error.status === 400) {
                                showLinkingError(error.data.message);
                            } else {
                                $translate('BM.Components.SorryTryAgainLater').then(function(text) {
                                    showLinkingError(text);
                                });
                            }
                        });
                    }, function(){
                        vm.isLoaderBusy = false;
                        $translate('bm.header.viewProfile.mfaConfirmError').then(function(text) {
                            showLinkingError(text);
                        });
                    });
                }
            }

            function closeModal() {
                clearErrors();
                $uibModalInstance.close(linkingResult);
            }

            function changeEmail() {
                clearErrors();
                $uibModalInstance.dismiss('change email');
            }

            function showLinkingError(text) {
                clearErrors();
                $rootScope.bmErrors.splice(0, $rootScope.bmErrors.length);
                $rootScope.bmErrors.push({type: 'danger', msg: text, closeable: true});
            }

            function clearErrors() {
                if (!$rootScope.bmErrors) {
                    $rootScope.bmErrors = [];
                }
                $rootScope.bmErrors = [];
            }
        }
})(window.angular);

(function (angular) {
    'use strict';

    angular.module('bluemoon.updatePassword', [
        'bluemoon.components.session',
        'bluemoon.passwordValidation',
        'pascalprecht.translate',
        'bluemoon.components.focus'
    ]);
})(window.angular);

(function(angular){
    'use strict';

    angular.module('bluemoon.updatePassword').controller('UpdatePasswordCtrl', updatePassword);

    updatePassword.$inject = ['$translate', '$scope', 'bmAccess', 'PasswordFactory', 'PasswordValidationFactory'];

    function updatePassword($translate, $scope, bmAccess, PasswordFactory, PasswordValidationFactory){
        /*jshint validthis:true */
        var vm = this;

        var confirmPasswordMsgNoData = '';
        var confirmPasswordMsgNoMatch = '';
        var reusedPasswordError = '';
        var commonPasswordError = '';

        this.$onInit = function(){
            vm.savePassword = savePassword;
            vm.cancelPassword = cancelPassword;
            vm.validatePasswordFields = validatePasswordFields;
            vm.validateConfirmPassword = validateConfirmPassword;
            vm.setConfirmPasswordInFocus = setConfirmPasswordInFocus;
            vm.setConfirmPasswordOutOfFocus = setConfirmPasswordOutOfFocus;
            vm.isConfirmPasswordInvalid = isConfirmPasswordInvalid;
            vm.isConfirmPasswordValid = isConfirmPasswordValid;
            vm.closeAlert = closeAlert;

            vm.newPasswordError = '';
            vm.confirmPasswordError = '';
            vm.confirmPasswordInFocus = false;

            $translate('BM.Components.PasswordMatchError').then(function(data){
                confirmPasswordMsgNoMatch = data;
            });
            $translate('BM.Components.NoDataEnteredError').then(function(data){
                confirmPasswordMsgNoData = data;
            });
            $translate('BM.Components.PasswordUsedPreviouslyError').then(function(data){
                reusedPasswordError = data;
            });
            $translate('BM.Components.PasswordTooCommonError').then(function(data){
                commonPasswordError = data;
            });

            // 2-way bound data object to pass information between tabs
            vm.sharedLocal = vm.sharedData;
            vm.sharedLocal.hasUnsavedPassword = false;

            // Create method publicly available through 2-way data bound object
            vm.sharedLocal.setPasswordDirty = function(){
                setFormState();
            };

            vm.isSkinny = vm.sharedLocal.skinny === true; // controls how alerts are displayed
            vm.alerts = [];

            // Load up password validation rules
            PasswordValidationFactory.loadPasswordRules().then(function(response){
                angular.extend(vm, response);
            });

            // If appropriate, check for the existence of the user data
            bmAccess.has('PPE-AccountSwitching').then(function(){
                checkForUser();
            }).catch(angular.noop);
        };

        function checkForUser(){
            // Make sure a user is loaded
            if(angular.isUndefined(vm.user) || vm.user === ''){
                $translate('BM.Components.AccountInformation.LoadError').then(function(alert){
                    addAlert(alert, 'danger');
                });

                return;
            }
        }

        function savePassword(){
            resetAlerts();

            // Validate the form
            validatePasswordFields(true);

            if(vm.updatePasswordForm.$invalid || vm.passwordIsValidated !== true || vm.confirmIsValidated !== true){
                // Toggle all validation messages
                if(vm.updatePasswordForm.currentPassword.$error.required){
                   vm.updatePasswordForm.currentPassword.$dirty = true;
                   vm.updatePasswordForm.currentPassword.hasVisited = true;
                }

                $translate('BM.Components.IncompleteForm').then(function(value){
                    addAlert(value, 'danger');
                });

                return;
            }

            $scope.$emit('bm-busy-loading-on');
            PasswordFactory.savePassword(vm.currentPassword, vm.newPassword).then(function(){
                $scope.$emit('bm-busy-loading-off');
                resetEntryForm();
                vm.sharedLocal.hasUnsavedPassword = false;

                bmAccess.has('PPE-AccountSwitching').then(function(){
                    if (vm.user && vm.user.email) {
                        $translate('BM.Components.PasswordUpdateSuccessful').then(function (value) {
                            value = value + ' ' + vm.user.email;
                            addAlert(value, 'success');
                        });
                    } else {
                        $translate('bm.header.viewProfile.password.saveSuccessful').then(function (value) {
                            addAlert(value, 'success');
                        });
                    }
                }, function() {
                    $translate('bm.header.viewProfile.password.saveSuccessful').then(function(value){
                        addAlert(value, 'success');
                    });
                });
            }, function(response) {
                $scope.$emit('bm-busy-loading-off');

                response.config.global = false;
                if (response.status === 401) {
                    $translate('BM.Components.PasswordInvalidError').then(function(value){
                        addAlert(value, 'danger');
                    });
                } else if (response.data.error === 'PASSWORD_CONTAINS_USERINFO') {
                    $translate('BM.Components.PasswordContainsPersonalInfo').then(function(value){
                        addAlert(value, 'danger');
                    });
                } else {
                    $translate('BM.Components.PasswordUpdateError').then(function(value){
                        addAlert(value, 'danger');
                    });
                }
            });
        }

        function validatePasswordFields(isSubmit){
            validatePassword(isSubmit);
            validateConfirmPassword(isSubmit);
        }

        function validatePassword(isSubmit){
            // Reset the validation message
            vm.newPasswordError = '';
            vm.passwordIsValidated = false;

            // Password required
            if(vm.updatePasswordForm.newPassword.$error.required){
                $translate('BM.Components.EnterPasswordError').then(function(data){
                    vm.newPasswordError = data;
                });
                return;
            }

            if(angular.isUndefined(vm.rules) || vm.rules.length === 0) {
                return;
            }

            // run the rules
            // first, the character length rule because it's required
            var lengthRule = vm.rules.characterLengthRule;
            if(!lengthRule.test(vm.newPassword)) {
                $translate('BM.Components.ValidPasswordError').then(function(data){
                    vm.newPasswordError = data;
                });
                return;
            } else {
                // second, the character type rules
                var rulesPassed = 0;
                for(var pos = 0; pos < vm.rules.characterTypeRules.length; pos++) {
                    var currentRule = vm.rules.characterTypeRules[pos];
                    if(currentRule.test(vm.newPassword)) {
                        rulesPassed++;
                    }
                }
                if(rulesPassed < vm.charClassReq) {
                    $translate('BM.Components.ValidPasswordError').then(function(data){
                        vm.newPasswordError = data;
                    });
                    return;
                }
            }

            if(vm.rules.prohibitedCharacterRule.test(vm.newPassword)){
                vm.newPasswordError = vm.rules.prohibitedCharacterRule.label + ': ' + vm.rules.prohibitedCharacterRule.getInvalidChars(vm.newPassword).join(', ');
                return;
            }

            if(isSubmit && (vm.currentPassword === vm.newPassword)){
                $translate('BM.Components.NewPasswordMatchError').then(function(data){
                    vm.newPasswordError = data;
                });
                return;
            }

            PasswordFactory.verifyNewPassword(vm.newPassword).then(function(response){
                if (response.data.usedPreviously) {
                    vm.newPasswordError = reusedPasswordError;
                } else if (response.data.tooCommon) {
                    vm.newPasswordError = commonPasswordError;
                }
            });

            vm.passwordIsValidated = true;
        }

        function validateConfirmPassword(isSubmit){
            // Reset the validation message
            vm.confirmPasswordError = '';
            vm.confirmIsValidated = false;

            // Has anything even been entered? Only show message on submit of form.
            if(isSubmit && (angular.isUndefined(vm.confirmPassword) || vm.confirmPassword === '')){
                vm.confirmPasswordError = confirmPasswordMsgNoData;
                return;
            }

            if((angular.isUndefined(vm.confirmPassword) || vm.confirmPassword === '') &&
                (angular.isUndefined(vm.newPassword) || vm.newPassword === '')){
                return;
            }

            if(vm.confirmPassword !== vm.newPassword){
                vm.confirmPasswordError = confirmPasswordMsgNoMatch;
                return;
            }

            vm.confirmIsValidated = true;
        }

        function isConfirmPasswordValid() {
            var isValid = false;
            var newPwd = '';
            var confirmPwd = '';

            if(vm.confirmPassword) {
                if(!vm.updatePasswordForm.newPassword.$error.required) {
                    newPwd = vm.newPassword;
                    confirmPwd = vm.confirmPassword;

                    if((confirmPwd.length === newPwd.length) && (confirmPwd === newPwd)) {
                        isValid = true;
                    }
                }
            }
            return isValid;
        }

        function isConfirmPasswordInvalid() {
            var isInvalid = true;
            var newPwd = '';
            var confirmPwd = '';
            vm.confirmIsValidated = false;

            // Get the data to check
            if(angular.isUndefined(vm.newPassword)){
                newPwd = '';
            } else {
                newPwd = vm.newPassword;
            }
            if(angular.isUndefined(vm.confirmPassword)){
                confirmPwd = '';
            } else {
                confirmPwd = vm.confirmPassword;
            }

            // check the data
            if(vm.confirmPasswordInFocus) {
                vm.updatePasswordForm.confirmPassword.$dirty = true;

                if(confirmPwd === newPwd) {
                    vm.confirmPasswordError = '';
                    isInvalid = false;
                } else if(newPwd.slice(0, confirmPwd.length) !== confirmPwd) {
                    if(confirmPwd === '') {
                        vm.confirmPasswordError = confirmPasswordMsgNoData;
                    } else {
                       vm.confirmPasswordError = confirmPasswordMsgNoMatch;

                    }
                } else {
                     vm.confirmPasswordError = '';
                     isInvalid = false;
                }
            } else {
                if(vm.updatePasswordForm.confirmPassword.$dirty) {
                    vm.confirmPasswordError = '';
                    validateConfirmPassword(true);
                }

                if(vm.confirmPasswordError === '') {
                    isInvalid = false;
                }
            }

            return isInvalid;
        }

        function setConfirmPasswordInFocus() {
            vm.confirmPasswordInFocus = true;
            vm.confirmPasswordError = '';
        }

        function setConfirmPasswordOutOfFocus() {
            vm.confirmPasswordInFocus = false;
        }

        function resetEntryForm(){
            vm.currentPassword = '';
            vm.newPassword = '';
            vm.confirmPassword = '';
            vm.updatePasswordForm.$setPristine();
            vm.passwordIsValidated = false;
            vm.confirmIsValidated = false;

            // clear any validation messages
            vm.updatePasswordForm.currentPassword.$setValidity('required', true);
            vm.newPasswordError = '';
            vm.confirmPasswordError = '';
        }

        function addAlert(message, type){
            resetAlerts();

            var alert = { msg: message, type: type };

            if(vm.isSkinny){
                alert.closeable = true;
                alert.timeout = 2500;
            }

            vm.alerts.push(alert);
        }

        function resetAlerts(){
            vm.alerts.length = 0;
        }

        function closeAlert(index){
            vm.alerts.splice(index, 1);
        }

        function cancelPassword(){
            if(vm.sharedLocal.resetOnCancel){
                vm.currentPassword = '';
                vm.newPassword = '';
                vm.confirmPassword = '';

                setFormState();
            }

            $scope.$emit('bmProfileCancelAction');
        }

        function setFormState(){
            var isClean = (angular.isUndefined(vm.currentPassword) || vm.currentPassword === '') &&
                (angular.isUndefined(vm.newPassword) || vm.newPassword === '') &&
                (angular.isUndefined(vm.confirmPassword) || vm.confirmPassword === '');

            if(isClean){
                resetEntryForm();
                resetAlerts();
            } else {
                vm.updatePasswordForm.$setDirty();
            }

            vm.sharedLocal.hasUnsavedPassword = !isClean;
        }
    }

})(window.angular);

(function(angular){
    'use strict';

    angular.module('bluemoon.updatePassword').factory('PasswordFactory', passwordFactory);
    passwordFactory.$inject = ['$http'];

    function passwordFactory($http){
        var factory = {
            savePassword: savePassword,
            verifyNewPassword: verifyNewPassword
        };
        var passwordApi = '/api/profiles/v1/password';
        var passwordVerifyApi = '/api/profiles/v2/password/check';

        return factory;

        //////////

        function savePassword(oldPassword, newPassword){
            return $http({
                method: 'PUT',
                url: passwordApi,
                data: { oldPassword: oldPassword, newPassword: newPassword },
                headers: {'x-prevent-unauthorized': true},
                bmAuthRedirect: false // disable 401 redirection
            });
        }

        function verifyNewPassword(password){
            return $http({
                method: 'POST',
                url: passwordVerifyApi,
                headers: {'Content-Type': 'application/json'},
                data: {
                    password: password
                }
            });
        }
    }
})(window.angular);

(function(angular){
    'use strict';

    angular.module('bluemoon.updatePassword').directive('bmUpdatePassword', [function(){
        return {
            restrict: 'E',
            replace: true,
            templateUrl: 'update-password/update-password.2js.html',
            scope: {
                user: '=',
                sharedData: '='
            },
            controller: 'UpdatePasswordCtrl',
            controllerAs: 'vm',
            bindToController: true
        };
    }]);

})(window.angular);

(function (angular) {
    'use strict';

    angular.module('bluemoon.securityQuestions', [
        'bluemoon.components.session',
        'pascalprecht.translate',
        'bmForceModelChange',
        'bmHttpCache'
    ]);
})(window.angular);

(function(angular){
    'use strict';

    angular.module('bluemoon.securityQuestions').controller('SecurityQuestionsCtrl', securityQuestions);
    securityQuestions.$inject = ['$q', '$scope', '$translate', 'SecurityQuestionsFactory'];

    function securityQuestions($q, $scope, $translate, SecurityQuestionsFactory){
        /*jshint validthis:true */
        var vm = this;
        var questionCounter;
        var answerInitValue;
        var masterQuestions = vm.master;
        var initialUserQuestions = vm.userQuestions;

        vm.saveQuestions = saveQuestions;
        vm.cancelQuestions = cancelQuestions;
        vm.processQuestionSelect = processQuestionSelect;
        vm.validateAnswer = validateAnswer;
        vm.clearDefaultAnswer = clearDefaultAnswer;

        var selectQuestionError = 'Please select a question.';
        var enterAnswerError = 'Please enter an answer.';
        var loadSecurityQuestionsError = 'Unable to load security question information. Please try again.';
        var loadSecurityEnounteredError = 'An error was encountered while loading security questions.';
        var entryDataLoadError = 'Unable to load form entry data. Please try again.';
        var noSecurityQuestionsSetupError = 'Please setup your security questions.';

        // 2-way bound data object to pass information between tabs
        vm.sharedLocal = vm.sharedData;
        vm.sharedLocal.hasUnsavedQuestions = false;

        translateErrors();
        initializeView();

        //////////

        function translateErrors(){
            $translate('BM.Components.Security.SelectQuestionError').then(function(data){
                selectQuestionError = data;
            });
            $translate('BM.Components.Security.EnterAnswerError').then(function(data){
                enterAnswerError = data;
            });
            $translate('BM.Components.Security.LoadSecurityQuestionsError').then(function(data){
                loadSecurityQuestionsError = data;
            });
            $translate('BM.Components.Security.LoadSecurityEnounteredError').then(function(data){
                loadSecurityEnounteredError = data;
            });
            $translate('BM.Components.Security.EntryDataLoadError').then(function(data){
                entryDataLoadError = data;
            });

            $translate('BM.Components.Security.NoSecurityQuestionsSetupError').then(function(data){
                noSecurityQuestionsSetupError = data;
            });
        }

        function initializeView(){
            resetAlerts();
            vm.questions = [];

            // Create method publicly available through 2-way data bound object
            vm.sharedLocal.setQuestionsDirty = function(){
                setFormState();
            };

            // assumes user never setup any questions
            if(angular.isUndefined(initialUserQuestions)){
                initialUserQuestions = getDefaultUserQuestions();
                addAlert(noSecurityQuestionsSetupError, 'danger');
            } else {
                // Note: These characters in javascript seem bad
                answerInitValue = '●●●●●●●●●●●●●●●●●●●●';
            }

            if(angular.isUndefined(masterQuestions) || initialUserQuestions.length === 0){
                addAlert(loadSecurityQuestionsError, 'danger');
                return;
            }

            vm.questions = getBindableData(angular.copy(initialUserQuestions));
            filterMasterQuestions();
        }

        function getDefaultUserQuestions(){
            return [
                { questionId: '', question: '', answer: '' },
                { questionId: '', question: '', answer: '' },
                { questionId: '', question: '', answer: '' }
            ];
        }

        function saveQuestions(){
            resetAlerts();

            // Just make sure
            if(angular.isUndefined(vm.questions) || vm.questions.length === 0){
                addAlert(entryDataLoadError, 'danger');
                return;
            }

            var isFormValid = validateFormEntry(vm.questions);

            if(!isFormValid){
                // Note: Validation messages will be set when isFormValid is processed
                var alert = '';
                 $translate('BM.Components.IncompleteForm').then(function(data){
                    alert = data;
                    addAlert(alert, 'danger');
                });
                return;
            }

            var questionsToSave = getSaveData(angular.copy(vm.questions));

            $scope.$emit('bm-busy-loading-on');
            SecurityQuestionsFactory.saveQuestions(questionsToSave).then(function(){
                $scope.$emit('bm-busy-loading-off');
                vm.sharedLocal.hasUnsavedQuestions = false;
                initialUserQuestions = angular.copy(vm.questions);
                $translate('bm.header.viewProfile.questions.saveSuccessful').then(function(value){
                    addAlert(value, 'success');
                });
            }, function(){
                $scope.$emit('bm-busy-loading-off');
                $translate('BM.Components.IncorrectSecurityQuestion').then(function(value){
                    addAlert(value, 'danger');
                });
            });
        }

        function cancelQuestions(){
            if(vm.sharedLocal.resetOnCancel){
                initializeView();
                setFormState();
            }

            $scope.$emit('bmProfileCancelAction');
        }

        function processQuestionSelect(listIndex, question){
            validateQuestion(question);

            // Answer is required if question is changed in a list
            if(angular.isUndefined(question) || angular.isUndefined(question.answer) || question.answer === answerInitValue){
                question.answer = '';
            }

            // Filter the master questions list for each question
            filterMasterQuestions(listIndex);
        }

        function filterMasterQuestions(listIndex){
            // listIndex = <select> list that the value was changed in
            // Need to filter selected questions out of other master lists so the same question can't be selected twice
            var currentQuestionList;

            for(questionCounter = 0; questionCounter < vm.questions.length; questionCounter++){
                // Don't need skip the list that was just selected
                if(angular.isDefined(listIndex) && questionCounter === listIndex){
                    continue;
                }

                // Get a filtered list
                currentQuestionList = angular.copy(masterQuestions);
                currentQuestionList = currentQuestionList.filter(notAlreadySelected);

                // The first time through will not have a master list of questions
                if(angular.isUndefined(vm.questions[questionCounter].masterList)){
                    vm.questions[questionCounter].masterList = currentQuestionList;
                    continue;
                }

                var removeCounter = vm.questions[questionCounter].masterList.length;
                var questionIdAsInt = parseInt(vm.questions[questionCounter].selectedQuestion.questionId);

                // Clear the existing array without creating a new array object as this will kill scope
                while(removeCounter > 0){
                    removeCounter--;
                    // Don't clear the selected question
                    if(vm.questions[questionCounter].masterList[removeCounter].questionId === questionIdAsInt){
                        continue;
                    }

                    vm.questions[questionCounter].masterList.splice(removeCounter, 1);
                }

                // Append to the array without creating a new array object
                for(var addCounter = 0; addCounter < currentQuestionList.length; addCounter++){
                    if(currentQuestionList[addCounter].questionId === questionIdAsInt){
                        continue;
                    }

                    if(currentQuestionList[addCounter].questionId < questionIdAsInt){
                        vm.questions[questionCounter].masterList.unshift(currentQuestionList[addCounter]);
                    } else {
                        vm.questions[questionCounter].masterList.push(currentQuestionList[addCounter]);
                    }
                }
            }
        }

        function notAlreadySelected(element){
            var alreadySelected = false;
            var questionIdAsInt;

            for(var counter = 0; counter < vm.questions.length; counter++){
                if(alreadySelected){
                    break;
                }

                if(vm.questions[counter].selectedQuestion === null){
                    continue;
                }

                questionIdAsInt = parseInt(vm.questions[counter].selectedQuestion.questionId);
                // questionCounter is global and represents the current list being filtered
                alreadySelected = (element.questionId === questionIdAsInt && questionIdAsInt !== vm.questions[questionCounter].selectedQuestion.questionId);
            }

            return !alreadySelected;
        }

        function clearDefaultAnswer(question){
            if(question.answer === answerInitValue){
                question.answer = '';
            }
        }

        function validateFormEntry(questions){
            var isValid = true;

            angular.forEach(questions, function(question){
                validateQuestion(question);
                validateAnswer(question);

                if(question.questionError !== '' || question.answerError !== ''){
                    isValid = false;
                }
            });

            return isValid;
        }

        function validateQuestion(question){
            if(angular.isUndefined(question)){
                question.questionError = selectQuestionError;
                return;
            }

            if(angular.isUndefined(question) || question.selectedQuestion === null || angular.isUndefined(question.selectedQuestion) || question.selectedQuestion.questionId === ''){
                question.questionError = selectQuestionError;
                return;
            }

            // set unloaded question to the selected question
            if(question.questionId === ''){
                question.questionId = question.selectedQuestion.questionId;
                question.question = question.selectedQuestion.question;
            }

            question.questionError = '';
        }

        function validateAnswer(question){
            if(angular.isUndefined(question) || angular.isUndefined(question.answer) || question.answer === ''){
                question.answerError = enterAnswerError;
                return;
            }

            question.answerError = '';
        }

        function getBindableData(questions){
            angular.forEach(questions, function(question){
                question.answer = answerInitValue;
                question.answerError = '';
                question.questionError = '';

                // Store the selected question separately for the model
                // http://stackoverflow.com/questions/28133187/angularjs-select-cleared-after-selecting-value
                if(angular.isUndefined(question.selectedQuestion)){
                    question.selectedQuestion = question;
                }
            });

            return questions;
        }

        function getSaveData(questionList){
            var questionsToSave = {};
            var questions = [];

            angular.forEach(questionList, function(saveQuestion, index){
                if(angular.isUndefined(saveQuestion.selectedQuestion)){
                    questions.push({
                        questionId: saveQuestion.questionId,
                        question: saveQuestion.question,
                        answer: saveQuestion.answer
                    });
                } else {
                    questions.push({
                        questionId: parseInt(saveQuestion.selectedQuestion.questionId),
                        question: getQuestionTextFromId(saveQuestion.selectedQuestion.questionId),
                        answer: (saveQuestion.answer === answerInitValue) ? initialUserQuestions[index].answer : saveQuestion.answer
                    });
                }
            });

            questionsToSave.questions = questions;
            return questionsToSave;
        }

        function getQuestionTextFromId(questionId){
            var questionText;

            for(var counter = 0; counter < masterQuestions.length; counter++){
                if(parseInt(questionId) === masterQuestions[counter].questionId){
                    questionText = masterQuestions[counter].question;
                    break;
                }
            }

            return questionText;
        }

        function addAlert(message, type){
            resetAlerts();
            vm.alerts.push({ msg: message, type: type });
        }

        function resetAlerts(){
            vm.alerts = [];
        }

        function setFormState(){
            // Is the form valid?
            var isFormValid = validateFormEntry(vm.questions);

            if(!isFormValid){
                vm.sharedLocal.hasUnsavedQuestions = true;
                return;
            }

            var saveData = getSaveData(vm.questions);
            var initialData = getSaveData(initialUserQuestions);
            var isClean = angular.equals(saveData, initialData);

            if(isClean){
                resetAlerts();
            }

            vm.sharedLocal.hasUnsavedQuestions = !isClean;
        }
    }
})(window.angular);

(function(angular){
    'use strict';

    angular.module('bluemoon.securityQuestions').factory('SecurityQuestionsFactory', securityQuestionsFactory);
    securityQuestionsFactory.$inject = ['$q','$http', 'AuthenticatedSessionData', 'bmHttpCacheHelper'];

    function securityQuestionsFactory($q, $http, authenticatedSessionData, bmHttpCacheHelper){
        var factory = {
            getSecurityQuestions: getSecurityQuestions,
            getUserSecurityQuestions: getUserSecurityQuestions,
            getMyUserSecurityQuestions: getMyUserSecurityQuestions,
            saveQuestions: saveQuestions
        };

        var questionsApi = '/api/profiles/v1/security-questions';

        // cache for 10 minutes
        var baseHttpConfig = {
            headers: {
                'Content-Type': 'application/json; charset=utf-8',
                'Compress-Data': 'true',
                'Accept': 'application/json'
            },
            bmCache: 600000
        };

        return factory;

        //////////

        function getUserSecurityQuestions(emailAddress){
            if(angular.isUndefined(emailAddress)){
                var deferred = $q.defer();
                deferred.reject();
                return deferred.promise;
            }

            var apiUrl = questionsApi + '/' + emailAddress;
            return $http.get(apiUrl, baseHttpConfig);
        }

        function getMyUserSecurityQuestions(){
            var myEmail = angular.isDefined(authenticatedSessionData.meta) ? authenticatedSessionData.meta.EmailAddress : undefined;

            return getUserSecurityQuestions(myEmail);
        }

        function getSecurityQuestions(){
            return $http.get(questionsApi, baseHttpConfig);
        }

        function saveQuestions(questions){
            return $http.put(questionsApi, questions).then(function(){
                var emailAddress = angular.isDefined(authenticatedSessionData.meta) ? authenticatedSessionData.meta.EmailAddress : undefined;

                // invalidate any user questions stored in cache
                if(angular.isDefined(emailAddress)){
                    bmHttpCacheHelper.invalidateHttpCache(questionsApi + '/' + emailAddress);
                }
            });
        }
    }
})(window.angular);

(function(angular){
    'use strict';

    angular.module('bluemoon.securityQuestions').directive('bmSecurityQuestions', [function(){
        return {
            restrict: 'E',
            replace: true,
            templateUrl: 'security-questions/security-questions.2js.html',
            scope: {
                master: '=',
                userQuestions: '=',
                sharedData: '='
            },
            controller: 'SecurityQuestionsCtrl',
            controllerAs: 'vm',
            bindToController: true
        };
    }]);

})(window.angular);

(function(angular){
    'use strict';

    angular.module('bmViewProfile', [
        'ui.bootstrap',
        'pascalprecht.translate',
        'bmPermission',
        'bluemoon.myAccount',
        'bluemoon.securityQuestions',
        'bluemoon.updatePassword',
        'bmCheckpointCredentials',
        'bmMultifactorProfile',
        'bmLinkedAccounts'
    ]);
})(window.angular);

(function(angular){
    'use strict';

    angular.module('bmViewProfile').controller('bmViewProfileCtrl', bmViewProfileCtrl);
    bmViewProfileCtrl.$inject = ['$scope', '$translate', '$uibModalInstance', 'languages', 'user'];

    function bmViewProfileCtrl($scope, $translate, $uibModalInstance, languages, user){
        /*jshint validthis:true */
        var vm = this;
        vm.languages = languages;
        vm.user = user;

        // object used to share methods between profile directives
        vm.sharedProfile = {};

        vm.closeProfile = closeProfile;
        vm.tabDeselect = tabDeselect;
        vm.tabSelect = tabSelect;

        $scope.$on('bmLanguageChangeSuccess', loadTranslations);
        $scope.$on('bmProfileCancelAction', function(){
            closeProfile();
        });

        loadTranslations();

        //////////

        function loadTranslations(){
            $translate('bm.header.viewProfile.unsavedChanges').then(function(value){
                vm.translatedUnsaved = value;
            }, function(){
                vm.translatedUnsaved = 'Unsaved Changes';
            });
        }

        function closeProfile(){
            $uibModalInstance.dismiss('close');
        }

        function tabSelect(whichTab){
            switch(whichTab){
                case 'linkedAccounts':
                    vm.sharedProfile.refreshLinkedAccounts();
                    break;
                default:
                    break;
            }
        }

        function tabDeselect(whichTab){
            switch(whichTab){
                case 'account':
                    vm.sharedProfile.setAccountDirty();
                    break;
                case 'password':
                    vm.sharedProfile.setPasswordDirty();
                    break;
                case 'checkpoint':
                    vm.sharedProfile.setCheckpointDirty();
                    break;
                case 'linkedAccounts':
                    vm.sharedProfile.setLinkedAccountsDirty();
                    break;
                default:
                    break;
            }
        }
    }
})(window.angular);

(function (angular) {
    'use strict';

    angular.module('bluemoon.components.timeZoneOffsetInterceptor', [])
        .config(['$httpProvider', function ($httpProvider) {
            $httpProvider.interceptors.push('bmHttpTimeZoneOffsetInterceptor');
        }])
        .service('bmHttpTimeZoneOffsetInterceptor', function () {
            var headerKey = 'User-Time-Zone-Offset-Minutes';
            this.request = function (conf) {
                if (!conf.headers[headerKey]) {
                    conf.headers[headerKey] = new Date().getTimezoneOffset();
                }
                return conf;
            };
        });
})(window.angular);

(function(angular) {
    'use strict';

    /*
     *  bmFormatOnBlur
     *
     *  Requires: ngModel
     *
     *  Scope type: none
     *
     *  Description:
     *  Binds to the blur event and works with ngModel to reformat the view value after a blur. Useful in cases where
     *  a value converter directive accepts multiple input formats that are different from the output format (e.g. dates).
     */
    angular.module('bmFormatOnBlur', ['bento.services'])
        .directive('bmFormatOnBlur', ['$bentoServices',
            function($bentoServices) {
                return {
                    require: 'ngModel',
                    priority: 10,
                    link: function($scope, element, attrs, ctrl) {
                        // when we lose focus, revert to old value if new value is invalid,
                        // then reformat the view.
                        element.bind('blur', function() {
                            $bentoServices.safeApply($scope, angular.noop);

                            // re-run the formatter chain on the $modelValue
                            if(!ctrl.$invalid) {
                                ctrl.$viewValue = ctrl.$modelValue;
                                for(var i = ctrl.$formatters.length - 1; i >= 0; i = i - 1) {
                                    ctrl.$viewValue = ctrl.$formatters[i](ctrl.$viewValue);
                                }

                                // re-render the view
                                ctrl.$render();
                            }
                        });
                    }
                };
    }]);

}(window.angular));

(function(angular){
    'use strict';

    angular.module('bmLinkedAccounts', ['bento.modern', 'LinkedAccountsService', 'wj', 'bmLinkingMerge']);
})(window.angular);

(function(angular) {
    'use strict';

    angular.module('bmLinkedAccounts').controller('LinkedAccountsCtrl', LinkedAccountsCtrl);
	LinkedAccountsCtrl.$inject = ['$scope', '$translate', '$bentoBusyLoader', '$uibModal', 'LinkedAccountsService'];

    function LinkedAccountsCtrl($scope, $translate, $bentoBusyLoader, $uibModal, LinkedAccountsService){

        /*jshint validthis:true */
		var vm = this;

		this.$onInit = function(){
			vm.saveLinkedAccounts = saveLinkedAccounts;
			vm.cancelLinkedAccounts = cancelLinkedAccounts;
			vm.defaultChanged = defaultChanged;
			vm.openMergeLinkingAccountDialog = openMergeLinkingAccountDialog;

			vm.linkedAccounts = [];
			vm.gridData = [];
			vm.alerts = [];
			vm.linkedAccountsSummaryMsg = '';
			vm.selectedDefaultLinkAccountId = '0';
			vm.flexgrid = undefined;
			vm.hasOneAccount = false;
			vm.showAccounts = true;
			vm.isLoaderBusy = false;

			// 2-way bound data object to pass information between tabs
			vm.sharedLocal = vm.sharedData;
			vm.sharedLocal.hasUnsavedLinkedAccounts = false;

			initializeView();
		};

		function initializeView() {
			resetAlerts();

			// Create method publicly available through 2-way data bound object
			vm.sharedLocal.setLinkedAccountsDirty = function(){
				setFormState();
			};

			vm.sharedLocal.refreshLinkedAccounts = function(){
				if(vm.linkedAccounts.length === 0) {
					loadData();
				}
			};

			// Only used when it's called in a dialog by itself. It will not when called when viewing profile.
			if(vm.sharedLocal.loadLinkedAccounts) {
				loadData();
			}
		}

		function loadData() {
			// Make sure the user was resolved
			if(angular.isUndefined(vm.user) || vm.user === ''){
				$translate('BM.Components.AccountInformation.LoadError').then(function(alert){
					addAlert(alert, 'danger');
				});

				return;
			} else {
				loadLinkedAccounts();
			}
		}

        function openMergeLinkingAccountDialog() {
            var modalOptions = {
                templateUrl: 'components/linking-merge/linking-merge-modal.2js.html',
                controllerUrl: 'components/linking-merge/linking-merge-controller',
                controller: 'bmLinkingMergeCtrl as vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    user: function () {
                        return undefined;
                    },
                    sharedProfile: function () {
                        return {};
                    }
                }
            };
            var instance = $uibModal.open(modalOptions)
				.result.then(function () {
					$translate('bm.linkingMerge.success').then(function (value) {
                        addAlert(value, 'success');
                    });
					loadLinkedAccounts();
				}, function () {
					// do nothing on popup dismissal.
				});

            return instance;

        }

		function loadLinkedAccounts() {
			vm.isLoaderBusy = true;
			LinkedAccountsService.getAllOnvioLinkedAccounts().then(function(response){
				vm.linkedAccounts = response.data;

				// if no accounts, do not show grid
				if(vm.linkedAccounts && vm.linkedAccounts.length < 1) {
					vm.showAccounts = false;
				}

				// if only one account, disable active and default values
				if(vm.linkedAccounts && vm.linkedAccounts.length < 2) {
					vm.hasOneAccount = true;
				}

				// find the default account
				for(var pos1 = 0; pos1 < vm.linkedAccounts.length; pos1++) {
					var someLinkedAccount = vm.linkedAccounts[pos1];
					if(someLinkedAccount.home) {
						vm.selectedDefaultLinkAccountId = someLinkedAccount.linkedAccountId;
					}

					if(!someLinkedAccount.displayedNickname || someLinkedAccount.displayedNickname === '') {
						vm.linkedAccounts[pos1].displayedNickname = '';
					}
				}

				vm.gridData = vm.linkedAccounts;
				vm.gridData = new wijmo.collections.CollectionView(vm.gridData);  // jshint ignore: line
				vm.gridData.trackChanges = true;
				vm.isLoaderBusy = false;

			}).catch(function(error){
				addAlert(error.message, 'danger');
				vm.isLoaderBusy = false;
				console.log(error);
			});
		}

		function addAlert(message, type){
			resetAlerts();

			var alert = { msg: message, type: type, closeable: true };
			vm.alerts.push(alert);
		}

		function resetAlerts(){
			vm.alerts = [];
		}

		function convertToJson(itemsEdited) {
			var jsonObject = {
				linkedAccountsToUpdate : []
			};

			for(var pos = 0; pos < itemsEdited.length; pos++) {
				var item = itemsEdited[pos];
				jsonObject.linkedAccountsToUpdate.push(item);
			}

			return jsonObject;
		}

		function saveLinkedAccounts() {
			resetAlerts();

			var items = vm.gridData.items;
			var itemsEdited = vm.gridData.itemsEdited;

			// Check for edited items
			if(itemsEdited && itemsEdited.length > 0) {
				// check to make sure all items are valid
				if(hasValidData(items)) {
					// conver to json
					var jsonAccounts = convertToJson(itemsEdited);

					vm.isLoaderBusy = true;
					LinkedAccountsService.updateLinkedAccounts(jsonAccounts).then(function(){
						vm.isLoaderBusy = false;
						$translate('bm.components.linkedAccounts.updateSuccsessful').then(function(msg){
							addAlert(msg, 'success');
						});
					}).catch(function(error){
						vm.isLoaderBusy = false;
						console.log(error);
					});
				}
			}
		}

		function hasValidData(items) {
			var isValid = true;

			if(!hasActiveAccount(items)) {
				isValid = false;
				$translate('bm.components.linkedAccounts.missingActive').then(function(msg){
						addAlert(msg, 'danger');
				}, function() {
					addAlert('Bad translation: You must have at least one active account selected.', 'danger');
				});
			} else if(!hasActiveHomeAccount(items)) {
				isValid = false;
				$translate('bm.components.linkedAccounts.missingActiveHome').then(function(msg){
						addAlert(msg, 'danger');
				}, function() {
					addAlert('Bad translation: You must have an active account marked as home.', 'danger');
				});
			} else if(!hasValidNickname(items)) {
				isValid = false;
				$translate('bm.components.linkedAccounts.invalidNickname').then(function(msg){
						addAlert(msg, 'danger');
				}, function() {
					addAlert('Bad translation: The nickname must be less then 50 characters.', 'danger');
				});

			}
			return isValid;
		}

		function hasActiveAccount(items) {
			var hasOneActiveAccount = false;
			for(var pos = 0; pos < items.length; pos++) {
				if(items[pos].active) {
					hasOneActiveAccount = true;
				}
			}

			return hasOneActiveAccount;
		}

		function hasActiveHomeAccount(items) {
			var activeHomeAccount = false;
			for(var pos = 0; pos < items.length; pos++) {
				if(items[pos].active && items[pos].home) {
					activeHomeAccount = true;
				}
			}

			return activeHomeAccount;
		}

		function hasValidNickname(items) {
			var validNickname = true;
			for(var pos = 0; pos < items.length; pos++) {
				if(items[pos].displayedNickname && items[pos].displayedNickname.length > 50) {
					validNickname = false;
				}
			}

			return validNickname;
		}

		function cancelLinkedAccounts() {
			if(vm.sharedLocal.resetOnCancel) {
				initializeView();
				setFormState();
			}
			resetAlerts();
			$scope.$emit('bmProfileCancelAction');
		}

		function setFormState(){
			var hasChanges = false;

			if(!angular.isUndefined(vm.gridData.itemsEdited)) {
				if(vm.gridData.itemsEdited.length > 0) {
					hasChanges = true;
				}
			}

			if(hasChanges){
				vm.linkedAccountsForm.$setDirty();
			} else {
				resetAlerts();
			}

			vm.sharedLocal.hasUnsavedLinkedAccounts = hasChanges;
		}

		$scope.$watch('selectedDefaultLinkAccountId', function() {
			defaultChanged();
		});

		function defaultChanged() {
			if(vm.flexgrid && (vm.selectedDefaultLinkAccountId !== 0)) {
				var cv = vm.flexgrid.collectionView;
				for(var pos = 0; pos < cv.items.length; pos++) {
					var item = cv.items[pos];
					if((item.linkedAccountId === vm.selectedDefaultLinkAccountId) && (!item.home)) {
						cv.editItem(cv.items[pos]);
						cv.items[pos].home = true;
						cv.items[pos].active = true;
						cv.commitEdit();
						cv.refresh();
					} else if((item.linkedAccountId !== vm.selectedDefaultLinkAccountId) && (item.home)) {
						cv.editItem(cv.items[pos]);
						cv.items[pos].home = false;
						cv.commitEdit();
						cv.refresh();
					}
				}
			}
		}
	}
})(window.angular);

(function(angular){
    'use strict';

    angular.module('bmLinkedAccounts').directive('bmLinkedAccounts', bmLinkedAccounts);
    bmLinkedAccounts.$inject = [];

    function bmLinkedAccounts(){
        return {
            restrict: 'EA',
            templateUrl: 'components/linked-accounts/linked-accounts.2js.html',
            scope: {
                user: '=',
                sharedData: '='
            },
            controller: 'LinkedAccountsCtrl',
            controllerAs: 'vm',
            bindToController: true,
            replace: true
        };
    }
})(window.angular);

(function(angular){
  'use strict';

  angular.module('LinkedAccountsService', []).service('LinkedAccountsService', LinkedAccountsService);

  LinkedAccountsService.$inject = ['$q', '$http'];
  function LinkedAccountsService($q, $http){
    /*jshint validthis:true */
    var self = this;
	var mergeAccountsApi = '/api/profiles/v2/accounts/merge';
    var linkedAccountsApi = '/api/profiles/v1/accounts';
	var linkedAccountsSessionApi = '/api/security/v2/sessions/accounts';
	var linkExistingAccountApi = '/api/profiles/v1/accounts/merge';

    self.linkAccounts = linkAccounts;
    self.getLinkedAccounts = getLinkedAccounts;
	self.getActiveLinkedAccounts = getActiveLinkedAccounts;
    self.getActiveOnvioLinkedAccounts = getActiveOnvioLinkedAccounts;
    self.getAllOnvioLinkedAccounts = getAllOnvioLinkedAccounts;
    self.updateLinkedAccounts = updateLinkedAccounts;
	self.createLinkedAccountSession = createLinkedAccountSession;
	self.linkExistingAccount = linkExistingAccount;
    self.linkExistingAccountWithLogin = linkExistingAccountWithLogin;

    function linkAccounts(linkingAccount) {
        return $http({
            method: 'PUT',
            url: mergeAccountsApi,
            headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
            data: linkingAccount
        });
    }

	function getLinkedAccounts() {
		// no need to send the bluid, it will be retrieved from
		return $http({
			method: 'GET',
			url: linkedAccountsApi,
			headers: {'Accept': 'application/json'}
		});
	}

	function getActiveLinkedAccounts() {
		var linkedAccountsUrl = linkedAccountsApi + '?active=true';
		return $http({
			method: 'GET',
			url: linkedAccountsUrl,
			headers: {'Accept': 'application/json'}
		});
	}

	function getActiveOnvioLinkedAccounts() {
        var linkedAccountsUrl = linkedAccountsApi + '?active=true&hideNonOnvio=true';
        return $http({
            method: 'GET',
            url: linkedAccountsUrl,
            headers: {'Accept': 'application/json'}
        });
    }

	function getAllOnvioLinkedAccounts() {
        var linkedAccountsUrl = linkedAccountsApi + '?hideNonOnvio=true';
        return $http({
            method: 'GET',
            url: linkedAccountsUrl,
            headers: {'Accept': 'application/json'}
        });
    }

	function updateLinkedAccounts(linkedAccounts){
		return $http({
			method: 'PUT',
			url: linkedAccountsApi,
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json'
			},
			data: linkedAccounts.linkedAccountsToUpdate
		});
	}

	function createLinkedAccountSession(linkedAcccountId) {
		var apiUrl = linkedAccountsSessionApi + '/' + linkedAcccountId;
		return $http({
			method: 'POST',
			url: apiUrl,
			headers: {'Accept': 'application/json'}
		});
	}

	function linkExistingAccount(bluid) {
		var config = {
			method: 'PUT',
			url: linkExistingAccountApi + '/' + bluid,
		};
		return $http(config);
	}

    function linkExistingAccountWithLogin(email) {
        var config = {
            method: 'PUT',
            url: linkExistingAccountApi + '?login=' + encodeURIComponent(email)
        };

        return $http(config).then(
            function(resp) {
                var defer = $q.defer();
                defer.resolve(resp);
                return defer.promise;
            },
            function(resp) {
                resp.config.global = false;
                return $q.reject(resp);
            }
        );
    }

  }
})(window.angular);

(function(angular) {
    'use strict';

    angular.module('bmLinkedAccounts').controller('LinkedAccountsDialogCtrl', LinkedAccountsDialogCtrl);
	LinkedAccountsDialogCtrl.$inject = ['$scope', '$uibModalInstance', 'user', 'sharedProfile' ];

	function LinkedAccountsDialogCtrl($scope, $uibModalInstance, user, sharedProfile){
		/*jshint validthis:true */
		var vm = this;

		vm.user = undefined;
		vm.sharedProfile = {};

		vm.user = user;
		vm.sharedProfile = sharedProfile;
		vm.sharedProfile.loadLinkedAccounts = true;
		vm.closeDialog = closeDialog;

        $scope.$on('bmProfileCancelAction', function(){
            closeDialog();
        });

        function closeDialog(){
            $uibModalInstance.dismiss('close');
        }
	}
})(window.angular);

(function(angular){
    'use strict';

    angular.module('bmLinkingMerge', [
        'ui.bootstrap',
        'pascalprecht.translate'

    ]);
})(window.angular);

(function(angular){
    'use strict';

    angular.module('bmLinkedAccounts').controller('bmLinkingMergeCtrl', bmLinkingMergeCtrl);
    bmLinkingMergeCtrl.$inject = ['$translate', '$http', '$window', '$uibModalInstance', 'bmUser', 'LinkedAccountsService'];

    function bmLinkingMergeCtrl($translate, $http, $window, $uibModalInstance, user, LinkedAccountsService){
        /*jshint validthis:true */
        var vm = this;
        vm.user = user;
        vm.linkingAccount = {pwd: '', uid: ''};

        vm.addLinkingAccount = addLinkingAccount;

        vm.closeAddAccount = closeAddAccount;
        vm.clearFields = clearFields;
        vm.alerts = [];
        vm.emailRegex =  new RegExp('^((([a-z]|\\d|[!#\\$%&\'\\*\\+\\-\\/=\\?\\^_`{\\|}~]|[\\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF])+(\\.([a-z]|\\d|[!#\\$%&\'\\*\\+\\-' +
        '\\/=\\?\\^_`{\\|}~]|[\\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF])+)*)|((\\x22)((((\\x20|\\x09)*(\\x0d\\x0a))?(\\x20|\\x09)+)?(([\\x01-\\x08\\x0b' +
        '\\x0c\\x0e-\\x1f\\x7f]|\\x21|[\\x23-\\x5b]|[\\x5d-\\x7e]|[\\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF])|(\\\\([\\x01-\\x09\\x0b\\x0c\\x0d-\\x7f]|' +
        '[\\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF]))))*(((\\x20|\\x09)*(\\x0d\\x0a))?(\\x20|\\x09)+)?(\\x22)))@((([a-z]|\\d|[\\u00A0-\\uD7FF\\uF900-' +
        '\\uFDCF\\uFDF0-\\uFFEF])|(([a-z]|\\d|[\\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF])([a-z]|\\d|-|\\.|_|~|[\\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-' +
        '\\uFFEF])*([a-z]|\\d|[\\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF])))\\.)+(([a-z]|[\\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF])|(([a-z]|' +
        '[\\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF])([a-z]|\\d|-|\\.|_|~|[\\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF])*([a-z]|[\\u00A0-\\uD7FF' +
        '\\uF900-\\uFDCF\\uFDF0-\\uFFEF])))\\.?$', 'i');

        function clearFields() {
            vm.linkingAccountForm.pwd = '';
            vm.linkingAccountForm.uid = '';
        }

        function addLinkingAccount() {
            resetAlerts();

            if (vm.linkingAccountForm.$invalid) {

                setFormValidity();
                return;
            }

            if(!vm.emailRegex.test(vm.linkingAccount.uid)){
                $translate('bm.linkingMerge.wrongEmailFormat').then(function (value) {
                    addAlert(value, 'danger');
                });
                return;
            }

            LinkedAccountsService.linkAccounts(vm.linkingAccount)
            .then(function(){
                $uibModalInstance.close();
                $window.location.reload();
            })
            .catch(function(response){
                // don't get caught up in the global error handler
                response.config.global = false;

                if(response.status === 400 && response.data.Message[0] === 'Unable to confirm your password. Please try again.'){
                    $translate('bm.linkingMerge.wrongPassword').then(function (value) {
                        addAlert(value, 'danger');
                    });
                } else if (response.status === 400 && response.data.Message[0] === 'Cannot link accounts that are in the same company'){
                    $translate('bm.linkingMerge.wrongCompanyAlert').then(function (value) {
                        addAlert(value, 'danger');
                    });
                } else if (response.status === 400 && response.data.Message[0] === 'Deactivated account. Please contact your administrator'){
                    $translate('bm.linkingMerge.deactivatedAccountAlert').then(function (value) {
                        addAlert(value, 'danger');
                    });
                } else {
                    addAlert(response.data.Message[0], 'danger');
                }
            });
        }

        function setFormValidity(){
            if(vm.linkingAccountForm.uid.$error.required){
                vm.linkingAccountForm.uid.$setDirty();
                vm.linkingAccountForm.uid.$setTouched();
            }

            if(vm.linkingAccountForm.pwd.$error.required){
                vm.linkingAccountForm.pwd.$setDirty();
                vm.linkingAccountForm.pwd.$setTouched();
            }
        }

        function closeAddAccount(){
            clearFields();
            resetAlerts();
            $uibModalInstance.dismiss('close');
        }

        function addAlert(message, type){
            resetAlerts();
            vm.alerts.push({ msg: message, type: type, closeable: true, timeout: 2500 });
        }

        function resetAlerts(){
            vm.alerts.length = 0;
        }

    }
})(window.angular);

(function(angular){
    'use strict';

    angular.module('bmPreviewTrialWidget', []);
})(window.angular);

(function(angular){
    'use strict';

    angular.module('bmPreviewTrialWidget').component('previewTrialWidget', {
        templateUrl: 'components/preview-trial-widget/preview-trial-widget.2js.html',
        controller: previewTrialWidgetCtrl,
        controllerAs: 'vm'
    });

    previewTrialWidgetCtrl.$inject = ['previewTrialService', '$translate', '$q', 'bmUtil', 'bmPermission'];
    function previewTrialWidgetCtrl(previewTrialService, $translate, $q, bmUtil, bmPermission) {
        /*jshint validthis:true */
        var vm = this;

        vm.$onInit = onInit;
        function onInit(){
            vm.days = ''; // fall back for 404 error on ProvisioningServices trial api
            vm.lang = getLang();
            bmPermission.has('Platform.Trial').then(function() {
                getRemainingDays().then(function(days){
                    vm.days = days;
                    setMessage();
                });
            }).catch(angular.noop);
            bmPermission.has('Platform.PreviewMode').then(function() {
                setMessage();
            }).catch(angular.noop);
        }
        function setMessage() {
            bmPermission.has('Platform.Trial').then(function() {
                vm.trial = true;
                vm.modeButtonLink = '/trial/' + vm.lang + '/purchase';
            }).catch(angular.noop);
            bmPermission.has('Platform.PreviewMode').then(function() {
                vm.preview = true;
                vm.modeButtonLink = '/trial/' + vm.lang + '/signup';
            }).catch(angular.noop);
        }
        function getLang(){
            var lang = bmUtil.cookie('BMLanguageCode');
            return lang.slice(0,2);
        }
        function getRemainingDays() {
            return getTrialExpiration().then(function(expirationDate){
                var today = new Date();
                var expiration = new Date(expirationDate);
                var diff = Math.abs(expiration.getTime() - today.getTime());
                var days = Math.floor(diff / (1000 * 3600 * 24));
                return days;
            });
        }
        function getTrialExpiration(){
            return previewTrialService.getTrialExpiration().then(function(resp){
                return resp.data.expireDate;
            });
        }
    }
})(window.angular);

(function(angular){
    'use strict';

    angular.module('bmPreviewTrialWidget').factory('previewTrialService', previewTrialService);
    previewTrialService.$inject = ['$http'];

    function previewTrialService($http) {
		var factory = {
			getTrialExpiration: getTrialExpiration
		};

		return factory;

		function getTrialExpiration() {
			return $http({
				method: 'GET',
				url: '/api/provisioning/v1/trials'
			});
		}
    }

})(window.angular);

(function (angular) {
    'use strict';

    angular.module('bluemoon.components.modal', ['ui.bootstrap', 'bento.modern']).service('bmModal', [ '$uibModal', function($uibModal) {

        /*
         * Displays a customizable modal.
         *
         * Config object properties:
         *
         * templateUrL: String, optional. Path to the template that should be used for this modal.
         *      If blank, a default template will be used that takes two variables: title and body.
         * showClose: boolean, optional. If true, a close button will be shown in the top-right corner
         *      of the modal. Defaults to true.
         * vars: Map of variables used in the modal template, available to the template as $scope.vars
         * buttons: An array of button config objects:
         *      text: String. Displayed on the button.
         *      value: Any. Supplied to handlers as an argument.
         *      dismiss: Boolean, optional. Determines button click behavior.
         *               If false, onClosed is called when this button is clicked.
         *               If true, onDismissed is called when this button is clicked.
         *               Defaults to false.
         * onClosed: function(any). A handler called when the modal is closed. Takes a button value as an argument.
         * onDismissed: function(any). A handler called when the modal is dismissed. Takes a button value as an argument.
         *
         * returns: The modal that was generated as a bento $uibModalInstance.
         */
        this.modal = function(config){

            if(!config){
                config = {};
            }

            var modal = $uibModal.open({
                templateUrl: 'components/modal/modal-base.2js.html',
                controller: ['$scope', function($scope){

                    $scope.templateUrl = (!config.templateurl ? 'components/modal/modal-default.2js.html' : config.templateUrl);
                    $scope.vars = (!angular.isObject(config.vars) ? {title: 'Default Modal Title', body: 'This is the default modal body. Your config is missing the vals object.'} : config.vars);
                    $scope.buttons = (!angular.isObject(config.buttons) ? [{text: 'Default Button', value: 'default'}] : config.buttons);
                    $scope.showClose = (!config.showClose ? true : config.showClose);

                }]
            });

            modal.result.then(
                function(result){
                    if(!!config.onClosed){
                        config.onClosed(result);
                    }
                }, function(reason){
                    if(!!config.onDismissed){
                        config.onDismissed(reason);
                    }
                }
            );

            return modal;

        };
    }]);

}(window.angular));

// Adapted from christopherthielen's qdecorator
// https://github.com/angular-ui/ui-router/issues/2889

// Prints out unhandled promise rejection stack traces to the console.
// Only works when you are not using minification (because it parses the stack traces).
// Also only tested with Chrome.

// Decorate the $q service when app starts
angular.module('bmUnhandledPromiseRejectionTracer', ['bmEnvironment'])
.decorator('$q', ['$delegate', 'bmEnvironmentConst', function($delegate, bmEnvironmentConst) {
  'use strict';

  // Pass thru if we are not in local dev mode
  if (!bmEnvironmentConst.isLocalType) { return $delegate; }

  // Create a sample promise.
  var promise = $delegate.when();

  // Access the `Promise` prototype (nonstandard, but works)
  var promisePrototoype = Object.getPrototypeOf(promise);
  var isPromisePrototype = typeof promisePrototoype === 'object' &&
    ['then', 'catch', 'finally'].reduce(function(acc, key) {
      return acc && !!promisePrototoype[key];
    }, true);

  if (isPromisePrototype) {
    // The angular $q promise implementation sets `$$state` once in its Promise constructor:
    //
    // function Promise() {
    //   this.$$state = { status: 0 };
    // }
    //
    // Hijack the promise behavior by adding a setter for `$$state` on the Promise prototype.
    // The setter is run each time a promise is created (via any method: $q.when(), promise.then(), etc).
    //
    // The setter records the stack trace in which the promise was created.
    Object.defineProperty(promisePrototoype, '$$state', {
      set: function($$state) {
        this._$$state = $$state;

        if (typeof $$state._status === 'undefined') {
          this._value = this.value;
          this._logged = false;

          // Define a getter for `Promise.$$state.value`
          // ('value' is the resolved or rejected value)
          Object.defineProperty($$state, 'value', {
            enumerable: true,
            set: function(val) {
              this._value = val;
            },
            get: function() {
              // Check if this is the "Possibly unhandled rejection" handler. return the stack trace instead
              if (this.status === 2 && this.pur && new Error().stack.includes('processChecks')) {
                if (!this._logged) {
                  this._logged = true;
                  console.error(this._value);
                }
                return this._context;
              }
              return this._value;
            },
          });
        }

        // Create an Error object and use its stack trace
        $$state._context = new Error('Possibly unhandled rejection (promise creation stack)');
      },
      get: function() {
        return this._$$state;
      },
      enumerable: true,
    });

    // Whenever promise.then() (or .catch or .finally) is called, a new promise is created.
    // Add the chained-from-promise's stack to the new promise's stack to allow analysis of the full promise chain
    var realThenFn = promisePrototoype.then;
    promisePrototoype.then = function() {
      var chainedPromise = realThenFn.apply(this, arguments);

      var prevContext = this.$$state && this.$$state._context;
      var chainedContext = chainedPromise.$$state && chainedPromise.$$state._context;

      if (chainedContext) {
        try {
          chainedContext.stack =  chainedContext.stack +
            '\nPromise Chained from:\n' +
            prevContext.stack;
        } catch (ignored) {}
      }
      return chainedPromise;
    };
  }

  return $delegate;
}]);
